{
  "reporting.title": "Ekspor Data Kustom",
  "reporting.description": "Pilih laporan, periode pelaporan, dan kolom Anda, lalu unduh CSV yang siap untuk spreadsheet.",
  "reporting.builder": "Kembali ke penyusun laporan",
  "reporting.queue": "Antrian Laporan Saya",
  "reporting.queueEmpty": "Laporan yang Anda buat akan muncul di sini.",
  "reporting.design.emptyQueuePage": "Tidak ada laporan di halaman ini.",
  "reporting.design.firstQueuePage": "Kembali ke halaman pertama",
  "reporting.reportType": "Jenis laporan",
  "reporting.layout": "Tata letak CSV",
  "reporting.layout.SPREADSHEET": "Lembar kerja: pemeriksaan dalam kolom",
  "reporting.layout.RESULT_LIST": "Daftar rinci: hasil dalam baris",
  "reporting.layout.TABLE": "Tabel",
  "reporting.meaning.SPREADSHEET": "Pemeriksaan muncul sebagai kolom untuk setiap sampel. Hasil berulang menggunakan baris tambahan; pembacaan ulang yang tidak terkait disimpan terpisah.",
  "reporting.meaning.RESULT_LIST": "Setiap hasil independen muncul pada barisnya sendiri. Hasil berulang tetap dipertahankan.",
  "reporting.meaning.TABLE": "Setiap kejadian yang tercatat muncul pada barisnya sendiri.",
  "reporting.dateFrom": "Tanggal dari",
  "reporting.dateTo": "Tanggal sampai",
  "reporting.dates.required": "Wajib",
  "reporting.dates.requiredFrom": "Pilih tanggal mulai.",
  "reporting.dates.requiredTo": "Pilih tanggal akhir.",
  "reporting.dates.invalid": "Pilih tanggal kalender yang valid.",
  "reporting.dates.reversed": "Tanggal akhir harus sama dengan atau setelah tanggal mulai.",
  "reporting.dates.tooLong": "Pilih periode {days} hari atau kurang, termasuk kedua tanggal.",
  "reporting.dates.range": "Pilih periode berurutan dalam batas maksimum yang ditampilkan di atas.",
  "reporting.periodHelp": "Menggunakan {dateMeaning} dalam {timezone}, termasuk kedua tanggal. Periode maksimum: {days} hari.",
  "reporting.dateAnchor.collectionDate": "tanggal pengambilan sampel",
  "reporting.dateAnchor.requestDate": "tanggal permintaan rujukan",
  "reporting.dateAnchor.sentDate": "tanggal pengiriman rujukan",
  "reporting.dateAnchor.eventOrRecordedDate": "tanggal kejadian bila diketahui, selain itu tanggal pencatatan (ditandai oleh Dasar Tanggal)",
  "reporting.dateAnchor.dateOfEvent": "tanggal kejadian ketidaksesuaian",
  "reporting.dateAnchor.enteredDate": "tanggal penolakan yang tercatat",
  "reporting.labSections": "Instalasi Lab",
  "reporting.allAccessibleSections": "Semua Instalasi Lab yang dapat diakses",
  "reporting.tests": "Pemeriksaan",
  "reporting.allTests": "Semua pemeriksaan",
  "reporting.resultStatuses": "Status hasil",
  "reporting.finalized": "Difinalisasi",
  "reporting.all": "Semua",
  "reporting.available": "Kolom yang tersedia",
  "reporting.search": "Cari kolom",
  "reporting.selected": "Kolom terpilih",
  "reporting.selectedCount": "Kolom terpilih ({count})",
  "reporting.group.sample": "Sampel dan pemesanan",
  "reporting.group.referrals": "Rujukan",
  "reporting.group.nonConformance": "Ketidaksesuaian / Penolakan",
  "reporting.group.patient": "Pasien",
  "reporting.group.result": "Detail hasil",
  "reporting.group.tests": "Pemeriksaan yang dikonfigurasi",
  "reporting.group.components": "Komponen hasil yang dikonfigurasi",
  "reporting.group.turnaround": "Waktu penyelesaian",
  "reporting.group.testTurnaround": "Waktu penyelesaian per pemeriksaan",
  "reporting.group.componentTurnaround": "Waktu penyelesaian per komponen hasil",
  "reporting.group.observations": "Pertanyaan tambahan",
  "reporting.headerPreview": "Pratinjau header CSV",
  "reporting.moveUp": "Pindahkan {field} ke atas",
  "reporting.moveDown": "Pindahkan {field} ke bawah",
  "reporting.remove": "Hapus {field}",
  "reporting.position": "{field}: posisi {position} dari {count}",
  "reporting.review": "Tinjau laporan",
  "reporting.edit": "Edit laporan",
  "reporting.generate": "Buat File CSV",
  "reporting.submitting": "Mengirim laporan…",
  "reporting.generating": "Menyiapkan CSV Anda…",
  "reporting.download": "Unduh CSV",
  "reporting.loading": "Memuat opsi laporan…",
  "reporting.currentReport": "Laporan Anda saat ini",
  "reporting.previous": "Sebelumnya",
  "reporting.next": "Berikutnya",
  "reporting.rows": "{count, plural, other {# baris}}",
  "reporting.state.QUEUED": "Dalam antrian",
  "reporting.state.GENERATING": "Sedang dibuat",
  "reporting.state.READY": "Siap diunduh",
  "reporting.state.FAILED": "Gagal",
  "reporting.state.EXPIRED": "Kedaluwarsa",
  "reporting.state.CANCELLED": "Dibatalkan",
  "reporting.loadError": "Tidak dapat memuat informasi laporan",
  "reporting.submitError": "Tidak dapat membuat laporan",
  "reporting.requestError": "Permintaan tidak dapat diselesaikan. Pilihan Anda tetap disimpan; coba lagi.",
  "reporting.networkError": "Server tidak dapat dijangkau. Pilihan Anda tetap disimpan; coba lagi.",
  "reporting.request.invalid": "Periksa periode laporan, filter, dan kolom yang dipilih, lalu coba lagi.",
  "reporting.request.conflict": "Pengenal pengiriman ini sudah digunakan untuk pilihan laporan yang berbeda. Mulai laporan baru.",
  "reporting.columns.stale": "Beberapa kolom yang dipilih tidak lagi tersedia. Hapus kolom tersebut dan pilih dari katalog saat ini.",
  "reporting.jobs.limit": "Anda telah mencapai batas laporan aktif. Tunggu hingga sebuah laporan selesai, lalu coba lagi.",
  "reporting.access.denied": "Akses OpenELIS Anda saat ini tidak mengizinkan laporan ini.",
  "reporting.access.scopeChanged": "Akses Anda ke Instalasi Lab yang dipilih telah berubah. Tinjau laporan dengan akses Anda saat ini.",
  "reporting.access.noSections": "Tidak ada Instalasi Lab yang dapat diakses untuk laporan ini.",
  "reporting.access.signIn": "Masuk ke OpenELIS untuk melanjutkan.",
  "reporting.definition.changed": "Definisi laporan telah berubah. Tinjau opsi laporan saat ini sebelum menjalankan lagi.",
  "reporting.definition.unavailable": "Jenis laporan ini tidak lagi tersedia.",
  "reporting.tests.stale": "Beberapa pemeriksaan yang dipilih tidak lagi tersedia. Tinjau pilihan pemeriksaan Anda.",
  "reporting.status.invalid": "Pilih status hasil yang tersedia.",
  "reporting.filters.unsupported": "Beberapa filter yang diminta tidak tersedia untuk laporan ini. Tinjau opsi laporan saat ini.",
  "reporting.filters.unavailable": "Beberapa filter sebelumnya tidak tersedia untuk laporan ini. Tinjau filter saat ini sebelum membuat laporan.",
  "reporting.job.generationFailed": "CSV tidak dapat dibuat. Permintaan laporan Anda tetap disimpan.",
  "reporting.job.outputUnavailable": "Server tidak dapat menyimpan file ekspor. Minta administrator Anda agar folder ekspor dapat ditulisi, lalu ulangi laporan ini.",
  "reporting.job.expired": "File ini sudah kedaluwarsa. Jalankan laporan lagi dengan periode laporan baru.",
  "reporting.job.notReady": "Laporan ini belum siap untuk diunduh.",
  "reporting.job.notFound": "Laporan ini tidak ditemukan.",
  "reporting.saved.library": "Laporan bersama",
  "reporting.saved.search": "Cari laporan bersama",
  "reporting.saved.loading": "Memuat laporan bersama…",
  "reporting.saved.loadError": "Tidak dapat memuat laporan bersama",
  "reporting.saved.empty": "Belum ada laporan bersama yang disimpan.",
  "reporting.saved.shared": "Tersedia untuk semua orang yang dapat menggunakan laporan.",
  "reporting.saved.open": "Buka",
  "reporting.saved.save": "Simpan laporan",
  "reporting.saved.update": "Perbarui laporan bersama",
  "reporting.saved.copy": "Simpan salinan",
  "reporting.saved.delete": "Hapus laporan bersama",
  "reporting.saved.name": "Nama laporan",
  "reporting.saved.confirmSave": "Simpan laporan bersama",
  "reporting.saved.confirmDelete": "Hapus",
  "reporting.saved.confirmUpdate": "Perbarui",
  "reporting.saved.cancel": "Batal",
  "reporting.saved.copyName": "Salinan dari {name}",
  "reporting.saved.created": "Disimpan sebagai {name}.",
  "reporting.saved.updated": "{name} diperbarui.",
  "reporting.saved.freshDates": "Pilih tanggal baru sebelum menjalankan laporan ini.",
  "reporting.saved.deleteHelp": "Hapus {name} dari pustaka laporan bersama? File yang sudah dibuat tetap disimpan.",
  "reporting.saved.updateHelp": "Ganti {name} dengan pilihan yang saat ini ditampilkan di penyusun?",
  "reporting.saved.changed": "Seseorang mengubah laporan bersama ini setelah Anda membukanya. Pilihan Anda masih ada di sini; buka kembali laporan tersimpan saat ini atau simpan salinannya.",
  "reporting.saved.invalid": "Tinjau pilihan laporan sebelum menyimpan.",
  "reporting.saved.nameInvalid": "Masukkan nama laporan maksimal 200 karakter.",
  "reporting.saved.notFound": "Laporan bersama ini tidak lagi tersedia.",
  "reporting.saved.pageInvalid": "Permintaan daftar laporan bersama tidak valid.",
  "accept.action.button": "Setuju",
  "accessDenied.message": "Anda tidak memiliki akses pada modul ini. Silahkan kontak admin sistem.",
  "accessDenied.okButton": "OK",
  "accessDenied.title": "Akses ditolak",
  "accession.entry": "Masukkan Nomor Registrasi",
  "activityReportByPanel": "Laporan aktivitas berdasarkan Panel",
  "activityReportByTest": "Laporan aktivitas berdasarkan Pemeriksaan",
  "activityReportByTestSection": "Laporan aktivitas berdasarkan Bagian Pemeriksaan",
  "add.age.range": "Tambah Rentang Umur lainnya +",
  "add.aliquot": "Tambah Alikuot",
  "add.new.dictionary.menu": "Tambah Menu Kamus Baru",
  "address.search.label": "Cari Alamat",
  "address.level.provinsi": "Propinsi",
  "address.level.kabupaten": "Kabupaten/Kota",
  "address.level.kecamatan": "Kabupaten / Kota",
  "address.level.kelurahan": "Kelurahan/Desa",
  "adjustment.button": "Sesuaikan Kuantitas",
  "adjustment.newQuantity": "Kuantitas Baru",
  "adjustment.notes": "Catatan",
  "adjustment.notes.placeholder": "Sedialan rincian penyesuaian ini",
  "adjustment.reason": "Alasan Penyesuaian",
  "adjustment.reason.select": "Pilih Alasan",
  "adjustment.success": "Kuantitas lot berhasil disesuaikan",
  "adjustment.title": "Sesuaikan Kuantitas Lot",
  "admin.dashboard.subtitle": "Pilih area administrasi untuk dikonfigurasi",
  "admin.dashboard.title": "Dasbor admin",
  "admin.formEntryConfig": "Konfigurasi Umum",
  "admin.programs.title": "Program",
  "admin.programs.subtitle": "Inisiatif tempat pemesanan dikelompokkan, masing-masing dengan domain, satu atau beberapa instalasi lab, dan kuesioner entri pemesanan opsional.",
  "admin.programs.add": "Tambah Program",
  "admin.programs.search": "Cari berdasarkan nama",
  "admin.programs.selector.new": "Program Baru",
  "admin.programs.row.expand.aria": "Edit program",
  "admin.programs.row.actions.aria": "Tindakan program",
  "admin.programs.list.column.name": "Nama",
  "admin.programs.list.column.domain": "Domain",
  "admin.programs.list.column.active": "Status",
  "admin.programs.list.column.units": "Instalasi Lab",
  "admin.programs.list.status.active": "Aktif",
  "admin.programs.list.status.inactive": "Inaktif",
  "admin.programs.list.filter.domain.label": "Domain",
  "admin.programs.list.filter.domain.all": "Semua domain",
  "admin.programs.list.toggle.showDeactivated": "Tampilkan sudah inaktif",
  "admin.programs.action.deactivate": "Nonaktifkan",
  "admin.programs.action.reactivate": "Aktifkan Ulang",
  "admin.programs.deactivate.modal.title": "Nonaktifkan Program ini?",
  "admin.programs.deactivate.modal.body.noOrders": "\"{programName}\" tidak memiliki pemesanan dan hanya tidak akan lagi muncul untuk pemesanan baru. Anda dapat mengaktifkannya kembali kapan saja dari daftar Program.",
  "admin.programs.deactivate.modal.confirm": "Nonaktifkan",
  "admin.programs.deactivate.modal.cancel": "Batal",
  "admin.programs.reactivate.success": "{programName} diaktifkan ulang",
  "admin.programs.deactivate.success": "{programName} dinonaktifkan",
  "admin.programs.domain.confirm.heading": "Ubah Domain Program?",
  "admin.programs.domain.confirm.body": "Pemesanan historis dievaluasi berdasarkan aturan domain {from}. Perubahan ke {to} hanya berlaku ke depan: pemesanan yang ada tetap mempertahankan kode programnya dan tidak dikodekan ulang, dan program hanya akan ditawarkan pada pemesanan {to} mulai sekarang.",
  "admin.programs.list.empty": "Tidak ada program yang sesuai dengan pencarian dan filter saat ini.",
  "admin.programs.basicInfo.labUnits.selectAll": "Pilih semua",
  "admin.programs.basicInfo.labUnits.placeholder": "Ketik untuk memfilter instalasi lab",
  "orderEntry.programPicker.empty": "Saat ini tidak ada program yang aktif. Administrator dapat mengaktifkannya di Admin › Program.",
  "orderEntry.programPicker.empty.domain": "Saat ini tidak ada program {domain} yang aktif. Administrator dapat mengaktifkannya di Admin › Program.",
  "admin.programs.basicInfo.programName.label": "Nama Program",
  "admin.programs.basicInfo.programName.placeholder": "mis. Skrining HBV Antenatal",
  "admin.programs.basicInfo.code.label": "Kode Program",
  "admin.programs.basicInfo.code.placeholder": "mis. HBV_ANC",
  "admin.programs.basicInfo.code.invalid": "Gunakan huruf, angka, spasi, atau garis bawah saja.",
  "admin.programs.basicInfo.programName.tooLong": "Gunakan paling banyak {max} karakter.",
  "admin.programs.basicInfo.labUnits.label": "Instalasi Lab",
  "admin.programs.basicInfo.showOnMicroCase.off": "Matikan",
  "admin.programs.basicInfo.showOnMicroCase.on": "Nyalakan",
  "admin.programs.basicInfo.showOnMicroCase.label": "Tampilkan pada kasus Mikrobiologi",
  "admin.programs.basicInfo.showOnMicroCase.helper": "Izinkan Program ini pada kasus mikrobiologi. Kasus baru mewarisinya dari pemesanan; hal ini tidak mengubah cara pekerjaan dialihkan.",
  "admin.programs.basicInfo.domain.label": "Domain",
  "admin.programs.basicInfo.domain.required": "Domain wajib diisi",
  "admin.programs.editor.status.label": "Status:",
  "admin.programs.guidance.domain.toggle.show": "Apa arti setiap Domain?",
  "admin.programs.guidance.domain.toggle.hide": "Sembunyikan",
  "admin.programs.guidance.domain.clinical": "Pemeriksaan pasien: formulir mencatat identitas pasien, penyelenggara, dan riwayat sebelumnya.",
  "admin.programs.guidance.domain.environmental": "Pengambilan sampel untuk kepatuhan/surveilans (air, makanan, udara). Tanpa bidang pasien.",
  "admin.programs.guidance.domain.vector": "Surveilans spesimen (nyamuk, caplak): spesies, manifes pool.",
  "admin.programs.guidance.gui.emptyState.body": "Belum ada pertanyaan. Tambahkan pertanyaan satu per satu, atau tempel Kuesioner dalam mode JSON.",
  "admin.programs.guidance.gui.emptyState.action": "Tambah Pertanyaan Pertama",
  "admin.programs.guidance.json.referenceCard.format": "Format: Kuesioner FHIR R4",
  "admin.programs.guidance.json.referenceCard.allowedTypes": "- item.type yang diizinkan: {allowed}.",
  "admin.programs.questionnaire.mode.visualBuilder": "Pembuat Visual",
  "admin.programs.questionnaire.mode.json": "JSON",
  "admin.programs.questionnaire.question.text.label": "Teks Pertanyaan",
  "admin.programs.questionnaire.question.type.label": "Jenis Pertanyaan",
  "admin.programs.questionnaire.question.addNew": "Tambah Pertanyaan Baru",
  "admin.programs.questionnaire.question.actions.aria": "Tindakan pertanyaan",
  "admin.programs.questionnaire.question.actions.delete": "Hapus pertanyaan",
  "admin.programs.questionnaire.answerOptions.section.title": "Opsi jawaban",
  "admin.programs.questionnaire.answerOptions.addOption": "Tambah opsi",
  "admin.programs.questionnaire.answerOptions.deleteOption": "Hapus opsi",
  "admin.programs.questionnaire.answerOptions.empty": "Belum ada opsi. Tambahkan setidaknya satu agar penerimaan dapat memilih nilai.",
  "admin.programs.questionnaire.answerOptions.coded": "berkode",
  "admin.programs.questionnaire.answerOptions.codedHelp": "Opsi berkode berasal dari terminologi dan ditampilkan hanya-baca di sini. Edit opsi tersebut dalam mode JSON.",
  "admin.programs.questionnaire.preview.label": "Contoh",
  "admin.programs.questionnaire.preview.empty": "Belum ada pertanyaan. Mulai tambahkan pertanyaan untuk melihat pratinjau.",
  "admin.programs.questionnaire.preview.untitled": "(tanpa judul)",
  "admin.programs.questionnaire.preview.boolean.example": "◯ Ya ◯ Tidak",
  "admin.programs.questionnaire.preview.quantity.numberPlaceholder": "angka",
  "admin.programs.questionnaire.preview.quantity.unit": "satuan",
  "admin.programs.questionnaire.json.validate": "Validasi JSON",
  "admin.programs.questionnaire.json.reformat": "Format Ulang",
  "admin.programs.questionnaire.json.validated": "Tervalidasi: {count} pertanyaan",
  "admin.programs.questionnaire.json.error.title": "Kuesioner Tidak Valid",
  "admin.programs.questionnaire.json.error.resourceType": "resourceType harus \"Questionnaire\"",
  "admin.programs.questionnaire.json.error.itemArray": "item harus berupa array",
  "admin.programs.questionnaire.json.error.itemShape": "setiap item harus memiliki linkId, text, dan type dalam [{allowed}]",
  "admin.programs.questionnaire.json.error.duplicateLinkId": "linkId \"{linkId}\" duplikat: setiap item harus memiliki linkId yang unik",
  "admin.programs.guidance.json.referenceCard.advanced": "Fitur lanjutan (enableWhen, satuan Quantity melalui unit/unitOption, item bertingkat) diedit di sini dalam JSON. Pembuat Visual mempertahankannya tetapi tidak menampilkannya.",
  "admin.programs.basicInfo.domain.helper": "Mengatur di mana program ini muncul: penerimaan hanya melihat program yang sesuai dengan domain pemesanan.",
  "admin.programs.editor.status.noHardDelete": "Tidak ada penghapusan permanen: penonaktifan mempertahankan riwayat.",
  "admin.programs.deactivate.modal.body": "\"{programName}\" tidak akan lagi muncul di pemilih Program entri pemesanan untuk pemesanan baru. {orderCount, plural, one {# pemesanan historisnya tetap mempertahankan kode programnya} other {# pemesanan historisnya tetap mempertahankan kode programnya}} dan semua hitungan indikator tetap tersimpan. Anda dapat mengaktifkannya kembali kapan saja dari daftar Program.",
  "admin.programs.deactivate.modal.body.unknownCount": "\"{programName}\" tidak akan lagi muncul di pemilih Program entri pemesanan untuk pemesanan baru. Pemesanan historis tetap mempertahankan kode programnya dan semua hitungan indikator tetap tersimpan. Anda dapat mengaktifkannya kembali kapan saja dari daftar Program.",
  "admin.programs.questionnaire.question.unsupported": "Ini adalah item \"{type}\" yang tidak diedit oleh pembuat ini. Item ini disimpan persis seperti adanya saat Anda menyimpan. Edit dalam mode JSON.",
  "admin.programs.questionnaire.question.type.boolean": "Ya / Tidak",
  "admin.programs.questionnaire.question.type.choice": "Pilihan",
  "admin.programs.questionnaire.question.type.checkbox": "Kotak centang",
  "admin.programs.questionnaire.question.type.integer": "Bilangan bulat",
  "admin.programs.questionnaire.question.type.decimal": "Angka desimal",
  "admin.programs.questionnaire.question.type.date": "Tanggal",
  "admin.programs.questionnaire.question.type.time": "Waktu",
  "admin.programs.questionnaire.question.type.string": "Teks pendek",
  "admin.programs.questionnaire.question.type.text": "Teks panjang",
  "admin.programs.questionnaire.question.type.quantity": "Kuantitas",
  "admin.programs.questionnaire.question.typeExample.boolean": "Jawaban ya/tidak. Contoh: \"Kunjungan antenatal pertama?\"",
  "admin.programs.questionnaire.question.typeExample.choice": "Satu opsi dari daftar tetap. Contoh: \"Kondisi spesimen\".",
  "admin.programs.questionnaire.question.typeExample.checkbox": "Beberapa opsi dapat dipilih. Contoh: \"Gejala yang ada\".",
  "admin.programs.questionnaire.question.typeExample.integer": "Hanya bilangan bulat. Contoh: \"Usia kehamilan (minggu)\".",
  "admin.programs.questionnaire.question.typeExample.decimal": "Angka dengan desimal. Contoh: \"Berat badan ibu (kg)\".",
  "admin.programs.questionnaire.question.typeExample.date": "Tanggal kalender. Contoh: \"Tanggal haid terakhir\".",
  "admin.programs.questionnaire.question.typeExample.time": "Waktu dalam sehari. Contoh: \"Waktu pengambilan sampel\".",
  "admin.programs.questionnaire.question.typeExample.string": "Teks bebas pendek. Contoh: \"Nama penyelenggara\".",
  "admin.programs.questionnaire.question.typeExample.text": "Teks bebas panjang. Contoh: \"Catatan klinis\".",
  "admin.programs.questionnaire.question.typeExample.quantity": "Angka beserta satuan (mis. \"Volume yang diambil: 5 mL\"). Satuan yang diizinkan berasal dari ekstensi FHIR yang diatur dalam mode JSON; Quantity yang hanya dibuat lewat GUI menerima satuan apa pun.",
  "admin.config.logo.error.fileTooLarge": "Gambar terlalu besar. Ukuran maksimum 2 MB.",
  "admin.config.logo.formats": "Format: JPG, PNG, GIF (maks 2MB)",
  "admin.label": "Admin",
  "admin.labUnit.basicInfo.domain.clinical": "Klinis",
  "admin.labUnit.basicInfo.domain.environmental": "Lingkungan",
  "admin.labUnit.basicInfo.domain.label": "Domain",
  "admin.labUnit.basicInfo.domain.vector": "Vektor",
  "admin.labUnit.domain.confirm.body": "Pemesanan/hasil sebelumnya telah dievaluasi berdasarkan aturan domain sebelumnya. Pemesanan baru akan menggunakan aturan domain yang baru.",
  "admin.labUnit.domain.confirm.heading": "Ubah Domain Instalasi Lab?",
  "admin.labUnit.edit.select": "Pilih Instalasi Lab",
  "admin.labUnit.edit.title": "Edit Instalasi Lab Domain",
  "admin.labUnit.list.filter.domain": "Filter berdasarkan Domain",
  "admin.legacy": "Admin Versi Lama",
  "button.back": "← Kembali ke Daftar",
  "button.labUnit.add": "Tambahkan Instalasi Lab",
  "button.labUnit.create": "Buat Instalasi Lab",
  "button.labUnit.creating": "Membuat...",
  "button.labUnit.tests.assign": "Tugaskan Pemeriksaan",
  "button.labUnit.tests.assign.confirm": "Tugaskan {count, plural, one {# pemeriksaan} other {# pemeriksaan}}",
  "button.labUnit.tests.reassign": "Tugaskan ulang yang dipilih ({count})",
  "button.labUnit.tests.reassign.confirm": "Tugaskan ulang {count, plural, one {# pemeriksaan} other {# pemeriksaan}}",
  "configuration.labUnit.manage": "Pengelolaan Instalasi Lab",
  "error.labUnit.description.maxLength": "Deskripsi harus berisikan maksimal {max} karakter",
  "error.labUnit.domain.required": "Domain wajib diisi",
  "error.labUnit.list.load": "Terjadi kesalahan saat memuat Instalasi Lab",
  "error.labUnit.name.duplicate": "Nama instalasi lab ini sudah ada",
  "error.labUnit.name.maxLength": "Nama harus terdiri dari maksimal {max} karakter",
  "error.request.unreadable": "Tidak ada yang disimpan: server tidak menerima salah satu nilai yang dikirim. Periksa formulir dan coba lagi.",
  "error.labUnit.name.required": "Wajb ada nama ",
  "heading.labUnit.add": "Tambah Instalasi Lab Baru",
  "heading.labUnit.editing": "Edit: {name}",
  "heading.labUnit.filtered": "Menampilkan {filtered} dari {total} Instalasi Lab",
  "heading.labUnit.management": "Pengelolaan Instalasi Lab",
  "heading.labUnit.subtitle": "Konfigurasi instalasi lab (bagian laboratorium), klasifikasi domain, penugasan pemeriksaan, dan urutan tampilan.",
  "heading.labUnit.total": "Total: {total} Instalasi Lab",
  "helper.labUnit.description": "Deskripsi singkat mengenai instalasi lab ini untuk referensi staf laboratorium",
  "helper.labUnit.domain": "Menentukan kolom entri pemesanan dan pengambilan sampel mana yang berlaku untuk pemesanan yang diteruskan ke instalasi lab ini.",
  "helper.labUnit.name": "Masukkan nama yang unik untuk Instalasi Lab ini (misalnya, \"Hematologi\", \"Mikrobiologi\")",
  "label.labUnit.actions": "Aksi",
  "label.labUnit.active": "Aktif",
  "label.labUnit.description": "Deskripsi",
  "label.labUnit.displayOrder": "Posisi",
  "label.labUnit.displayOrder.addHint": "Simpan dulu instalasi lab ini, lalu atur urutan tampilannya.",
  "label.labUnit.displayOrder.current": "Saat ini",
  "label.labUnit.displayOrder.intro": "Tempatkan instalasi lab ini di menu dan daftar tarik-turun instalasi lab di seluruh sistem. Masukkan posisi dan simpan — instalasi lab lainnya akan dinomori ulang secara otomatis.",
  "label.labUnit.displayOrder.loading": "Sedang memuat urutan tampilan...",
  "label.labUnit.displayOrder.saved": "Urutan tampilan telah disimpan",
  "label.labUnit.displayOrder.saveError": "Gagal menyimpan urutan tampilan",
  "label.labUnit.domain": "Domain",
  "label.labUnit.filterStatus": "Filter berdasarkan Status",
  "label.labUnit.list.loading": "Memuat instalasi lab...",
  "label.labUnit.loading": "Memuat instalasi lab...",
  "label.labUnit.notFound": "Instalasi lab ini tidak ada. Kembali ke daftar untuk memilih yang lain.",
  "label.labUnit.editorLoadError": "Instalasi lab tidak dapat dimuat. Muat ulang halaman untuk mencoba lagi.",
  "label.labUnit.name": "Nama",
  "label.labUnit.nameInLocale": "Nama ({language})",
  "error.labUnit.tests.action": "Tindakan penugasan pemeriksaan gagal",
  "error.labUnit.deactivate.failed": "Instalasi Lab tidak dinonaktifkan. Periksa pilihan dan coba lagi.",
  "error.labUnit.deactivate.destinationInactive": "Instalasi Lab tujuan tidak aktif. Pilih instalasi yang aktif, atau aktifkan ulang terlebih dahulu.",
  "heading.labUnit.tests.assign": "Tugaskan Pemeriksaan untuk Instalasi Lab Ini",
  "heading.labUnit.tests.reassign": "Menugaskan Ulang Pemeriksaan",
  "label.labUnit.tests.assign.explain": "Setiap pemeriksaan hanya dapat tergabung dalam satu instalasi lab. Menugaskan pemeriksaan di sini akan memindahkannya dari instalasi lab saat ini (ditampilkan di samping setiap pemeriksaan).",
  "label.labUnit.tests.assign.none": "Tidak ditemukan pemeriksaan yang dapat ditugaskan.",
  "label.labUnit.tests.reassign.destination": "Instalasi Lab tujuan",
  "label.labUnit.tests.reassign.explain": "Penugasan ulang efektif segera. Pemesanan baru akan diteruskan ke instalasi lab tujuan; hasil yang selesai tetap mempertahankan data aslinya.",
  "label.labUnit.tests.reassign.inactiveDestination": "Instalasi lab ini nonaktif: pemeriksaan yang dipindahkan tidak dapat dipesan sampai instalasi diaktifkan kembali. Hasil yang sudah selesai tetap menyimpan data aslinya.",
  "label.labUnit.inactiveOption": "{name} (nonaktif)",
  "label.labUnit.tests.reassign.moving": "{count, plural, other {# pemeriksaan}} will be moved:",
  "message.labUnit.tests.assigned": "Pemeriksaan telah ditugaskan ke instalasi lab ini.",
  "message.labUnit.tests.reassigned": "Pemeriksaan berhasil ditugaskan ulang.",
  "placeholder.labUnit.tests.reassign.destination": "Pilih tujuan...",
  "placeholder.labUnit.tests.search": "Cari pemeriksaan...",
  "label.labUnit.section.assigned-tests": "Pemeriksaan Ditugaskan",
  "label.labUnit.section.basic-info": "Informasi Dasar",
  "label.labUnit.section.display-order": "Urutan tampilan",
  "label.labUnit.status": "Status",
  "label.labUnit.testCount": "Pemeriksaan",
  "label.labUnit.tests.addHint": "Simpan dulu instalasi lab ini, lalu tugaskan pemeriksaan ke dalamnya.",
  "label.labUnit.tests.count": "{count, plural, other {# pemeriksaan ditetapkan}}",
  "label.labUnit.tests.loadError": "Tidak dapat memuat pemeriksaan yang telah ditugaskan",
  "label.labUnit.tests.loading": "Sedang memuat Pemeriksaan yang telah ditugaskan...",
  "label.labUnit.tests.none": "Belum ada pemeriksaan yang ditugaskan untuk instalasi lab ini.",
  "label.labUnit.tests.testName": "Nama Pemeriksaan",
  "message.labUnit.add.success": "Instalasi Lab berhasil dibuat.",
  "message.labUnit.edit.success": "Instalasi Lab telah berhasil disimpan.",
  "message.labUnit.noResults": "Tidak ditemukan instalasi lab yang sesuai dengan kriteria Anda",
  "placeholder.labUnit.filter.domain": "Semua domain",
  "placeholder.labUnit.filter.status": "Semua status",
  "placeholder.labUnit.search": "Cari instalasi lab...",
  "sidenav.label.admin.labUnit.addingNew": "Menambahkan instalasi lab baru",
  "sidenav.label.admin.labUnit.backToList": "← Semua Instalasi Lab",
  "sidenav.label.admin.labUnit.editing": "Edit: {name}",
  "sidenav.label.admin.labUnit.editingGeneric": "Mengedit instalasi lab",
  "sidenav.label.admin.labUnit.sectionsHelper": "Klik sebuah instalasi lab untuk mengedit bagian-bagiannya",
  "sidenav.label.admin.labUnitManagement": "Editor Instalasi Lab",
  "warning.labUnit.deactivateInUse": "{count, plural, other {# pemeriksaan aktif ditetapkan ke instalasi lab ini. Menonaktifkannya akan menyembunyikannya dari pemesanan, tetapi penetapannya tetap tersimpan.}}",
  "heading.labUnit.deactivate": "Nonaktifkan Instalasi Lab",
  "button.labUnit.deactivate.confirm": "Nonaktifkan Instalasi Lab",
  "label.labUnit.deactivate.loading": "Memeriksa apa saja yang akan terdampak…",
  "label.labUnit.deactivate.impact": "Instalasi lab ini saat ini memiliki:",
  "label.labUnit.deactivate.impact.tests": "{count} pemeriksaan yang ditetapkan ({active} aktif)",
  "label.labUnit.deactivate.impact.pending": "{count} analisis tertunda",
  "label.labUnit.deactivate.impact.historical": "{count} analisis selesai (riwayat tidak pernah dihapus)",
  "info.labUnit.deactivate.pending": "Instalasi Lab ini tetap ada di daftar kerja sampai {count} analisis yang tertunda selesai.",
  "label.labUnit.deactivate.option": "Apa yang harus dilakukan terhadap pemeriksaan yang ditetapkan?",
  "label.labUnit.deactivate.option.keep": "Pertahankan penetapan: pemeriksaan tetap ditetapkan, instalasi berhenti menerima pemesanan baru",
  "label.labUnit.deactivate.option.deactivateAll": "Nonaktifkan juga semua pemeriksaan yang ditetapkan",
  "label.labUnit.deactivate.option.reassign": "Pindahkan pemeriksaan ke instalasi lab lain terlebih dahulu",
  "label.labUnit.deactivate.confirm": "Ketik DEACTIVATE untuk mengonfirmasi",
  "admin.page.configuration.formEntryConfigMenu.button.add": "Tambah",
  "admin.page.configuration.formEntryConfigMenu.button.deactivate": "Nonaktifkan",
  "admin.page.configuration.formEntryConfigMenu.button.exit": "Keluar",
  "admin.page.configuration.formEntryConfigMenu.button.modify": "Modifikasi",
  "admin.page.configuration.formEntryConfigMenu.button.save": "Simpan",
  "admin.page.configuration.formEntryConfigMenu.description": "Deskripsi",
  "admin.page.configuration.formEntryConfigMenu.editRecord": "Rekaman Edit",
  "admin.page.configuration.formEntryConfigMenu.name": "Nama",
  "admin.page.configuration.formEntryConfigMenu.select": "Pilih",
  "admin.page.configuration.formEntryConfigMenu.value": "Nilai",
  "admin.labelPresets.title": "Pengaturan Label",
  "admin.labelPresets.addButton": "Tambah Pengaturan",
  "admin.labelPresets.search.placeholder": "Cari pengaturan...",
  "admin.labelPresets.col.name": "Nama",
  "admin.labelPresets.col.barcodeType": "Jenis Kode QR",
  "admin.labelPresets.col.dimensions": "Dimensi",
  "admin.labelPresets.col.scope": "Ruang Lingkup",
  "admin.labelPresets.col.status": "Status",
  "admin.labelPresets.col.actions": "Aksi",
  "admin.labelPresets.systemTag": "Sistem",
  "admin.labelPresets.status.active": "Aktif",
  "admin.labelPresets.status.inactive": "Inaktif",
  "admin.labelPresets.scope.order": "Pemesanan",
  "admin.labelPresets.scope.sample": "Sampel",
  "admin.labelPresets.action.edit": "Edit",
  "admin.labelPresets.action.duplicate": "Duplikasi",
  "admin.labelPresets.action.activate": "Aktifkan",
  "admin.labelPresets.action.deactivate": "Nonaktifkan",
  "admin.labelPresets.duplicateName": "Salinan dari {name}",
  "admin.labelPresets.duplicated": "Pengaturan diduplikasi",
  "admin.labelPresets.duplicateFailed": "Duplikasi gagal",
  "admin.labelPresets.activated": "Pengaturan diaktifkan",
  "admin.labelPresets.deactivated": "Pengaturan dinonaktifkan",
  "admin.labelPresets.toggleFailed": "Gagal merubah status",
  "admin.labelPresets.saveFailed": "Penyimpanan gagal",
  "admin.labelPresets.saveFailed.detail": "Server menjawab {status}: {message}",
  "admin.labelPresets.saveFailed.noResponse": "Tidak ada respons dari server. Periksa koneksi lalu coba lagi.",
  "error.labelpreset.fields.unique": "Setiap bidang konten dan setiap posisi tampilan hanya boleh digunakan sekali per pengaturan.",
  "error.labelpreset.field.required": "Setiap entri bidang konten harus menyebutkan sebuah bidang.",
  "admin.labelPresets.created": "Pengaturan dibuat",
  "admin.labelPresets.updated": "Pengaturan diperbarui",
  "admin.labelPresets.editor.titleAdd": "Tambah Pengaturan Label",
  "admin.labelPresets.editor.titleEdit": "Edit Pengaturan Label",
  "admin.labelPresets.editor.section.basicInfo": "Informasi Dasar",
  "admin.labelPresets.editor.section.dimensions": "Dimensi (mm)",
  "admin.labelPresets.editor.section.barcodeSettings": "Pengaturan Kode QR",
  "admin.labelPresets.editor.section.printScope": "Ruang Lingkup & Kuantitas Pencetakan",
  "admin.labelPresets.field.name": "Nama Pengaturan",
  "admin.labelPresets.field.isActive": "Aktif",
  "admin.labelPresets.field.heightMm": "Tinggi (mm)",
  "admin.labelPresets.field.widthMm": "Lebar (mm)",
  "admin.labelPresets.field.barcodeType": "Jenis Kode QR",
  "admin.labelPresets.field.defaultPerOrder": "Default per Pemesanan",
  "admin.labelPresets.field.maxPerOrder": "Maks per Pemesanan",
  "admin.labelPresets.field.defaultPerSample": "Default per Sampel",
  "admin.labelPresets.field.maxPerSample": "Maks per Sampel",
  "admin.labelPresets.validation.name.required": "Wajb ada nama ",
  "admin.labelPresets.validation.name.toolong": "Nama tidak lebih dari 120 karakter",
  "admin.labelPresets.validation.dimension.range": "Dimensi harus antara 5 sampai 200 mm",
  "admin.labelPresets.validation.barcodeType.required": "Wajib ada jenis kode QR",
  "admin.labelPresets.validation.scope.required": "Setidaknya satu ruang lingkup pencetakan (Pemesanan atau Sample) harus dipilih",
  "admin.labelPresets.validation.max.lte": "Maks harus lebih dari atau sama dengan default",
  "admin.labelPresets.editor.section.fields": "Bidang konten",
  "admin.labelPresets.fields.helper": "Bidang yang dicetak di atas kode QR, sesuai urutan ini. No. Registrasi selalu berada di urutan pertama.",
  "admin.labelPresets.fields.locked": "Selalu pertama",
  "admin.labelPresets.fields.required": "Wajib",
  "admin.labelPresets.fields.required.aria": "Wajib: {field}",
  "admin.labelPresets.fields.moveUp": "Pindahkan {field} ke atas",
  "admin.labelPresets.fields.moveDown": "Pindahkan {field} ke bawah",
  "admin.labelPresets.fields.remove": "Hapus {field}",
  "admin.labelPresets.fields.add.label": "Tambah bidang",
  "admin.labelPresets.fields.add.placeholder": "Pilih bidang",
  "admin.labelPresets.fields.add.button": "Tambah",
  "admin.labelPresets.fields.allAdded": "Semua bidang yang tersedia sudah ada pada label ini.",
  "admin.labelPresets.fields.fitHint": "{count, plural, one {Bidang yang dipilih} other {# bidang yang dipilih}} mungkin tidak muat pada label {height} mm; sekitar {rows, plural, one {# baris muat} other {# baris muat}} di atas kode QR. Anda tetap dapat menyimpan.",
  "admin.labelPresets.fields.position": "Posisi {position}",
  "admin.labelPresets.fieldKey.LAB_NUMBER": "Nomor Registrasi",
  "admin.labelPresets.fieldKey.PATIENT_NAME": "Nama Pasien",
  "admin.labelPresets.fieldKey.PATIENT_ID": "NIK Pasien",
  "admin.labelPresets.fieldKey.PATIENT_DOB": "Tanggal Lahir Pasien",
  "admin.labelPresets.fieldKey.PATIENT_SEX": "Jenis Kelamin Pasien",
  "admin.labelPresets.fieldKey.SITE_ID": "ID Tempat",
  "admin.labelPresets.fieldKey.COLLECTION_DATETIME": "Tanggal dan Waktu Pengumpulan",
  "admin.labelPresets.fieldKey.COLLECTED_BY": "Dikumpulkan oleh",
  "admin.labelPresets.fieldKey.TESTS": "Pemeriksaan",
  "admin.labelPresets.fieldKey.SPECIMEN_TYPE": "Jenis Spesimen",
  "admin.labelPresets.fieldKey.BLOCK_ID": "ID Blok",
  "admin.labelPresets.fieldKey.SLIDE_ID": "ID slide",
  "admin.labelPresets.fieldKey.STAIN_TYPE": "Jenis Pewarnaan",
  "admin.labelPresets.fieldKey.CASE_NUMBER": "Nomor Kasus",
  "admin.labelPresets.fieldKey.STORAGE_LOCATION": "Lokasi Penyimpanan",
  "admin.labelPresets.fieldKey.EXPIRY_DATE": "Tanggal Kedaluwarsa",
  "error.labelpreset.field.key.unknown": "Bidang konten tidak dikenal.",
  "admin.labelPresets.siteWide.title": "Pengaturan Kode QR Seluruh Tempat",
  "admin.labelPresets.siteWide.scope": "Berlaku untuk seluruh laboratorium",
  "admin.labelPresets.siteWide.prePrint.legend": "Nomor label pracetak berasal dari",
  "admin.labelPresets.siteWide.prePrint.orderEntry": "Format dan kumpulan nomor yang sama dengan entri pemesanan",
  "admin.labelPresets.siteWide.prePrint.separate": "Seri pracetak terpisah",
  "admin.labelPresets.siteWide.prefix.label": "Prefiks",
  "admin.labelPresets.siteWide.prefix.helper": "Tepat 4 huruf atau angka. Nomor pracetak diawali dengan prefiks ini, lalu tahun dan nomor urut.",
  "admin.labelPresets.siteWide.prefix.invalid": "Prefiks harus tepat 4 huruf atau angka",
  "admin.labelPresets.siteWide.save": "Simpan pengaturan",
  "admin.labelPresets.siteWide.saved": "Pengaturan kode QR untuk seluruh tempat disimpan",
  "admin.labelPresets.siteWide.saveFailed": "Pengaturan kode QR untuk seluruh tempat tidak disimpan",
  "admin.labelPresets.siteWide.loadFailed": "Pengaturan kode QR untuk seluruh tempat tidak dapat dimuat. Muat ulang halaman untuk mencoba lagi.",
  "error.sitesettings.barcode.prefix.format": "Prefiks pracetak harus tepat 4 huruf atau angka jika seri terpisah digunakan",
  "advanced.search": "Pencarian Lanjutan",
  "alert.expired.title": "Barang Kedaluwarsa",
  "alert.expiring.title": "Segera Kedaluwarsa",
  "alert.lowStock.title": "Peringatan Stok Sedikit",
  "alerts.acknowledge.button": "Mengetahui",
  "alerts.acknowledge.comment": "Komentar Pemecahan Masalah",
  "alerts.acknowledge.comment.placeholder": "Jelaskan bagaimana peringatan diatasi...",
  "alerts.acknowledge.comment.required": "Komentar resolusi diperlukan untuk peringatan kritis",
  "alerts.acknowledge.error": "Gagal mengkonfirmasi peringatan",
  "alerts.acknowledge.success": "Berhasil mengkonfirmasi peringatan",
  "alerts.acknowledge.title": "Konfirmasi Peringatan",
  "alerts.autoRefresh": "Auto-refresh setiap 60 detik",
  "alerts.dashboard.title": "Dasbor peringatan",
  "alerts.empty": "Tidak ada peringatan untuk ditampilkan",
  "alerts.eqaDeadlineSummary.critical": "Kritis",
  "alerts.eqaDeadlineSummary.deadlineCount": "{count} deadline berikutnya",
  "alerts.eqaDeadlineSummary.subtitle": "Pengumpulan PME yang deadline dikelompokan berdasarkan penyelenggara",
  "alerts.eqaDeadlineSummary.title": "Ringkasan Deadline PME",
  "alerts.eqaDeadlineSummary.viewAll": "Lihat Semua",
  "alerts.filter.myAlerts": "Peringatan Saya",
  "alerts.filter.search": "Mencari peringatan...",
  "alerts.filter.severity": "Keparahan",
  "alerts.filter.status": "Status",
  "alerts.filter.type": "Jenis Peringatan",
  "alerts.severity.critical": "Kritis",
  "alerts.severity.warning": "Peringatan",
  "alerts.status.acknowledged": "Sudah diketahui",
  "alerts.status.open": "Buka",
  "alerts.status.resolved": "Selesai",
  "alerts.summary.critical": "Peringatan Kritis",
  "alerts.summary.eqaDeadlines": "Deadline PME",
  "alerts.summary.sampleExpiration": "Sampel segera kedaluwarsa",
  "alerts.summary.statOverdue": "Pemesanan STAT yang lewat tenggat",
  "alerts.summary.totalOpen": "Total Terbuka",
  "alerts.table.actions": "Aksi",
  "alerts.table.created": "Dibuat",
  "alerts.table.message": "Pesan",
  "alerts.table.severity": "Keparahan",
  "alerts.table.status": "Status",
  "alerts.table.type": "Jenis",
  "alerts.type.critical_result": "Hasil Kritis",
  "alerts.type.equipment_failure": "Alat Gagal",
  "alerts.type.freezer_humidity": "Kelembapan Freezer",
  "alerts.type.freezer_offline": "Freezer Offline",
  "alerts.type.freezer_temperature": "Suhu Freezer",
  "alerts.type.inventory_low": "Inventaris Rendah",
  "alerts.type.other": "Lainnya",
  "alerts.type.referral_critical_result": "Hasil Kritis Rujukan",
  "alerts.type.referral_rejected": "Rujukan Ditolak",
  "alerts.type.sample_tracking": "Pelacakan Sampel",
  "alerts.type.critical_unacknowledged": "Batalkan Konfirmasi Kritis",
  "alerts.type.eqa_deadline": "Deadline PME",
  "alerts.type.eqa_submission_failed": "Pengiriman PME Gagal",
  "alerts.type.microbiology_critical": "Mikrobiologi Kritis",
  "alerts.type.required_by_deadline": "Wajib Diserahkan Sebelum Tenggat",
  "alerts.type.sample_expiration": "Tanggal Kedaluwarsa Sampel",
  "alerts.type.stat_overdue": "STAT lewat tenggat",
  "alerts.type.stat_upcoming": "STAT segera tenggat",
  "aliquot": "Alikuot",
  "aliquot.analyses.count": "Analisis: {count}",
  "aliquot.id": "ID Alikuot",
  "aliquot.quantity": "Kuantitas Alikuot",
  "aliquot.quantity.not.balanced": "Jumlah tidak seimbang untuk jenis sampel",
  "aliquot.save.error": "Error saat menyimpan data alikuot.",
  "aliquot.save.success": "Data pembuatan alikuot sukses tersimpan.",
  "aliquot.tests.not.assigned": "Tidak menugaskan pemeriksaan pada jenis sampel",
  "aliquot.validation.errors": "Kesalahan Validasi",
  "aliquoting": "Pembuatan alikuot",
  "aliquoting.section": "Bagian pembuatan alikuot",
  "all.label": "Semua",
  "all.tests.assigned": "Semua pemeriksaan ditugaskan",
  "allocated.to.aliquots": "Dialokasikan pada Alikuot",
  "analysis.count": "Penghitungan Analisis",
  "analysis.details": "Rincian Analisis",
  "analyzer.adoption.error.heldResults": "{record} masih memiliki hasil yang ditahan dari revisi {revision}. Selesaikan terlebih dahulu sebelum mengadopsi.",
  "analyzer.adoption.error.inactiveTest": "{record} dipetakan ke pemeriksaan yang sudah tidak aktif. Pilih pemeriksaan lain sebelum mengadopsi.",
  "analyzer.adoption.error.missingAnswers": "{record} memerlukan keputusan untuk setiap jawabannya. Belum ada: {answers}.",
  "analyzer.adoption.error.missingDecisions": "Setiap rekaman yang dipertahankan revisi yang lebih baru memerlukan keputusan. Belum ada: {records}.",
  "analyzer.adoption.error.notNewer": "Adopsi memindahkan alat ke revisi yang lebih baru dari revisi {revision}.",
  "analyzer.adoption.error.revisionInactive": "Revisi {revision} dari jenis alat ini tidak aktif.",
  "analyzer.bridge.connection.httpStatus": "Analyzer Bridge menolak permintaan tersebut.",
  "analyzer.bridge.connection.invalidEvidence": "Analyzer Bridge menjawab untuk alat atau jenis alat yang berbeda.",
  "analyzer.bridge.connection.invalidRequest": "Permintaan ke Analyzer Bridge tidak lengkap.",
  "analyzer.bridge.connection.notConfigured": "Tidak ada Analyzer Bridge yang dikonfigurasi untuk server ini.",
  "analyzer.bridge.connection.reconcileRequired": "OpenELIS mempertahankan pemetaan alat sebelumnya, tetapi Analyzer Bridge mungkin masih menggunakan pemetaan yang baru. Terapkan pemetaan lagi saat Bridge dapat dijangkau agar keduanya kembali selaras.",
  "analyzer.bridge.connection.referenceNotStored": "Koneksi Analyzer Bridge tidak dapat disimpan dengan alat ini.",
  "analyzer.bridge.connection.unreachable": "Analyzer Bridge tidak dapat dijangkau.",
  "analyzer.mapping.error.catalogNotCurrent": "Pemeriksaan atau jawaban yang dipetakan sudah tidak aktif di katalog pemeriksaan. Pilih yang lain sebelum mengonfirmasi.",
  "analyzer.mapping.error.changedSinceLoaded": "Pemetaan alat ini berubah setelah halaman ini dimuat. Muat ulang halaman untuk melihat pemetaan terkini.",
  "analyzer.mapping.error.componentRequired": "{record} masuk ke komponen pemeriksaannya. Pilih komponen tersebut, atau biarkan rekaman belum terselesaikan.",
  "analyzer.mapping.error.confirmBeforeApply": "Konfirmasi pemetaan alat saat ini sebelum menerapkannya.",
  "analyzer.mapping.error.recognitionChanged": "Pengenalan kontrol pada jenis alat berubah setelah halaman ini dimuat. Muat ulang halaman sebelum mengonfirmasi.",
  "analyzer.mapping.error.resultNotCurrent": "Jawaban yang dipetakan sudah tidak aktif untuk pemeriksaannya. Pilih jawaban lain.",
  "analyzer.mapping.error.testNotCurrent": "Pemeriksaan yang dipetakan sudah tidak aktif di katalog pemeriksaan. Pilih pemeriksaan lain.",
  "analyzer.setup.assays.continue": "Lanjut Verifikasi",
  "analyzer.setup.assays.count": "{on} dari {total} uji aktif",
  "analyzer.setup.assays.help": "Aktifkan uji yang dijalankan instrumen ini, sesuai dengan pengaturan kode pemeriksaan host pada instrumen. Verifikasi hanya memetakan uji yang aktif. Hasil untuk uji yang nonaktif akan ditahan, tidak pernah hilang.",
  "analyzer.setup.assays.loadError": "Uji alat tidak dapat dimuat.",
  "analyzer.setup.assays.loading": "Memuat uji",
  "analyzer.setup.assays.match.ambiguous": "Beberapa pemeriksaan di katalog lab ini cocok",
  "analyzer.setup.assays.match.bound": "Cocok dengan {name}",
  "analyzer.setup.assays.match.excluded": "Diatur untuk tidak diterima",
  "analyzer.setup.assays.match.incompatible": "Ada pemeriksaan yang cocok tetapi tidak dapat menampung hasil ini",
  "analyzer.setup.assays.match.noMatch": "Tidak ada pemeriksaan di katalog lab ini",
  "analyzer.setup.assays.none": "Jenis alat ini tidak mendeklarasikan uji, sehingga tidak ada yang perlu dipetakan. Hasil yang dikirimnya ditahan sebagai pemeriksaan tidak dikenal dan dapat dipetakan dari hasil yang ditahan.",
  "analyzer.setup.assays.saveError": "Uji tidak dapat disimpan.",
  "analyzer.setup.assays.title": "Uji",
  "analyzer.setup.error.adoptToMove": "Untuk memindahkan alat ini ke revisi {revision}, adopsi revisi tersebut dari halaman jenis alat.",
  "analyzer.setup.error.profileKept": "Alat yang sudah dikonfigurasi tetap menggunakan jenis alatnya.",
  "analyzer.reset.error.profileAvailable": "Jenis alat ini masih tersedia. Adopsi revisi yang lebih baru untuk memindahkannya.",
  "analyzer.setup.connect.reset": "Atur ulang jenis alat",
  "analyzer.setup.connect.reset.failed": "Jenis alat tidak dapat diatur ulang. Coba lagi.",
  "analyzer.action.activate": "Aktifkan",
  "analyzer.action.add": "Tambah Alat",
  "analyzer.action.configureConnection": "Konfigurasi koneksi",
  "analyzer.action.deactivate": "Nonaktifkan",
  "analyzer.action.editSetup": "Edit pengaturan",
  "analyzer.action.qualityControl": "Kendali Mutu",
  "analyzer.action.reactivate": "Aktifkan Ulang",
  "analyzer.bridgePairing.automatic": "OpenELIS memasangkan diri secara otomatis dengan kode yang telah dikonfigurasi. Anda juga dapat memasukkan kode di sini.",
  "analyzer.bridgePairing.cancel": "Batal",
  "analyzer.bridgePairing.code.label": "Kode pemasangan",
  "analyzer.bridgePairing.error.certificateMismatch": "Bridge menjawab untuk sertifikat yang berbeda dari yang ditunjukkannya, sehingga OpenELIS tidak memasangkan diri dengannya.",
  "analyzer.bridgePairing.error.closed": "Bridge tidak menerima pemasangan. Konfigurasikan kode pemasangan baru di Bridge, mulai ulang, lalu pasangkan kembali.",
  "analyzer.bridgePairing.error.codeRequired": "Masukkan kode pemasangan.",
  "analyzer.bridgePairing.error.identity": "OpenELIS tidak dapat membuat atau membaca kuncinya untuk Bridge.",
  "analyzer.bridgePairing.error.invalidAnswer": "Jawaban Bridge tidak dapat dibaca.",
  "analyzer.bridgePairing.error.notConfigured": "Tidak ada alamat Analyzer Bridge yang dikonfigurasi untuk OpenELIS.",
  "analyzer.bridgePairing.error.refused": "Bridge menolak pemasangan.",
  "analyzer.bridgePairing.error.unreachable": "OpenELIS tidak dapat menjangkau Analyzer Bridge.",
  "analyzer.bridgePairing.error.wrongCode": "Bridge tidak menerima kode tersebut.",
  "analyzer.bridgePairing.pair": "Pasangkan",
  "analyzer.bridgePairing.pairAgain": "Pasangkan lagi",
  "analyzer.bridgePairing.paired.detail": "{url} · Sertifikat Bridge {fingerprint} · dipasangkan {pairedAt}",
  "analyzer.bridgePairing.paired.title": "Terpasang dengan Analyzer Bridge",
  "analyzer.bridgePairing.unpaired.subtitle": "Masukkan kode pemasangan yang ditampilkan Bridge di log-nya, atau kode yang telah dikonfigurasi. Hasil menunggu di Bridge sampai dipasangkan.",
  "analyzer.bridgePairing.unpaired.title": "Analyzer Bridge belum dipasangkan",
  "analyzer.combinationName.notification": "Kombinasi alat dan nama pemeriksaan di alat harus unik",
  "analyzer.fhirImport.error.importFailed": "Gagal mengimpor FHIR bundle",
  "analyzer.fhirImport.error.invalidBundleType": "Jenis bundle harus berupa 'transaksi' atau 'batch', yang ditampilkan: {bundleType}",
  "analyzer.fhirImport.error.noObservations": "Bundle tidak memiliki Observation dengan hasil",
  "analyzer.deliveryIssues.attention.review": "Tinjau hasil yang tidak terkirim",
  "analyzer.deliveryIssues.attention.subtitle": "Analyzer Bridge menahan hasil yang tidak dapat dikirimkan ke OpenELIS.",
  "analyzer.deliveryIssues.attention.title": "{count, plural, other {# hasil alat}} not delivered",
  "analyzer.deliveryIssues.column.actions": "Aksi",
  "analyzer.deliveryIssues.column.analyzer": "Alat",
  "analyzer.deliveryIssues.column.detail": "Rincian",
  "analyzer.deliveryIssues.column.reason": "Alasan",
  "analyzer.deliveryIssues.column.received": "Diterima",
  "analyzer.deliveryIssues.column.status": "Status",
  "analyzer.deliveryIssues.description": "Hasil yang diterima Analyzer Bridge tetapi belum dikirimkan ke OpenELIS. Ulang mengirim hasil kembali setelah penyebabnya diperbaiki; Abaikan menyembunyikannya dan menyimpannya di Bridge untuk audit.",
  "analyzer.deliveryIssues.dismiss": "Tutup",
  "analyzer.deliveryIssues.empty": "Bridge tidak memiliki hasil yang tidak terkirim.",
  "analyzer.deliveryIssues.error.actionFailed": "Tindakan tidak dapat diselesaikan. Muat ulang dan coba lagi.",
  "analyzer.deliveryIssues.error.bridgeInvalidResponse": "Analyzer Bridge mengirim respons yang tidak dapat dibaca OpenELIS.",
  "analyzer.deliveryIssues.error.incompleteList": "Analyzer Bridge memiliki lebih banyak hasil yang tidak terkirim daripada yang dapat dimuat tampilan ini. Tinjau outbox Bridge secara langsung.",
  "analyzer.deliveryIssues.error.bridgeNotConfigured": "OpenELIS tidak memiliki alamat Analyzer Bridge yang dikonfigurasi.",
  "analyzer.deliveryIssues.error.bridgeRefused": "Bridge menolak tindakan ini ({reason}). Muat ulang untuk melihat kondisi terkininya.",
  "analyzer.deliveryIssues.error.bridgeUnreachable": "Analyzer Bridge tidak dapat dijangkau.",
  "analyzer.deliveryIssues.error.invalidId": "Referensi hasil ini tidak valid.",
  "analyzer.deliveryIssues.loadFailed": "Hasil yang tidak terkirim tidak dapat dimuat dari Analyzer Bridge.",
  "analyzer.deliveryIssues.loading": "Memeriksa hasil yang tidak terkirim di Analyzer Bridge",
  "analyzer.deliveryIssues.reason.AMBIGUOUS_SOURCE": "Lebih dari satu koneksi alat dapat memiliki pesan ini. Berikan alamat yang berbeda untuk setiap alat, lalu ulangi.",
  "analyzer.deliveryIssues.reason.CONNECTION_TRANSPORT_MISMATCH": "Alat mengirim melalui tipe koneksi yang tidak diterima oleh pengaturannya.",
  "analyzer.deliveryIssues.reason.OE_CONFIG_STATE": "OpenELIS menolak hasil karena pengaturannya sendiri. Perbaiki pengaturan alat, lalu ulangi.",
  "analyzer.deliveryIssues.reason.OE_REJECTED": "OpenELIS menolak hasil tersebut.",
  "analyzer.deliveryIssues.reason.OE_UNEXPECTED_REDIRECT": "OpenELIS menjawab dengan pengalihan, sehingga hasil tidak terkirim. Periksa alamat OpenELIS di Bridge.",
  "analyzer.deliveryIssues.reason.PARSE_NO_RESULTS": "Pesan tidak berisi hasil untuk dikirimkan.",
  "analyzer.deliveryIssues.reason.RENDER_ERROR": "Bridge tidak dapat mengonversi pesan untuk OpenELIS.",
  "analyzer.deliveryIssues.reason.RETRY_EXHAUSTED": "OpenELIS tetap tidak dapat dijangkau sampai semua percobaan ulang habis. Hasil masih utuh; ulangi setelah OpenELIS dapat dijangkau.",
  "analyzer.deliveryIssues.reason.UNPINNED_PROFILE": "Koneksi alat tidak memiliki revisi jenis alat, sehingga hasilnya tidak dapat dibaca.",
  "analyzer.deliveryIssues.reason.UNREGISTERED_SOURCE": "Pengirim tidak cocok dengan koneksi alat yang tersimpan. Siapkan alat, lalu ulangi.",
  "analyzer.deliveryIssues.reason.none": "OpenELIS belum menerima hasil; Bridge terus mencoba ulang.",
  "analyzer.deliveryIssues.reason.unknown": "Bridge tidak dapat mengirimkan hasil ini ({code}).",
  "analyzer.deliveryIssues.retry": "Ulang",
  "analyzer.deliveryIssues.state.deadLettered": "Tidak terkirim",
  "analyzer.deliveryIssues.state.retrying": "Mencoba ulang",
  "analyzer.deliveryIssues.title": "Hasil alat yang tidak terkirim",
  "analyzer.deliveryIssues.unrecognizedSender": "Pengirim tidak dikenal {source}",
  "analyzer.importIssues.accession": "Nomor Registrasi",
  "analyzer.importIssues.action": "Aksi",
  "analyzer.importIssues.description": "Tinjau peristiwa pada alat analisis mikrobiologi yang tidak dapat dicocokkan atau diproses. Hasil yang ditahan ditinjau dalam daftar kerja hasil masing-masing alat analisis.",
  "analyzer.importIssues.empty": "Tidak ada kejadian kegagalan alat analisis mikrobiologi yang memerlukan perhatian",
  "analyzer.importIssues.event": "Kejadian",
  "analyzer.importIssues.event.astQcFail": "Kegagalan Kendali Mutu AST",
  "analyzer.importIssues.event.astResultAvailable": "Hasil AST sudah tersedia",
  "analyzer.importIssues.event.unknown": "Peristiwa Alat ({code})",
  "analyzer.importIssues.events.description": "Perbaiki pemetaan alat atau informasi target sebelum sumber mengirimkan hasilnya kembali.",
  "analyzer.importIssues.events.title": "Peristiwa alat yang macet",
  "analyzer.importIssues.failure.astRunNotMatched": "Tidak ada proses AST yang cocok dengan pengidentifikasi alat analisis dan kartu tersebut.",
  "analyzer.importIssues.failure.processingFailed": "Peristiwa Alat tidak dapat diproses.",
  "analyzer.importIssues.failure.unknown": "Peristiwa Alat tidak dapat diproses ({code}).",
  "analyzer.importIssues.loadFailed": "Masalah impor alat tidak dapat dimuat",
  "analyzer.importIssues.loading": "Memuat masalah impor alat",
  "analyzer.importIssues.openMappings": "Buka pemetaan",
  "analyzer.importIssues.openResults": "Buka hasil alat",
  "analyzer.importIssues.reason": "Alasan kegagalan",
  "analyzer.importIssues.received": "Diterima",
  "analyzer.importIssues.result": "Hasil",
  "analyzer.importIssues.source": "Identitas Sumber",
  "analyzer.importIssues.staging.description": "Baris hasil yang diimpor ini memerlukan perbaikan konfigurasi alat sebelum dilakukan validasi.",
  "analyzer.importIssues.staging.title": "Masalah hasil di staging",
  "analyzer.importIssues.target": "Referensi target",
  "analyzer.importIssues.test": "Pemeriksaan",
  "analyzer.importIssues.title": "Masalah impor Alat",
  "analyzer.fieldCreation.acceptedUnits.label": "Satuan yang diterima",
  "analyzer.fieldCreation.acceptedUnits.placeholder": "Pilih satuan yang diterima",
  "analyzer.fieldCreation.cancel": "Batalkan",
  "analyzer.fieldCreation.confirmation": "Saya mengerti bidang ini akan tersedia untuk pemetaan segera setelah dibuat",
  "analyzer.fieldCreation.create": "Buat Bidang",
  "analyzer.fieldCreation.createNew": "Buat Bidang Baru",
  "analyzer.fieldCreation.description.label": "Deskripsi (Opsional)",
  "analyzer.fieldCreation.description.placeholder": "Masukkan deskripsi bidang",
  "analyzer.fieldCreation.entityType.label": "Jenis Entitas",
  "analyzer.fieldCreation.entityType.placeholder": "Pilih jenis entitas",
  "analyzer.fieldCreation.error.generic": "Gagal membuat bidang",
  "analyzer.fieldCreation.error.title": "Error saat membuat bidang",
  "analyzer.fieldCreation.fieldName.label": "Nama Bidang",
  "analyzer.fieldCreation.fieldName.placeholder": "Masukkan nama bidang",
  "analyzer.fieldCreation.fieldType.label": "Jenis Bidang",
  "analyzer.fieldCreation.fieldType.placeholder": "Pilih jenis bidang",
  "analyzer.fieldCreation.loincCode.label": "Kode LOINC (Opsional)",
  "analyzer.fieldCreation.loincCode.placeholder": "Masukkan kode LOINC",
  "analyzer.fieldCreation.modal.subtitle": "Buat bidang baru yang siap dipetakan segera",
  "analyzer.fieldCreation.modal.title": "Buat Bidang Baru SILNAS",
  "analyzer.fieldCreation.success.message": "Bidang sudah tersedia untuk pemetaan",
  "analyzer.fieldCreation.success.title": "Bidang berhasil dibuat",
  "analyzer.fieldCreation.validation.entityType.required": "Wajib ada jenis entitas",
  "analyzer.fieldCreation.validation.fieldName.required": "Wajib ada nama bidang",
  "analyzer.fieldCreation.validation.unique": "Bidang dengan nama ini sudah ada",
  "analyzer.fieldCreation.validation.units.required": "Satuan yang diterima wajib diisi untuk kolom numerik.",
  "analyzer.filter.lifecycleStage.all": "Semua Tahapan Siklus Hidup",
  "analyzer.filter.lifecycleStage.label": "Tahapan Siklus Hidup",
  "analyzer.filter.status": "Status",
  "analyzer.filter.status.all": "Semua Status",
  "analyzer.filter.status.label": "Status",
  "analyzer.filter.testUnit": "Instalasi Lab",
  "analyzer.filter.type": "Jenis Alat",
  "analyzer.form.activeStatus": "Status Aktif",
  "analyzer.form.activeStatus.description": "Aktifkan alat ini untuk koleksi data",
  "analyzer.form.addTitle": "Tambah Alat Baru",
  "analyzer.form.cancel": "Batalkan",
  "analyzer.form.communicationMode": "Mode Komunikasi",
  "analyzer.form.communicationMode.analyzerInitiated": "Alat → SIL (alat terkoneksi ke OpenELIS)",
  "analyzer.form.communicationMode.both": "Bidireksional (dua arah)",
  "analyzer.form.communicationMode.help": "Yang memulai koneksi. Umumnya menggunakan Alat → SIL.",
  "analyzer.form.communicationMode.lisInitiated": "SIL → Alat (SIL terhubung ke alat)",
  "analyzer.form.createdBy": "Dibuat Oleh",
  "analyzer.form.createdDate": "Tanggal/Waktu Dibuat",
  "analyzer.form.defaults.error": "Gagal memuat konfigurasi default",
  "analyzer.form.defaults.loaded": "Konfigurasi default dimuat",
  "analyzer.form.defaults.loaded.subtitle": "Templat untuk {name} berhasil dimuat. Lakukan kustomisasi sebelum menyimpan.",
  "analyzer.form.editTitle": "Edit Alat",
  "analyzer.form.error.invalidCommunicationMode": "Mode komunikasi invalid: {value}. Nilai valid: {validValues}",
  "analyzer.form.error.invalidProtocolVersion": "Versi protokol invalid: {value}. Nilai valid: {validValues}",
  "analyzer.form.error.save": "Gagal menyimpan alat",
  "analyzer.form.error.unknown": "Terjadi error yang tidak diketahui",
  "analyzer.form.fileProtocol.description": "Alat ini mengimpor hasil dari file. Pengaturan impor akan dikonfigurasi setelah menyimpan.",
  "analyzer.form.fileProtocol.title": "Protokol Impor File",
  "analyzer.form.identifierPattern": "Pola Pengidentifikasi",
  "analyzer.form.identifierPattern.helperText": "Pola Regex untuk mencocokkan pengidentfikasi pesan masuk untuk routing",
  "analyzer.form.identifierPattern.placeholder": "misalnya, ^ABX\\^PENTRA.*",
  "analyzer.form.ipAddress": "Alamat IP",
  "analyzer.form.ipAddress.placeholder": "192.168.1.10",
  "analyzer.form.lastModified": "Tanggal/Waktu Modifikasi Terakhir",
  "analyzer.form.loadDefaultConfig": "Muat Konfigurasi Default",
  "analyzer.form.loadDefaultConfig.helperText": "Pengaturan cepat menggunakan templat alat pre-konfigurasi untuk plugin GenericASTM dan GenericHL7",
  "analyzer.form.loadDefaultConfig.placeholder": "Pilih templat alat pre-konfigurasi",
  "analyzer.form.name": "Nama Alat",
  "analyzer.form.name.placeholder": "misalnya, Hematology Analyzer 1",
  "analyzer.form.pluginType": "Jenis Plugin",
  "analyzer.form.pluginType.helperText": "Plugin alat yang akan menangani pesan masuk",
  "analyzer.form.pluginType.placeholder": "Pilih jenis plugin...",
  "analyzer.form.port": "Nomor Portal",
  "analyzer.form.port.placeholder": "5000",
  "analyzer.form.protocolVersion": "Versi Protokol",
  "analyzer.form.save": "Simpan",
  "analyzer.form.status": "Status",
  "analyzer.form.status.helperText": "Transisi status berdasarkan status alat. Pembatalan manual hanya untuk INAKTIF, PENGATURAN, dan VALIDASI.",
  "analyzer.form.subtitle": "Konfigurasi pengaturan koneksi alat dan instalasi lab",
  "analyzer.form.success.save": "Alat berhasil disimpan",
  "analyzer.form.testConnection": "Tes Koneksi",
  "analyzer.form.testConnection.error": "Koneksi Gagal",
  "analyzer.form.testUnits": "Penugasan Instalasi Lab",
  "analyzer.form.testUnits.helper": "Pilih satu atau lebih instalasi lab untuk alat ini",
  "analyzer.form.testUnits.placeholder": "Pilih instalasi lab...",
  "analyzer.form.type": "Jenis Alat",
  "analyzer.form.type.helperText": "Pilih Jenis Alat yang dapat digunakan kembali untuk koneksi yang telah dipasang ini.",
  "analyzer.form.type.invalidSelection": "Revisi Jenis Alat tersebut tidak tersedia atau sudah inaktif",
  "analyzer.form.type.loadError": "Jenis Alat tidak dapat dimuat",
  "analyzer.form.type.other": "Lainnya",
  "analyzer.form.type.placeholder": "Pilih jenis alat",
  "analyzer.form.type.revision": "{name}, revisi {revision} ({protocol})",
  "analyzer.form.validation.ipAddress.invalid": "Format alamat IP tidak valid",
  "analyzer.form.validation.name.required": "Wajib mengisi nama alat",
  "analyzer.form.validation.type.required": "Wajib mengisi jenis alat",
  "analyzer.hl7.insertError": "Error memasukkan HL7",
  "analyzer.hl7.parseError": "Error saat mengurai HL7",
  "analyzer.hl7.unknownAnalyzer": "Tidak dapat mengidentifikasi dari HL7 MSH (aplikasi/fasilitas yang mengirim)",
  "analyzer.list.subtitle": "Kelola alat laboratorium dan pemetaan bidang",
  "analyzer.list.title": "Alat",
  "analyzer.lifecycle.activate.blockedMessage": "Lengkapi persyaratan pengaturan ini sebelum mengaktifkan. Buka Edit pengaturan pada alat ini untuk memverifikasi pemetaan dan koneksinya.",
  "analyzer.lifecycle.activate.blockedTitle": "Alat analisis belum siap",
  "analyzer.lifecycle.activate.cancel": "Batalkan aktivasi",
  "analyzer.lifecycle.activate.confirm": "Aktifkan alat",
  "analyzer.lifecycle.activate.error": "Alat tidak dapat diaktifkan.",
  "analyzer.lifecycle.activate.errorTitle": "Aktivasi gagal",
  "analyzer.lifecycle.activate.message": "Aktifkan {name}? Pengaturannya akan diperiksa sebelum dapat digunakan.",
  "analyzer.lifecycle.activate.title": "Aktifkan alat",
  "analyzer.lifecycle.deactivate.cancel": "Batalkan penonaktifan",
  "analyzer.lifecycle.deactivate.confirm": "Nonaktifkan alat analisis",
  "analyzer.lifecycle.deactivate.error": "Alat analisis tersebut tidak dapat dinonaktifkan.",
  "analyzer.lifecycle.deactivate.errorTitle": "Penonaktifan gagal",
  "analyzer.lifecycle.deactivate.message": "Nonaktifkan {name}? Penggunaan runtime baru akan dihentikan. Konfigurasi dan riwayatnya akan tetap disimpan, dan alat ini dapat diaktifkan ulang nanti.",
  "analyzer.lifecycle.deactivate.title": "Nonaktifkan alat analisis",
  "analyzer.lifecycle.reactivate.blockedMessage": "Selesaikan persyaratan pengaturan ini sebelum mengaktifkan ulang. Buka Edit pengaturan pada alat ini untuk memverifikasi pemetaan dan koneksinya.",
  "analyzer.lifecycle.reactivate.blockedTitle": "Alat analisis belum siap",
  "analyzer.lifecycle.reactivate.cancel": "Batalkan reaktivasi",
  "analyzer.lifecycle.reactivate.confirm": "Aktifkan ulang alat analisis",
  "analyzer.lifecycle.reactivate.error": "Alat analisis tersebut tidak dapat diaktifkan ulang.",
  "analyzer.lifecycle.reactivate.errorTitle": "Pengaktifan ulang gagal",
  "analyzer.lifecycle.reactivate.message": "Aktifkan Ulang {name}? Pengaturannya akan diperiksa kembali sebelum dapat digunakan.",
  "analyzer.lifecycle.reactivate.title": "Aktifkan ulang alat analisis",
  "analyzer.connection.choice.select": "Pilih nilai",
  "analyzer.connection.field.apiToken": "Token API",
  "analyzer.connection.field.connectionRole": "Peran koneksi",
  "analyzer.connection.field.directory": "Direktori",
  "analyzer.connection.field.directory.help": "Direktori pada host Analyzer Bridge",
  "analyzer.connection.field.enabled": "Diaktifkan",
  "analyzer.connection.field.filePattern": "Pola File",
  "analyzer.connection.field.filePattern.help": "Pola nama file yang dipantau oleh Analyzer Bridge",
  "analyzer.connection.field.host": "Host",
  "analyzer.connection.field.host.help": "Alamat IP alat. Opsional jika alat terhubung ke Analyzer Bridge. Kosongkan jika alat menjangkau bridge melalui NAT atau proxy, dan gunakan nama sistem instrumen sebagai gantinya.",
  "analyzer.connection.field.numberFormat": "Pemisah desimal dalam hasil",
  "analyzer.connection.numberFormat.comma": "Koma (12,5)",
  "analyzer.connection.numberFormat.point": "Titik (12.5)",
  "analyzer.connection.field.port": "Portal",
  "analyzer.connection.field.senderId": "Nama sistem instrumen",
  "analyzer.connection.field.senderId.help": "Nama yang dikirim instrumen ini dalam pesannya (ASTM H.5 atau HL7 MSH-3), misalnya System Name GeneXpert. Hanya diperlukan jika beberapa alat berbagi port dan alamat ini.",
  "analyzer.connection.field.serialPort": "Perangkat serial",
  "analyzer.connection.field.transport": "Transportasi",
  "analyzer.connection.field.unavailable": "Pengaturan koneksi",
  "analyzer.connection.readiness.profileUnavailable": "Koneksi ini terkunci pada {profileId} revisi {revision}, yang sudah tidak dimiliki Analyzer Bridge. Atur ulang jenis alat, lalu pilih jenis yang tersedia untuk menghubungkannya kembali. Alat tetap menyimpan nama, Instalasi Lab, koneksi, dan riwayatnya.",
  "analyzer.connection.readiness.restoreFailed": "Analyzer Bridge tidak dapat memulai ulang koneksi ini. Aktifkan lagi; jika masih gagal, periksa log Bridge.",
  "analyzer.connection.role.client": "Klien",
  "analyzer.connection.role.server": "Server",
  "analyzer.connection.reference.configured": "Koneksi Bridge telah dikonfigurasi",
  "analyzer.connection.reference.missing": "Pengaturan koneksi wajib",
  "analyzer.connection.transport.RS-232": "Serial (RS-232)",
  "analyzer.connection.transport.TCP/IP": "Jaringan (TCP/IP)",
  "analyzer.connection.validation.invalid": "Periksa nilai ini.",
  "analyzer.connection.validation.required": "Bidang ini diperlukan.",
  "analyzer.setup.close": "Tutup pengaturan alat",
  "analyzer.setup.connect.address.required": "Masukkan alamat alat analisis",
  "analyzer.activation.blocker.bridgeAcknowledgement": "Analyzer Bridge belum mengetahui pengaturan persis seperti ini.",
  "analyzer.activation.blocker.connection": "Pengaturan koneksi belum lengkap atau tidak valid.",
  "analyzer.activation.blocker.dataFlow": "Alur data yang dipilih tidak didukung oleh jenis alat ini.",
  "analyzer.activation.blocker.labUnit": "Tugaskan setidaknya satu instalasi lab yang aktif.",
  "analyzer.activation.blocker.mappings": "Pemetaan alat analisis harus diverifikasi kembali.",
  "analyzer.activation.blocker.name": "Masukkan nama alat analisis.",
  "analyzer.activation.blocker.profile": "Revisi jenis alat yang dipilih tidak tersedia atau tidak lagi sesuai dengan alat ini.",
  "analyzer.activation.blocker.recognition": "Pengenalan kontrol harus diverifikasi kembali.",
  "analyzer.activation.blocker.transport": "Jenis koneksi yang dipilih tidak didukung oleh jenis alat ini.",
  "analyzer.setup.connect.activation.active": "Alat sedang aktif",
  "analyzer.setup.connect.activation.activating": "Mengaktifkan alat analisis",
  "analyzer.setup.connect.activation.blockerUnknown": "Pengaturan alat analisis belum siap untuk diaktifkan.",
  "analyzer.setup.connect.activation.cancel": "Batal",
  "analyzer.setup.connect.activation.error": "Kesiapan alat analisis tidak dapat diperiksa.",
  "analyzer.setup.connect.activation.finish": "Selesai dan aktifkan",
  "analyzer.setup.connect.activation.loading": "Memeriksa kesiapan alat analisis",
  "analyzer.setup.connect.activation.readiness": "Kesiapan aktivasi",
  "analyzer.setup.connect.activation.ready": "Alat analisis sudah siap diaktifkan",
  "analyzer.setup.connect.activation.saveChanges": "Simpan Perubahan",
  "analyzer.setup.connect.activation.saveLater": "Simpan dan selesaikan nanti",
  "analyzer.setup.connect.activation.saving": "Menyimpan alat analisis",
  "analyzer.setup.connect.activation.verifyMappings": "Verifikasi pemetaan",
  "analyzer.setup.connect.analyzerAddress": "Alamat alat analisis",
  "analyzer.setup.connect.check.analyzer.address.missing": "Alamat alat belum disimpan, sehingga alat tidak diperiksa. Hasil yang masuk dari alat membuktikan koneksi berfungsi.",
  "analyzer.setup.connect.check.analyzer.host.unknown": "Alamat alat {host} tidak dapat dikenali, sehingga alat tidak diperiksa. Hasil yang masuk dari alat membuktikan koneksi berfungsi.",
  "analyzer.setup.connect.check.analyzer.reachable": "Bridge berhasil mencapai alat di {host}.",
  "analyzer.setup.connect.check.analyzer.unreachable": "Bridge tidak dapat mencapai alat di {host}. Alat yang terhubung ke Bridge sering kali tidak dapat dijangkau dari Bridge (firewall, NAT, atau server yang di-hosting). Hasil yang masuk dari alat membuktikan koneksi berfungsi.",
  "analyzer.setup.connect.check.connection.mode.unsupported": "Mode koneksi ini tidak didukung oleh Bridge.",
  "analyzer.setup.connect.check.directory.configuration.missing": "Masukkan direktori berkas alat sebelum melakukan pengujian.",
  "analyzer.setup.connect.check.directory.not.directory": "Jalur yang dikonfigurasi bukanlah sebuah direktori.",
  "analyzer.setup.connect.check.directory.not.found": "Direktori yang telah dikonfigurasi tidak ditemukan.",
  "analyzer.setup.connect.check.directory.not.readable": "Bridge tidak dapat membaca direktori yang dikonfigurasi.",
  "analyzer.setup.connect.check.directory.path.invalid": "Jalur direktori yang dikonfigurasi tidak valid.",
  "analyzer.setup.connect.check.directory.ready": "Direktori sudah siap.",
  "analyzer.setup.connect.check.http.configuration.missing": "Masukkan alamat web alat analisis sebelum melakukan pemeriksaan.",
  "analyzer.setup.connect.check.http.connection.error": "Bridge tidak dapat terhubung ke alamat web alat analisis.",
  "analyzer.setup.connect.check.http.input.verify.with.delivery": "Alat ini mengirim pesan ke Bridge, sehingga koneksi ini harus diverifikasi dengan mengirimkan hasil.",
  "analyzer.setup.connect.check.http.interrupted": "Pengujian koneksi web terputus.",
  "analyzer.setup.connect.check.http.ready": "Alamat web alat analisis tersebut dapat diakses.",
  "analyzer.setup.connect.check.http.server.error": "Alamat web alat analisis tersebut menampilkan kesalahan server.",
  "analyzer.setup.connect.check.http.timeout": "Alamat web alat analisis tersebut tidak merespons sebelum batas waktu habis.",
  "analyzer.setup.connect.check.http.url.invalid": "Alamat web Alat analisis tersebut tidak valid.",
  "analyzer.setup.connect.check.listener.configuration.missing": "Penerima Bridge bersama belum dikonfigurasi. Minta administrator Bridge untuk memeriksa pengaturan penerimanya.",
  "analyzer.setup.connect.check.listener.endpoint.missing": "Alamat listener Bridge belum dikonfigurasi.",
  "analyzer.setup.connect.check.listener.not.listening": "Listener Bridge tidak menerima koneksi.",
  "analyzer.setup.connect.check.listener.port.in.use": "Port pendengar Bridge yang telah dikonfigurasi sedang digunakan.",
  "analyzer.setup.connect.check.listener.profile.unsupported": "Profil yang disematkan tidak mendefinisikan pendengar Bridge yang kompatibel.",
  "analyzer.setup.connect.check.listener.ready": "Listener Bridge sudah siap.",
  "analyzer.setup.connect.check.listener.timeout": "Listener Bridge tidak merespons sebelum batas waktu habis.",
  "analyzer.setup.connect.check.remote.astm.ready": "Alat analisis tersebut telah selesai melakukan proses handshake ASTM.",
  "analyzer.setup.connect.check.remote.astm.response.invalid": "Alat analisis tersebut mengembalikan respons handshake ASTM yang tidak valid.",
  "analyzer.setup.connect.check.remote.configuration.missing": "Periksa alamat alat dan pengaturan tujuan keluar. Port pengganti opsional dapat menggantikan port default jenis alat atau Bridge.",
  "analyzer.setup.connect.check.remote.connection.error": "Bridge tidak dapat terhubung ke alat.",
  "analyzer.setup.connect.check.remote.hl7.ready": "Alat analisis telah menyelesaikan proses handshake HL7.",
  "analyzer.setup.connect.check.remote.hl7.response.invalid": "Alat analisis tersebut mengembalikan respons handshake HL7 yang tidak valid.",
  "analyzer.setup.connect.check.remote.host.unknown": "Alamat alat tidak dapat diidentifikasi.",
  "analyzer.setup.connect.check.remote.protocol.unsupported": "Protokol alat ini tidak mendukung pemeriksaan koneksi jarak jauh.",
  "analyzer.setup.connect.check.remote.refused": "Alat analisis menolak koneksi tersebut.",
  "analyzer.setup.connect.check.remote.timeout": "Alat analisis tersebut tidak merespons sebelum batas waktu habis.",
  "analyzer.setup.connect.check.serial.configuration.missing": "Masukkan perangkat serial alat sebelum melakukan pengujian.",
  "analyzer.setup.connect.check.serial.not.found": "Perangkat serial yang telah dikonfigurasi tidak ditemukan.",
  "analyzer.setup.connect.check.serial.not.readable": "Bridge tidak dapat membaca perangkat serial yang dikonfigurasi.",
  "analyzer.setup.connect.check.serial.path.invalid": "Jalur perangkat serial yang dikonfigurasi tidak valid.",
  "analyzer.setup.connect.check.serial.ready": "Perangkat serial alat sudah siap.",
  "analyzer.setup.connect.checkKind.analyzer": "Alat (sebagai informasi)",
  "analyzer.setup.connect.checkKind.directory": "Direktori",
  "analyzer.setup.connect.checkKind.http_endpoint": "Alamat situs web",
  "analyzer.setup.connect.checkKind.http_input": "Pesan masuk dari alat",
  "analyzer.setup.connect.checkKind.listener": "Listener Bridge",
  "analyzer.setup.connect.checkKind.other": "Pemeriksaan koneksi",
  "analyzer.setup.connect.checkKind.remote_protocol": "Protokol alat",
  "analyzer.setup.connect.checkKind.serial_device": "Perangkat serial",
  "analyzer.setup.connect.checkStatus.failed": "Pemeriksaan koneksi gagal.",
  "analyzer.setup.connect.checkStatus.missing_configuration": "Pengaturan koneksi belum lengkap.",
  "analyzer.setup.connect.checkStatus.passed": "Pemeriksaan koneksi lolos.",
  "analyzer.setup.connect.checkStatus.skipped": "Pemeriksaan koneksi ini tidak dapat dijalankan.",
  "analyzer.setup.connect.checkStatus.timed_out": "Waktu tunggu pemeriksaan koneksi telah habis.",
  "analyzer.setup.connect.configureEndpoint": "Konfigurasi alat analisis agar menggunakan",
  "analyzer.setup.connect.dataFlow": "Aliran data",
  "analyzer.setup.connect.dataFlow.resultsOnly": "Hanya hasil",
  "analyzer.setup.connect.dataFlow.twoWay": "Dua arah",
  "analyzer.setup.connect.destination": "Tujuan: {host}, portal {port}",
  "analyzer.setup.connect.destinationRemediation": "Periksa alamat alat, portal tujuan, layanan penerima, dan akses jaringan, lalu uji kembali.",
  "analyzer.setup.connect.listenerPort": "Portal penerima Bridge: {port}",
  "analyzer.setup.connect.portSource": "Portal dipilih dari: {source}",
  "analyzer.setup.connect.portSource.override": "Penggantian pada koneksi",
  "analyzer.setup.connect.portSource.profile": "Default jenis alat",
  "analyzer.setup.connect.portSource.bridge": "Default Bridge",
  "analyzer.setup.connect.directory": "Direktori berkas Alat",
  "analyzer.setup.connect.directory.required": "Masukkan direktori berkas alat",
  "analyzer.setup.connect.error": "Pengaturan koneksi tidak dapat disimpan atau diuji.",
  "analyzer.setup.connect.evidence": "Bukti koneksi",
  "analyzer.setup.connect.loadError": "Koneksi alat yang telah disimpan tidak dapat dimuat.",
  "analyzer.setup.connect.loading": "Memuat koneksi alat",
  "analyzer.setup.connect.outcome.failure": "Koneksi Gagal",
  "analyzer.setup.connect.outcome.missing_configuration": "Pengaturan koneksi belum lengkap",
  "analyzer.setup.connect.outcome.success": "Koneksi siap",
  "analyzer.setup.connect.outcome.timeout": "Waktu tunggu koneksi habis",
  "analyzer.setup.connect.port": "Port alat",
  "analyzer.setup.connect.port.invalid": "Masukkan nomor port dari 1 hingga 65535",
  "analyzer.setup.connect.sourceAddress": "Alamat sumber alat",
  "analyzer.setup.connect.test": "Tes Koneksi",
  "analyzer.setup.connect.testing": "Menguji koneksi",
  "analyzer.setup.connect.title": "Hubungkan",
  "analyzer.setup.connect.useResultsOnly": "Gunakan hanya hasil",
  "analyzer.setup.instrument.continue": "Lanjut ke Assay",
  "analyzer.setup.instrument.labUnits": "Instalasi Lab",
  "analyzer.setup.instrument.labUnits.placeholder": "Pilih instalasi lab",
  "analyzer.setup.instrument.labUnits.required": "Pilih setidaknya satu instalasi lab",
  "analyzer.setup.instrument.name": "Nama Alat Analisis",
  "analyzer.setup.instrument.name.required": "Masukkan nama alat analisis",
  "analyzer.setup.instrument.notListed": "Alat yang dicari tidak tercantum?",
  "analyzer.setup.instrument.saveError": "Alat analisis tidak dapat disimpan. Silakan coba lagi.",
  "analyzer.setup.instrument.saving": "Menyimpan alat analisis",
  "analyzer.setup.instrument.summary": "Rincian alat yang telah disimpan",
  "analyzer.setup.step.edit": "Edit {step}",
  "analyzer.setup.instrument.type": "Jenis Alat",
  "analyzer.setup.instrument.type.helper": "Pilih jenis yang tercantum untuk alat Anda, meskipun alat hanya akan mengirim hasil. Apakah alat hanya mengirim hasil atau juga menerima pemesanan diatur kemudian, di Koneksi.",
  "analyzer.setup.instrument.type.placeholder": "Cari jenis alat",
  "analyzer.setup.instrument.type.required": "Pilih jenis alat analisis",
  "analyzer.setup.instrument.typeOption": "{name} · {manufacturer} · {protocol} · revisi {revision}",
  "analyzer.setup.instrument.title": "Alat",
  "analyzer.setup.steps": "Langkah-langkah pengaturan Alat analisis",
  "analyzer.setup.title": "Siapkan alat baru",
  "analyzer.setup.title.named": "Atur {name}",
  "analyzer.setup.verify.confirm": "Konfirmasi pemetaan di bawah untuk melanjutkan.",
  "analyzer.setup.verify.noAssays": "Tidak ada uji yang aktif untuk alat ini. Aktifkan uji yang dijalankannya di Uji.",
  "analyzer.setup.verify.unresolved": "{count, plural, other {# rekaman atau nilai}} of the assays that are on still need mapping. Map them below, or turn the assay off in Assays if this instrument does not run it.",
  "analyzer.setup.verify.continue": "Lanjut Hubungkan",
  "analyzer.setup.verify.selecting": "Sedang menerapkan pemetaan...",
  "analyzer.setup.verify.selectionError": "Pemetaan yang telah ditinjau tidak dapat diterapkan. Muat ulang Verifikasi dan coba lagi.",
  "analyzer.setup.verify.loading": "Memuat verifikasi pemetaan",
  "analyzer.setup.verify.summary": "Pemetaan yang telah ditinjau untuk pengaturan ini",
  "analyzer.setup.verify.summary.stale": "Pemetaan perlu diverifikasi ulang",
  "analyzer.setup.verify.title": "Verifikasi",
  "analyzer.navigation.analyzerTypes": "Jenis Alat",
  "analyzer.navigation.analyzers": "Alat",
  "analyzer.navigation.analyzersList": "Daftar Alat",
  "analyzer.navigation.fieldMappings": "Pemetaan Bidang",
  "analyzer.navigation.qc": "Kendali Mutu",
  "analyzer.navigation.qcDashboard": "Dasbor QC",
  "analyzer.navigation.qcAlerts": "Peringatan dan Pelanggaran Kendali Mutu",
  "analyzer.navigation.qcCorrectiveActions": "Tindakan perbaikan",
  "analyzerType.action.deactivate": "Nonaktifkan",
  "analyzerType.action.editMappings": "Lihat pemetaan default",
  "analyzerType.action.history": "Lihat Riwayat",
  "analyzerType.action.reactivate": "Aktifkan Ulang",
  "analyzerType.action.updateShared": "Perbarui jenis bersama",
  "analyzerType.adoption.adopted": "Revisi {revision} telah diadopsi. Konfirmasi pemetaan di bawah, lalu terapkan untuk mengganti alat ini.",
  "analyzerType.adoption.blocked.heldResults": "{code} masih memiliki hasil yang ditahan dari revisi {revision}. Selesaikan terlebih dahulu sebelum mengadopsi.",
  "analyzerType.adoption.blocked.inactiveTest": "Dipetakan ke pemeriksaan yang sudah tidak aktif. Pilih pemeriksaan lain.",
  "analyzerType.adoption.blocked.reviewHeld": "Tinjau hasil yang ditahan",
  "analyzerType.adoption.bucket.blocked": "Terblokir",
  "analyzerType.adoption.bucket.blocked.help": "Adopsi menunggu hingga semua ini diselesaikan.",
  "analyzerType.adoption.bucket.changed": "Berubah",
  "analyzerType.adoption.bucket.changed.help": "Revisi yang lebih baru mengusulkan pilihan lain untuk item ini. Pertahankan pilihan saat ini atau gunakan default baru.",
  "analyzerType.adoption.bucket.needs_mapping": "Perlu pemetaan",
  "analyzerType.adoption.bucket.needs_mapping.help": "Baru di revisi ini, atau tidak lagi dibawa. Petakan sekarang atau tunda untuk nanti.",
  "analyzerType.adoption.bucket.retired": "Tidak lagi dikirim",
  "analyzerType.adoption.bucket.retired.help": "Revisi {revision} tidak lagi mengirim item ini, sehingga pemetaannya dihapus.",
  "analyzerType.adoption.bucket.unchanged": "Tidak berubah",
  "analyzerType.adoption.bucket.unchanged.help": "Item ini dibawa apa adanya.",
  "analyzerType.adoption.changed.current": "Saat ini: {name}",
  "analyzerType.adoption.changed.newDefault": "Default baru: {name}",
  "analyzerType.adoption.error.save": "Adopsi tidak dapat disimpan",
  "analyzerType.adoption.keepCurrent": "Pertahankan yang saat ini",
  "analyzerType.adoption.notice.subtitle": "Alat ini tetap menerima dengan revisi {from} sampai Anda menyimpan, mengonfirmasi, dan menerapkan perubahan ini.",
  "analyzerType.adoption.notice.title": "Mengadopsi revisi {revision}",
  "analyzerType.adoption.save": "Simpan sebagai revisi {revision}",
  "analyzerType.adoption.title": "Adopsi revisi {revision} dari {name}",
  "analyzerType.adoption.useNewDefault": "Gunakan default baru",
  "analyzerType.affectedAnalyzers.heading": "{count, plural, other {Alat yang menggunakan jenis ini}}",
  "analyzerType.affectedAnalyzers.adopt": "Adopsi revisi {revision}",
  "analyzerType.affectedAnalyzers.verify": "Verifikasi pemetaan tersimpan",
  "analyzerType.actions.ariaLabel": "Aksi untuk {name}",
  "analyzerType.button.create": "Buat Jenis Alat Baru",
  "analyzerType.button.cancel": "Batal",
  "analyzerType.button.duplicate": "Duplikasi Profil",
  "analyzerType.button.publish": "Publikasikan Profil",
  "analyzerType.button.startUpdate": "Mulai pembaruan",
  "analyzerType.column.actions": "Aksi",
  "analyzerType.column.protocol": "Protokol",
  "analyzerType.column.resultsMapped": "Hasil yang telah dipetakan",
  "analyzerType.column.status": "Status",
  "analyzerType.column.testsMapped": "Pemeriksaan yang telah dipetakan",
  "analyzerType.column.type": "Jenis Alat",
  "analyzerType.column.usedBy": "Digunakan oleh",
  "analyzerType.dataFlow.resultsOnly": "Hanya hasil",
  "analyzerType.dataFlow.twoWay": "Dua arah",
  "analyzerType.duplicate.lineage.subtitle": "Profil baru ini dimulai dari revisi {name} dengan nomor {revision}. Perubahan-perubahan selanjutnya tidak memengaruhi profil sumber maupun Alat analisisnya.",
  "analyzerType.duplicate.lineage.title": "Profil baru dengan riwayat asal yang dipertahankan",
  "analyzerType.draft.created.subtitle": "Draf tersebut disimpan di Analyzer Bridge. Draf tersebut harus selesai dan diverifikasi terlebih dahulu sebelum dapat dipublikasikan untuk pengaturan alat analisis.",
  "analyzerType.draft.created.title": "Draf profil telah dibuat",
  "analyzerType.draft.loading": "Memuat draf profil",
  "analyzerType.draft.publish.ready.subtitle": "{name} memiliki identitas unik yang dimiliki oleh Bridge dan mempertahankan riwayat asal sumbernya.",
  "analyzerType.draft.publish.ready.title": "Siap dipublikasikan",
  "analyzerType.draft.publish.review.subtitle": "Periksa dan simpan perilaku pengenalan kontrol untuk {name} sebelum dipublikasikan.",
  "analyzerType.draft.publish.review.title": "Selesaikan tinjauan profil",
  "analyzerType.draft.update.loading": "Memuat draf pembaruan profil",
  "analyzerType.draft.update.subtitle": "Jenis Alat bersama tidak akan berubah hingga draf ini selesai dan diterbitkan. Alat yang sudah ada tetap terikat pada revisi mereka saat ini.",
  "analyzerType.draft.update.title": "Draf pembaruan profil telah dibuat",
  "analyzerType.empty.subtitle": "Sesuaikan kriteria pencarian atau filter untuk melihat jenis Alat lainnya.",
  "analyzerType.empty.title": "Tidak ada jenis alat yang cocok",
  "analyzerType.explainer.subtitle": "Alat yang identik dapat menggunakan satu jenis yang sama. Buat duplikasi suatu jenis jika suatu alat memerlukan perilaku yang berbeda; nonaktifkan jenis tersebut alih-alih menghapus riwayatnya.",
  "analyzerType.explainer.title": "Pengaturan alat analisis yang dapat digunakan kembali",
  "analyzerType.error.nameUnique": "Nama profil harus unik",
  "analyzerType.field.connectionTest": "Mendukung pemeriksaan koneksi",
  "analyzerType.field.dataFlow": "Aliran data",
  "analyzerType.field.fileFormat": "Format File",
  "analyzerType.field.filePattern": "Pola Nama File",
  "analyzerType.field.manufacturer": "Produsen",
  "analyzerType.field.model": "Model",
  "analyzerType.field.newProfileName": "Nama profil baru",
  "analyzerType.field.profileName": "Nama profil",
  "analyzerType.field.protocol": "Protokol",
  "analyzerType.field.resultColumn": "Kolom Hasil",
  "analyzerType.field.sampleColumn": "Kolom Nomor Identitas Sampel",
  "analyzerType.field.sourceProfile.placeholder": "Pilih jenis alat analisis",
  "analyzerType.field.sourceProfile": "Jenis Alat sumber",
  "analyzerType.field.testColumn": "Kolom kode pemeriksaan",
  "analyzerType.filter.all": "Semua",
  "analyzerType.filter.mapping": "Status pemetaan",
  "analyzerType.filter.protocol": "Protokol",
  "analyzerType.filter.showDeactivated": "Tampilkan sudah inaktif",
  "analyzerType.filter.source": "Dibuat",
  "analyzerType.history.action.created": "Dibuat",
  "analyzerType.history.action.deactivated": "Sudah inaktif",
  "analyzerType.history.action.duplicated": "Terduplikasi",
  "analyzerType.history.action.reactivated": "Diaktifkan ulang",
  "analyzerType.history.action.shipped": "Sudah dikirim",
  "analyzerType.history.action.updated": "Terbarui",
  "analyzerType.history.actor": "Diubah oleh",
  "analyzerType.history.change": "Perubahan",
  "analyzerType.history.loading": "Memuat riwayat profil",
  "analyzerType.history.revisionValue": "Revisi {revision}",
  "analyzerType.history.revision": "Revisi",
  "analyzerType.history.status": "Status",
  "analyzerType.history.time": "Diubah pada",
  "analyzerType.lineage": "Diambil dari {profileId} revisi {revision}",
  "analyzerType.loading": "Memuat jenis-jenis alat analisis",
  "analyzerType.mapping.complete": "Telah dipetakan sepenuhnya",
  "analyzerType.mapping.count": "{mapped} / {total} · {percent}%",
  "analyzerType.mapping.countWithExcluded": "{mapped} / {total} · {percent}% · {excluded} ditandai sebagai \"Jangan terima\"",
  "analyzerType.mapping.incomplete": "Perlu pemetaan",
  "analyzerType.mapping.notApplicable": "Tidak berlaku",
  "analyzerType.mapping.notStarted": "Belum dipetakan",
  "analyzerType.mappingEditor.applyToAnalyzer": "Terapkan pemetaan dan coba ulang hasil yang ditahan",
  "analyzerType.mappingEditor.appliedToAnalyzer": "Pemetaan saat ini telah diterapkan ke alat ini. Hasil ditahan yang memenuhi syarat telah dicoba ulang.",
  "analyzerType.mappingEditor.error.applyToAnalyzer": "Tidak dapat menerapkan pemetaan ke alat ini.",
  "analyzerType.mappingEditor.alias": "Alias: {alias}",
  "analyzerType.mappingEditor.confirm": "Konfirmasi pemetaan dan pengenalan kontrol",
  "analyzerType.mappingEditor.confirmation.by": "Dikonfirmasi oleh {actor} pada {date}",
  "analyzerType.mappingEditor.confirmation.current": "Konfirmasi saat ini",
  "analyzerType.mappingEditor.confirmation.stale": "Konfirmasi sudah kedaluwarsa",
  "analyzerType.mappingEditor.confirmation.summary.current": "Saat ini",
  "analyzerType.mappingEditor.confirmation.summary.stale": "Kedaluwarsa",
  "analyzerType.mappingEditor.confirmation.summary.unconfirmed": "Belum dikonfirmasi",
  "analyzerType.mappingEditor.confirmation.unconfirmed": "Belum dikonfirmasi",
  "analyzerType.mappingEditor.confirmation": "Konfirmasi",
  "analyzerType.mappingEditor.confirmed": "Pemetaan dan pengenalan kontrol telah dikonfirmasi",
  "analyzerType.mappingEditor.error.confirm": "Konfirmasi gagal",
  "analyzerType.mappingEditor.error.load": "Pemetaan Jenis Alat tidak dapat dimuat",
  "analyzerType.mappingEditor.error.route": "Diperlukan alat atau revisi Jenis Alat yang valid",
  "analyzerType.mappingEditor.error.save": "Pemetaan tidak dapat disimpan",
  "analyzerType.mappingEditor.excludeResult.short": "Jangan terima",
  "analyzerType.mappingEditor.excludeResult": "Jangan terima {value}",
  "analyzerType.mappingEditor.callComponentPicker": "Hasil call untuk {code} masuk ke",
  "analyzerType.mappingEditor.componentPicker": "Komponen OpenELIS untuk {code}",
  "analyzerType.mappingEditor.componentPicker.required": "Pilih komponen tempat catatan ini ditempatkan.",
  "analyzerType.mappingEditor.componentPicker.placeholder": "Pilih komponen",
  "analyzerType.mappingEditor.excludeTest": "Jangan terima {code}",
  "analyzerType.mappingEditor.translationOf": "Terjemahan dari {value}",
  "analyzerType.mappingEditor.partial": "{count} pemetaan belum terselesaikan. Anda dapat mengonfirmasi dan menghubungkan; hasil yang terdampak akan disimpan untuk dikoreksi sebelum digunakan.",
  "analyzerType.mappingEditor.incomplete": "Perbaiki pilihan pemeriksaan atau hasil yang tidak tersedia sebelum konfirmasi.",
  "analyzerType.mappingEditor.loading": "Memuat pemetaan jenis alat",
  "analyzerType.mappingEditor.normalized": "Identitas yang dinormalisasi",
  "analyzerType.mappingEditor.observed": "Teramati pada hasil yang ditahan",
  "analyzerType.mappingEditor.recognition.heading": "Pengenalan hasil kontrol",
  "analyzerType.mappingEditor.recognition.none": "Jenis Alat ini secara eksplisit menyatakan bahwa antarmuka tersebut tidak mentransmisikan hasil kontrol apa pun.",
  "analyzerType.mappingEditor.resultPicker.placeholder": "Pilih hasil OpenELIS",
  "analyzerType.mappingEditor.resultPicker": "Hasil OpenELIS untuk {value}",
  "analyzerType.mappingEditor.tests.none": "Jenis alat ini tidak mendeklarasikan pemeriksaan, sehingga tidak ada yang perlu dipetakan. Pembuatnya dapat menambahkan pemeriksaan ke revisi baru dari jenis ini.",
  "analyzerType.mappingEditor.results.empty": "Pemeriksaan ini tidak memiliki opsi hasil yang aktif",
  "analyzerType.mappingEditor.results.heading": "Hasil - {name}",
  "analyzerType.mappingEditor.results.loading": "Memuat opsi hasil",
  "analyzerType.mappingEditor.results.openCatalog": "Tambahkan opsi hasil di Katalog Pemeriksaan",
  "analyzerType.mappingEditor.results.testFirst": "Pilih Pemeriksaan OpenELIS sebelum memetakan hasilnya",
  "analyzerType.mappingEditor.reason.result.ambiguous": "Tidak dipetakan: beberapa jawaban untuk pemeriksaan ini memiliki kode nilai ini. Pilih salah satu.",
  "analyzerType.mappingEditor.reason.result.incompatible": "Tidak dipetakan: tidak ada jawaban untuk pemeriksaan ini yang dapat menampung nilai ini.",
  "analyzerType.mappingEditor.reason.result.no_match": "Tidak dipetakan: tidak ada jawaban untuk pemeriksaan ini yang memiliki kode nilai ini.",
  "analyzerType.mappingEditor.reason.test.ambiguous": "Tidak dipetakan: beberapa pemeriksaan dalam katalog lab ini memiliki kodenya. Pilih salah satu.",
  "analyzerType.mappingEditor.reason.test.incompatible": "Tidak dipetakan: sebuah pemeriksaan dalam katalog lab ini memiliki kodenya tetapi tidak dapat menampung hasil ini.",
  "analyzerType.mappingEditor.reason.test.no_match": "Tidak dipetakan: tidak ada pemeriksaan dalam katalog lab ini yang memiliki kodenya.",
  "analyzerType.mappingEditor.results": "Hasil yang telah dipetakan",
  "analyzerType.mappingEditor.return": "Kembali",
  "analyzerType.mappingEditor.save": "Simpan pemetaan",
  "analyzerType.mappingEditor.saved": "Pemetaan telah disimpan",
  "analyzerType.mappingEditor.own.title": "Pemetaan khusus alat ini",
  "analyzerType.mappingEditor.own.subtitle": "Perubahan di sini hanya berlaku untuk alat ini. Perubahan berlaku saat Anda mengonfirmasi pemetaan dan menerapkannya.",
  "analyzerType.mappingEditor.defaults.title": "Default untuk alat baru",
  "analyzerType.mappingEditor.defaults.subtitle": "Ini adalah pengaturan awal untuk alat baru dengan jenis ini, dicocokkan berdasarkan kode standar terhadap katalog saat ini. Tidak ada yang disimpan di sini; setiap alat menyimpan pemetaannya sendiri.",
  "analyzerType.mappingEditor.origin.override": "Diedit",
  "analyzerType.mappingEditor.changes.heading": "Tinjau perubahan sebelum menyimpan",
  "analyzerType.mappingEditor.changes.save": "Simpan Perubahan",
  "analyzerType.mappingEditor.changes.none": "Tidak ada yang berubah sejak penyimpanan terakhir.",
  "analyzerType.mappingEditor.changes.row": "{from} ke {to}",
  "analyzerType.mappingEditor.sourceCode": "Kode alat",
  "analyzerType.mappingEditor.state.bound": "Dipetakan",
  "analyzerType.mappingEditor.state.excluded": "Jangan terima",
  "analyzerType.mappingEditor.state.unresolved": "Perlu pemetaan",
  "analyzerType.mappingEditor.subtitle": "{protocol} · revisi {revision}",
  "analyzerType.mappingEditor.suggestion": "Saran kecocokan: {name}",
  "analyzerType.mappingEditor.summary": "Ringkasan pemetaan",
  "analyzerType.mappingEditor.testPicker.placeholder": "Cari berdasarkan nama, kode, atau LOINC",
  "analyzerType.mappingEditor.testPicker": "Pemeriksaan OpenELIS untuk {code}",
  "analyzerType.mappingEditor.tests.heading": "Pemetaan pemeriksaan dan hasil",
  "analyzerType.mappingEditor.tests.help": "Tinjau setiap kode alat secara terpisah. Hubungkan kode tersebut ke Pemeriksaan OpenELIS yang aktif atau kecualikan secara eksplisit.",
  "analyzerType.mappingEditor.tests": "Pemeriksaan yang telah dipetakan",
  "analyzerType.mappingEditor.title": "Pemetaan {name}",
  "analyzerType.mappingEditor.unsaved": "Perubahan pemetaan yang tidak tersimpan",
  "analyzerType.mappingEditor.useSuggestion": "Gunakan pemeriksaan yang disarankan",
  "analyzerType.modal.deactivate.subtitle": "Alat analisis yang ada dan riwayat revisi tetap terhubung. Profil ini tidak akan lagi tersedia untuk pengaturan alat analisis baru.",
  "analyzerType.modal.deactivate.title": "Nonaktifkan {name}",
  "analyzerType.modal.history.title": "Riwayat {name}",
  "analyzerType.modal.reactivate.subtitle": "Profil ini akan tersedia kembali untuk pengaturan alat analisis baru. Alat analisis yang sudah ada tetap terikat pada revisi yang telah dipilih.",
  "analyzerType.modal.reactivate.title": "Aktifkan Ulang {name}",
  "analyzerType.modal.update.subtitle": "Tindakan ini memulai revisi baru yang tidak dapat diubah dari revisi {revision}. {count, plural, one {# alat tetap terkunci pada revisinya saat ini.} other {# alat tetap terkunci pada revisinya saat ini.}}",
  "analyzerType.modal.update.title": "Perbarui {name}",
  "analyzerType.notification.action.error.subtitle": "Coba lakukan aksi profil itu lagi.",
  "analyzerType.notification.action.error": "Aksi profil gagal",
  "analyzerType.notification.create.success": "Profil telah dibuat",
  "analyzerType.notification.deactivate.success": "Profil sudah inaktif",
  "analyzerType.notification.duplicate.success": "Profil telah diduplikasi",
  "analyzerType.notification.update.success": "Profil telah diperbarui",
  "analyzerType.notification.loadError.subtitle": "Periksa koneksi Analyzer Bridge, lalu coba lagi.",
  "analyzerType.notification.catalogIssues": "Beberapa profil alat tidak dapat dimuat",
  "analyzerType.notification.catalogIssues.subtitle": "Analyzer Bridge menyisihkan file-file ini dan tetap melayani semua profil lainnya. Perbaiki atau hapus setiap file, lalu mulai ulang Bridge.",
  "analyzerType.notification.loadError": "Jenis Alat tidak dapat dimuat",
  "analyzerType.notification.reactivate.success": "Profil telah diaktifkan ulang",
  "analyzerType.page.subtitle": "Pengaturan yang dapat digunakan kembali di balik Alat analisis Anda.",
  "analyzerType.page.title": "Jenis Alat",
  "analyzerType.protocol.file": "Berkas datar",
  "analyzerType.recognition.none.affirmation": "Saya mengonfirmasi bahwa antarmuka ini tidak mengirimkan hasil kontrol",
  "analyzerType.recognition.none.subtitle": "Publikasikan profil ini hanya jika antarmuka alat tidak mengirimkan hasil kontrol. Profil yang mengirimkan kontrol memerlukan aturan pengenalan yang eksplisit.",
  "analyzerType.recognition.none.title": "Tidak ada pengenalan hasil kontrol secara otomatis",
  "analyzerType.recognition.condition.add": "Tambah Kondisi",
  "analyzerType.recognition.condition.fieldValue": "Nilai {source}",
  "analyzerType.recognition.condition.new": "Kondisi pengenalan baru",
  "analyzerType.recognition.condition.prefixValue": "Prefiks Identitas Spesimen",
  "analyzerType.recognition.condition.remove": "Hapus Kondisi",
  "analyzerType.recognition.condition.select.placeholder": "Pilih suatu kondisi",
  "analyzerType.recognition.condition.select": "Kondisi baru",
  "analyzerType.recognition.condition.sourceContains": "{source} berisi",
  "analyzerType.recognition.condition.sourceEquals": "{source} sama dengan",
  "analyzerType.recognition.condition.specimenPrefix": "Identitas spesimen dimulai dengan",
  "analyzerType.recognition.condition.summary.configuredPattern": "Identitas spesimen sesuai dengan pola yang telah dikonfigurasi",
  "analyzerType.recognition.condition.summary.contains": "{source} berisi {value}",
  "analyzerType.recognition.condition.summary.equals": "{source} sama dengan {value}",
  "analyzerType.recognition.condition.summary.startsWith": "{source} dimulai dengan {value}",
  "analyzerType.recognition.condition.summary.unknown": "Pengenalan hasil kontrol",
  "analyzerType.recognition.error.load": "Pengenalan kontrol tidak dapat dimuat.",
  "analyzerType.recognition.error.save": "Pengenalan kontrol tidak dapat disimpan.",
  "analyzerType.recognition.error.title": "Pengenalan kontrol perlu mendapat perhatian",
  "analyzerType.recognition.heading": "Pengenalan hasil kontrol",
  "analyzerType.recognition.loading": "Memuat pengenalan kontrol",
  "analyzerType.recognition.mode.none": "Antarmuka ini tidak mengirimkan hasil kontrol",
  "analyzerType.recognition.mode.none.short": "Tidak ada pengenalan hasil kontrol",
  "analyzerType.recognition.mode.rules": "Kenali elemen kontrol dengan menggunakan kondisi-kondisi berikut ini",
  "analyzerType.recognition.mode.rules.short": "Pengenalan kontrol berbasis aturan",
  "analyzerType.recognition.mode.unconfigured.short": "Pengenalan kontrol belum dikonfigurasi",
  "analyzerType.recognition.mode.unconfigured": "Tidak ada aturan pengenalan kontrol yang dikonfigurasi. Hasil kontrol mungkin tidak teridentifikasi secara otomatis.",
  "analyzerType.recognition.mode": "Bagaimana antarmuka ini mengidentifikasi hasil kontrol?",
  "analyzerType.recognition.rules.help": "Sebuah hasil dianggap sebagai kontrol jika salah satu kondisi terpenuhi.",
  "analyzerType.recognition.save": "Simpan pengenalan kontrol",
  "analyzerType.recognition.saved": "Pengenalan kontrol telah disimpan",
  "analyzerType.recognition.source.specimenId": "Identitas Spesimen",
  "analyzerType.revision": "revisi {revision}",
  "analyzerType.search.label": "Cari jenis alat",
  "analyzerType.search.placeholder": "Cari jenis alat...",
  "analyzerType.source.shipped": "Sudah dikirim",
  "analyzerType.source.site": "Dibuat di tempat ini",
  "analyzerType.status.active": "Aktif",
  "analyzerType.status.inactive": "Sudah inaktif",
  "analyzerType.summary.ariaLabel": "Ringkasan jenis alat analisis",
  "analyzerType.summary.deactivated": "Sudah inaktif",
  "analyzerType.summary.inUse": "Sedang Digunakan",
  "analyzerType.summary.needsAttention": "Perlu Perhatian",
  "analyzerType.summary.total": "Jenis Alat",
  "analyzerType.usedBy": "{count, plural, =0 {Tidak digunakan} one {# alat} other {# alat}}",
  "analyzer.navigation.qcControlLots": "Lot Kontrol",
  "analyzer.navigation.qcRuleConfig": "Konfigurasi Aturan",
  "analyzer.page.addButton": "Tambah Alat",
  "analyzer.page.hierarchy.list": "Daftar Alat",
  "analyzer.page.hierarchy.mappings": "Pemetaan Bidang",
  "analyzer.page.hierarchy.root": "Alat",
  "analyzer.page.title": "Alat",
  "analyzer.plugin.missing": "Plugin Tidak Ditemukan",
  "analyzer.qc.alerts.message": "Fitur peringatan dan pelanggaran akan segera tersedia.",
  "analyzer.qc.alerts.title": "Peringatan dan Pelanggaran Kendali Mutu",
  "analyzer.qc.corrective.message": "Fitur tindakan perbaikan akan segera tersedia.",
  "analyzer.qc.corrective.title": "Tindakan Perbaikan",
  "analyzer.qc.placeholder.message": "Fitur Kendali Mutu akan segera tersedia.",
  "analyzer.qc.placeholder.title": "Kendali Mutu",
  "analyzer.action.viewResults": "Lihat hasilnya",
  "analyzer.results.held.assayNotEnabled": "Uji ini dinonaktifkan di pengaturan alat, sehingga hasilnya ditahan. Aktifkan di langkah Uji pada pengaturan jika instrumen ini menjalankannya; hasil akan dicoba ulang saat pemetaan diterapkan.",
  "analyzer.results.held.code": "Kode alat: {code}",
  "analyzer.results.held.enableAssay": "Aktifkan uji",
  "analyzer.results.held.instrumentNote": "Catatan instrumen: {note}",
  "analyzer.results.held.otherRevision": "Dikirim dengan revisi {revision} dari profil alat ini, yang membaca pemeriksaan ini secara berbeda dari revisi yang berlaku sekarang. Jalankan ulang sampel.",
  "analyzer.results.instrumentReported": "Dilaporkan instrumen",
  "analyzer.results.instrumentReported.assay": "Uji: {assay}",
  "analyzer.results.instrumentReported.assayVersion": "Uji: {assay}, versi {version}",
  "analyzer.results.instrumentReported.flag": "Penanda: {flag}",
  "analyzer.results.instrumentReported.operator": "Operator: {operator}",
  "analyzer.results.failedRun.dismiss": "Abaikan sebagai run gagal",
  "analyzer.results.failedRun.dismissed": "Run gagal dicatat pada pemesanan dan pemeriksaannya tetap terbuka untuk pengulangan.",
  "analyzer.results.failedRun.error": "Run gagal tidak dapat diabaikan",
  "analyzer.results.held.qcTargetMissing": "Kontrol ini melaporkan jawaban, tetapi pemeriksaan dan level kontrolnya tidak memiliki target QC untuk menilainya. Tetapkan jawaban yang diharapkan, lalu terapkan pemetaan alat untuk mencobanya ulang.",
  "analyzer.results.held.setQcTarget": "Tetapkan target QC",
  "analyzer.results.held.reviewMapping": "Tinjau pemetaan alat",
  "analyzer.results.sampleFlags": "Penanda alat: {flags}",
  "analyzer.results.held.subtitle": "Hasil yang ditahan tidak dapat diterima. Setiap hasil menjelaskan langkah yang harus dilakukan: tinjau pemetaan alat ini, atau abaikan proses yang gagal agar pemeriksaannya tetap terbuka untuk diulang.",
  "analyzer.results.held.tag": "Ditahan",
  "analyzer.results.held.title": "{count, plural, other {# hasil alat memerlukan perhatian}}",
  "analyzer.qualitativeMapping.isDefault": "Standar",
  "analyzer.qualitativeMapping.mappings": "Pemetaan Nilai",
  "analyzer.qualitativeMapping.noValues": "Tidak ada nilai alat tersedia untuk pemetaan",
  "analyzer.qualitativeMapping.openelisCode.placeholder": "Pilih kode SILNAS",
  "analyzer.qualitativeMapping.subtitle": "Pemetaan nilai kualitatif untuk {fieldName}",
  "analyzer.qualitativeMapping.title": "Pemetaan Nilai Kualitatif",
  "analyzer.qualitativeMapping.validation.error": "Kesalahan Validasi",
  "analyzer.qualitativeMapping.validation.error.subtitle": "Perbaiki error di bawah ini",
  "analyzer.qualitativeMapping.validation.noDefault": "Tidak ada nilai default",
  "analyzer.qualitativeMapping.validation.noDefault.subtitle": "Setidaknya satu pemetaan harus ditandai sebagai default",
  "analyzer.qualitativeMapping.validation.openelisCode.required": "Wajib mengisi kode SILNAS",
  "analyzer.query.button": "Kueri Alat",
  "analyzer.query.cancel": "Batal",
  "analyzer.query.modal.logs": "Log Koneksi",
  "analyzer.query.modal.noLogs": "Belum ada log",
  "analyzer.query.modal.progress": "Kemajuan",
  "analyzer.query.modal.state": "Status",
  "analyzer.query.modal.subtitle": "Ambil bidang yang tersedia dari alat",
  "analyzer.query.modal.title": "Kueri Alat",
  "analyzer.query.progress": "{percent}% selesai",
  "analyzer.search.label": "Cari",
  "analyzer.search.placeholder": "Cari Alat...",
  "analyzer.attention.review": "Tinjau hasil yang ditahan",
  "analyzer.attention.subtitle": "Petakan pemeriksaan atau nilai hasil yang tidak dikenal sebelum menggunakan hasil tersebut secara klinis.",
  "analyzer.attention.tag": "Perlu diperhatikan",
  "analyzer.attention.title.many": "{count} alat memiliki hasil yang ditahan",
  "analyzer.attention.title.one": "{name} memiliki hasil yang ditahan",
  "analyzer.stat.active": "Aktif",
  "analyzer.stat.inactive": "Inaktif",
  "analyzer.stat.needsAttention": "Perlu diperhatikan",
  "analyzer.stat.setup": "Di Pengaturan",
  "analyzer.stat.total": "Total Alat",
  "analyzer.stats.active": "Alat Aktif",
  "analyzer.stats.inactive": "Alat Inaktif",
  "analyzer.stats.total": "Total Alat",
  "analyzer.status.active": "Aktif",
  "analyzer.status.deleted": "Hapus",
  "analyzer.status.error_pending": "Error Tertunda",
  "analyzer.status.inactive": "Inaktif",
  "analyzer.status.offline": "Offline",
  "analyzer.status.setup": "Pengaturan",
  "analyzer.status.validation": "Validasi",
  "analyzer.success.save": "Alat berhasil disimpan",
  "analyzer.table.actions": "Aksi",
  "analyzer.table.connection": "Koneksi",
  "analyzer.table.header.connection": "Koneksi",
  "analyzer.table.header.lastModified": "Dimodifikasi Terakhir",
  "analyzer.table.header.name": "Nama",
  "analyzer.table.header.status": "Status",
  "analyzer.table.header.testUnits": "Instalasi Lab",
  "analyzer.table.header.type": "Jenis",
  "analyzer.table.lastModified": "Dimodifikasi Terakhir",
  "analyzer.table.name": "Nama",
  "analyzer.table.status": "Status",
  "analyzer.table.testUnits": "Instalasi Lab",
  "analyzer.table.type": "Jenis",
  "analyzer.table.type.loading": "Memuat jenis alat penganalisis",
  "analyzer.table.type.unavailable": "Jenis Alat tidak tersedia",
  "analyzer.testUnits.count": "{count, plural, other {# satuan}}",
  "analyzer.testConnection.bridge.healthCheckFailed": "Tidak dapat mencapai bridge health endpoint di {url}: {detail}",
  "analyzer.testConnection.bridge.httpStatus": "Bridge mengembalikan HTTP {status}",
  "analyzer.testConnection.bridge.notConfigured": "Bridge tidak dikonfigurasi",
  "analyzer.testConnection.bridge.unparseableResponse": "Bridge respon unparsable (tidak dapat di parse)",
  "analyzer.testConnection.bridge.unreachable": "Tidak dapat mencapai bridge: {detail}",
  "analyzer.testConnection.close": "Tutup",
  "analyzer.testConnection.logs": "Log Koneksi",
  "analyzer.testConnection.requestBuildFailed": "Gagal membuat request: {detail}",
  "analyzer.testConnection.success": "Koneksi Berhasil",
  "analyzer.testConnection.tcp.bridgeNotConfigured": "Bridge tidak dikonfigurasi, koneksi dengan alat tidak dapat diuji coba",
  "analyzer.testConnection.testAgain": "Uji Kembali",
  "analyzer.testConnection.testing": "Menguji koneksi...",
  "analyzer.testConnection.title": "Uji Koneksi",
  "analyzer.testMapping.activeMappings": "{count} pemetaan aktif",
  "analyzer.testMapping.analyzerInfo": "Informasi Alat",
  "analyzer.testMapping.analyzerName": "Nama Alat",
  "analyzer.testMapping.analyzerType": "Jenis Alat",
  "analyzer.testMapping.appliedMappings": "Pemetaan yang Diterapkan",
  "analyzer.testMapping.entityPreview": "Pratinjau Entitas SILNAS",
  "analyzer.testMapping.errors": "Error",
  "analyzer.testMapping.loading": "Memproses pratinjau...",
  "analyzer.testMapping.messageInput": "Sampel Pesan ASTM",
  "analyzer.testMapping.messageInput.counter": "{current} / {max} karakter",
  "analyzer.testMapping.messageInput.helper": "Masukkan pesan sampel ASTM untuk pratinjau bagaimana interpretasinya",
  "analyzer.testMapping.messageInput.placeholder": "H|\\^&|||PSM^Micro^2.0|...",
  "analyzer.testMapping.messageInput.required": "Sampel Pesan ASTM *",
  "analyzer.testMapping.noResults": "Belum ada hasil pratinjau. Masukkan sampel pesan ASTM dan klik Pratinjau Pemetaan.",
  "analyzer.testMapping.parsedFields": "Bidang yang diurai",
  "analyzer.testMapping.parsedFields.astmRef": "Referensi ASTM",
  "analyzer.testMapping.parsedFields.fieldName": "Nama Bidang",
  "analyzer.testMapping.parsedFields.interpretation": "Interpretasi",
  "analyzer.testMapping.parsedFields.mappedTo": "Dipetakan ke",
  "analyzer.testMapping.parsedFields.rawValue": "Nilai Mentah",
  "analyzer.testMapping.pluginConfigSnapshot": "Snapshot Konfigurasi Plugin",
  "analyzer.testMapping.previewOptions": "Opsi Pratinjau",
  "analyzer.testMapping.previewOptions.detailedParsing": "Tunjukkan rincian tahapan penguraian",
  "analyzer.testMapping.previewOptions.validateAll": "Validasi semua pemetaan",
  "analyzer.testMapping.results": "Pratinjau Hasil",
  "analyzer.testMapping.saveTestCase": "Simpan sebagai Kasus Pengujian",
  "analyzer.testMapping.submit": "Pratinjau Pemetaan",
  "analyzer.testMapping.subtitle": "Pratinjau bagaimana sampel pesan ASTM akan diinterpretasi",
  "analyzer.testMapping.testAnother": "Uji Pesan Lainnya",
  "analyzer.testMapping.title": "Pemetaan Bidang Pemeriksaan",
  "analyzer.testMapping.validation.invalidFormat": "Format pesan ASTM invalid",
  "analyzer.testMapping.validation.messageRequired": "Pesan ASTM wajib ada",
  "analyzer.testMapping.validation.messageTooLarge": "Pesan ASTM melebihi maksimum 10KB",
  "analyzer.testMapping.warnings": "Peringatan",
  "analyzer.unitMapping.analyzerUnit": "Satuan Sumber (Alat)",
  "analyzer.unitMapping.analyzerUnit.helper": "Satuan yang dilaporkan oleh alat",
  "analyzer.unitMapping.conversionFactor": "Faktor Konversi",
  "analyzer.unitMapping.conversionFactor.helper": "Faktor untuk mengkonversi dari {from} ke {to} (misalnya, 0.0555 mg/dL ke mmol/L)",
  "analyzer.unitMapping.openelisUnit": "Satuan Target (SILNAS)",
  "analyzer.unitMapping.openelisUnit.helper": "Satuan resmi digunakan di SILNAS",
  "analyzer.unitMapping.openelisUnit.placeholder": "Pilih satuan target",
  "analyzer.unitMapping.rejectIfMismatch": "Tolak bila Satuan Tidak Cocok",
  "analyzer.unitMapping.rejectIfMismatch.helper": "Tolak pesan bila satuan tidak cocok dan tidak ada faktor konversi yang tersedia",
  "analyzer.unitMapping.subtitle": "Konfigurasi pemetaan satuan untuk {fieldName}",
  "analyzer.unitMapping.title": "Pemetaan Satuan",
  "analyzer.unitMapping.validation.analyzerUnit.required": "Satuan sumber wajib ada",
  "analyzer.unitMapping.validation.conversionFactor.invalid": "Faktor konversi harus angka positif",
  "analyzer.unitMapping.validation.conversionFactor.required": "Faktor konversi wajib ada jika satuan berbeda",
  "analyzer.unitMapping.validation.error": "Kesalahan Validasi",
  "analyzer.unitMapping.validation.error.subtitle": "Mohon perbaiki error di bawah",
  "analyzer.unitMapping.validation.openelisUnit.required": "Satuan target wajib ada",
  "analyzerTestName.header.analyzerName": "Alat - Nama Alat Uji",
  "analyzerTestName.modal.add.heading": "Tambah Nama Alat Uji",
  "analyzerTestName.modal.update.heading": "Perbarui Nama Alat Uji",
  "assigned.cytopathologist.label": "Ahli Sitopatologi ditugaskan",
  "assigned.pathologist.label": "Ahli Patologi ditugaskan",
  "assigned.technician.label": "Teknisi ditugaskan",
  "audittrail.table.heading.action": "Tindakan",
  "audittrail.table.heading.identifier": "Pengidentifikasi",
  "audittrail.table.heading.item": "Barang",
  "audittrail.table.heading.newvalue": "Nilai Baru",
  "audittrail.table.heading.oldvalue": "Nilai Lama",
  "audittrail.table.heading.time": "Waktu",
  "audittrail.table.heading.user": "Pengguna",
  "audittrail.table.title.patientResults": "Hasil Pasien",
  "availabletests.title": "Pemeriksaan Tersedia",
  "availabletests.none": "Every orderable test of the existing samples is already on this order.",
  "back.action.button": "Kembali",
  "banner.menu.administration": "Admin",
  "banner.menu.alerts": "Peringatan",
  "banner.menu.alerts.tooltip": "Dasbor peringatan dan penjaminan mutu",
  "banner.menu.aliquot": "Alikuot",
  "banner.menu.aliquot.tooltip": "Alikuot sampel",
  "banner.menu.billing": "Pembayaran",
  "banner.menu.billing.tooltip": "Pembayaran",
  "banner.menu.createDouble": "Entri Ganda",
  "banner.menu.createInitial": "Entri Awal",
  "banner.menu.eorders": "Pemesanan yang masuk",
  "banner.menu.eqa": "PME",
  "banner.menu.eqa.distribution": "Distribusi PME",
  "banner.menu.eqa.distribution.tooltip": "Buat dan kelola distribusi PME",
  "banner.menu.eqa.management": "Program PME",
  "banner.menu.eqa.management.tooltip": "Buat dan kelola program PME",
  "banner.menu.eqa.mgmt": "Pengelolaan PME",
  "banner.menu.eqa.mgmt.distributions": "Distribusi",
  "banner.menu.eqa.mgmt.distributions.tooltip": "Buat dan kelola distribusi PME",
  "banner.menu.eqa.mgmt.participants": "Peserta",
  "banner.menu.eqa.mgmt.participants.tooltip": "Kelola pendaftaran organisasi di program PME",
  "banner.menu.eqa.mgmt.programs": "Program",
  "banner.menu.eqa.mgmt.programs.tooltip": "Buat dan kelola program PME",
  "banner.menu.eqa.mgmt.results": "Hasil & Analisis",
  "banner.menu.eqa.mgmt.results.tooltip": "Pengumpulan hasil PME dan analisis statistik",
  "banner.menu.eqa.mgmt.tooltip": "Kelola program, peserta, dan distribusi PME",
  "banner.menu.eqa.tests": "Pemeriksaan PME",
  "banner.menu.eqa.tests.myPrograms": "Program Saya",
  "banner.menu.eqa.tests.myPrograms.tooltip": "Kelola pendaftaran pribadi untuk program PME eksternal",
  "banner.menu.eqa.tests.orders": "Pemesanan",
  "banner.menu.eqa.tests.orders.tooltip": "Lihat dan kelola pemesanan pemeriksaan PME",
  "banner.menu.eqa.tests.tooltip": "Pemesanan pemeriksaan PME dan pendaftaran program",
  "banner.menu.eqa.tooltip": "Pemantapan Mutu Eksternal",
  "banner.menu.generic.sample": "Sampel Generik",
  "banner.menu.generic.sample.edit": "Edit Sampel",
  "banner.menu.generic.sample.import": "Impor Sampel",
  "banner.menu.generic.sample.order": "Penerimaan Sampel",
  "banner.menu.generic.sample.results": "Masukkan Hasil",
  "banner.menu.help": "Bantuan",
  "banner.menu.help.about": "Tutorial Video",
  "banner.menu.help.contact": "Catatan rilis",
  "banner.menu.help.documents": "Dokumentasi Proses",
  "banner.menu.help.formDBS": "Formulir Dried Blood Spot",
  "banner.menu.help.formVL": "Formulir Viral Load",
  "banner.menu.help.usermanual": "Panduan Pengguna",
  "banner.menu.home": "Beranda",
  "banner.menu.inventory": "Inventaris",
  "banner.menu.inventory.catalog": "Kelola Katalog",
  "banner.menu.inventory.dashboard": "Dasbor",
  "banner.menu.inventory.list": "Barang Inventaris",
  "banner.menu.inventory.reports": "Laporan",
  "banner.menu.nonconformity": "Ketidaksesuaian",
  "banner.menu.nonconformity.correctiveActions": "Tindakan perbaikan",
  "banner.menu.nonconformity.dashboard": "Semua Kejadian Ketidaksesuaian",
  "banner.menu.nonconformity.report": "Laporan Kejadian Ketidaksesuaian",
  "banner.menu.nonconformity.view": "Lihat Kejadian Ketidaksesuaian Baru",
  "banner.menu.patient": "Pasien",
  "banner.menu.patient.Create": "Kajian",
  "banner.menu.patient.addOrEdit": "Tambah/Edit Pasien",
  "banner.menu.patient.merge": "Gabung Pasien",
  "banner.menu.patient.merge.tooltip": "Gabung duplikasi rekaman pasien",
  "banner.menu.patientConsult": "Lihat",
  "banner.menu.patientEdit": "Edit",
  "banner.menu.patienthistory": "Riwayat Pasien",
  "banner.menu.printBarcode": "Kode QR",
  "banner.menu.referredOut": "Dirujuk keluar",
  "banner.menu.report.validation.backlog": "Validasi Tertunda",
  "banner.menu.reports": "Laporan",
  "banner.menu.reports.routine": "Rutin",
  "banner.menu.reports.study": "Kajian",
  "banner.menu.results": "Hasil",
  "banner.menu.results.CobasIntegra400": "Biokimia: Cobas Integra 400+",
  "banner.menu.results.FacsCalibur": "Imunologi: FacsCalibur",
  "banner.menu.results.FacsCantoII": "Imunologi: FacsCantoII",
  "banner.menu.results.FacsPrestoanalyzer": "Imunologi: FacsPresto",
  "banner.menu.results.Fullyanalyzer": "Biokimia: Pengimpor seluruh alat",
  "banner.menu.results.GeneXpertAnalyzer": "GeneXpertAnalyzer",
  "banner.menu.results.GeneXpertanalyzer": "GeneXpertFileAnalyzer",
  "banner.menu.results.PocH100iAnalyzer": "PocH100iAnalisis",
  "banner.menu.results.SysmeXT": "Hematologi: SysmeXT 2000i",
  "banner.menu.results.SysmexXNLAnalyzer": "SysmexXNLAnalyzer",
  "banner.menu.results.SysmexXNLanalyzer": "Alat Analisis SysmexXNL",
  "banner.menu.results.SysmexXPAnalyzer": "Alat Analisis SysmexXP",
  "banner.menu.results.SysmexXPanalyzer": "Alat Analisis SysmexXP",
  "banner.menu.results.accession": "Berdasarkan Pemesanan",
  "banner.menu.results.analyzer": "Alat",
  "banner.menu.results.cobasc111analyzer": "Biokimia: Cobas C111",
  "banner.menu.results.genexpertanalyzer": "GeneXpert",
  "banner.menu.results.logbook": "Berdasarkan Unit",
  "banner.menu.results.mindrayanalyzer": "Mindray",
  "banner.menu.results.order.programmes": "Pemesanan Program",
  "banner.menu.results.patient": "Berdasarkan Pasien",
  "banner.menu.results.quantstudio3analyzer": "QuantStudio 3",
  "banner.menu.results.status": "Berdasarkan Pemeriksaan, Tanggal atau Status",
  "banner.menu.results.sysmexanalyzer": "Hematologi: Sysmex XT 2000 i",
  "banner.menu.results.sysmexxtanalyzer": "Hematologi: Pengimport Sysmex XT analyzer",
  "banner.menu.results.taqman48dbsanalyzer": "Virologi: Cobas TaqMan48 DNA PCR",
  "banner.menu.results.testdate": "Berdasarkan Tanggal Pemeriksaan",
  "banner.menu.results.unified": "Entri Hasil",
  "banner.menu.results.unified.tooltip": "Daftar pekerjaan entri hasil terpadu",
  "banner.menu.results.weber": "Weber 4000",
  "banner.menu.resultvalidation": "Validasi",
  "banner.menu.resultvalidation.bacteria": "Bakteri",
  "banner.menu.resultvalidation.bench": "Berdasarkan Meja Kerja",
  "banner.menu.resultvalidation.biochemistry": "Biokimia",
  "banner.menu.resultvalidation.cytobacteriology": "Sitobakteriologi",
  "banner.menu.resultvalidation.dnapcr": "PCR DNA",
  "banner.menu.resultvalidation.ecbu": "ECBU",
  "banner.menu.resultvalidation.endocrinologie": "Endokrinologi",
  "banner.menu.resultvalidation.genotyping": "Genotiping",
  "banner.menu.resultvalidation.hemato-immunology": "Hemato-imunologi",
  "banner.menu.resultvalidation.hematology": "Hematologi",
  "banner.menu.resultvalidation.immunology": "Imunologi",
  "banner.menu.resultvalidation.immunology.Haiti": "Imuno-virologi",
  "banner.menu.resultvalidation.immunologyHematology": "Imuno - hematologi",
  "banner.menu.resultvalidation.liquidBio": "Cairan biologis",
  "banner.menu.resultvalidation.malaria": "Malaria",
  "banner.menu.resultvalidation.molecularBio": "Biologi Molekuler",
  "banner.menu.resultvalidation.mycobacteriology": "Mikobakteriologi",
  "banner.menu.resultvalidation.mycology": "Mikologi",
  "banner.menu.resultvalidation.parasitology": "Parasitologi",
  "banner.menu.resultvalidation.serology": "Serologi",
  "banner.menu.resultvalidation.serology-immunology": "Serologi-Imunologi",
  "banner.menu.resultvalidation.viralload": "Viral Load",
  "banner.menu.resultvalidation.virology": "Virologi",
  "banner.menu.resultvalidation_routine": "Rutin",
  "banner.menu.resultvalidation_study": "Kajian",
  "banner.menu.sample": "Pemesanan",
  "banner.menu.sample.shipment": "Pengiriman Sampel",
  "banner.menu.sampleAdd": "Tambah Pemesanan",
  "banner.menu.sampleBatchEntry": "Masukkan Pemesanan Batch",
  "banner.menu.sampleConsult": "Lihat",
  "banner.menu.sampleCreate": "Kajian",
  "banner.menu.sampleEdit": "Edit Pemesanan",
  "banner.menu.sampleManagement": "Pengelolaan Sampel",
  "banner.menu.sampleManagement.tooltip": "Menu Pengelolaan Sampel",
  "banner.menu.storage": "Penyimpanan",
  "banner.menu.storage.tooltip": "Pengelolaan Penyimpanan Sampel",
  "banner.menu.study.eorders": "Pemesanan Elektronik",
  "banner.menu.workplan": "Rencana Kerja",
  "banner.menu.workplan.batch": "Rencana Kerja Batch",
  "banner.menu.workplan.batch.tooltip": "Rencana Kerja Batch",
  "banner.menu.workplan.bench": "Berdasarkan Unit",
  "banner.menu.workplan.panel": "Berdasarkan Panel",
  "banner.menu.workplan.priority": "Berdasarkan Prioritas",
  "banner.menu.workplan.test": "Berdasarkan Jenis Pemeriksaan",
  "banner.menu.workplan.unit": "Berdasarkan Bagian Pemeriksaan",
  "barcode.additionalInvalidLevels.message": "Kode QR memiliki tingkatan di luar bagian yang valid. Hanya tingkatan valid yang diisi.",
  "barcode.additionalInvalidLevels.warning": "Tingkatan tidak valid lainnya terdeteksi",
  "barcode.autoOpenForm": "Membuka formulir lokasi dengan hirarki yang valid",
  "barcode.debounce.warning": "Silahkan tunggu sebelum memindai kode QR lain",
  "barcode.error": "Kode QR tidak valid",
  "barcode.firstMissingLevel": "Tingkatan pertama yang hilang: {level}",
  "barcode.format": "Format Kode QR",
  "barcode.header": "kode QR",
  "barcode.invalidFormat": "Format kode QR tidak valid. Aturan: RUANGAN-PERANGKAT atau RUANGAN-PERANGKAT-RAK-LACI-POSISI",
  "barcode.label.block": "Label blok",
  "barcode.label.freezer": "Label freezer",
  "barcode.label.helper.text": "Masukkan nilai dalam: mm",
  "barcode.label.order": "Label Pemesanan",
  "barcode.label.slide": "Label slide",
  "barcode.label.specimen": "Label spesimen",
  "barcode.label.info.blockCaseNumber": "Nomor Kasus Blok",
  "barcode.label.info.blockId": "ID Blok",
  "barcode.label.info.blockNumber": "Nomor Blok",
  "barcode.label.info.boxid": "ID Boks",
  "barcode.label.info.caseNumber": "Nomor Kasus",
  "barcode.label.info.collectedBy": "Dikumpulkan oleh",
  "barcode.label.info.collectionDate": "Tanggal Pengambilan",
  "barcode.label.info.collectionDateTime": "Tanggal dan Waktu Pengumpulan",
  "barcode.label.info.created": "Dibuat",
  "barcode.label.info.destination": "Tujuan",
  "barcode.label.info.expiryDate": "Tanggal Kedaluwarsa",
  "barcode.label.info.labNumber": "Nomor Registrasi",
  "barcode.label.info.patientDobFull": "Tanggal Lahir Pasien",
  "barcode.label.info.patientId": "NIK Pasien",
  "barcode.label.info.patientName": "Nama Pasien",
  "barcode.label.info.patientSexFull": "Jenis Kelamin Pasien",
  "barcode.label.info.samplecount": "Sampel",
  "barcode.label.info.siteId": "ID Tempat",
  "barcode.label.info.slideId": "ID slide",
  "barcode.label.info.slideNumber": "Nomor Slide",
  "barcode.label.info.specimenType": "Jenis Spesimen",
  "barcode.label.info.stainType": "Jenis Pewarnaan",
  "barcode.label.info.storageLocation": "Lokasi Penyimpanan",
  "barcode.label.info.temperature": "Suhu",
  "barcode.label.info.tests": "Pemeriksaan",
  "barcode.labels.order.row": "Label pemesanan",
  "barcode.labels.running.total": "Total pengerjaan",
  "barcode.labels.sample.row": "Contoh label spesimen {sampleNumber}",
  "barcode.labels.section.title": "Kuantitas label",
  "barcode.locationNotFound": "Lokasi tidak ditemukan",
  "barcode.notification.save": "Konfigurasi kode QR telah disimpan",
  "barcode.partialMatch": "Kecocokan parsial - beberapa komponen valid",
  "barcode.print.button": "Cetak",
  "barcode.print.labels.title": "Label untuk pemesanan ini",
  "barcode.print.all.button": "Cetak semua",
  "barcode.print.all.saved": "Mencetak setiap label yang disimpan dengan pemesanan ini sesuai jumlah yang disimpan.",
  "barcode.print.all.legacy": "Mencetak {orderCount, plural, one {# label pemesanan} other {# label pemesanan}} dan {specimenCount, plural, one {# label} other {# label}} per sampel.",
  "barcode.print.col.label": "Label",
  "barcode.print.col.accession": "Nomor Registrasi",
  "barcode.print.col.info": "Informasi Tambahan",
  "barcode.print.col.quantity": "Jumlah yang Dicetak",
  "barcode.print.quantity.for": "Jumlah label yang dicetak untuk {label}",
  "barcode.print.size": "{height} × {width} mm",
  "barcode.print.max.hint": "Hingga {max}",
  "barcode.print.max.total": "Hingga {max} secara total, termasuk cetakan sebelumnya",
  "barcode.print.row.button": "Cetak {label}",
  "error.labels.quantity.max": "Jumlah di atas batas maksimum pengaturan memerlukan override label.",
  "error.labels.quantity.min": "Cetak minimal satu label.",
  "barcode.print.dialog.quantityFor": "Kuantitas yang akan dicetak {label}",
  "barcode.print.dialog.title": "Cetak label",
  "barcode.print.done": "Selesai",
  "barcode.print.later": "Loncat — Cetak Nanti",
  "barcode.print.preprint": "Kode QR pra-cetak",
  "barcode.print.preprint.button": "Label pra-cetak",
  "barcode.print.preprint.note": "Catatan: Bila ada penambahan institusi dan/atau sampel dan pemeriksaan, data tersebut akan dicetak di SEMUA label",
  "barcode.print.skip": "Lewati",
  "barcode.print.title": "Cetak Label Kode QR",
  "barcode.ready": "Siap untuk memindai",
  "barcode.scan": "Pindai kode QR",
  "barcode.scan.error": "Pemesanan tidak ditemukan",
  "barcode.scan.placeholder": "Pindai Kode QR atau masukkan nomor lab...",
  "barcode.scan.success": "Pemesanan berhasil dimuat",
  "barcode.scanning": "Memindai...",
  "barcode.scanOrType": "Pindai kode QR atau ketik lokasi",
  "barcode.success": "Lokasi ditemukan",
  "barcode.validHierarchyPrefilled": "Tingkatan hirarki yang valid telah terisi",
  "barcode.validation.altPrefix": "Input harus alphanumeric dan mengandung maksimum 4 karakter.",
  "barcode.validationFailed": "Validasi kode QR gagal",
  "barcodeconfiguration.browse.title": "Konfigurasi Kode QR",
  "breadcrumb.home": "Beranda",
  "breadcrumb.caseView": "Tampilan Kasus",
  "breadcrums.admin.managment": "Pengelolaan Admin",
  "calendar.management.title": "Pengelolaan Kalender",
  "calendar.management.description": "Kelola libur nasional dan konfigurasi akhir pekan untuk penghitungan TAT di jam kerja",
  "calendar.management.addHoliday": "Tambah hari libur",
  "calendar.management.editHoliday": "Edit hari libur",
  "calendar.management.deleteConfirm": "Apakah Anda mau menghapus hari libur ini?",
  "calendar.management.holidayName": "Nama Hari Libur",
  "calendar.management.date": "Tanggal",
  "calendar.management.recurring": "Pengulangan",
  "calendar.management.annual": "Tahunan",
  "calendar.management.oneTime": "Sekali",
  "calendar.management.active": "Aktif",
  "calendar.management.inactive": "Inaktif",
  "calendar.management.weekend": "Akhir pekan",
  "calendar.management.weekendDays": "Hari Akhir Pekan (dikeluarkan dari Jam Kerja)",
  "calendar.management.weekendSaved": "Konfigurasi akhir pekan disimpan",
  "calendar.management.importCsv": "Impor CSV",
  "calendar.management.exportCsv": "Ekspor CSV",
  "calendar.management.importPreview": "Pratinjau Impor",
  "calendar.management.year": "Tahun",
  "calendar.management.noHolidays": "Tidak ada Hari Libur dikonfigurasi untuk {year}. Klik \"Tambah Hari Libur\" untuk mulai.",
  "calendar.management.duplicateDate": "Hari Libur sudah ada di tanggal ini",
  "calendar.management.imported": "{count} hari libur diimpor",
  "calendar.management.skipped": "{count} hari libur diloncat",
  "calendar.management.holidayCount": "{count} hari libur dikonfigurasi untuk {year}",
  "calendar.management.saveError": "Error menyimpan hari libur",
  "calendar.management.loadError": "Error menyimpan hari libur",
  "calendar.management.save": "Simpan",
  "calendar.management.cancel": "Batal",
  "calendar.management.actions": "Aksi",
  "calendar.management.status": "Status",
  "calendar.management.column.date": "Tanggal",
  "calendar.management.column.holidayName": "Nama Hari Libur",
  "calendar.management.column.recurring": "Pengulangan",
  "calendar.management.column.status": "Status",
  "calendar.management.column.actions": "Aksi",
  "calendar.management.day.sun": "Min",
  "calendar.management.day.mon": "Sen",
  "calendar.management.day.tue": "Sel",
  "calendar.management.day.wed": "Rab",
  "calendar.management.day.thu": "Kam",
  "calendar.management.day.fri": "Jum",
  "calendar.management.day.sat": "Sab",
  "calendar.management.chooseFile": "Pilih file CSV",
  "calendar.management.csvColumns": "Kolom: tanggal, nama, pengulangan (true/false)",
  "calendar.management.rowsFound": "{count} baris ditemukan",
  "calendar.management.column.csvDate": "Tanggal",
  "calendar.management.column.csvName": "Nama",
  "calendar.management.column.csvRecurring": "Pengulangan",
  "calendar.management.importing": "Mengimpor...",
  "caseView.action.discard": "Buang perubahan",
  "caseView.action.saveDraft": "Simpan draf",
  "caseView.action.showDeactivated": "Tampilkan sudah inaktif",
  "caseView.banner.unsavedChanges": "Kasus ini memiliki perubahan yang belum disimpan. Tinggalkan halaman dan hilangkan perubahan tersebut?",
  "caseView.badge.deactivated": "Sudah inaktif",
  "caseView.badge.notApplicable": "N/A",
  "caseView.badge.readOnly": "Hanya baca",
  "caseView.label.assignedStaff": "{role}: {name}",
  "caseView.label.caseProgress": "Perkembangan kasus",
  "caseView.label.caseSummary": "Ringkasan kasus",
  "caseView.label.numberedSection": "{number}. {title}",
  "caseView.label.notRecorded": "- tidak dicatat",
  "caseView.label.unsavedChanges": "Perubahan tidak tersimpan",
  "caseView.locked.awaitingStage": "Tersedia setelah kasus mencapai {stage}",
  "caseView.locked.prerequisite": "Tersedia setelah langkah-langkah sebelumnya pada kasus ini selesai",
  "column.qc.accession": "Sampel QC",
  "column.qc.detail": "Detail",
  "column.qc.result": "Hasil",
  "column.qc.test": "Pemeriksaan",
  "column.qc.type": "Tipe",
  "compliance.dashboard.chart.comparison.title": "Perbandingan Lokasi — Persentase Kepatuhan Periode Saat Ini",
  "compliance.dashboard.chart.drilldown.title": "Analisis Mendalam Situs — Tren per Parameter",
  "compliance.dashboard.chart.trend.title": "Tren Tingkat Kepatuhan — Semua Tempat",
  "compliance.dashboard.descriptive.excluded": "Parameter deskriptif yang tidak dimasukkan dalam grafik tren",
  "compliance.dashboard.drilldown.placeholder": "Pilih tempat…",
  "compliance.dashboard.empty": "Tidak ada data yang sesuai dengan filter yang dipilih",
  "compliance.dashboard.export.pdf": "Ekspor PDF",
  "compliance.dashboard.filter.allStandards": "Semua Standar",
  "compliance.dashboard.filter.dateRange": "Rentang Tanggal",
  "compliance.dashboard.filter.dateRangeEnd": "Tanggal Selesai",
  "compliance.dashboard.filter.drilldownSite": "Analisis mendalam berdasarkan tempat",
  "compliance.dashboard.filter.sites": "Tempat Pengambilan Sampel",
  "compliance.dashboard.filter.sites.placeholder": "Semua Tempat",
  "compliance.dashboard.filter.standard": "Baku Mutu",
  "compliance.dashboard.kpi.complianceRate": "Tingkat Kepatuhan",
  "compliance.dashboard.kpi.exceedances": "Jumlah Pelanggaran Batas",
  "compliance.dashboard.kpi.sitesMonitored": "Tempat yang Dipantau",
  "compliance.dashboard.kpi.totalOrders": "Jumlah Pemesanan",
  "compliance.dashboard.loading.comparison": "Sedang memuat perbandingan…",
  "compliance.dashboard.loading.drilldown": "Sedang memuat detail lebih lanjut…",
  "compliance.dashboard.loading.exceedances": "Memuat data pelampauan batas…",
  "compliance.dashboard.loading.generating": "Sedang membuat…",
  "compliance.dashboard.loading.trend": "Memuat tren…",
  "compliance.dashboard.lowData": "Data rendah (< 3 pemesanan)",
  "compliance.dashboard.status.fail": "FAIL",
  "compliance.dashboard.table.col.date": "Tanggal",
  "compliance.dashboard.table.col.labNumber": "No. Registrasi",
  "compliance.dashboard.table.col.parameter": "Parameter",
  "compliance.dashboard.table.col.result": "Hasil",
  "compliance.dashboard.table.col.site": "Tempat",
  "compliance.dashboard.table.col.status": "Status",
  "compliance.dashboard.table.col.threshold": "Ambang batas",
  "compliance.dashboard.table.exceedances.title": "Ringkasan Pelampauan",
  "compliance.dashboard.title": "Dasbor Kepatuhan Lingkungan",
  "error.referOut.emailFormat": "Masukkan alamat email yang valid (misalnya, lab@example.org).",
  "error.referOut.handoffRequiredForDispatch": "Tanggal/Waktu Serah Terima wajib diisi untuk proses pengiriman.",
  "error.referOut.maxLength": "Maksimal {max} karakter.",
  "error.referOut.phoneFormat": "Masukkan nomor telepon yang valid beserta prefiks kode negara (misalnya +62 812 3456 7890).",
  "error.referOut.referringLabRequired": "Pilih Lab Rujukan.",
  "error.validation.qc.ackFailed": "Gagal mencatat konfirmasi QC. Silakan coba lagi.",
  "holding.time.exceeded.message": "Waktu penahanan maksimum sesuai SOP telah terlampaui untuk: {tests}",
  "holding.time.exceeded.note": "PERINGATAN: Hasil dimasukkan setelah batas waktu penyimpanan maksimum sesuai SOP terlampaui.",
  "holding.time.exceeded.title": "Waktu Penahanan Telah Melebihi Batas",
  "label.button.edit.details": "Edit detail",
  "label.expand.poolDetails": "Perluas detail pool",
  "label.pool.collapse": "Sembunyikan spesimen satu per satu",
  "label.pool.expand": "Tampilkan spesimen satu per satu",
  "label.pool.expansion.next": "Berikutnya",
  "label.pool.expansion.page": "Halaman {page} dari {total}",
  "label.pool.expansion.prev": "Sebelumnya",
  "label.pool.expansion.title": "Spesimen {animal} ({count})",
  "label.qc.fail": "Gagal",
  "label.qc.pass": "Lolos",
  "label.referOut.action.dispatch": "Kirim",
  "label.referOut.action.edit": "Edit",
  "label.referOut.action.referOut": "Rujuk Keluar",
  "label.referOut.action.save": "Simpan Rujukan",
  "label.referOut.action.view": "Lihat",
  "label.referOut.column.actions": "Aksi",
  "label.referOut.column.referringLab": "Lab Rujukan",
  "label.referOut.column.sampleId": "Nomor Identitas Sampel",
  "label.referOut.column.sampleType": "Jenis Sampel",
  "label.referOut.column.status": "Status Subkontrak",
  "label.referOut.column.tests": "Pemeriksaan",
  "label.referOut.dispatch.error": "Gagal mengirimkan rujukan.",
  "label.referOut.dispatch.notSaved": "Simpan rujukan tersebut sebelum dikirim.",
  "label.referOut.dispatch.success": "Rujukan telah dikirim.",
  "label.referOut.empty.subtitle": "Sampel akan muncul di sini setelah disimpan. Simpan pemesanan terlebih dahulu untuk merujuk spesimen.",
  "label.referOut.empty.title": "Tidak ada sampel yang tersedia untuk rujukan",
  "label.referOut.field.agreementReference": "Nomor Perjanjian",
  "label.referOut.field.cocContactEmail": "Alamat Email Kontak Rantai Pengawasan",
  "label.referOut.field.cocContactEmail.placeholder": "lab@example.org",
  "label.referOut.field.cocContactName": "Nama Kontak Rantai Pengawasan",
  "label.referOut.field.cocContactPhone": "Nomor Telepon Kontak Rantai Pengawasan",
  "label.referOut.field.cocContactPhone.placeholder": "+62 812 3456 7890",
  "label.referOut.field.expectedReturnDate": "Perkiraan Tanggal Kembali",
  "label.referOut.field.handoffDate": "Tanggal Serah Terima",
  "label.referOut.field.handoffDatetime": "Tanggal/Waktu Serah Terima",
  "label.referOut.field.handoffTime": "Waktu Serah Terima",
  "label.referOut.field.handoffTime.placeholder": "jam:menit",
  "label.referOut.field.notes": "Catatan",
  "label.referOut.field.referringLab": "Lab Rujukan",
  "label.referOut.field.referringLab.placeholder": "Pilih Lab Rujukan",
  "label.referOut.save.error": "Gagal menyimpan rujukan.",
  "label.referOut.save.success": "Rujukan telah disimpan.",
  "label.referOut.section.description": "Kirimkan spesimen ke laboratorium eksternal. Setiap sampel dilengkapi dengan metadata rantai pengawasan yang lengkap.",
  "label.referOut.section.title": "Dirujuk keluar / Subkontrak",
  "label.referOut.status.cancelled": "Dibatalkan",
  "label.referOut.status.closed": "Ditutup",
  "label.referOut.status.completed": "Selesai",
  "label.referOut.status.dispatched": "Telah dikirim",
  "label.referOut.status.draft": "Draf",
  "label.referOut.status.inProgress": "Dalam pengerjaan",
  "label.referOut.status.notReferred": "Di lab internal",
  "label.referOut.status.received": "Diterima",
  "label.referOut.status.rejected": "Ditolak",
  "label.referOut.status.requested": "Diminta",
  "label.referOut.status.resultsReturned": "Hasil Dikembalikan",
  "label.referOut.field.reason": "Alasan",
  "label.referOut.field.reason.placeholder": "Pilih alasan (opsional)",
  "label.referOut.action.referOutAll": "Rujuk semua sampel internal",
  "label.referOut.status.pendingSave": "Menunggu disimpan",
  "label.referOut.staged.success": "Disiapkan untuk {count} sampel. Rujukan disimpan saat Simpan pada langkah ini.",
  "order.status.referredOut": "Dirujuk keluar",
  "order.referral.partial": "{referred} dari {total} pemeriksaan dirujuk ke {lab}",
  "order.referral.fully": "Semua {total} pemeriksaan dirujuk ke {lab}",
  "label.sampleKind.blank": "BLANKO",
  "label.sampleKind.client": "Sampel klien",
  "label.sampleKind.control": "KONTROL",
  "label.sampleKind.duplicate": "DUPLIKAT",
  "label.sampleKind.qc": "QC",
  "label.validation.qc.ack.checkbox": "Saya telah meninjau kegagalan QC dan mengevaluasi dampaknya terhadap penerbitan hasil",
  "label.validation.qc.ack.heading": "Konfirmasi Wajib",
  "label.validation.qc.banner.subtitle": "Tinjau dan konfirmasi di bawah ini sebelum merilis hasil.",
  "label.validation.qc.banner.title": "Terdeteksi kegagalan QC — {count} Sampel QC tidak memenuhi kriteria penerimaan",
  "label.validation.qc.failedSamples": "Sampel yang Gagal dalam QC",
  "label.validation.qc.justification": "Alasan",
  "label.validation.checkBeforeRelease": "Periksa sebelum dirilis",
  "label.validation.triage.filterLabel": "Filter berdasarkan sinyal",
  "label.validation.filter.all": "Semua",
  "label.validation.filter.needsReview": "Perlu ditinjau",
  "label.validation.filter.nce": "NCE",
  "label.validation.filter.qcFail": "Gagal QC",
  "label.validation.filter.modified": "Dimodifikasi",
  "label.validation.filter.ackPending": "Konfirmasi tertunda",
  "label.validation.search.box": "No Registrasi",
  "label.validation.search.rangeHint": "Rentang: A..B, atau A.. untuk A dan seterusnya",
  "label.validation.search.fromDate": "Dari",
  "label.validation.search.toDate": "Kepada",
  "label.validation.search.loadError": "Antrean validasi tidak dapat dimuat.",
  "label.validation.filter.critical": "Kritis",
  "label.validation.filter.abnormal": "Tidak normal",
  "label.validation.lane.clear": "Kosongkan",
  "label.validation.lane.needsReview": "Perlu ditinjau",
  "label.validation.signal.nce": "NCE terbuka",
  "label.validation.signal.qcFail": "Gagal QC",
  "label.validation.signal.modified": "Dimodifikasi",
  "label.validation.signal.ackPending": "Konfirmasi tertunda",
  "label.validation.signal.nonconforming": "Tidak Sesuai",
  "label.validation.signal.critical": "Kritis",
  "label.validation.review.result": "Hasil",
  "label.validation.review.units": "Unit",
  "label.validation.review.normalRange": "Rentang referensi",
  "label.validation.review.criticalRange": "Rentang kritis",
  "label.validation.review.method": "Metode",
  "label.validation.review.analyzer": "Alat",
  "label.validation.review.performedAt": "Dilakukan di",
  "label.validation.review.enteredBy": "Dimasukkan oleh",
  "label.validation.review.enteredDate": "Dimasukkan pada",
  "label.validation.review.collected": "Diambil",
  "label.validation.review.qc": "QC",
  "label.validation.review.qc.PASS": "QC lolos",
  "label.validation.review.qc.FAIL": "QC gagal",
  "label.validation.review.notRecorded": "Tidak terekam",
  "label.validation.review.beforeRelease": "Sebelum merilis, periksa:",
  "label.validation.review.components": "Komponen",
  "label.validation.review.component": "Komponen",
  "label.validation.review.flag": "Penanda",
  "label.validation.review.primary": "Primer",
  "label.validation.review.reference": "Referensi",
  "label.validation.review.notes": "Catatan",
  "label.validation.review.notes.summary": "{count} Catatan",
  "label.validation.review.notes.empty": "Tidak ada catatan",
  "label.validation.review.notes.add": "Catatan validasi",
  "label.validation.review.notes.placeholder": "Tambahkan catatan validasi…",
  "label.validation.review.notes.visibility": "Visibilitas",
  "label.validation.review.notes.internal": "Internal",
  "label.validation.review.notes.external": "Kirim beserta hasilnya",
  "label.validation.review.notes.externalWarning": "Catatan ini akan tercantum dalam laporan pasien.",
  "label.validation.review.notes.contextHint": "Konteks: Validasi (direkam secara otomatis).",
  "label.validation.review.notes.context.result": "Catatan hasil",
  "label.validation.review.modify.reason": "Alasan perubahan",
  "label.validation.review.modify.reasonRequired": "Alasan wajib untuk mengubah suatu hasil.",
  "label.validation.review.modify.newValue": "Hasil terbaru",
  "label.validation.review.modify.notEditable": "Jenis hasil ini diedit di halaman Entri Hasil.",
  "label.validation.review.qcSection": "QC",
  "label.validation.review.reagents.followUp": "Lot reagen dan lot kontrol untuk analisis ini ditinjau di halaman Entri Hasil.",
  "label.validation.review.action.release": "Validasi & rilis",
  "label.validation.review.action.modify": "Ubah hasil",
  "label.validation.review.action.saveModification": "Simpan perubahan",
  "label.validation.review.action.cancel": "Batal",
  "label.validation.review.action.refer": "Rujuk pemeriksaan ini",
  "label.validation.review.release.qcAckFirst": "Konfirmasi QC yang gagal di bawah ini sebelum merilis.",
  "label.validation.review.error.notAwaitingValidation": "Hasil ini telah berubah sejak halaman dimuat. Silakan muat ulang halaman dan periksa kembali.",
  "label.validation.review.error.qcAcknowledgmentRequired": "QC yang gagal dalam batch ini harus dikonfirmasi sebelum dirilis.",
  "label.validation.review.error.modificationReasonRequired": "Alasan wajib untuk mengubah suatu hasil.",
  "label.validation.review.error.modifyRoleRequired": "Peran Anda tidak memungkinkan untuk melakukan modifikasi terhadap hasil.",
  "label.validation.review.error.resultRequired": "Masukkan nilai hasil sebelum menyimpan.",
  "label.validation.review.error.invalidResult": "Hasilnya belum lengkap; periksa nilai yang memenuhi syarat.",
  "label.validation.review.error.generic": "Aksi tersebut tidak dapat diselesaikan.",
  "label.validation.review.success.released": "Hasil telah divalidasi dan diterbitkan.",
  "label.validation.review.success.accepted": "Component validated. The test is released once its other components are validated.",
  "label.validation.review.success.modified": "Hasil telah diubah. Hasil tersebut tetap berada dalam antrian Validasi.",
  "esig.context.validateSingle": "Validasi dan terbitkan {test} untuk nomor registrasi {accession}",
  "label.validation.bulk.releaseAllClear": "Rilis semua bebas masalah ({count})",
  "label.validation.bulk.heading": "Rilis semua hasil bebas masalah",
  "label.validation.bulk.bodyClear": "{count, plural, other {# hasil ini}} in the Clear lane: in range, no recorded QC failure, no non-conformity, not modified, not critical. A result that stops being clear before the release is skipped.",
  "label.validation.bulk.bodyEsig": "Rilis mencatat satu tanda tangan elektronik untuk seluruh kumpulan.",
  "label.validation.bulk.disabled": "Fitur pelepasan massal dinonaktifkan untuk laboratorium ini.",
  "label.validation.emptyState.signals": "{count} hasil dalam antrean ini memiliki hal yang perlu diperiksa sebelum dirilis.",
  "label.validation.emptyState.signalsDetail": "Paling umum: {signals}.",
  "label.validation.emptyState.noReference": "{count} hasil berasal dari pemeriksaan tanpa nilai rujukan yang tercatat di katalog pemeriksaan, sehingga tidak dapat dinilai sebagai normal.",
  "label.validation.emptyState.noReferenceHint": "Catat nilai normal yang diharapkan untuk pemeriksaan ini di Katalog Pemeriksaan agar hasilnya dapat lolos.",
  "label.validation.emptyState.rangeNotApplied": "{count} hasil tidak diterapkan rentang rujukan karena jenis kelamin atau usia pasien tidak tercatat. Tinjau satu per satu, atau catat nilai yang belum ada pada data pasien.",
  "label.validation.emptyState.queueEmpty": "Tidak ada yang menunggu validasi.",
  "label.validation.release.scope": "Pengecekan kelayakan memeriksa rentang rujukan, penanda hasil, ketidaksesuaian, perubahan setelah disimpan, dan konfirmasi nilai kritis, serta menahan setiap hasil yang memiliki kegagalan QC tercatat. Pengecekan ini tidak memastikan bahwa QC telah dilakukan.",
  "label.validation.bulk.none": "Tidak ada hasil bebas masalah untuk dirilis.",
  "label.validation.bulk.column.accession": "No Registrasi.",
  "label.validation.bulk.success": "{count} hasil bebas masalah telah dirilis.",
  "label.validation.bulk.partial": "{released} dirilis; {skipped} dilewati karena tidak lagi bebas masalah.",
  "label.validation.bulk.error.bulkReleaseDisabled": "Fitur pelepasan massal dinonaktifkan untuk laboratorium ini.",
  "label.validation.bulk.error.qcAcknowledgmentRequired": "QC yang gagal dalam batch ini harus dikonfirmasi sebelum dirilis.",
  "label.validation.bulk.error.nothingReleased": "Tidak ada hasil terpilih yang masih bebas masalah; tidak ada yang dirilis.",
  "label.validation.bulk.error.generic": "Proses pelepasan massal tidak selesai.",
  "label.validation.review.action.review": "Tinjau →",
  "esig.context.releaseAllClear": "Terbitkan {count} hasil tanpa masalah untuk {accession}",
  "instructions.validation.bulk.release": "Jika diaktifkan, halaman Validasi menampilkan opsi \"Rilis semua sekaligus\", yang hanya merilis hasil di jalur Clear (dalam rentang, lolos QC, tidak ada sinyal) dengan satu tanda tangan elektronik. Nonaktifkan opsi ini jika Anda ingin setiap hasil dirilis satu per satu setelah ditinjau.",
  "instructions.validation.retest.note": "Jika fitur ini diaktifkan, seorang validator yang mengirimkan hasil kembali untuk Pemeriksaan Ulang harus menulis catatan untuk tim penguji.",
  "label.validation.review.action.retest": "Kirim untuk Pemeriksaan Ulang",
  "label.validation.review.action.reject": "Tolak (ajukan NCE)",
  "label.validation.review.retest.note": "Catatan untuk meja kerja",
  "label.validation.review.retest.noteRequired": "Catatan wajib untuk mengirimkan hasil Pemeriksaan Ulang.",
  "label.validation.review.retest.hint": "Hasil tersebut dikembalikan ke \"Entri Hasil\" dan alur proses dimulai kembali dari level 1.",
  "label.validation.review.reject.hint": "Penolakan akan mengajukan kejadian ketidaksesuaian; lengkapi formulir untuk mencatatnya.",
  "label.validation.review.reject.disabled": "Fitur penolakan hasil dinonaktifkan untuk laboratorium ini.",
  "label.validation.review.error.stale": "Hasil ini telah diubah oleh {who} di {when}. Sedang memuat ulang antrian…",
  "label.validation.review.error.retestNoteRequired": "Catatan wajib untuk mengirimkan hasil Pemeriksaan Ulang.",
  "label.validation.review.error.rejectionDisabled": "Fitur penolakan hasil dinonaktifkan untuk laboratorium ini.",
  "label.validation.review.success.retest": "Hasil dikirim untuk Pemeriksaan Ulang.",
  "label.validation.review.success.rejected": "Hasil ditolak; kejadian ketidaksesuaian dicatat.",
  "label.validation.bulk.error.stale": "Antrean telah berubah saat Anda sedang memeriksanya. Sedang dimuat ulang…",
  "label.validation.autoValidated.toggle": "Sertakan validasi otomatis",
  "label.validation.autoValidated.heading": "Hasil yang divalidasi secara otomatis ({count})",
  "label.validation.autoValidated.tag": "Divalidasi secara otomatis",
  "label.validation.autoValidated.empty": "Tidak ada hasil yang divalidasi secara otomatis untuk nomor registrasi ini.",
  "label.validation.autoValidated.hint": "Diterbitkan saat entri hasil tanpa validator; ditampilkan hanya untuk ditinjau.",
  "label.validation.autoValidated.releasedOn": "Dirilis pada",
  "label.validation.signal.rangeNotApplied": "Rentang tidak diterapkan",
  "result.rangeNotApplied.sexMissing": "Rentang Rujukan tidak diterapkan: jenis kelamin pasien tidak tercatat",
  "result.rangeNotApplied.ageMissing": "Rentang Rujukan tidak diterapkan: usia pasien tidak tercatat",
  "result.rangeNotApplied.sexAndAgeMissing": "Rentang Rujukan tidak diterapkan: jenis kelamin dan usia pasien tidak tercatat",
  "laporanHasil.action.generatePdf": "Membuat PDF",
  "laporanHasil.action.regeneratePdf": "Membuat ulang PDF",
  "laporanHasil.col.actions": "Aksi",
  "laporanHasil.col.collectionDate": "Tanggal Pengambilan",
  "laporanHasil.col.compliance": "Kepatuhan",
  "laporanHasil.col.labNumber": "Nomor Registrasi",
  "laporanHasil.col.lastGenerated": "Terakhir Dibuat",
  "laporanHasil.col.site": "Tempat",
  "laporanHasil.col.standard": "Standar",
  "laporanHasil.col.tests": "Pemeriksaan",
  "laporanHasil.detail.ambientTemp": "Suhu Lingkungan",
  "laporanHasil.detail.collectionDateTime": "Tanggal/Waktu Pengambilan",
  "laporanHasil.detail.collectionMethod": "Metode Pengambilan",
  "laporanHasil.detail.complianceSummary": "Ringkasan Kepatuhan",
  "laporanHasil.detail.conditions": "Kondisi Pengambilan",
  "laporanHasil.detail.gps": "GPS",
  "laporanHasil.detail.labAnalyst": "Analis Laboratorium",
  "laporanHasil.detail.labManager": "Manajer Laboratorium",
  "laporanHasil.detail.parameter": "Parameter",
  "laporanHasil.detail.ppNo": "PP No.",
  "laporanHasil.detail.preservation": "Pengawetan",
  "laporanHasil.detail.result": "Hasil",
  "laporanHasil.detail.signatures": "Tanda Tangan",
  "laporanHasil.detail.site": "Tempat",
  "laporanHasil.detail.siteInfo": "Pengaturan Informasi Aplikasi",
  "laporanHasil.detail.standard": "Standar",
  "laporanHasil.detail.status": "Status",
  "laporanHasil.detail.threshold": "Ambang batas",
  "laporanHasil.detail.waterTemp": "Suhu Air",
  "laporanHasil.detail.weather": "Cuaca",
  "laporanHasil.empty": "Pemesanan tidak ditemukan untuk filter yang dipilih.",
  "laporanHasil.error": "Gagal memuat laporan. Silakan coba lagi.",
  "laporanHasil.filter.all": "Semua",
  "laporanHasil.filter.allSites": "Semua Tempat",
  "laporanHasil.filter.allStandards": "Semua Standar",
  "laporanHasil.filter.complianceStatus": "Status Kepatuhan",
  "laporanHasil.filter.dateFrom": "Tanggal Mulai",
  "laporanHasil.filter.dateTo": "Tanggal Sampai",
  "laporanHasil.filter.generated": "Dihasilkan",
  "laporanHasil.filter.generationStatus": "Status Pembuatan",
  "laporanHasil.filter.notGenerated": "Belum Dibuat",
  "laporanHasil.filter.samplingSite": "Tempat Pengambilan Sampel",
  "laporanHasil.filter.standard": "Baku Mutu",
  "laporanHasil.loading": "Sedang memuat laporan kepatuhan...",
  "laporanHasil.status.borderline": "Garis ambang",
  "laporanHasil.status.compliant": "Sesuai Kepatuhan",
  "laporanHasil.status.ineligible": "Tidak ada tautan standar",
  "laporanHasil.status.nonCompliant": "Tidak Sesuai Kepatuhan",
  "laporanHasil.status.none": "–",
  "laporanHasil.subtitle": "Membuat sertifikat kepatuhan untuk pemesanan lingkungan yang telah divalidasi",
  "laporanHasil.tile.generated": "Dihasilkan",
  "laporanHasil.tile.ineligible": "Tidak memenuhi syarat",
  "laporanHasil.tile.ineligible.desc": "Tidak tervalidasi atau tidak ada standar yang terkait",
  "laporanHasil.tile.notGenerated": "Belum Dibuat",
  "laporanHasil.title": "Laporan Kepatuhan",
  "lhu.amendment.error.generic": "Gagal menerbitkan ulang laporan tersebut. Silakan coba lagi.",
  "lhu.amendment.modal.description": "Anda sedang menerbitkan ulang LHU untuk nomor registrasi {labNumber}. Laporan yang diterbitkan ulang akan ditandai sebagai amandemen terhadap sertifikat yang telah diterbitkan sebelumnya.",
  "lhu.amendment.modal.heading": "Penerbitan Ulang LHU dengan Perubahan",
  "lhu.amendment.modal.submit": "Terbitkan Ulang & Unduh PDF",
  "lhu.amendment.reason.helper": "Jelaskan alasan mengapa laporan asli tersebut direvisi (wajib untuk kepatuhan terhadap ISO 17025 §7.8.8).",
  "lhu.amendment.reason.label": "Alasan perubahan",
  "lhu.amendment.reason.placeholder": "misalnya: Hasil pH yang salah — alat tidak dikalibrasi",
  "lhu.amendment.reason.required": "Alasan perubahan wajib dicantumkan",
  "lhu.amendment.reissue": "Penerbitan Ulang dengan Perubahan",
  "lhu.amendment.submitting": "Menerbitkan ulang…",
  "nce.close.error": "Gagal menutup KTS",
  "nce.close.success": "KTS berhasil ditutup",
  "nce.correctiveAction.error": "Gagal memajukan status KTS",
  "nce.correctiveAction.success": "KTS dipindahkan ke Tindakan Perbaikan",
  "notificationtrigger.activetriggers.heading": "Pemicu Aktif",
  "notificationtrigger.activetriggers.subtitle": "Setiap baris mengontrol satu jenis kejadian notifikasi. Aktifkan dengan menggeser tombol ke posisi \"On\". Pengaturan saluran dan penerima hanya diterapkan jika pemicu diaktifkan.",
  "notificationtrigger.channel.email": "Email",
  "notificationtrigger.channel.sms": "SMS",
  "notificationtrigger.channel.whatsapp": "WhatsApp",
  "notificationtrigger.template.disallowed": "This message type cannot include {fields}. Use the merge fields listed under the template.",
  "notificationtrigger.column.channels": "Channel",
  "notificationtrigger.column.enabled": "Diaktifkan",
  "notificationtrigger.column.eventcode": "Kode Kejadian",
  "notificationtrigger.column.override": "Penyesuaian per Instalasi Lab",
  "notificationtrigger.column.recipients": "Penerima",
  "notificationtrigger.column.trigger": "Pemicu",
  "notificationtrigger.config.subtitle": "Aktifkan atau nonaktifkan pemicu notifikasi, pilih saluran pengiriman, dan lakukan konfigurasi jenis penerima untuk setiap kejadian.",
  "notificationtrigger.config.title": "Konfigurasi Trigger Pemberitahuan",
  "notificationtrigger.disabled.hint": "Aktifkan pemicu ini untuk melakukan konfigurasi saluran dan penerima.",
  "notificationtrigger.override.comingsoon": "Fitur penyesuaian per instalasi lab belum tersedia.",
  "notificationtrigger.override.configure": "Konfigurasi",
  "notificationtrigger.recipient.coccontact": "Kontak CoC",
  "notificationtrigger.recipient.orderingprovider": "Penyelenggara Pemesan",
  "notificationtrigger.recipient.submittinguser": "Pengguna yang Mengirimkan",
  "notificationtrigger.referralout.defaultoff": "Pengaturan default: Matikan — harus diaktifkan secara eksplisit.",
  "notificationtrigger.referralout.description": "Terkirim saat sampel dirujuk ke laboratorium eksternal.",
  "notificationtrigger.referralout.firesoncenote": "Dikirim sekali untuk setiap rujukan yang disimpan. Jika satu pemesanan berisi rujukan ke dua laboratorium yang berbeda, maka akan dikirimkan dua notifikasi.",
  "notificationtrigger.referralout.name": "Rujukan Keluar",
  "notificationtrigger.sentmessages.action.resend": "Kirim ulang",
  "notificationtrigger.sentmessages.action.viewlog": "Lihat Log",
  "notificationtrigger.sentmessages.channel.failed": "Gagal",
  "notificationtrigger.sentmessages.channel.sent": "Dikirim",
  "notificationtrigger.sentmessages.column.actions": "Aksi",
  "notificationtrigger.sentmessages.column.channels": "Channel",
  "notificationtrigger.sentmessages.column.datetime": "Tanggal/Waktu",
  "notificationtrigger.sentmessages.column.recipient": "Penerima",
  "notificationtrigger.sentmessages.column.reference": "Referensi",
  "notificationtrigger.sentmessages.column.status": "Status",
  "notificationtrigger.sentmessages.column.type": "Tipe",
  "notificationtrigger.sentmessages.count": "{count} dari {total} pesan",
  "notificationtrigger.sentmessages.empty.heading": "Tidak ada notifikasi yang terkirim.",
  "notificationtrigger.sentmessages.filter.status.all": "Semua Status",
  "notificationtrigger.sentmessages.filter.status.failed": "Gagal",
  "notificationtrigger.sentmessages.filter.status.label": "Status",
  "notificationtrigger.sentmessages.filter.status.sent": "Terkirim",
  "notificationtrigger.sentmessages.filter.type.all": "Semua Jenis",
  "notificationtrigger.sentmessages.filter.type.label": "Tipe",
  "notificationtrigger.sentmessages.heading": "Pesan yang Terkirim",
  "notificationtrigger.sentmessages.resend.disclaimer": "Dengan mengirim ulang, byte pesan asli dan alamat penerima akan dikirim kembali. Untuk mengirim ke alamat yang berbeda, edit catatan pasien dan buat kejadian baru.",
  "notificationtrigger.sentmessages.resend.failure": "Pengiriman ulang gagal. Lihat log server untuk detailnya.",
  "notificationtrigger.sentmessages.resend.success": "Notifikasi telah dikirim ulang.",
  "notificationtrigger.sentmessages.status.failed": "Gagal",
  "notificationtrigger.sentmessages.status.sent": "Terkirim",
  "notificationtrigger.sentmessages.subtitle": "Semua pemberitahuan keluar yang dikirimkan oleh OpenELIS, dari semua tipe trigger dan channel.",
  "notificationtrigger.sentmessages.viewlog.channels": "Hasil Saluran",
  "notificationtrigger.sentmessages.viewlog.column.attempts": "Upaya",
  "notificationtrigger.sentmessages.viewlog.column.channel": "Saluran",
  "notificationtrigger.sentmessages.viewlog.column.error": "Error",
  "notificationtrigger.sentmessages.viewlog.column.status": "Status",
  "notificationtrigger.sentmessages.viewlog.heading": "Riwayat Notifikasi",
  "notificationtrigger.sentmessages.viewlog.message": "Isi Pesan",
  "notificationtrigger.sentmessages.viewlog.subject": "Subjek",
  "notificationtrigger.status.new": "BARU",
  "notificationtrigger.subcontractdispatched.description": "Terkirim ketika sampel telah dikirimkan secara fisik ke laboratorium penerima.",
  "notificationtrigger.subcontractdispatched.name": "Subkontrak Telah Dikirim",
  "notificationtrigger.tabs.sentmessages": "Pesan yang Terkirim",
  "notificationtrigger.tabs.sentmessages.placeholder": "Pesan yang terkirim — akan hadir pada pembaruan mendatang.",
  "notificationtrigger.tabs.templates": "Templat",
  "notificationtrigger.tabs.templates.placeholder": "Editor templat — akan hadir pada versi mendatang.",
  "notificationtrigger.tabs.triggers": "Pemicu",
  "notificationtrigger.templates.body.help": "Teks bebas dengan bidang penggabungan. Template ini tidak dikelola oleh i18n — silakan edit langsung.",
  "notificationtrigger.templates.body.label": "Isi Pesan",
  "notificationtrigger.templates.button.reset": "Atur Ulang ke Default",
  "notificationtrigger.templates.button.save": "Simpan Template",
  "notificationtrigger.templates.channel.help": "Setiap saluran memiliki bidang templatnya masing-masing. Beralihlah ke saluran lain untuk mengeditnya secara terpisah.",
  "notificationtrigger.templates.channel.label": "Saluran",
  "notificationtrigger.templates.heading": "Konfigurasi Template Notifikasi",
  "notificationtrigger.templates.mergefields.heading": "Bidang Gabungan yang Tersedia",
  "notificationtrigger.templates.mergefields.help": "Bidang-bidang di bawah ini khusus untuk kejadian {eventCode}. Klik sebuah bidang untuk memasukkannya di posisi kursor.",
  "notificationtrigger.templates.mergefields.optionalnote": "Jika [expectedReturn] tidak ditetapkan pada rujukan, kolom tersebut akan ditampilkan kosong — tanpa pesan kesalahan.",
  "notificationtrigger.templates.preview.label": "Pratinjau yang Telah Dirender",
  "notificationtrigger.templates.referralout.description": "Dikirimkan kepada kontak pelanggan (Penyelenggara Pemesan) dan/atau staf internal (Pengguna yang Mengirimkan) saat rujukan disimpan.",
  "notificationtrigger.templates.subcontractdispatched.description": "Terkirim kepada kontak CoC di laboratorium penerima dan kepada pelanggan saat sampel dikirimkan secara fisik ke laboratorium penerima.",
  "notificationtrigger.templates.subject.label": "Subjek",
  "notificationtrigger.templates.subtitle": "Buat templat pesan untuk setiap jenis kejadian notifikasi. Templat tersebut berupa teks bebas yang dilengkapi dengan bidang penggabungan.",
  "order.clinicalInfo.helper": "Konteks opsional untuk memandu pemilihan pemeriksaan dan pelaporan - tidak terekam sebagai diagnosis yang telah dikonfirmasi.",
  "order.complete.processing.description": "{labNumber} Saat ini berstatus \"{status}\" dan akan muncul dalam daftar pekerjaan Identifikasi Vektor V-03.",
  "order.complete.processing.description.plain": "{labNumber} saat ini berstatus \"Sedang Diproses\" dan akan muncul dalam daftar pekerjaan Identifikasi Vektor V-03.",
  "order.complete.processing.title": "Pemesanan Selesai — Sedang Diproses",
  "order.context.poolOf": "Pool berisi {count} {animal}",
  "order.paymentStatus.helper": "Bagaimana proses pembayaran untuk pemesanan ini akan dilakukan.",
  "order.priority.helper": "Rutin: waktu penyelesaian standar. STAT: segera diproses.",
  "order.referral.sampleType.ambiguous": "Pemesanan rujukan ini meminta {items}, namun jenis sampel tidak dapat ditentukan secara otomatis. Silakan pilih jenis sampel di bawah ini, lalu pilih pemeriksaan yang diminta.",
  "order.requester.section.helper": "Pilih lembaga yang memesan pemeriksaan tersebut dan penyelenggara yang bertanggung jawab.",
  "panel.domain.clinical": "Klinis",
  "panel.domain.environmental": "Lingkungan",
  "panel.domain.eqa": "PME",
  "panel.domain.vector": "Vektor",
  "panel.filter.domain": "Domain",
  "panel.organism.flea": "Kutu",
  "panel.organism.fly": "Terbang",
  "panel.organism.mosquito": "Nyamuk",
  "panel.organism.rodent": "Hewan pengerat",
  "panel.organism.selectPlaceholder": "Pilih Grup Organisme",
  "panel.organism.tick": "Centang",
  "patient.search.section.helper": "Cari berdasarkan kombinasi bidang apa saja. Nama dicocokkan secara persis atau berdasarkan huruf awalnya. Fitur 'Pencarian Eksternal' melakukan pencarian di Daftar Klien dan membutuhkan setidaknya nama serta Tanggal Lahir.",
  "placeholder.validation.qc.justification": "Wajib diisi (maks. 500 karakter)",
  "provider.add.new": "+ Tambah Penyelenggara baru \"{name}\"",
  "providerTitle.abbreviation": "Singkatan",
  "providerTitle.add": "Tambah Gelar",
  "providerTitle.confirm.activate": "Aktifkan \"{title}\"?",
  "providerTitle.confirm.activate.body": "Gelar ini akan ditawarkan kembali saat memilih gelar penyelenggara.",
  "providerTitle.confirm.deactivate": "Nonaktifkan \"{title}\"?",
  "providerTitle.confirm.deactivate.body": "Gelar ini tidak akan ditawarkan lagi untuk pilihan baru. {count} penyelenggara yang sudah memakainya tetap mempertahankannya.",
  "providerTitle.duplicate": "\"{value}\" sudah ada dalam daftar",
  "providerTitle.edit": "Edit Gelar",
  "providerTitle.edit.warning": "Mengubah gelar akan mengubah tampilannya pada setiap penyelenggara yang menggunakannya.",
  "providerTitle.empty": "Belum ada gelar penyelenggara yang dikonfigurasi.",
  "providerTitle.filter.status": "Status",
  "providerTitle.filter.status.active": "Aktif",
  "providerTitle.filter.status.all": "Semua",
  "providerTitle.filter.status.inactive": "Inaktif",
  "providerTitle.inUse": "Sedang Digunakan",
  "providerTitle.search": "Cari gelar",
  "providerTitle.sortOrder": "Sortir Pemesanan",
  "providerTitle.summary": "{total} gelar: {active} aktif, {inactive} nonaktif.",
  "providerTitle.title": "Judul",
  "providerTitle.titles": "Gelar Penyelenggara",
  "provider.email.field": "Email Penyelenggara",
  "provider.fax.field": "No. Telp Penyelenggara Layanan",
  "provider.title.field": "Judul",
  "provider.title.inName": "Itu tampaknya gelar. Pertimbangkan untuk memindahkannya ke kolom Gelar agar daftar diurutkan berdasarkan nama belakang.",
  "provider.title.filter": "Filter berdasarkan gelar",
  "provider.title.filter.all": "Semua gelar",
  "provider.title.placeholder": "Pilih gelar...",
  "provider.firstName.field": "Nama Depan",
  "provider.lastName.field": "Nama Belakang",
  "provider.new.helper": "Akan dibuat sebagai penyelenggara baru saat pemesanan ini disimpan.",
  "provider.new.tag": "Baru",
  "provider.no.match": "Tidak ditemukan penyelenggara yang sesuai.",
  "provider.phone.field": "Telepon",
  "qc.add.blank": "+ QC Blanko",
  "qc.add.control": "+ QC Kontrol",
  "qc.add.duplicate": "+ QC Duplikasi",
  "qc.collect.inheritsFromParent": "Rincian pengambilan diwarisi dari sampel induk",
  "qc.expectedValue.placeholder": "misalnya 50,0",
  "qc.samples.label": "Sampel QC:",
  "qc.samples.numericOnly": "Saat ini, QC hanya didukung untuk pemeriksaan dengan hasil numerik. Pemeriksaan yang dipilih berupa hasil terkode - pilih pemeriksaan numerik untuk menambahkan QC.",
  "qc.samples.thresholdsMissing": "Konfigurasikan ambang batas QC untuk {tests} di bagian Administrasi → Konfigurasi Pemeriksaan sebelum menambahkan sampel QC.",
  "qc.status.current": "Status QC Saat Ini",
  "qc.status.failed.warning.message": "Lot yang gagal QC dikecualikan dari pemeriksaan dan dari stok yang tersedia untuk digunakan.",
  "qc.status.failed.warning.title": "Lot ini tidak akan dapat digunakan",
  "qc.status.new": "Status QC Baru",
  "qc.status.notes": "Catatan QC",
  "qc.status.notes.placeholder": "Alasan hasil QC, pemeriksaan yang dilakukan, atau referensi",
  "qc.type.blank": "QC: Blanko",
  "qc.type.control": "QC: Kontrol",
  "qc.type.duplicate": "QC: Duplikasi",
  "referral.accept.error": "Hasilnya tidak dapat diterima. Silakan coba lagi.",
  "referral.action.accept": "Terima",
  "referral.action.acceptToAnalysis": "Terima untuk Dianalisis",
  "referral.action.clearFilters": "Hapus filter",
  "referral.action.enterResult": "Masukkan hasil",
  "referral.action.markLost": "Tandai Hilang",
  "referral.action.notifyReferenceLab": "Beritahukan Lab Rujukan",
  "referral.action.openResultEntry": "Buka di Entri Hasil",
  "referral.action.reject": "Tolak",
  "referral.banner.filterToStuck": "Filter hanya yang macet",
  "referral.banner.stuckReferralsSubtitle": "{count} rujukan telah berada di Lab Rujukan selama lebih dari {threshold} hari.",
  "referral.banner.stuckReferralsTitle": "Terdeteksi rujukan yang macet",
  "referral.box.cannotReconcileMessage": "Kotak tidak dapat direkonsiliasi - {count} sampel masih menunggu rekonsiliasi hasil. Lihat Hasil Laboratorium Rujukan.",
  "referral.box.viewBlockedReferrals": "Lihat di Hasil Lab Rujukan",
  "referral.breadcrumb.referenceLabResults": "Hasil Laboratorium Rujukan",
  "referral.chip.ariaLabel": "Tampilan hasil Lab Rujukan",
  "referral.chip.history": "Riwayat",
  "referral.chip.outstanding": "Belum Selesai",
  "referral.chip.returned": "Telah dikembalikan — perlu ditindaklanjuti",
  "referral.column.actions": "Aksi",
  "referral.column.boxId": "ID Boks",
  "referral.column.closedDate": "Tanggal penutupan",
  "referral.column.daysOutstanding": "Jumlah hari belum selesai",
  "referral.column.daysTotal": "Jumlah hari",
  "referral.column.labNumber": "Nomor Registrasi",
  "referral.column.outcome": "Hasil",
  "referral.column.patient": "Pasien",
  "referral.column.priority": "Prioritas",
  "referral.column.referenceLab": "Lab Rujukan",
  "referral.column.requestor": "Pemohon awal",
  "referral.column.resultSummary": "Ringkasan hasil",
  "referral.column.returnedDate": "Tanggal Pengembalian",
  "referral.column.sentDate": "Tanggal Dikirim",
  "referral.column.status": "Status",
  "referral.column.tests": "Pemeriksaan",
  "referral.expand.criticalBadge": "KRITIS",
  "referral.expand.detail.ageYears": "{years, plural, other {# tahun}}",
  "referral.expand.detail.boxId": "ID Boks",
  "referral.expand.detail.boxReceivedDate": "Telah diterima di Lab Rujukan",
  "referral.expand.detail.collected": "Diambil",
  "referral.expand.detail.currentStatus": "Status saat ini",
  "referral.expand.detail.daysOutstanding": "Jumlah hari belum selesai",
  "referral.expand.detail.dispatched": "Telah dikirim",
  "referral.expand.detail.fhirTask": "Tugas FHIR",
  "referral.expand.detail.labNumber": "Nomor Registrasi",
  "referral.expand.detail.patient": "Pasien",
  "referral.expand.detail.priority": "Prioritas",
  "referral.expand.detail.referenceLab": "Lab Rujukan",
  "referral.expand.detail.requestor": "Pemohon awal",
  "referral.expand.detail.sampleType": "Jenis sampel",
  "referral.expand.detail.tests": "Pemeriksaan",
  "referral.expand.noResultPayload": "Lab Rujukan tidak memberikan hasil yang terstruktur.",
  "referral.expand.originalOrderContext": "Konteks pemesanan asli",
  "referral.expand.outcomeDetail": "Rincian hasil",
  "referral.expand.receptionAction": "Aksi penerimaan",
  "referral.expand.receptionHint": "Periksa hasil yang dikembalikan di bawah ini, lalu pilih \"Terima\" untuk menyimpannya ke dalam rekam medis pasien, atau pilih \"Tolak\" jika hasil tersebut tidak dapat digunakan.",
  "referral.expand.referenceLabTransit": "Pengiriman sampel ke Lab Rujukan",
  "referral.expand.result": "Hasil",
  "referral.expand.statusDetail": "Rincian status",
  "referral.filter.allPriorities": "Semua Prioritas",
  "referral.filter.allRefLabs": "Semua Lab Rujukan",
  "referral.filter.dateRange": "Rentang Tanggal",
  "referral.filter.daysOutstandingBucket": "Jumlah hari belum selesai",
  "referral.filter.daysOutstandingBucket.stuck": "Terjebak (> {threshold} hari)",
  "referral.filter.priority": "Prioritas",
  "referral.filter.referenceLab": "Lab Rujukan",
  "referral.markLost.cancelButton": "Batal",
  "referral.markLost.confirmButton": "Tandai sebagai Hilang",
  "referral.markLost.description": "Hal ini menandai bahwa rujukan tersebut hilang dalam transit dan menghapusnya dari daftar \"Belum Selesai\". Tim klinis perlu mengambil kembali sampel tersebut dan merujuknya kembali.",
  "referral.markLost.modalTitle": "Tandai rujukan sebagai hilang",
  "referral.markLost.reasonLabel": "Alasan",
  "referral.markLost.reasonPlaceholder": "Misalnya: Kurir telah melakukan konfirmasi kehilangan. Kotak tersebut tidak pernah sampai di Lab Rujukan.",
  "referral.markLost.reasonRequired": "Alasan wajib diisi.",
  "referral.metric.outstanding": "Belum Selesai",
  "referral.metric.reconciledToday": "Telah direkonsiliasi hari ini",
  "referral.metric.rejectedThisWeek": "Ditolak minggu ini",
  "referral.metric.returned": "Telah dikembalikan — perlu ditindaklanjuti",
  "referral.notification.accepted": "Hasil telah diterima dalam rekam medis pasien.",
  "referral.notification.rejected": "Hasil ditolak. Dokter telah diberi tahu untuk mengambil sampel kembali.",
  "referral.notify.errorRetry": "Gagal memberi tahu Lab Rujukan. Coba lagi.",
  "referral.notify.toast": "Lab Rujukan telah diberi tahu.",
  "referral.page.title": "Hasil Laboratorium Rujukan",
  "referral.reject.cancelButton": "Batal",
  "referral.reject.confirmButton": "Tolak dan beri tahu tenaga medis",
  "referral.reject.description": "Penolakan akan menutup pemeriksaan yang bersangkutan secara permanen dan memberi tahu tenaga medis untuk mengambil kembali sampel serta merujuknya kembali.",
  "referral.reject.error": "Hasilnya tidak dapat ditolak. Silakan coba lagi.",
  "referral.reject.modalTitle": "Tolak hasil yang dikembalikan",
  "referral.reject.reason.clotted": "Menggumpal",
  "referral.reject.reason.damagedContainer": "Wadah yang rusak",
  "referral.reject.reason.hemolyzed": "Hemolisis",
  "referral.reject.reason.insufficientVolume": "Volume tidak cukup",
  "referral.reject.reason.mislabeled": "Salah label",
  "referral.reject.reason.other": "Lainnya",
  "referral.reject.reason.temperatureDeviation": "Penyimpangan suhu",
  "referral.reject.reason.wrongSampleType": "Jenis Sampel Salah",
  "referral.reject.reasonLabel": "Alasan",
  "referral.reject.reasonTextLabel": "Rincian",
  "referral.reject.reasonTextPlaceholder": "Jelaskan mengapa hasil yang diperoleh ini tidak dapat digunakan.",
  "referral.reject.reasonTextRequired": "Rincian wajib diisi.",
  "referral.reject.warningTitle": "Aksi ini tidak dapat dibatalkan",
  "referral.result.interp.Abnormal": "Tidak normal",
  "referral.result.interp.Critical": "Kritis",
  "referral.result.interp.Normal": "Normal",
  "referral.status.cancelled": "Dibatalkan",
  "referral.status.completed": "Hasil telah dikembalikan",
  "referral.status.draft": "Draf",
  "referral.status.inProgress": "Dalam Pengerjaan di Lab Rujukan",
  "referral.status.received": "Di Lab Rujukan",
  "referral.status.reconciled": "Direkonsiliasi",
  "referral.status.rejected": "Ditolak oleh Lab Rujukan",
  "referral.status.requested": "Terkirim — sedang menunggu persetujuan",
  "referral.table.count": "{count, plural, =0 {Tidak ada rujukan} one {# rujukan} other {# rujukan}}",
  "referral.table.history.title": "Riwayat",
  "referral.table.outstanding.title": "Rujukan yang belum diselesaikan",
  "referral.table.returned.title": "Telah dikembalikan — perlu ditindaklanjuti",
  "referral.tag.manuallyEntered": "Dimasukkan secara manual",
  "reports.tat.title": "Laporan Waktu Penyelesaian",
  "reports.tat.description": "Analisis waktu penyelesaian laboratorium setiap milestone pekerjaan",
  "reports.tat.generateReport": "Membuat Laporan",
  "reports.tat.clearFilters": "Hapus filter",
  "reports.tat.segment.orderToCollection": "Pemesanan sampai Pengambilan",
  "reports.tat.segment.collectionToReceipt": "Pengambilan sampai Diterima",
  "reports.tat.segment.receiptToTesting": "Pengambilan sampai Pengujian Dimulai",
  "reports.tat.segment.receiptToResult": "Diterima sampai Entri Hasil",
  "reports.tat.segment.receiptToValidation": "Diterima sampai Validasi",
  "reports.tat.segment.resultToValidation": "Entri Hasil sampai Validasi",
  "reports.tat.segment.overall": "Waktu Penyelesaian (TAT) keseluruhan",
  "reports.tat.calendarTime": "Waktu Kalender",
  "reports.tat.workingTime": "Jam Kerja",
  "reports.tat.workingTimeInfo": "Mode Jam Kerja: Selain {weekendDays} dan {holidayCount} libur nasional di kisaran tanggal ini",
  "reports.tat.configuredWeekends": "akhir pekan yang dikonfigurasi",
  "reports.tat.noHolidaysWarning": "Tidak ada konfigurasi libur nasional. Konfigurasi libur nasional dapat dilakukan di Admin > Pengelolaan Kalender",
  "reports.tat.manageCalendar": "Kelola Kalender",
  "reports.tat.totalResults": "Hasil Total",
  "reports.tat.meanTat": "Rata-rata TAT",
  "reports.tat.medianTat": "Median Waktu Penyelesaian (TAT)",
  "reports.tat.percentile90": "Presentil 90",
  "reports.tat.minTat": "Min TAT",
  "reports.tat.maxTat": "Maks TAT",
  "reports.tat.stdDeviation": "Simpangan Baku",
  "reports.tat.distribution": "Distribusi TAT",
  "reports.tat.breakdownBy": "Breakdown berdasarkan",
  "reports.tat.clickRowHint": "Klik baris untuk melihat hasil individual",
  "reports.tat.summary": "Ringkasan",
  "reports.tat.detailList": "Daftar Rinci",
  "reports.tat.trends": "Tren",
  "reports.tat.noResults": "Hasil tidak ditemukan untuk filter ini. Coba mengatur rentang tanggal atau kriteria filter.",
  "reports.tat.insufficientData": "Data tidak cukup",
  "reports.tat.loadError": "Error memuat data laporan",
  "reports.tat.dateRange": "Rentang Tanggal",
  "reports.tat.labUnit": "Instalasi Lab",
  "reports.tat.testPanel": "Pemeriksaan / Panel",
  "reports.tat.priority.all": "Semua",
  "reports.tat.priority.routine": "Rutin",
  "reports.tat.priority.stat": "STAT",
  "reports.tat.priority.asap": "ASAP",
  "reports.tat.sampleType": "Jenis Sampel",
  "reports.tat.orderingSite": "Institusi Pemesan",
  "reports.tat.priority": "Prioritas",
  "reports.tat.includeCancelled": "Sertakan pembatalan/penolakan",
  "reports.tat.export": "Ekspor",
  "reports.tat.exportCsv": "Ekspor CSV",
  "reports.tat.exportPdf": "Ekspor PDF",
  "reports.tat.labNumber": "Nomor Lab",
  "reports.tat.patient": "Pasien",
  "reports.tat.test": "Pemeriksaan",
  "reports.tat.orderCreated": "Pemesanan Dibuat",
  "reports.tat.collected": "Diambil",
  "reports.tat.received": "Diterima",
  "reports.tat.testingStarted": "Pemeriksaan Dimulai",
  "reports.tat.resultEntered": "Hasil Dimasukkan",
  "reports.tat.validated": "Divalidasi",
  "reports.tat.selectedTat": "TAT yang dipilih",
  "reports.tat.overallTat": "TAT keseluruhan",
  "reports.tat.columns": "Kolom",
  "reports.tat.rowsPerPage": "Baris per halaman",
  "reports.tat.showing": "Menampilkan {from}-{to} dari {total} hasil",
  "reports.tat.trend": "Tren",
  "reports.tat.aggregation": "Agregasi",
  "reports.tat.daily": "Harian",
  "reports.tat.weekly": "Mingguan",
  "reports.tat.monthly": "Bulanan",
  "reports.tat.compareBy": "Bandingkan berdasarkan",
  "reports.tat.showVolume": "Tampilkan volume pemesanan",
  "reports.tat.mean": "Rata-rata",
  "reports.tat.median": "Median",
  "reports.tat.notApplicable": "N/A",
  "reports.tat.dateRangeFrom": "Rentang Tanggal (Dari)",
  "reports.tat.dateRangeTo": "Rentang Tanggal (Sampai)",
  "reports.tat.tatSegment": "Segmen TAT",
  "reports.tat.metrics": "Metrik",
  "reports.tat.compareNone": "Tidak ada",
  "reports.tat.comparePriority": "Prioritas",
  "reports.tat.column.labNumber": "Nomor Lab",
  "reports.tat.column.test": "Pemeriksaan",
  "reports.tat.column.labUnit": "Instalasi Lab",
  "reports.tat.column.priority": "Prioritas",
  "reports.tat.column.ordered": "Dipesan",
  "reports.tat.column.collected": "Diambil",
  "reports.tat.column.received": "Diterima",
  "reports.tat.column.started": "Dimulai",
  "reports.tat.column.resulted": "Dihasilkan",
  "reports.tat.column.validated": "Divalidasi",
  "reports.tat.column.selectedTat": "TAT yang dipilih",
  "reports.tat.column.overallTat": "TAT keseluruhan",
  "reports.tat.column.name": "Nama",
  "reports.tat.column.count": "Jumlah",
  "reports.tat.column.mean": "Rata-rata",
  "reports.tat.column.median": "Median",
  "reports.tat.column.p90": "Persentil ke-90",
  "reports.tat.column.max": "Maks",
  "reports.tat.home": "Beranda",
  "reports.tat.all": "Semua",
  "reports.tat.preset.today": "Hari ini",
  "reports.tat.preset.7days": "7 hari terakhir",
  "reports.tat.preset.30days": "30 hari terakhir",
  "reports.tat.preset.90days": "90 hari terakhir",
  "reports.tat.preset.thisMonth": "Bulan ini",
  "reports.tat.preset.lastMonth": "Bulan lalu",
  "reports.tat.preset.thisQuarter": "Triwulan ini",
  "button.cancel": "Batal",
  "button.activate": "Aktifkan",
  "button.adjust": "Sesuaikan",
  "button.deactivate": "Nonaktifkan",
  "button.dispose": "Musnahkan",
  "button.edit": "Edit",
  "button.generate": "Membuat",
  "button.label.genarateReport": "Membuat Laporan",
  "button.label.loadnext": "Memuat Bundel Berikutnya",
  "button.label.loadprevious": "Memuat Bundel Sebelumnya",
  "button.label.showHidePram": "Tunjukkan/Sembunyikan Parameter Laporan",
  "button.record": "Rekam",
  "button.save": "Simpan",
  "button.save.draft": "Simpan draf",
  "button.save.next": "Simpan & Lanjut",
  "button.save.stay": "Simpan",
  "button.send": "Kirim",
  "button.update": "Perbarui",
  "calculatedTests": "Perhitungan Pemeriksaan",
  "catalog.item.activate.success": "Barang di katalog berhasil diaktifkan",
  "catalog.item.category": "Kategori",
  "catalog.item.code": "Kode",
  "catalog.item.code.hint": "Pengidentifikasi tetap yang digunakan oleh integrasi. Biarkan kosong dan kami akan membuatnya dari nama, misalnya PAR-500MG-001.",
  "catalog.item.code.locked": "Kode dikunci setelah disimpan agar integrasi dan referensi yang ada tetap berfungsi.",
  "catalog.item.code.placeholder": "Biarkan kosong untuk dibuat otomatis dari nama",
  "catalog.item.code.preview": "Akan disimpan sebagai {code}",
  "catalog.item.compatibleAnalyzers": "Alat yang Kompatibel",
  "catalog.item.deactivate.confirm.button": "Nonaktifkan",
  "catalog.item.deactivate.confirm.message": "Apakah Anda yakin akan menonaktifkan {itemName}?",
  "catalog.item.deactivate.confirm.title": "Konfirmasi Penonaktifan",
  "catalog.item.deactivate.implications.1": "Barang ini tidak akan muncul lagi di daftar barang aktif",
  "catalog.item.deactivate.implications.2": "Lot tersisa untuk barang ini masih dapat diakses",
  "catalog.item.deactivate.implications.3": "Anda dapat mengaktifkan ulang barang ini kembali saat diperlukan",
  "catalog.item.deactivate.implications.title": "Implikasi:",
  "catalog.item.deactivate.label": "Barang Dinonaktifkan",
  "catalog.item.deactivate.success": "Barang berhasil dinonaktifkan",
  "catalog.item.error.saveGeneric": "Error menyimpan barang di katalog",
  "catalog.item.error.stabilityRequired": "Stabilitas setelah dibuka wajib diisi untuk reagen",
  "catalog.item.form.title.add": "Tambah Barang Baru di Katalog",
  "catalog.item.form.title.edit": "Edit Barang di Katalog",
  "catalog.item.lowStockThreshold": "Ambang Batas Stok Sedikit",
  "catalog.item.manufacturer": "Produsen",
  "catalog.item.minimumStock": "Level Stok Minimum",
  "catalog.item.name": "Nama Barang",
  "catalog.item.reorderLevel": "Level Pemesanan Ulang",
  "catalog.item.reorderQuantity": "Kuantitas yang dipesan ulang",
  "catalog.item.save.error": "Error menyimpan barang di katalog",
  "catalog.item.save.success": "Barang di katalog berhasil disimpan",
  "catalog.item.stabilityAfterOpening": "Stabilitas Setelah Dibuka (hari)",
  "catalog.item.status": "Status",
  "catalog.item.storageRequirements": "Persyaratan Penyimpanan",
  "catalog.item.testTypes": "Jenis Pemeriksaan",
  "catalog.item.testsPerCartridge": "Pemeriksaan Per Katrid",
  "catalog.item.testsPerKit": "Pemeriksaan Per Kit",
  "catalog.item.units": "Unit",
  "catalog.search.placeholder": "Cari berdasarkan nama barang",
  "choose.availablepanel": "Pilih Panel yang Tersedia",
  "coldStorage.action.createSuccess": "Tindakan perbaikan berhasil dibuat",
  "coldStorage.action.retractSuccess": "Tindakan perbaikan berhasil dibatalkan",
  "coldStorage.action.updateSuccess": "Tindakan perbaikan berhasil diperbarui",
  "coldStorage.actions": "Aksi",
  "coldStorage.activated": "sudah aktif",
  "coldStorage.addDevicesMessage": "Tambah perangkat di Pengelolaan Perangkat untuk mengkonfigurasi ambang batas suhu",
  "coldStorage.addNewDevice": "Tambah Perangkat Baru",
  "coldStorage.alert.acknowledged": "Berhasil mengkonfirmasi peringatan",
  "coldStorage.alert.actionFailed": "Tidak dapat {action} peringatan {alertId}",
  "coldStorage.alert.equipment": "Alat Gagal",
  "coldStorage.alert.equipment.description": "Peringatan malfungsi atau masalah koneksi alat",
  "coldStorage.alert.inventory": "Peringatan Inventaris",
  "coldStorage.alert.inventory.description": "Peringatan inventaris hampir habis atau pengelolaan stok ",
  "coldStorage.alert.resolved": "Peringatan berhasil diselesaikan",
  "coldStorage.alert.saveFailed": "Gagal menyimpan pilihan notifikasi:",
  "coldStorage.alert.saveSuccess": "Pilihan notifikasi berhasil disimpan. Setiap jenis peringatan memiliki metode notifikasi sesuai konfigurasinya.",
  "coldStorage.alert.temperature": "Peringatan Suhu",
  "coldStorage.alert.temperature.description": "Peringatan akan dipicu saat suhu freezer melebihi ambang batas",
  "coldStorage.alert.type": "Jenis Peringatan",
  "coldStorage.alertConfiguration": "Konfigurasi Peringatan",
  "coldStorage.autoEscalate": "Otomatis lakukan eskalasi peringatan yang tidak terselesaikan",
  "coldStorage.button.delete": "Hapus",
  "coldStorage.configuredDevices": "Perangkat yang dikonfigurasi",
  "coldStorage.correctiveAction.column.actionId": "ID Aksi",
  "coldStorage.correctiveAction.column.created": "Dibuat",
  "coldStorage.correctiveAction.column.lastUpdatedBy": "Terakhir Diperbarui Oleh",
  "coldStorage.correctiveAction.column.performedBy": "Dilakukan Oleh",
  "coldStorage.correctiveAction.edited": "Diedit",
  "coldStorage.correctiveAction.status.cancelled": "Dibatalkan",
  "coldStorage.correctiveAction.status.completed": "Selesai",
  "coldStorage.correctiveAction.status.inProgress": "Dalam Pengerjaan",
  "coldStorage.correctiveAction.status.pending": "Tertunda",
  "coldStorage.correctiveAction.status.retracted": "Ditarik kembali",
  "coldStorage.correctiveAction.type.calibration": "Kalibrasi",
  "coldStorage.correctiveAction.type.calibration.description": "Kalibrasi peralatan atau sensor",
  "coldStorage.correctiveAction.type.equipmentRepair": "Perbaikan Peralatan",
  "coldStorage.correctiveAction.type.equipmentRepair.description": "Memperbaiki atau mengganti peralatan",
  "coldStorage.correctiveAction.type.itemReorder": "Pemesanan Ulang Barang",
  "coldStorage.correctiveAction.type.itemReorder.description": "Memesan ulang barang inventaris",
  "coldStorage.correctiveAction.type.maintenance": "Pemeliharaan",
  "coldStorage.correctiveAction.type.maintenance.description": "Melakukan tugas-tugas pemeliharaan",
  "coldStorage.correctiveAction.type.other": "Lainnya",
  "coldStorage.correctiveAction.type.other.description": "Tindakan Perbaikan lainnya atau yang disesuaikan",
  "coldStorage.correctiveAction.type.sampleRelocation": "Relokasi Sampel",
  "coldStorage.correctiveAction.type.sampleRelocation.description": "Memindahkan sampel ke lokasi lain",
  "coldStorage.correctiveAction.type.temperatureAdjustment": "Penyesuaian Suhu",
  "coldStorage.correctiveAction.type.temperatureAdjustment.description": "Menyesuaikan pengaturan suhu",
  "coldStorage.criticalThreshold": "Ambang Batas Kritis (°C)",
  "coldStorage.dashboard.acknowledge": "Mengetahui",
  "coldStorage.dashboard.activeAlerts": "Peringatan Aktif ({count})",
  "coldStorage.dashboard.column.currentTemp": "Suhu Saat Ini",
  "coldStorage.dashboard.column.currentTemp2": "Sensor Suhu 2",
  "coldStorage.dashboard.column.device": "Perangkat",
  "coldStorage.dashboard.column.duration": "Durasi",
  "coldStorage.dashboard.column.humidity": "Kelembapan",
  "coldStorage.dashboard.column.lastReading": "Pembacaan Terakhir",
  "coldStorage.dashboard.column.location": "Lokasi",
  "coldStorage.dashboard.column.severity": "Keparahan",
  "coldStorage.dashboard.column.started": "Dimulai",
  "coldStorage.dashboard.column.targetTemp": "Suhu Target",
  "coldStorage.dashboard.column.temperature": "Suhu",
  "coldStorage.dashboard.column.unitId": "ID Unit",
  "coldStorage.dashboard.column.unitName": "Nama Unit",
  "coldStorage.dashboard.criticalAlertSubtitle": "{count} Unit penyimpanan yang mengalami fluktuasi suhu yang kritis",
  "coldStorage.dashboard.criticalAlertTitle": "Peringatan Kritis",
  "coldStorage.dashboard.deviceTypeFilter": "Jenis Perangkat",
  "coldStorage.dashboard.kpi.critical": "Peringatan Kritis",
  "coldStorage.dashboard.kpi.normal": "Status Normal",
  "coldStorage.dashboard.kpi.totalUnits": "Jumlah Unit Penyimpanan",
  "coldStorage.dashboard.kpi.warnings": "Peringatan",
  "coldStorage.dashboard.lastUpdate": "Pembaruan Terakhir: {time}",
  "coldStorage.dashboard.loadingUnits": "Sedang memuat unit penyimpanan…",
  "coldStorage.dashboard.noActiveAlerts": "Tidak ada peringatan yang aktif",
  "coldStorage.dashboard.noUnitsFound": "Tidak ditemukan unit penyimpanan.",
  "coldStorage.dashboard.online": "Online",
  "coldStorage.dashboard.refresh": "Segarkan",
  "coldStorage.dashboard.refreshing": "Menyegarkan",
  "coldStorage.dashboard.refreshingEllipsis": "Menyegarkan...",
  "coldStorage.dashboard.searchLabel": "Cari berdasarkan ID Unit atau Nama",
  "coldStorage.dashboard.statusFilter": "Status",
  "coldStorage.dashboard.storageUnitsTitle": "Unit Penyimpanan",
  "coldStorage.dashboard.subtitle": "Pemantauan suhu secara real-time & Kepatuhan",
  "coldStorage.dashboard.systemStatus": "Status Sistem: {status}",
  "coldStorage.dashboard.tab.correctiveActions": "Tindakan Perbaikan",
  "coldStorage.dashboard.tab.dashboard": "Dasbor",
  "coldStorage.dashboard.tab.historicalTrends": "Tren Historis",
  "coldStorage.dashboard.tab.reports": "Laporan",
  "coldStorage.dashboard.tab.settings": "Pengaturan",
  "coldStorage.dashboard.viewAlertDetails": "Lihat rincian peringatan",
  "coldStorage.deactivated": "sudah inaktif",
  "coldStorage.description": "Deskripsi",
  "coldStorage.device.activate": "Aktivasi perangkat",
  "coldStorage.device.activateMessage": "Mengaktivasi perangkat ini akan mengaktivasi pemantauan dan pengumpulan data.",
  "coldStorage.device.changeStatus": "Ubah Status Perangkat",
  "coldStorage.device.changeStatusOf": "Ubah status {name}:",
  "coldStorage.device.created": "Perangkat berhasil dibuat",
  "coldStorage.device.createdSuccess": "Perangkat \"{name}\" berhasil dibuat",
  "coldStorage.device.deactivate": "Inaktivasi perangkat",
  "coldStorage.device.deactivateMessage": "Menginaktivasi perangkat ini akan menghentikan pemantauan dan pengumpulan data. Riwayat data akan tersimpan.",
  "coldStorage.device.delete": "Hapus Perangkat",
  "coldStorage.device.deleteConfirm": "Apakah Anda yakin akan menghapus {name}?",
  "coldStorage.device.deleteWarning": "Aksi ini akan menandai perangkat sebagai inaktif dan menghapusnya dari pemantauan aktif. Riwayat data akan tersimpan.",
  "coldStorage.device.deleted": "Perangkat \"{name}\" berhasil dihapus",
  "coldStorage.device.deviceStatus": "Status Perangkat",
  "coldStorage.device.edit": "Edit perangkat",
  "coldStorage.device.id": "ID perangkat",
  "coldStorage.device.ipAddress": "Alamat IP",
  "coldStorage.device.port": "Portal",
  "coldStorage.device.protocol": "Protokol",
  "coldStorage.device.registerCount": "Register per Nilai",
  "coldStorage.device.registerCount.help": "1 untuk nilai 16-bit, 2 untuk nilai 32-bit yang mencakup dua register",
  "coldStorage.device.roomFacility": "Ruangan/Fasilitas",
  "coldStorage.device.rs485": "RS-485 Setengah-Duplex (Opsional)",
  "coldStorage.device.rs485.delayAfter": "Penundaan Setelah Pengiriman (ms)",
  "coldStorage.device.rs485.delayBefore": "Waktu Tunda Sebelum Pengiriman (ms)",
  "coldStorage.device.rs485.mode": "Aktifkan pengaturan waktu pengaktifan driver RS-485",
  "coldStorage.device.rs485.rtsActiveHigh": "RTS aktif tinggi selama transmisi",
  "coldStorage.device.rs485.rxDuringTx": "Aktifkan penerima selama proses transmisi",
  "coldStorage.device.rs485.termination": "Terminasi bus diaktifkan",
  "coldStorage.device.secondProbe": "Sensor Suhu Kedua (Opsional)",
  "coldStorage.device.secondProbe.offset": "Suhu Dasar 2 (°C)",
  "coldStorage.device.secondProbe.offsetHelp": "Pergeseran dasar untuk probe kedua",
  "coldStorage.device.secondProbe.register": "Register Suhu 2",
  "coldStorage.device.secondProbe.registerHelp": "Alamat register Modbus untuk probe suhu kedua yang independen. Pembacaan suhunya dicatat dan ditampilkan dalam grafik; peringatan ambang batas dipicu berdasarkan data dari probe pertama.",
  "coldStorage.device.secondProbe.scale": "Skala Suhu 2",
  "coldStorage.device.secondProbe.scaleHelp": "Faktor penskalaan (misalnya, 0,1 untuk membagi dengan 10)",
  "coldStorage.device.statusChanged": "Perangkat \"{name}\" berhasil {status}",
  "coldStorage.device.type": "Jenis",
  "coldStorage.device.updated": "Perangkat berhasil diperbarui",
  "coldStorage.device.wordOrder": "Urutan Kata",
  "coldStorage.device.wordOrder.bigEndian": "Big-endian (kata yang paling signifikan terlebih dahulu)",
  "coldStorage.device.wordOrder.help": "Urutan kedua register dalam nilai 32-bit; diabaikan saat membaca satu register",
  "coldStorage.device.wordOrder.littleEndian": "Little endian (kata yang paling tidak signifikan terlebih dahulu)",
  "coldStorage.deviceHistory.averageMetric": "Rata-rata {metric}",
  "coldStorage.deviceHistory.column.acknowledgedPerformedBy": "Sudah diketahui / Dilaksanakan Oleh",
  "coldStorage.deviceHistory.column.date": "Tanggal",
  "coldStorage.deviceHistory.column.eventId": "Identitas Peristiwa",
  "coldStorage.deviceHistory.column.eventType": "Jenis Kejadian",
  "coldStorage.deviceHistory.column.summaryTitle": "Ringkasan / Judul",
  "coldStorage.deviceHistory.column.time": "Waktu",
  "coldStorage.deviceHistory.correctiveActions": "Tindakan Perbaikan",
  "coldStorage.deviceHistory.dataPoints": "Titik Data",
  "coldStorage.deviceHistory.exportCsv": "Ekspor CSV",
  "coldStorage.deviceHistory.loadingEvents": "Memuat riwayat kejadian...",
  "coldStorage.deviceHistory.loadingTemperature": "Sedang memuat data suhu...",
  "coldStorage.deviceHistory.maxMetric": "Maks {metric}",
  "coldStorage.deviceHistory.metric": "Metrik:",
  "coldStorage.deviceHistory.minMetric": "Min {metric}",
  "coldStorage.deviceHistory.noEventsFound": "Tidak ditemukan kejadian.",
  "coldStorage.deviceHistory.noTemperatureData": "Tidak ada data suhu yang tersedia untuk rentang waktu yang dipilih.",
  "coldStorage.deviceHistory.searchEvents": "Cari kejadian",
  "coldStorage.deviceHistory.searchPlaceholder": "Cari berdasarkan ID kejadian, ringkasan, atau pengguna...",
  "coldStorage.deviceHistory.tab.eventHistory": "Riwayat Kejadian",
  "coldStorage.deviceHistory.tab.temperatureTrends": "Tren Suhu",
  "coldStorage.deviceHistory.timeRange": "Rentang Waktu:",
  "coldStorage.deviceHistory.title": "Riwayat Perangkat - {name} ({id})",
  "coldStorage.deviceHistory.totalAlerts": "Jumlah Peringatan",
  "coldStorage.deviceHistory.totalEvents": "Jumlah Kejadian",
  "coldStorage.email": "Email",
  "coldStorage.emailSmsNotifications": "Notifikasi Email & SMS",
  "coldStorage.error.createAction": "Gagal membuat tindakan perbaikan. Silahkan coba lagi.",
  "coldStorage.error.createDevice": "Gagal membuat perangkat:",
  "coldStorage.error.createRoom": "Gagal membuat ruangan:",
  "coldStorage.error.deleteDevice": "Gagal menghapus perangkat:",
  "coldStorage.error.loadActions": "Gagal memuat tindakan perbaikan. Silahkan coba lagi.",
  "coldStorage.error.loadAuditTrail": "Tidak dapat memuat jejak audit",
  "coldStorage.error.loadAuditTrailDetail": "Terjadi kesalahan tak terduga saat memuat catatan audit.",
  "coldStorage.error.loadDevices": "Gagal memuat perangkat:",
  "coldStorage.error.loadExcursions": "Tidak dapat memuat riwayat fluktuasi suhu",
  "coldStorage.error.loadExcursionsDetail": "Terjadi error tak terduga saat memuat fluktuasi suhu.",
  "coldStorage.error.loadFailed": "Tidak dapat memuat data pemantauan Penyimpanan Dingin.",
  "coldStorage.error.loadLocations": "Gagal memuat lokasi:",
  "coldStorage.error.loadUsers": "Gagal membuat daftar pengguna. Silahkan coba beberapa saat lagi.",
  "coldStorage.error.noCurrentUser": "Tidak dapat mengidentifikasi pengguna saat ini. Silakan masuk kembali.",
  "coldStorage.error.retractAction": "Gagal membatalkan tindakan perbaikan. Silahkan coba lagi.",
  "coldStorage.error.saveThreshold": "Gagal menyimpan konfigurasi ambang batas:",
  "coldStorage.error.toggleStatus": "Gagal mengganti status perangkat:",
  "coldStorage.error.updateAction": "Gagal memuat tindakan perbaikan. Silahkan coba beberapa saat lagi.",
  "coldStorage.error.updateDevice": "Gagal memperbarui perangkat:",
  "coldStorage.error.updateFailed": "Tidak dapat memperbarui data penyimpanan dingin",
  "coldStorage.escalationDelay": "Penundaan Eskalasi (menit)",
  "coldStorage.escalationDelayHelper": "Waktu tunggu sebelum eskalasi peringatan yang tidak terselesaikan",
  "coldStorage.escalationRules": "Aturan Eskalasi",
  "coldStorage.filter.activeOnly": "Hanya yang Aktif",
  "coldStorage.filter.all": "Semua Perangkat",
  "coldStorage.filter.inactiveOnly": "Hanya yang Inaktif",
  "coldStorage.footer": "Pemantauan Penyimpanan Dingin v2.1.0 | Sesuai dengan pedoman CAP, CLIA, FDA, dan WHO | Pengelolaan Data yang Sesuai dengan HIPAA",
  "coldStorage.granularNotificationControl": "Kendali Notifikasi Granular",
  "coldStorage.granularNotificationControlDesc": "Konfigurasi notifikasi email dan SMS untuk setiap jenis peringatan. Aktifkan metode notifikasi yang diinginkan untuk setiap jenis kategori peringatan.",
  "coldStorage.howNotificationsWork": "Bagaimana notifikasi bekerja",
  "coldStorage.howNotificationsWorkDesc": "Saat peringatan terpicu (pelanggaran ambang batas suhu, kegagalan perangkat, dll.), sistem akan:",
  "coldStorage.loadingDevices": "Memuat perangkat...",
  "coldStorage.loadingPrefs": "Memuat pilihan notifikasi...",
  "coldStorage.name": "Nama",
  "coldStorage.noConfigFound": "Konfigurasi tidak ditemukan",
  "coldStorage.noDevicesConfigured": "Tidak ada perangkat yang dikonfigurasi",
  "coldStorage.notification.createRecord": "Membuat rekaman peringatan di sistem (tampil di Dasbor)",
  "coldStorage.notification.logAttempt": "Log percobaan notifikasi untuk kepentingan proses jejak audit",
  "coldStorage.notification.sendEmail": "Kirim notifikasi via EMAIL jika diaktifkan (untuk penerima yang di tetapkan)",
  "coldStorage.notification.sendSms": "Kirim notifikasi SMS jika diaktifkan (untuk nomor telepon yang ditetapkan)",
  "coldStorage.pollInterval": "Interval Poll (detik)",
  "coldStorage.reports.column.action": "Aksi",
  "coldStorage.reports.column.details": "Rincian",
  "coldStorage.reports.column.excursionId": "ID Fluktuasi Suhu",
  "coldStorage.reports.column.freezer": "Freezer",
  "coldStorage.reports.column.freezerId": "Nomor Identitas Freezer",
  "coldStorage.reports.column.startTime": "Waktu Mulai",
  "coldStorage.reports.column.temperatureRange": "Rentang Suhu",
  "coldStorage.reports.column.timestamp": "Cap waktu",
  "coldStorage.reports.column.user": "Pengguna",
  "coldStorage.reports.downloadReport": "Unduh Laporan {format}",
  "coldStorage.reports.endDate": "Tanggal Selesai",
  "coldStorage.reports.excursionHistory": "Riwayat Fluktuasi Suhu",
  "coldStorage.reports.exportFormat": "Format Ekspor",
  "coldStorage.reports.footer": "Pemantauan Penyimpanan Dingin v2.1.0 | Sesuai dengan standar CAP, CLIA, FDA, dan WHO | Pengelolaan data yang sesuai dengan HIPAA",
  "coldStorage.reports.freezer": "Freezer",
  "coldStorage.reports.generateReport": "Buat Laporan",
  "coldStorage.reports.loadingAudit": "Sedang memuat entri audit…",
  "coldStorage.reports.loadingExcursions": "Memuat fluktuasi suhu…",
  "coldStorage.reports.noAuditActivity": "Tidak ada aktivitas audit untuk filter yang dipilih.",
  "coldStorage.reports.noAuditMatch": "Tidak ada entri audit yang sesuai dengan pencarian Anda.",
  "coldStorage.reports.noExcursions": "Tidak ada fluktuasi suhu untuk filter yang dipilih.",
  "coldStorage.reports.regulatoryCompliance": "Kepatuhan terhadap Peraturan",
  "coldStorage.reports.regulatoryComplianceDesc": "Laporan-laporan tersebut mengikuti pedoman CAP (College of American Pathologists), CLIA (Clinical Laboratory Improvement Amendments), FDA (Food and Drug Administration), dan WHO (World Health Organization) mengenai penyimpanan dengan pengaturan suhu.",
  "coldStorage.reports.reportType": "Jenis Laporan",
  "coldStorage.reports.searchAuditTrail": "Cari jejak audit...",
  "coldStorage.reports.startDate": "Tanggal Mulai",
  "coldStorage.reports.tab.auditTrail": "Jejak Audit",
  "coldStorage.reports.tab.excursions": "Fluktuasi Suhu",
  "coldStorage.reports.title": "Laporan Kepatuhan",
  "coldStorage.room.addNew": "Tambah Ruangan Baru",
  "coldStorage.room.create": "Buat Ruangan",
  "coldStorage.room.created": "Ruangan berhasil dibuat",
  "coldStorage.room.description": "Deskripsi",
  "coldStorage.room.descriptionPlaceholder": "Masukkan deskripsi ruangan (opsional)",
  "coldStorage.room.name": "Nama Ruangan *",
  "coldStorage.room.namePlaceholder": "Masukkan nama ruangan (misalnya, Ruangan Penyimpanan Lab A)",
  "coldStorage.saveNotificationPrefs": "Menyimpan Pilihan Notifikasi",
  "coldStorage.saveThresholdConfig": "Simpan Konfigurasi Ambang Batas",
  "coldStorage.saving": "Menyimpan...",
  "coldStorage.search.placeholder": "Cari berdasarkan ID atau nama perangkat",
  "coldStorage.selectType": "Pilih jenis",
  "coldStorage.sms": "SMS",
  "coldStorage.status": "Status",
  "coldStorage.status.active": "AKTIF",
  "coldStorage.status.inactive": "INAKTIF",
  "coldStorage.status.noData": "Tidak ada data",
  "coldStorage.status.offline": "Offline",
  "coldStorage.status.unknown": "Tidak diketahui",
  "coldStorage.supervisorEmail": "Email Penyelia",
  "coldStorage.supervisorEmailHelper": "Alamat email untuk mengirim peringatan tereskalasi",
  "coldStorage.supervisorEmailPlaceholder": "supervisor@lab.com",
  "coldStorage.targetTemperature": "Target Suhu (°C)",
  "coldStorage.threshold.saveSuccess": "Konfigurasi ambang batas berhasil disimpan",
  "coldStorage.thresholdConfiguration": "Konfigurasi Ambang Batas Suhu",
  "coldStorage.trends.averageMetric": "Rata-rata {metric}",
  "coldStorage.trends.axis.humidity": "Kelembapan (%)",
  "coldStorage.trends.axis.temperature": "Suhu (°C)",
  "coldStorage.trends.axis.temperature2": "Suhu - Probe 2 (°C)",
  "coldStorage.trends.maxMetric": "Maks {metric}",
  "coldStorage.trends.metric": "Metrik",
  "coldStorage.trends.metric.humidity": "Kelembapan",
  "coldStorage.trends.metric.temperature": "Suhu",
  "coldStorage.trends.metric.temperature2": "Suhu (Sensor 2)",
  "coldStorage.trends.minMetric": "Min {metric}",
  "coldStorage.usingDefaults": "Menggunakan pengaturan notifikasi default. Simpan untuk membuat konfigurasi.",
  "coldStorage.validation.error": "Kesalahan Validasi",
  "coldStorage.validation.retractionReason": "Masukkan alasan pembatalan",
  "coldStorage.validation.selectActionType": "Mohon pilih jenis aksi",
  "coldStorage.validation.selectDevice": "Mohon pilih perangkat",
  "coldStorage.validation.selectRoom": "Mohon pilih ruangan/lokasi untuk perangkat ini",
  "coldStorage.warningThreshold": "Peringatan Ambang Batas (°C)",
  "collect.addSample.button": "Tambah Sampel",
  "collect.assign.addToSample": "Tambah ke sampel yang ada",
  "collect.assign.button": "Tugaskan Pemeriksaan",
  "collect.assign.description": "Tugaskan pemeriksaan ke tube sampel",
  "collect.assign.newSample": "Buat sampel baru",
  "collect.assign.newSampleHelp": "Masukkan jenis sampel ke tube baru",
  "collect.assign.noExisting": "Tidak ada sampel tersebut",
  "collect.assign.title": "Penugasan Pemeriksaan",
  "collect.multiSampleExample.description": "Jika dibutuhkan jenis sample lebih dari satu",
  "collect.multiSampleExample.result": "Buat tube terpisah untuk setiap jenis",
  "collect.multiSampleExample.title": "Contoh Pengambilan Multi-Sampel",
  "collect.noSampleYet": "Sampel belum diambil",
  "collect.noCompatibleSampleTypes": "Belum ada jenis sampel yang diatur untuk pemeriksaan ini di katalog pemeriksaan",
  "collect.noTestsOrdered": "Pemeriksaan belum dipesan",
  "collect.noTestsWarning.subtitle": "Tambah sample dengan pemeriksaan di Step 1 sebelum lanjut",
  "collect.noTestsWarning.title": "Tidak ada pemeriksaan yang diambil",
  "collect.requestedTests.info": "Pemeriksaan diminta untuk pemesanan ini",
  "collect.requestedTests.title": "Pemeriksaan yang diminta",
  "collect.sample.assignedTests": "Pemeriksaan Ditugaskan",
  "collect.sample.collectionConditions": "Kondisi Pengambilan",
  "collect.sample.collectionConditions.placeholder": "Catat kondisi khusus...",
  "collect.sample.collectionDate": "Tanggal Pengambilan",
  "collect.sample.collectionMethod": "Metode Pengambilan",
  "collect.addTests.title": "Tambah Pemeriksaan atau Panel",
  "collect.addTests.helper": "Tambahkan pemeriksaan yang diminta klinisi setelah pemesanan dimasukkan, atau pemeriksaan yang baru sesuai setelah sampel tersedia.",
  "collect.consentRequired.title": "Informed Consent Wajib Ada",
  "collect.consentRequired.subtitle": "Laboratorium ini mewajibkan informed consent dicatat sebelum pengambilan dapat dilanjutkan.",
  "sample.holdingLimit": "Batas waktu simpan: {limit}",
  "sample.holdingLimit.testBy": "periksa sebelum {deadline}",
  "env.sample.receivedAtLab": "Diterima di Lab",
  "collect.sample.specimenOrigin": "Asal Sampel",
  "collect.sample.temperature": "Suhu Sampel",
  "collect.sample.temperature.placeholder": "mis. 4 C",
  "collect.sample.collectionDate.helper": "Tanggal saat sampel diambil",
  "collect.sample.collectionTime": "Waktu Pengambilan",
  "collect.sample.collector": "Pengambil sampel",
  "collect.sample.header": "Sampel {number}",
  "collect.sample.labPerformedSampling": "Pengambilan sampel yang dilakukan di laboratorium",
  "collect.sample.nce.link": "Laporan Kejadian Ketidaksesuaian",
  "collect.sample.noTests": "Tidak ada pemeriksaan yang ditugaskan untuk sampel ini",
  "collect.sample.printLabels": "Cetak label",
  "collect.printMoreLabels.helper": "Mengambil lebih banyak dari yang diperkirakan, atau memerlukan jenis sampel lain? Gunakan Tambah Sampel, lalu cetak labelnya dari kartu sampel atau bagian Label.",
  "collect.sample.quantity": "Kuantitas",
  "collect.sample.receivedAtLab": "Diterima di Lab",
  "collect.sample.receivedAtLab.helper": "Periksa jika sampel sudah diterima di laboratorium",
  "collect.sample.receivedDate": "Tanggal Diterima",
  "collect.sample.receivedTime": "Waktu Diterima",
  "collect.sample.remove": "Hapus Sampel",
  "collect.samples.title": "Sampel",
  "collect.table.compatibleTypes": "Jenis Sampel Yang Kompatibel",
  "collect.table.sampleAssignments": "Penugasan Sampel",
  "collect.table.testPanel": "Pemeriksaan / Panel",
  "heading.informedConsent.sectionTitle": "Persetujuan yang Didahului dengan Informasi",
  "heading.informedConsent.auditRecord": "Rekaman Audit Consent",
  "label.informedConsent.consentGiven": "Pasien sudah memberi tanda tangan consent",
  "label.informedConsent.formReference": "Nomor Referensi Form Consent",
  "label.informedConsent.recordedBy": "Direkam oleh",
  "label.informedConsent.recordedAt": "Direkam pada",
  "label.informedConsent.statusTag": "Consent sudah Direkam",
  "label.informedConsent.notRecorded": "Tidak terekam",
  "placeholder.informedConsent.formReference": "mis. CF-2026-00123",
  "placeholder.informedConsent.recordedBy": "mis. Dr. Smith",
  "error.informedConsent.formReferenceMaxLength": "Referensi form consent tidak lebih dari 100 karakter",
  "error.informedConsent.formReferenceInvalidChars": "Hanya boleh menggunakan abjad, angka, hyphen, dan spasi",
  "coldstorage.label.dashboard": "Dasbor Penyimpanan Beku",
  "collection.date": "Tanggal Pengambilan",
  "collector": "Pengambil sampel",
  "collector.label": "Pengambil sampel",
  "column.actions": "Aksi",
  "column.name.accept": "Terima",
  "column.name.analyzerResult": "Hasil dari Alat",
  "column.name.currentResult": "Hasil Saat Ini",
  "column.name.ignore": "Abaikan",
  "column.name.normalRange": "Rentang Normal",
  "column.name.notes": "Catatan",
  "column.name.pastNotes": "Catatan Sebelumnya",
  "column.name.qcDetail": "Detail",
  "column.name.qcStatus": "Status QC",
  "column.name.reject": "Tolak",
  "column.name.result": "Hasil",
  "column.name.retest": "Pemeriksaan Ulang",
  "column.name.sampleInfo": "Informasi Sampel",
  "column.name.sampleKind": "Jenis Sampel",
  "column.name.save": "Simpan",
  "column.name.statusPerRegulation": "Status — Sesuai Peraturan",
  "column.name.testDate": "Tanggal Pemeriksaan",
  "column.name.testId": "Identitas Pemeriksaan",
  "column.name.testName": "Nama Pemeriksaan",
  "column.name.uncertainty": "U (k=2)",
  "common.codeGenerator.error.invalidCode": "Kode harus berisi setidaknya satu huruf, angka, atau garis bawah.",
  "common.properties.title": "Properti Umum",
  "configuration.batch.test.reassignment": "Penugasan kembali dan pembatalan pemeriksaan kelompok",
  "configuration.method": "Pengelolaan Metode",
  "configuration.method.create": "Buat Metode Baru",
  "configuration.testCatalog.tests.explain": "Buat, edit, ganti nama, aktifkan, dan atur ketersediaan pemesanan pemeriksaan, beserta rentang, opsi hasil, metode, dan labelnya",
  "configuration.testCatalog.panels.explain": "Buat dan edit panel, tetapkan pemeriksaannya, dan atur urutan tampilannya",
  "configuration.testCatalog.sampleTypes.explain": "Buat dan edit jenis sampel, tetapkan pemeriksaan, dan atur urutan tampilannya",
  "configuration.testCatalog.labUnits.explain": "Buat dan edit instalasi lab serta tetapkan pemeriksaannya",
  "configuration.testCatalog.import.explain": "Muat pemeriksaan, panel, jenis sampel, dan instalasi lab dari file CSV",
  "configuration.testCatalog.methods.explain": "Tambah metode; metode baru menjadi aktif setelah digunakan oleh suatu pemeriksaan",
  "configuration.selectList.add": "Tambah daftar pilihan hasil",
  "configuration.selectList.add.alert": "Untuk mengubah ejaan entri daftar hasil saat ini, gunakan opsi Ganti nama daftar hasil yang ada.",
  "configuration.selectList.add.explain": "Untuk membuat daftar pilihan hasil untuk hasil pemeriksaan",
  "configuration.selectList.rename": "Namai ulang opsi daftar hasil yang ada",
  "configuration.selectList.rename.explain": "Namai ulang opsi daftar hasil yang ada",
  "configuration.test.activate": "Aktif/nonaktifkan pemeriksaan",
  "configuration.test.activate.explain": "Untuk mengaktifkan atau menonaktifkan pemeriksaan yang ada",
  "configuration.test.catalog": "Lihat Katalog Pemeriksaan",
  "configuration.test.catalog.explain": "Melihat Katalog Pemeriksaan saat ini",
  "configuration.test.orderable": "Mengaktifkan/menonaktifkan ketersediaan pemeriksaan",
  "configuration.test.orderable.explain": "Pemeriksaan yang tersedia dapat dipesan pada saat penerimaan pasien. Jika tidak tersedia, maka dapat dipesan sebagai pemeriksaan refleks.",
  "configuration.testCatalog.uom.explain": "Tampilkan daftar satuan pengukuran dan perbaiki nama, kode, dan kode UCUM-nya",
  "configuration.uom.title": "Satuan Pengukuran",
  "configuration.uom.explain": "Satuan yang digunakan untuk melaporkan hasil numerik. Satuan juga dapat dibuat saat mengedit pemeriksaan.",
  "configuration.uom.add": "Tambah Satuan",
  "configuration.uom.edit": "Edit Satuan",
  "configuration.uom.empty": "Tidak ada satuan pengukuran yang cocok",
  "method.modal.edit.heading": "Edit Metode",
  "configuration.method.create.duplicate": "Metode dengan nama ini sudah ada. Gunakan nama lain.",
  "configuration.panel.assign": "Penugasan Pemeriksaan",
  "configuration.panel.assign.explain": "Klik untuk memilih nama pemeriksaan yang akan ditugaskan pada panel; nama pemeriksaan yang baru akan muncul di bagian bawah panel",
  "configuration.panel.confirmation.explain": "Panel ini tidak aktif sampai ada satu pemeriksaan yang ditugaskan",
  "configuration.panel.create": "Buat panel baru",
  "configuration.panel.create.duplicate": "Jenis panel dengan nama yang sama ditemukan. Batalkan dan gunakan nama lain.",
  "configuration.panel.order": "Mengatur Urutan Panel",
  "configuration.panel.order.explain": "Menyortir panel dengan mengklik dan menyeret ke urutan yang tepat",
  "configuration.panel.order.explain.limits": "Hanya panel dengan pemeriksaan yang ditugaskan dapat dipesan. Untuk panel baru, mohon menugaskan pemeriksaan sebelum melakukan pemesanan.",
  "configuration.sampleType.assign.explain": "Pilih pemeriksaan yang akan ditugaskan pada jenis sampel dengan mengklik nama pemeriksaan; pemeriksaan baru akan tampilan di bawah jenis sampel yang ditugaskan",
  "configuration.sampleType.assign.new.type": "Tugaskan ke jenis sampel",
  "configuration.sampleType.confirmation.explain": "Jenis sampel ini tidak akan aktif sampai setidaknya satu pemeriksaan telah ditugaskan.",
  "configuration.sampleType.create": "Buat Jenis Sampel Baru",
  "configuration.sampleType.create.duplicate": "Jenis sampel dengan nama yang sama ditemukan. Mohon membatalkan atau menggunakan nama lain",
  "configuration.sampleType.manage": "Kelola Jenis Sampel",
  "configuration.sampleType.manage.explain": "Gunakan untuk membuat, mengatur tampilan pemesanan atau menugaskan pemeriksaan pada jenis sampel",
  "configuration.sampleType.order": "Mengatur Urutan Jenis Sampel",
  "configuration.sampleType.order.explain": "Menyortir jenis sampel dengan mengklik dan menyeret ke urutan yang tepat",
  "configuration.sampleType.order.explain.limits": "Hanya jenis sampel dengan penugasan pemeriksaan yang dapat dipesan. Untuk jenis sampel baru, mohon menugaskan pemeriksaan sebelum melakukan pemesanan.",
  "configuration.selectList.assign.description": "Entri baru dapat ditugaskan ke pemeriksaan atau dapat disimpan tanpa penugasan. Pilih satu atau lebih pemeriksaan untuk ditugaskan, lalu sesuaikan urutan tampilan. Jika entri baru berupa nilai rentang normal untuk pemeriksaan yang dipilih, centang kotak berlabel `Normal`. Jika diinginkan, petugas dapat memasukkan teks untuk lebih memperjelas hasil, dan centang kotak berlabel `Dapat Diperjelas`. Misalnya; jika pilihannya adalah daftar organisme dan pilihan terakhir adalah `Lainnya`, maka pengguna dapat memasukkan organisme yang tidak ada dalam daftar.",
  "configuration.selectList.assign.header": "Tugaskan pilihan hasil baru ke pemeriksaan",
  "configuration.selectList.assign.new": "Opsi daftar pilihan baru",
  "configuration.selectList.confirmChange": "Nilai normal akan diubah dari %oldvalue% ke%newvalue%, apakah anda yakin akan lanjut?",
  "configuration.selectList.description": "Masukkan English dan French ke opsi pilihan baru. Bila terjemahan tidak diketahui, maka istilah akan digunakan untuk kedua bahasa tersebut.",
  "configuration.selectList.header": "Buat opsi pilihan hasil baru",
  "configuration.test.management.ocl": "Impor OCL Concept",
  "configuration.test.management.organization": "Pengaturan Pemeriksaan",
  "configuration.test.modify.tab.configuration": "Konfigurasi",
  "configuration.test.modify.tab.compliance": "Ambang Kepatuhan",
  "configuration.test.modify.filter.instruction": "Pilih Jenis Sampel atau Bagian Sampel untuk menampilkan pemeriksaan",
  "configuration.test.modify.filter.noTestsFound": "Tidak ada pemeriksaan yang cocok untuk kriteria yang dipilih",
  "configuration.test.modify.filter.selectToBegin": "Silahkan pilih Jenis Sampel atau Bagian Sampel untuk mulai menampilkan pemeriksaan",
  "configuration.testUnit.assign.new.unit": "Menugaskan ke bagian pemeriksaan",
  "configuration.testUnit.confirmation.explain": "Instalasi Lab ini tidak aktif sampai setidaknya satu pemeriksaan ditugaskan",
  "configuration.testUnit.create": "Buat Instalasi Lab baru",
  "configuration.testUnit.create.duplicate": "Instalasi Lab dengan nama yang sama ditemukan. Batalkan atau gunakan nama lain.",
  "configuration.testUnit.order": "Mengatur Urutan Unit Pemeriksaan",
  "configuration.testUnit.order.explain": "Menyortir unit laboratorium dengan mengklik dan menyeret unit ke urutan yang tepat",
  "configuration.testUnit.order.explain.limits": "Hanya bagian pemeriksaan dengan pemeriksaan yang ditugaskan yang dapat dipesan. Untuk bagian baru, silahkan menugaskan pemeriksaan sebelum melakukan pemesanan.",
  "heading.sampleType.management": "Editor Jenis Sampel",
  "heading.sampleType.subtitle": "Konfigurasikan jenis sampel, urutan tampilan pemeriksaan, hubungan pemeriksaan, dan klasifikasi domain.",
  "heading.sampleType.editing": "Edit: {name}",
  "label.sampleType.domain": "Domain Sampel",
  "label.domain.CLINICAL": "Klinis",
  "label.domain.ENVIRONMENTAL": "Lingkungan",
  "label.domain.VECTOR": "Vektor",
  "label.sampleType.domain.clinical": "Klinis",
  "label.sampleType.domain.environmental": "Lingkungan",
  "label.sampleType.domain.helper": "Menentukan mode alur kerja mana (Klinis atau Lingkungan) yang akan menampilkan jenis sampel ini.",
  "label.sampleType.filterDomain": "Saring berdasarkan domain",
  "label.sampleType.testCount": "Pemeriksaan",
  "label.sampleType.actions": "Aksi",
  "label.sampleType.status": "Status",
  "placeholder.sampleType.search": "Cari jenis sampel...",
  "placeholder.sampleType.filter.domain": "Semua domain",
  "button.sampleType.add": "Tambah Jenis Sampel",
  "configuration.uom.create": "Buat Satuan Pengukuran Baru",
  "configure.labNumber.title": "Pengelolaan Nomor Registrasi",
  "confirmation.rename": "Konfirmasi perubahan yang dibuat",
  "currentests.title": "Pemeriksaan saat ini",
  "cytology.label.cellabnomality": "Abnormalitas Sel Epitel",
  "cytology.label.confirmSelect": "Bila opsi ini dipilih, semua informasi diagnosis saat ini akan dihapus",
  "cytology.label.dashboard": "Dasbor Sitologi",
  "cytology.label.glandular": "Kelenjar",
  "cytology.label.negative": "Negatif lesi intraepitelial atau keganasan",
  "cytology.label.neoplastic": "Keragaman sel non-neoplastik",
  "cytology.label.organisms": "Organisme",
  "cytology.label.other": "Neoplasma ganas lainnya",
  "cytology.label.otherResult": "Hasil diagnosis lainnya",
  "cytology.label.reactive": "Perubahan sel reaktif",
  "cytology.label.review": "Menunggu tinjauan dari ahli sitopatologi",
  "cytology.label.specimen": "Kecukupan spesimen",
  "cytology.label.squamous": "Skuamosa",
  "cytology.label.title": "Sitologi",
  "cytology.status.completed": "Selesai",
  "cytology.status.preparingSlides": "Menyiapkan slide",
  "cytology.status.readyForCytopathologist": "Siap untuk Ahli Sitopatologi",
  "cytology.status.screening": "Skrining",
  "dashboard.avg.turn.around.label": "Rerata waktu penyelesaian",
  "dashboard.avg.turn.around.reception.to.result.label": "Waktu Rerata Penerimaan Sampai Hasil",
  "dashboard.avg.turn.around.reception.to.validation.label": "Waktu Rerata Penerimaan Sampai Validasi",
  "dashboard.avg.turn.around.result.to.validation.label": "Waktu Rerata Hasil Sampai Validasi",
  "dashboard.avg.turn.around.subtitle.label": "Penerimaan sampai validasi",
  "dashboard.complete.orders.label": "Pemesanan selesai hari ini",
  "dashboard.in.progress.label": "Dalam Pengerjaan",
  "dashboard.in.progress.subtitle.label": "Menunggu entri hasil",
  "dashboard.metrics.loadFailed": "Jumlah dasbor tidak dapat dimuat.",
  "dashboard.partially.completed.label": "Sebagian selesai hari ini",
  "dashboard.partially.completed.subtitle.label": "Menunggu Pemeriksaan yang Belum Selesai",
  "dashboard.rejected.orders": "Pemesanan ditolak",
  "dashboard.turn.around.label": "Waktu penyelesaian tertunda",
  "dashboard.turn.around.subtitle.label": "Lebih dari 96 jam",
  "dashboard.unprints.results.label": "Hasil belum dicetak",
  "dashboard.user.orders.label": "Pemesanan yang dimasukkan pengguna",
  "dashboard.user.orders.today.label": "Pemesanan dimasukkan oleh pengguna hari ini",
  "dashboard.user.ordersEntered": "Pemesanan yang Dimasukkan",
  "dashboard.validation.ready.label": "Siap untuk validasi",
  "dashboard.validation.ready.subtitle.label": "Menunggu tinjauan",
  "dataexport.status.actions": "Aksi",
  "dataexport.status.attempt.duration": "Durasi",
  "dataexport.status.attempt.endTime": "Waktu Selesai",
  "dataexport.status.attempt.startTime": "Waktu Mulai",
  "dataexport.status.attempt.status": "Status",
  "dataexport.status.duration.ms": "{value} ms",
  "dataexport.status.duration.s": "{value} s",
  "dataexport.status.empty": "Tidak ada pelanggan FHIR yang dikonfigurasi. Atur org.openelisglobal.fhir.subscriber di common.properties dan mulai ulang server untuk mendaftarkan satu pelanggan.",
  "dataexport.status.endpoint": "Titik akhir",
  "dataexport.status.failed24h": "Gagal / Total (24 jam)",
  "dataexport.status.failed24hValue": "{failed} / {total}",
  "dataexport.status.intervalMin": "Interval retry",
  "dataexport.status.intervalValue": "{value} min",
  "dataexport.status.lastAttempt": "Coba terakhir",
  "dataexport.status.lastRefreshed": "Refresh terakhir",
  "dataexport.status.lastStatus": "Status Terakhir",
  "dataexport.status.lastSuccess": "Sukses Terakhir",
  "dataexport.status.loadingAttempts": "Memuat riwayat percobaan...",
  "dataexport.status.never": "Tidak pernah",
  "dataexport.status.noAttempts": "Belum ada percobaan",
  "dataexport.status.placeholderDash": "—",
  "dataexport.status.refresh": "Segarkan",
  "dataexport.status.retry": "Ulangi sekarang",
  "dataexport.status.retryInFlight": "Men-trigger…",
  "dataexport.status.title": "Status Ekspor Data FHIR",
  "datasubmission.siteid": "ID Tempat",
  "database.clean": "Pembersihan Database",
  "database.clean.button": "Kosongkan Database",
  "database.clean.confirm.message": "Apakah Anda yakin akan mengosongkan database? Ini akan menghapus semua data pasien dan pemeriksaan",
  "database.clean.confirm.title": "Konfirmasi Pengosongan Database",
  "database.clean.confirm.warning": "Aksi ini tidak dapat dibatalkan!",
  "database.clean.error": "Gagal mengosongkan database.",
  "database.clean.not.training": "Pembersihan database hanya tersedia di instalasi pelatihan.",
  "database.clean.success": "Database berhasil dikosongkan.",
  "database.clean.warning": "Ini akan menghapus permanen semua data pasien, sampel dan hasil dari database.",
  "date.created": "Tanggal Dibuat",
  "datepicker.future.notAllowed": "Tanggal tidak boleh di masa mendatang.",
  "datepicker.past.notAllowed": "Tanggal tidak boleh di masa lalu.",
  "datepicker.placeholder.dmy": "dd/mm/yyyy",
  "datepicker.placeholder.mdy": "mm/dd/yyyy",
  "delete.error.msg": "Error saat menghapus",
  "delete.success.msg": "Berhasil dihapus",
  "description.active": "Jika pemeriksaan sedang aktif, maka dapat dipesan melalui formulir pemesanan atau sebagai bagian algoritma pemeriksaan. Jika pemeriksaan tidak aktif, maka tidak dapat dipesan atau dijadikan bagian algoritma pemeriksaan.",
  "description.ageRange": "Jika rentang usia (dalam bulan) penting untuk nilai yang diberikan, maka akan ditentukan di sini.",
  "description.name": "Nama pemeriksaan akan muncul di dalam sistem, baik versi bahasa Inggris maupun Prancis.",
  "description.normalRange": "Rentang numerik yang diharapkan dari orang sehat.",
  "description.note": "n/a berarti tidak tersedia. Nilai tidak dispesifikasi.",
  "description.orderable": "Jika pemeriksaan aktif dan dapat dipesan, maka pemeriksaan dapat dipesan melalui formulir pemesanan. Jika pemeriksaan aktif tetapi tidak dapat dipesan, maka pemeriksaan hanya akan dilakukan jika merupakan rujukan dari pemeriksaan lain.",
  "description.panel": "Jika pemeriksaan adalah bagian dari panel pemeriksaan, maka panel akan disebut di sini.",
  "description.referenceValue": "Nilai pilihan untuk orang sehat. Hanya untuk daftar hasil yang dipilih.",
  "description.reportName": "Nama pemeriksaan yang tampil pada laporan. Tampil dalam Bahasa Inggris maupun Perancis",
  "description.resultLimits": "Batas hasil normal dan valid untuk pemeriksaan numerik. Nilai tergantung umur dan jenis kelamin pasien.",
  "description.resultType": "Jenis hasil untuk pemeriksaan ini:",
  "description.resultType.alphanumeric": "A - Alfanumerik:",
  "description.resultType.alphanumericDesc": "Menerima nilai numerik atau teks dalam kotak teks. Nilai tidak akan dievaluasi apakah normal atau valid.",
  "description.resultType.cascadingMultiSelectList": "C - Daftar pilihan berganda bertingkat:",
  "description.resultType.cascadingMultiSelectListDesc": "Serupa dengan pilihan berganda, tapi pengguna dapat memilih lebih dari satu kelompok dari pilihan dropdown.",
  "description.resultType.kind": "Jenis hasil untuk pemeriksaan ini:",
  "description.resultType.multiSelectList": "M - Daftar pilihan berganda:",
  "description.resultType.multiSelectListDesc": "Pengguna dapat memilih satu atau lebih nilai dari daftar dropdown. Nilai referensi tidak dispesifikasi.",
  "description.resultType.numeric": "N - Numerik:",
  "description.resultType.numericDesc": "Hanya menerima hasil numerik dalam kotak teks. Hasil dapat dievaluasi dalam rentang normal atau valid.",
  "description.resultType.selectList": "D - Daftar pilihan:",
  "description.resultType.selectListDesc": "Pengguna dapat memilih dari daftar dropdown. Nilai normal akan ditentukan sebagai nilai referensi.",
  "description.resultType.textArea": "R-Teks bebas:",
  "description.resultType.textAreaDesc": "Menerima lebih dari 200 karakter dalam area teks. Tidak dievaluasi apakah normal atau valid.",
  "description.sampleType": "Jenis sampel yang dapat diuji. Jika petugas yang menerima dapat memilih jenis sampel setelah pemesanan pemeriksaan, maka akan ditandai sebagai \"pengguna\", untuk menunjukkan bahwa pengguna memilih jenis sampel tersebut.",
  "description.selectValues": "Hanya ditentukan untuk hasil pilihan tunggal, pilihan ganda, atau pilihan ganda bertingkat. Ini adalah pilihan yang tersedia terlihat oleh pengguna. Jika pilihan ditandai sebagai 'dapat memenuhi syarat', maka pengguna dapat memasukkan informasi tambahan di kotak teks.",
  "description.sex": "Jika jenis kelamin pasien berpengaruh pada nilai, maka akan disebutkan disini.",
  "description.significantDigits": "Jumlah digit signifikan untuk hasil numerik. Hasil yang dimasukkan akan dibulatkan atau ditambahkan angka di depan hingga mencapai jumlah digit yang benar. Rentang normal akan ditampilkan dengan jumlah angka signifikan yang benar.",
  "description.testUnit": "Bagian lab yang melakukan pemeriksaan. Disebut juga sebagai bagian pemeriksaan.",
  "description.uom": "Satuan pengukuran pemeriksaan. Biasanya berlaku hanya untuk jenis hasil numerik atau alfanumerik.",
  "description.validRange": "Hasil numerik di luar rentang ini adalah indikasi pemeriksaan tidak dilakukan dengan benar.",
  "dictionary.category.isActive": "Aktif",
  "dictionary.category.label": "Kategori Kamus",
  "dictionary.category.localAbbreviation": "Singkatan lokal",
  "dictionary.category.name": "Kategori",
  "dictionary.dictEntry": "Entri kamus",
  "dictionary.error.dictEntryRequired": "Enter the dictionary entry.",
  "dictionary.error.localAbbreviationRequired": "Enter a local abbreviation.",
  "dictionary.error.localAbbreviationTooLong": "A local abbreviation has at most 60 characters.",
  "dictionary.label.modify": "Menu kamus",
  "dictionary.loincCode": "Kode LOINC",
  "dictionary.loincCode.help": "Masukkan kode LOINC standar",
  "dictionary.loincCode.helpText": "Pengenal standar observasi laboratorium",
  "dictionary.loincCode.invalid": "Format LOINC tidak valid (contoh yang benar: 12345-6 or LP12345-6)",
  "dictionary.loincCode.placeholder": "misalnya, 12345-6",
  "dictionary.menu.deactivate.fail": "Penonaktifan menu kamus gagal",
  "dictionary.menu.deactivate.success": "Penonaktifan menu kamus sukses",
  "dictionary.modal.add.heading": "Tambah Kamus",
  "dictionary.modal.edit.heading": "Edit Kamus",
  "dictionary.number.label": "Nomor Kamus",
  "disposal.button": "Musnahkan Lot",
  "disposal.notes": "Catatan Pemusnahan",
  "disposal.notes.placeholder": "Sediakan rincian pemusnahan (metode pemusnahan, saksi, dll.)",
  "disposal.reason": "Alasan Pemusnahan",
  "disposal.reason.select": "Pilih alasan",
  "disposal.success": "Lot berhasil dimusnahkan",
  "disposal.title": "Musnahkan Lot",
  "disposal.warning.message": "Aksi ini tidak dapat dibatalkan. Lot akan ditandai dimusnahkan atau dihapus dari inventaris aktif.",
  "disposal.warning.title": "Peringatan",
  "emergencyContactInfo.title": "Informasi Kontak Darurat",
  "english.current": "Bahasa Inggris saat ini",
  "english.label": "Bahasa Inggris",
  "enterText.label": "Masukkan hasil teks",
  "eorder.allInfo": "Semua Informasi",
  "eorder.button.editOrder": "Edit Pemesanan",
  "eorder.button.enterOrder": "Masukkan Pemesanan",
  "eorder.buttons": " ",
  "eorder.date.end": "Tanggal Selesai",
  "eorder.date.start": "Tanggal Mulai",
  "eorder.facility.requesting": "Lembaga Pemohon",
  "eorder.header": "Cari Pemesanan Pemeriksaan Yang Masuk",
  "eorder.id.national": "NIK",
  "eorder.id.subjectNumber": "Nomor Subyek",
  "eorder.instructions.enter1": "Kecocokan Pencarian Permintaan Pemeriksaan - Dalam",
  "eorder.instructions.enter2": "menu, tambah nomor registrasi dan pilih",
  "eorder.instructions.enter3": "menerima permintaan seperti apa adanya, atau pilih",
  "eorder.instructions.enter4": "membuat perubahan",
  "eorder.labNumber": "Nomor Registrasi",
  "eorder.labnumber.referring": "Nomor Lab Perujuk",
  "eorder.name.first": "Nama Depan",
  "eorder.name.last": "Nama Belakang",
  "eorder.passport.number": "Nomor Paspor",
  "eorder.priority": "Prioritas",
  "eorder.requestDate": "Tanggal Permintaan",
  "eorder.search.noresults": "Nomor Permintaan Elektronik",
  "eorder.search1.text": "Cari berdasar Nama Belakang, NIK, Nomor Lab Perujuk, atau Nomor Paspor",
  "eorder.search2.text": "Cari berdasarkan Tanggal, dan Status rentang tanggal permintaan pemeriksaan. Pencarian akan dilakukan berdasarkan tanggal dirujuk, atau tanggal permintaan elektronik.",
  "eorder.searchValue": "Cari Nilai",
  "eorder.status": "Status",
  "eorder.test.name": "Nama Pemeriksaan",
  "eqa.action.deactivate": "Nonaktifkan",
  "eqa.action.edit": "Edit",
  "eqa.action.enterResults": "Masukkan Hasil",
  "eqa.action.enterViewResults": "Masukkan/Lihat Hasil",
  "eqa.action.reactivate": "Aktifkan Ulang",
  "eqa.action.viewOrder": "Lihat Pemesanan",
  "eqa.action.viewResults": "Lihat Hasil",
  "eqa.admin.addProgram": "Tambah Program",
  "eqa.admin.col.actions": "Aksi",
  "eqa.admin.col.category": "Kategori",
  "eqa.admin.col.frequency": "Frekuensi",
  "eqa.admin.col.participants": "Peserta yang terdaftar",
  "eqa.admin.col.programName": "Nama Program",
  "eqa.admin.col.provider": "Penyelenggara",
  "eqa.admin.delete": "Hapus",
  "eqa.admin.form.addHeading": "Tambah Program PME Baru",
  "eqa.admin.form.category.placeholder": "Pilih Kategori",
  "eqa.admin.form.description.placeholder": "Deskripsi dan tujuan program...",
  "eqa.admin.form.editHeading": "Edit Program PME",
  "eqa.admin.form.frequency.placeholder": "Pilih Frekuensi",
  "eqa.admin.form.name.placeholder": "mis., Kultur TB & Sensitivitas",
  "eqa.admin.form.provider.placeholder": "Pilih penyelenggara",
  "eqa.admin.form.subtitle": "Daftar di program PME baru",
  "eqa.admin.programs.subtitle": "Kelola program dan penyelenggara PME yang terdaftar",
  "eqa.admin.programs.title": "Program PME",
  "eqa.admin.provider.placeholder": "mis., WHO",
  "eqa.admin.subtitle": "Kelola program, pengguna dan pengaturan sistem PME",
  "eqa.admin.tab.participants": "Peserta",
  "eqa.admin.tab.userManagement": "Pengelolaan Pengguna",
  "eqa.admin.tile.acrossAllPrograms": "Seluruh program",
  "eqa.admin.tile.activePrograms": "Program Aktif",
  "eqa.admin.tile.canManageEqa": "Dapat mengelola PME",
  "eqa.admin.tile.enrolledParticipants": "Peserta yang terdaftar",
  "eqa.admin.tile.systemUsers": "Pengguna Sistem",
  "eqa.admin.tile.totalParticipants": "Total Peserta",
  "eqa.admin.tile.totalPrograms": "{count} total program",
  "eqa.admin.title": "Administrasi Program",
  "eqa.admin.userManagement.placeholder": "Pengelolaan pengguna segera ada",
  "eqa.column.actions": "Aksi",
  "eqa.deadline.label": "Tenggat Pemeriksaan",
  "eqa.distribution.action.continue": "Lanjut",
  "eqa.distribution.action.ship": "Kirim",
  "eqa.distribution.action.track": "Lacak",
  "eqa.distribution.action.viewReport": "Lihat Laporan",
  "eqa.distribution.advance": "Status Lanjutan",
  "eqa.distribution.backToDashboard": "Kembali ke Distribusi",
  "eqa.distribution.barcodes": "Buat Kode QR",
  "eqa.distribution.col.actions": "Aksi",
  "eqa.distribution.col.deadline": "Tenggat",
  "eqa.distribution.col.participants": "Peserta",
  "eqa.distribution.col.program": "Program",
  "eqa.distribution.col.responses": "Respon",
  "eqa.distribution.col.round": "Bulat",
  "eqa.distribution.col.samples": "Sampel",
  "eqa.distribution.col.shipmentId": "ID Pengiriman",
  "eqa.distribution.col.status": "Status",
  "eqa.distribution.create": "Buat Distribusi",
  "eqa.distribution.createError": "Gagal membuat distribusi",
  "eqa.distribution.createShipment": "Buat Pengiriman Baru",
  "eqa.distribution.createSuccess": "Distribusi berhasil dibuat.",
  "eqa.distribution.dashboard.subtitle": "Distribusi sampel PME ke laboratorium peserta",
  "eqa.distribution.dashboard.title": "Distribusi PME",
  "eqa.distribution.deadline": "Tenggat Penyerahan",
  "eqa.distribution.detail.title": "Rincian Distribusi",
  "eqa.distribution.empty": "Distribusi tidak ditemukan",
  "eqa.distribution.filter.allShipments": "Semua Pengiriman",
  "eqa.distribution.filter.program": "Filter berdasarkan Program",
  "eqa.distribution.filter.status": "Filter berdasarkan Status",
  "eqa.distribution.list.title": "Distribusi PME",
  "eqa.distribution.manageParticipants": "Kelola Peserta",
  "eqa.distribution.name": "Nama Distribusi",
  "eqa.distribution.name.placeholder": "mis, Round 1 - Kimia 2026",
  "eqa.distribution.network.active": "Peserta Aktif",
  "eqa.distribution.network.active.sub": "Yang terdaftar saat ini",
  "eqa.distribution.network.responseRate": "Rerata Kecepatan Respon",
  "eqa.distribution.network.responseRate.sub": "4 triwulan terakhir",
  "eqa.distribution.network.subtitle": "Ringkasan laboratorium peserta yang terdaftar",
  "eqa.distribution.network.title": "Jejaring Peserta",
  "eqa.distribution.network.total": "Total Peserta",
  "eqa.distribution.network.total.sub": "Seluruh negara",
  "eqa.distribution.participants": "Organisasi Peserta",
  "eqa.distribution.participants.min": "Wajib setidaknya 2 organisasi peserta",
  "eqa.distribution.participants.none": "Tidak ada organisasi yang terdaftar di program tersebut. Daftarkan peserta sebelum membuat distribusi.",
  "eqa.distribution.participants.select": "Pilih organisasi",
  "eqa.distribution.program": "Program PME",
  "eqa.distribution.program.select": "Pilih program",
  "eqa.distribution.responseRate": "kecepatan respon",
  "eqa.distribution.shipments.subtitle": "Lacak distribusi sampel PME dan respon peserta",
  "eqa.distribution.shipments.title": "Pengiriman PME",
  "eqa.distribution.shipped": "Sudah dikirim",
  "eqa.distribution.status.completed": "Selesai",
  "eqa.distribution.status.draft": "Draf",
  "eqa.distribution.status.prepared": "Disiapkan",
  "eqa.distribution.status.shipped": "Sudah dikirim",
  "eqa.distribution.step.confirmation": "Konfirmasi",
  "eqa.distribution.step.details": "Program & Rincian",
  "eqa.distribution.step.participants": "Peserta",
  "eqa.distribution.summary.completed": "Selesai",
  "eqa.distribution.summary.completed.sub": "Semua respon sudah diterima",
  "eqa.distribution.summary.draft": "Draf Pengiriman",
  "eqa.distribution.summary.draft.sub": "Tengah disiapkan",
  "eqa.distribution.summary.participants": "Peserta",
  "eqa.distribution.summary.participants.sub": "Sudah terdaftar",
  "eqa.distribution.summary.shipped": "Sudah dikirim",
  "eqa.distribution.summary.shipped.sub": "Menunggu respon",
  "eqa.enrollment.allStatuses": "Semua Status",
  "eqa.enrollment.alreadyEnrolled": "Yang terdaftar saat ini",
  "eqa.enrollment.alreadyEnrolledCount": "{count} organisasi yang terdaftar",
  "eqa.enrollment.confirmWithdraw": "Konfirmasi Penarikan",
  "eqa.enrollment.created.success": "Pendaftaran program berhasil dibuat",
  "eqa.enrollment.deactivated": "Pendaftaran program berhasil dinonaktifkan",
  "eqa.enrollment.description": "Deskripsi",
  "eqa.enrollment.district": "Kabupaten",
  "eqa.enrollment.editing": "Edit: {name}",
  "eqa.enrollment.empty": "Tidak ada pendaftaran ditemukan untuk program ini",
  "eqa.enrollment.enroll": "Daftar",
  "eqa.enrollment.enrollParticipant": "Daftarkan Peserta",
  "eqa.enrollment.enrollSelected": "Daftarkan yang Dipilih",
  "eqa.enrollment.enrollmentDate": "Tanggal Pendaftaran",
  "eqa.enrollment.error": "Pendaftaran tidak tersimpan. Coba lagi.",
  "eqa.enrollment.labUnits": "Instalasi Lab",
  "eqa.enrollment.new": "Pendaftaran Program PME Baru",
  "eqa.enrollment.organizationCode": "Kode Organisasi",
  "eqa.enrollment.organizationName": "Nama Organisasi",
  "eqa.enrollment.panels": "Panel",
  "eqa.enrollment.programName": "Nama Program",
  "eqa.enrollment.programName.placeholder": "Masukkan nama program",
  "eqa.enrollment.provider": "Penyelenggara",
  "eqa.enrollment.provider.placeholder": "Masukkan nama penyelenggara",
  "eqa.enrollment.reactivate": "Aktifkan Ulang",
  "eqa.enrollment.reactivated": "Pendaftaran program diaktifkan ulang",
  "eqa.enrollment.save": "Simpan Pendaftaran",
  "eqa.enrollment.saveChanges": "Simpan Perubahan",
  "eqa.enrollment.searchOrgs": "Cari organisasi...",
  "eqa.enrollment.searchPlaceholder": "Cari organisasi berdasarkan nama atau kode...",
  "eqa.enrollment.selectLabUnits": "Pilih instalasi lab...",
  "eqa.enrollment.selectOrg": "Pilih organisasi...",
  "eqa.enrollment.selectOrgsPrompt": "Pilih organisasi untuk mendaftar",
  "eqa.enrollment.selectPanels": "Pilih panel...",
  "eqa.enrollment.selectProgram": "Pilih Program",
  "eqa.enrollment.selectProgramPrompt": "Pilih program untuk melihat pendaftaran",
  "eqa.enrollment.selectTests": "Pilih pemeriksaan...",
  "eqa.enrollment.selected": "dipilih",
  "eqa.enrollment.status": "Status",
  "eqa.enrollment.status.active": "Aktif",
  "eqa.enrollment.status.suspended": "Ditangguhkan",
  "eqa.enrollment.status.withdrawn": "Ditarik",
  "eqa.enrollment.success": "Pendaftaran Berhasil",
  "eqa.enrollment.suspend": "Ditangguhkan",
  "eqa.enrollment.tests": "Pemeriksaan",
  "eqa.enrollment.thisLab": "Lab ini",
  "eqa.enrollment.updated.success": "Pendaftaran program berhasil diperbarui",
  "eqa.enrollment.withdraw": "Tarik",
  "eqa.enrollment.withdrawReason": "Alasan Penarikan",
  "eqa.enrollment.withdrawReasonPlaceholder": "Masukkan alasan penarikan peserta ini...",
  "eqa.filter.allPriorities": "Semua Prioritas",
  "eqa.filter.allPrograms": "Semua Program",
  "eqa.filter.allStatuses": "Semua Status",
  "eqa.filter.eqaOnly": "Hanya Sampel PME",
  "eqa.filter.priority": "Prioritas",
  "eqa.filter.program": "Program",
  "eqa.filter.status": "Status",
  "eqa.management.action.enterResults": "Masukkan Hasil",
  "eqa.management.action.submit": "Kirim",
  "eqa.management.bulkUpload": "Unggah Hasil Bulk",
  "eqa.management.col.accession": "Aksesi #",
  "eqa.management.col.actions": "Aksi",
  "eqa.management.col.deadline": "Tenggat",
  "eqa.management.col.progress": "Kemajuan",
  "eqa.management.col.provider": "Penyelenggara/Program",
  "eqa.management.col.sampleId": "Nomor Identitas Sampel",
  "eqa.management.col.status": "Status",
  "eqa.management.daysLeft": "hari tersisa",
  "eqa.management.distributions.title": "Distribusi",
  "eqa.management.filter.allSamples": "Semua Sampel",
  "eqa.management.overdue": "Lewat tenggat",
  "eqa.management.participants.subtitle": "Kelola pendaftaran organisasi di program PME",
  "eqa.management.participants.title": "Peserta",
  "eqa.management.performance.onTime": "Penyerahan Tepat Waktu",
  "eqa.management.performance.participation": "Keikutsertaan",
  "eqa.management.performance.participation.sub": "Semua program terdaftar",
  "eqa.management.performance.subtitle": "Metrik kinerja PME laboratorium Anda",
  "eqa.management.performance.title": "Ringkasan Kinerja",
  "eqa.management.performance.zScore": "Rerata Z-Score",
  "eqa.management.performance.zScore.sub": "Dalam rentang dapat diterima",
  "eqa.management.programs.subtitle": "Kelola program yang didistribusi oleh laboratorium ini",
  "eqa.management.programs.title": "Program PME",
  "eqa.management.results.title": "Hasil & Analisis",
  "eqa.management.samples.empty": "Tidak ada sampel PME ditemukan",
  "eqa.management.samples.subtitle": "Kelola sampel PME yang diterima dan kirim hasil",
  "eqa.management.samples.title": "Sampel PME",
  "eqa.management.status.completed": "Selesai",
  "eqa.management.status.completed.sub": "Siap untuk mengirim",
  "eqa.management.status.inProgress": "Dalam Pengerjaan",
  "eqa.management.status.inProgress.sub": "Pemeriksaan dalam pengerjaan",
  "eqa.management.status.in_progress": "Dalam Pengerjaan",
  "eqa.management.status.overdue": "Lewat tenggat",
  "eqa.management.status.pending": "Tertunda",
  "eqa.management.status.pending.sub": "Belum dimulai",
  "eqa.management.status.submitted": "Dikirim",
  "eqa.management.status.submitted.sub": "Hasil dikirim",
  "eqa.management.subtitle": "Terima dan kelola sampel PME dari penyelenggara eksternal",
  "eqa.management.title": "Pengelolaan PME",
  "eqa.management.viewPerformance": "Lihat Kinerja",
  "eqa.myProgram.helperText": "Memilih pendaftaran akan secara otomatis mengisi pemeriksan dan panel",
  "eqa.myProgram.label": "Pendaftaran Program Saya",
  "eqa.myProgram.prePopulated.subtitle": "{tests} pemeriksaan dan {panels} panel yang telah dipilih sebelumnya dari pendaftaran",
  "eqa.myProgram.prePopulated.title": "Pemeriksaan/panel terisi otomatis",
  "eqa.myProgram.select": "Memilih pendaftaran untuk mengisi pemeriksan dan panel secara otomatis...",
  "eqa.myPrograms.action.deactivate": "Nonaktifkan",
  "eqa.myPrograms.action.edit": "Sunting",
  "eqa.myPrograms.action.reactivate": "Aktifkan Ulang",
  "eqa.myPrograms.description": "Deskripsi",
  "eqa.myPrograms.enrollButton": "Daftar Program",
  "eqa.myPrograms.enrollInProgram": "Daftar Program",
  "eqa.myPrograms.labUnits": "Instalasi Lab",
  "eqa.myPrograms.panels": "Panel",
  "eqa.myPrograms.programName": "Nama Program",
  "eqa.myPrograms.provider": "Penyelenggara",
  "eqa.myPrograms.search.placeholder": "Cari program...",
  "eqa.myPrograms.status": "Status",
  "eqa.myPrograms.status.active": "Aktif",
  "eqa.myPrograms.status.inactive": "Inaktif",
  "eqa.myPrograms.subtitle": "Program yang diikuti laboratorium ini",
  "eqa.myPrograms.testMapping": "Pemetaan Pemeriksaan (Opsional)",
  "eqa.myPrograms.testMappingHint": "Pilih pemeriksaan dan panel untuk otomatis mengisi Entri Pemesanan saat program dipilih",
  "eqa.myPrograms.tests": "Pemeriksaan",
  "eqa.myPrograms.title": "Program PME Saya",
  "eqa.order.deadline": "Tenggat Hasil",
  "eqa.order.form.title": "Informasi Sampel PME",
  "eqa.order.participantId": "ID Peserta",
  "eqa.order.priority": "Prioritas PME",
  "eqa.order.programme": "Program",
  "eqa.order.provider": "Penyelenggara",
  "eqa.order.providerSampleId": "ID Sampel Penyelenggara",
  "eqa.orders.completedThisMonth": "Selesai Bulan Ini",
  "eqa.orders.enterNewTest": "Masukkan Pemeriksaan PME Baru",
  "eqa.orders.inProgress": "Dalam Pengerjaan",
  "eqa.orders.overdue": "Lewat tenggat",
  "eqa.orders.pending": "Tertunda",
  "eqa.orders.search.placeholder": "Cari berdasarkan nomor lab atau program...",
  "eqa.participant.id": "ID Peserta",
  "eqa.priority.critical": "Kritis",
  "eqa.priority.label": "Prioritas",
  "eqa.priority.standard": "Standar",
  "eqa.priority.urgent": "Mendesak",
  "eqa.program.activate": "Aktifkan",
  "eqa.program.active": "Aktif",
  "eqa.program.addProgram": "Tambah Program",
  "eqa.program.cancel": "Batal",
  "eqa.program.create": "Buat Program",
  "eqa.program.createTitle": "Buat Program PME",
  "eqa.program.deactivate": "Nonaktifkan",
  "eqa.program.description": "Deskripsi",
  "eqa.program.description.placeholder": "Deskripsi Program PME...",
  "eqa.program.edit": "Edit Program",
  "eqa.program.editTitle": "Edit Program PME",
  "eqa.program.empty": "Program PME tidak ditemukan",
  "eqa.program.inactive": "Inaktif",
  "eqa.program.label": "Program PME",
  "eqa.program.management.title": "Pengelolaan Program PME",
  "eqa.program.name": "Nama Program",
  "eqa.program.name.placeholder": "mis., Uji Profisiensi Kimia",
  "eqa.program.name.required": "Nama program wajib ada",
  "eqa.program.provider.required": "Penyelenggara wajib ada",
  "eqa.program.participantCount": "Peserta yang terdaftar",
  "eqa.program.provider": "Penyelenggara",
  "eqa.program.required": "Program PME wajib ada saat mendaftarkan sampel PME",
  "eqa.program.save": "Simpan Program",
  "eqa.program.select": "Pilih Program PME",
  "eqa.program.status": "Status",
  "eqa.program.tests": "Pemeriksaan Ditugaskan",
  "eqa.program.tests.assign": "Tugaskan Pemeriksaan",
  "eqa.program.tests.select": "Pilih pemeriksaan untuk ditugaskan",
  "eqa.provider.label": "Organisasi Penyelenggara PME",
  "eqa.provider.sampleId": "ID Sampel Penyelenggara",
  "eqa.provider.select": "Pilih Penyelenggara PME",
  "eqa.results.acceptable": "Dapat diterima",
  "eqa.results.batch.import": "Impor Batch",
  "eqa.results.col.deadline": "Tenggat",
  "eqa.results.col.labNumber": "Nomor Lab",
  "eqa.results.col.priority": "Prioritas",
  "eqa.results.col.programme": "Program",
  "eqa.results.col.provider": "Penyelenggara",
  "eqa.results.col.status": "Status",
  "eqa.results.import.confirm": "Konfirmasi Impor",
  "eqa.results.import.errors": "{count} baris ada error",
  "eqa.results.import.success": "{count} hasil berhasil diimpor",
  "eqa.results.import.upload": "Unggah file CSV",
  "eqa.results.manual.entry": "Entri Hasil Manual",
  "eqa.results.mean": "Rata-rata",
  "eqa.results.minimum.participants": "Minimal 5 peserta diperlukan untuk analisis statistik",
  "eqa.results.noResults": "Hasil pemeriksaan PME tidak ditemukan.",
  "eqa.results.organization": "Organisasi",
  "eqa.results.organization.select": "Pilih organisasi",
  "eqa.results.participant.count": "Jumlah Peserta",
  "eqa.results.performance": "Kinerja",
  "eqa.results.questionable": "Dipertanyakan",
  "eqa.results.report.downloading": "Mengunduh laporan...",
  "eqa.results.report.generate": "Buat Laporan",
  "eqa.results.search.placeholder": "Cari berdasarkan nomor lab, program, atau penyelenggara...",
  "eqa.results.standardDeviation": "Simpangan Baku",
  "eqa.results.statistics": "Statistik",
  "eqa.results.submit": "Kirim Hasil",
  "eqa.results.test": "Pemeriksaan",
  "eqa.results.test.select": "Pilih Pemeriksaan",
  "eqa.results.title": "Hasil & Analisis PME",
  "eqa.results.unacceptable": "Tidak dapat diterima",
  "eqa.results.value": "Nilai Hasil",
  "eqa.results.zscore": "Skor Z",
  "eqa.sample.badge": "PME",
  "eqa.sample.checkbox": "Sampel PME",
  "eqa.sample.checkbox.helper": "Periksa jika ini sampel Pemantapan Mutu Eksternal",
  "eqa.sample.demographics.disabled": "Demografi tidak diaktifkan untuk sampel PME",
  "eqa.sample.patient.readonly.body": "Bidang demografi pasien diatur otomatis untuk sampel PME dan tidak dapat diedit.",
  "eqa.sample.patient.readonly.title": "Sampel PME — Info Pasien Dikunci",
  "eqa.section.title": "Rincian Sampel PME",
  "eqa.status.active": "Aktif",
  "eqa.status.completed": "Selesai",
  "eqa.status.inProgress": "Dalam Pengerjaan",
  "eqa.status.inactive": "Inaktif",
  "eqa.status.inprogress": "Dalam Pengerjaan",
  "eqa.status.overdue": "Lewat tenggat",
  "eqa.status.pending": "Tertunda",
  "eqa.submission.audit": "Penyerahan Jejak Audit",
  "eqa.submission.date": "Tanggal Penyerahan",
  "eqa.submission.error": "Penyerahan gagal",
  "eqa.submission.fhir": "Kirim lewat FHIR",
  "eqa.submission.fhir.description": "Kirim hasil ke penyelenggara PME eksternal melalui FHIR R4",
  "eqa.submission.late.approve": "Setujui Penyerahan Terlambat",
  "eqa.submission.late.justification": "Justifikasi Penyerahan Terlambat",
  "eqa.submission.late.justification.placeholder": "Masukkan alasan keterlambatan penyerahan...",
  "eqa.submission.late.supervisor": "ID Pengguna Penyelia",
  "eqa.submission.late.warning": "Tenggat penyerahan sudah lewat. Wajib ada persetujuan penyelia.",
  "eqa.submission.method": "Metode Penyerahan",
  "eqa.submission.success": "Hasil berhasil diserahkan",
  "eqa.submission.title": "Penyerahan Hasil",
  "eqa.tests.action.enterResults": "Masukkan Hasil",
  "eqa.tests.action.viewOrder": "Lihat Pemesanan",
  "eqa.tests.action.viewResults": "Lihat Hasil",
  "eqa.tests.dateEntered": "Tanggal Masuk",
  "eqa.tests.deadline": "Tenggat",
  "eqa.tests.enterNew": "Masukkan Pemeriksaan PME Baru",
  "eqa.tests.labNumber": "Nomor Lab",
  "eqa.tests.orders.subtitle": "Pemesanan uji profisiensi untuk laboratorium ini",
  "eqa.tests.orders.title": "Pemesanan PME",
  "eqa.tests.priority": "Prioritas",
  "eqa.tests.program": "Program PME",
  "eqa.tests.provider": "Penyelenggara",
  "eqa.tests.searchPlaceholder": "Cari berdasarkan # registrasi, program, atau penyelenggara...",
  "eqa.tests.status": "Status",
  "eqa.tests.status.completed": "Selesai",
  "eqa.tests.status.inProgress": "Dalam Pengerjaan",
  "eqa.tests.status.overdue": "Lewat tenggat",
  "eqa.tests.status.pending": "Tertunda",
  "eqa.tests.summary.completedThisMonth": "Selesai Bulan Ini",
  "eqa.tests.summary.inProgress": "Dalam Pengerjaan",
  "eqa.tests.summary.overdue": "Lewat tenggat",
  "eqa.tests.summary.pending": "Tertunda",
  "eqa.validation.deadline.required": "Wajib ada Tenggat Pemeriksaan",
  "eqa.validation.program.required": "Wajib ada Program PME",
  "eqa.validation.provider.required": "Wajib ada Organisasi Penyelenggara PME",
  "error.add.edited.msg": "Error saat mengedit/menambah",
  "error.barcode.dimension.positive": "Dimensi label harus bilangan positif",
  "error.barcode.labelcount.default.lte.max": "Jumlah label default tidak boleh melebihi maksimum untuk jenis label ini",
  "error.delete.msg": "Error saat menghapus",
  "error.duplicate.calculationname": "Duplikasi Nama Penghitungan atau Error saat menyimpan",
  "error.fetch.boxDetails": "Gagal menarik rincian boks",
  "error.fetch.boxes": "Gagal menarik boks pengiriman",
  "error.fetch.facilities": "Gagal menarik fasilitas",
  "error.fetch.unassignedSamples": "Gagal menarik sampel yang tidak ditugaskan",
  "error.field.required": "Bidang ini diperlukan",
  "error.import.patient": "Error saat mengimpor Pasien ke sistem",
  "error.invalid.email": "Email tidak valid",
  "error.invalidcredentials": "Nama Pengguna atau Kata Kunci salah",
  "error.locale.format": "Format invalid. Gunakan: en, fr, es, atau en-US, fr-CA, dll.",
  "error.no.patient.data": "Tidak ada Data Pasien yang dapat diimpor",
  "error.nonconform.report": "Silahkan Masukkan Nilai",
  "error.report.csv.date": "Silahkan pilih jenis tanggal.",
  "error.report.csv.study": "Silahkan pilih jenis kajian.",
  "error.report.status": "Error saat membuat laporan",
  "error.report.linkIncomplete": "Tautan tidak menyebutkan {0} mana yang harus dibuka, sehingga laporan tidak dapat ditampilkan. Pilih dari daftar laporan.",
  "error.report.linkIncomplete.title": "Tautan Laporan Ini Tidak Lengkap",
  "error.required.destination": "Wajib ada lembaga tujuan",
  "error.results.loadFailed": "Daftar pekerjaan hasil tidak dapat dimuat",
  "error.results.loadFailed.detail": "Ini bukanlah daftar pekerjaan yang kosong — permintaan tersebut gagal, sehingga pekerjaan yang masih tertunda di sini tidak ditampilkan. Silakan coba lagi, dan laporkan kepada administrator jika masalah ini terus berlanjut.",
  "error.results.precision": "Pemeriksaan ini menampilkan hasil hingga {0} desimal. Masukkan nilai dengan presisi tersebut, atau nilai yang tercatat dan nilai yang ditampilkan akan berbeda.",
  "error.results.staleSave": "Hasil ini diperbarui oleh {0} di {1} — segarkan halaman untuk melihat nilai terbaru",
  "error.results.save.noResponse": "Hasil tidak disimpan karena server tidak merespons. Periksa koneksi dan coba lagi.",
  "error.order.staleSave": "Pemesanan ini telah diperbarui oleh {0} pada {1}. Muat ulang untuk melihat versi terbaru, lalu lakukan perubahan Anda lagi.",
  "error.patient.staleSave": "Pasien ini telah diperbarui oleh {0} pada {1}. Muat ulang untuk melihat versi terbaru, lalu lakukan perubahan Anda lagi.",
  "error.testCatalog.staleSave": "Pemeriksaan ini telah diperbarui oleh {0} pada {1}. Muat ulang untuk melihat versi terbaru, lalu lakukan perubahan Anda lagi.",
  "error.testCatalog.storage.invalidField": "{field}: nilai ini tidak diterima. Pilih kondisi yang tercantum, gunakan nol atau lebih untuk durasi, dan jaga teks sesuai batas panjangnya.",
  "error.staleSave.section": "Orang lain telah mengubah data ini setelah Anda membukanya. Tidak ada yang disimpan. Muat ulang untuk melihat versi terbaru, lalu lakukan perubahan Anda lagi.",
  "error.load.failed": "Daftar ini tidak dapat dimuat. Muat ulang untuk mencoba lagi.",
  "error.save.failed": "Gagal menyimpan",
  "error.save.msg": "Error saat menyimpan",
  "error.save.order": "Error saat menyimpan pemesanan",
  "error.save.patient": "Error saat menyimpan Pasien",
  "error.title": "Error",
  "errorBoundary.reload": "Muat ulang",
  "errorBoundary.route.patientResultsViewer.message": "Ada kesalahan saat menampilkan hasil pasien ini. Coba muat ulang.",
  "errorBoundary.route.patientResultsViewer.title": "Hasil pasien tidak bisa dimuat ulang",
  "errorBoundary.route.resultsSearch.message": "Ada kesalahan pada halaman hasil. Coba muat ulang.",
  "errorBoundary.route.resultsSearch.title": "Hasil tidak bisa dimuat",
  "errorBoundary.route.modifyOrder.message": "Terjadi kesalahan pada halaman modifikasi pemesanan. Muat ulang untuk mencoba lagi.",
  "errorBoundary.route.modifyOrder.title": "Modifikasi Pemesanan Tidak Dapat Dimuat",
  "errorBoundary.route.orderEntry.message": "Terjadi kesalahan pada halaman entri pemesanan. Muat ulang untuk mencoba lagi.",
  "errorBoundary.route.orderEntry.title": "Entri Pemesanan Tidak Dapat Dimuat",
  "errorBoundary.route.samplePatientEntry.message": "Ada kesalahan pada halaman entri sampel. Coba muat ulang.",
  "errorBoundary.route.samplePatientEntry.title": "Entri sampel tidak bisa dimuat",
  "errorBoundary.route.storage.message": "Ada kesalahan pada halaman ini. Coba muat ulang, atau gunakan menu untuk pindah halaman.",
  "errorBoundary.route.storage.title": "Penyimpanan tidak bisa dimuat",
  "errorBoundary.route.analyzers.message": "Ada kesalahan pada saat memuat halaman ini. Coba muat ulang.",
  "errorBoundary.route.analyzers.title": "Modul alat tidak dapat dimuat",
  "errorBoundary.route.analyzerResults.message": "Ada kesalahan pada saat memuat hasil. Coba muat ulang.",
  "errorBoundary.route.analyzerResults.title": "Hasil dari alat tidak dapat dimuat",
  "serverReconnect.title": "Tidak dapat terhubung ke server",
  "serverReconnect.retryIn": "Mencoba lagi dalam {seconds} dtk",
  "serverReconnect.trying": "Mencoba lagi sekarang…",
  "serverReconnect.tryNow": "Coba sekarang",
  "errors.no.sample": "Pilih sampel yang sesuai untuk setiap pemeriksaan.",
  "errors.requester.org.or.requestor.required": "Masukkan minimal salah satu dari Organisasi Pemohon atau kontak Pemohon.",
  "esig.button.certify": "Sertifikasi & Lanjut",
  "esig.button.reject": "Tolak",
  "esig.button.saveAndSign": "Simpan",
  "esig.button.saveModification": "Simpan",
  "esig.button.sign": "Tanda tangan",
  "esig.button.validate": "Validasi",
  "esig.certification.acknowledge": "Saya sudah membaca dan mengerti pernyataan di atas",
  "esig.certification.intro": "Sebelum menggunakan tanda tangan elektronik, Anda harus menyatakan bahwa tanda tangan elektronik Anda setara dengan tanda tangan tertulis yang sah secara hukum.",
  "esig.error.disabled": "Tanda tangan elektronik tidak diaktifkan",
  "esig.error.generic": "Terjadi error",
  "esig.error.invalidCredentials": "Kredensial invalid",
  "esig.error.keycloakNotSupported": "Keycloak authentication belum tersedia untuk tanda tangan elektronik",
  "esig.error.loadingStatus": "Gagal memuat status tanda tangan",
  "esig.error.mustAcknowledge": "Anda harus menyetujui pernyataan sertifikasi",
  "esig.error.passwordRequired": "Kata kunci diperlukan",
  "esig.error.rejectionReasonRequired": "Wajib ada alasan penolakan",
  "esig.error.title": "Error",
  "esig.error.usernameRequired": "Nama pengguna diperlukan",
  "esig.info.fullAuth": "Ini adalah tanda tangan pertama Anda untuk sesi ini. Masukkan nama pengguna dan kata kunci Anda untuk mengotentikasi.",
  "esig.info.legalBinding": "Dengan memasukkan kredensial, Anda membuat tanda tangan elektronik yang mengikat secara hukum berdasarkan 21 CFR Part 11.",
  "esig.info.passwordOnly": "Anda memiliki sesi tanda tangan aktif. Masukkan kata kunci untuk melanjutkan.",
  "esig.label.context": "Aksi:",
  "esig.label.meaning": "Arti Tanda Tangan:",
  "esig.label.password": "Kata kunci",
  "esig.label.rejectionReason": "Alasan Penolakan",
  "esig.label.signingAs": "Menandatangani sebagai: {userName}",
  "esig.label.username": "Nama pengguna",
  "esig.meaning.authored": "Dibuat oleh",
  "esig.meaning.modified": "Dimodifikasi",
  "esig.meaning.rejected": "Ditolak",
  "esig.meaning.validatedAndReleased": "Divalidasi dan Diterbitkan",
  "esig.placeholder.password": "Masukkan kata kunci untuk mengkonfirmasi",
  "esig.placeholder.rejectionReason": "Masukkan alasan penolakan",
  "esig.placeholder.username": "Masukkan nama pengguna Anda",
  "esig.title.certification": "Sertifikasi Tanda Tangan Elektronik",
  "esig.title.signature": "Tanda Tangan Elektronik",
  "example": "Contoh",
  "external.id": "Identitas Eksternal",
  "external.referrals.report": "Laporan Rujukan Eksternal",
  "externalReferredOutTests.title": "Laporan Rujukan Eksternal",
  "externalconnections.active": "Aktif",
  "externalconnections.add.title": "Tambah Koneksi Eksternal",
  "externalconnections.authtype": "Tipe Otentikasi",
  "externalconnections.authtype.basic.password": "Kata kunci",
  "externalconnections.authtype.basic.username": "Nama pengguna",
  "externalconnections.browse.title": "Koneksi Eksternal",
  "externalconnections.deactivate.success": "Koneksi eksternal berhasil dinonaktifkan.",
  "externalconnections.description": "Deskripsi",
  "externalconnections.edit.title": "Edit Koneksi Eksternal",
  "externalconnections.name": "Nama",
  "externalconnections.name.placeholder": "Masukkan nama koneksi",
  "externalconnections.programmedconnection": "Tipe Koneksi",
  "externalconnections.save.success": "Koneksi eksternal berhasil disimpan.",
  "externalconnections.search": "Cari koneksi eksternal",
  "externalconnections.search.placeholder": "Cari berdasarkan nama atau tipe",
  "externalconnections.select": "Pilih",
  "externalconnections.uri": "URI",
  "externalconnections.uri.placeholder": "mis. https://server:port",
  "false.label": "Salah",
  "field.active": "Aktif/Tidak Aktif",
  "field.ageRange": "Rentang Umur",
  "field.dictionaryValues": "Nilai Kamus",
  "field.loinc": "LOINC",
  "field.name": "Nama",
  "field.normalRange": "Rentang normal",
  "field.note": "Catatan",
  "field.orderable": "Permintaan dapat/tidak dapat dilakukan",
  "field.panel": "Panel",
  "field.referenceValue": "Nilai referensi",
  "field.reportName": "Nama Laporan",
  "field.resultLimits": "Batas hasil",
  "field.resultType": "Jenis hasil",
  "field.sampleType": "Jenis sampel",
  "field.select.testSection": "Pilih Bagian Pemeriksaan",
  "field.selectValues": "Pilih nilai",
  "field.sex": "Jenis kelamin",
  "field.significantDigits": "Digit signifikan",
  "field.testSection": "Bagian pemeriksaan",
  "field.testUnit": "Instalasi Lab",
  "field.uom": "Satuan pengukuran",
  "field.validRange": "Rentang valid",
  "file.import.configuration.active": "Aktif",
  "file.import.configuration.analyzer": "Alat",
  "file.import.configuration.analyzer.emptyState": "Tidak ada plugin impor file yang diinstal",
  "file.import.configuration.analyzer.placeholder": "Pilih Alat",
  "file.import.configuration.cancel": "Batal",
  "file.import.configuration.columnMappings": "Pemetaan Kolom",
  "file.import.configuration.columnMappings.helperText": "Pemetaan JSON untuk kolom CSV ke bidang SILNAS (misalnya, {\"Sample_ID\": \"sampleId\", \"Result\": \"result\"})",
  "file.import.configuration.delimiter": "Pemisah",
  "file.import.configuration.delimiter.helperText": "Karakter delimiter CSV (default: koma)",
  "file.import.configuration.error.save": "Gagal menyimpan konfigurasi impor file",
  "file.import.configuration.error.unknown": "Terjadi error yang tidak diketahui",
  "file.import.configuration.fileFormat": "Format File",
  "file.import.configuration.fileFormat.placeholder": "Pilih format file",
  "file.import.configuration.filePattern": "Pola File",
  "file.import.configuration.filePattern.helperText": "Pola glob untuk file yang cocok (misalnya, *.csv, results_*.txt)",
  "file.import.configuration.hasHeader": "Baris yang memiliki Header",
  "file.import.configuration.importDirectory": "Direktori Impor",
  "file.import.configuration.importDirectory.helperText": "Direktori untuk melihat file baru",
  "file.import.configuration.importDirectory.placeholder": "/data/import",
  "file.import.configuration.save": "Simpan",
  "file.import.configuration.success.created": "Konfigurasi impor file berhasil dibuat",
  "file.import.configuration.success.updated": "Konfigurasi impor file berhasil diperbarui",
  "file.import.configuration.title.add": "Tambah Konfigurasi Impor File",
  "file.import.configuration.title.edit": "Edit Konfigurasi Impor File",
  "file.import.configuration.validation.analyzerId.required": "Alat wajib ada",
  "file.import.configuration.validation.columnMappings.invalid": "Format JSON invalid untuk pemetaan kolom",
  "file.import.configuration.validation.importDirectory.required": "Direktori impor wajib ada",
  "fileImport.format.csv": "CSV",
  "fileImport.format.excel": "Excel",
  "fileImport.format.tsv": "TSV",
  "filters.label": "Filter",
  "freezer.alert.detail.acknowledge": "Mengetahui",
  "freezer.alert.detail.acknowledgedAt": "Diketahui Pada",
  "freezer.alert.detail.acknowledgedBy": "DIketahui Oleh",
  "freezer.alert.detail.acknowledgmentNotes": "Catatan Konfirmasi",
  "freezer.alert.detail.actions": "Aksi yang Telah Dilakukan",
  "freezer.alert.detail.close": "Tutup",
  "freezer.alert.detail.correctiveAction": "Tindakan Perbaikan",
  "freezer.alert.detail.correctiveActionDescription": "Deskripsi",
  "freezer.alert.detail.correctiveActionFailed": "Gagal mencatat Tindakan Perbaikan",
  "freezer.alert.detail.correctiveActionType": "Jenis tindakan",
  "freezer.alert.detail.delete": "Hapus Peringatan",
  "freezer.alert.detail.deleteConfirm": "Apakah Anda ingin menghapus peringatan ini secara permanen?",
  "freezer.alert.detail.deleteFailed": "Gagal menghapus peringatan",
  "freezer.alert.detail.deletePermanently": "Hapus secara permanen",
  "freezer.alert.detail.deleteWarning": "Waktu Mulai, tingkat keparahan, konfirmasi, dan catatan dihapus tanpa jejak audit dan tidak dapat dipulihkan.",
  "freezer.alert.detail.freezer": "Freezer",
  "freezer.alert.detail.id": "ID Peringatan",
  "freezer.alert.detail.logCorrectiveAction": "Catat tindakan perbaikan",
  "freezer.alert.detail.message": "Pesan",
  "freezer.alert.detail.method": "Metode",
  "freezer.alert.detail.notes": "Catatan",
  "freezer.alert.detail.notesPlaceholder": "Tambah catatan mengenai peringatan ini...",
  "freezer.alert.detail.notifications": "Notifikasi Terkirim",
  "freezer.alert.detail.overview": "Gambaran Umum Peringatan",
  "freezer.alert.detail.recipient": "Penerima",
  "freezer.alert.detail.resolutionNotes": "Catatan Pemecahan Masalah",
  "freezer.alert.detail.resolve": "Selesaikan",
  "freezer.alert.detail.resolvedAt": "Diselesaikan Pada",
  "freezer.alert.detail.resolvedBy": "Diselesaikan Oleh",
  "freezer.alert.detail.sentAt": "Terkirim pada",
  "freezer.alert.detail.severity": "Keparahan",
  "freezer.alert.detail.startTime": "Waktu Mulai",
  "freezer.alert.detail.status": "Status",
  "freezer.alert.detail.summary": "Ringkasan",
  "freezer.alert.detail.takenAt": "Diambil pada",
  "freezer.alert.detail.takenBy": "Diambil oleh",
  "freezer.alert.detail.title": "Rincian Peringatan",
  "freezer.alert.severity.critical": "Kritis",
  "freezer.alert.severity.warning": "Peringatan",
  "freezer.alert.status.acknowledged": "Sudah diketahui",
  "freezer.alert.status.closed": "Ditutup",
  "freezer.alert.status.escalated": "Dieskalasi",
  "freezer.alert.status.open": "Buka",
  "freezer.alert.status.resolved": "Selesai",
  "freezer.nav.corrective": "Tindakan Perbaikan",
  "freezer.nav.corrective.tooltip": "Kelola tindakan perbaikan",
  "freezer.nav.dashboard": "Dasbor",
  "freezer.nav.dashboard.tooltip": "Lihat dasbor pemantauan penyimpanan dingin",
  "freezer.nav.reports": "Laporan",
  "freezer.nav.reports.tooltip": "Membuat laporan penyimpanan dingin",
  "freezer.nav.settings": "Pengaturan",
  "freezer.nav.settings.tooltip": "Konfigurasi pengaturan penyimpanan dingin",
  "freezer.nav.trends": "Tren Historis",
  "freezer.nav.trends.tooltip": "Lihat tren suhu berdasarkan waktu",
  "french.current": "PERANCIS saat ini",
  "french.label": "Perancis",
  "from.title": "Dari",
  "genericSample.edit.success": "Sample berhasil diperbarui",
  "genericSample.edit.success.accession": "Nomor Registrasi: {accessionNumber}",
  "genericSample.edit.title": "Edit Sampel",
  "genericSample.field.by": "Oleh",
  "genericSample.field.count": "#",
  "genericSample.field.date": "Tanggal",
  "genericSample.field.from": "Dari",
  "genericSample.field.id": "Identitas",
  "genericSample.field.labPersonReceived": "Diterima petugas lab",
  "genericSample.field.project": "Proyek",
  "genericSample.field.storageLocation": "# Freezer penyimpanan dan lokasi",
  "genericSample.field.type": "Jenis",
  "genericSample.notebook.selection.title": "Pemilihan Proyek (Opsional)",
  "genericSample.order.error.labNoRequired": "Mohon membuat Nomor Registrasi sebelum menyimpan.",
  "genericSample.order.generateLabNo": "Membuat Nomor Registrasi",
  "genericSample.order.labNo.placeholder": "Klik untuk \"Membuat Nomor Registrasi\"",
  "genericSample.order.success.details": "Rincian Sampel",
  "genericSample.order.success.message": "Pemesanan sampel berhasil dibuat dengan nomor registrasi: {accessionNumber}",
  "genericSample.order.title": "Penerimaan Sampel",
  "gps.accuracy.display": "±{accuracy}m akurasi",
  "gps.accuracy.warning.message": "Akurasi GPS {accuracy}m, melebihi ambang batas wajib {required}m. Mohon mengambil lokasi lagi dengan mengubah posisi.",
  "gps.accuracy.warning.title": "Peringatan Akurasi GPS",
  "gps.button.clear": "Kosongkan",
  "gps.button.getting.location": "Mengambil Lokasi...",
  "gps.button.location.captured": "Lokasi Diambil",
  "gps.button.use.my.location": "Gunakan Lokasi Saya",
  "gps.collapse": "Ciutkan bagian GPS",
  "gps.config.accuracy.helper": "Maksimum akurasi GPS yang dapat diterima dalam meter. Atur ke 0 untuk menginaktifkan pemeriksaan akurasi.",
  "gps.config.accuracy.label": "Akurasi yang diperlukan (meter)",
  "gps.config.enabled.description": "Jika diaktifkan, bidang koordinat GPS akan muncul di alur kerja Entri Pesanan untuk menarik lokasi pengambilan sampel.",
  "gps.config.enabled.label": "Aktifkan Koordinat GPS",
  "gps.config.error.load": "Gagal memuat konfigurasi GPS",
  "gps.config.save.error": "Gagal menyimpan konfigurasi GPS",
  "gps.config.save.success": "Konfigurasi GPS berhasil disimpan",
  "gps.config.saving": "Menyimpan...",
  "gps.config.section.general": "Pengaturan GPS",
  "gps.config.timeout.helper": "Waktu maksimum untuk menunggu lokasi GPS dalam detik.",
  "gps.config.timeout.label": "Waktu habis (detik)",
  "gps.config.title": "Konfigurasi Koordinat GPS",
  "gps.config.unsaved.changes": "Anda memiliki perubahan belum tersimpan. Apakah Anda yakin untuk menutup?",
  "gps.config.unsaved.subtitle": "Ingat untuk menyimpan perubahan sebelum meninggalkan halaman.",
  "gps.config.unsaved.title": "Perubahan Tidak Tersimpan",
  "gps.config.validation.accuracy.negative": "Akurasi wajib tidak boleh negatif",
  "gps.config.validation.accuracy.too.high": "Akurasi wajib tidak boleh lebih dari 10.000 meter",
  "gps.config.validation.timeout.too.high": "Waktu habis tidak boleh lebih dari 120 detik",
  "gps.config.validation.timeout.too.low": "Waktu habis harus setidaknya 1 detik",
  "gps.coordinates.captured.via": "Diambil dengan {method}",
  "gps.coordinates.current": "Koordinat saat ini",
  "gps.error.not.supported": "GPS tidak didukung dengan peramban ini",
  "gps.error.permission.denied": "Akses GPS ditolak. Mohon mengaktifkan izin lokasi dan coba lagi.",
  "gps.error.position.unavailable": "Lokasi GPS tidak tersedia. Mohon periksa pengaturan lokasi perangkat Anda.",
  "gps.error.timeout": "Waktu permintaan GPS habis. Silahkan coba lagi.",
  "gps.error.title": "Error GPS",
  "gps.error.unknown": "Terjadi error GPS yang tidak diketahui. Mohon coba lagi.",
  "gps.info.description": "Koordinat GPS merekam lokasi geografis lokasi sampel, untuk mendukung surveilans epidemiologi dan pemetaan penyakit.",
  "gps.info.title": "Koordinat GPS",
  "gps.latitude.helper": "Derajat Utara (+) atau Selatan (-), antara -90 dan 90",
  "gps.latitude.invalid": "Garis lintang harus di antara -90 dan 90 derajat",
  "gps.latitude.label": "Garis Lintang",
  "gps.latitude.placeholder": "misalnya, -1.286389",
  "gps.longitude.helper": "Derajat Timur (+) atau Barat (-), antara -180 dan 180",
  "gps.longitude.invalid": "Garis bujur harus di antara -180 dan 180 derajat",
  "gps.longitude.label": "Garis bujur",
  "gps.longitude.placeholder": "misalnya, 36.817223",
  "gps.manual.entry.off": "Matikan",
  "gps.manual.entry.on": "Nyalakan",
  "gps.manual.entry.title": "Masukkan koordinat manual",
  "gps.manual.entry.toggle": "Entri koordinat manual",
  "gps.not.captured": "Tidak tertangkap",
  "gps.section.description": "Menangkap lokasi geografis pengambilan sampel untuk pelacakan epidemiologi",
  "gps.section.title": "Lokasi Pengambilan (GPS)",
  "gps.status.captured": "Ditangkap",
  "gps.status.optional": "Opsional",
  "gps.tile.collapse": "Ciutkan bagian GPS",
  "gps.tile.expand": "Kembangkan untuk menambah koordinat GPS",
  "gps.warning.partial.coordinates": "Garis lintang dan garis bujur harus menunjukkan lokasi valid.",
  "header.ID": "Identitas",
  "header.assign": "Menugaskan",
  "header.cancel.test": "Membatalkan Pemeriksaan",
  "header.formname": "Nama Formulir",
  "header.icon.help": "Bantuan",
  "header.icon.lang": "Bahasa",
  "header.icon.menu.close": "Tutup menu",
  "header.icon.menu.open": "Buka menu",
  "header.icon.menu.pin": "Sematkan menu",
  "header.icon.menu.unpin": "Lepaskan penandaan menu",
  "header.icon.notifications": "Notifikasi",
  "header.icon.search": "Cari",
  "header.icon.user": "Pengguna",
  "header.label.ARV": "ARV-awal",
  "header.label.EID": "Diagnosis anak-anak dengan DBS-PCR",
  "header.label.changeLab": "Pilih Lab",
  "header.label.followup": "ARV-Tindak-lanjut",
  "header.label.intialFollowup": "ARV-->Awal-TindakLanjut-VL",
  "header.label.logout": "Keluar",
  "header.label.nonconformityByDate": "Laporan Ketidaksesuaian berdasarkan Tanggal",
  "header.label.selectLab": "Pilih Lab",
  "header.label.selectlocale": "Pilih Lokal",
  "header.label.specialRequest": "Permintaan khusus",
  "header.label.study.ciexport": "Ekspor file CSV berdasarkan Tanggal",
  "header.label.study.vlloadtrends": "Laporan Ekspor Data Viral Load",
  "header.label.version": "Versi:",
  "header.reject": "Tolak",
  "header.rejection.reason": "Alasan penolakan",
  "header.results.recorded": "Hasil terekam",
  "hide.aliquoting": "Sembunyikan pengalikuotan",
  "holder.choose.availabletest": "Pilih Pemeriksaan yang tersedia",
  "home.dashboard.title": "Dasbor",
  "home.label": "Beranda",
  "immunohistochemistry.label.addreport": "Tambah Laporan",
  "immunohistochemistry.label.averageChrom": "Rerata Sinyal Kromosom 17 per nukleus",
  "immunohistochemistry.label.averageHer2": "Rerata HER2 per nukleus",
  "immunohistochemistry.label.cellIntensity": "Intensitas. Skor Allred",
  "immunohistochemistry.label.cellPercent": "% sel yang menujukkan pewarnaan nukleus dengan",
  "immunohistochemistry.label.dashboard": "Dasbor Imunohistokimia",
  "immunohistochemistry.label.her2Assesment": "Penilaian protein HER2 adalah",
  "immunohistochemistry.label.her2Pattern": "Pola pewarnaan CerbB2/HER2",
  "immunohistochemistry.label.her2ScoreOf": "dengan skor",
  "immunohistochemistry.label.historicalDiagnosis": "Diagnosis histologis",
  "immunohistochemistry.label.ihcRatio": "Rasio Sinyal HER2/Neu terhadap Kromosom 17",
  "immunohistochemistry.label.ihcScore": "IHK (Skor Cerb2)",
  "immunohistochemistry.label.mibName": " MiB 1(ki-67) (Indeks Proliferatif): ",
  "immunohistochemistry.label.molecularType": "Subtipe Molekuler",
  "immunohistochemistry.label.numberOfCancer": "Jumlah Nukleus Kanker",
  "immunohistochemistry.label.outOf8": "dari 8",
  "immunohistochemistry.label.report": "Laporan",
  "immunohistochemistry.label.reports": "Laporan",
  "immunohistochemistry.label.review": "Menunggu Tinjauan Imunohistokimia",
  "immunohistochemistry.label.title": "Imunohistokimia",
  "immunohistochemistry.label.tumorCells": "dari positif sel tumor (cut off 20%)",
  "immunohistochemistry.status.completed": "Selesai",
  "immunohistochemistry.status.inProgress": "Dalam Pengerjaan",
  "immunohistochemistry.status.readyPathologist": "Siap untuk Ahli Patologi",
  "import.autoGenerated": "Dibuat secara otomatis",
  "import.created": "Dibuat",
  "import.error.failed": "Impor gagal",
  "import.error.importFile": "Gagal mengimpor file",
  "import.error.selectFile": "Pilih file terlebih dahulu",
  "import.error.validateFile": "Gagal memvalidasi file",
  "import.error.validateFirst": "Silahkan validasi file terlebih dahulu dan perbaiki kesalahan yang ada",
  "import.error.validationFailed": "Validasi gagal. Silahkan periksa kesalahan di bawah.",
  "import.failed": "Impor Gagal",
  "import.failedCount": "Gagal",
  "import.header.collectionDate": "Tanggal Pengambilan",
  "import.header.errorMessage": "Pesan Kesalahan",
  "import.header.field": "Bidang",
  "import.header.from": "Dari",
  "import.header.labNo": "No Registrasi",
  "import.header.quantity": "Kuantitas",
  "import.header.row": "Baris",
  "import.header.sampleType": "Jenis Sampel",
  "import.header.samplesToCreate": "Sampel yang akan dibuat",
  "import.importing": "Mengimpor...",
  "import.invalidRows": "Baris Invalid",
  "import.selectFile": "Pilih file",
  "import.status.invalid": "Tidak valid",
  "import.status.valid": "Valid",
  "import.success": "Impor Berhasil",
  "import.totalRows": "Baris total",
  "import.totalSamplesToCreate": "Total Sampel yang akan Dibuat",
  "import.uploadFile": "Unggah file",
  "import.uploadFileDesc": "Unggah file CSV atau Excel ({types})",
  "import.validRows": "Baris Valid",
  "import.validating": "Memvalidasi...",
  "import.validationStatus": "Status Validasi",
  "input.error.same.panel.type": "Jenis panel yang ada dengan nama yang sama ditemukan. Batalkan atau gunakan nama lain.",
  "input.placeholder.labNo": "Masukkan Nomor Registrasi",
  "input.placeholder.patientFirstName": "Masukkan Nama Depan Pasien",
  "input.placeholder.patientId": "Masukkan Identitas Pasien",
  "input.placeholder.patientLastName": "Masukkan Nama Belakang Pasien",
  "input.placeholder.prevLabNumber": "Masukkan Nomor Registrasi Sebelumnya",
  "input.placeholder.providerEmail": "Masukkan Email Pemohon",
  "input.placeholder.providerFax": "Masukkan Nomor Faks Pemohon",
  "input.placeholder.providerWorkPhone": "Masukkan Nomor Telepon Pemohon",
  "input.placeholder.provisionalClinicalDiagnosis": "Masukkan Diagnosis Klinis Sementara",
  "input.placeholder.requesterFirstName": "Masukkan Nama Depan Pemohon",
  "input.placeholder.requesterLastName": "Masukkan Nama Belakang Pemohon",
  "input.placeholder.searchTestName": "Cari Nama Pemeriksaan di sini",
  "input.placeholder.selectPanel": "Pilih Jenis Panel",
  "input.placeholder.selectPriority": "Pilih Prioritas",
  "input.placeholder.selectTest": "Pilih Jenis Pemeriksaan",
  "input.placeholder.selectTestSection": "Pilih Jenis Unit",
  "instructions.copy.labnum": "Salin Nomor Registrasi ",
  "instructions.order.entry.eqa.enabled": "Bila aktif, akan ada kotak centang di layar Entri Pemesanan, dan petugas dapat menandai sampel sebagai sampel PME (Pemantapan Mutu Eksternal). Demografi pasien akan otomatis terisi dengan N/A dan dikunci.",
  "instructions.order.entry.requester": "Jika diaktifkan, kolom \"Cari Pemohon\", \"Nama Depan Pemohon\", dan \"Nama Belakang Pemohon\" akan menjadi kolom yang wajib diisi pada layar \"Tambah Pemesanan\". Jika dinonaktifkan (pengaturan default), ketiga kolom tersebut bersifat opsional.",
  "instructions.test.activation": "Pemeriksaan Aktif: kotak centang menunjukkan pemeriksaan yang sudah aktif. Untuk mengaktifkan pemeriksaan, centang kotak; untuk menonaktifkan, hapus centang. Semua jenis sampel tanpa pemeriksaan aktif akan dinonaktifkan dan muncul di bagian bawah, di bawah 'Jenis Sampel Tidak Aktif'. Jika salah satu pemeriksaan diaktifkan, jenis sampel tersebut akan diaktifkan.",
  "instructions.test.activation.confirm": "Verifikasi perubahan yang akan dibuat. Simpan jika sudah benar. Gunakan tombol kembali untuk memperbaiki perubahan.",
  "instructions.test.activation.sort": "Urutan tampilan: Daftar jenis sampel yang mempunyai pemeriksaan yang baru diaktivasi. Sortir pemeriksaan untuk mengatur tampilan di layar entri permintaan. Sortir dilakukan dengan menyeret ke posisi yang diinginkan",
  "instructions.test.order": "Permintaan dapat dilakukan untuk pemeriksaan yang dicentang. Ubah tanda centang untuk mengubah status. Agar permintaan pemeriksan dapat dilakukan, pemeriksaan tersebut harus aktif dan dapat dipesan. Pemeriskaan yang aktif tetapi tidak dapat dipesan dapat diminta sebagai bagian dari pemeriksaan refleks.",
  "invalid.json": "JSON tidak valid",
  "inventory.add.button": "Tambah Lot Baru",
  "inventory.addItem.button": "Tambah Barang Katalog",
  "inventory.consume.error.noLots": "Tidak ada stok tersedia untuk {name} ({code})",
  "inventory.consume.error.noLotsAwaitingQc": "Tidak ada stok yang lolos QC untuk {name} ({code}): {count} lot dengan stok sedang menunggu QC. Tandai QC sebagai lolos untuk menggunakannya.",
  "inventory.consume.error.noLotsQcFailed": "Tidak ada stok yang dapat digunakan untuk {name} ({code}): {count} lot dengan stok gagal QC",
  "inventory.consume.error.noLotsQuarantined": "Tidak ada stok yang dapat digunakan untuk {name} ({code}): {count} lot dengan stok sedang dikarantina",
  "inventory.dashboard.title": "Dasbor Inventaris",
  "inventory.export.button": "Ekspor",
  "inventory.filter.all": "Semua",
  "inventory.filter.status": "Filter berdasarkan Status",
  "inventory.item.error.duplicateCode": "Barang inventaris dengan kode \"{code}\" sudah ada.",
  "inventory.item.error.codeGenerationExhausted": "Tidak dapat menemukan kode yang tersedia untuk prefiks \"{prefix}\". Masukkan kode secara manual.",
  "inventory.list.title": "Barang Inventaris",
  "inventory.lot.error.duplicateBarcode": "Kode QR \"{barcode}\" sudah ditetapkan ke lot {lotNumber}",
  "inventory.lot.search.placeholder": "Cari berdasarkan nama barang, nomor lot, atau kode QR",
  "inventory.metrics.expired": "Kedaluwarsa",
  "inventory.metrics.expiringSoon": "Segera Kedaluwarsa",
  "inventory.metrics.lowStock": "Stok Sedikit",
  "inventory.metrics.totalLots": "Lot Total",
  "inventory.tab.catalog": "Katalog",
  "inventory.tab.dashboard": "Dasbor",
  "inventory.tab.reports": "Laporan",
  "inventory.title": "Pengelolaan Inventaris",
  "label.action": "Aksi",
  "labNumber.format.current": "Format saat ini",
  "labNumber.format.new": "Format baru",
  "labNumber.prefix": "Prefiks",
  "labNumber.type": "Jenis Nomor Registrasi ",
  "labNumber.usePrefix": "Gunakan prefiks",
  "label.actions": "Aksi",
  "label.active": "Aktif",
  "label.actualTestName": "Nama pemeriksaan aktual",
  "label.add": "Tambah",
  "label.add.notification": "Tambah notifikasi pop up ke pengguna",
  "label.all": "Semua",
  "label.analysisNotStarted": "Analisis belum dimulai",
  "label.any": "Apa saja",
  "label.audittrail": "No Registrasi",
  "label.audittrail.Reports": "Laporan Jejak Audit",
  "label.audittrail.labNo.invalidaccessionnumber": "Nomor Registrasi Invalid",
  "label.audittrail.labNo.missing": "Perlu No Registrasi!",
  "label.audittrailreport.nextvisitdate": "Tanggal Kunjungan Berikutnya",
  "label.audittrailreport.priority": "Prioritas",
  "label.audittrailreport.program": "Program",
  "label.audittrailreport.receiveddate": "Tanggal Diterima",
  "label.audittrailreport.requestdate": "Tanggal Permintaan",
  "label.audittrailreport.requester": "Pemohon",
  "label.audittrailreport.requester.firstname": "Nama Depan Pemohon",
  "label.audittrailreport.requester.lastname": "Nama Belakang Pemohon",
  "label.audittrailreport.sitename": "Nama Tempat",
  "label.autoFilledFromServer": "Auto terisi dari server",
  "label.barcode": "Kode QR",
  "label.barcode.labelsets": "Jumlah Set Label",
  "label.barcode.orderlabel": "Jumlah Label yang dipesan per set",
  "label.barcode.specimenlabel": "Jumlah label spesimen per set",
  "label.barcode.totallabel": "Jumlah label untuk dicetak",
  "label.button.action": "Aksi",
  "label.button.add": "Tambah",
  "label.button.add.question": "Tambah pertanyaan baru",
  "label.button.cancel": "Batal",
  "label.button.close": "Tutup",
  "label.button.changepassword": "Ganti Kata Kunci",
  "label.button.clear": "Kosongkan",
  "label.button.confirm": "Konfirmasi",
  "label.button.confirmAction": "Konfirmasi aksi",
  "label.button.confirmDelete": "Konfirmasi hapus",
  "label.button.confirmTitle": "Apakah Anda yakin?",
  "label.button.delete": "Hapus",
  "label.button.descritpion": "Deskripsi",
  "label.button.edit": "Edit",
  "label.button.activate": "Aktifkan",
  "label.button.deactivate": "Nonaktifkan",
  "label.button.exit": "Keluar",
  "label.button.externalsearch": "Pencarian Eksternal",
  "label.button.field": "Bidang",
  "label.button.finish": "Selesai",
  "label.button.finished": "Selesai",
  "label.button.generatePrintableVersion": "Buat versi cetak",
  "label.button.import": "Impor",
  "label.button.login": "Masuk",
  "label.button.login.sso": "Single Sign-On (SSO)",
  "label.button.newEntry": "Entri baru",
  "label.button.ok": "Oke",
  "label.button.previous": "Sebelumnya",
  "label.button.range": "Rentang",
  "label.button.remove": "Hapus",
  "label.button.remove.report": "Hapus Laporan",
  "label.button.remove.slide": "Hapus slide",
  "label.button.reset": "Atur Ulang",
  "label.button.sample": "Sampel",
  "label.button.save": "Simpan",
  "label.button.saveconfig": "SImpan Konfigurasi",
  "label.button.search": "Cari",
  "label.button.select": "Pilih",
  "label.button.select.pathologist": "Pilih Ahli Patologi",
  "label.button.select.status": "Pilih Status",
  "label.button.select.technician": "Pilih Petugas",
  "label.button.select.test": "Pilih Pemeriksaan",
  "label.button.start": "Mulai",
  "label.button.submit": "Kirim",
  "label.button.update": "Perbarui",
  "label.button.uploadfile": "Unggah file",
  "label.button.validate": "Validasi",
  "label.button.viewReport": "Lihat Laporan",
  "label.cancel": "Batal",
  "label.cancel.test.no.replace": "Batalkan pemeriksaan untuk nomor registrasi terpilih, jangan menugaskan pemeriksaan baru",
  "label.checkedWillBeModified": "No Lab yang dicentang akan dimodifikasi",
  "label.clear": "Hapus filter",
  "label.content": "Konten Label",
  "label.confirm": "Konfirmasi",
  "label.created.samples": "Sampel yang Dibuat",
  "label.critical.range": "Rentang kritis",
  "label.currentTest": "Pemeriksaan saat ini",
  "label.days": "hari",
  "label.default.result": "Hasil default",
  "label.delete": "Hapus",
  "label.description": "Deskripsi",
  "label.edit": "Edit",
  "label.electronic.orders": "Permintaan elektronik",
  "label.equals": "sama dengan",
  "label.error": "Kesalahan",
  "label.existing.methods": "Metode yang ada",
  "label.existing.test.sets": "Set pemeriksaan yang ada",
  "label.filters.mycases": "Kasus saya",
  "label.filters.status": "Status",
  "label.field.required": "Bidang ini diperlukan",
  "label.status": "Status",
  "label.form.searchby": "Cari berdasarkan",
  "label.id": "ID",
  "label.import.errors": "Error saat Impor",
  "label.inactive": "Inaktif",
  "label.inactive.methods": "Metode inaktif. Tugaskan pemeriksaan untuk mengaktivasi",
  "label.includeInactiveTests": "Sertakan pemeriksaan inaktif",
  "label.inside.normalrange": "adalah dalam rentang normal",
  "label.lastPrinted": "Pencetakan terakhir: {date} {time} oleh {user}",
  "label.loading": "Memuat...",
  "label.required": "wajib",
  "label.loinc": "LOINC",
  "label.management.title": "Pengelolaan Label",
  "label.no": "Tidak",
  "label.no.options.available": "Tidak ada opsi tersedia",
  "label.none": "Kosong (tidak ada filter)",
  "label.notValidated": "Tidak tervalidasi",
  "label.notequals": "tidak sama dengan",
  "label.order.labNrPrefix": "No Registrasi",
  "label.order.patientPrefix": "Pasien",
  "label.order.scan.text": "Pindai ATAU masukkan manual ATAU",
  "label.orderable": "Dapat dipesan",
  "label.outside.normalrange": "adalah di luar rentang normal",
  "label.page.patientHistory": "Riwayat Pasien",
  "label.preview.data": "Pratinjau Data",
  "label.print": "Cetak Label",
  "label.print.error": "Error saat membuat label. Silahkan coba lagi.",
  "label.print.error.popupBlocked": "Popup diblokir. Izinkan popup untuk situs ini agar dapat mencetak label.",
  "label.print.openDirectly": "Buka label di tab baru",
  "label.print.generating": "Membuat...",
  "label.print.success": "Pencetakan label berhasil",
  "label.print.description": "Cetak label untuk pemesanan dan sampel",
  "label.print.helper": "Pilih jenis dan kuantitas label untuk dicetak",
  "label.print.success.count": "{count} label berhasil dicetak",
  "label.print.title": "Cetak label",
  "label.printAll": "Cetak Semua Label",
  "label.printAll.success": "Semua label berhasil dicetak",
  "label.printConfirmation.message": "Cetak label untuk {name}{code}?",
  "label.printConfirmation.title": "Cetak Label",
  "label.printHistory": "Cetak Riwayat",
  "label.printHistory.byUser": "Oleh {user}",
  "label.printHistory.count": "{count} label",
  "label.printHistory.loading": "Memuat riwayat cetak...",
  "label.printHistory.never": "Belum pernah dicetak",
  "label.printHistory.unknownUser": "Tidak diketahui",
  "label.printHistory.viewAll": "Lihat Riwayat",
  "label.printLabel": "Cetak Label",
  "label.program": "Program",
  "label.qualifiers": "Pengkualifikasi",
  "label.quantity": "Kuantitas",
  "label.readonly": "Hanya Baca",
  "label.reference.value": "Nilai referensi",
  "label.refertest.referencelab": "Rujuk ke lab rujukan",
  "label.rejectedByBiologist": "Ditolak oleh ahli biologi",
  "label.rejectedByTechnician": "Ditolak oleh petugas",
  "label.remove": "Hapus",
  "label.replaceWith": "Ganti dengan",
  "label.report.byNationalId": "Berdasarkan NIK",
  "label.reporting.range": "Rentang pelaporan",
  "label.result.order": "Pemesanan hasil",
  "label.resultSelectList": "Daftar pilihan hasil",
  "label.results.actions": "Aksi",
  "label.results.anotherUser": "pengguna lain",
  "label.results.date": "Tanggal Pemeriksaan",
  "label.results.domain": "Klinis",
  "label.results.domain.env": "Kualitas Air",
  "label.results.domain.vector": "Surveilans Vektor",
  "label.results.edit": "Edit",
  "label.results.inReviewBy": "Sedang ditinjau oleh {0}",
  "label.results.labUnit": "Instalasi Lab",
  "label.results.load": "Muat hasil",
  "label.results.loading": "Memuat hasil...",
  "label.results.range": "Rentang Referensi",
  "label.results.range.env": "Batas Regulasi",
  "label.results.range.vector": "Interpretasi",
  "label.results.reflexTriggered": "Pemeriksaan refleks/terkalkulasi ditambahkan untuk:",
  "label.results.refresh": "Segarkan",
  "label.results.result": "Hasil",
  "label.results.resultFor": "Hasil untuk {0}",
  "label.results.retry": "Coba lagi",
  "label.results.save": "Simpan",
  "label.results.search": "Cari berdasarkan Nomor Registrasi",
  "label.results.searchByPatient": "Cari berdasarkan Pasien",
  "label.results.selectAnotherPatient": "Pilih pasien lain",
  "label.results.selectedPatient": "Pasien yang Dipilih",
  "label.results.selectedPatient.none": "Tidak ada",
  "label.results.status": "Status",
  "label.results.status.all": "Semua",
  "label.results.subject": "Sampel / Pasien",
  "label.results.subject.env": "Sampel / Lokasi",
  "label.results.subject.vector": "Sampel / Perangkap",
  "label.results.table.caption": "Daftar pekerjaan hasil",
  "label.results.test": "Pemeriksaan",
  "label.results.titer.placeholder": "mis. 1:10",
  "label.results.method": "Metode",
  "label.results.analyzer": "Alat",
  "label.results.analyzer.none": "Bukan dari alat",
  "label.results.fromAnalyzer": "dari alat",
  "label.results.methodAnalyzerHint": "Metode adalah jenis alat; Alat adalah instrumen tertentu.",
  "label.results.expandRow": "Perluas baris",
  "label.results.collapseRow": "Lipat baris",
  "label.results.referredOut": "Dirujuk keluar",
  "label.results.notes": "Catatan",
  "label.results.note.context": "Konteks",
  "label.results.note.context.entry": "Entri",
  "label.results.note.context.modification": "Modifikasi",
  "label.results.note.context.auto": "Disetel secara otomatis dari aktivitas yang sedang Anda lakukan.",
  "label.results.note.visibility": "Visibilitas",
  "label.results.note.internal": "Hanya di lab",
  "label.results.note.external": "Kirim beserta hasilnya",
  "label.results.note.analysisLevel": "Tingkat analisis",
  "label.results.note.externalWarning": "Catatan ini akan tercantum dalam laporan pasien.",
  "label.results.note.placeholder": "Tambah Catatan…",
  "label.results.dilution.measured": "Nilai yang diukur",
  "label.results.dilution.factor": "Faktor pengenceran",
  "label.results.dilution.reported": "Nilai yang dilaporkan: {0}",
  "label.results.saveHint": "Fungsi Simpan akan menyimpan tanda tangan elektronik Anda. Konfirmasi kritis tidak akan pernah menghalangi proses Simpan.",
  "label.results.flag.normal": "Normal",
  "label.results.flag.abnormal": "Tidak normal",
  "label.results.flag.critical": "Kritis",
  "label.results.flag.invalid": "Tidak valid",
  "label.results.sample": "Sampel",
  "label.results.flag": "Penanda",
  "label.results.order.clinician": "Dokter Pemesan",
  "label.results.order.phone": "Telepon",
  "label.results.order.site": "Institusi Pemesan",
  "label.results.order.priority": "Prioritas",
  "label.results.order.collection": "Pengambilan",
  "label.results.section.program": "Info program",
  "label.results.program.name": "Program",
  "label.results.program.eqa": "PME",
  "label.results.program.readonly": "Kolom-kolom program di sini bersifat hanya baca; lakukan pengeditan pada pemesanan asalnya.",
  "label.results.section.storage": "Penyimpanan & pembuangan sampel",
  "label.results.storage.location": "Lokasi",
  "label.results.storage.position": "Posisi",
  "label.results.storage.notes": "Catatan",
  "label.results.storage.unassigned": "Tidak ada penugasan penyimpanan",
  "label.results.storage.assignLocation": "Tempatkan di Lokasi",
  "label.results.storage.moveLocation": "Pindah ke Lokasi",
  "label.results.program.capturedData": "Data program",
  "label.results.sampleStatus.title": "Status sampel",
  "label.results.sampleStatus.volume": "Volume: {0} tersisa dari {1} · status {2}.",
  "label.results.sampleStatus.noVolume": "Status {0}.",
  "label.results.sampleStatus.available": "Tersedia",
  "label.results.sampleStatus.usedUp": "habis (terpakai seluruhnya)",
  "label.results.sampleStatus.disposed": "Dimusnahkan",
  "label.results.sampleStatus.recordUse": "Catat jumlah yang digunakan",
  "label.results.sampleStatus.markUsedUp": "Tandai habis",
  "label.results.sampleStatus.startDisposal": "Mulai proses pembuangan",
  "label.results.sampleStatus.amountUsed": "Jumlah yang digunakan dalam pemeriksaan ini",
  "label.results.sampleStatus.record": "Rekam",
  "label.results.sampleStatus.recordHint": "Mengurangi volume yang tersisa — sampel tidak dibuang sampai habis atau secara eksplisit ditandai sebagai telah habis.",
  "label.results.sampleStatus.usedUpNote": "Sampel telah habis dan dimasukkan ke dalam antrian untuk alur kerja pembuangan. Rekam pembuangan mencatat siapa, kapan, dan metodenya.",
  "label.results.sampleStatus.disposalReason": "Alasan Pemusnahan",
  "label.results.sampleStatus.disposalMethod": "Metode pembuangan",
  "label.results.sampleStatus.disposalNotes": "Catatan",
  "label.results.sampleStatus.confirmDisposal": "Konfirmasi pembuangan",
  "label.results.sampleStatus.updateFailed": "Status sampel tidak diperbarui karena server tidak merespons. Periksa koneksi dan coba lagi.",
  "label.results.sampleStatus.reason.expired": "Kedaluwarsa",
  "label.results.sampleStatus.reason.contaminated": "Terkontaminasi",
  "label.results.sampleStatus.reason.patient_request": "Permohonan Pasien",
  "label.results.sampleStatus.reason.testing_complete": "Pemeriksaan Telah Selesai",
  "label.results.sampleStatus.reason.other": "Lainnya",
  "label.results.sampleStatus.method.autoclave": "Autoklaf untuk Limbah Berbahaya",
  "label.results.sampleStatus.method.neutralization": "Netralisasi Kimia",
  "label.results.sampleStatus.method.incineration": "Pembakaran",
  "label.results.sampleStatus.method.other": "Lainnya",
  "label.results.sampleStatus.footnote": "Penggunaan sebagian mencatat jumlah yang dikonsumsi terhadap sisa volume item sampel; habis total (atau Tandai habis) memicu pembuangan.",
  "label.results.section.reagents": "Reagen, QC & Kontrol",
  "label.results.reagents.summary.analyzer": "lot yang dilaporkan oleh alat",
  "label.results.reagents.summary.manual": "perekaman manual",
  "label.results.reagents.mode.analyzer": "mode pencatatan: dilaporkan oleh alat",
  "label.results.reagents.mode.manual": "mode pencatatan: manual (opsional)",
  "label.results.reagents.analyzerNote": "Dilaporkan oleh {0} dalam muatan hasilnya — hanya baca.",
  "label.results.reagents.lotsUsed": "Lot reagen yang digunakan",
  "label.results.reagents.noneLinked": "Tidak ada reagen yang terkait dengan pemeriksaan ini — tautan-tautan tersebut telah dikonfigurasi di Katalog Pemeriksaan.",
  "label.results.reagents.noLots": "Tidak ada lot yang tersedia di inventaris untuk reagen ini.",
  "label.results.reagents.perTest": "{0} {1} per pemeriksaan",
  "label.results.reagents.fefo": "Saran FEFO",
  "label.results.reagents.expires": "Exp {0} ·",
  "label.results.reagents.remaining": "{0} {1} sisanya",
  "label.results.reagents.quantityUsed": "Kuantitas yang Digunakan",
  "label.results.reagents.recordUse": "Catat penggunaan",
  "label.results.reagents.recorded": "Tercatat {0} {1} — penerapan FEFO antar-lot.",
  "label.results.reagents.recordFailed": "Tidak dapat mencatat penggunaan reagen.",
  "label.results.reagents.amountInvalid": "Kuantitas yang digunakan harus berupa bilangan positif.",
  "label.results.reagents.consumeNote": "Rekaman penggunaan mengurangi inventaris (FEFO) dan mencatat transaksi konsumsi yang terkait dengan analisis ini.",
  "label.results.control.title": "Hasil kontrol",
  "label.results.control.noneConfigured": "Tidak ada Lot Kontrol yang dikonfigurasi untuk pemeriksaan dan Alat ini.",
  "label.results.control.viewResults": "Lihat hasil kontrol",
  "label.results.control.capture.controlLine": "Garis kontrol",
  "label.results.control.capture.valid": "Valid",
  "label.results.control.capture.invalid": "Tidak valid",
  "label.results.control.capture.kitLot": "Lot kit",
  "label.results.control.capture.outcome": "Hasil",
  "label.results.control.capture.lot": "Lot kontrol",
  "label.results.control.capture.measured": "Nilai yang diukur",
  "label.results.control.capture.expected": "Nilai yang diharapkan",
  "label.results.control.capture.uncertainty": "Ketidakpastian (±)",
  "label.results.control.capture.record": "Catat hasil kontrol",
  "label.results.control.capture.recorded": "Hasil kontrol dicatat.",
  "label.results.control.capture.recordedBlocked": "Hasil kontrol dicatat. Pelaporan diblokir untuk hasil yang tercakup sampai pengulangan yang lolos dicatat.",
  "label.results.control.capture.blockedHint": "Kontrol yang gagal memblokir pelaporan untuk hasil yang tercakup, sehingga diperlukan pengulangan.",
  "label.results.control.capture.noBenchLots": "Tidak ada lot kontrol meja kerja yang dikonfigurasi untuk pemeriksaan ini. Tambahkan di QC → Lot Kontrol sebelum mencatat kontrol kuantitatif.",
  "label.results.control.capture.incomplete": "Lengkapi kolom hasil kontrol sebelum mencatat.",
  "label.results.control.capture.failed": "Pencatatan hasil kontrol gagal.",
  "label.results.dilution.title": "Pengenceran",
  "label.results.section.attachments": "Lampiran",
  "label.results.attachments.summary": "{0} file",
  "label.results.attachments.none": "Tidak ada",
  "label.results.attachments.empty": "Belum ada lampiran pada pemesanan ini.",
  "label.results.attachments.add": "Tambah lampiran",
  "label.results.attachments.tooLarge": "Ukuran file melebihi batas 10 MB.",
  "label.results.attachments.uploadFailed": "Unggah gagal — PDF, JPG, PNG, atau TIFF dengan ukuran maksimal 10 MB.",
  "label.results.attachments.resultsScope": "Hasil",
  "label.results.attachments.orderScope": "Pencatatan Pemesanan",
  "label.results.attachments.view": "Lihat",
  "label.results.attachments.download": "Unduh",
  "label.results.section.interpretation": "Interpretasi",
  "label.results.interpretation.summary": "masukkan melalui aturan atau teks bebas",
  "label.results.interpretation.ruleFired": "aturan diaktifkan ({0}) · buka otomatis",
  "label.results.interpretation.autoOpen": "aturan dipicu · buka otomatis",
  "label.results.interpretation.ruleBanner": "Kesesuaian aturan (dikonfigurasi pada pengujian): nilai yang dimasukkan {0} termasuk dalam kategori {1}. Pilih sebuah kategori untuk menerapkan teks penjelasannya, lalu edit sesuai kebutuhan.",
  "label.results.interpretation.match": "sesuai dengan nilai",
  "label.results.interpretation.freeText": "Interpretasi (teks bebas)",
  "label.results.interpretation.footnote": "Interpretasi dapat ditentukan melalui aturan yang dikonfigurasi pada tes (kelompok kategorikal, yang secara otomatis disesuaikan dengan nilai) atau teks bebas. Teks aturan hanyalah saran yang tidak mengikat sampai diterapkan atau diedit. Saat disimpan, teks tersebut akan dikirimkan bersama hasil ke dalam laporan.",
  "label.results.nce.disposition": "Penanganan hasil",
  "label.results.nce.disposition.hint": "Diterapkan saat NCE dikirim. Rujuk keluar merupakan aksi baris terpisah, bukan disposisi.",
  "label.results.nce.disposition.none": "Tidak ada",
  "label.results.nce.disposition.none.detail": "Ajukan NCE tanpa mengubah hasilnya.",
  "label.results.nce.disposition.cancel": "Batalkan hasil",
  "label.results.nce.disposition.cancel.detail": "Dibatalkan. Tidak ada nilai yang dilaporkan. Hal ini umum terjadi pada NCE pra-analisis.",
  "label.results.nce.disposition.reject": "Tolak + alasan",
  "label.results.nce.disposition.reject.detail": "Mengosongkan nilai dan mencatat alasannya. Diterapkan saat Anda Simpan dengan tanda tangan elektronik.",
  "label.results.nce.disposition.retest": "Pemeriksaan Ulang",
  "label.results.nce.disposition.retest.detail": "Memesan pemeriksaan yang sama lagi pada sampel ini; pengulangan akan muncul sebagai tertunda.",
  "label.results.nce.disposition.rejectArmed": "Penolakan telah diaktifkan pada baris tersebut — Simpan (tanda tangan elektronik) untuk menerapkannya.",
  "label.results.nce.disposition.cancelled": "Hasil dibatalkan.",
  "label.results.nce.disposition.retested": "Pemeriksaan Ulang telah dipesan.",
  "label.results.critical.range": "Kritis",
  "label.results.critical.banner.title": "Nilai kritis — wajib memberitahu dokter",
  "label.results.critical.banner.notify": "Klinisi yang bertanggung jawab harus diberi tahu. Catat hal tersebut di dasbor Peringatan dan catat panggilan di bawah.",
  "label.results.critical.acknowledge": "Saya Mengetahui",
  "label.results.critical.acknowledged": "Sudah diketahui",
  "label.results.critical.comment": "Komentar konfirmasi",
  "label.results.critical.comment.placeholder": "misalnya: Dokter diberi tahu melalui telepon",
  "label.results.section.history": "Riwayat (analisis ini)",
  "label.results.history.summary": "{0} peristiwa",
  "label.results.history.summary.unloaded": "revisi · status · Pemeriksaan Ulang",
  "label.results.history.when": "Waktu",
  "label.results.history.event": "Peristiwa",
  "label.results.history.detail": "Detail",
  "label.results.history.by": "Oleh",
  "label.results.history.event.CREATED": "Dibuat",
  "label.results.history.event.STATUS": "Status",
  "label.results.history.event.RESULT": "Hasil",
  "label.results.history.event.NOTE": "Catatan",
  "label.results.history.event.RETEST": "Pemeriksaan Ulang",
  "label.results.history.event.REFLEX": "Refleks",
  "label.results.history.event.OTHER": "Peristiwa",
  "label.results.history.empty": "Tidak ada peristiwa yang tercatat untuk analisis ini.",
  "label.results.history.footnote": "Analisis ini hanya mencakup — revisi, perubahan status, Pemeriksaan Ulang, koreksi, catatan, dan entri audit. Tren pasien tersimpan dalam rekam medis pasien; Westgard Rule terdapat di Dasbor QC.",
  "label.results.nce.report": "Laporkan Ketidaksesuaian",
  "label.results.reject.result": "Tolak hasil",
  "label.results.reject.reason": "Alasan Penolakan",
  "label.results.reject.hint": "Menyimpan dengan penolakan akan menghapus nilai, mencatat alasannya, dan menandai analisis sebagai “Ditolak Secara Teknis”.",
  "label.results.referral.refer": "Rujuk pemeriksaan ini",
  "label.results.referral.editing": "Rujukan tertunda — edit",
  "label.results.referral.organization": "Laboratorium rujukan",
  "label.results.referral.reason": "Alasan merujuk",
  "label.results.referral.date": "Tanggal rujukan",
  "label.results.referral.reportDate": "Tanggal laporan lab rujukan",
  "label.results.referral.hint": "Rujukan tersebut akan tercatat saat Anda menyimpan baris ini dan kemudian ditampilkan di dasbor Rujukan.",
  "label.results.referral.cancel": "Buang",
  "label.results.referral.incomplete": "Choose the reference laboratory and the referral reason, or discard the referral, before saving this row.",
  "label.results.section.aliquots": "Alikuot",
  "label.results.aliquots.summary": "{0} alikuot",
  "label.results.aliquots.summary.unloaded": "daftar · buat",
  "label.results.aliquots.labNo": "No Registrasi",
  "label.results.aliquots.quantity": "Kuantitas",
  "label.results.aliquots.createdDate": "Dibuat",
  "label.results.aliquots.empty": "Belum ada alikuot untuk sampel ini.",
  "label.results.aliquots.count": "Jumlah alikuot",
  "label.results.aliquots.totalQuantity": "Total Kuantitas yang akan Dipindahkan",
  "label.results.aliquots.notes": "Catatan",
  "label.results.aliquots.create": "Buat alikuot",
  "label.results.aliquots.created": "Alikuot telah dibuat.",
  "label.results.aliquots.failed": "Tidak dapat membuat alikuot.",
  "label.results.aliquots.remaining": "Kuantitas Sisa Induk",
  "label.results.history.event.REFERRAL": "Dirujuk",
  "label.results.history.event.NCE": "Ketidaksesuaian",
  "label.results.history.event.CRITICAL_ACK": "Kritis diketahui",
  "label.results.history.event.INVALID_CONFIRMED": "Di luar rentang valid dikonfirmasi",
  "label.results.alert.critical.title": "Hasil Kritis",
  "label.results.alert.critical.defaultMessage": "Ini adalah hasil kritis. Beri tahu klinisi yang bertanggung jawab sesuai prosedur laboratorium Anda.",
  "label.results.alert.invalid.title": "Nilai di luar rentang valid",
  "label.results.alert.invalid.body": "Nilai ini berada di luar rentang valid untuk pemeriksaan ini ({low} sampai {high}). Periksa sebelum menyimpan.",
  "label.results.alert.correct": "Perbaiki nilai",
  "label.results.alert.keepValue": "Pertahankan nilai ini",
  "label.results.alert.confirmAndSave": "Konfirmasi dan simpan",
  "label.results.alert.acknowledgeAndSave": "Mengetahui dan simpan",
  "label.results.callback.logged": "Panggilan balik dicatat",
  "label.results.referenceZone": "Referensi & konteks",
  "label.results.layoutRemembered": "Tata letak disimpan",
  "label.results.resetLayout": "Atur Ulang tata letak",
  "label.results.section.orderInfo": "Info pemesanan",
  "label.results.sampleType": "Jenis sampel",
  "label.results.testDate": "Tanggal Pemeriksaan",
  "label.results.receivedDate": "Diterima",
  "label.results.technician": "Petugas",
  "label.routine.Reports": "Laporan Rutin",
  "label.sample.types.activate": "Jenis sampel berikut akan diaktivasi:",
  "label.sample.types.deactivate": "Jenis sampel berikut akan dinonaktifkan karena tidak memiliki pemeriksaan:",
  "label.save": "Simpan",
  "label.saving": "Menyimpan...",
  "label.search.available.targetest": "Cari pemeriksaan tersedia",
  "label.search.availablepanel": "Cari panel tersedia",
  "label.search.labno.family": "Cari berdasarkan LabNo atau Nama Belakang",
  "label.search.patient": "Cari Pasien",
  "label.select": "Pilih",
  "label.select.dateRange": "Pilih Rentang Tanggal untuk laporan yang diinginkan",
  "label.select.list.options": "Pilih opsi daftar",
  "label.selectTestSectionCatalog": "Pilih bagian pemeriksaan untuk melihat katalog bagian tersebut",
  "label.sex.dependent": "Tergantung jenis kelamin",
  "label.shortCode": "Kode Pendek",
  "label.shortCode.error.invalidChars": "Kode pendek hanya dapat mengandung huruf, angka, hyphen atau underscore",
  "label.shortCode.error.maxLength": "Kode pendek harus kurang dari atau sama dengan 10 karakter",
  "label.shortCode.error.network": "Tidak dapat memverifikasi keunikan. Silahkan periksa manual.",
  "label.shortCode.error.save": "Error saat menyimpan kode pendek: {error}",
  "label.shortCode.error.startChar": "Kode pendek harus dimulai dengan huruf atau angka",
  "label.shortCode.helper": "Maksimum 10 karakter, alfanumerik dengan hyphen/underscore",
  "label.shortCode.optional.helper": "Opsional (kode akan digunakan jika ≤10 karakter). Maksimum 10 karakter, alfanumerik dengan hyphen/underscore",
  "label.shortCode.required.helper": "Wajib jika kode > 10 karakter. Maksimum 10 karakter, alfanumerik dengan hyphen/underscore",
  "label.shortCode.update.success": "Pembaruan kode pendek berhasil",
  "label.shortCodeRequired": "Kode pendek diwajibkan untuk pencetakan label. Silahkan buat pengaturan kode pendek di formulir Edit terlebih dahulu.",
  "label.shortCodeWarning": "Mengubah kode pendek akan membatalkan validasi label yang ada",
  "label.showChildren": "Tunjukan Elemen Anak",
  "label.study.Reports": "Laporan kajian",
  "label.test.name": "Nama Pemeriksaan",
  "label.test.activate": "Pemeriksaan ini akan diaktivasi",
  "label.test.add": "Tambahkan Pemeriksaan",
  "label.test.batch.cancel.finish": "Tidak dapat dibalik",
  "label.test.batch.cancel.start": "Anda telah memilih untuk membatalkan pemeriksaan",
  "label.test.batch.no.change.finish": "Pemeriksaan tidak dapat diubah",
  "label.test.batch.replace.start": "Berikut ini",
  "label.test.deactivate": "Pemeriksaan berikut akan diinaktivasi",
  "label.test.display.order": "Urutan tampilan pemeriksaan",
  "label.test.order.confirm": "Verifikasi: aktivasi/inaktivasi pemeriksaan yang dapat dipesan",
  "label.test.activation.confirm": "Verifikasi: Aktif/nonaktifkan pemeriksaan",
  "label.test.orderable": "Pemeriksaan berikut ini dapat dipesan dengan formulir permintaan",
  "label.test.results": "Hasil Pemeriksaan",
  "label.test.resultsData": "Data Hasil Pemeriksaan",
  "label.test.unorderable": "Pemeriksaan berikut ini tidak dapat dipesan dengan formulir permintaan. Hanya bisa dipesan sebagai pemeriksaan refleks",
  "label.testActivate": "Aktivasi Pemeriksaan",
  "label.testName": "Nama pemeriksaan",
  "label.text.generate": "Hasilkan",
  "label.total.tests": "Pemeriksaan total",
  "label.type": "Jenis Label",
  "label.type.order": "Label Pemesanan",
  "label.type.pool": "Pool {count} {animal}",
  "label.type.sample": "Label Sampel",
  "label.unit": "Unit",
  "label.user.notestsection": "Pengguna tidak memiliki Instalasi Lab yang ditugaskan. Hubungi Admin",
  "label.validation.errors": "Kesalahan Validasi",
  "label.validation.results": "Hasil Validasi",
  "label.view": "Lihat",
  "label.viewtestCatalog": "Katalog Pemeriksaan",
  "label.warning": "Peringatan",
  "label.yes": "Ya",
  "labno.alt.prefix.instruction": "Prefiks untuk label kode QR pra-cetak (4 karakter):",
  "labno.alt.prefix.note": "CATATAN: Jika prefiks ini telah digunakan, penomoran akan berlanjut dari nomor terakhir yang dihasilkan.",
  "labno.alt.prefix.use": "Gunakan format yang sama untuk nomor registrasi dan kumpulan nomor yang ada seperti pada Pembuatan Entri Permintaan.",
  "language.select.label": "Indonesia",
  "legend.search.availabletests": "Mencari dari pemeriksaan yang ada",
  "loading": "Memuat...",
  "loading.boxes": "Memuat boks...",
  "loading.description": "Memuat...",
  "location.collection.title": "Lokasi Pengambilan",
  "location.environmentalConditions": "Kondisi Lingkungan",
  "location.environmentalConditions.placeholder": "mis. 25°C, cuaca cerah",
  "location.gps.error": "Gagal mengambil lokasi",
  "location.gps.getCurrent": "Ambil Lokasi Saat",
  "location.gps.getting": "Mengambil Lokasi...",
  "location.gps.latitude": "Garis Lintang GPS",
  "location.gps.longitude": "Garis bujur GPS",
  "location.gps.notSupported": "Geolokasi tidak didukung dengan peramban ini",
  "location.gps.permissionDenied": "Izin lokasi ditolak",
  "location.gps.timeout": "Permintaan lokasi time out",
  "location.gps.unavailable": "Informasi lokasi tidak tersedia",
  "location.helper": "Hirarki Lokasi (Kabupaten Kota / Kecamatan / Kelurahan-Desa) menggunakan sistem struktur Lokasi yang ada. Jika perlu pengaturan baris yang lebih sederhana/pendek, profil alur kerja Lingkungan memungkinkan beberapa baris tidak dilabel.",
  "location.requesterReference": "Referensi Pemohon",
  "location.requesterReference.placeholder": "mis. Metode EPA 524.2",
  "location.select.placeholder": "Pilih {levelName}...",
  "location.siteDescription": "Deskripsi Tempat Pengambilan",
  "location.siteDescription.placeholder": "mis. titik masuk pasokan air kabupaten",
  "locale.active": "Aktif",
  "locale.add": "Tambah Bahasa",
  "locale.add.title": "Tambah Bahasa",
  "locale.code": "Kode Lokal",
  "locale.code.helper": "mis., en, fr, es, pt",
  "locale.create.success": "Bahasa berhasil dibuat",
  "locale.delete.confirm.message": "Apakah Anda yakin akan menghapus bahasa ini? Aksi ini tidak dapat dibatalkan.",
  "locale.delete.confirm.title": "Hapus Bahasa",
  "locale.delete.error": "Gagal menghapus bahasa",
  "locale.delete.fallback.error": "Tidak dapat menghapus bahasa alternatif. Atur bahasa lain sebagai alternatif terlebih dahulu.",
  "locale.delete.success": "Bahasa berhasil dihapus",
  "locale.displayName": "Nama di Tampilan",
  "locale.displayName.helper": "mis., English, Français, Español",
  "locale.edit.title": "Edit Bahasa",
  "locale.fallback": "Bahasa Alternatif",
  "locale.fallback.error": "Gagal mengatur bahasa alternatif",
  "locale.fallback.success": "Bahasa alternatif diperbarui",
  "locale.management.description": "Kelola bahasa yang ada untuk terjemahan metadata.",
  "locale.management.title": "Pengelolaan Bahasa",
  "locale.setFallback": "Atur sebagai Bahasa Alternatif",
  "locale.sortOrder": "Sortir Pemesanan",
  "locale.status": "Status",
  "locale.update.success": "Bahasa berhasil diperbarui",
  "log.submitting.aliquot.data": "Submit data alikuot:",
  "log.submitting.aliquot.data2": "Submit data alikuot (JSON):",
  "logging.management.apply": "Terapkan Level Log",
  "logging.management.description": "Ubah level logging backend saat runtime. Ini berguna untuk mendebug masalah tanpa perlu me-restart server. Perubahan akan berlaku segera tetapi tidak akan bertahan setelah server di-restart.",
  "logging.management.label": "Konfigurasi Logging",
  "logging.management.level": "Level Log",
  "logging.management.logger": "Nama Logger",
  "logging.management.logger.helper": "mis., org.openelisglobal, root",
  "logging.management.success": "Level log diatur ke {level} untuk {logger}",
  "login.account.disabled": "Akun dinon-aktifkan",
  "login.account.locked": "Akun terkunci",
  "login.complexity.message": "Kata kunci harus:",
  "login.complexity.message.1": "Setidaknya 7 karakter",
  "login.complexity.message.2": "Memiliki huruf besar dan kecil, atau angka",
  "login.complexity.message.3": "Memiliki setidaknya 1 karakter berikut ini: *, $, #, !",
  "login.complexity.message.4": "Tidak mengandung karakter lainnya",
  "login.complexity.new.message": "Kata kunci baru harus:",
  "login.complexity.new.message.1": "Tidak boleh sama dengan kata kunci saat ini",
  "login.error.account.disable": "Akun Anda telah dinonaktifkan. Silakan hubungi administrator sistem.",
  "login.error.password.current.incorrect": "Kata kunci saat ini yang Anda masukkan salah. Silakan coba lagi.",
  "login.error.password.expired": "Kata kunci Anda telah kedaluwarsa. Silakan hubungi administrator sistem.",
  "login.error.update.message": "Pembaruan kata kunci gagal. Silakan coba lagi.",
  "login.login.": "Ulang kata kunci",
  "login.login.current.password": "Kata kunci saat ini",
  "login.login.first": "Nama depan",
  "login.login.last": "Nama belakang",
  "login.login.name": "Nama login",
  "login.login.new.password": "Kata kunci baru",
  "login.login.password": "Kata kunci",
  "login.login.repeat.password": "Ulang kata kunci",
  "login.msg.password": "Kata kunci",
  "login.msg.password.missing": "Kata kunci diperlukan",
  "login.msg.username": "Nama pengguna",
  "login.msg.username.missing": "Nama pengguna diperlukan",
  "login.notice.message": "Pemberitahuan: Akses ke layanan ini hanya untuk personel yang berwenang. Jika Anda tidak memiliki wewenang dari administrator, Anda harus keluar sekarang. Organisasi ini melarang akses tanpa wewenang, pengungkapan, penggandaan, modifikasi, pengalihan, pemusnahan, penghilangan, penyalahgunaan, atau pencurian informasi tanpa izin.",
  "login.password.expired.date": "Tanggal kadaluarsa kata kunci",
  "login.password.expired.date.placeholder": "(dd/mm/yyyy)",
  "login.redirecting.sso": "Mengarahkan ke Single Sign-On...",
  "login.subtitle": "Masuk",
  "login.timeout": "Pengguna Time Out (menit)",
  "login.timeout.placeholder": "Masukkan dalam ms",
  "login.title": "Masuk",
  "lot.barcode": "Kode QR",
  "lot.barcode.assign": "Lot ini belum memiliki Kode QR. Masukkan sekarang; kode akan dikunci setelah disimpan.",
  "lot.barcode.hint": "Kosongkan untuk membuat kode dari kode barang dan nomor lot.",
  "lot.barcode.locked": "Kode QR dikunci setelah disimpan agar label yang sudah dicetak tetap berfungsi.",
  "lot.barcode.placeholder": "Kosongkan untuk dibuat otomatis",
  "lot.barcode.placeholder.assign": "Masukkan Kode QR",
  "lot.calculatedExpiry": "Perhitungan Kedaluwarsa",
  "lot.currentQuantity": "Kuantitas Saat Ini",
  "lot.dateOpened": "Tanggal Dibuka",
  "lot.details.no.movements": "Tidak ada pergerakan yang tercatat untuk lot ini",
  "lot.details.no.transactions": "Tidak ada transaksi terekam untuk lot ini",
  "lot.details.no.usage": "Tidak riwayat penggunaan untuk lot ini",
  "lot.details.section.basic": "Informasi Dasar",
  "lot.details.section.dates": "Tanggal Penting",
  "lot.details.section.movements": "Riwayat Pergerakan",
  "lot.details.section.quantities": "Kuantitas",
  "lot.details.section.storage": "Lokasi Penyimpanan",
  "lot.details.section.transactions": "Riwayat Transaksi",
  "lot.details.section.usage": "Riwayat Penggunaan",
  "lot.details.tab.info": "Informasi",
  "lot.details.tab.transactions": "Transaksi",
  "lot.details.tab.usage": "Riwayat Penggunaan",
  "lot.details.title": "Rincian Lot",
  "lot.details.view": "Tampilkan Rincian",
  "lot.expirationDate": "Tanggal Kedaluwarsa",
  "lot.form.title.add": "Menerima Lot Inventaris Baru",
  "lot.form.title.edit": "Edit Lot Inventaris",
  "lot.initialQuantity": "Kuantitas Awal",
  "lot.label.print": "Cetak label",
  "lot.label.print.failed": "Tidak dapat membuat label. Silakan coba lagi.",
  "lot.number": "Nomor Lot",
  "lot.number.hint": "Pengenal tetap untuk lot ini. Kosongkan dan sistem akan membuatnya dari kode barang dan tanggal hari ini.",
  "lot.number.placeholder": "Kosongkan untuk dibuat otomatis",
  "lot.qcStatus.FAILED": "Gagal",
  "lot.qcStatus.PASSED": "Lolos",
  "lot.qcStatus.PENDING": "Tertunda",
  "lot.qcStatus.QUARANTINED": "Dikarantina",
  "lot.qcStatus.hint": "Lot tetap tidak dapat digunakan untuk pemeriksaan sampai QC ditandai Lolos.",
  "lot.qcStatus": "Status QC",
  "lot.receiptDate": "Tanggal Penerimaan",
  "lot.save.error": "Error saat menyimpan lot",
  "lot.save.error.locationAfterCreate": "Lot telah dibuat, tetapi penetapan lokasi penyimpanannya gagal. Tekan Simpan lagi untuk mengulang penetapan saja, agar lot tidak diterima dua kali. {reason}",
  "lot.save.success": "Lot berhasil disimpan",
  "lot.selectItem": "Pilih Barang di Katalog",
  "lot.selectLocation": "Tambah Lokasi Penyimpanan",
  "lot.status": "Status",
  "lot.status.ACTIVE": "Aktif",
  "lot.status.CONSUMED": "Habis",
  "lot.status.DISPOSED": "Dimusnahkan",
  "lot.status.EXPIRED": "Kedaluwarsa",
  "lot.status.IN_USE": "Sedang Digunakan",
  "lot.status.QUARANTINED": "Dikarantina",
  "lot.storageLocation": "Lokasi Penyimpanan",
  "manage.testing.algorithms.add.reflex.tests": "Kelola Algoritma Pemeriksaan dan Pemeriksaan Refleks",
  "master.lists.page": "Halaman daftar master",
  "master.lists.page.analyzer": "Menu Nama Pemeriksaan di Alat",
  "master.lists.page.barcode": "Konfigurasi kode QR",
  "master.lists.page.batchtest": "Penugasan ulang dan pembatalan pemeriksaan batch",
  "master.lists.page.external.connections": "Menu Koneksi Eksternal",
  "master.lists.page.field": "Konfigurasi Validasi Field",
  "master.lists.page.list": "Daftar Plugin",
  "master.lists.page.menu": "Konfigurasi menu",
  "master.lists.page.notification": "Konfigurasi Notifikasi Pemeriksaan",
  "master.lists.page.order.entry": "Konfigurasi Entri Permintaan",
  "master.lists.page.org": "Menu Organisasi",
  "master.lists.page.patient": "Konfigurasi Entri Pasien",
  "master.lists.page.printed": "Konfigurasi Laporan Cetak",
  "master.lists.page.provider": "Penyelenggara",
  "master.lists.page.report.result": "Konfigurasi Pelaporan Hasil",
  "master.lists.page.result": "Konfigurasi Entri Hasil",
  "master.lists.page.site": "Pengaturan Informasi Aplikasi",
  "master.lists.page.test.management": "Pengelolaan Pemeriksaan",
  "master.lists.page.user": "Pengelolaan Pengguna",
  "master.lists.page.work.plan": "Konfigurasi Rencana Kerja",
  "menu.accession.validation": "Berdasarkan Permintaan",
  "menu.accession.validation.range": "Berdasarkan Rentang Nomor Permintaan",
  "menu.billing.active": "Menu Pembayaran Aktif",
  "menu.billing.address": "URL Pembayaran",
  "menu.billing.title": "Pengelolaan Menu Pembayaran",
  "menu.genericSample": "Sampel Generik",
  "menu.genericSample.edit": "Edit Sampel",
  "menu.genericSample.import": "Impor",
  "menu.genericSample.order": "Penerimaan Sampel",
  "menu.global.title": "Pengelolaan Menu Global",
  "menu.label.filter": "Filter : ",
  "menu.label.filter.active": "Hanya Aktif",
  "menu.label.filter.admin": "Hanya Administrator",
  "menu.label.filter.role": "Berdasarkan Peran Unit Lab",
  "menu.nonconform.active": "Menu Ketidaksesuaian Aktif",
  "menu.nonconform.title": "Pengelolaan Menu Ketidaksesuaian",
  "menu.patient.active": "Menu Pasien Aktif",
  "menu.patient.title": "Pengelolaan Menu Pasien",
  "menu.results.range": "Berdasarkan Rentang Nomor Permintaan",
  "menu.sidenav.active": "Navigasi Sisi Aktif",
  "menu.study.active": "Menu Kajian Aktif",
  "menu.study.title": "Konfigurasi Menu Kajian",
  "menu.validation.date": "Berdasarkan Tanggal",
  "message.method.activation": "Unit metode ini tidak aktif kecuali setidaknya satu pemeriksaan ditugaskan",
  "message.propertiesupdate.success": "Properti berhasil diperbarui",
  "method.browse.title": "Bagian Metode",
  "method.methodName": "Nama Metode",
  "method.modal.add.heading": "Tambah Metode Baru",
  "modal.add.method": "Tambah Metode Baru",
  "move.back": "Kembalikan",
  "move.to.aliquot": "Pindahkan ke Alikuot",
  "new.patient.label": "Pasien Baru",
  "next.action.button": "Berikutnya",
  "nextLabel.action.button": "Label Berikutnya",
  "no.aliquots": "Tidak ada alikuot tersedia",
  "no.analysis.found": "Tidak ada analisis ditemukan",
  "no.data.found": "Tidak ada data ditemukan",
  "no.option": "Tidak",
  "noTestsFound.matching": "Tidak ada pemeriksaan ditemukan",
  "nonconform.add.new.date": "Tambah tanggal baru",
  "nonconform.corrective.action": "Rencana atau rekomendasi tindakan perbaikan",
  "nonconform.corrective.actionType": "Jenis tindakan",
  "nonconform.corrective.comment": "Komentar",
  "nonconform.corrective.control": "Rencana atau rekomendasi tindakan pencegahan, perbaikan atau pengendalian simultan:",
  "nonconform.corrective.title": "Tindakan perbaikan kejadian ketidaksesuaian",
  "nonconform.date.completed": "Tanggal selesai",
  "nonconform.date.discussion.nce": "Tanggal diskusi dengan Petugas Kejadian Ketidaksesuaian",
  "nonconform.date.event": "Tanggal Kejadian",
  "nonconform.description.nce": "Deskripsi Kejadian Ketidaksesuaian",
  "nonconform.field.date": "Tanggal Kejadian Ketidaksesuaian",
  "nonconform.field.reporting.data": "Tanggal Pelaporan",
  "nonconform.goToNceForm": "Pergi ke formulir Kejadian Ketidaksesuaian",
  "nonconform.lab.componenet.nce": "Komponen Lab dimana Kejadian Ketidaksesuaian terjadi",
  "nonconform.label.highseverity": "9 = Keparahan sangat tinggi -- perlu tindakan segera",
  "nonconform.label.lowseverity": "1 = Keparahan sangat rendah -- tidak perlu tindakan segera",
  "nonconform.label.prescibernamesite": "Nama dan Lokasi Dokter yang mengeluarkan resep",
  "nonconform.label.proposed.action": "Tindakan yang diusulkan",
  "nonconform.label.reportingunit": "Unit yang melapor",
  "nonconform.label.suspected.cause.nce": "Penyebab dugaan Kejadian Ketidaksesuaian",
  "nonconform.nce.concurrent.control.action": "Tindakan pengendalian simultan",
  "nonconform.nce.number": "Nomor Kejadian Ketidaksesuaian",
  "nonconform.nce.preventive.action": "Tindakan pencegahan",
  "nonconform.nce.resolution": "Penyelesaian Kejadian Ketidaksesuaian",
  "nonconform.nce.resolution.description": "Apakah tindakan korektif dan pengendalian pencegahan/simultan efektif dalam menyelesaikan Kejadian Ketidaksesuaian dan mencegahnya terulang kembali?",
  "nonconform.nce.turnaround.time": "Waktu Penyelesaian",
  "nonconform.order.save.fail": "Penyimpanan gagal",
  "nonconform.order.save.failBecause": "Save failed: {reason}",
  "nonconform.search.nceNumber": "Nomor Kejadian Ketidaksesuaian",
  "nonconform.column.date": "Tanggal",
  "nonconform.column.labSection": "Lab Section/Unit",
  "nonconform.search.lastName": "Nama Belakang",
  "nonconform.search.firstName": "Nama Depan",
  "nonconform.search.patientCode": "Patient Identification Code",
  "nonconform.search.labNumber": "Nomor Registrasi",
  "nonconform.search.specimenType": "Jenis Spesimen",
  "nonconform.order.save.success": "Penyimpanan berhasil",
  "nonconform.person.reporting.different": "Nama petugas yang melaporkan Kejadian Ketidaksesuaian (bila berbeda)",
  "nonconform.person.responsible": "Petugas yang bertanggungjawab",
  "nonconform.report": "Lapor Kejadian Ketidaksesuaian",
  "nonconform.report.field.date": "Tanggal Laporan",
  "nonconform.severity.score": "Skor Keparahan",
  "nonconform.view.comments": "Komentar",
  "nonconform.view.corrective.action.description": "Deskripsi tindakan perbaikan yang akan diambil",
  "nonconform.view.event.date": "Tanggal Kejadian",
  "nonconform.view.event.description": "Deskripsi Kejadian",
  "nonconform.view.lab.component": "Komponen Laboratorium",
  "nonconform.view.nce.category": "Kategori Kejadian Ketidaksesuaian",
  "nonconform.view.nce.likely.occur": "Seberapa besar kemungkinan Kejadian Ketidaksesuaian akan terulang?",
  "nonconform.view.nce.severity": "Keparahan",
  "nonconform.view.nce.type": "Jenis Kejadian Ketidaksesuaian",
  "nonconform.view.preventive.description": "Jika ada, jelaskan tindakan pencegahan atau pengendalian simultan",
  "nonconform.view.report": "Lihat Kejadian Ketidaksesuaian Baru",
  "nonconform.view.reporting.person": "Petugas yang melapor",
  "nonconform.view.severe.consequences": "Bagaimana tingkat keparahan konsekuensi atau pengaruh dari Kejadian Ketidaksesuaian?",
  "nonconform.view.specimen": "Spesimen",
  "nce.attachment.dropzone": "Tarik dan lepaskan file disini atau klik untuk mengunggah",
  "nce.attachment.error.maxFiles": "Maksimum {maxFiles} file dibolehkan",
  "nce.attachment.error.size": "Ukuran file melebihi maksimum {maxSize}",
  "nce.attachment.error.type": "Tipe file tidak didukung. Tipe yang diterima: {types}",
  "nce.attachment.error.upload": "Error saat mengunggah file",
  "nce.attachment.files": "file",
  "nce.attachment.hint": "(Opsional - maks {maxFiles} file, masing-masing 10MB)",
  "nce.attachment.uploading": "Mengunggah...",
  "nce.category.administrative": "Administratif",
  "nce.category.analytical": "Analisis",
  "nce.category.postanalytical": "Pasca-analisis",
  "nce.category.preanalytical": "Pra- analisis",
  "nce.field.attachments": "Lampiran",
  "nce.field.notes": "Catatan",
  "nce.field.description.placeholder": "Jelaskan apa yang terjadi, kapan terdeteksi, dan hal relevan lainnya...",
  "nce.field.immediateAction": "Tindakan Segera Diambil",
  "nce.field.immediateAction.placeholder": "Tindakan perbaikan apa yang akan segera diambil...",
  "nce.field.linkedItems": "Sampel/Hasil Terkait",
  "nce.field.severity": "Keparahan",
  "nce.field.title": "Judul",
  "nce.field.title.placeholder": "Deskripsi singkat kejadian...",
  "nce.severity.critical": "Kritis",
  "nce.severity.critical.description": "Resiko keselamatan pasien, pelanggaran peraturan",
  "nce.severity.major": "Mayor",
  "nce.severity.major.description": "Dampat signifikan pada mutu atau operasional",
  "nce.severity.minor": "Minor",
  "nce.severity.minor.description": "Dampak terbatas, mudah diperbaiki",
  "nce.severity.low": "Rendah",
  "nce.severity.low.description": "Dampak minimal, tidak ada tindakan perbaikan diperlukan",
  "nce.status.open": "Buka",
  "nce.status.underInvestigation": "Dalam Investigasi",
  "nce.tree.empty": "Tidak ada pemesanan ditemukan. Cari nomor lab untuk mulai.",
  "nce.tree.loading": "Memuat pemesanan...",
  "nce.tree.order": "Pemesanan",
  "nce.tree.search": "Filter berdasarkan pemeriksaan atau sampel...",
  "nce.tree.selected": "{sampleCount} sampel, {resultCount} hasil dipilih",
  "nce.trigger.order_cancellation": "Pembatalan pesanan dapat memerlukan dokumen KTS",
  "nce.trigger.partial_sample_rejection": "Penolakan sampel parsial memerlukan dokumentasi KTS",
  "nce.trigger.pathology_rejection": "Penolakan kasus patologi dapat memerlukan dokumentasi KTS",
  "nce.trigger.premature_disposal": "Pemusnahan sebelum waktunya dapat memerlukan dokumen KTS",
  "nce.trigger.qc_invalidation": "Invalidasi QC memerlukan dokumentasi KTS",
  "nce.trigger.referral_rejection": "Penolakan rujukan memerlukan dokumentasi KTS",
  "nce.trigger.result_rejection_no_retest": "Penolakan hasil tanpa pengujian ulang memerlukan dokumentasi KTS",
  "nce.trigger.result_rejection_retest": "Penolakan hasil tanpa pengujian ulang dapat memerlukan dokumentasi KTS",
  "nce.trigger.sample_rejection": "Penolakan sampel memerlukan dokumentasi KTS",
  "nce.trigger.test_cancel_no_results": "Pembatalan pengujian memerlukan dokumen KTS",
  "nce.trigger.test_cancel_with_results": "Pembatalan pengujian dengan hasil memerlukan dokumen KTS",
  "nce.type.calibration_failure": "Kegagalan kalibrasi",
  "nce.type.communication_failure": "Kegagalan komunikasi",
  "nce.type.contamination": "Kontaminasi",
  "nce.type.documentation_error": "Kesalahan dokumentasi",
  "nce.type.equipment_malfunction": "Malfungsi alat",
  "nce.type.labeling_error": "Kesalahan pelabelan",
  "nce.type.patient_id_mismatch": "Salah mencocokkan identitas pasien",
  "nce.type.policy_violation": "Pelanggaran kebijakan",
  "nce.type.procedure_deviation": "Penyimpangan prosedur",
  "nce.type.qc_failure": "Kegagalan QC",
  "nce.type.reagent_issue": "Masalah reagen",
  "nce.type.report_delay": "Laporan terlambat",
  "nce.type.report_distribution_error": "Kesalahan distribusi laporan",
  "nce.type.requisition_incomplete": "Permintaan pemeriksaan tidak lengkap",
  "nce.type.resource_shortage": "Kurang sumber daya",
  "nce.type.result_interpretation_error": "Kesalahan interpretasi hasil",
  "nce.type.sample_collection_error": "Kesalahan pengambilan sampel",
  "nce.type.staff_competency_issue": "Masalah kompetensi pegawai",
  "nce.type.storage_error": "Kesalahan penyimpanan",
  "nce.type.system_error": "Kesalahan sistem",
  "nce.type.training_gap": "Kesenjangan pelatihan",
  "nce.type.transcription_error": "Kesalanan transkripsi",
  "nce.type.transport_issue": "Masalah transportasi",
  "nce.type.request_form_error": "Kesalahan formulir permintaan",
  "nce.type.equipment_failure": "Kegagalan alat",
  "nce.type.procedure_error": "Kesalahan prosedur",
  "nce.type.calibration_error": "Kesalahan kalibrasi",
  "nce.type.cross_contamination": "Kontaminasi silang",
  "nce.type.result_transcription_error": "Kesalahan transkripsi hasil",
  "nce.type.report_delivery_error": "Kesalahan pengiriman hasil",
  "nce.type.critical_value_not_reported": "Nilai kritis tidak dilaporkan",
  "nce.type.delayed_result": "Hasil terlambat",
  "nce.type.result_amendment": "Amendemen hasil",
  "nce.type.training_issue": "Masalah pelatihan",
  "nce.category.analysis": "Analysis",
  "nce.category.general": "General",
  "nce.category.order": "Pemesanan",
  "nce.category.sample": "Sampel",
  "nce.type.barcodeIssue": "Barcode Issue",
  "nce.type.brokenTubeContainer": "Broken Tube/Container",
  "nce.type.calibrationIssue": "Calibration Issue",
  "nce.type.coagulatedSample": "Coagulated Sample",
  "nce.type.contaminationClient": "Contamination - client",
  "nce.type.contaminationInternal": "Contamination - internal",
  "nce.type.demographicError": "Demographic error",
  "nce.type.employeeConcern": "Employee concern",
  "nce.type.expiredReagentMaterial": "Expired Reagent/Material",
  "nce.type.formIncorrect": "Form incorrect",
  "nce.type.formMissing": "Form missing",
  "nce.type.haemolyticSample": "Hemolytic sample",
  "nce.type.improperSpecimenCollection": "Improper Specimen Collection",
  "nce.type.inadequateSampling": "Inadequate Sampling",
  "nce.type.incorrectMeasurement": "Incorrect measurement of sample or reagent",
  "nce.type.instrumentDowntime": "Instrument Downtime",
  "nce.type.insufficientAmount": "Insufficient Amount",
  "nce.type.inventoryStorage": "Inventory Storage",
  "nce.type.leakage": "Leakage",
  "nce.type.lostSpecimenIrreplacable": "Lost Specimen - Irreplaceable",
  "nce.type.lostSpecimenRedraw": "Lost Specimen - Redraw",
  "nce.type.lotNumberIssue": "Lot Number Issue",
  "nce.type.mislabeledUnlabeled": "Mislabeled/unlabeled specimen",
  "nce.type.missingSample": "Missing Sample",
  "nce.type.otherDescribe": "Other, please describe",
  "nce.type.rerunEquipmentFailure": "Rerun - Equipment Failure",
  "nce.type.rerunInconsistentResults": "Rerun - Inconsistent Results",
  "nce.type.rerunQCFailure": "Rerun- QC Failure",
  "nce.type.resultReported": "Result reported when quality control sample tested out of range",
  "nce.type.sopDeviation": "SOP Deviation (please describe)",
  "nce.type.specimenReceiptDelay": "Specimen Receipt Delay",
  "nce.type.spill": "Spill",
  "nce.type.technologyIssue": "Technology/Computer issue",
  "nce.type.transmissionDelay": "Transmission Delay",
  "nce.type.wrongSpecimen": "Wrong specimen",
  "nce.type.wrongTemperature": "Wrong temperature",
  "nce.type.wrongTestKit": "Wrong Test Kit",
  "nce.button.createNce": "Buat KTS",
  "nce.button.skip": "Lewati",
  "nce.creating": "Membuat KTS...",
  "nce.description.placeholder": "Deskripsikan kejadian ketidaksesuaian...",
  "nce.error.create.failed": "Gagal membuat KTS",
  "nce.error.severity.required": "Keparahan wajib ada",
  "nce.trigger.mandatory.message": "Anda harus membuat KTS sebelum dapat lanjut dengan aksi ini.",
  "nce.trigger.mandatory.title": "KTS wajib ada",
  "nce.trigger.order_cancellation.message": "Pembatalan pesanan dapat memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.order_cancellation.title": "Pembatalan Pemesanan - KTS",
  "nce.trigger.partial_sample_rejection.message": "Penolakan sampel parsial memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.partial_sample_rejection.title": "Penolakan Sampel Parsial - Wajib Ada KTS",
  "nce.trigger.pathology_rejection.message": "Penolakan kasus patologi dapat memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.pathology_rejection.title": "Penolakan Patologi - KTS",
  "nce.trigger.premature_disposal.message": "Pemusnahan sebelum waktunya dapat memerlukan dokumen kejadian ketidaksesuaian.",
  "nce.trigger.premature_disposal.title": "Pemusnahan Sebelum Waktunya - KTS",
  "nce.trigger.qc_invalidation.message": "Invalidasi QC memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.qc_invalidation.title": "Invalidasi QC - Wajib Ada KTS",
  "nce.trigger.referral_rejection.message": "Penolakan rujukan memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.referral_rejection.title": "Penolakan Rujukan - Wajib Ada KTS",
  "nce.trigger.result_rejection_no_retest.message": "Penolakan hasil tanpa pengujian ulang memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.result_rejection_no_retest.title": "Penolakan Hasil - Wajib Ada KTS",
  "nce.trigger.result_rejection_retest.message": "Penolakan hasil dengan pengujian ulang dapat memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.result_rejection_retest.title": "Penolakan Hasil - KTS",
  "nce.trigger.sample_rejection.message": "Penolakan sampel memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.sample_rejection.title": "Penolakan Sampel - Wajib Ada KTS",
  "nce.trigger.test_cancel_no_results.message": "Pembatalan pemeriksaan dapat memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.test_cancel_no_results.title": "Pembatalan Pemeriksaan - KTS",
  "nce.trigger.test_cancel_with_results.message": "Pembatalan pemeriksaan dengan hasil memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.test_cancel_with_results.title": "Pembatalan Pemeriksaan - KTS wajib ada",
  "nce.admin.trigger.config.title": "Konfigurasi Trigger Ketidaksesuaian",
  "nce.admin.trigger.config.description": "Konfigurasi pembuatan Kejadian Ketidaksesuaian secara otomatis",
  "nce.admin.trigger.behaviors.title": "Perilaku Trigger",
  "nce.admin.rejection.mappings.title": "Pemetaan Alasan Penolakan",
  "nce.admin.rejection.mappings.description": "Pemetaan alasan penolakan terhadap kategori KTS untuk mengisi otomatis.",
  "nce.trigger.behavior.mandatory": "Wajib",
  "nce.trigger.behavior.prompted": "Dipicu",
  "nce.trigger.behavior.disabled": "Dinonaktifkan",
  "nce.trigger.column.type": "Tipe Trigger",
  "nce.trigger.column.description": "Deskripsi",
  "nce.trigger.column.behavior": "Perilaku",
  "nce.trigger.column.active": "Aktif",
  "nce.trigger.type.sampleRejection": "Penolakan Sampel",
  "nce.trigger.type.resultRejection": "Penolakan Hasil",
  "nce.trigger.type.qaEvent": "Acara QA",
  "nce.trigger.type.manual": "Panduan",
  "nce.trigger.update.success": "Konfigurasi trigger diperbarui",
  "nce.trigger.update.error": "Gagal memperbarui konfigurasi trigger",
  "nce.mapping.add": "Tambah Pemetaan",
  "nce.mapping.edit": "Edit Pemetaan",
  "nce.mapping.column.rejectionReason": "Alasan Penolakan",
  "nce.mapping.column.category": "Kategori KTS",
  "nce.mapping.column.type": "Jenis KTS",
  "nce.mapping.column.severity": "Keparahan Default",
  "nce.mapping.column.active": "Aktif",
  "nce.mapping.noData": "Tidak ada konfigurasi pemetaan penolakan",
  "nce.mapping.validation.error": "Wajib ada alasan dan kategori penolakan",
  "nce.mapping.save.success": "Pemetaan berhasil disimpan",
  "nce.mapping.active": "Aktif",
  "nce.field.category": "Kategori",
  "nce.field.type": "Jenis",
  "nce.select.category": "Pilih Kategori",
  "nce.select.type": "Pilih jenis",
  "nce.error.dateOfEvent.required": "Wajib ada tanggal kejadian",
  "nce.error.reportingUnit.required": "Instalasi yang melaporkan wajib ada",
  "nce.error.description.required": "Deksripsi wajib ada",
  "nce.error.suspectedCauses.required": "Penyebab suspek wajib ada",
  "nce.error.proposedAction.required": "Tindakan yang diusulkan wajib ada",
  "nce.error.category.required": "Kategori wajib ada",
  "nce.attachment.saveFirst": "Simpan kejadian KTS untuk mengaktifkan lampiran file",
  "nce.attachment.error.noEvent": "Mohon simpan kejadian KTS terlebih dahulu sebelum mengunggah lampiran",
  "nce.attachment.download": "Unduh",
  "nce.attachment.delete": "Hapus",
  "requester.add.new.restricted": "Fitur penambahan organisasi baru telah dinonaktifkan oleh administrator Anda.",
  "requester.add.new.restricted.organization.contact": "Fitur untuk memasukkan informasi kontak organisasi baru telah dinonaktifkan oleh administrator Anda. Silakan cari organisasi yang sudah ada di bagian atas.",
  "requester.add.new.restricted.provider": "Fitur penambahan penyelenggara baru telah dinonaktifkan oleh administrator Anda.",
  "requester.add.new.restricted.provider.contact": "Fitur pengisian informasi kontak untuk penyelenggara layanan baru telah dinonaktifkan oleh administrator Anda. Silakan cari penyelenggara yang sudah ada di bagian atas.",
  "requester.add.new.restricted.requestor": "Penambahan pemohon baru telah dinonaktifkan oleh administrator Anda. Silakan cari pemohon yang sudah ada di atas.",
  "requester.contact.search": "Cari Pemohon",
  "requester.contact.search.helper": "Cari nama kontak yang mengajukan permintaan Pemeriksaan ini, atau masukkan nama kontak baru di bawah ini. Setidaknya salah satu dari \"Organisasi Pemohon\" atau \"Pemohon\" wajib diisi.",
  "requester.organization.add.new": "+ Tambah organisasi baru \"{name}\"",
  "requester.organization.email": "Alamat Email Organisasi",
  "requester.organization.fax": "No. Telp Organisasi",
  "requester.organization.new.helper": "Akan dibuat sebagai organisasi baru saat pemesanan ini disimpan.",
  "requester.organization.new.tag": "Baru",
  "requester.organization.no.match": "Tidak ditemukan organisasi yang sesuai.",
  "requester.organization.phone": "Nomor Telepon Organisasi",
  "requester.organization.search": "Pencarian Organisasi Pemohon",
  "requestor.add.new": "+ Tambah pemohon baru \"{name}\"",
  "requestor.add.new.restricted": "Fitur penambahan pemohon baru telah dinonaktifkan oleh administrator Anda.",
  "requestor.department": "Departemen",
  "requestor.email": "Email",
  "requestor.fax": "No. Telp",
  "requestor.firstName": "Nama Depan",
  "requestor.lastName": "Nama Belakang",
  "requestor.name": "Nama Pemohon",
  "requestor.name.placeholder": "Masukkan nama pemohon",
  "requestor.new.helper": "Akan dibuat sebagai pemohon baru saat pemesanan ini disimpan.",
  "requestor.new.tag": "Baru",
  "requestor.no.match": "Tidak ditemukan pemohon yang sesuai.",
  "requestor.phone": "Telepon",
  "requestor.search.helper": "Ketik minimal 2 karakter untuk melakukan pencarian otomatis.",
  "result.compliance.fail": "FAIL",
  "result.compliance.pass": "PASS",
  "result.pool.filter.allLots": "Semua lot",
  "result.pool.filter.allPools": "Semua kolam renang",
  "result.pool.filter.clear": "Hapus filter",
  "result.pool.filter.count": "Menampilkan {shown} dari {total} hasil",
  "result.pool.filter.lot": "Filter oleh lot",
  "result.pool.filter.pool": "Saring berdasarkan kolam renang",
  "result.pool.intake": "Kolam penampungan",
  "result.pool.subpool": "Sub-kelompok {n}",
  "result.vectorPool.label": "Pool berisi {count} {animal}",
  "results.uncertainty.column.label": "U (k=2)",
  "results.uncertainty.validation.negative": "Ketidakpastian harus berupa bilangan non-negatif.",
  "results.uncertainty.value.prefix": "±",
  "sample.fallback.name": "Sampel",
  "sample.priority.ASAP": "ASAP",
  "sample.priority.FUTURE_STAT": "STAT Mendatang",
  "sample.priority.ROUTINE": "Rutin",
  "sample.priority.STAT": "STAT (Mendesak)",
  "sample.priority.TIMED": "Terjadwal",
  "sample.referToReferenceLab.helper": "Tandai jika sampel ini wajib diuji di laboratorium rujukan eksternal.",
  "sampleAcceptance.action.moveDown": "Geser ke bawah",
  "sampleAcceptance.action.moveUp": "Geser ke atas",
  "sampleAcceptance.banner.resampledFrom": "Ini adalah sampel pengganti yang dibuat melalui pengambilan ulang dari sampel #{id}.",
  "sampleAcceptance.banner.resampledFrom.title": "Sampel pengganti",
  "sampleAcceptance.banner.resampledTo": "Sampel ini ditolak dan diambil ulang. Pemesanan pengganti: {accession}.",
  "sampleAcceptance.banner.resampledTo.title": "Diambil sampel ulang",
  "sampleAcceptance.button.addItem": "Tambah item",
  "sampleAcceptance.col.active": "Aktif",
  "sampleAcceptance.col.label": "Label",
  "sampleAcceptance.col.order": "Pemesanan",
  "sampleAcceptance.col.statusForDomain": "Status domain ini",
  "sampleAcceptance.domain.all": "Semua domain",
  "sampleAcceptance.domain.clinical": "Klinis",
  "sampleAcceptance.domain.environmental": "Lingkungan",
  "sampleAcceptance.domain.vector": "Vektor",
  "sampleAcceptance.enforcement.help": "Penegakan aturan ditetapkan per domain, bukan per instalasi lab — seorang petugas resepsionis melayani banyak instalasi lab.",
  "sampleAcceptance.enforcement.label": "Penegakan daftar periksa — {domain}",
  "sampleAcceptance.enforcement.mandatory": "Wajib — tahan Langkah 3 hingga selesai",
  "sampleAcceptance.enforcement.off": "Matikan — sembunyikan daftar periksa",
  "sampleAcceptance.enforcement.optional": "Opsional — rekam tetapi jangan blokir",
  "sampleAcceptance.gate.blocked": "Penerimaan spesimen wajib dilakukan untuk domain ini - terima setiap spesimen (atau laporkan NCE / ambil spesimen ulang) sebelum pemesanan ini dapat dilanjutkan.",
  "sampleAcceptance.labWide.heading": "Ketentuan yang berlaku di seluruh laboratorium (terapkan kecuali jika ada ketentuan di tingkat domain yang menggantikannya)",
  "sampleAcceptance.labWide.inherited": "Item yang berlaku di seluruh lab — diwarisi (fallback aktif)",
  "sampleAcceptance.labWide.superseded": "Item yang berlaku di seluruh laboratorium — digantikan di sini (diedit dari “Semua domain”)",
  "sampleAcceptance.notify.enforcementSaved": "Penegakan aturan diperbarui",
  "sampleAcceptance.notify.itemAdded": "Item daftar periksa telah ditambah",
  "sampleAcceptance.notify.itemSaved": "Item daftar periksa telah disimpan",
  "sampleAcceptance.notify.recordFailed": "Gagal mencatat penerimaan",
  "sampleAcceptance.notify.rejectFailed": "Gagal menolak",
  "sampleAcceptance.notify.resampleFailed": "Gagal melakukan resampling",
  "sampleAcceptance.ownItems.empty": "Belum ada item — domain ini akan dialihkan ke daftar untuk seluruh laboratorium di bawah ini.",
  "sampleAcceptance.ownItems.heading": "Item {domain}",
  "sampleAcceptance.qa.accepted.success": "Penerimaan telah dicatat",
  "sampleAcceptance.qa.answer.fail": "Gagal",
  "sampleAcceptance.qa.answer.na": "N/A",
  "sampleAcceptance.qa.answer.pass": "Lolos",
  "sampleAcceptance.qa.button.accept": "Terima sampel",
  "sampleAcceptance.qa.button.reject": "Tolak",
  "sampleAcceptance.qa.button.resample": "Ambil Sampel Ulang",
  "sampleAcceptance.qa.context.collected": "Diambil",
  "sampleAcceptance.qa.context.longTransit": "waktu transit yang lama — terserah Anda",
  "sampleAcceptance.qa.context.note": "Transit hanya ditampilkan sebagai referensi — sistem ini tidak melakukan penilaian otomatis apa pun. Daftar aktif: {domain}.",
  "sampleAcceptance.qa.context.received": "Diterima",
  "sampleAcceptance.qa.context.transit": "Waktu transit",
  "sampleAcceptance.qa.empty": "Tidak ada daftar periksa penerimaan yang dikonfigurasi untuk domain ini.",
  "sampleAcceptance.qa.failHint": "Sampel ini gagal pemeriksaan — laporkan sebagai NCE atau ambil sampel ulang, jangan diterima.",
  "sampleAcceptance.qa.failHint.reject": "This sample has failed checks. Report an NCE or reject it instead of accepting.",
  "sampleAcceptance.qa.noSample": "Simpan pengambilan untuk melakukan penerimaan spesimen ini.",
  "sampleAcceptance.qa.note.label": "Catatan (Opsional)",
  "sampleAcceptance.qa.note.placeholder": "Opsional — catat kondisi apa saja yang diamati",
  "sampleAcceptance.qa.status.accepted": "Diterima",
  "sampleAcceptance.qa.status.pending": "Tertunda",
  "sampleAcceptance.qa.status.rejected": "Ditolak",
  "sampleAcceptance.qa.status.review": "Tinjauan",
  "sampleAcceptance.qa.subtitle": "Selesaikan daftar periksa penerimaan untuk sampel ini",
  "sampleAcceptance.qa.subtitle.rejected": "Spesimen ini ditolak dan diambil sampelnya kembali — hanya untuk dibaca.",
  "sampleAcceptance.qa.subtitle.rejectedEqa": "This sample was rejected — read-only.",
  "sampleAcceptance.qa.subtitle.rejectedVector": "Penangkapan ini ditolak — hanya baca.",
  "sampleAcceptance.qa.title": "Penerimaan pendaftaran",
  "sampleAcceptance.reject.commit": "Konfirmasi penolakan",
  "sampleAcceptance.reject.comment.label": "Komentar (opsional)",
  "sampleAcceptance.reject.info": "Tolak hasil tangkapan ini karena tidak layak pakai. Hasil tangkapan ini tidak dapat diambil ulang, sehingga tidak dibuat pemesanan pengganti.",
  "sampleAcceptance.reject.info.eqa": "Reject this proficiency-testing sample. PT material cannot be recollected, so no replacement order is created.",
  "sampleAcceptance.reject.reason.label": "Alasan (sudah terisi otomatis dari item yang gagal — dapat diedit)",
  "sampleAcceptance.reject.reason.required": "Alasan wajib diisi",
  "sampleAcceptance.reject.success": "Sampel ditolak.",
  "sampleAcceptance.reject.title": "Tolak — {labNumber}",
  "sampleAcceptance.resample.commit": "Lakukan resampling",
  "sampleAcceptance.resample.info": "Tolak sampel ini dan buat pemesanan pengambilan baru untuk pengambilan ulang. Pemohon akan diberi tahu.",
  "sampleAcceptance.resample.reason.label": "Alasan (sudah terisi otomatis dari item yang gagal — dapat diedit)",
  "sampleAcceptance.resample.reason.required": "Alasan wajib diisi",
  "sampleAcceptance.resample.success": "Pengambilan sampel ulang telah dibuat - pemesanan baru {accession}. Pemohon telah diberi tahu.",
  "sampleAcceptance.resample.title": "Ambil Sampel Ulang - {labNumber}",
  "sampleAcceptance.review.col.eligibility": "Persyaratan Kelayakan",
  "sampleAcceptance.review.col.labNo": "Lab #",
  "sampleAcceptance.review.col.sampleType": "Jenis sampel",
  "sampleAcceptance.review.col.transit": "Transit",
  "sampleAcceptance.review.noSamples": "Tidak ada spesimen yang dikumpulkan untuk ditinjau.",
  "sampleAcceptance.review.subtitle": "Pilih sampel untuk menyelesaikan daftar periksa penerimaannya",
  "sampleAcceptance.review.title": "Penerimaan Pendaftaran",
  "sampleAcceptance.status.active": "Aktif",
  "sampleAcceptance.status.inactive": "Inaktif",
  "sampleAcceptance.status.inheritedActive": "Aktif (diwariskan)",
  "sampleAcceptance.status.superseded": "Digantikan",
  "sampleAcceptance.title": "Daftar Periksa Penerimaan Sampel",
  "sidenav.label.admin.nceTriggerConfig": "Konfigurasi Trigger",
  "sidenav.label.admin.nceCategoryType": "Kategori & Jenis",
  "sidenav.label.admin.nceConfig": "Konfigurasi Ketidaksesuaian",
  "nce.admin.categorytype.title": "Konfigurasi Kategori dan Jenis Ketidaksesuaian",
  "nce.admin.categorytype.description": "Kelola kategori dan jenis yang ada untuk Kejadian Ketidaksesuaian.",
  "nce.admin.tab.categories": "Kategori",
  "nce.admin.tab.types": "Jenis",
  "nce.admin.category.add": "Tambah Kategori",
  "nce.admin.category.edit": "Edit Kategori",
  "nce.admin.category.name.required": "Nama kategori wajib ada",
  "nce.admin.category.save.success": "Kategori berhasil disimpan",
  "nce.admin.category.save.error": "Gagal menyimpan kategori",
  "nce.admin.type.add": "Tambah Jenis",
  "nce.admin.type.edit": "Edit Jenis",
  "nce.admin.type.validation.error": "Nama dan jenis kategori wajib ada",
  "nce.admin.type.save.success": "Jenis berhasil disimpan",
  "nce.admin.type.save.error": "Gagal menyimpan jenis",
  "nce.admin.column.name": "Nama",
  "nce.admin.column.displayKey": "Tombol Tampilan",
  "nce.admin.column.typesCount": "Jumlah Jenis",
  "nce.admin.column.category": "Kategori",
  "nce.admin.column.actions": "Tindakan",
  "nce.admin.field.name": "Nama",
  "nce.admin.field.displayKey": "Display Key (untuk i18n)",
  "nce.admin.field.displayKey.helper": "Opsional. Digunakan untuk terjemahan.",
  "nce.admin.field.category": "Kategori",
  "nce.admin.delete.confirm.title": "Konfirmasi Penghapusan",
  "nce.admin.delete.confirm.message": "Apakah Anda yakin mau menghapus '{name}'? Aksi ini tidak dapat dibatalkan.",
  "nce.admin.delete.success": "Berhasil dihapus",
  "nce.inline.title": "Lapor Kejadian Ketidaksesuaian",
  "nce.inline.context": "KONTEKS (Auto-populated)",
  "nce.dashboard.breadcrumb": "NCE > All NCEs",
  "nce.dashboard.title": "Semua KTS",
  "nce.dashboard.subtitle": "Semua KTS yang terbuka di semua instalasi",
  "nce.dashboard.daysSince": "{count} days",
  "nce.button.reportNce": "Lapor KTS",
  "nce.search.placeholder": "Cari KTS...",
  "nce.filter.allStatus": "Semua Status",
  "nce.filter.allCategories": "Semua Kategori",
  "nce.filter.allSeverities": "Semua Keparahan",
  "nce.filter.clearAll": "Hapus Semua",
  "nce.summary.critical": "Kritis",
  "nce.summary.major": "Mayor",
  "nce.summary.minor": "Minor",
  "nce.summary.overdue": "Lewat tenggat",
  "nce.tag.overdue": "Lewat tenggat",
  "nce.tab.eventDetails": "Rincian Kejadian",
  "nce.tab.investigation": "Investigasi",
  "nce.tab.capa": "CAPA",
  "nce.tab.history": "Riwayat",
  "nce.field.suspectedCauses": "Penyebab Diduga",
  "nce.field.proposedAction": "Tindakan Yang Diusulkan",
  "nce.field.trigger": "Pemicu",
  "nce.capReason.time_24h": "{count} sampel tertaut, dibatasi rentang waktu 24 jam",
  "nce.capReason.count_50": "{count} sampel tertaut, dibatasi 50 terbaru",
  "nce.capa.noItems": "Belum ada tindakan perbaikan/pencegahan yang terekam.",
  "nce.capa.dueDate": "Tanggal Jatuh Tempo",
  "nce.history.noItems": "Tidak ada riwayat tersedia.",
  "nce.history.system": "Sistem",
  "nce.action.acknowledge": "Mengetahui",
  "nce.action.assignTo": "Ditugaskan Ke",
  "nce.action.addNote": "Tambah Catatan",
  "nce.action.close": "Tutup KTS",
  "nce.action.startCorrectiveAction": "Mulai Tindakan Perbaikan",
  "nce.link.duplicate.warning": "Spesimen ini sudah terkait ke KTS ini",
  "nce.list.empty": "Tidak ada KTS yang cocok dengan kriteria Anda.",
  "nce.modal.addNote": "Tambah Catatan",
  "nce.modal.addNoteDescription": "Tambah catatan ke KTS {nceNumber}",
  "nce.modal.notePlaceholder": "Masukkan catatatn Anda...",
  "nce.modal.assign": "Tugaskan KTS",
  "nce.modal.assignDescription": "Tugaskan KTS {nceNumber} ke pengguna",
  "nce.modal.selectUser": "Pilih Pengguna",
  "nce.modal.searchUser": "Cari pengguna...",
  "nce.assign.selectUser": "Pilih pengguna untuk menugaskan",
  "nce.assign.success": "KTS berhasil ditugaskan",
  "nce.assign.error": "Gagal menugaskan KTS",
  "nce.acknowledge.success": "KTS berhasil diketahui",
  "nce.acknowledge.error": "Gagal mengetahui KTS",
  "nce.note.empty": "SIlahkan masukan catatan",
  "nce.note.success": "Catatan berhasil ditambah",
  "nce.note.error": "Gagal menambah catatan",
  "nce.attachment.downloadError": "Gagal mengunduh lampiran",
  "nce.attachment.viewError": "Gagal melihat lampiran",
  "not.available": "Tidak tersedia",
  "not.specified": "Tidak dispesifikasi",
  "notAuthenticated": "Tidak diotentikasi",
  "notebook.attachments.title": "Lampiran",
  "notebook.attachments.uploadPrompt": "Klik untuk mengunggah file",
  "notebook.auditTrail.action.archived": "Diarsipkan",
  "notebook.auditTrail.action.created": "Dibuat",
  "notebook.auditTrail.action.finalized": "Difinalisasi",
  "notebook.auditTrail.action.locked": "Terkunci",
  "notebook.auditTrail.action.submitted": "Dikirim",
  "notebook.auditTrail.action.updated": "Terbarui",
  "notebook.auditTrail.comingSoon": "Fungsionalitas Jejak Audit akan segera tersedia.",
  "notebook.auditTrail.none.subtitle": "Entri Jejak Audit untuk Notebook ini tidak tersedia.",
  "notebook.auditTrail.none.title": "Jejak Audit tidak tersedia",
  "notebook.auditTrail.title": "Jejak Audit",
  "notebook.button.edit": "Edit",
  "notebook.button.editResults": "Edit Hasil",
  "notebook.button.enterResults": "Masukkan Hasil",
  "notebook.button.newLabNotebook": "Proyek",
  "notebook.button.view": "Lihat",
  "notebook.comments.add.button": "Tambah Komentar",
  "notebook.comments.add.label": "Tambah Komentar",
  "notebook.comments.none.subtitle": "Komentar belum ditambah.",
  "notebook.comments.none.title": "Belum ada komentar",
  "notebook.comments.title": "Komentar",
  "notebook.error.notAssigned": "Anda tidak ditugaskan pada proyek ini",
  "notebook.heading.allEntries": "Semua Entri",
  "notebook.heading.notebooks": "Proyek",
  "notebook.icon.edit": "Edit",
  "notebook.instruments.title": "Alat",
  "notebook.label.addpage": "Tambah Laman",
  "notebook.label.author": "Pengarang",
  "notebook.label.basicinfo": "Informasi Dasar",
  "notebook.label.content": "Isi Utama",
  "notebook.label.dashboard": "Dasbor Notebook",
  "notebook.label.drafts": "Draf",
  "notebook.label.entry": "Entri Notebook",
  "notebook.label.entryFiles": "File Entri",
  "notebook.label.instanceEntry": "Entri Instansi Notebook",
  "notebook.label.entryTags": "Tag Entri",
  "notebook.label.experimentDoc": "Dokumen Eksperimen",
  "notebook.label.experimentType": "Jenis Eksperimen",
  "notebook.label.filter.types": "Jenis Eksperimen",
  "notebook.label.finalized": "Difinalkan minggu ini",
  "notebook.label.formEntry": "Entri Formulir Notebook",
  "notebook.label.objective": "Tujuan",
  "notebook.label.pages": "Halaman Alur Kerja",
  "notebook.label.pending": "Tinjauan Tertunda",
  "notebook.label.project": "Proyek",
  "notebook.label.project.title": "Judul Proyek",
  "notebook.label.projectFiles": "File Proyek",
  "notebook.label.projectTags": "Tag Proyek",
  "notebook.label.protocol": "Nomor Protokol",
  "notebook.label.questionnaire": "Kuesioner",
  "notebook.label.sampleManagement": "Pengelolaan Sampel",
  "notebook.label.status": "Status",
  "notebook.label.technician": "Petugas",
  "notebook.label.title": "Judul Entri",
  "notebook.label.total": "Entri Total",
  "notebook.page.completed": "Selesai",
  "notebook.page.content": "Isi:",
  "notebook.page.instructions": "Petunjuk:",
  "notebook.page.markComplete": "Tandai sebagai Selesai",
  "notebook.page.modal.add.errorRequired": "Judul dan isi diperlukan.",
  "notebook.page.modal.add.title": "Tambah Halaman Baru",
  "notebook.page.modal.content.label": "Isi",
  "notebook.page.modal.edit.title": "Edit Halaman",
  "notebook.page.modal.instructions.label": "Petunjuk",
  "notebook.page.modal.title.label": "Judul",
  "notebook.page.title": "Notebook",
  "notebook.pages.none.subtitle": "Klik untuk menambah Halaman",
  "notebook.pages.none.title": "Tidak ada Halaman yang ditambah",
  "notebook.project.definition.form.title": "Formulir Definisi Proyek",
  "notebook.project.entry.form.title": "Formulir Entri Proyek",
  "notebook.results.modal.title": "Hasil untuk {accession}",
  "notebook.results.noAccession": "Sampel ini tidak memiliki nomor registrasi",
  "notebook.results.none.subtitle": "Hasil tidak ditemukan untuk nomor registrasi yang diberikan.",
  "notebook.results.none.title": "Hasil tidak ditemukan",
  "notebook.results.title": "Hasil",
  "notebook.sample.result.dateCreated": "Tanggal dibuat",
  "notebook.samples.available": "Sampel yang tersedia",
  "notebook.samples.none.subtitle": "Pencarian Sampel berdasarkan Pasien atau Nomor Registrasi",
  "notebook.samples.none.subtitle.selected": "Klik untuk menambah sampel",
  "notebook.samples.none.title": "Tidak ada sampel yang tersedia",
  "notebook.samples.none.title.selected": "Tidak ada sampel yang dipilih",
  "notebook.samples.resultsRecorded": "Hasil yang terekam:",
  "notebook.samples.selected": "Sampel yang dipilih",
  "notebook.search.byAccession": "Cari berdasarkan Aksesi",
  "notebook.search.byPatient": "Cari berdasarkan Pasien",
  "notebook.select.label": "Pilih Notebook",
  "notebook.select.none": "Tidak ada - hanya kolom bawaan",
  "notebook.select.optional": "Pilih notebook (opsional)",
  "notebook.status.archived": "Entri arsip",
  "notebook.status.assignment.title": "Status dan Penugasan",
  "notebook.status.draft": "Simpan draf",
  "notebook.status.finalized": "Finalisasi Entri",
  "notebook.status.locked": "Kunci Entri",
  "notebook.status.metadata.title": "Status & Metadata",
  "notebook.status.submitted": "Kirim untuk Peninjauan",
  "notebook.tab.attachments": "Lampiran",
  "notebook.tab.auditTrail": "Jejak Audit",
  "notebook.tab.comments": "Komentar",
  "notebook.tab.content": "Isi",
  "notebook.tab.entryDetails": "Rincian Entri",
  "notebook.tab.metadata": "MetaData",
  "notebook.tab.results": "Hasil",
  "notebook.tab.samples": "Sampel",
  "notebook.tab.workflow": "Alur Kerja",
  "notebook.table.header.entries": "Entri",
  "notebook.tag.placeholder": "Masukkan Tag",
  "notebook.tags.add": "Tambah Tag",
  "notebook.tags.modal.add.errorRequired": "Tag diperlukan",
  "notebook.tags.modal.add.label": "Tag",
  "notebook.tags.modal.add.title": "Tambah Tag Baru",
  "notebook.tags.title": "Tag",
  "notebook.validation.content.required": "Isi Utama diperlukan.",
  "notebook.validation.objective.required": "Tujuan diperlukan.",
  "notebook.validation.project.required": "Proyek diperlukan.",
  "notebook.validation.protocol.required": "Nomor protokol diperlukan.",
  "notebook.validation.title.required": "Judul diperlukan.",
  "notebook.validation.type.required": "Jenis eksperimen diperlukan.",
  "notification.error": "Error",
  "notification.info": "Informasi",
  "notification.invalid.confirm.password": "Kata Kunci tidak sama dengan di atas.",
  "notification.invalid.loginName": "Masukkan nilai alfanumerik tanpa spasi.",
  "notification.invalid.name": "Hanya masukkan nilai alfanumerik.",
  "notification.invalid.password": "Masukkan Kata Kunci sesuai petunjuk.",
  "notification.login.generic.error": "Error saat login",
  "notification.login.syntax.error": "Terjadi error saat mencoba masuk - Tidak dapat mengurai respons ke JSON",
  "notification.organization.post.delete.success": "Organisasi berhasil dinonaktifkan.",
  "notification.organization.post.internetAddress": "Masukkan URL organisasi yang valid.",
  "notification.organization.post.save.success": "Penambahan Informasi Organisasi Berhasil.",
  "notification.organization.post.success": "Pembaruan Informasi Organisasi Berhasil.",
  "notification.password.change.fail": "Perubahan Kata Kunci gagal",
  "notification.password.change.success": "Kata Kunci berhasil diubah",
  "notification.response.syntax.error": "Error -  Tidak dapat mengurai respon ke JSON",
  "notification.resultSelectList.post.save.success": "Daftar pilihan hasil berhasil disimpan.",
  "notification.resultSelectList.post.update.success": "Daftar pilihan hasil berhasil diperbarui.",
  "notification.slideover.button.hideread": "Sembunyikan dibaca",
  "notification.slideover.button.markallasread": "Tandai semua sebagai dibaca",
  "notification.slideover.button.markasread": "Tandai sebagai dibaca",
  "notification.slideover.button.reload": "Muat ulang",
  "notification.slideover.button.showread": "Tampilkan dibaca",
  "notification.slideover.button.subscribe": "Berlangganan di Perangkat ini",
  "notification.slideover.button.subscribe.fail": "Berlangganan gagal",
  "notification.slideover.button.subscribe.success": "Berlangganan berhasil",
  "notification.slideover.button.unsubscribe": "Berhenti berlangganan",
  "notification.slideover.button.unsubscribe.fail": "Berhenti berlangganan gagal",
  "notification.slideover.button.unsubscribe.success": "Berhenti berlangganan berhasil",
  "notification.slideover.empty.header": "Semua sudah dibaca",
  "notification.sliderover.empty.message": "Tidak ada notifikasi saat ini",
  "notification.success": "Berhasil",
  "notification.title": "Pesan notifikasi",
  "notification.user.add.success": "Informasi pengguna berhasil ditambahkan.",
  "notification.user.post.delete.success": "Penguna berhasil dinonaktifkan.",
  "notification.user.post.save.success": "Informasi Pengguna berhasil ditambah.",
  "notification.user.update.success": "Informasi pengguna berhasil diperbarui.",
  "notify.error": "Pengguna dan Pesan diperlukan",
  "notify.main.title": "Beri tahu Pengguna",
  "notify.message": "Pesan",
  "notify.user.by": "Pengguna yang akan dinotifikasi",
  "notify.user.success.notification": "Notifikasi berhasil terkirim",
  "of": "dari",
  "openreports.activity.title": "Laporan Kegiatan",
  "openreports.aggregate.title": "Laporan Agregat",
  "openreports.all.test.summary.title": "Ringkasan Laporan Pemeriksaan",
  "openreports.all.tests.aggregate": "Ringkasan Semua Pemeriksaan",
  "openreports.hiv.aggregate": "Ringkasan Pemeriksaan HIV",
  "openreports.management.title": "Laporan Manajemen",
  "openreports.mgt.nonconformity.date": "Laporan Ketidaksesuaian berdasarkan Tanggal",
  "openreports.mgt.nonconformity.section": "Laporan Ketidaksesuaian berdasarkan Unit dan Alasan",
  "openreports.mgt.rejection": "Laporan Penolakan",
  "openreports.patient.EID.version1": "EID Versi 1",
  "openreports.patient.EID.version2": "EID Versi 2",
  "openreports.patient.VL.version1": "VL Versi Nasional",
  "openreports.patientTestStatus": "Laporan Status Pasien",
  "openreports.patientreports.title": "Laporan Status Pasien",
  "openreports.stat.aggregate": "Laporan Statistik",
  "order.accept": "Terima",
  "order.accept.error": "Gagal menerima pemesanan",
  "order.additionalInfo": "Informasi Tambahan",
  "order.additionalInfo.helper": "Catatan opsional tentang pemesanan ini",
  "order.clinicalInfo": "Informasi Klinis",
  "order.continue": "Lanjut",
  "order.current.time": "Waktu sekarang (hh:mm)",
  "order.dashboard.empty": "Pemesanan tidak ditemukan",
  "order.dashboard.title": "Dasbor Pemesanan",
  "order.department.label": "ruang/departemen/unit:",
  "order.diagnosis.helper": "Diagnosis sementara - menjadi pedoman dalam pemilihan pemeriksaan. Tidak terekam sebagai diagnosis yang telah dikonfirmasi.",
  "order.diagnosis.placeholder": "Masukkan diagnosis atau catatan klinis",
  "order.entry.setup": "Pengaturan Entri Permintaan Batch",
  "order.external": "Eksternal",
  "order.facility": "Lembaga",
  "order.filter.priority": "Filter berdasarkan Prioritas",
  "order.filter.status": "Filter berdasarkan Status",
  "order.fixIssue": "Perbaiki Masalah",
  "order.form.label": "Formulir:",
  "order.form.select": "Pilih Formulir",
  "order.generate.barcode": "Buat Kode QR dan Simpan",
  "order.generate.barcode.history": "Nomor Registrasi yang digunakan sebelumnya",
  "order.if.other.label": "Lainnya, jelaskan:",
  "order.invalid.requester.name.label": "nama pemohon tidak valid",
  "order.invalid.site.name": "Nama tempat tidak valid",
  "order.labNumber": "Nomor Registrasi",
  "order.labNumber.generate": "Membuat Nomor Registrasi",
  "order.labNumber.helper": "Pengidentifikasi unik untuk pemesanan ini",
  "order.attachment.action.delete": "Hapus lampiran",
  "order.attachment.action.download": "Unduh lampiran",
  "order.attachment.action.view": "Lihat lampiran",
  "order.attachment.column.actions": "Aksi",
  "order.attachment.column.fileName": "Nama File",
  "order.attachment.column.fileSize": "Ukuran",
  "order.attachment.column.fileType": "Jenis",
  "order.attachment.column.uploadedAt": "Waktu diunggah",
  "order.attachment.delete.confirm.body": "Apakah Anda yakin mau menghapus \"{fileName}\"? Ini tidak dapat dibatalkan.",
  "order.attachment.delete.confirm.title": "Hapus lampiran",
  "order.attachment.delete.failed": "Tidak dapat menghapus lampiran. Silahkan coba lagi.",
  "order.attachment.dropzone": "Tarik dan lepaskan file disini atau klik untuk mencari",
  "order.attachment.empty": "Belum ada lampiran",
  "order.attachment.saveFirst": "Simpan pemesanan untuk menambahkan lampiran.",
  "order.attachment.error.maxFiles": "Anda dapat melampirkan maks {maxFiles} file.",
  "order.attachment.error.size": "Setiap file tidak lebih dari {maxSize}.",
  "order.attachment.error.type": "Jenis file yang didukung: {types}",
  "order.attachment.heading": "Lampiran",
  "order.attachment.hint": "Opsional. Sampai dengan {maxFiles} file, masing-masing 10MB. Mendukung: PDF, JPG, PNG, TIFF.",
  "order.attachment.upload.failed": "Satu atau lebih lampiran tidak dapat diunggah.",
  "order.labNumber.placeholder": "Masukkan atau buat nomor registrasi",
  "order.label.add": "Tambah Permintaan",
  "order.label.modify": "Modifikasi Permintaan",
  "order.legend.EDTATube": "Tabung EDTA",
  "order.legend.commonFields": "Field Umum",
  "order.legend.configureBarcode": "Konfigurasi Entri Kode QR",
  "order.legend.dryBloodSpot": "Tetes Darah Kering",
  "order.legend.dryTube": "Tabung kering",
  "order.legend.facility": "Lembaga",
  "order.legend.onDemand": "Sesuai permintaan",
  "order.legend.optionalFields": "Field opsional",
  "order.legend.patient": "Informasi Pasien",
  "order.legend.preDemand": "Pra-cetak",
  "order.legend.sample": "Sampel",
  "order.legend.selectMethod": "Pilih Metode",
  "order.legend.siteName": "Nama Tempat",
  "order.legend.specimen.collected": "Spesimen diambil",
  "order.legend.tests": "Pemeriksaan",
  "order.legend.viralLoadTest": "Pemeriksaan Viral Load",
  "order.lastUpdated": "Pembaruan Terakhir",
  "order.load.error": "Gagal memuat pemesanan",
  "order.location": "Lokasi",
  "order.new": "Pemesanan Baru",
  "order.payment.status.label": "Status pembayaran pasien:",
  "order.paymentStatus": "Status Pembayaran",
  "order.previousLabNumber": "Nomor Registrasi sebelumnya",
  "order.previousLabNumber.placeholder": "Masukkan nomor registrasi sebelumnya jika ada",
  "order.printLabels": "Cetak Label",
  "order.printLabels.info": "Cetak Kode QR untuk pemesanan ini",
  "order.priority": "Prioritas",
  "order.progress": "Kemajuan",
  "order.provisionalDiagnosis": "Diagnosis Sementara",
  "order.received.time": "Waktu datang (hh:mm)",
  "order.reception.time": "Waktu diterima (hh:mm)",
  "order.remember.site.and.requester.label": "Ingat tempat dan pemohon",
  "order.readonly.message": "Pemesanan ini dalam mode read-only",
  "order.requester": "Pemohon",
  "order.requester.email.label": "Email Pemohon:",
  "order.requester.fax.label": "Nomor Faks Pemohon:",
  "order.requester.firstName.label": "NamaDepan Pemohon:",
  "order.requester.lastName.label": "NamaBelakang Pemohon:",
  "order.requester.phone.label": "Nomor telepon Pemohon:",
  "order.requester.provisionalDiagnosis.label": "Diagnosis Klinis Sementara:",
  "order.result.reporting.heading": "PELAPORAN HASIL",
  "order.sampleCategory": "Kategori Sampel",
  "order.sampleCategory.helper": "Pilih kategori sampel untuk pengambilan",
  "order.sampling.performed.label": "Pengambilan sampel yang dilakukan untuk analisis:",
  "order.search.requester.label": "Cari Pemohon",
  "order.saveStatus.error": "Penyimpanan gagal",
  "order.saveStatus.saved": "Disimpan",
  "order.saveStatus.saving": "Menyimpan...",
  "order.saveStatus.unsaved": "Perubahan tidak tersimpan",
  "order.save.blocked": "Pemesanan tersebut tidak disimpan",
  "order.save.notPersisted": "Server menerima pemesanan tetapi tidak menyimpan sampel apa pun untuknya. Periksa pemesanan sebelum melanjutkan.",
  "order.save.incomplete": "Mohon tambah pasien (atau tempat pengambilan sampel) dan setidaknya satu jenis sampel sebelum menyimpan.",
  "order.save.incomplete.fields": "Tambahkan {fields} sebelum menyimpan.",
  "order.save.incomplete.and": "dan",
  "order.save.requirements.title": "Wajib sebelum menyimpan",
  "order.save.requirement.labNumber": "No. Registrasi",
  "order.save.requirement.patient": "pasien",
  "order.save.requirement.samplingSite": "tempat pengambilan sampel",
  "order.save.requirement.collectionSite": "tempat pengambilan",
  "order.save.requirement.requesterOrRequestor": "organisasi pemohon atau pemohon",
  "order.sample.missingTests": "Sampel {sampleNumber} memiliki jenis sampel tetapi tidak ada pemeriksaan. Tambahkan pemeriksaan atau hapus sampel sebelum menyimpan.",
  "order.sample.missingTests.named": "Sample {sampleNumber}: {sampleType} has no test. Add a test or remove the sample before saving.",
  "order.save.requirement.sampleType": "minimal satu jenis sampel",
  "order.save.requirement.site": "tempat pemohon",
  "order.save.requirement.patientSex": "jenis kelamin pasien",
  "order.save.requirement.patientBirthDate": "tanggal lahir pasien",
  "order.save.requirement.nationalId": "NIK pasien",
  "order.save.requirement.validEmail": "alamat email yang valid",
  "order.requestDate": "Tanggal Permintaan",
  "order.nextVisitDate": "Tanggal Kunjungan Berikutnya",
  "order.sampleHandling": "Penanganan Sampel",
  "sampleAcceptance.qa.button.continueWithTesting": "Lanjutkan pemeriksaan",
  "sampleAcceptance.qa.continueWithTesting.reason": "Mengapa sampel ini tetap diperiksa meskipun gagal dalam pengecekan?",
  "sampleAcceptance.qa.continueWithTesting.record": "Catat dan lanjutkan",
  "order.eqaSample": "Sampel pemantapan mutu eksternal (PME)",
  "order.noPatient": "Pemesanan ini tidak memiliki pasien",
  "order.noPatient.reason": "Alasan pemesanan tanpa pasien",
  "order.noPatient.reason.eqa": "Sampel pemantapan mutu eksternal",
  "order.noPatient.warning.title": "Hasil tidak akan dievaluasi terhadap rentang rujukan",
  "order.noPatient.warning.subtitle": "Tanpa pasien, tidak ada usia atau jenis kelamin untuk memilih rentang rujukan, sehingga hasil pada pemesanan ini tidak akan ditandai normal atau abnormal.",
  "order.noPatient.butPatientChosen": "Pasien terlampir pada pemesanan ini, sehingga keputusan tanpa pasien tidak akan dicatat.",
  "order.rangeNotApplied.warning.title": "Beberapa hasil tidak akan diperiksa terhadap rentang rujukan",
  "order.rangeNotApplied.warning.subtitle": "Jenis kelamin atau usia pasien tidak tercatat, dan pemeriksaan berikut memiliki rentang yang bergantung padanya: {tests}. Hasilnya perlu ditinjau sebelum dirilis.",
  "order.rangeNotApplied.warning.reportNce": "Lapor KTS",
  "order.eqa.program": "Program PME",
  "order.eqa.providerSampleId": "ID Sampel Penyelenggara",
  "order.eqa.deadline": "Tenggat Penyerahan",
  "order.eqa.priority": "Prioritas PME",
  "order.rememberSiteAndRequester": "Ingat tempat dan pemohon ini untuk pemesanan saya berikutnya",
  "order.testLocationCode": "Pengambilan Sampel Dilakukan Di",
  "order.testLocationCode.other": "Lainnya",
  "order.testLocationCode.otherLabel": "Jika lainnya, sebutkan",
  "provider.fax.invalid": "Masukkan nomor faks yang valid, hanya angka dan + ( ) -.",
  "provider.email.invalid": "Masukkan alamat email yang valid, misalnya lab@example.org.",
  "order.save.requirement.provider": "penyelenggara pemohon",
  "order.save.requirement.testsPerSample": "minimal satu pemeriksaan atau panel pada setiap sampel",
  "order.saved.draft": "Draf disimpan",
  "order.saved.title": "Pemesanan \"{labNumber}\" telah disimpan",
  "order.saved.next": "Berikutnya: {step}",
  "order.search.placeholder": "Cari pemesanan...",
  "order.search.site.name": "Cari Nama Tempat",
  "order.send.toAnalyzer": "Kirim ke alat",
  "order.send.modal.title": "Kirim pemesanan ke alat",
  "order.send.modal.confirm": "Kirim",
  "order.send.modal.cancel": "Batal",
  "order.send.modal.analyzerLabel": "Alat yang Dituju",
  "order.send.modal.accession": "Nomor registrasi pemesanan: {accession}",
  "order.send.modal.noAnalyzers": "Tidak ada alat yang dikonfigurasi untuk pengiriman dari SIL.",
  "order.send.success": "Pemesanan dikirim",
  "order.send.error": "Gagal mengirim pemesanan",
  "order.send.unknownError": "Kesalahan bridge tidak diketahui",
  "order.send.missingAccession": "Pemesanan tidak memiliki nomor registrasi yang terkait hasil",
  "order.site.name": "Nama tempat:",
  "order.step.collect": "Pengambilan",
  "order.step.complete": "Selesai",
  "order.step.enter": "Masukkan Pemesanan",
  "order.step.label": "Label & Simpan",
  "order.step.patient.info": "Informasi Pasien",
  "order.step.program.selection": "Pilihan Program",
  "order.step.qa": "Tinjauan QA",
  "order.step.prepare": "Siapkan Sampel",
  "order.step.sampleCheck": "Pengecekan sampel",
  "order.step.notStarted": "Belum dimulai",
  "order.step.done": "Selesai",
  "order.step.doneAt": "Selesai {time}",
  "order.step.toDo": "{count} belum dikerjakan",
  "order.step.ready": "Siap",
  "order.nav.saveExit": "Simpan dan keluar",
  "order.nav.saveNext": "Simpan dan lanjut",
  "order.nav.saveFinish": "Simpan dan selesai",
  "order.nav.discard.title": "Buang perubahan yang belum disimpan?",
  "order.nav.discard.body": "Perubahan yang belum disimpan di halaman ini akan hilang ({samples} sampel, {tests} pemeriksaan).",
  "order.nav.discard.order": "Buang pemesanan",
  "order.nav.discard.changes": "Buang perubahan",
  "order.continue.heading": "Untuk melanjutkan ke {step}",
  "order.continue.count": "{count} item diperlukan untuk melanjutkan",
  "order.continue.countOne": "1 item diperlukan untuk melanjutkan",
  "order.continue.item.patient": "Pilih atau buat pasien",
  "order.continue.item.labNumber": "Tambahkan No. Registrasi",
  "order.continue.item.nationalId": "Masukkan NIK pasien",
  "order.continue.item.patientSex": "Pilih jenis kelamin pasien",
  "order.continue.item.birthDate": "Masukkan tanggal lahir pasien",
  "order.continue.item.sampleType": "Tambahkan setidaknya satu jenis sampel",
  "order.continue.item.provider": "Tambahkan penyelenggara yang meminta",
  "order.continue.item.noTests": "Sampel {number}: pilih setidaknya satu pemeriksaan",
  "order.continue.item.noTestsOnSample": "{sample} tidak memiliki pemeriksaan. Tambahkan di Entri Pemesanan atau hapus sampel tersebut",
  "errors.samples.with.no.tests": "Ada sampel yang tidak memiliki pemeriksaan. Tambahkan pemeriksaan di Masukkan Pemesanan atau hapus sampel tersebut.",
  "order.continue.item.collectionTime": "Tanggal dan waktu pengambilan untuk {sample}",
  "order.continue.item.consent": "Catat persetujuan",
  "order.continue.item.acceptance": "Jawab daftar periksa penerimaan sampel",
  "order.status.entered": "Dimasukkan",
  "order.status.samplesPrepared": "Sampel disiapkan",
  "order.status.readyForTesting": "Siap untuk pemeriksaan",
  "order.status.cancelled": "Dibatalkan",
  "order.status.complete": "Selesai",
  "order.cancelled.notice": "Pemesanan ini dibatalkan: {reason}",
  "order.cancelled": "Pemesanan ini sudah dibatalkan",
  "order.notFound": "Pemesanan tidak ditemukan",
  "order.cancel.reasonRequired": "Alasan pembatalan wajib diisi",
  "order.cancel.complete": "Entri pemesanan sudah selesai; pemesanan ini tidak dapat dibatalkan lagi di sini",
  "order.cancel.inProgress": "Pemeriksaan sudah dimulai pada pemesanan ini; pemesanan tidak dapat dibatalkan lagi di sini",
  "order.release.prepareIncomplete": "Siapkan Sampel belum selesai",
  "order.release.reasonRequired": "Alasan merilis sebelum semua sampel diterima",
  "order.finish.title": "Pemesanan {labNo} selesai",
  "order.finish.subtitle": "Entri pemesanan sudah selesai. Hasil dapat dimasukkan saat tersedia.",
  "order.finish.backToOrders": "Kembali ke pemesanan",
  "order.finish.awaiting": "Masih menunggu sampel: {tests}",
  "order.sampleCheck.release": "Rilis untuk pemeriksaan",
  "order.sampleCheck.return": "Kembali ke Siapkan Sampel",
  "order.sampleCheck.proceedReason": "Alasan merilis sebelum semua sampel diterima",
  "order.sampleCheck.notAcceptedYet": "Belum diterima: {samples}. Jawaban dihitung setelah Anda menekan Terima sampel.",
  "order.sampleCheck.released": "Pemesanan {labNo} dirilis untuk pemeriksaan",
  "order.sampleCheck.disabled.incomplete": "Siapkan Sampel belum selesai. Buka dan selesaikan sampel terlebih dahulu.",
  "order.dashboard.cancelOrder": "Batalkan pemesanan",
  "order.dashboard.cancel.reason": "Alasan pembatalan",
  "order.dashboard.cancel.reasonOther": "Jelaskan alasannya",
  "order.dashboard.cancel.other": "Lainnya",
  "order.dashboard.cancel.confirm": "Batalkan pemesanan {labNo}?",
  "order.dashboard.cancel.body": "Pemeriksaannya dibatalkan dan sampelnya dinyatakan batal. Tidak ada yang dihapus.",
  "order.dashboard.cancelled": "Pemesanan {labNo} dibatalkan",
  "order.dashboard.filter.cancelled": "Dibatalkan",
  "order.dashboard.open": "Buka",
  "order.samples.printLabels": "Cetak label",
  "order.samples.notStored": "Tidak disimpan",
  "storage.noSamples": "Tambahkan sampel di atas untuk menyimpannya.",
  "common.discard": "Buang",
  "common.stay": "Tetap di Sini",
  "order.start.new": "Mulai Pemesanan Baru",
  "order.submit.labNumber": "Kirim dengan Nomor Registrasi",
  "order.submit.success": "Pemesanan berhasil dikirim",
  "order.submit.success.labNumber": "No. Registrasi: {labNumber}",
  "order.submitted.success.msg": "Pemesanan berhasil dikirim",
  "order.summary.accessionNumber": "Nomor Registrasi",
  "order.summary.collectionDate": "Tanggal Pengambilan",
  "order.dashboard.status.all": "Semua Status",
  "order.dashboard.status.inProgress": "Dalam Pengerjaan",
  "order.dashboard.status.pendingQa": "Menunggu pengecekan sampel",
  "order.dashboard.status.completed": "Selesai",
  "order.dashboard.status.hasReferred": "Memiliki pemeriksaan yang dirujuk",
  "order.dashboard.status.referredOut": "Dirujuk keluar",
  "order.dashboard.priority.all": "Semua Prioritas",
  "order.dashboard.priority.stat": "STAT",
  "order.dashboard.priority.asap": "ASAP",
  "order.dashboard.priority.timed": "Terjadwal",
  "order.dashboard.priority.routine": "Rutin",
  "order.summary.patientName": "Nama Pasien",
  "order.summary.sampleType": "Jenis Sampel",
  "order.summary.title": "Ringkasan Pemesanan",
  "order.test.request.heading": "Permintaan Pemeriksaan",
  "order.title": "PERMINTAAN",
  "ordertests.title": "Permintaan Pemeriksaan",
  "organization.add.placeholder": "Nilai alfanumerik",
  "organization.add.placeholder.active": "Ya atau Tidak",
  "organization.add.placeholder.internetAddress": "https://orgname.com",
  "organization.add.placeholder.parent": "Organisasi Induk",
  "organization.add.title": "Tambah Organisasi",
  "organization.city": "Kota",
  "organization.clia.number": "Nomor CLIA",
  "organization.edit.title": "Edit Organisasi",
  "organization.internetaddress": "Website",
  "organization.isActive": "Status Aktif",
  "organization.main.title": "Pengelolaan Organisasi",
  "organization.next": "Halaman Berikutnya",
  "organization.organizationName": "Nama Organisasi",
  "organization.parent": "Induk Organisasi",
  "organization.previous": "Halaman sebelumnya",
  "organization.search.byorgname": "Cari berdasarkan Nama Organisasi",
  "organization.search.parent.name": "Nama Organisasi Induk",
  "organization.search.placeHolder": "Cari berdasarkan Nama Organisasi...",
  "organization.select": "Pilih",
  "organization.short.CI": "Prefiks Organisasi",
  "organization.streetAddress": "Nama Jalan",
  "organization.type.CI": "Jenis Kegiatan",
  "organization.type.CI.description": "Jenis Kegiatan: Deskripsi",
  "organization.type.CI.name": "Jenis Kegiatan: Nama",
  "organization.type.CI.select": "Jenis Kegiatan: Pilih",
  "otherMalignant.placeholder": "Keganasan lainnya",
  "page.breadcrumb.separator": " > ",
  "page.title.back": "Kembali",
  "pagination.backward": "Halaman Sebelumnya",
  "pagination.forward": "Halaman Berikutnya",
  "pagination.item": "{min}-{max}",
  "pagination.item-range": "{min}-{max} dari {total} barang",
  "pagination.items-on-page": "{count} {count, plural, one {entri} other {entri}} di halaman ini",
  "pagination.items-per-page": "Item per halaman",
  "pagination.itemsPerPage": "Item per halaman:",
  "pagination.nextPage": "Halaman berikutnya",
  "pagination.page": "Halaman {page}",
  "pagination.page-number": "Nomor Halaman",
  "pagination.page-range": "dari {total} {total, plural, one {page} other {pages}}",
  "pagination.previousPage": "Halaman sebelumnya",
  "panel.existing": "Panel yang ada",
  "panel.existing.inactive": "Panel Inaktif (tugaskan pemeriksaan untuk mengaktifkan)",
  "panel.new": "Panel Baru",
  "panel.panelName": "Nama Panel",
  "pathology.action.addCassette": "Add cassette",
  "pathology.action.addSlide": "Add slide",
  "pathology.action.deactivateBlock": "Deactivate block {designation}",
  "pathology.action.deactivateCassette": "Deactivate cassette {designation}",
  "pathology.action.deactivateSlide": "Deactivate slide {barcode}",
  "pathology.action.printCassetteLabels": "Print all cassette labels",
  "pathology.action.printSlideLabels": "Print all slide labels",
  "pathology.badge.cassetteCount": "{count, plural, one {# cassette} other {# cassettes}}",
  "pathology.badge.openRequestCount": "{count} terbuka",
  "pathology.badge.openRequests": "Permintaan terbuka: {names}",
  "pathology.badge.openRequestsMore": "Permintaan terbuka: {names} dan {count} lainnya",
  "pathology.badge.slideCount": "{count, plural, other {# preparat}}",
  "pathology.banner.transitionsLater": "Transisi tahapan akan tersedia pada rilis berikutnya. Untuk saat ini, atur tahapan di sini.",
  "pathology.empty.noReports": "Belum ada laporan. Lengkapi temuan dan kesimpulan untuk membuatnya.",
  "pathology.empty.stageNotRecorded": "OpenELIS belum mencatat pekerjaan pada tahapan ini. Kasus tetap dapat dipindahkan melalui tahapan ini.",
  "pathology.error.designationConflict": "Another save changed this case at the same moment. Reload the case and try again.",
  "pathology.label.addslide": "Tambah Slide",
  "pathology.label.block": "Blok",
  "pathology.label.block.number": "Nomor Blok",
  "pathology.label.blocks": "Blok",
  "pathology.label.case": "Kasus Patologi",
  "pathology.label.caseTitle": "Kasus Patologi {labNumber}",
  "pathology.label.casesInProgress": "Kasus dalam Pengerjaan",
  "pathology.label.cassette": "Cassette",
  "pathology.label.cassettes": "Cassettes",
  "pathology.label.complete": "Selesai",
  "pathology.label.conclusion": "Kesimpulan",
  "pathology.label.dashboard": "Dasbor Patologi",
  "pathology.label.deactivating": "Deactivating",
  "pathology.label.designationPending": "Assigned on save",
  "pathology.label.grossexam": "Pemeriksaan Umum",
  "pathology.label.location": "Lokasi",
  "pathology.label.microexam": "Pemeriksaan Mikroskopis",
  "pathology.label.newCassette": "New cassette {position}",
  "pathology.label.newSlide": "New slide {position}",
  "pathology.label.parentBlock": "Cut from block",
  "pathology.label.printlabel": "Cetak Label",
  "pathology.label.refer": "Rujuk ke Imunohistokimia",
  "pathology.label.release": "Siap untuk dirilis",
  "pathology.label.report": "Laporan Patologi",
  "pathology.label.request": "Permintaan",
  "pathology.label.requests": "Permintaan Patologi Tambahan",
  "pathology.label.review": "Menunggu Tinjauan Patologi",
  "pathology.label.slide": "Slide",
  "pathology.label.slide.add.number": "Jumlah Slide untuk ditambah",
  "pathology.label.slide.number": "Nomor Slide",
  "pathology.label.slides": "Slide",
  "pathology.label.stage": "Tahapan",
  "pathology.label.techniques": "Teknik yang digunakan",
  "pathology.label.textconclusion": "Teks kesimpulan",
  "pathology.label.title": "Patologi",
  "pathology.label.view": "Lihat File",
  "pathology.locked.nothingToPrint": "No saved labels to print yet",
  "pathology.locked.reasonRequired": "Give a reason before deactivating",
  "pathology.locked.releaseNoPathologist": "Ahli patologi harus ditugaskan sebelum kasus dapat dirilis",
  "pathology.locked.releaseNoTechnician": "Petugas harus ditugaskan sebelum kasus dapat dirilis",
  "pathology.locked.saveBeforeDeactivate": "Save or discard your changes before deactivating",
  "pathology.locked.slideNeedsBlock": "Pick the block this slide was cut from",
  "pathology.locked.slideNeedsSavedBlock": "Save a cassette before adding a slide",
  "pathology.locked.stageDisabled": "Tidak dilacak di laboratorium ini",
  "pathology.modal.deactivateBlockHeading": "Deactivate block {designation}?",
  "pathology.modal.deactivateBody": "The record is kept and stays available under Show deactivated. Cassettes, blocks and slides are never deleted.",
  "pathology.modal.deactivateCassetteHeading": "Deactivate cassette {designation}?",
  "pathology.modal.deactivateFailed": "The deactivation was refused. Reload the case and try again.",
  "pathology.modal.deactivateSlideHeading": "Deactivate slide {barcode}?",
  "pathology.section.caseInfo": "Informasi Kasus",
  "pathology.section.findings": "Temuan & Kesimpulan",
  "pathology.section.review": "Tinjauan Ahli Patologi",
  "pathology.stage.accessioned": "Teregistrasi",
  "pathology.stage.completed": "Selesai",
  "pathology.stage.coverslipping": "Pemasangan Kaca Penutup & QC",
  "pathology.stage.decalcification": "Dekalsifikasi",
  "pathology.stage.embedding": "Penanaman Jaringan",
  "pathology.stage.grossing": "Pemeriksaan Makroskopis",
  "pathology.stage.microtomy": "Mikrotomi",
  "pathology.stage.processing": "Pemrosesan",
  "pathology.stage.readyPathologist": "Siap untuk Ahli Patologi",
  "pathology.stage.staining": "Pewarnaan",
  "pathology.stage.underReview": "Dalam Tinjauan Ahli Patologi",
  "pathology.toast.blockDeactivated": "Block {designation} deactivated",
  "pathology.toast.cassetteDeactivated": "Cassette {designation} deactivated",
  "pathology.toast.slideDeactivated": "Slide {barcode} deactivated",
  "patient.address.camp": "Kelompok/Komunitas",
  "patient.address.fokontany": "Fokontany",
  "patient.address.hamletOrLot": "Hamlet / Lot",
  "patient.address.healthdistrict": "Kabupaten",
  "patient.address.healthregion": "Kecamatan",
  "patient.address.province": "Propinsi",
  "patient.address.street": "Jalan",
  "patient.address.town": "Kota",
  "patient.age.days": "Hari",
  "patient.age.months": "Bulan",
  "patient.age.years": "Umur/Tahun",
  "patient.alias": "Alias",
  "patient.dataSourceName": "Nama Sumber Data",
  "patient.dob": "Tanggal Lahir",
  "patient.dob.future": "Tanggal lahir tidak boleh di masa depan.",
  "patient.validation.contactEmailInvalid": "Enter a valid email address for the contact.",
  "patient.validation.dobInvalid": "Enter a valid date of birth.",
  "patient.validation.dobOrAgeRequired": "Enter a date of birth or an age in years, months or days.",
  "patient.validation.emailInvalid": "Enter a valid email address.",
  "patient.validation.nationalIdRequired": "Enter the national ID.",
  "patient.validation.sexRequired": "Select the patient's sex.",
  "patient.eduction": "Pendidikan",
  "patient.emergency.additional.camp": "Masukkan Kelompok/Komunitas",
  "patient.emergency.additional.district": "Masukkan Kabupaten",
  "patient.emergency.additional.education": "Masukkan Pendidikan",
  "patient.emergency.additional.maritalstatus": "Masukkan Status Pernikahan",
  "patient.emergency.additional.nationnality": "Masukkan Kewarganegaraan",
  "patient.emergency.additional.othernationality": "Masukkan Kewarganegaraan Lain",
  "patient.emergency.additional.region": "Masukkan Daerah",
  "patient.emergency.additional.street": "Masukkan Nama Jalan",
  "patient.emergency.additional.town": "Masukkan Kota",
  "patient.emergency.email": "Masukkan Email Kontak Darurat",
  "patient.emergency.firstname": "Masukkan Nama Depan Kontak Darurat",
  "patient.emergency.lastname": "Masukkan Nama Belakang Kontak Darurat",
  "patient.emergency.phone": "Masukkan Nomor Telepon Kontak Darurat",
  "patient.externalId": "Identitas eksternal",
  "patient.female": "Perempuan",
  "patient.first.name": "Nama Depan",
  "patient.gender": "Jenis Kelamin",
  "patient.gps.latitude": "Garis Lintang GPS",
  "patient.gps.latitude.placeholder": "mis., -18.879190 (rentang -90 sampai 90)",
  "patient.gps.longitude": "Garis bujur GPS",
  "patient.gps.longitude.placeholder": "mis., 47.507905 (rentang -180 sampai 180)",
  "patient.id": "Identitas Pasien",
  "patient.information.age": "Masukkan Umur",
  "patient.information.days": "Masukkan Hari",
  "patient.information.email": "Masukkan Email Pasien",
  "patient.information.firstname": "Masukkan Nama Depan Pasien",
  "patient.information.healthid": "Masukkan Pengidentifikasi Kesehatan Unik",
  "patient.information.lastname": "Masukkan Nama Belakang Pasien",
  "patient.information.months": "Masukkan Bulan",
  "patient.information.nationalid": "Masukkan NIK",
  "patient.information.primaryphone": "Masukkan Nomor Utama Pasien",
  "patient.label": "Pasien",
  "patient.label.additionalInfo": "Informasi Tambahan",
  "patient.label.age": "Umur",
  "patient.label.customNotes": "Catatan Kostum",
  "patient.label.diseaseProgramme": "Program Penyakit Target",
  "patient.label.occupation": "Pekerjaan",
  "patient.label.contactphone": "Nomor Telepon Kontak:{PHONE_FORMAT}",
  "patient.label.email": "Email",
  "patient.label.info": "Informasi Pasien",
  "patient.label.modify": "Tambah atau Modifikasi Pasien",
  "patient.label.name": "Nama",
  "patient.label.nopatientid": "Informasi Pasien Tidak Tersedia",
  "patient.label.primaryphone": "Nomor Telepon Utama:{PHONE_FORMAT}",
  "patient.label.sex": "Jenis Kelamin",
  "patient.last.name": "Nama Belakang",
  "phone.format.international.label": "Internasional",
  "phone.format.local.label": "Lokal",
  "patient.male": "Laki-Laki",
  "patient.maritalstatus": "Status Pernikahan",
  "patient.merge.activeOrders": "Permintaan Aktif",
  "patient.merge.address": "Alamat",
  "patient.merge.addressesDiffer": "Alamat berbeda: {primary} vs {secondary}",
  "patient.merge.auditEntries": "Audit Entri (menyimpan data pasien asli)",
  "patient.merge.back": "Kembali",
  "patient.merge.cancelButton": "Batal",
  "patient.merge.clinicalSummary": "Ringkasan Klinis",
  "patient.merge.confirmButton": "Konfrimasi Penggabungan",
  "patient.merge.confirmCheckbox": "Saya memahami bahwa aksi ini tidak dapat dibatalkan dan telah memverifikasi bahwa pasien yang benar sedang digabungkan.",
  "patient.merge.confirmMerge": "Konfirmasi Penggabungan Pasien",
  "patient.merge.conflictNote": "(Demografi pasien primer akan digunakan)",
  "patient.merge.conflictingInfo": "Konflik Informasi terdeteksi",
  "patient.merge.contactInfo": "Informasi Kontak",
  "patient.merge.county": "Provinsi",
  "patient.merge.dataToConsolidate": "Data yang akan Dikonsolidasi",
  "patient.merge.demographics": "Demografi",
  "patient.merge.dob": "Tanggal lahir",
  "patient.merge.email": "Email",
  "patient.merge.emailsDiffer": "Email berbeda: {primary} vs {secondary}",
  "patient.merge.error.alreadyMerged": "Pasien sudah tergabung",
  "patient.merge.error.executionFailed": "Eksekusi penggabungan gagal",
  "patient.merge.error.noPermission": "Hanya Administrator Global yang dapat melakukan penggabungan pasien",
  "patient.merge.error.patientNotFound": "Pasien tidak ditemukan",
  "patient.merge.error.samePatient": "Tidak dapat menggabung pasien yang sama",
  "patient.merge.error.selectBoth": "Pilih kedua pasien untuk melanjutkan",
  "patient.merge.error.selectPrimary": "Pilih pasien yang akan menjadi rekaman primer",
  "patient.merge.error.validationFailed": "Validasi penggabungan gagal",
  "patient.merge.externalIds": "Identitas Eksternal",
  "patient.merge.gender": "Jenis Kelamin",
  "patient.merge.identifiers": "Pengidentifikasi",
  "patient.merge.identifiersToPreserve": "Pengidentifikasi yang Perlu Disimpan (semua pasien)",
  "patient.merge.mergeSummary": "Ringkasan Penggabungan",
  "patient.merge.mergingFrom": "Penggabungan Dari",
  "patient.merge.mergingLabel": "Menggabungkan",
  "patient.merge.name": "Nama",
  "patient.merge.nationalId": "NIK",
  "patient.merge.nationalIds": "NIK",
  "patient.merge.nextStep": "Langkah Berikutnya",
  "patient.merge.noIdentifiers": "Pengidentifikasi tidak ditemukan",
  "patient.merge.noPatientSelected": "Tidak ada Pasien yang dipilih",
  "patient.merge.notRecorded": "Tidak terekam",
  "patient.merge.orders": "Permintaan",
  "patient.merge.ordersCount": "{count} ({active} aktif)",
  "patient.merge.patientId": "Nomor Identitas Pasien",
  "patient.merge.patientIds": "Nomor Identitas Pasien",
  "patient.merge.patientResults": "Hasil Pasien",
  "patient.merge.phone": "Telepon",
  "patient.merge.phonesDiffer": "Nomor Telepon berbeda: {primary} vs {secondary}",
  "patient.merge.postalCode": "Kode Pos",
  "patient.merge.primaryLabel": "Primer",
  "patient.merge.primaryPatient": "Pasien Primer",
  "patient.merge.reason": "Alasan penggabungan (wajib)",
  "patient.merge.reasonPlaceholder": "Masukan alasan penggabungan rekaman pasien",
  "patient.merge.recordsReassigned": "{count} rekaman yang ditugaskan",
  "patient.merge.samples": "Sampel",
  "patient.merge.searchDifferent": "Cari pasien yang berbeda",
  "patient.merge.selectFirstPatient": "Pilih Pasien Pertama",
  "patient.merge.selectPrimaryDescription": "Pasien yang mana akan menjadi rekaman primer?",
  "patient.merge.selectPrimaryRecord": "Pilih Rekaman Pasien Primer",
  "patient.merge.selectSecondPatient": "Pilih Pasien Kedua",
  "patient.merge.step.compare": "Pilih Primer",
  "patient.merge.step.confirm": "Konfirmasi Penggabungan",
  "patient.merge.step.select": "Pilih Pasien",
  "patient.merge.streetAddress": "Nama Jalan",
  "patient.merge.success": "Penggabungan pasien sukses",
  "patient.merge.successMessage": "Pasien {mergedId} telah digabungkan dengan pasien {primaryId}. Audit ID: {auditId}",
  "patient.merge.testResults": "Hasil Pemeriksaan",
  "patient.merge.title": "Gabung Rekaman Pasien",
  "patient.merge.totalContacts": "Kontak",
  "patient.merge.totalRelations": "Hubungan",
  "patient.merge.totalResults": "Hasil Total",
  "patient.merge.totalSamples": "Sampel",
  "patient.merge.town": "Kabupaten/Kota",
  "patient.merge.tryDifferentSearch": "Atur kriteria pencarian atau gunakan pengidentifikasi pasien yang lain.",
  "patient.merge.warning.dataLink": "Semua data berikutnya akan terkait dengan pasien primer. Pasien yang tidak dipilih akan ditandai sebagai penggabungan dan inaktif.",
  "patient.merge.warning.irreversible": "Aksi ini TIDAK BISA dibatalkan. Semua data akan dikonsolidasi permanen.",
  "patient.merge.warning.samePatient": "Pasien yang sama telah dipilih",
  "patient.merge.warning.samePatientDescription": "Anda telah memilih pasien yang sama. Silahkan pilih dua pasien yang berbeda untuk digabunngkan.",
  "patient.natioanalid": "NIK",
  "patient.nationalid": "NIK",
  "patient.nationality": "Kewarganegaraan",
  "patient.nationality.other": "Tuliskan Kewarganegaraan lainnya",
  "patient.photo.active.camera": "Klik untuk mengaktifkan kamera",
  "patient.photo.add": "Tambah Foto",
  "patient.photo.browse": "Klik untuk mencari file",
  "patient.photo.camera.permission.denied": "Izin akses kamera ditolak. Silakan periksa pengaturan browser Anda.",
  "patient.photo.cancel": "Batal",
  "patient.photo.capture": "Ambil Foto",
  "patient.photo.captured": "Foto yang diambil:",
  "patient.photo.change": "Ganti Gambar",
  "patient.photo.confirm": "Konfirmasi",
  "patient.photo.dragndrop": "Seret dan lepas gambar di sini",
  "patient.photo.error.fileTooLarge": "Gambar terlalu besar. Ukuran maksimum 2 MB.",
  "patient.photo.formats": "Format: JPG, PNG (maks 1MB)",
  "patient.photo.import": "Impor",
  "patient.photo.label": "Foto Pasien",
  "patient.photo.modal.heading": "Pilih Foto Pasien",
  "patient.photo.modal.options": "Opsi Pilihan Gambar",
  "patient.photo.preview": "Pratinjau:",
  "patient.photo.preview.alt": "Pratinjau Foto Pasien",
  "patient.photo.preview.captured.alt": "Foto pasien yang diambil",
  "patient.photo.retake": "Pengambilan ulang",
  "patient.photo.start.camera": "Buka Kamera",
  "patient.photo.take": "Ambil Foto",
  "patient.photo.view": "Lihat Foto",
  "patient.idDoc.title": "Dokumen Identitas",
  "patient.idDoc.addDocument": "Tambah Dokumen",
  "patient.idDoc.selectImage": "Pilih Gambar",
  "patient.idDoc.documentType": "Jenis Dokumen",
  "patient.idDoc.description": "Deskripsi",
  "patient.idDoc.description.placeholder": "Masukkan deskripsi dokumen",
  "patient.idDoc.category.nationalId": "NIK",
  "patient.idDoc.category.insuranceCard": "Kartu Asuransi",
  "patient.idDoc.category.other": "Lainnya",
  "patient.idDoc.view": "Lihat",
  "patient.idDoc.edit": "Edit",
  "patient.idDoc.delete": "Hapus",
  "patient.idDoc.remove": "Hapus",
  "patient.idDoc.pending": "Tidak tersimpan",
  "patient.idDoc.empty": "Tidak ada dokumen identitas diunggah",
  "patient.idDoc.viewDocument": "Lihat Dokumen",
  "patient.idDoc.editDocument": "Edit Dokumen",
  "patient.idDoc.confirmDelete": "Hapus Dokumen",
  "patient.idDoc.deleteWarning": "Apakah Anda yakin akan menghapus dokumen ini? Aksi ini tidak dapat dibatalkan.",
  "patient.idDoc.upload": "Unggah",
  "patient.idDoc.dragndrop": "Seret dan lepas gambar di sini",
  "patient.idDoc.browse": "atau klik untuk mencari file",
  "patient.idDoc.formats": "Format: JPEG, PNG, PDF (maks 10MB)",
  "patient.idDoc.useCamera": "Buka Kamera",
  "patient.idDoc.pdfSelected": "Dokumen PDF dipilih",
  "patient.idDoc.error.invalidFormat": "Format file invalid. Format yang didukung: JPEG, PNG, PDF.",
  "patient.idDoc.error.fileTooLarge": "File terlalu besar. Ukuran maksimum 10MB.",
  "patient.prev.lab.no": "Nomor Registrasi sebelumnya",
  "patient.report.associated.name": "Laporan Pasien Lainnya",
  "patient.report.collection.name": "Kumpulan Laporan Pasien ARV",
  "patient.search.nopatient": "Pasien yang dicari tidak ditemukan",
  "patient.st.number": "Nomor ST",
  "patient.subject.number": "Nomor Pengidentifikasi Kesehatan Unik",
  "patient.yrs": "tahun",
  "patientcontact.person.email": "Email Kontak",
  "patientcontact.person.firstname": "Nama Depan Kontak",
  "patientcontact.person.lastname": "Nama Belakang Kontak",
  "placeholder.accession.number": "Masukkan Nomor Registrasi",
  "print.barcode": "Cetak Kode QR",
  "process.testAdd.pressNext.ageRangeSelectiong": "Tekan tombol Berikutnya. Pemilihan Rentang Usia tidak diperlukan!",
  "process.testAdd.pressNext.selectGroupDictionary": "Tekan tombol Berikutnya. Langkah Memilih Grup Daftar Kamus tidak diperlukan!",
  "program.name.label": "Nama Program",
  "project.ARVFollowupStudy.name": "Tindak lanjut ARV",
  "project.ARVStudies.name": "ARV",
  "project.ARVStudy.name": "ARV Awal",
  "project.EIDStudy.name": "EID",
  "project.IndeterminateStudy.name": "Tidak ditentukan",
  "project.RTNStudy.name": "RTN",
  "project.Recency.name": "Pemeriksaan Terkini",
  "project.SequencingStudy.name": "Sekuensing",
  "project.SpecialRequestStudy.name": "Permintaan Khusus",
  "project.VLStudy.name": "VL",
  "project.add.subtitle": "Tambah Proyek",
  "project.add.title": "Tambah Proyek",
  "project.browse.title": "Proyek",
  "project.completedDate": "Tanggal Selesai",
  "project.desc.short": "Deksripsi Proyek",
  "project.description": "Deskripsi Proyek",
  "project.edit.subtitle": "Edit Proyek",
  "project.edit.title": "Edit Proyek",
  "project.external.reference": "Rujukan Eksternal",
  "provider.browse.title": "Pengelolaan Penyelenggara",
  "provider.email": "Email",
  "provider.fax": "No. Telp",
  "provider.isActive": "Adalah Aktif",
  "provider.modal.add.heading": "Tambah Penyelenggara",
  "provider.modal.update.heading": "Perbarui Penyelenggara",
  "provider.providerFirstName": "Nama Depan Penyelenggara",
  "provider.providerLastName": "Nama Belakang Penyelenggara",
  "provider.search": "Cari Penyelenggara",
  "provider.search.placeholder": "Cari Nama Penyelenggara...",
  "provider.select": "Pilih Penyelenggara",
  "provider.telephone": "Nomor Telepon",
  "qa.checklist.incomplete": "Daftar centang QA tidak lengkap",
  "qa.checklist.instructions": "Selesaikan semua centang yang diperlukan sebelum mengirim",
  "qa.checklist.samplingSiteCorrect": "Informasi tempat pengambilan sampel sudah benar",
  "qa.checklist.title": "Daftar centang QA",
  "qa.summary.noSamples": "Tidak ada sampel untuk ditinjau",
  "qa.summary.noTests": "Tidak ada pengujian yang dipilih",
  "qa.summary.order": "Rincian Pemesanan",
  "qa.summary.panel": "Panel",
  "qa.summary.patient": "Informasi Pasien",
  "qa.summary.poolOf": "Pool berisi {count} {animal}",
  "qa.summary.samples": "Ringkasan Sampel",
  "qa.summary.samplingSite": "Tempat Pengambilan Sampel",
  "qa.summary.siteCode": "Kode Tempat",
  "qa.summary.siteName": "Nama Tempat",
  "qc.comments.add": "Tambah Komentar",
  "qc.comments.empty": "Belum ada komentar",
  "qc.comments.placeholder": "Masukkan komentar QC...",
  "qc.comments.title": "Komentar QC",
  "qc.expectedValue": "Nilai yang Diharapkan",
  "qc.frequency.compliance": "Metrik Kepatuhan",
  "qc.frequency.config": "Konfigurasi Frekuensi QC",
  "qc.frequency.daily": "Startup Harian",
  "qc.frequency.everyHours": "Setiap N Jam",
  "qc.frequency.everySamples": "Setiap N Sampel",
  "qc.frequency.manual": "Hanya Trigger Manual",
  "qc.frequency.notConfigured": "Tidak dikonfigurasi",
  "qc.frequency.perShift": "Per Shift",
  "qc.frequency.save": "SImpan Konfigurasi",
  "qc.frequency.type": "Jenis Frekuensi",
  "qc.frequency.value": "Nilai Frekuensi",
  "qc.leveyJennings.mean": "Rata-rata",
  "qc.leveyJennings.minus2SD": "-2 SD",
  "qc.leveyJennings.minus3SD": "-3 SD",
  "qc.leveyJennings.noData": "Tidak ada QC data tersedia",
  "qc.leveyJennings.plus2SD": "+2 SD",
  "qc.leveyJennings.plus3SD": "+3 SD",
  "qc.leveyJennings.title": "Bagan Kontrol Levey-Jennings",
  "qc.notes": "Catatan QC",
  "qc.notes.placeholder": "Masukkan catatan dan pengamatan QC",
  "qc.parentSample": "Sampel Induk",
  "qc.signature.comment": "Komentar (opsional)",
  "qc.signature.comment.placeholder": "Tambah komentar...",
  "qc.signature.ipAddress": "Alamat IP",
  "qc.signature.noSignatures": "Belum ada tanda tangan",
  "qc.signature.sign": "Tanda tangan Laporan",
  "qc.signature.signedAt": "Waktu Tanda Tangan",
  "qc.signature.success": "Laporan berhasil ditandatangani",
  "qc.signature.title": "Tanda Tangan Elektronik",
  "qc.signature.userId": "ID Pengguna",
  "qc.status": "Status QC",
  "qc.status.failed": "Gagal",
  "qc.status.notRequired": "Tidak Wajib",
  "qc.status.passed": "Lolos",
  "qc.status.pending": "QC tertunda",
  "qc.status.select": "Pilih Status QC",
  "qc.status.update.button": "Perbarui Status QC",
  "qc.status.update.success": "Status QC berhasil diperbarui",
  "qc.status.update.title": "Perbarui Status QC",
  "qc.status.warning.message": "Lot ini tidak dapat digunakan bila ditandai \"Gagal\", sampai status QC diperbarui.",
  "qc.status.warning.title": "Peringatan Kegagalan QC",
  "qc.westgard.noViolations": "Tidak ada pelanggaran terdeteksi",
  "qc.westgard.rule.disabled": "Dinonaktifkan",
  "qc.westgard.rule.enabled": "Diaktifkan",
  "qc.westgard.rules": "Westgard Rule",
  "qc.westgard.rules.description": "Konfigurasi evaluasi QC Westgard multi-rule",
  "qc.westgard.violations": "Pelanggaran",
  "quantity": "Kuantitas",
  "quantity.balanced": "Kuantitas Seimbang",
  "quantity.not.balanced": "Kuantitas tidak seimbang",
  "quick.entry.accession.number": "Nomor Registrasi",
  "referTest.referralLabel": "Rujuk Pemeriksaan ke lab rujukan",
  "referral.button.labSearch": "Cari Rujukan dengan Nomor Registrasi",
  "referral.button.patientSearch": "Cari Pasien",
  "referral.button.unitTestSearch": "Cari Rujukan Berdasarkan Instalasi Lab & Pemeriksaan",
  "referral.date.end": "Tanggal Selesai (dd/mm/yyyy)",
  "referral.date.start": "Tanggal Dimulai (dd/mm/yyyy)",
  "referral.emptyState": "Tidak ditemukan rujukan yang sesuai dengan filter yang dipilih.",
  "referral.error": "Tidak ada Rujukan yang cocok dengan kriteria",
  "referral.input": "Pindai atau Masukkan Manual",
  "referral.label.institute": "Lembaga",
  "referral.label.reason": "Alasan Merujuk",
  "referral.label.referredOutTests": "Pemeriksaan yang dirujuk ke luar",
  "referral.label.sentdate": "Tanggal Dikirim",
  "referral.label.testmethod": "Metode",
  "referral.label.testtoperform": "Pemeriksaan yang Dilakukan",
  "referral.main.button": "Cari Rujukan berdasarkan Pasien",
  "referral.matching.search": "Pencarian Kecocokan Pemeriksaan Rujukan",
  "referral.out.head": "Rujukan",
  "referral.out.note": "Catatan: Jika pencarian dilakukan berdasarkan tanggal hasil, maka hanya pemeriksaan yang ada hasilnya yang akan muncul.",
  "referral.out.request": "Hasil berdasarkan Tanggal / Pemeriksaan / Jenis Tanggal Instalasi Lab:",
  "referral.print.selected.patient.reports": "Cetak Laporan Pasien yang Dipilih",
  "referral.print.selected.patient.reports.selectall.button": "Pilih Semua",
  "referral.print.selected.patient.reports.selectnone.button": "Kosongkan Pilihan",
  "referral.result.labNumber": "Hasil berdasarkan Nomor Registrasi",
  "referral.result.referenceRange": "Rentang referensi",
  "referral.search": "Cari",
  "referral.search.column.analysisId": "ID Analisis",
  "referral.search.column.referenceLab": "Lab Rujukan",
  "referral.search.column.resultDate": "Tanggal Hasil",
  "referral.search.column.sentDate": "Tanggal Dikirim",
  "referral.test": "Pemeriksaan",
  "referral.testresult.pastnote": "Catatan Sebelumnya",
  "referral.units": "Unit",
  "referrer.label": "Perujuk",
  "reflexTests": "Pemeriksaan Refleks",
  "reject.action.button": "Penolakan",
  "reject.order.sample.notification": "Anda menolak sampel. Sampel ini akan ditolak dan tidak akan muncul dalam rencana kerja setelah disimpan, tidak ada hasil yang dapat dimasukkan untuk pemesanan ini.",
  "remaining.quantity": "Kuantitas sisa:",
  "remove.aliquot": "Hapus Alikuot",
  "report.enter.labNumber.headline": "Buat laporan atau semua laporan dalam rentang tertentu berdasarkan Nomor Permintaan / Nomor Registrasi",
  "report.enter.patient.headline": "Buat Semua Laporan untuk Klien tertentu",
  "report.enter.patient.headline.description": "Cari pasien melalui nomor registrasi sebelumnya, ID Pasien (yang dapat berupa nomor ID Kesehatan Unik atau NIK) atau bidang lainnya.",
  "report.enter.site.headline": "Buat Laporan berdasarkan Tempat",
  "report.labe.byLabNumber": "Laporan berdasarkan Nomor Registrasi",
  "report.labe.byPatient": "Laporan berdasarkan Pasien",
  "report.labe.date": "Laporan berdasarkan Tanggal",
  "report.labe.site": "Laporan berdasarkan Tempat",
  "report.label.site.dateType": "Jenis Tanggal",
  "report.label.site.onlyResults": "Hanya Laporan yang ada hasil",
  "report.patient.site.description": "Buat laporan berdasarkan tanggal hasil atau tanggal permintaan. Tanggal hasil hanya akan menampilkan laporan dengan hasil. Jika Anda hanya memilih laporan dengan hasil, maka semua laporan untuk pemeriksaan yang dalam pengerjaan tidak akan dibuat.",
  "report.patient.title.final": "Results: final report",
  "report.patient.title.partial": "Results: partial report",
  "report.patient.labDirector": "Lab director",
  "report.patient.block.order": "Pemesanan",
  "report.patient.block.dates": "Dates",
  "report.patient.siteWard": "Site / ward",
  "report.patient.completed": "Selesai",
  "report.patient.completed.pending": "Not yet complete",
  "report.patient.contactTracing.indexName": "Contact tracing index name",
  "report.patient.contactTracing.indexRecordNumber": "Contact tracing index record number",
  "report.patient.samples": "Sampel",
  "report.patient.sample.number": "#",
  "report.patient.sample.condition": "Kondisi",
  "report.patient.sample.rejected": "Rejected: {0}",
  "report.patient.sample.notRecorded": "Tidak terekam",
  "report.patient.strip.collected": "Collected {0}",
  "report.patient.strip.collectedFirst": "Collected {0} (first of {1} samples)",
  "report.patient.result.sampleRejected": "Sample rejected",
  "report.patient.result.rejected": "Ditolak",
  "report.patient.col.sample": "Smp",
  "report.patient.col.completed": "Selesai",
  "report.patient.flag.low": "L",
  "report.patient.flag.high": "H",
  "report.patient.flag.criticalLow": "LL",
  "report.patient.flag.criticalHigh": "HH",
  "report.patient.flag.abnormal": "*",
  "report.patient.flag.referred": "R",
  "report.patient.flag.confirm": "C",
  "report.patient.legend": "Legend",
  "report.patient.legend.high": "above normal",
  "report.patient.legend.low": "below normal",
  "report.patient.legend.critical": "critical",
  "report.patient.legend.referred": "referred, result pending",
  "report.patient.legend.confirm": "confirmation test",
  "report.patient.notAccredited": "Not within the laboratory's accredited scope",
  "report.patient.awaitingValidation": "Awaiting validation",
  "report.patient.performedBy": "Dilakukan oleh {0}",
  "report.patient.accred.notesLine": "Tests on this report are accredited by: {0}.",
  "report.patient.callback.line": "Callback: {0}, {1}, by {2}. {3}.",
  "report.patient.callback.more": "(+{0} earlier attempts)",
  "report.patient.callback.confirmed": "Read back confirmed",
  "report.patient.callback.noReadback": "Terhubung, tanpa baca ulang",
  "report.patient.callback.unreachable": "Tidak dapat dihubungi",
  "report.patient.corrected.line": "Corrected report. Replaces the report issued {0}. Change: {1}.",
  "report.patient.corrected.seeReplaced": "See the replaced report",
  "report.patient.version": "Version {0}.",
  "report.patient.footer.version": "Version {0}",
  "report.patient.comments": "General comments",
  "report.patient.releasedBy": "Validated and released by",
  "report.patient.endOfReport": "End of report",
  "report.patient.issued": "Issued",
  "report.patient.page": "Page",
  "report.select.site": "Pilih Tempat",
  "report.select.studttype": "Pilih Jenis Kajian",
  "reporting.label.testName": "Nama Pemeriksaan yang dilaporkan",
  "reports.auditTrail": "Jejak Audit",
  "reports.systemAuditTrail": "Jejak Audit Sistem",
  "reports.button": "Membuat Laporan",
  "reports.dateRange": "Rentang Tanggal",
  "reports.endDate": "Tanggal Selesai",
  "reports.error.dateRangeRequired": "Rentang tanggal wajib untuk jenis laporan ini",
  "reports.error.generationFailed": "Gagal membuat laporan. Silahkan coba lagi.",
  "reports.error.invalidDate": "Tanggal tidak valid",
  "reports.error.invalidDateRange": "Tanggal selesai harus setelah tanggal mulai",
  "reports.error.unknownExportFormat": "Format ekspor tidak dikenal",
  "reports.error.unknownReportType": "Jenis laporan tidak dikenal",
  "reports.export": "Ekspor",
  "reports.export.byDate": "Ekspor berdasarkan Tanggal",
  "reports.export.byDate_routine": "Laporan CSV Rutin",
  "reports.export.general": "Ekspor umum",
  "reports.export.specific": "Ekspor Data Viral Load",
  "reports.export.valid": "Valid",
  "reports.export.whonet": "Laporan WHONET",
  "reports.followupRequired.byLocation": "Diperlukan Tindak Lanjut",
  "reports.format": "Format Ekspor",
  "reports.format.select": "Pilih format",
  "reports.generate.title": "Membuat Laporan Inventaris",
  "reports.generating": "Membuat...",
  "reports.generation.success": "Laporan berhasil dibuat dan diunduh",
  "reports.groupByLocation": "Kelompokkan berdasarkan lokasi penyimpanan",
  "reports.groupByType": "Kelompokkan berdasarkan jenis barang",
  "reports.grouping": "Opsi Pengelompokan",
  "reports.help.description": "Laporan ini untuk menganalisis data inventaris Anda:",
  "reports.help.tip1": "Rentang tanggal untuk analisis kecenderungan",
  "reports.help.tip2": "Kelompokkan berdasarkan jenis atau lokasi agar lebih mudah dipahami",
  "reports.help.tip3": "Ekspor ke Excel untuk analisis lebih lanjut",
  "reports.help.title": "Tips Pelaporan",
  "reports.includeExpired": "Sertakan lot kedaluwarsa",
  "reports.includeInactive": "Sertakan barang inaktif",
  "reports.info.message": "Pilih jenis dan pilihan laporan di bawah. Pembuatan laporan memerlukan waktu.",
  "reports.info.title": "Pembuatan Laporan",
  "reports.label.cistudyexport": "Laporan Umum",
  "reports.label.indicator": "Indikator",
  "reports.label.indicator.performance": "Kinerja Bagian",
  "reports.label.referred.out": "Laporan Pemeriksaan yang dirujuk ke luar",
  "reports.label.trends": "Tren",
  "reports.menu.covid": "Laporan Covid",
  "reports.nonConformity.byDate.report": "Berdasarkan Tanggal",
  "reports.nonConformity.byLabno.report": "Berdasarkan No Lab",
  "reports.nonConformity.bySectionReason.report": "Berdasarkan Unit dan Alasan",
  "reports.nonConformity.bySectionReason.title": "Laporan Ketidaksesuaian berdasarkan Unit dan Alasan",
  "reports.nonConformity.menu": "Laporan Ketidaksesuaian",
  "reports.nonConformity.notification.report": "Notifikasi Ketidaksesuaian",
  "reports.nonConformity.notification.report.instructions": "Jika layanan dipilih, maka semua notifikasi ketidaksesuaian yang belum dicetak akan dicetak. Jika tidak ada layanan yang tercantum, maka semua pemberitahuan telah dicetak. Dengan memasukkan nomor registrasi, maka Anda akan mencetak notifikasi meskipun sebelumnya telah dicetak. Layanan ini tidak harus dipilih.",
  "reports.options": "Opsi Filter",
  "reports.patient.ARV.version1": "ARV-Versi",
  "reports.patient.ARV.version1 ": "ARV-Versi 1",
  "reports.patient.ARVFollowup.version1": "ARV Tindak Lanjut Versi 1",
  "reports.patient.ARVFollowup.version2": "ARV Tindak Lanjut Versi 2",
  "reports.patient.ARVInitial.version1": "ARV Awal Versi 1",
  "reports.patient.ARVInitial.version2": "ARV Awal Versi 2",
  "reports.patient.Indeterminate.location": "Indeterminate berdasarkan Layanan",
  "reports.patient.Indeterminate.version1": "Indeterminate Versi 1",
  "reports.patient.Indeterminate.version2": "Indeterminate Versi 2",
  "reports.startDate": "Tanggal Mulai",
  "reports.type": "Jenis Laporan",
  "reports.type.expirationForecast": "Prakiraan Kedaluwarsa",
  "reports.type.expirationForecast.description": "Barang yang akan kedaluwarsa dalam rentang waktu tersebut",
  "reports.type.lotTraceability": "Ketertelusuran Lot",
  "reports.type.lotTraceability.description": "Ketertelusuran lengkap pergerakan dan penggunaan lot.",
  "reports.type.lowStock": "Peringatan Stok Sedikit",
  "reports.type.lowStock.description": "Barang yang di bawah level stok minimum",
  "reports.type.select": "Pilih jenis laporan",
  "reports.type.stockLevels": "Laporan Level Stok",
  "reports.type.stockLevels.description": "Level stok saat ini untuk semua barang inventaris",
  "reports.type.transactionHistory": "Riwayat Transaksi",
  "reports.type.transactionHistory.description": "Semua transaksi dalam kurun tanggal",
  "reports.type.usageTrends": "Kecenderungan Penggunaan",
  "reports.type.usageTrends.description": "Pola penggunaan dan kecenderungan konsumsi seiring waktu",
  "request.samesite.order": "Masukan permintaan dari tempat yang sama",
  "requester.label": "Pemohon",
  "required.invalidtext": "FIeld ini wajib",
  "result.acceptasis.warning": "Dengan mencentang kotak ini berarti Anda menerima hasilnya tanpa syarat. \nHal ini dapat berarti:\n1. Pemeriksaan sudah diulang dan hasilnya sama.\n2. Tidak ada hasil, tapi tidak ingin membatalkan pemeriksaan.\n3. Ada perubahan hasil, dan ingin memberi opsi agar petugas dapat mencantumkan catatan perubahan untuk petugas di tahap validasi.\nAlasan mengapa aksi ini dilakukan harus dicantumkan.\n",
  "result.acceptasis.trigger": "Terima",
  "result.acceptasis.reason.label": "Alasan untuk penerimaan tanpa syarat",
  "result.acceptasis.reason.placeholder": "Wajib — mis. diuji ulang dua kali dengan hasil yang sama, atau tidak ada hasil tersedia",
  "result.acceptasis.confirm": "Konfirmasi penerimaan",
  "result.acceptasis.cancel": "Batal",
  "result.acceptasis.committed": "Diterima",
  "result.acceptasis.undo": "Batal",
  "result.entry.error.accessionRequired": "Silahkan masukkan nomor registrasi",
  "result.entry.error.title": "Kesalahan",
  "result.entry.info.title": "Informasi",
  "result.entry.label": "Entri Hasil",
  "result.entry.noResults": "Tidak ada sampel ditemukan untuk nomor registrasi {accessionNumber}",
  "result.entry.noTestsFound": "Tidak ada pemeriksaan dengan hasil tertunda ditemukan untuk nomor registrasi {accessionNumber}",
  "result.entry.results.accessionNumber": "Nomor Registrasi",
  "result.entry.results.sampleCount": "Sampel",
  "result.entry.results.testCount": "Pemeriksaan",
  "result.entry.results.title": "Hasil Pemeriksaan Tertunda",
  "result.entry.saveSuccess": "Hasil disimpan untuk {testName}",
  "result.entry.search.accessionLabel": "Nomor Registrasi",
  "result.entry.search.accessionPlaceholder": "Masukkan nomor registrasi...",
  "result.entry.search.button": "Cari",
  "result.entry.search.searching": "Mencari...",
  "result.entry.search.title": "Cari berdasarkan Nomor Registrasi",
  "result.entry.success.title": "Berhasil",
  "result.entry.table.action": "Aksi",
  "result.entry.table.header.sampleId": "Nomor Identitas Sampel",
  "result.entry.table.header.sampleType": "Jenis Sampel",
  "result.entry.table.header.testCount": "Pemeriksaan",
  "result.entry.table.noSamples": "Tidak ditemukan sampel dengan pemeriksaan",
  "result.entry.table.noTests": "Tidak ada pemeriksaan untuk sampel ini",
  "result.entry.table.result": "Hasil",
  "result.entry.table.resultPlaceholder": "Masukkan hasil",
  "result.entry.table.save": "Simpan",
  "result.entry.table.saving": "Menyimpan...",
  "result.entry.table.status": "Status",
  "result.entry.table.testName": "Nama Pemeriksaan",
  "result.entry.table.testsTitle": "Pemeriksaan ({count})",
  "result.entry.title": "Entri Hasil",
  "result.noTestsFound": "Tidak ditemukan pemeriksaan yang tepat.",
  "result.nonconforming.item": "Sampel atau permintaan tidak sesuai ATAU telah ditolak",
  "result.outOfValidRange.msg": "Nilai yang Anda masukkan (kolom merah) berada di luar rentang nilai yang diizinkan. Silakan periksa nilainya.",
  "result.notNumeric.msg": "{test}: \"{value}\" bukan angka. Masukkan angka desimal biasa atau notasi ilmiah seperti 1.5e5 atau 1.5 x 10^5, lalu simpan kembali.",
  "result.reject.warning": "Penolakan hasil bersifat permanen. \nHasil tidak akan tersedia lagi.",
  "result.report.queue.size": "Jumlah Antrian :",
  "result.search.noresult": "Hasil tidak ditemukan",
  "resultreporting.browse.title": "Konfigurasi Pelaporan Hasil",
  "resultreporting.config.url": "URL situs untuk mengirim hasil. Contohnya http://192.168.56.101/someSite",
  "resultreporting.config.url.placeholder": "https://orgname.com/someSite",
  "results.label.refer": "Rujuk pemeriksaan ke lab rujukan",
  "routine.reports": "Laporan Rutin",
  "rulebuilder.error.invalidNumeric": "Nomor Numerik Tidak Valid",
  "rulebuilder.error.invalidTest": "Pemeriksaan Tidak Valid",
  "rulebuilder.label.add.externaltrigger": "Masukkan pesan eksternal `dipicu oleh`",
  "rulebuilder.label.add.internaltrigger": "Masukkan pesan internal `dipicu oleh` message",
  "rulebuilder.label.addAction": "Tambah Aksi",
  "rulebuilder.label.addCondition": "Tambah Kondisi",
  "rulebuilder.label.addExternalNote": "Tambah Catatan Eksternal",
  "rulebuilder.label.addInternalNote": "Tambah Catatan Internal",
  "rulebuilder.label.addPopup": "Tambah Pop Up",
  "rulebuilder.label.addRule": "Tambah Aturan",
  "rulebuilder.label.addRuleConditions": "Tambah Kondisi Aturan Refleks",
  "rulebuilder.label.confirmDelete": "Apakah Anda ingin menonaktifkan Aturan ini?",
  "rulebuilder.label.dictValue": "Nilai Kamus",
  "rulebuilder.label.noSuggestions": "Tidak ada saran tersedia",
  "rulebuilder.label.numericValue": "Nilai Numerik",
  "rulebuilder.label.numericValue2": "Nilai Numerik 2",
  "rulebuilder.label.overallOptions": "Semua Opsi",
  "rulebuilder.label.perfomActions": "Lakukan aksi berikut",
  "rulebuilder.label.relation": "Hubungan",
  "rulebuilder.label.removeAction": "Hapus Aksi",
  "rulebuilder.label.removeCondition": "Hapus Kondisi",
  "rulebuilder.label.removeRule": "Nonaktifkan Aturan",
  "rulebuilder.label.rule": "Aturan",
  "rulebuilder.label.ruleDetails": "Lihat Aturan",
  "rulebuilder.label.ruleName": "Nama Aturan",
  "rulebuilder.label.searchTest": "Cari Pemeriksaan",
  "rulebuilder.label.selectSample": "Pilih Sampel",
  "rulebuilder.label.textValue": "Nilai teks",
  "rulebuilder.label.toggleRule": "Alihkan Aturan",
  "sample.accession.number": "Aksesi Sampel",
  "sample.add.action": "Tambah Sampel",
  "sample.collection.date": "Tanggal Pengambilan",
  "sample.collection.method": "Metode Pengambilan",
  "sample.collection.method.placeholder": "mis., venipuncture, capillary, tubing",
  "sample.collection.time": "Waktu Pengambilan",
  "sample.currentDate": "Tanggal Saat Ini",
  "sample.requiredBy": "Wajib",
  "sample.specimen.origin": "Asal Spesimen (lab perujuk)",
  "sample.specimen.origin.placeholder": "Nama laboratorium perujuk",
  "sample.temperature": "Suhu Sampel",
  "sample.temperature.placeholder": "mis., suhu ruang, dibekukan, didinginkan",
  "sample.entry.available.tests": "Pemeriksaan Tersedia",
  "sample.entry.nextVisit.date": "Tanggal kunjungan berikutnya",
  "sample.entry.panels": "Panel",
  "sample.entry.project.patient.and.testName": "Nama/Kode pasien {br} Nama Pemeriksaan",
  "sample.entry.project.testName": "Nama Pemeriksaan",
  "sample.entry.search.barcode": "Cetak Kode QR untuk Permintaan yang Ada",
  "sample.id": "Nomor Identitas Sampel",
  "sample.item.info": "Informasi Sampel",
  "sample.items.for.accession": "Item Sampel untuk nomor registrasi:",
  "sample.label.accessionNumber": "Nomor Registrasi",
  "sample.label.collectionDate": "Tanggal Pengambilan",
  "sample.label.dept": "Ruang/Departmen/Unit",
  "sample.label.facility": "Lembaga Perujuk",
  "sample.label.labnumber": "Nomor Registrasi",
  "sample.label.labnumber.generate": "Buat",
  "sample.label.labnumber.new": "Nomor Registrasi Baru",
  "sample.labnumber.reassign.button": "Tetapkan Ulang No. Registrasi",
  "sample.labnumber.reassign.confirm": "Tetapkan Ulang",
  "sample.labnumber.reassign.current": "Nomor Registrasi Saat Ini",
  "sample.labnumber.reassign.heading": "Tetapkan Ulang No. Registrasi",
  "sample.labnumber.reassign.pending": "Spesimen ini akan dialihkan ke {number} saat Anda menyimpannya.",
  "sample.labnumber.reassign.pending.title": "Penetapan ulang nomor registrasi laboratorium tertunda",
  "sample.labnumber.reassign.undo": "Batal",
  "sample.labnumber.reassign.warning": "Penugasan ulang akan mengubah Nomor Registrasi spesimen ini secara permanen. Label, laporan, dan referensi yang ada yang mengacu pada nomor saat ini tidak akan lagi sesuai dengan nomor tersebut. Lakukan hal ini hanya untuk memperbaiki spesimen yang salah diberi label.",
  "sample.label.noorder": "Permintaan Tidak Ada",
  "sample.label.orderdate": "Tanggal Permintaan",
  "sample.label.orderpanel": "Panel Permintaan",
  "sample.label.requester": "Pemohon",
  "sample.label.search.Order": "Cari Permintaan",
  "sample.label.search.labnumber": "Cari berdasarkan Nomor Registrasi",
  "sample.label.search.patient": "Cari berdasarkan Pasien",
  "sample.label.typeOfSample": "Jenis Sampel",
  "sample.label.types": "Jenis Sampel",
  "sample.management.action.clearSelection": "Hapus Pilihan",
  "sample.management.action.createAliquot": "Buat Alikuot",
  "sample.management.action.selectAllAliquots": "Pilih Semua Alikuot",
  "sample.management.action.selectAllParents": "Pilih Semua Induk",
  "sample.management.addTests.button": "Tambah Pemeriksaan",
  "sample.management.addTests.error.addFailed": "Gagal menambah pemeriksaan. Silahkan coba lagi.",
  "sample.management.addTests.error.loadSampleTypes": "Error memuat jenis sampel",
  "sample.management.addTests.error.loadTests": "Error memuat pemeriksaan yang tersedia",
  "sample.management.addTests.error.noEligibleSamples": "Tidak dapat menambah pemeriksaan; semua sampel yang dipilih akan dipindahkan seluruhnya",
  "sample.management.addTests.error.noTests": "Silahkan pilih setidaknya satu pemeriksaan",
  "sample.management.addTests.modal.add": "Tambah Pemeriksaan",
  "sample.management.addTests.modal.addCount": "Menambah {count} Pemeriksaan",
  "sample.management.addTests.modal.adding": "Menambahkan...",
  "sample.management.addTests.modal.aliquotsIncluded": "alikuot dimasukkan",
  "sample.management.addTests.modal.bulkAliquotNote": "Pemeriksaan akan ditambahkan pada sampel yang dipilih termasuk alikuot.",
  "sample.management.addTests.modal.cancel": "Batal",
  "sample.management.addTests.modal.noEligibleSamples": "Tidak Ada Sampel yang Memenuhi Syarat",
  "sample.management.addTests.modal.noTestsAvailable": "Tidak ada pemeriksaan tersedia untuk jenis sampel ini.",
  "sample.management.addTests.modal.noTestsSelected": "Tidak ada pemeriksaan yang dipilih",
  "sample.management.addTests.modal.panels": "Panel",
  "sample.management.addTests.modal.searchTestsPlaceholder": "Cari pemeriksaan...",
  "sample.management.addTests.modal.selectSampleType": "Jenis Sampel",
  "sample.management.addTests.modal.selectSampleTypeFirst": "Silahkan pilih jenis sampel untuk mulai menampilkan panel dan pemeriksaan yang tersedia.",
  "sample.management.addTests.modal.selectSampleTypePlaceholder": "Pilih jenis sampel...",
  "sample.management.addTests.modal.selectTests": "Pilih Pemeriksaan",
  "sample.management.addTests.modal.selectTestsPlaceholder": "Cari dan pilih pemeriksaan...",
  "sample.management.addTests.modal.selectedTests": "Pemeriksaan yang Dipilih",
  "sample.management.addTests.modal.subtitle": "Tambah pemeriksaan ke {count} sampel terpilih",
  "sample.management.addTests.modal.tests": "Pemeriksaan",
  "sample.management.addTests.modal.title": "Tambahkan Pemeriksaan ke Sampel",
  "sample.management.addTests.resultItem": "{sampleId}: {added} ditambahkan",
  "sample.management.addTests.resultItem.withSkipped": "{sampleId}: {added} ditambah, {skipped} dilewatkan",
  "sample.management.addTests.success": "{count} pemeriksaan telah berhasil ditambah",
  "sample.management.addTests.successDetailed": "{count} pemeriksaan ditambah ke sampel {samples}: {details}",
  "sample.management.addTests.successDetailedWithSkipped": "{added} pemeriksaan ditambah ke sampel {samples}, {skipped} dilewatkan: {details}",
  "sample.management.addTests.successWithSkipped": "{added} pemeriksaan ditambah, {skipped} pemeriksaan dilewatkan (sudah dipesan)",
  "sample.management.addTests.title": "Tambah Pemeriksaan",
  "sample.management.addTests.warning.dispensedSamples": "{count} sampel yang tidak ada volume tersisa akan dilewatkan. Pemeriksaan akan ditambahkan pada {eligible} sampel yang memenuhi syarat.",
  "sample.management.addTests.warning.dispensedSamples.title": "Tidak termasuk sampel yang dipindahkan",
  "sample.management.aliquot.error.createFailed": "Gagal membuat alikuot. Silahkan coba lagi.",
  "sample.management.aliquot.error.numberOfAliquotsInvalid": "Jumlah alikuot harus antara 1 dan 100",
  "sample.management.aliquot.error.quantityExceedsRemaining": "Kuantitas yang diminta ({requested}) melebihi yang tersisa ({remaining})",
  "sample.management.aliquot.error.quantityPerAliquotTooSmall": "Kuantitas per alikuot ({quantityPerAliquot}) akan kurang dari minimum (0.001)",
  "sample.management.aliquot.error.quantityPositive": "Kuantitas harus lebih dari 0",
  "sample.management.aliquot.error.quantityRequired": "Kuantitas harus ada",
  "sample.management.aliquot.error.title": "Error",
  "sample.management.aliquot.modal.cancel": "Batal",
  "sample.management.aliquot.modal.create": "Buat Alikuot",
  "sample.management.aliquot.modal.createMultiple": "Buat {count} Alikuot",
  "sample.management.aliquot.modal.creating": "Membuat...",
  "sample.management.aliquot.modal.notesLabel": "Catatan (Opsional)",
  "sample.management.aliquot.modal.notesPlaceholder": "Tambah catatan mengenai alikuot ini...",
  "sample.management.aliquot.modal.numberOfAliquotsHelper": "Masukkan jumlah alikuot bervolume sama yang akan dibuat (1-100)",
  "sample.management.aliquot.modal.numberOfAliquotsLabel": "Jumlah Alikuot",
  "sample.management.aliquot.modal.parentInfo": "Informasi Sampel Induk",
  "sample.management.aliquot.modal.preview": "Pratinjau",
  "sample.management.aliquot.modal.previewText": "Membuat {count} alikuot dengan kuantitas masing-masing {quantityEach} {unit}",
  "sample.management.aliquot.modal.quantityHelper": "Masukkan kuantitas untuk dipindahkan dalam {unit}",
  "sample.management.aliquot.modal.quantityLabel": "Kuantitas yang akan Dipindahkan",
  "sample.management.aliquot.modal.quantityPlaceholder": "Masukkan kuantitas",
  "sample.management.aliquot.modal.subtitle": "Membuat alikuot dari sampel {externalId}",
  "sample.management.aliquot.modal.title": "Buat Alikuot",
  "sample.management.aliquot.modal.totalQuantityHelper": "Masukkan kuantitas total untuk dibagi ke alikuot dalam {unit}",
  "sample.management.aliquot.modal.totalQuantityLabel": "Total Kuantitas yang akan Dipindahkan",
  "sample.management.aliquot.success": "Alikuot {externalId} berhasil dibuat. Silahkan lakukan pencarian kembali untuk melihat pembaruan hasil.",
  "sample.management.aliquot.successMultiple": "{count} alikuot berhasil dibuat ({externalIds}). Silahkan lakukan pencarian kembali untuk melihat pembaruan hasil.",
  "sample.management.breadcrumb.title": "Pengelolaan Sampel",
  "sample.management.cancelTest.error": "Gagal membatalkan pemeriksaan. Silahkan coba lagi.",
  "sample.management.cancelTest.success": "Pemeriksaan \"{testName}\" berhasil dibatalkan",
  "sample.management.description": "Pencarian dan pengelolaan item sampel, membuat alikuot, dan menambah pemeriksaan",
  "sample.management.error.title": "Error",
  "sample.management.hierarchy.aliquotOf": "Alikuot dari {parent}",
  "sample.management.hierarchy.aliquots": "alikuot",
  "sample.management.noResults.subtitle": "Tidak ada sampel ditemukan untuk nomor registrasi ini: {accessionNumber}",
  "sample.management.noResults.title": "Hasil tidak ditemukan",
  "sample.management.results.accessionNumber": "Nomor Registrasi",
  "sample.management.results.aliquots": "alikuot",
  "sample.management.results.aliquotsSelected": "alikuot",
  "sample.management.results.item": "item",
  "sample.management.results.items": "item",
  "sample.management.results.selected": "Dipilih",
  "sample.management.results.title": "Item Sampel",
  "sample.management.results.totalCount": "Total Sampel",
  "sample.management.search.error.general": "Error memuat hasil sampel. Silahkan coba lagi.",
  "sample.management.search.label": "Cari Sampel",
  "sample.management.search.loading": "Mencari...",
  "sample.management.search.placeholder": "Masukkan nomor registrasi untuk mencari...",
  "sample.management.search.title": "Cari Sampel",
  "sample.management.status.allVolumeDispensed": "Semua volume dipindahkan",
  "sample.management.status.available": "Tersedia",
  "sample.management.status.consumed": "Habis",
  "sample.management.status.inUse": "Sedang Digunakan",
  "sample.management.status.unknown": "Tidak diketahui",
  "sample.management.success.title": "Berhasil",
  "sample.management.table.cancelTest": "Batalkan Pemeriksaan",
  "sample.management.table.cancelling": "Membatalkan...",
  "sample.management.table.header.externalId": "Nomor Identitas Sampel",
  "sample.management.table.header.hierarchy": "Hirarki",
  "sample.management.table.header.originalQuantity": "Kuantitas Awal",
  "sample.management.table.header.quantity": "Kuantitas Awal",
  "sample.management.table.header.remainingQuantity": "Kuantitas Sisa",
  "sample.management.table.header.sampleType": "Jenis Sampel",
  "sample.management.table.header.status": "Status",
  "sample.management.table.header.tests": "Pemeriksaan",
  "sample.management.table.noResults": "Tidak ada item sampel untuk ditampilkan. Gunakan pencarian di atas untuk menemukan sampel.",
  "sample.management.table.noTests": "Tidak ada pemeriksaan yang dipesan untuk sampel ini",
  "sample.management.table.orderedDate": "Dipesan",
  "sample.management.table.orderedTests": "Pemeriksaan yang Dipesan ({count})",
  "sample.management.title": "Pengelolaan Sampel",
  "sample.panel.label.text": "Cari Panel yang Tersedia",
  "sample.panel.placeholder": "Pilih Panel yang Tersedia",
  "sample.panel.search.error.msg": "Tidak ada panel yang cocok",
  "sample.quantity.label": "Kuantitas",
  "sample.receivedDate": "Tanggal Diterima",
  "sample.reject.label": "Tolak Sampel",
  "sample.reject.reason.choose": "Choose a rejection reason",
  "sample.reject.reason.label": "Alasan Penolakan",
  "sample.reject.reasonRequired": "Choose a rejection reason.",
  "sample.remove.action": "Hapus Sampel",
  "sample.requestDate": "Tanggal Permintaan",
  "sample.search.nosample": "Tidak ada sampel ditemukan untuk nomor registrasi ini",
  "sample.search.panel.legend.text": "Cari dari panel yang tersedia",
  "sample.search.scanner.instructions": "Pindai atau Masukkan Manual. Untuk laporan tunggal, kosongkan kotak di kanan",
  "sample.search.scanner.instructions.highaccession": "Untuk laporan tunggal, kosongkan kotak di kanan",
  "sample.search.scanner.instructions2": "Pindai atau Masukkan Manual",
  "sample.search.title": "Cari Sampel",
  "sample.select.type": "Pilih jenis sampel",
  "sample.type": "Jenis Sampel",
  "sample.type.and.test.sort.order": "Jenis sampel dan urutan penyortiran pemeriksaan",
  "sample.type.helper": "Pilih jenis sampel - panel dan pemeriksaan yang tersedia akan diperbarui setelah pemilihan.",
  "sample.uom.label": "Satuan Pengukuran Sampel",
  "sample.voided.title": "Sampel dibatalkan",
  "sampleManagement.actions": "Aksi",
  "sampleManagement.addTests.button": "Tambah Pemeriksaan",
  "sampleManagement.addTests.cancel": "Batal",
  "sampleManagement.addTests.duplicate": "Pemeriksaan sudah dipesan untuk {sampleId}",
  "sampleManagement.addTests.error": "Error menambah pemeriksaan",
  "sampleManagement.addTests.incompatible": "Pemeriksaan tidak kompatibel dengan jenis sampel ({sampleType})",
  "sampleManagement.addTests.selectSamples": "Pilih Sampel untuk menambah Pemeriksaan",
  "sampleManagement.addTests.selectTests": "Pilih Sampel untuk ditambah",
  "sampleManagement.addTests.skipped": "{count} duplikat dilewati",
  "sampleManagement.addTests.submit": "Tambah Pemeriksaan",
  "sampleManagement.addTests.success": "{count} pemeriksaan berhasil ditambah",
  "sampleManagement.addTests.title": "Tambahkan Pemeriksaan ke Sampel",
  "sampleManagement.aliquot.button": "Buat Alikuot",
  "sampleManagement.aliquot.cancel": "Batal",
  "sampleManagement.aliquot.error": "Error saat membuat alikuot",
  "sampleManagement.aliquot.error.concurrentModification": "Pengguna lain memodifikasi sampel ini. Refresh dan coba lagi.",
  "sampleManagement.aliquot.error.insufficientQuantity": "Tidak dapat membuat alikuot: yang diminta {requested} melebihi yang sisa {remaining}",
  "sampleManagement.aliquot.error.noRemainingQuantity": "Semua volume dipindahkan: tidak ada kuantitas sisa yang tersedia untuk pengalikuotan",
  "sampleManagement.aliquot.notes": "Catatan (opsional)",
  "sampleManagement.aliquot.notesPlaceholder": "Tambahkan catatan untuk alikuot ini...",
  "sampleManagement.aliquot.parentExternalId": "Identitas Eksternal Induk",
  "sampleManagement.aliquot.parentLabel": "Sampel Induk",
  "sampleManagement.aliquot.quantityPlaceholder": "Masukkan kuantitas...",
  "sampleManagement.aliquot.quantityToTransfer": "Kuantitas yang akan Dipindahkan",
  "sampleManagement.aliquot.remainingQuantity": "Kuantitas Sisa",
  "sampleManagement.aliquot.submit": "Buat Alikuot",
  "sampleManagement.aliquot.success": "Alikuot {externalId} berhasil dibuat",
  "sampleManagement.aliquot.title": "Buat Alikuot",
  "sampleManagement.aliquot.unit": "Unit",
  "sampleManagement.aliquot.validation.exceeds": "Kuantitas melebihi kuantitas sisa",
  "sampleManagement.aliquot.validation.min": "Kuantitas harus setidaknya 0.001",
  "sampleManagement.aliquot.validation.required": "Kuantitas untuk dipindahkan harus ada",
  "sampleManagement.clearSelection": "Hapus pilihan",
  "sampleManagement.hierarchy.children": "Alikuot:",
  "sampleManagement.hierarchy.collapse": "Susutkan hirarki",
  "sampleManagement.hierarchy.expand": "Kembangkan hirarki",
  "sampleManagement.hierarchy.level": "Tingkatan {level}",
  "sampleManagement.hierarchy.parent": "Induk:",
  "sampleManagement.notification.refreshResults": "Hasil sudah direfresh",
  "sampleManagement.results.children": "Alikuot",
  "sampleManagement.results.collectionDate": "Tanggal Pengambilan",
  "sampleManagement.results.count": "{count} sampel ditemukan",
  "sampleManagement.results.externalId": "Identitas Eksternal",
  "sampleManagement.results.originalQuantity": "Kuantitas Awal",
  "sampleManagement.results.parent": "Induk",
  "sampleManagement.results.remainingQuantity": "Kuantitas Sisa",
  "sampleManagement.results.sampleType": "Jenis Sampel",
  "sampleManagement.results.status": "Status",
  "sampleManagement.results.tests": "Pemeriksaan",
  "sampleManagement.results.title": "Hasil Pencarian",
  "sampleManagement.search.button": "Cari",
  "sampleManagement.search.error": "Error saat mencari sampel",
  "sampleManagement.search.label": "Cari berdasarkan Nomor Registrasi",
  "sampleManagement.search.loading": "Mencari...",
  "sampleManagement.search.noResults": "Tidak ada sampel ditemukan untuk nomor registrasi ini",
  "sampleManagement.search.placeholder": "Masukkan Nomor Registrasi...",
  "sampleManagement.selectSamples": "Pilih Sampel",
  "sampleManagement.selectedCount": "{count} terpilih",
  "sampleManagement.test.name": "Nama Pemeriksaan",
  "sampleManagement.test.orderedDate": "Tanggal Permintaan",
  "sampleManagement.test.status": "Status",
  "sampleManagement.test.status.CANCELLED": "Dibatalkan",
  "sampleManagement.test.status.COMPLETED": "Selesai",
  "sampleManagement.test.status.IN_PROGRESS": "Dalam Pengerjaan",
  "sampleManagement.test.status.ORDERED": "Pemesanan",
  "sampleManagement.title": "Pengelolaan Sampel",
  "sampleManagement.validation.accessionNumberRequired": "Nomor Registrasi wajib ada",
  "sampleManagement.validation.parentSampleRequired": "Item sampel induk harus ada",
  "sampleManagement.validation.samplesRequired": "Setidaknya satu sampel harus dipilih",
  "sampleManagement.validation.testsRequired": "Setidaknya satu pemeriksaan harus dipilih",
  "sampleType.existing": "Jenis sampel yang ada",
  "sampleType.existing.inactive": "Jenis Sampel Inaktif. Tugaskan pemeriksaan untuk mengaktivasi.",
  "sampleType.new": "Jenis Sampel Baru",
  "sampleType.typeName": "Nama Jenis Sampel",
  "save.aliquot.changes": "Simpan Perubahan Alikuot",
  "save.config.success.msg": "Konfigurasi Berhasil Diperbarui",
  "save.order.success.msg": "Entri Permintaan Sampel berhasil disimpan",
  "save.success": "Penyimpanan berhasil",
  "saving": "Menyimpan...",
  "search.by.dictionary.entry": "Cari berdasarkan Entri Kamus",
  "search.label": "Cari",
  "search.label.accession": "Masukkan Nomor Registrasi",
  "search.label.analysis": "Pilih Status Analisis",
  "search.label.collectiondate": "Masukkan Tanggal Pengambilan",
  "search.label.fromaccession": "Dari Nomor Registrasi",
  "search.label.loadnext": "Masukkan 99 Rekaman Berikutnya, dimulai dari Nomor Registrasi",
  "search.label.receiveddate": "Masukkan Tanggal Diterima",
  "search.label.sample": "Pilih Status Sampel",
  "search.label.test": "Pilih Nama Pemeriksaan",
  "search.label.testdate": "Masukkan Tanggal Pemeriksaan",
  "search.label.testunit": "Pilih Instalasi Lab",
  "search.label.toaccession": "Ke Nomor Registrasi",
  "search.patient.label": "Cari Pasien",
  "search.placeholder": "Mencari...",
  "searchTests.label": "Cari Pemeriksaan yang Tersedia",
  "searchTests.legend": "Cari seluruh pemeriksaan yang tersedia",
  "searchindexmanagement.description": "Indeks pencarian diperbarui secara otomatis saat data ditambahkan atau dimodifikasi. Jika Anda ingin memperbarui indeks pencarian secara manual, klik tombol Mulai Pengindeksan Ulang. Proses ini akan membutuhkan waktu.",
  "searchindexmanagement.label": "Cari Pengelolaan Indeks",
  "searchindexmanagement.reindex": "Mulai Pengindeksan",
  "searchindexmanagement.reindex.error": "Pengindeksan Ulang gagal",
  "searchindexmanagement.reindex.success": "Pengindeksan Ulang berhasil",
  "select.aliquot": "Cari Alikuot",
  "select.datarange.label": "Rentang tanggal adalah saat perujukan dilakukan",
  "select.dateRange": "Pilih Rentang Tanggal untuk Ringkasan Laporan Pemeriksaan",
  "select.default.option.label": "Pilih satu opsi",
  "select.end.date.referredTests": "Tanggal Selesai (dd/mm/yyyy)",
  "select.labUnits": "Pilih unit laboratorium yang ingin Anda buat pemeriksaannya, Anda dapat memilih sebanyak yang dinginkan.",
  "select.label.analyser": "Pilih Alat",
  "select.priority.tests": "Pilih prioritas pemeriksaan yang ingin ditampilkan",
  "select.program": "Program",
  "select.referral.centre": "Pusat Rujukan atau Laboratorium",
  "select.referral.centre.is.required": "Pusat rujukan atau laboratorium adalah wajib",
  "select.start.date.referredTests": "Tanggal Dimulai (dd/mm/yyy)",
  "select.timeFrame": "Pilih waktu yang diinginkan untuk membuat laporan",
  "select.timeFrame.Note": "CATATAN: semua tanggal dan waktu didasarkan pada waktu penerimaan. Contoh: pemeriksaan yang diterima pada 31 Januari pukul 23:59 dan hasilnya keluar pada 1 Februari pukul 09:30 akan tercatat di luar jam kerja normal pada bulan Januari.",
  "select.year.report": "Pilih tahun yang diinginkan untuk membuat laporan",
  "selectListRenameEntry.selectList": "Pilih Daftar Ganti Nama Entri",
  "selectListRenameEntry.selectListEdit": "Pilih Edit Daftar Ganti Nama Entri",
  "selectReportValues.title": "Pilih Nilai Laporan",
  "selectResult.title": "Pilih Hasil",
  "serial.config.active.label": "Aktif",
  "serial.config.baudRate.label": "Kecepatan Baud",
  "serial.config.connect.button": "Hubungkan",
  "serial.config.connect.error": "Error saat menghubungkan serial port",
  "serial.config.connect.success": "Serial port berhasil terhubung",
  "serial.config.create.title": "Buat Konfigurasi Serial Port",
  "serial.config.dataBits.label": "Bit Data",
  "serial.config.disconnect.button": "Koneksi Putus",
  "serial.config.disconnect.error": "Error saat diskoneksi serial port",
  "serial.config.disconnect.success": "Diskoneksi serial port berhasil",
  "serial.config.edit.title": "Edit Konfigurasi Serial Port",
  "serial.config.flowControl.label": "Kendali Alur",
  "serial.config.flowControl.none": "Tidak ada",
  "serial.config.form.legend": "Pengaturan Serial Port",
  "serial.config.parity.even": "Genap",
  "serial.config.parity.label": "Paritas",
  "serial.config.parity.mark": "Tanda",
  "serial.config.parity.none": "Tidak ada",
  "serial.config.parity.odd": "Ganjil",
  "serial.config.parity.space": "Ruang",
  "serial.config.portName.label": "Nama Portal",
  "serial.config.save.error": "Gagal menyimpan konfigurasi serial port",
  "serial.config.save.success": "Konfigurasi serial port berhasil disimpan",
  "serial.config.status.label": "Status Koneksi",
  "serial.config.stopBits.label": "Bit Penghenti",
  "serial.config.validation.analyzerId.required": "Identitas alat wajib ada",
  "serial.config.validation.baudRate.invalid": "Baud rate harus di antara 9600 dan 115200",
  "serial.config.validation.dataBits.invalid": "Bit data harus 7 atau 8",
  "serial.config.validation.portName.required": "Nama portal wajib ada",
  "server.error.msg": "Error pada server, silahkan kontak administrator",
  "common.retry": "Ulang",
  "show.aliquoting": "Tampilkan Pengalikuotan",
  "showing": "Menampilkan",
  "breadcrumb.label.addOrder": "Tambah Pemesanan",
  "sidenav.label.admin": "Admin",
  "sidenav.label.admin.backToMainMenu": "Kembali ke menu utama",
  "sidenav.label.admin.barcodeconfiguration": "Konfigurasi Kode QR",
  "sidenav.label.admin.labelPresets": "Pengaturan Label",
  "sidenav.label.admin.commonproperties": "Properti Aplikasi",
  "sidenav.label.admin.eqaProgram": "Pengelolaan Program PME",
  "sidenav.label.admin.formEntry.menustatementconfig": "Konfigurasi MenuStatement",
  "sidenav.label.admin.formEntry.nonconformityconfig": "Konfigurasi Ketidaksesuaian",
  "sidenav.label.admin.formEntry.patientconfig": "Konfigurasi Entri Pasien",
  "sidenav.label.admin.formEntry.PrintedReportsconfig": "Konfigurasi Laporan Cetak",
  "sidenav.label.admin.formEntry.resultConfig": "Konfigurasi Entri Hasil",
  "sidenav.label.admin.formEntry.sampleEntryconfig": "Konfigurasi Entri Permintaan",
  "sidenav.label.admin.formEntry.siteBranding": "Branding Situs",
  "sidenav.label.admin.formEntry.siteInfoconfig": "Pengaturan Informasi Aplikasi",
  "sidenav.label.admin.formEntry.validationconfig": "Konfigurasi Validasi",
  "sidenav.label.admin.formEntry.Workplanconfig": "Konfigurasi Rencana Kerja",
  "sidenav.label.admin.labNumber": "Pengelolaan Nomor Registrasi",
  "sidenav.label.admin.localization": "Lokalisasi",
  "sidenav.label.admin.menu": "Konfigurasi Menu",
  "sidenav.label.admin.menu.billing": "Konfigurasi Menu Pembayaran",
  "sidenav.label.admin.menu.global": "Konfigurasi Menu Global",
  "sidenav.label.admin.menu.nonconform": "Konfigurasi Menu Ketidaksesuaian",
  "sidenav.label.admin.menu.patient": "Konfigurasi Menu Pasien",
  "sidenav.label.admin.menu.study": "Konfigurasi Menu Kajian",
  "sidenav.label.admin.organizationmgt": "Pengelolaan Organisasi",
  "sidenav.label.admin.testmgt": "Konfigurasi Pemeriksaan Refleks",
  "sidenav.label.admin.testmgt.calculated": "Pengelolaan Pemeriksaan dengan Nilai Terkalkulasi",
  "sidenav.label.admin.testmgt.testCatalogEditor": "Editor Katalog Pemeriksaan",
  "sidenav.label.admin.testCatalog": "Pengelolaan Katalog Pemeriksaan",
  "sidenav.label.admin.testCatalog.backToList": "← Semua Pemeriksaan",
  "sidenav.label.admin.testCatalog.sectionsHelper": "Pilih pemeriksaan untuk pengeditan bagian",
  "sidenav.label.admin.testCatalog.editing": "Edit: {name}",
  "sidenav.label.admin.testCatalog.editingGeneric": "Mengedit pemeriksaan",
  "label.testCatalog.editor": "Editor Katalog Pemeriksaan",
  "label.testCatalog.editor.empty": "Tidak ada pengujian yang dipilih",
  "label.testCatalog.editor.empty.helper": "Buka pemeriksaan dari Katalog Pemeriksaan untuk mengedit",
  "label.testCatalog.editor.loadError": "Gagal memuat pemeriksaan ini. Silahkan coba lagi.",
  "label.testCatalog.editor.saveAsNew": "Simpan sebagai pemeriksaan baru...",
  "label.testCatalog.editor.save.pending": "Penyimpanan tersedia setelah editor bagian tersebut dibuat",
  "label.testCatalog.editor.clone.pending": "Simpan sebagai pemeriksaan baru tersedia setelah editor bagian tersebut dibuat",
  "label.testCatalog.section.pending": "Editor bagian ini akan tersedia pada tahap pengembangan berikutnya.",
  "label.testCatalog.section.basic-info": "Informasi Dasar",
  "label.testCatalog.section.sample-results": "Sampel & Hasil",
  "label.testCatalog.section.methods": "Metode",
  "label.testCatalog.section.ranges": "Rentang",
  "label.testCatalog.section.qc-targets": "Target QC",
  "label.testCatalog.section.storage": "Penyimpanan Sampel",
  "label.testCatalog.section.panels": "Panel",
  "label.testCatalog.entity.panels": "Editor Panel",
  "note.panel.domainUpgrade": "Domain panel ditetapkan pada panel itu sendiri, bukan ditentukan dari jenis sampel yang digunakan oleh pemeriksaannya.",
  "note.panel.domainLaterPhase": "Panel yang pemeriksaannya mencakup jenis sampel dari domain lain ditandai sebagai Domain campuran.",
  "label.panel.list.description": "Kumpulan pemeriksaan yang diurutkan; jenis sampel berasal dari pemeriksaan-pemeriksaan yang menjadi anggotanya",
  "label.panel.list.empty": "Tidak ada panel yang sesuai dengan filter saat ini.",
  "label.panel.search": "Cari berdasarkan nama atau LOINC",
  "button.panel.add": "Tambah Panel",
  "label.panel.col.name": "Nama Panel",
  "label.panel.col.tests": "Pemeriksaan",
  "label.panel.col.domain": "Domain",
  "label.panel.list.mixedDomain": "Domain campuran",
  "label.panel.list.mixedDomain.detail": "Jenis sampel di luar domain panel ini: {sampleTypes}",
  "label.panel.col.sampleTypes": "Jenis Sampel (turunan)",
  "label.panel.col.status": "Status",
  "label.panel.backToList": "Kembali ke daftar",
  "label.panel.notFound": "Panel ini tidak ada atau tidak dapat dimuat. Kembali ke daftar untuk memilih yang lain.",
  "title.panel.new": "Panel Baru",
  "label.panel.name": "Nama Panel",
  "placeholder.panel.name": "misalnya: Pemeriksaan Anemia",
  "label.panel.domain": "Domain",
  "helper.panel.domainGuard": "Hanya pemeriksaan domain {domain} yang dapat ditambahkan ke panel ini.",
  "helper.panel.loincIsIdentifier": "LOINC panel tersebut berfungsi sebagai pengidentifikasinya.",
  "note.panel.sampleTypesDerived": "Jenis sampel ditentukan berdasarkan pemeriksaan-pemeriksaan yang terdapat dalam panel ini.",
  "label.panel.description": "Deskripsi",
  "label.panel.active": "Aktif",
  "helper.panel.needsTest": "Tambahkan setidaknya satu pemeriksaan sebelum panel ini dapat diaktifkan.",
  "error.panel.save": "Panel tersebut tidak dapat disimpan. Periksa bidang-bidangnya dan coba lagi.",
  "error.panel.nameRequired": "Nama Panel wajib diisi.",
  "error.panel.nameTooLong": "Nama panel berisi maksimal 20 karakter.",
  "error.panel.descriptionTooLong": "Deskripsi berisi maksimal 60 karakter.",
  "error.panel.nameDuplicate": "Panel lain sudah menggunakan nama ini. Masukkan nama yang berbeda.",
  "error.panel.domainConflict": "Panel ini tidak dapat dimasukkan ke dalam {domain}: {count, plural, one {# pemeriksaannya termasuk} other {# pemeriksaannya termasuk}} dalam domain lain ({tests}).",
  "helper.panel.domainConflict.remedy": "Ubah domain pemeriksaan tersebut di Katalog Pemeriksaan, atau hapus dari panel ini, lalu simpan lagi.",
  "error.panel.tests.domainConflict": "Tidak disimpan: {tests} {count, plural, one {tidak} other {tidak}} termasuk dalam domain panel ini ({domain}). Hanya pemeriksaan domain {domain} yang dapat ditambahkan.",
  "error.panel.tests.activeNeedsTest": "Tidak disimpan: panel yang aktif memerlukan minimal satu pemeriksaan. Pertahankan satu pemeriksaan, atau nonaktifkan panel di Informasi Dasar terlebih dahulu.",
  "error.panel.tests.inactive": "Tidak disimpan: {tests} {count, plural, one {inaktif} other {inaktif}}. Hanya pemeriksaan yang aktif yang dapat ditambahkan ke panel.",
  "error.panel.tests.loadFailed": "Pemeriksaan panel tidak dapat dimuat, sehingga belum ada yang dapat disimpan. Coba lagi untuk memuatnya kembali.",
  "error.testCatalog.panels.domainConflict": "Pemeriksaan ini tidak dapat bergabung dengan {panelName}: panel dimasukkan ke dalam {panelDomain} dan pemeriksaan ke dalam {testDomain}.",
  "error.testCatalog.panels.activateFailed": "Panel \"{name}\" was created and this test added, but it could not be switched on. Activate it in the Panel Editor.",
  "error.testCatalog.panels.activeNeedsTest": "Tidak disimpan: {panels} akan tidak memiliki pemeriksaan saat aktif. Nonaktifkan {count, plural, one {panel tersebut} other {panel-panel tersebut}} terlebih dahulu, atau pertahankan pemeriksaan ini di {count, plural, one {panel tersebut} other {panel-panel tersebut}}.",
  "success.panel.created": "Panel dibuat. Panel tetap nonaktif sampai minimal satu pemeriksaan ditetapkan ke panel tersebut.",
  "error.panel.create.invalid": "Panel tidak dapat dibuat. Isi setiap bidang wajib, termasuk kode LOINC.",
  "label.panel.section.basic-info": "Informasi Dasar",
  "label.panel.section.tests": "Pemeriksaan",
  "label.panel.section.terminology": "Terminologi",
  "label.panel.section.localization": "Lokalisasi",
  "label.panel.localization.intro": "Edit terjemahan per bahasa untuk nama panel ini. Bidang yang belum diterjemahkan akan ditampilkan dalam bahasa Inggris. Kelola semua terjemahan dari halaman admin Pengelolaan Terjemahan.",
  "label.panel.localization.empty": "Panel ini tidak memiliki kolom nama yang dapat diterjemahkan.",
  "label.panel.localization.loadError": "Tidak dapat memuat terjemahan untuk panel ini.",
  "label.panel.localization.field.name": "Nama Panel",
  "sidenav.label.admin.panel.editing": "Mengedit panel: {name}",
  "sidenav.label.admin.panel.sectionsHelper": "Klik sebuah panel untuk mengedit bagian-bagiannya",
  "sidenav.label.admin.panel.addingNew": "Menambahkan Panel Baru",
  "label.panel.testsCount": "pengujian",
  "label.panel.addTest": "Tambahkan pemeriksaan",
  "label.panel.tests.filterBySampleType": "Filter berdasarkan Jenis Sampel",
  "label.panel.tests.filterBySampleType.all": "Semua Jenis Sampel",
  "placeholder.panel.addTest": "Cari berdasarkan nama atau kode…",
  "helper.panel.membershipSync": "Perubahan keanggotaan menjaga daftar panel di entri pemesanan tetap sinkron.",
  "label.panel.col.order": "Pemesanan",
  "label.panel.col.testName": "Nama Pemeriksaan",
  "label.panel.col.code": "Kode",
  "label.panel.moveUp": "Geser ke atas",
  "label.panel.moveDown": "Geser ke bawah",
  "empty.panel.tests": "Tidak ada pemeriksaan — gunakan kolom pencarian di atas untuk menambahkan yang pertama.",
  "helper.panel.loincRouting": "Kode ini juga berfungsi sebagai kunci perutean aktif; pemesanan elektronik FHIR mencocokkan panel berdasarkan kode ini saat penerimaan. Kode LOINC utama tetap tercantum pada panel untuk tampilan daftar dan entri pemesanan.",
  "label.panel.terminology.primary": "Primer",
  "label.panel.terminology.empty": "Belum ada pemetaan terminologi. Pemetaan LOINC adalah pengidentifikasi panel tersebut.",
  "label.panel.terminology.saved": "Pemetaan terminologi telah disimpan.",
  "label.panel.terminology.saveInvalid": "Beberapa pemetaan tidak valid. Periksa sumber, kode, dan Duplikasi.",
  "label.panel.terminology.codeTooLong": "Tidak disimpan: kode {code} lebih panjang dari {max} karakter.",
  "label.panel.terminology.loincTooLong": "Tidak disimpan: {code} bukan kode LOINC. Kode LOINC memiliki paling banyak 10 karakter.",
  "label.panel.terminology.saveError": "Tidak dapat menyimpan pemetaan terminologi.",
  "note.panel.positionShared": "Posisi menyimpan nilai panel_item.sort_order - kolom yang sama yang diedit di bagian Panel pada sisi pemeriksaan.",
  "label.testCatalog.section.labels": "Label",
  "label.testCatalog.section.terminology": "Terminologi",
  "label.testCatalog.labels.col.preset": "Pengaturan",
  "label.testCatalog.labels.col.defaultQty": "Kuantitas Default",
  "label.testCatalog.labels.col.maxQty": "Kuantitas Maks",
  "label.testCatalog.labels.col.allowOverride": "Izinkan Override",
  "label.testCatalog.labels.col.actions": "Aksi",
  "label.testCatalog.labels.addLabelType": "Tambah Jenis Label",
  "label.testCatalog.labels.addLabelType.placeholder": "Pilih Pengaturan Label",
  "label.testCatalog.labels.empty": "Tidak ada jenis label yang dikonfigurasi. Tambah pengaturan label untuk secara otomatis diterapkan saat pemeriksaan ini dipesan.",
  "label.testCatalog.labels.loadError": "Gagal memuat konfigurasi label untuk pemeriksaan ini.",
  "label.testCatalog.labels.saved": "Konfigurasi label disimpan",
  "label.testCatalog.labels.saveError": "Gagal menyimpan konfigurasi label.",
  "label.testCatalog.labels.unsaved": "Anda memiliki perubahan label yang tidak tersimpan. Klik Simpan untuk menerapkannya.",
  "label.testCatalog.labels.maxLtDefault": "Kuantitas Maks harus lebih dari atau sama dengan Kuantitas Default.",
  "label.testCatalog.labels.allowOverride.label": "Izinkan override saat entri pemesanan",
  "label.testCatalog.labels.generationSettings": "Pengaturan Pembuatan Label",
  "label.testCatalog.labels.remove.action": "Hapus",
  "label.testCatalog.labels.remove.title": "Hapus Jenis Label",
  "label.testCatalog.labels.remove.confirm": "Hapus",
  "label.testCatalog.labels.remove.body": "Hapus {name} dari konigurasi label pemeriksaan ini?",
  "label.testCatalog.section.reagents": "Reagen",
  "label.testCatalog.section.analyzers": "Alat",
  "label.testCatalog.section.alerts": "Peringatan",
  "label.testCatalog.section.accreditation": "Akreditasi",
  "label.testCatalog.accreditation.add": "Tambah akreditasi",
  "label.testCatalog.accreditation.added": "Akreditasi ditambahkan",
  "label.testCatalog.accreditation.removed": "Akreditasi dihapus",
  "label.testCatalog.accreditation.empty": "Pemeriksaan ini tidak diakreditasi oleh badan mana pun.",
  "label.testCatalog.accreditation.selectBody": "Pilih badan akreditasi",
  "label.testCatalog.accreditation.remove": "Hapus akreditasi",
  "label.testCatalog.accreditation.remove.body": "Hapus pemeriksaan ini dari {body}? Logonya tidak akan lagi muncul pada laporan yang hanya berisi pemeriksaan ini.",
  "label.testCatalog.accreditation.manageLink": "Kelola badan akreditasi dan tanggal kedaluwarsa",
  "label.testCatalog.accreditation.loadError": "Akreditasi tidak dapat dimuat.",
  "label.testCatalog.accreditation.saveError": "Akreditasi tidak dapat ditambahkan.",
  "label.testCatalog.accreditation.deleteError": "Akreditasi tidak dapat dihapus.",
  "label.testCatalog.section.reflex-calc": "Reflex & Calc",
  "label.testCatalog.section.localization": "Lokalisasi",
  "label.testCatalog.section.display-order": "Urutan tampilan",
  "label.sampleType.section.basic-info": "Informasi Dasar",
  "label.sampleType.section.associated-tests": "Pemeriksaan Terkait",
  "label.sampleType.section.terminology": "Terminologi",
  "label.sampleType.section.localization": "Lokalisasi",
  "label.sampleType.localization.intro": "Edit terjemahan per bahasa untuk nama jenis sampel ini. Kolom yang belum diterjemahkan akan menggunakan Bahasa Inggris sebagai bahasa default. Kelola semua terjemahan dari halaman admin Manajemen Terjemahan.",
  "label.sampleType.localization.empty": "Jenis sampel ini tidak memiliki bidang nama yang dapat dilokalkan.",
  "label.sampleType.localization.loadError": "Tidak dapat memuat terjemahan untuk jenis sampel ini.",
  "label.sampleType.localization.field.name": "Nama Jenis Sampel",
  "label.sampleType.terminology.intro": "Petakan jenis sampel ini ke kode terminologi standar demi interoperabilitas.",
  "label.sampleType.terminology.empty": "Tidak ada pemetaan terminologi.",
  "label.sampleType.terminology.saved": "Pemetaan terminologi telah disimpan.",
  "label.sampleType.terminology.saveError": "Tidak dapat menyimpan pemetaan terminologi.",
  "label.sampleType.terminology.saveInvalid": "Beberapa pemetaan tidak valid. Periksa sumber, kode, dan Duplikasi.",
  "label.sampleType.terminology.addHint": "Simpan dulu jenis sampel ini, lalu tambahkan pemetaan terminologi.",
  "label.sampleType.localization.addHint": "Simpan dulu Jenis Sampel ini, lalu edit terjemahannya.",
  "label.sampleType.name": "Nama",
  "label.sampleType.section.display-order": "Urutan tampilan",
  "label.sampleType.section.disposal": "Pembuangan",
  "label.sampleType.displayOrder": "Posisi di menu Jenis Sampel",
  "label.sampleType.displayOrder.intro": "Tempatkan jenis sampel ini dalam menu Jenis Sampel pada entri pemesanan. Ketikkan posisi atau gunakan tombol panah, lalu simpan; setiap jenis sampel akan diberi nomor ulang.",
  "label.sampleType.displayOrder.current": "Jenis sampel ini",
  "label.sampleType.displayOrder.loading": "Memuat jenis sampel...",
  "label.sampleType.displayOrder.saved": "Urutan tampilan telah diperbarui.",
  "label.sampleType.displayOrder.saveError": "Tidak dapat memperbarui urutan tampilan.",
  "label.sampleType.displayOrder.addHint": "Simpan dulu jenis sampel ini, lalu atur posisinya di menu.",
  "label.sampleType.disposalInstructions": "Petunjuk pembuangan",
  "label.sampleType.disposal.intro": "Panduan referensi dalam bentuk teks bebas mengenai pembuangan jenis spesimen ini. Petunjuk penanganan yang resmi dan terstruktur tercantum pada bagian Penyimpanan setiap pemeriksaan serta alur kerja pembuangan spesimen.",
  "label.sampleType.disposal.placeholder": "misalnya, disterilkan dengan autoklaf sebelum dimusnahkan sebagai limbah berbahaya biologis",
  "label.sampleType.disposal.loading": "Sedang memuat petunjuk pembuangan...",
  "label.sampleType.disposal.saved": "Petunjuk pembuangan telah disimpan.",
  "label.sampleType.disposal.saveError": "Tidak dapat menyimpan petunjuk pembuangan.",
  "label.sampleType.disposal.addHint": "Simpan dulu jenis sampel ini, lalu tambahkan petunjuk pembuangan.",
  "label.sampleType.tests.manageIntro": "Pemeriksaan yang terkait dengan jenis sampel ini. Telusuri katalog untuk menambahkan lagi, atau hapus tautan yang sudah ada. Tautan yang sama juga dapat dikelola dari Informasi Dasar pemeriksaan di Katalog Pemeriksaan.",
  "label.sampleType.tests.search": "Cari pemeriksaan",
  "label.sampleType.tests.searchPlaceholder": "Cari berdasarkan nama pemeriksaan...",
  "label.sampleType.tests.filterBySampleType": "Filter berdasarkan Jenis Sampel",
  "label.sampleType.tests.filterBySampleType.all": "Jenis sampel apa saja",
  "label.sampleType.tests.pick": "Pemeriksaan yang akan ditambahkan",
  "label.sampleType.tests.pickPlaceholder": "Pilih pemeriksaan...",
  "label.sampleType.tests.add": "Tambah Pemeriksaan",
  "label.sampleType.tests.addError": "Tidak dapat menghubungkan pemeriksaan tersebut dengan jenis sampel ini.",
  "label.sampleType.tests.domainMismatch": "Pemeriksaan ini termasuk dalam domain yang berbeda dari jenis sampel ini, sehingga tidak dapat menggunakannya.",
  "label.sampleType.tests.remove": "Hapus pemeriksaan",
  "helper.sampleType.name": "Masukkan nama unik untuk jenis sampel ini (misalnya, \"Serum\", \"Darah Lengkap\")",
  "helper.sampleType.description": "Berikan deskripsi jenis sampel ini sebagai rujukan bagi petugas lab",
  "label.sampleType.active": "Aktif",
  "label.sampleType.description": "Deskripsi",
  "label.sampleType.tests.removeError": "Tidak dapat memutuskan tautan pemeriksaan tersebut.",
  "label.sampleType.tests.removeLastOfActive": "Tidak dilepaskan: ini adalah satu-satunya jenis sampel dari pemeriksaan aktif, sehingga pemeriksaan tersebut tidak dapat dipesan. Berikan jenis sampel lain pada pemeriksaan atau nonaktifkan terlebih dahulu.",
  "label.sampleType.tests.loading": "Memuat pemeriksaan yang terkait...",
  "label.sampleType.tests.none": "Tidak ada pemeriksaan yang terkait dengan jenis sampel ini.",
  "message.sampleType.add.success": "Jenis sampel berhasil disimpan.",
  "message.sampleType.edit.success": "Jenis sampel berhasil diperbarui.",
  "heading.sampleType.add": "Tambah Jenis Sampel Baru",
  "button.sampleType.create": "Buat Jenis Sampel",
  "button.sampleType.creating": "Membuat...",
  "heading.sampleType.filtered": "Menampilkan {filtered} dari {total} jenis sampel",
  "heading.sampleType.total": "Total: {total} jenis sampel",
  "label.sampleType.tests.addHint": "Simpan jenis sampel ini terlebih dahulu, lalu kaitkan pemeriksaan dari konfigurasi pemeriksaan.",
  "message.sampleType.noResults": "Tidak ada jenis sampel yang sesuai dengan kriteria Anda",
  "error.sampleType.create.invalidName": "Nama ini berisi karakter yang tidak diizinkan, seperti tag HTML. Hapus karakter tersebut dan coba lagi.",
  "error.sampleType.create.invalid": "Jenis sampel tidak dibuat. Periksa bidang dan coba lagi.",
  "error.sampleType.create.duplicateName": "Jenis sampel dengan nama ini sudah ada.",
  "error.sampleType.create.duplicateDescription": "Jenis sampel lain dalam domain ini sudah memiliki deskripsi ini.",
  "error.sampleType.update.description.409": "Jenis sampel lain dalam domain ini sudah memiliki deskripsi ini.",
  "error.sampleType.update.abbreviation.409": "Jenis sampel lain dalam domain ini sudah menggunakan singkatan ini.",
  "error.sampleType.update.abbreviation.400": "Singkatan berisi maksimal 10 karakter.",
  "error.sampleType.update.whonetCode.400": "Kode WHONET berisi maksimal 5 karakter.",
  "error.sampleType.update.description.400": "Deskripsi maksimal 40 karakter.",
  "error.sampleType.nameTooLong": "Nama jenis sampel baru maksimal 40 karakter.",
  "label.sampleType.loading": "Memuat Jenis Sampel...",
  "label.sampleType.notFound": "Jenis sampel ini tidak ada. Kembali ke daftar untuk memilih yang lain.",
  "label.sampleType.editorLoadError": "Jenis sampel tidak dapat dimuat. Muat ulang halaman untuk mencoba lagi.",
  "stock.status.pendingQc": "QC tertunda",
  "stock.status.qcFailed": "Gagal QC",
  "stock.status.quarantined": "Dikarantina",
  "label.sampleType.whonetCode": "Kode spesimen WHONET",
  "helper.sampleType.whonetCode": "Kode yang ditulis pada bidang SPECIMEN_TYPE di WHONET (maksimal 5 karakter).",
  "label.sampleType.whonetReturn": "Kembali ke pratinjau WHONET",
  "warning.sampleType.deactivateInUse": "{count} pemeriksaan aktif menggunakan jenis ini; pemeriksaan tersebut tidak dapat dipesan selama jenis ini nonaktif.",
  "note.sampleType.associatedTests.viewOnly": "Hanya untuk dilihat — spesimen suatu tes merupakan bagian dari identitasnya. Untuk menjalankan tes pada jenis sampel ini, buat varian spesimen di Katalog Pemeriksaan.",
  "sidenav.label.admin.sampleType.backToList": "← Semua Jenis Sampel",
  "sidenav.label.admin.sampleType.editing": "Edit: {name}",
  "sidenav.label.admin.sampleType.editingGeneric": "Mengedit Jenis Sampel",
  "sidenav.label.admin.sampleType.sectionsHelper": "Klik Jenis Sampel untuk mengedit bagian-bagiannya",
  "sidenav.label.admin.sampleType.addingNew": "Menambahkan Jenis Sampel Baru",
  "label.testCatalog.localization.locale": "Lokal",
  "label.testCatalog.localization.intro": "Edit terjemahan untuk nama pemeriksaan dan pelaporan. Bidang yang tidak diterjemahkan akan dikembalikan ke Bahasa Inggris. Kelola terjemahan dari laman admin Pengelolaan Terjemahan.",
  "label.testCatalog.localization.unsaved": "Anda memiliki perubahan terjemahan yang tidak tersimpan. Klik Simpan untuk menerapkannya.",
  "label.testCatalog.localization.loadError": "Gagal memuat terjemahan untuk pemeriksaan ini.",
  "label.testCatalog.localization.empty": "Pemeriksaan ini tidak memiliki bidang nama lokal.",
  "label.testCatalog.localization.saved": "Terjemahan disimpan",
  "label.testCatalog.localization.saveError": "Tidak dapat menyimpan terjemahan.",
  "label.testCatalog.localization.fallbackRequired": "Nilai bahasa Inggris ditampilkan di semua layar jika tidak ada terjemahan, sehingga tidak boleh kosong.",
  "label.testCatalog.localization.field.name": "Nama Pemeriksaan",
  "label.testCatalog.localization.field.reportingName": "Nama Pelaporan",
  "label.testCatalog.localization.fallback.en": "Bahasa Alternatif (en)",
  "label.testCatalog.localization.fallback.tooltip": "Menampilkan nilai dalam Bahasa Inggris karena tidak ada terjemahan yang dikonfigurasi untuk {locale}.",
  "label.testCatalog.reflexCalc.loadError": "Gagal memuat refleks dan kalkukasi terkait pemeriksaan ini.",
  "label.testCatalog.reflexCalc.reflex.heading": "Pemeriksaan Refleks",
  "label.testCatalog.reflexCalc.reflex.helper": "Aturan yang mengurutkan pemeriksaan secara otomatis berdasarkan hasil. Kelola ini di Daftar Master → Aturan Refleks.",
  "label.testCatalog.reflexCalc.reflex.col.rule": "Nama Aturan",
  "label.testCatalog.reflexCalc.reflex.col.trigger": "Kondisi Trigger",
  "label.testCatalog.reflexCalc.reflex.col.reflexTests": "Pemeriksaan Refleks Dipesan",
  "label.testCatalog.reflexCalc.reflex.empty": "Tidak ada aturan refleks yang dikonfigurasi. Aturan refleks dikelola di Daftar Master → Aturan Refleks.",
  "label.testCatalog.reflexCalc.reflex.manage": "Kelola Aturan Refleks",
  "label.testCatalog.reflexCalc.calc.heading": "Hasil Terkalkulasi",
  "label.testCatalog.reflexCalc.calc.helper": "Formula yang menggunakan hasil pemeriksaan ini atau yang menghasilkan pemeriksaan ini sebagai output. Kelola di Daftar Master → Hasil Terkalkukasi.",
  "label.testCatalog.reflexCalc.calc.feedsInto": "Pemeriksaan ini mengumpan ke",
  "label.testCatalog.reflexCalc.calc.calculatedBy": "Pemeriksaan ini dikalkulasi oleh",
  "label.testCatalog.reflexCalc.calc.col.name": "Nama Formula",
  "label.testCatalog.reflexCalc.calc.col.formula": "Rumus",
  "label.testCatalog.reflexCalc.calc.col.output": "Output Pemeriksaan",
  "label.testCatalog.reflexCalc.calc.empty": "Tidak ada",
  "label.testCatalog.reflexCalc.calc.feedsInto.empty": "Pemeriksaan ini tidak menjadi bagian dari hasil perhitungan apa pun. Perhitungan dikelola di Daftar Utama → Nilai yang Dihitung.",
  "label.testCatalog.reflexCalc.calc.calculatedBy.empty": "Pemeriksaan ini tidak dihitung dari pemeriksaan lainnya. Penghitungan dikelola di Daftar Utama → Nilai Terkalkulasi.",
  "label.testCatalog.reflexCalc.calc.manage": "Kelola Hasil Terkalkulasi",
  "label.testCatalog.alerts.addRule": "Tambah Aturan",
  "label.testCatalog.alerts.empty": "Tidak ada konfigurasi aturan peringatan. Tambah aturan untuk menotifikasi penerima jika hasil cocok dengan kondisi.",
  "label.testCatalog.alerts.loadError": "Gagal memuat aturan peringatan untuk pemeriksaan ini.",
  "label.testCatalog.alerts.saved": "Aturan peringatan berhasil disimpan",
  "label.testCatalog.alerts.saveError": "Gagal menyimpan aturan peringatan.",
  "label.testCatalog.alerts.saveRefused": "Aturan peringatan ditolak. Nama, nilai, dan email kustom maksimal 100 karakter, telepon kustom maksimal 20, dan peran harus dapat menerima notifikasi.",
  "label.testCatalog.alerts.deleted": "Aturan peringatan dihapus",
  "label.testCatalog.alerts.deleteError": "Gagal menghapus aturan peringatan.",
  "label.testCatalog.alerts.nameRequired": "Wajib ada nama aturan.",
  "label.testCatalog.alerts.valueRequired": "Nilai spesifik diperlukan untuk trigger Nilai Spesifik.",
  "label.testCatalog.alerts.col.name": "Nama",
  "label.testCatalog.alerts.col.trigger": "Pemicu",
  "label.testCatalog.alerts.col.channels": "Channel",
  "label.testCatalog.alerts.col.ack": "Wajib Konfirmasi",
  "label.testCatalog.alerts.col.enabled": "Diaktifkan",
  "label.testCatalog.alerts.col.actions": "Aksi",
  "label.testCatalog.alerts.trigger.ALL": "Semua Hasil",
  "label.testCatalog.alerts.trigger.ABNORMAL": "Tidak normal",
  "label.testCatalog.alerts.trigger.CRITICAL": "Kritis",
  "label.testCatalog.alerts.trigger.SPECIFIC_VALUE": "Nilai Spesifik",
  "label.testCatalog.alerts.trigger.COMPLIANCE_BREACH": "Pelanggaran Kepatuhan",
  "label.testCatalog.alerts.edit.action": "Edit",
  "label.testCatalog.alerts.delete.action": "Hapus",
  "label.testCatalog.alerts.delete.title": "Hapus Aturan Peringatan",
  "label.testCatalog.alerts.delete.confirm": "Hapus",
  "label.testCatalog.alerts.delete.body": "Hapus aturan peringatan {name}?",
  "label.testCatalog.alerts.modal.addTitle": "Tambah Aturan Peringatan",
  "label.testCatalog.alerts.modal.editTitle": "Edit Aturan Peringatan",
  "label.testCatalog.alerts.field.name": "Nama Aturan",
  "label.testCatalog.alerts.field.trigger": "Peringatan jika hasil adalah:",
  "label.testCatalog.alerts.field.specificValue": "Nilai spesifik",
  "label.testCatalog.alerts.field.channels": "Channel notifikasi",
  "label.testCatalog.alerts.field.recipients": "Penerima",
  "label.testCatalog.alerts.field.ackRequired": "Wajib ada konfirmasi",
  "label.testCatalog.alerts.channel.sms": "SMS",
  "label.testCatalog.alerts.channel.email": "Email",
  "label.testCatalog.alerts.recipient.physician": "Dokter Pemesan",
  "label.testCatalog.alerts.recipient.patient": "Pasien",
  "label.testCatalog.alerts.recipient.facility": "Lembaga Perujuk",
  "label.testCatalog.alerts.recipient.customPhone": "Telepon kostum",
  "label.testCatalog.alerts.recipient.customEmail": "Email kostum",
  "label.testCatalog.alerts.recipient.roleId": "Notifikasi pengguna dengan peran",
  "label.testCatalog.alerts.recipient.rolePlaceholder": "Pilih peran",
  "label.testCatalog.reagents.col.name": "Nama Reagen",
  "label.testCatalog.reagents.col.usage": "Jenis Penggunaan",
  "label.testCatalog.reagents.col.qty": "Kuantitas per Pemeriksaan",
  "label.testCatalog.reagents.col.stock": "Level Stok",
  "label.testCatalog.reagents.col.actions": "Aksi",
  "label.testCatalog.reagents.empty": "Tidak ada reagen terkait. Tautkan reagen dari inventaris untuk melacak konsumsi per pemeriksaan.",
  "label.testCatalog.reagents.loadError": "Gagal memuat reagen untuk pemeriksaan ini.",
  "label.testCatalog.reagents.linkButton": "Tautkan Reagen",
  "label.testCatalog.reagents.linkError": "Gagal menautkan satu atau lebih reagen. Silahkan coba lagi.",
  "label.testCatalog.reagents.modal.title": "Tautkan Reagen",
  "label.testCatalog.reagents.modal.linkSelected": "Tautkan Yang Dipilih",
  "label.testCatalog.reagents.modal.select.label": "Reagen",
  "label.testCatalog.reagents.modal.select.placeholder": "Pilih reagen untuk ditautkan",
  "label.testCatalog.reagents.modal.allLinked": "Semua reagen yang tersedia sudah ditautkan ke pemeriksaan ini.",
  "label.testCatalog.reagents.unitPlaceholder": "Unit",
  "label.testCatalog.reagents.updated": "Reagen diperbarui",
  "label.testCatalog.reagents.saveError": "Gagal menyimpan perubahan.",
  "label.testCatalog.reagents.unitTooLong": "Satuan maksimal 50 karakter.",
  "label.testCatalog.reagents.unsaved": "Anda memiliki perubahan reagen yang tidak tersimpan. Klik Simpan untuk menerapkannya.",
  "label.testCatalog.reagents.retry": "Ulang",
  "label.testCatalog.reagents.unlink.action": "Putuskan Tautan",
  "label.testCatalog.reagents.unlink.title": "Putuskan Tautan Reagen",
  "label.testCatalog.reagents.unlink.confirm": "Putuskan Tautan",
  "label.testCatalog.reagents.unlink.body": "Putuskan tautan {name} untuk pemeriksaan ini? Hasil yang sudah tertaut dengan reagen ini tidak terpengaruh.",
  "label.testCatalog.reagents.unlinked": "Reagen tidak tertaut",
  "label.testCatalog.reagents.unlinkError": "Gagal memutuskan tautan reagen. Silahkan coba lagi.",
  "label.testCatalog.basicInfo.name": "Nama",
  "label.testCatalog.basicInfo.name.helper": "Nama tampilan adalah terjemahan — edit di bagian Lokalisasi.",
  "label.testCatalog.basicInfo.reportingName": "Nama pelaporan",
  "label.testCatalog.basicInfo.labUnit": "Instalasi Lab",
  "label.testCatalog.basicInfo.labUnit.inactive": "{name} (nonaktif)",
  "label.testCatalog.basicInfo.labUnit.inactiveHelp": "Instalasi lab ini nonaktif, sehingga pemeriksaan tidak dapat dipesan. Menyimpan akan tetap membuatnya nonaktif; aktifkan kembali di Pengelolaan Instalasi Lab.",
  "label.testCatalog.basicInfo.createInactiveHint": "Pemeriksaan yang dibuat Inaktif. Lakukan konfigurasi, kemudian aktifkan agar dapat dipesan.",
  "sidenav.label.environmental.compliance.tooltip": "Dasbor Kepatuhan Lingkungan",
  "site.search.helper": "Ketik minimal 2 karakter untuk melakukan pencarian otomatis. Wajib untuk mengarahkan hasil kembali ke tempat yang meminta.",
  "storage.skipped.title": "Penyimpanan dilewati untuk {count} sampel",
  "test.qc.blankThreshold": "Ambang Batas Blanko",
  "test.qc.recoveryWindowPct": "Jendela Pemulihan (%)",
  "test.qc.rpdThreshold": "Ambang Batas RPD (%)",
  "test.qc.thresholds.description": "Nilai ambang batas opsional untuk evaluasi QC lingkungan/vektor. Biarkan kosong jika tidak berlaku.",
  "test.qc.thresholds.heading": "Ambang Batas Penerimaan QC",
  "title.testCatalog.createTest": "Buat pemeriksaan baru",
  "label.testCatalog.testName": "Nama pemeriksaan",
  "label.testCatalog.testCode": "Kode pemeriksaan",
  "label.testCatalog.domain": "Domain",
  "label.testCatalog.specimenType": "Jenis sampel",
  "label.testCatalog.basicInfo.sampleTypes": "Jenis sampel",
  "helper.testCatalog.basicInfo.sampleTypesMulti": "Pilih semua jenis sampel yang digunakan untuk pemeriksaan ini. Konfigurasi berlaku untuk semuanya.",
  "error.testCatalog.basicInfo.sampleTypeRequired": "Pilih setidaknya satu jenis sampel.",
  "error.testCatalog.basicInfo.sampleTypeDomain": "Domain jenis sampel ini tidak sesuai dengan domain pemeriksaan.",
  "label.testCatalog.list.sampleTypesSummary": "{first} +{n}",
  "label.testCatalog.override.col.sampleType": "Spesimen",
  "label.testCatalog.override.shared": "Semua spesimen (yang dibagikan)",
  "notice.testCatalog.intake.awaitingSpecimen": "Menunggu sampel — pemeriksaan ini dilakukan pada beberapa sampel; selesaikan saat pengambilan sampel.",
  "tag.testCatalog.finding.noSampleTypeLink": "Tidak ada tautan jenis sampel",
  "error.testCatalog.codeExists": "Pemeriksaan dengan kode ini sudah ada.",
  "error.testCatalog.description.inUse": "Pemeriksaan lain sudah menggunakan deskripsi ini. Deskripsi harus unik — ubah deskripsinya, lalu simpan kembali.",
  "notification.testCatalog.testCreated": "Pemeriksaan '{name}' dibuat. Lengkapi konfigurasi pada bagian sebelah kiri.",
  "label.testCatalog.basicInfo.code": "Kode",
  "label.testCatalog.basicInfo.description": "Deskripsi",
  "label.testCatalog.basicInfo.domain": "Domain",
  "label.testCatalog.basicInfo.domain.CLINICAL": "Klinis",
  "label.testCatalog.basicInfo.domain.ENVIRONMENTAL": "Lingkungan",
  "label.testCatalog.basicInfo.domain.VECTOR": "Vektor",
  "label.testCatalog.basicInfo.domainModal.title": "Ganti domain pemeriksaan?",
  "label.testCatalog.basicInfo.domainModal.body": "Ganti domain pemeriksaan ini menjadi {domain}? Ini akan mempengaruhi pengkategorian pemeriksaan di katalog.",
  "label.testCatalog.basicInfo.amr": "Pemeriksaan surveilans AMR",
  "label.testCatalog.basicInfo.active": "Aktif",
  "label.testCatalog.basicInfo.status": "Status",
  "label.testCatalog.basicInfo.orderable": "Dapat dipesan",
  "label.testCatalog.basicInfo.saved": "Informasi dasar disimpan.",
  "error.testCatalog.basicInfo.labUnitInactive": "Instalasi Lab tersebut tidak aktif. Pilih instalasi yang aktif, atau aktifkan ulang di Pengelolaan Instalasi Lab terlebih dahulu.",
  "error.testCatalog.create.refused": "Pemeriksaan tidak dibuat: jenis sampel atau Instalasi Lab tidak dapat digunakan. Periksa dan coba lagi.",
  "error.testCatalog.basicInfo.invalidValue": "Informasi dasar tidak disimpan: salah satu nilai tidak dapat disimpan. Perbaiki bidang yang disorot.",
  "error.testCatalog.basicInfo.timeHolding": "Masukkan jumlah menit dalam bilangan bulat, atau kosongkan.",
  "error.testCatalog.basicInfo.qcThreshold": "Masukkan angka 0 atau lebih (hingga 5 angka desimal), atau kosongkan.",
  "label.testCatalog.sampleResults.saved": "Sampel & hasil disimpan.",
  "label.testCatalog.sampleResults.empty": "Tidak ada komponen hasi. Tambahkan komponen hasil untuk mendefinisikan bagaimana hasil pemeriksaan diambil.",
  "label.testCatalog.sampleResults.newComponent": "(komponen baru)",
  "label.testCatalog.sampleResults.code": "Kode komponen",
  "label.testCatalog.sampleResults.isPrimary": "Komponen primer",
  "label.testCatalog.sampleResults.showOnReport": "Tampilkan di laporan pasien",
  "label.testCatalog.sampleResults.label": "Label komponen",
  "label.testCatalog.sampleResults.resultType": "Jenis hasil",
  "label.testCatalog.sampleResults.resultType.N": "Numerik",
  "label.testCatalog.sampleResults.resultType.none": "Tidak ada jenis hasil yang dipilih",
  "label.testCatalog.sampleResults.preview.noType": "Pilih jenis hasil di atas untuk melihat bagaimana teknisi akan memasukkan hasil ini.",
  "label.testCatalog.sampleResults.resultType.D": "Daftar pilihan tunggal (kamus)",
  "label.testCatalog.sampleResults.resultType.R": "Teks bebas",
  "label.testCatalog.sampleResults.resultType.M": "Daftar pilihan ganda",
  "label.testCatalog.sampleResults.resultType.C": "Pilihan ganda bertingkat",
  "label.testCatalog.sampleResults.resultType.T": "Titer",
  "label.testCatalog.sampleResults.resultType.A": "Alfa (teks tervalidasi)",
  "label.testCatalog.sampleResults.resultType.group.primary": "Umum",
  "label.testCatalog.sampleResults.resultType.group.advanced": "Jenis lanjutan / jenis lama",
  "label.testCatalog.sampleResults.resultType.showAdvanced": "Jenis lanjutan / jenis lama",
  "label.testCatalog.sampleResults.resultType.hideAdvanced": "Sembunyikan advanced / legacy types",
  "label.testCatalog.sampleResults.resultTypeDesc.N": "Angka terukur dengan satuan (mis. 12.3 g/dL).",
  "label.testCatalog.sampleResults.resultTypeDesc.D": "Satu nilai di pilih dari fixed set (mis. Terdeteksi / Tidak terdeteksi).",
  "label.testCatalog.sampleResults.resultTypeDesc.R": "Komentar atau deksripsi yang diketik.",
  "label.testCatalog.sampleResults.resultTypeDesc.M": "Satu atau lebih nilai dari daftar; tidak ada nilai rujukan tunggal.<br>",
  "label.testCatalog.sampleResults.resultTypeDesc.C": "Opsi grup; pilih multiple grup.",
  "label.testCatalog.sampleResults.resultTypeDesc.T": "Rasio dilusi, misalnya, 1:10 atau 1:20 (umum di serologi).",
  "label.testCatalog.sampleResults.resultTypeDesc.A": "Teks alfanumerik yang valid (kode atau nilai dengan kode singkat).",
  "label.testCatalog.sampleResults.preview": "Pratinjau entri hasil",
  "label.testCatalog.sampleResults.previewHelper": "Yang terlihat saat petugas lab mengisi hasil.",
  "label.testCatalog.sampleResults.purpose": "Menjelaskan apa yang direkam oleh petugas lab untuk pemeriksaan ini dan bagaimana hasil diinterpretasikan.",
  "label.testCatalog.sampleResults.labelRequired": "Setiap komponen hasil memerlukan label sebelum dapat disimpan.",
  "label.testCatalog.sampleResults.resultTypeRequired": "Pilih jenis hasil untuk \"{component}\" sebelum menyimpan.",
  "label.testCatalog.sampleResults.mostTestsOneResult": "Umumnya pemeriksaan merekam satu hasil. Tambah komponen jika pemeriksaan menghasilkan beberapa nilai (mis. diferensial).",
  "label.testCatalog.sampleResults.displayOrder": "Urutan tampilan",
  "label.testCatalog.sampleResults.uom": "Satuan pengukuran",
  "label.testCatalog.sampleResults.uom.none": "(tidak ada)",
  "label.testCatalog.sampleResults.uom.addNew": "＋ Tambah satuan baru…",
  "label.testCatalog.sampleResults.uom.newName": "Nama di Tampilan",
  "label.testCatalog.sampleResults.uom.newCode": "Kode",
  "label.testCatalog.sampleResults.uom.newUcum": "Kode UCUM",
  "label.testCatalog.sampleResults.uom.newDescription": "Deskripsi",
  "label.testCatalog.sampleResults.uom.saveNew": "Buat satuan",
  "label.testCatalog.sampleResults.significantDigits": "Digit signifikan",
  "label.testCatalog.sampleResults.significantDigits.helper": "Jumlah digit yang akan dipertahankan setelah koma desimal saat hasil numerik dimasukkan. Biarkan kosong jika tidak ingin dilakukan pembulatan.",
  "admin.testCatalog.sampleResults.lod.label": "LOD",
  "admin.testCatalog.sampleResults.loq.label": "LOQ",
  "admin.testCatalog.sampleResults.lod.helper": "Batas deteksi (opsional)",
  "admin.testCatalog.sampleResults.loq.helper": "Batas kuantifikasi (opsional)",
  "error.testCatalog.sampleResults.valueTooLong": "{component}: ada nilai yang lebih panjang dari batas kolomnya (label 255, kode 50, hasil default dan nilai opsi 80; teks interpretasi 255, kecocokan 80, tingkat keparahan dan warna 20 karakter).",
  "error.testCatalog.sampleResults.unitUnknown": "{component}: satuan ukuran tersebut tidak ada.",
  "error.testCatalog.sampleResults.activeNeedsComponent": "Tidak disimpan: pemeriksaan yang aktif memerlukan minimal satu komponen hasil. Pertahankan satu komponen, atau nonaktifkan pemeriksaan di Informasi Dasar terlebih dahulu.",
  "error.testCatalog.sampleResults.lodGtLoq": "LOD tidak boleh lebih besar dari LOQ.",
  "error.testCatalog.sampleResults.detectionLimitNegative": "Batas deteksi harus nol atau lebih.",
  "admin.testCatalog.qcTargets.section.label": "Target QC",
  "admin.testCatalog.qcTargets.intro": "Target kontrol yang digunakan Entri Hasil untuk menilai setiap run QC. Masukkan sekali di sini agar petugas hanya memasukkan nilai terukur.",
  "admin.testCatalog.qcTargets.column.level": "Level kontrol",
  "admin.testCatalog.qcTargets.column.expected": "Nilai yang diharapkan",
  "admin.testCatalog.qcTargets.column.uncertainty": "Ketidakpastian (±)",
  "admin.testCatalog.qcTargets.column.unit": "Unit",
  "admin.testCatalog.qcTargets.column.overrides": "Penyesuaian lot",
  "admin.testCatalog.qcTargets.column.status": "Status",
  "admin.testCatalog.qcTargets.column.actions": "Aksi",
  "admin.testCatalog.qcTargets.level.low": "Rendah",
  "admin.testCatalog.qcTargets.level.normal": "Normal",
  "admin.testCatalog.qcTargets.level.high": "Tinggi",
  "admin.testCatalog.qcTargets.expectedOutcome.label": "Hasil yang diharapkan",
  "admin.testCatalog.qcTargets.expectedOutcome.placeholder": "Pilih hasil yang diharapkan",
  "admin.testCatalog.qcTargets.addTarget": "Tambah target",
  "admin.testCatalog.qcTargets.addOverride": "Tambah penyesuaian lot",
  "admin.testCatalog.qcTargets.lot.label": "Lot kontrol",
  "admin.testCatalog.qcTargets.lot.placeholder": "Cari lot kontrol…",
  "admin.testCatalog.qcTargets.lot.emptyLink": "Lot tidak ditemukan. Kelola lot di Pengelolaan Lot QC",
  "admin.testCatalog.qcTargets.overrides.none": "Tidak ada penyesuaian lot",
  "admin.testCatalog.qcTargets.overrides.count": "{count, plural, other {# penyesuaian lot}}",
  "admin.testCatalog.qcTargets.empty.level": "Belum ada target yang dikonfigurasi: petugas memasukkan nilai saat pencatatan",
  "admin.testCatalog.qcTargets.helper.precedence": "Saat entri hasil, formulir kontrol diisi otomatis dari penyesuaian lot jika ada, jika tidak dari nilai default level.",
  "admin.testCatalog.qcTargets.showDeactivated": "Tampilkan sudah inaktif",
  "admin.testCatalog.qcTargets.deactivate": "Nonaktifkan",
  "admin.testCatalog.qcTargets.reactivate": "Aktifkan Ulang",
  "admin.testCatalog.qcTargets.edit": "Edit target",
  "admin.testCatalog.qcTargets.done": "Selesai",
  "admin.testCatalog.qcTargets.saved": "Target QC disimpan.",
  "admin.testCatalog.qcTargets.loadError": "Target QC tidak dapat dimuat.",
  "error.testCatalog.qcTargets.uncertaintyNegative": "Ketidakpastian harus berupa bilangan non-negatif.",
  "error.testCatalog.qcTargets.required": "Setiap target aktif memerlukan nilai yang diharapkan dan ketidakpastian, atau hasil yang diharapkan.",
  "label.testCatalog.sampleResults.defaultResult": "Hasil default",
  "label.testCatalog.sampleResults.defaultResult.none": "Tidak ada default",
  "label.testCatalog.sampleResults.allowMultiple": "Izinkan pembacaan multiple",
  "label.testCatalog.sampleResults.options": "Opsi select-list",
  "label.testCatalog.sampleResults.options.empty": "Belum ada opsi yang ditentukan. Tambah setidaknya satu opsi agar hasil ini dapat dimasukkan.",
  "label.testCatalog.sampleResults.option.value": "Nilai",
  "label.testCatalog.sampleResults.option.sortOrder": "Sortir Pemesanan",
  "label.testCatalog.sampleResults.option.sortOrder.helper": "Pilihan ditampilkan kepada petugas dalam urutan naik — angka yang lebih kecil muncul terlebih dahulu.",
  "label.testCatalog.sampleResults.option.normal": "Normal",
  "label.testCatalog.sampleResults.option.qualifiable": "Dapat dikualifikasi",
  "error.testCatalog.sampleResults.duplicateOption": "{component} mencantumkan {options} lebih dari sekali. Hapus baris tambahan agar entri hasil menawarkan setiap opsi satu kali.",
  "label.testCatalog.sampleResults.addOption": "Tambah opsi",
  "label.testCatalog.sampleResults.addCustomOption": "Tambah opsi khusus",
  "label.testCatalog.sampleResults.searchDictionary": "Cari nilai kamus...",
  "label.testCatalog.sampleResults.removeOption": "Hapus opsi",
  "label.testCatalog.sampleResults.interpretations": "Interpretasi",
  "label.testCatalog.sampleResults.interpretations.empty": "Tidak ada interpretasi yang ditentukan. Tambah satu interpretasi untuk melampirkan panduan atau penanda keparahan pada suatu hasil.",
  "label.testCatalog.sampleResults.interp.valueMatch": "Nilai cocok",
  "label.testCatalog.sampleResults.interp.selectValue": "Pilih nilai...",
  "label.testCatalog.sampleResults.interp.numericHint": "mis. >140, 90-140, =0",
  "label.testCatalog.sampleResults.interp.text": "Interpretasi",
  "label.testCatalog.sampleResults.interp.severity": "Keparahan",
  "label.testCatalog.sampleResults.addInterpretation": "Tambah interpretasi",
  "label.testCatalog.sampleResults.removeInterpretation": "Hapus interpretasi",
  "label.testCatalog.sampleResults.severity.NORMAL": "Normal",
  "label.testCatalog.sampleResults.severity.ABNORMAL": "Tidak normal",
  "label.testCatalog.sampleResults.severity.CRITICAL": "Kritis",
  "label.testCatalog.sampleResults.actions": "Aksi",
  "label.testCatalog.sampleResults.addComponent": "Tambah komponen",
  "label.testCatalog.sampleResults.removeComponent": "Hapus komponen",
  "label.testCatalog.sampleResults.moveUp": "Pindahkan komponen ke atas",
  "label.testCatalog.sampleResults.moveDown": "Pindahkan komponen ke bawah",
  "label.testCatalog.sampleResults.copyFrom": "Salin konfigurasi dari pemeriksaan",
  "label.testCatalog.sampleResults.copyFrom.placeholder": "Pilih pemeriksaan",
  "label.testCatalog.sampleResults.copyFromButton": "Salin dari pemeriksaan",
  "label.testCatalog.sampleResults.copyConfirm.title": "Ganti konfigurasi hasil pemeriksaan ini?",
  "label.testCatalog.sampleResults.copyConfirm.body": "Setiap komponen hasil, opsi daftar pilihan, dan interpretasi pemeriksaan ini akan diganti dengan milik {source}. Tidak ada yang berubah sampai Anda mengklik Simpan. Setelah disimpan, penggantian tidak dapat dibatalkan.",
  "label.testCatalog.sampleResults.copyConfirm.confirm": "Ganti konfigurasi",
  "label.testCatalog.sampleResults.copyStaged": "Konfigurasi disalin dari {source}, belum disimpan",
  "label.testCatalog.sampleResults.copyStaged.helper": "Klik Simpan untuk mengganti konfigurasi pemeriksaan ini dengannya, atau buang untuk mempertahankan konfigurasi saat ini.",
  "label.testCatalog.sampleResults.copyDiscard": "Buang konfigurasi yang disalin",
  "label.testCatalog.sampleResults.copyEmpty": "{source} tidak memiliki konfigurasi hasil untuk disalin.",
  "label.testCatalog.sampleResults.copyLoadError": "Konfigurasi {source} tidak dapat dimuat.",
  "label.testCatalog.sampleResults.copied": "Konfigurasi disalin.",
  "label.testCatalog.ranges.activated": "Pemeriksaan diaktifkan.",
  "label.testCatalog.ranges.ackModal.title": "Aktifkan dengan coverage gap?",
  "label.testCatalog.ranges.ackModal.confirm": "Ketahui dan aktifkan",
  "label.testCatalog.ranges.ackModal.warning": "Pemeriksaan ini memiliki rentang referensi dengan coverage gap.",
  "label.testCatalog.ranges.ackModal.body": "Rentang usia berikut ini tidak memiliki rentang referensi — hasil pada rentang tersebut tidak dapat ditandai berdasarkan rentang tersebut. Klik \"Ketahui\" untuk tetap mengaktifkannya.",
  "label.testCatalog.ranges.male": "Laki-Laki",
  "label.testCatalog.ranges.female": "Perempuan",
  "label.testCatalog.ranges.gapRange": "{from} – {to}",
  "label.testCatalog.ranges.days": "hari",
  "label.testCatalog.ranges.months": "bulan",
  "label.testCatalog.ranges.years": "tahun",
  "label.testCatalog.ranges.noUpperLimit": "tidak ada batas atas",
  "label.testCatalog.ranges.noLowerLimit": "tidak ada batas bawah",
  "label.testCatalog.ranges.both": "Keduanya",
  "label.testCatalog.ranges.add": "Tambahkan rentang",
  "label.testCatalog.ranges.empty": "Tidak ada rentang referensi yang ditetapkan.",
  "label.testCatalog.ranges.saved": "Rentang referensi telah disimpan.",
  "label.testCatalog.ranges.loadError": "Tidak dapat memuat rentang referensi.",
  "label.testCatalog.ranges.col.component": "Komponen",
  "label.testCatalog.ranges.allComponents": "Semua komponen",
  "label.testCatalog.ranges.col.sex": "Jenis Kelamin",
  "label.testCatalog.ranges.col.age": "Rentang Umur",
  "label.testCatalog.ranges.col.normal": "Normal",
  "label.testCatalog.ranges.col.critical": "Kritis",
  "label.testCatalog.ranges.col.valid": "Valid",
  "label.testCatalog.ranges.col.actions": "Aksi",
  "label.testCatalog.ranges.anyAge": "Umur apa saja",
  "label.testCatalog.ranges.coverage.title": "Validasi cakupan",
  "label.testCatalog.ranges.coverage.gapsHeading": "Rentang umur yang belum tercakup:",
  "label.testCatalog.ranges.coverage.gapWithComponent": "{range} — {component}",
  "label.testCatalog.ranges.coverage.status.COMPLETE": "Tercakup sepenuhnya",
  "label.testCatalog.ranges.coverage.status.GAP": "Ada celah-celah",
  "label.testCatalog.ranges.coverage.status.OVERLAP": "Terdapat bagian yang tumpang tindih",
  "label.testCatalog.ranges.coverage.status.EMPTY": "Tidak ada rentang",
  "label.testCatalog.ranges.modal.titleAdd": "Tambah rentang referensi",
  "label.testCatalog.ranges.modal.titleEdit": "Edit rentang referensi",
  "label.testCatalog.ranges.modal.sex": "Berlaku untuk",
  "label.testCatalog.ranges.modal.component": "Komponen hasil",
  "label.testCatalog.ranges.modal.component.all": "Semua komponen",
  "label.testCatalog.ranges.modal.ageUnit": "Satuan umur",
  "label.testCatalog.ranges.modal.minAge": "Dari umur",
  "label.testCatalog.ranges.modal.maxAge": "Hingga umur (kosong = tidak ada batas atas)",
  "label.testCatalog.ranges.modal.lowNormal": "Rendah normal",
  "label.testCatalog.ranges.modal.highNormal": "Tinggi normal",
  "label.testCatalog.ranges.modal.lowCritical": "Rendah kritis",
  "label.testCatalog.ranges.modal.highCritical": "Tinggi kritis",
  "label.testCatalog.ranges.modal.lowValid": "Rendah valid",
  "label.testCatalog.ranges.modal.highValid": "Tinggi yang valid",
  "label.testCatalog.ranges.modal.lowReporting": "Pelaporan rendah",
  "label.testCatalog.ranges.modal.highReporting": "Pelaporan tinggi",
  "error.testCatalog.ranges.reportingInverted": "Batas bawah pelaporan tidak boleh lebih tinggi dari batas atas pelaporan.",
  "label.testCatalog.ranges.modal.ageError": "“Hingga umur” harus lebih besar dari “Dari umur”.",
  "label.testCatalog.ranges.modal.boundsError": "Batas-batas harus disusun secara bertingkat ke luar: batas rendah valid ≤ batas rendah kritis ≤ batas rendah normal ≤ batas tinggi normal ≤ batas tinggi kritis ≤ batas tinggi valid.",
  "label.testCatalog.storage.saved": "Penyimpanan sampel telah disimpan.",
  "label.testCatalog.storage.loadError": "Tidak dapat memuat pengaturan Penyimpanan Sampel.",
  "label.testCatalog.storage.history.view": "Lihat riwayat perubahan",
  "label.testCatalog.storage.history.title": "Penyimpanan Sampel — Riwayat Perubahan",
  "label.testCatalog.storage.history.loadError": "Tidak dapat memuat riwayat perubahan.",
  "label.testCatalog.storage.history.empty": "Tidak ada perubahan yang tercatat.",
  "label.testCatalog.storage.history.filter": "Saring berdasarkan bidang",
  "label.testCatalog.storage.history.col.changedAt": "Diubah pada",
  "label.testCatalog.storage.history.col.changedBy": "Diubah oleh",
  "label.testCatalog.storage.history.col.field": "Bidang",
  "label.testCatalog.storage.history.col.old": "Nilai Lama",
  "label.testCatalog.storage.history.col.new": "Nilai Baru",
  "label.testCatalog.storage.storageHeading": "Penyimpanan",
  "label.testCatalog.storage.disposalHeading": "Pembuangan",
  "label.testCatalog.storage.handlingHeading": "Penanganan khusus",
  "label.testCatalog.storage.condition": "Kondisi penyimpanan",
  "label.testCatalog.storage.conditionCustom": "Kondisi khusus",
  "label.testCatalog.storage.duration": "Durasi penyimpanan maksimum",
  "label.testCatalog.storage.durationUnit": "Satuan durasi",
  "label.testCatalog.storage.stabilityNotes": "Catatan Stabilitas",
  "label.testCatalog.storage.protectFromLight": "Lindungi dari cahaya",
  "label.testCatalog.storage.doNotFreeze": "Jangan dibekukan",
  "label.testCatalog.storage.doNotRefrigerate": "Jangan disimpan di lemari es",
  "label.testCatalog.storage.disposalMethod": "Metode pembuangan",
  "label.testCatalog.storage.disposalTimeframe": "Jangka waktu pembuangan",
  "label.testCatalog.storage.disposalUnit": "Satuan rentang waktu",
  "label.testCatalog.storage.specialInstructions": "Petunjuk khusus",
  "label.testCatalog.storage.overrideRestricted": "Membatasi penggantian durasi penyimpanan",
  "label.testCatalog.storage.none": "— tidak ada —",
  "label.testCatalog.storage.condition.AMBIENT": "Ambient (Suhu Ruangan)",
  "label.testCatalog.storage.condition.CONTROLLED_ROOM_TEMPERATURE": "Suhu ruangan yang dikendalikan (20–25°C)",
  "label.testCatalog.storage.condition.COOL_ROOM": "Ruangan sejuk (8–15°C)",
  "label.testCatalog.storage.condition.COLD_ROOM": "Ruangan pendingin (2–8°C)",
  "label.testCatalog.storage.condition.REFRIGERATED": "Didinginkan (2–8°C)",
  "label.testCatalog.storage.condition.FROZEN": "Beku (−20°C)",
  "label.testCatalog.storage.condition.DEEP_FROZEN": "Dibekukan dalam suhu sangat rendah (−70°C)",
  "label.testCatalog.storage.condition.ULTRA_LOW_FREEZER": "Lemari pembeku bersuhu sangat rendah (−80°C)",
  "label.testCatalog.storage.condition.WARM_INCUBATOR": "Inkubator hangat (35–37°C)",
  "label.testCatalog.storage.disposal.INCINERATION": "Pembakaran",
  "label.testCatalog.storage.disposal.AUTOCLAVE": "Autoklaf",
  "label.testCatalog.storage.disposal.CHEMICAL_DISINFECTION": "Desinfeksi kimiawi",
  "label.testCatalog.storage.disposal.BIOHAZARD": "Limbah berbahaya biologis",
  "label.testCatalog.storage.disposal.SHARPS_CONTAINER": "Wadah limbah tajam",
  "label.testCatalog.storage.disposal.SEWER": "Pembuangan limbah saluran pembuangan / saluran air",
  "label.testCatalog.storage.disposal.RETURN_TO_SENDER": "Kembalikan kepada pengirim",
  "label.testCatalog.storage.disposal.ARCHIVE": "Arsip jangka panjang",
  "label.testCatalog.storage.disposal.STANDARD": "Sampah umum",
  "label.testCatalog.storage.unit.hours": "jam",
  "label.testCatalog.storage.unit.days": "hari",
  "label.testCatalog.storage.unit.weeks": "minggu",
  "label.testCatalog.storage.unit.months": "bulan",
  "label.testCatalog.analyzers.infoCard": "Alat dihubungkan ke pemeriksaan ini pada layar konfigurasi alat. Daftar ini bersifat hanya baca.",
  "label.testCatalog.analyzers.empty": "Belum ada alat yang dipetakan ke pemeriksaan ini.",
  "label.testCatalog.analyzers.loadError": "Tidak dapat memuat alat untuk pemeriksaan ini.",
  "label.testCatalog.analyzers.col.analyzer": "Alat",
  "label.testCatalog.analyzers.col.testName": "Nama Pemeriksaan Alat",
  "label.testCatalog.displayOrder.pickSampleType": "Jenis sampel",
  "label.testCatalog.displayOrder.intro": "Atur ulang urutan tampilan pemeriksaan dalam suatu jenis sampel. Urutan disimpan secara otomatis.",
  "label.testCatalog.displayOrder.empty": "Tidak ada pemeriksaan yang ditugaskan ke jenis sampel ini.",
  "label.testCatalog.displayOrder.loadError": "Tidak dapat memuat urutan tampilan.",
  "label.testCatalog.displayOrder.saved": "Urutan tampilan disimpan.",
  "label.testCatalog.displayOrder.currentTest": "Pemeriksaan ini",
  "label.testCatalog.displayOrder.moveUp": "Geser ke atas",
  "label.testCatalog.displayOrder.moveDown": "Geser ke bawah",
  "label.testCatalog.displayOrder.col.position": "Posisi",
  "label.testCatalog.displayOrder.col.test": "Pemeriksaan",
  "label.testCatalog.displayOrder.dragHandle": "Seret untuk mengatur ulang urutannya",
  "label.testCatalog.terminology.intro": "Petakan pemeriksaan ini ke kode terminologi standar demi interoperabilitas.",
  "vector.collectedVolume.helper": "Jumlah organisme dalam pool ini, misalnya, jumlah nyamuk.",
  "vector.complete.animal": "Hewan",
  "vector.complete.cancel": "Batal",
  "vector.complete.details.collectionDate": "Tanggal Pengambilan",
  "vector.complete.details.collectionSite": "Tempat Pengambilan",
  "vector.complete.details.collector": "Pengambil sampel",
  "vector.complete.details.lifecycleStage": "Tahapan Siklus Hidup",
  "vector.complete.details.tests": "Pemeriksaan",
  "vector.complete.details.title": "Rincian Pemesanan",
  "vector.complete.details.trapType": "Jenis Perangkap",
  "vector.complete.labNumber": "Nomor Registrasi",
  "vector.complete.newOrder": "Pemesanan Vektor Baru",
  "vector.complete.quantity": "Kuantitas",
  "vector.complete.quantity.value": "{count} Organisme",
  "vector.complete.status": "Status",
  "vector.complete.status.processing": "Pemrosesan",
  "vector.lifecycleStage.helper": "Tahapan perkembangan organisme yang diambil.",
  "vector.order.collectionContext.helper": "Opsional — mencatat kondisi ekologis pada saat pengambilan (bionomik).",
  "vector.order.collectionDate.heading": "Tanggal Pengambilan",
  "vector.order.collectionDate.helper": "Tanggal lot diambil secara fisik dari lapangan. Berlaku untuk setiap sampel dalam pemesanan ini.",
  "vector.order.site.add.new": "+ Tambahkan tempat baru \"{name}\"",
  "vector.order.site.add.new.restricted": "Fitur penambahan tempat pengambilan sampel baru telah dinonaktifkan oleh administrator Anda.",
  "vector.order.site.new.helper": "Akan dibuat sebagai tempat pengambilan sampel baru saat pemesanan ini disimpan.",
  "vector.order.site.new.tag": "Baru",
  "vector.order.site.no.match": "Tidak ditemukan tempat yang sesuai.",
  "vector.pool.noTests": "Tidak ada pemeriksaan yang tercatat",
  "vector.pool.summary": "Pool berisi {count} {animal}",
  "vector.trapCount.helper": "Jumlah perangkap yang dipasang — digunakan bersama dengan jumlah malam untuk menghitung kepadatan per malam per perangkap.",
  "vector.trapNights.helper": "Jumlah malam perangkap tersebut sudah aktif. Biarkan kosong jika upaya tersebut tidak terekam.",
  "vector.trapType.helper": "Metode atau perangkat pengambilan sampel yang digunakan — pilih jenis sampel terlebih dahulu.",
  "vectorDec.actionBar.assigned": "{assigned}/{total} ditugaskan · {pools} pool",
  "vectorDec.button.back": "Kembali",
  "vectorDec.button.discard": "Buang",
  "vectorDec.button.previewGrouping": "Pratinjau Pengelompokan",
  "vectorDec.button.savePools": "Simpan Pool",
  "vectorDec.button.splitIndividuals": "Pisahkan per individu →",
  "vectorDec.button.splitIndividuals.tooltip": "Pengaturan cepat: satu spesimen per Pool",
  "vectorDec.button.view": "Lihat",
  "vectorDec.col.children": "Spesimen Turunan",
  "vectorDec.col.positiveTest": "Hasil Pemeriksaan Positif",
  "vectorDec.col.results": "Hasil",
  "vectorDec.col.status": "Status",
  "vectorDec.empty": "Tidak ada tugas dekonvolusi.",
  "vectorDec.error.initiateFailed": "Tidak dapat memulai proses dekonvolusi.",
  "vectorDec.error.loadWorklist": "Tidak dapat memuat daftar pekerjaan dekonvolusi.",
  "vectorDec.error.minPoolCount": "Jumlah pool harus minimal 2.",
  "vectorDec.error.noAssignedSpecimens": "Seret setidaknya satu spesimen ke dalam pool sebelum menyimpan.",
  "vectorDec.error.noParent": "Tidak ada SampleItem induk yang tersedia untuk dipisahkan.",
  "vectorDec.error.poolFloorByType": "Lot memiliki {types} jenis sampel ({names}) - minimal {types} pool diperlukan untuk distribusi acak.",
  "vectorDec.error.unassignedSpecimens": "{count} Spesimen-spesimen tersebut masih tidak ditugaskan. Menugaskan semua spesimen sebelum menyimpan.",
  "vectorDec.field.howManyPools": "Berapa pool?",
  "vectorDec.field.notes": "Catatan",
  "vectorDec.field.organismsPerPool": "Jumlah organisme per kolam",
  "vectorDec.field.poolCount": "Jumlah pool",
  "vectorDec.field.strategy": "Metode penugasan",
  "vectorDec.filter.all": "Semua",
  "vectorDec.filter.status": "Filter berdasarkan Status",
  "vectorDec.heading.preview": "Usulan Pengelompokan Pool",
  "vectorDec.heading.split": "Pisahkan menjadi Sub-pool",
  "vectorDec.heading.worklist": "Dekonvolusi Pool",
  "vectorDec.individualMode.badge": "Mode individu",
  "vectorDec.locationOverride.help": "Ganti tempat pengambilan sampel yang diwarisi untuk masing-masing sub-pool. Gunakan opsi ini jika satu lot sampel diambil dari beberapa tempat.",
  "vectorDec.locationOverride.inherit": "Mewarisi dari lot (default)",
  "vectorDec.locationOverride.notes": "Catatan alikuot",
  "vectorDec.locationOverride.site": "Tempat Pengambilan",
  "vectorDec.locationOverride.title": "Lokasi pengambilan per sub-pool (opsional)",
  "vectorDec.message.success": "{count} sub-pool telah dibuat ({labRange}), {orders} pemesanan pemeriksaan telah dimasukkan ke antrian. Status → Dekonvolusi Dalam Pengerjaan.",
  "vectorDec.message.successIndividual": "{count} alikuot individu telah dibuat ({labRange}), {orders} pemesanan pemeriksaan telah dimasukkan ke antrian. Status → Dekonvolusi Dalam Pengerjaan. Konfirmasi Sporozoit VR-07 akan dijalankan pada hasil positif yang telah dikonfirmasi.",
  "vectorDec.parent.label": "Induk",
  "vectorDec.parent.quantity": "Kuantitas: {qty}",
  "vectorDec.preview.body": "{count} pool menggunakan {strategy}. Seret spesimen antar pool untuk menyesuaikan sebelum menyimpan.",
  "vectorDec.preview.empty": "Tidak ada spesimen",
  "vectorDec.preview.organisms": "Organisme",
  "vectorDec.preview.poolN": "Pool {n}",
  "vectorDec.preview.poolWithSpecies": "Pool {n} — {species}",
  "vectorDec.preview.specimenCount": "{count, plural, other {# spesimen}}",
  "vectorDec.preview.title": "Pengelompokan yang diusulkan",
  "vectorDec.preview.unassigned": "{count, plural, =0 {Semua spesimen ditugaskan} one {# belum ditugaskan} other {# belum ditugaskan}}",
  "vectorDec.preview.unassignedHint": "{count} belum ditugaskan - spesimen ini tetap berada di pool asal.",
  "vectorDec.reflexPreview.copiedTag": "COPIED",
  "vectorDec.reflexPreview.eagerTag": "EAGER",
  "vectorDec.reflexPreview.heading": "↪ Aturan refleks akan aktif saat melakukan penyelamatan",
  "vectorDec.reflexPreview.parentTests": "Perintah pengujian induk ({test}) — dijalankan ulang pada setiap anak",
  "vectorDec.reflexPreview.screeningPanel": "panel penyaringan",
  "vectorDec.reflexPreview.tipSplitIndividuals": "Tips: Pisahkan menjadi spesimen-spesimen terpisah agar juga dapat memicu {rules} — aturan ini hanya diterapkan pada kelompok yang berisi satu organisme saja.",
  "vectorDec.results.positive": "({count} +)",
  "vectorDec.setup.distribution": "{specimens} spesimen → ~{perPool} per pool{remainder, plural, =0 {} other {, sisa +1 ke {remainder} pool pertama}}",
  "vectorDec.status.complete": "Dekonvolusi Selesai",
  "vectorDec.status.confirmed": "Telah dilakukan konfirmasi",
  "vectorDec.status.inProgress": "Dalam Pengerjaan",
  "vectorDec.status.pending": "Perlu Ditinjau",
  "vectorDec.strategy.manual": "Menugaskan secara manual — seret dan lepas spesimen ke dalam kelompok",
  "vectorDec.strategy.manual.hint": "Seret dan lepas spesimen ke dalam pool sendiri",
  "vectorDec.strategy.manual.title": "Menugaskan secara manual",
  "vectorDec.strategy.random": "Menugaskan secara acak — sebarkan spesimen secara merata ke dalam kelompok-kelompok",
  "vectorDec.strategy.random.hint": "Sebarkan spesimen secara merata ke seluruh pool",
  "vectorDec.strategy.random.title": "Menugaskan secara acak",
  "vectorDec.strategy.species": "Sub-kelompok otomatis berdasarkan spesies — mengelompokkan spesimen yang serupa",
  "vectorDec.strategy.species.hint": "Kelompokkan spesimen berdasarkan spesies - spesimen wajib mencantumkan identitas spesies",
  "vectorDec.strategy.species.title": "Sub-pool otomatis berdasarkan spesies",
  "vectorDec.totalOrganisms": "Jumlah organisme",
  "vectorDec.warning.exceedsParent.body": "{total} organisme diminta di seluruh pool turunan, tetapi pool induk memiliki {parent}. Sistem tetap akan membuat {total} turunan.",
  "vectorDec.warning.exceedsParent.title": "Total melebihi kuantitas induk",
  "vectorId.batch.selectedCount": "{count, plural, other {# spesimen dipilih}}",
  "vectorId.bloodMeal.add": "Tambah Panel ke Pemesanan",
  "vectorId.bloodMeal.added": "Panel Identifikasi Makanan Darah ditambahkan ke pemesanan pemeriksaan spesimen.",
  "vectorId.bloodMeal.addedSub": "Sumber: manual (teknisi lab menerima saran). Sesuai BR-V03-014.",
  "vectorId.bloodMeal.alreadyAttached": "Panel makanan darah sudah terpasang ({skipped} pemeriksaan).",
  "vectorId.bloodMeal.body": "Pesanlah Panel Identifikasi Makanan Darah Nyamuk untuk mengidentifikasi spesies inang yang menjadi sumber makanan spesimen ini.",
  "vectorId.bloodMeal.bulkAdd": "Tambah Panel ke Semua ({count})",
  "vectorId.bloodMeal.bulkAddedSub": "Panel makanan darah diproses untuk {count} spesimen.",
  "vectorId.bloodMeal.bulkBody": "Tambah Panel Identifikasi Makanan Darah Nyamuk ke setiap spesimen yang dipilih agar laboratorium dapat mengidentifikasi inang vertebrata mana yang menjadi sumber makanan nyamuk tersebut.",
  "vectorId.bloodMeal.bulkSummary": "Panel makanan darah: {added} telah ditambahkan, {skipped} sudah tercantum, {rejected} ditolak.",
  "vectorId.bloodMeal.bulkTitle": "Nyamuk betina yang menghisap darah terdeteksi ({count} spesimen)",
  "vectorId.bloodMeal.dismiss": "Tutup",
  "vectorId.bloodMeal.error.add": "Tidak dapat menambahkan Panel Identifikasi Makanan Darah Nyamuk.",
  "vectorId.bloodMeal.error.dismiss": "Tidak dapat mencatat pengabaian saran.",
  "vectorId.bloodMeal.title": "Nyamuk betina yang menghisap darah terdeteksi",
  "vectorId.bulk.applyToCount": "Terapkan pada {count} spesimen",
  "vectorId.bulk.heading": "Terapkan Identitas Spesies Secara Massal",
  "vectorId.bulk.notice.body": "Bidang detail molekuler (gen target, uji, nomor aksesi) tidak disalin secara massal - catat informasi tersebut untuk setiap spesimen.",
  "vectorId.bulk.notice.title": "Bidang yang spesifik untuk spesimen tidak disalin",
  "vectorId.button.bulkApply": "🔖 Terapkan Massal ({count})",
  "vectorId.button.cancel": "Batal",
  "vectorId.button.close": "▲ Tutup",
  "vectorId.button.confirm": "Konfirmasi",
  "vectorId.button.confirmAll": "✓ Konfirmasi untuk semua vektor",
  "vectorId.button.confirmResult": "✓ Konfirmasi: {test}",
  "vectorId.button.hideResults": "Sembunyikan hasil",
  "vectorId.button.identify": "▼ Identifikasi",
  "vectorId.button.reviewResults": "Tinjau hasil ({n})",
  "vectorId.button.save": "Simpan Identifikasi",
  "vectorId.button.splitPool": "↗ Pisahkan",
  "vectorId.col.collectionDate": "Tanggal Pengambilan",
  "vectorId.col.decon": "Dekonvolusi",
  "vectorId.col.decon.help": "Status dekonvolusi — apakah hasil pool telah dimasukkan dan sub-pool sedang menunggu tinjauan.",
  "vectorId.col.idStatus": "Status Identifikasi",
  "vectorId.col.lotId": "ID Lot",
  "vectorId.col.organismGroup": "Kelompok",
  "vectorId.col.progress": "Kemajuan",
  "vectorId.col.site": "Tempat Pengambilan Sampel",
  "vectorId.completion.body": "{positive} dari {total} sub-pool terkonfirmasi ({pct}%)",
  "vectorId.completion.body.confirmed": "{total} vektor terkonfirmasi",
  "vectorId.completion.body.partial": "Telah dikonfirmasi untuk semua vektor dalam pool ini:",
  "vectorId.completion.heading": "Dekonvolusi Selesai",
  "vectorId.completion.heading.confirmed": "Hasil Telah Dikonfirmasi",
  "vectorId.completion.heading.partial": "Hasil Telah Terkonfirmasi Sebagian",
  "vectorId.completion.tag": "Dekonvolusi Selesai",
  "vectorId.completion.tag.confirmed": "Telah dilakukan konfirmasi",
  "vectorId.completion.tag.partial": "Terkonfirmasi Sebagian",
  "vectorId.confidence.confirmed": "Telah dilakukan konfirmasi",
  "vectorId.confidence.presumptive": "Dugaan",
  "vectorId.distribution.confirmed": "{count} Telah dikonfirmasi",
  "vectorId.distribution.heading": "Distribusi Spesies",
  "vectorId.distribution.notIdentified": "{count} Tidak Teridentifikasi",
  "vectorId.distribution.notYet": "Belum teridentifikasi",
  "vectorId.distribution.presumptive": "{count} Dugaan",
  "vectorId.empty": "Tidak ada lot dalam antrian ini.",
  "vectorId.error.accessionFormat": "Format nomor aksesi GenBank: 1–2 huruf yang diikuti oleh 5–8 angka (misalnya MW123456).",
  "vectorId.error.confidenceRequired": "Tingkat keyakinan wajib diisi.",
  "vectorId.error.loadSpecimens": "Tidak dapat memuat spesimen untuk lot ini.",
  "vectorId.error.loadWorklist": "Tidak dapat memuat daftar pekerjaan.",
  "vectorId.error.methodRequired": "Metode identifikasi wajib diisi.",
  "vectorId.error.notesTooLong": "Catatan harus terdiri dari maksimal 500 karakter.",
  "vectorId.error.requiredFields": "Spesies, metode, dan tingkat kepercayaan wajib dicantumkan.",
  "vectorId.error.saveFailed": "Tidak dapat menyimpan data identifikasi.",
  "vectorId.error.speciesRequired": "Spesies wajib diisi.",
  "vectorId.filter.complete": "Selesai",
  "vectorId.filter.complete.sub": "Semua spesimen telah diidentifikasi.",
  "vectorId.filter.decon": "Dekonvolusi",
  "vectorId.filter.decon.sub": "Hasil pool sudah dimasukkan, sedang menunggu keputusan petugas untuk membaginya atau melakukan konfirmasi.",
  "vectorId.filter.label": "Status",
  "vectorId.filter.notstarted": "Belum dimulai",
  "vectorId.filter.notstarted.sub": "Diterima, 0 spesimen telah diidentifikasi.",
  "vectorId.filter.partialid": "Identifikasi Sebagian",
  "vectorId.filter.partialid.sub": "Proses identifikasi sedang dalam pengerjaan.",
  "vectorId.filter.pending": "Tertunda",
  "vectorId.filter.pending.sub": "Semua lot yang belum selesai, termasuk pool yang hasilnya masih menunggu tinjauan petugas.",
  "vectorId.form.assayName": "Nama Uji",
  "vectorId.form.assayName.placeholder": "RT-PCR multipleks",
  "vectorId.form.confidence": "Keyakinan",
  "vectorId.form.genbankAccession": "Nomor Aksesi GenBank",
  "vectorId.form.genbankAccession.placeholder": "MW123456",
  "vectorId.form.lifecycleStage": "Tahapan Siklus Hidup",
  "vectorId.form.linkedResult": "Tautan ke Hasil Analisis Patogen",
  "vectorId.form.linkedResultPlaceholder": "Pilih hasil pada lot ini…",
  "vectorId.form.method": "Metode",
  "vectorId.form.molecularDetails": "🔬 Rincian Molekuler",
  "vectorId.form.notes": "Catatan",
  "vectorId.form.physState": "Status Fisiologis",
  "vectorId.form.select": "Pilih…",
  "vectorId.form.species": "Spesies",
  "vectorId.form.speciesPlaceholder": "Cari genus atau spesies…",
  "vectorId.form.targetGene": "Gen Target",
  "vectorId.form.targetGene.placeholder": "COI, ITS2, rDNA 28S",
  "vectorId.heading.worklist": "Daftar Pekerjaan Identifikasi Vektor",
  "vectorId.loading": "Sedang dimuat…",
  "vectorId.message.bulkSuccess": "Identifikasi diterapkan pada {count} spesimen.",
  "vectorId.message.saveSuccess": "Identifikasi telah disimpan.",
  "vectorId.method.both": "Morfologi + Molekuler",
  "vectorId.method.molecular": "Molekuler",
  "vectorId.method.morphological": "Morfologis",
  "vectorId.notif.confirmAll.error": "Hasil tidak dapat dikonfirmasi. Silakan coba lagi.",
  "vectorId.notif.confirmAll.success": "Hasil telah dikonfirmasi untuk semua vektor dalam pool ini.",
  "vectorId.notif.deconNeeded.body": "Hasil telah dimasukkan untuk pool ini. Pisahkan menjadi sub-pool untuk pemeriksaan lebih lanjut, atau konfirmasi bahwa hasil tersebut berlaku untuk semua vektor.",
  "vectorId.notif.deconNeeded.bodyWithTest": "Salah satu pemeriksaan telah memiliki hasil. Pisahkan menjadi sub-pool untuk pemeriksaan lebih lanjut, atau konfirmasi bahwa hasil tersebut berlaku untuk semua vektor.",
  "vectorId.notif.deconNeeded.title": "Hasil Pool Menunggu Tinjauan",
  "vectorId.physState.blood_fed": "Telah menghisap darah",
  "vectorId.physState.gravid": "Hamil",
  "vectorId.physState.half_gravid": "Setengah hamil",
  "vectorId.physState.unfed": "Belum diberi makan",
  "vectorId.physState.unknown": "Tidak diketahui / belum dievaluasi",
  "vectorId.resplit.heading": "Split: {label}",
  "vectorId.search.placeholder": "Cari lot…",
  "vectorId.specimen.col.confidence": "Keyakinan",
  "vectorId.specimen.col.idStatus": "Status Identifikasi",
  "vectorId.specimen.col.label": "Spesimen",
  "vectorId.specimen.col.labNo": "Nomor Registrasi",
  "vectorId.specimen.col.poolOrSpecimen": "Pool / Spesimen",
  "vectorId.specimen.col.species": "Spesies",
  "vectorId.specimen.confirmed": "Telah dilakukan konfirmasi",
  "vectorId.specimen.count": "Spesimen",
  "vectorId.specimen.empty": "Tidak ada spesimen untuk lot ini.",
  "vectorId.specimen.label": "Spesimen No.{n}",
  "vectorId.specimen.notIdentified": "Tidak Teridentifikasi",
  "vectorId.specimen.presumptive": "Dugaan",
  "vectorId.status.complete": "Selesai",
  "vectorId.status.inProgress": "Dalam Pengerjaan",
  "vectorId.status.notStarted": "Belum dimulai",
  "vectorId.tag.deconComplete": "Selesai",
  "vectorId.tag.deconInProgress": "Dekonvolusi dalam pengerjaan",
  "vectorId.tag.deconNeeded": "⚠ Tinjau Hasil",
  "vectorId.tag.subPoolPending": "{count} sub-pool yang berisi hasil",
  "vectorId.tree.organisms": "{count, plural, other {# organisme}}",
  "vectorReport.density.bySite": "Kepadatan per tempat dan periode",
  "vectorReport.density.effortNotRecorded": "Upaya tidak terekam",
  "vectorReport.density.period": "Periode",
  "vectorReport.density.perTrapNight": "Kepadatan (per malam per perangkap)",
  "vectorReport.density.pools": "Pool",
  "vectorReport.density.site": "Tempat",
  "vectorReport.density.specimens": "Spesimen",
  "vectorReport.density.title": "Jumlah spesimen menurut tempat",
  "vectorReport.density.trapNights": "Malam perangkap",
  "vectorReport.description": "Indeks pemantauan yang dihitung dari data pengumpulan vektor, identifikasi spesies, dan hasil pemeriksaan patogen yang tercatat",
  "vectorReport.empty": "Tidak ada data untuk ruang lingkup yang dipilih.",
  "vectorReport.exportPdf": "Ekspor PDF",
  "vectorReport.fieldMap.description": "Atur ulang urutan, sembunyikan, beri label baru, atau beri tag portal pada metrik yang ditampilkan di Alat Bantu Pengisian Manual.",
  "vectorReport.fieldMap.hidden": "Tersembunyi",
  "vectorReport.fieldMap.label": "Label",
  "vectorReport.fieldMap.metric": "Metrik",
  "vectorReport.fieldMap.order": "Pemesanan",
  "vectorReport.fieldMap.portalTag": "Tag portal",
  "vectorReport.fieldMap.title": "Peta Bidang Entri Manual",
  "vectorReport.fieldMap.visibility": "Visibilitas",
  "vectorReport.fieldMap.visible": "Terlihat",
  "vectorReport.fieldMap.visibleLabel": "Tampak di Alat Bantu Pengisian Manual",
  "vectorReport.filter.allSites": "Semua Tempat",
  "vectorReport.filter.apply": "Terapkan",
  "vectorReport.filter.dateRange": "Rentang Tanggal",
  "vectorReport.filter.from": "Dari",
  "vectorReport.filter.site": "Tempat Pengambilan Sampel",
  "vectorReport.filter.to": "Kepada",
  "vectorReport.freshness": "Kebaruan data",
  "vectorReport.freshness.as": "Data per {time}",
  "vectorReport.freshness.unknown": "Tidak diketahui",
  "vectorReport.generated": "Dibuat:",
  "vectorReport.home": "Beranda",
  "vectorReport.loadError": "Gagal memuat indikator pengawasan. Silakan coba lagi.",
  "vectorReport.manualEntry.confirmBody": "Catat snapshot audit angka minggu ini ({periodStart} – {periodEnd})? Pengiriman ulang data minggu yang sama akan dicatat sebagai entri terpisah.",
  "vectorReport.manualEntry.confirmSubmit": "Konfirmasi",
  "vectorReport.manualEntry.copied": "Telah disalin ke papan klip",
  "vectorReport.manualEntry.copy": "Salin nilai",
  "vectorReport.manualEntry.empty": "Tidak ada metrik yang dikonfigurasi untuk periode ini",
  "vectorReport.manualEntry.loading": "Sedang memuat data mingguan...",
  "vectorReport.manualEntry.lowConfidence": "Tingkat kepercayaan menurun (dekonvolusi pool di bawah 95%)",
  "vectorReport.manualEntry.markSubmitted": "Tandai minggu sebagai telah dikirim",
  "vectorReport.manualEntry.submitError": "Tidak dapat menyimpan pengiriman",
  "vectorReport.manualEntry.submitted": "Minggu telah ditandai sebagai telah dikirimkan",
  "vectorReport.manualEntry.title": "Alat Bantu Pengisian Manual",
  "vectorReport.manualEntry.week": "Minggu pelaporan",
  "vectorReport.mir.classic": "MIR (klasik)",
  "vectorReport.mir.observed": "Tingkat infeksi (yang teramati)",
  "vectorReport.mir.pathogen": "Patogen",
  "vectorReport.mir.positivePools": "Pool positif",
  "vectorReport.mir.resolution": "Resolusi positif",
  "vectorReport.mir.species": "Spesies",
  "vectorReport.mir.sporozoite": "Tingkat sporozoit",
  "vectorReport.mir.sporozoiteNote": "Tingkat kepercayaan akan menurun jika resolusi dekonvolusi pool berada di bawah 95%.",
  "vectorReport.mir.title": "Tingkat Infeksi Minimum per Spesies",
  "vectorReport.mir.totalSpecimens": "Total Spesimen",
  "vectorReport.mir.withheld": "Ditahan",
  "vectorReport.positivity.notConfigured": "Klasifikasi hasil positif tidak dikonfigurasi untuk penerapan ini, sehingga angka tingkat infeksi, hasil positif, dan sporozoit tidak tersedia. Konfigurasikan tingkat signifikansi hasil di Katalog Pemeriksaan untuk mengaktifkannya.",
  "vectorReport.positivity.pathogen": "Patogen",
  "vectorReport.positivity.pct": "Positivitas",
  "vectorReport.positivity.poolsPositive": "Pool positif",
  "vectorReport.positivity.poolsTested": "Pool yang diperiksa",
  "vectorReport.positivity.title": "Hasil positif patogen",
  "vectorReport.positivity.unrecognized": "Beberapa hasil memiliki nilai signifikansi yang tidak termasuk dalam klasifikasi yang diakui (POSITIF, NEGATIF, atau TIDAK JELAS) dan tidak dimasukkan dalam perhitungan hasil positif. Periksa Katalog Pemeriksaan agar hasil-hasil ini dapat dihitung.",
  "vectorReport.prompt": "Pilih rentang tanggal dan tempat, lalu pilih \"Terapkan\" untuk melihat indeks pemantauan.",
  "vectorReport.qc.detail": "{passed} dari {total} analisis lolos",
  "vectorReport.qc.passed": "Analisis telah lolos",
  "vectorReport.qc.passRate": "Tingkat kelulusan",
  "vectorReport.qc.title": "Tingkat kelulusan QC",
  "vectorReport.qc.total": "Jumlah analisis",
  "vectorReport.species.genus": "Genus",
  "vectorReport.species.pct": "Proporsi",
  "vectorReport.species.species": "Spesies",
  "vectorReport.species.specimens": "Spesimen",
  "vectorReport.species.title": "Distribusi spesies",
  "vectorReport.sporozoite.title": "Tingkat sporozoit (Anopheles)",
  "vectorReport.title": "Surveilans Vektor",
  "vfs.abj": "ABJ (Tingkat Bebas Larva)",
  "vfs.abj.target.below": "✗ ABJ di bawah target 95% Kementerian Kesehatan",
  "vfs.abj.target.met": "✓ ABJ memenuhi target 95% yang ditetapkan oleh Kemenkes",
  "vfs.bi": "Indeks Breteau (per 100 rumah)",
  "vfs.ci": "Indeks Wadah (CI)",
  "vfs.containersExamined": "Wadah yang diperiksa",
  "vfs.containersPositive": "Wadah positif",
  "vfs.err.containersExceeded": "Tidak boleh melebihi jumlah wadah yang diperiksa.",
  "vfs.err.examinedMin": "Harus ≥ 1 saat memasukkan data larva.",
  "vfs.err.housesExceeded": "Tidak boleh melebihi jumlah rumah yang diperiksa.",
  "vfs.err.negative": "Tidak boleh negatif.",
  "vfs.err.populationMin": "Harus ≥ 1 saat memasukkan data kepompong.",
  "vfs.hi": "Indeks Rumah (HI)",
  "vfs.housesExamined": "Rumah-rumah yang diperiksa",
  "vfs.housesPositive": "Rumah-rumah yang positif",
  "vfs.indices.title": "Indeks yang dihitung (pratinjau)",
  "vfs.larval.title": "Survei Larva — Mode C",
  "vfs.populationAtRisk": "Populasi berisiko",
  "vfs.ppi": "Pupa per Orang (PPI)",
  "vfs.pupaeCount": "Jumlah kepompong",
  "vfs.pupal.title": "Survei Kepompong — Mode D",
  "vfs.surveyMethod": "Metode survei",
  "vfs.surveyMethod.placeholder": "Pilih satu opsi",
  "warning.testCatalog.noLoinc": "Pemeriksaan ini tidak memiliki kode LOINC. Hasil dari Alat dan pemesanan elektronik tidak dapat diimpor ke pemeriksaan ini.",
  "warning.testCatalog.duplicateLoinc": "LOINC {code} juga digunakan oleh {testName}. Hasil yang masuk untuk kode ini hanya diarahkan ke satu pemeriksaan (yang pertama cocok) - hasil mungkin dikirim ke pemeriksaan yang salah.",
  "label.testCatalog.terminology.col.source": "Sumber",
  "label.testCatalog.terminology.col.code": "Kode",
  "label.testCatalog.terminology.col.displayName": "Nama di Tampilan",
  "label.testCatalog.terminology.displayName.placeholder": "misalnya, Glukosa [Massa/volume] dalam Serum atau Plasma",
  "label.testCatalog.terminology.col.relationship": "Hubungan",
  "label.testCatalog.terminology.col.appliesTo": "Berlaku untuk",
  "label.testCatalog.terminology.appliesTo.test": "Seluruh pemeriksaan",
  "label.testCatalog.terminology.col.actions": "Aksi",
  "label.testCatalog.terminology.source": "Sumber terminologi",
  "label.testCatalog.terminology.code": "Kode",
  "label.testCatalog.terminology.relationship": "Hubungan",
  "label.testCatalog.terminology.addMapping": "Tambah Pemetaan",
  "label.testCatalog.terminology.remove": "Hapus pemetaan",
  "label.testCatalog.terminology.empty": "Tidak ada pemetaan terminologi.",
  "label.testCatalog.terminology.loadError": "Tidak dapat memuat pemetaan terminologi.",
  "label.testCatalog.terminology.saved": "Pemetaan terminologi telah disimpan.",
  "error.testCatalog.terminology.duplicate": "Kode {source} {code} duplikat; pemetaan ini sudah ada untuk pemeriksaan ini.",
  "error.testCatalog.terminology.invalid": "Pemetaan tidak dapat disimpan — periksa apakah ada kode yang duplikat, sumber yang tidak diketahui, atau hubungan yang tidak valid.",
  "error.testCatalog.terminology.tooLong": "Kode maksimal 80 karakter dan nama tampilan maksimal 255.",
  "label.testCatalog.terminology.rel.none": "— tidak ada —",
  "label.testCatalog.terminology.rel.SAME_AS": "Sama seperti",
  "label.testCatalog.terminology.rel.BROADER_THAN": "Lebih luas daripada",
  "label.testCatalog.terminology.rel.NARROWER_THAN": "Lebih sempit daripada",
  "label.testCatalog.panels.intro": "Kelola panel mana saja yang mencakup pemeriksaan ini, serta posisinya di dalam masing-masing panel tersebut.",
  "label.testCatalog.panels.addToPanel": "Tambah ke panel",
  "label.testCatalog.panels.col.panel": "Panel",
  "label.testCatalog.panels.col.position": "Posisi",
  "label.testCatalog.panels.col.actions": "Aksi",
  "label.testCatalog.panels.position": "Posisi",
  "label.testCatalog.panels.remove": "Hapus dari panel",
  "label.testCatalog.panels.remove.confirm.heading": "Hapus pemeriksaan dari panel?",
  "label.testCatalog.panels.remove.confirm.body": "Pemeriksaan ini akan dihapus dari {panel}. Pemeriksaan ini tetap ada di Katalog dan panel-panel lain. Anda dapat menambahkannya kembali nanti.",
  "label.testCatalog.panels.moveUp": "Pindahkan ke atas",
  "label.testCatalog.panels.moveDown": "Pindahkan ke bawah",
  "label.testCatalog.panels.viewOrder": "Lihat urutan pengujian panel ini",
  "label.testCatalog.panels.orderContext": "Pemeriksaan dalam panel ini (berurutan):",
  "label.testCatalog.panels.empty": "Pemeriksaan ini belum termasuk dalam panel apa pun.",
  "label.testCatalog.panels.loadError": "Tidak dapat memuat keanggotaan panel.",
  "label.testCatalog.panels.saved": "Keanggotaan panel telah disimpan.",
  "label.testCatalog.panels.createPanel": "Buat panel baru",
  "label.testCatalog.panels.createPanelHint": "Masukkan nama untuk membuat panel dan menambahkan pemeriksaan ini ke dalamnya. Jenis sampel, modul pemesanan, dan pengaturan lainnya dikonfigurasi nanti di Editor Panel.",
  "notification.testCatalog.panels.created": "Panel '{name}' telah dibuat dan pemeriksaan ini telah ditambahkan. Lakukan Konfigurasi lebih lanjut di Panel Editor.",
  "label.search": "Cari",
  "label.testCatalog.list": "Katalog Pemeriksaan",
  "label.testCatalog.list.search": "Cari berdasarkan nama pemeriksaan",
  "label.testCatalog.list.col.status": "Status",
  "label.testCatalog.list.filter.allDomains": "Semua domain",
  "label.testCatalog.list.filter.allStatus": "Semua status",
  "label.testCatalog.list.filter.inactive": "Inaktif",
  "label.testCatalog.list.coverageIncomplete": "Cakupan belum lengkap",
  "label.testCatalog.list.filter.amr": "AMR",
  "label.testCatalog.list.filter.anyAmr": "Apa saja",
  "label.testCatalog.list.filter.amrOnly": "Hanya AMR",
  "label.testCatalog.list.filter.nonAmr": "Non-AMR",
  "label.testCatalog.list.filter.sampleType": "Jenis Sampel",
  "label.testCatalog.list.filter.allSampleTypes": "Semua Jenis Sampel",
  "label.testCatalog.list.filter.allLabUnits": "Semua instalasi lab",
  "label.testCatalog.list.amrTag": "AMR",
  "label.testCatalog.list.noLoinc": "Tidak ada LOINC",
  "label.testCatalog.list.filter.issuesOnly": "Hanya pemeriksaan yang mengalami masalah",
  "label.testCatalog.list.health.banner": "{count} pemeriksaan memiliki masalah konfigurasi ({errors} kesalahan · {warnings} peringatan)",
  "label.testCatalog.list.health.show": "Tampilkan",
  "label.testCatalog.activation.incomplete.heading": "Pemeriksaan tersebut belum dapat diaktifkan",
  "label.testCatalog.activation.incomplete.body": "Selesaikan hal-hal berikut ini sebelum pemeriksaan ini dapat diaktifkan:",
  "label.testCatalog.list.col.sampleType": "Jenis Sampel",
  "button.testCatalog.newTest": "Pemeriksaan baru",
  "button.testCatalog.editRelated": "Edit pemeriksaan terkait secara bersamaan",
  "button.testCatalog.editRelatedFromEditor": "Edit pemeriksaan yang terkait…",
  "label.testCatalog.editor.noRelated": "Tidak ada pemeriksaan terkait yang memiliki nama yang sama dengan pemeriksaan ini.",
  "label.testCatalog.editor.createSaveFirst.title": "Simpan pemeriksaan terlebih dahulu",
  "label.testCatalog.editor.createSaveFirst": "Lengkapi Informasi Dasar dan simpan. Bagian ini akan tersedia setelah pemeriksaan dibuat.",
  "label.testCatalog.editingNTests": "Mengedit {count} pemeriksaan",
  "label.testCatalog.perTestIdentity": "Identitas & LOINC (per pemeriksaan)",
  "state.testCatalog.differsAcrossTests": "Berbeda-beda antar pemeriksaan",
  "button.testCatalog.setAllTo": "Atur semuanya ke nilai-nilai ini",
  "label.testCatalog.group.rangesSaved": "Rentang referensi telah disimpan ke {count} pemeriksaan.",
  "label.testCatalog.group.storageIntro": "Edit pengaturan penyimpanan & penanganan sekali saja; saat disimpan, kolom yang Anda ubah diterapkan ke setiap pemeriksaan yang dipilih dan kolom lainnya tetap seperti semula pada setiap pemeriksaan.",
  "label.testCatalog.group.storageDiffer": "Kolom berikut tidak sama pada setiap pemeriksaan yang dipilih: {fields}. Formulir menampilkan nilai pemeriksaan pertama; kolom yang tidak Anda ubah tetap menggunakan nilai masing-masing pemeriksaan.",
  "button.testCatalog.removeFromSet": "Hapus dari kelompok ini",
  "label.testCatalog.group.rangesIntro": "Edit rentang referensi sekali saja; setelah disimpan, pengaturan tersebut akan diterapkan ke semua pemeriksaan yang dipilih. Identitas dan LOINC tetap berlaku per pemeriksaan.",
  "label.testCatalog.group.rangesDiffer": "Rentang saat ini pada pemeriksaan yang dipilih tidak sama. Jika disimpan, semua pemeriksaan akan disetel ke nilai di bawah ini.",
  "label.testCatalog.group.rangesLoadError": "Rentang saat ini dari {tests} tidak dapat dimuat, sehingga belum ada yang dapat diterapkan. Coba lagi untuk memuatnya kembali.",
  "label.testCatalog.ranges.table.sex": "Berlaku untuk",
  "label.testCatalog.ranges.table.age": "Rentang Umur",
  "label.testCatalog.ranges.table.normal": "Normal (rendah / tinggi)",
  "label.testCatalog.list.filters": "Filter",
  "label.testCatalog.list.filters.count": "Filter ({count})",
  "label.testCatalog.list.error": "Katalog Pemeriksaan tidak dapat dimuat. Sesuaikan filter atau muat ulang untuk mencoba lagi.",
  "label.testCatalog.list.empty": "Tidak ada pemeriksaan yang sesuai dengan filter saat ini.",
  "sidenav.label.admin.testmgt.ManageMethod": "Pengelolaan Metode",
  "sidenav.label.admin.testmgt.reflex": "Pengelolaan Pemeriksaan Refleks",
  "sidenav.label.admin.usermgt": "Pengelolaan Pengguna",
  "sideNav.label.arvfollowup1": "ARV Tindak Lanjut Versi 1",
  "sideNav.label.arvfollowup2": "ARV TIndak Lanjut Versi 2",
  "sideNav.label.arvreports1": "ARV Awal Versi 1",
  "sideNav.label.arvreports2": "ARV Awal Versi 2",
  "sideNav.label.arvversion1": "ARV-Versi 1",
  "sideNav.label.associatedpatientreport": "Laporan Pasien Terkait",
  "sideNav.label.audittrail": "Jejak Audit",
  "sidenav.label.barcode": "kode QR",
  "sidenav.label.batchorder": "Entri Pemesanan Batch",
  "sideNav.label.bypaneltype": "Berdasarkan Jenis Panel",
  "sideNav.label.bytesttype": "Berdasarkan Jenis Pemeriksaan",
  "sideNav.label.byunit": "Berdasarkan Unit",
  "sideNav.label.collectedarvpatientreports": "Kumpulan Laporan Pasien ARV",
  "sidenav.label.cytology": "Sitologi",
  "sidenav.label.cytology.dashboard": "Dasbor",
  "sideNav.label.delayedvalidation": "Validasi Tertunda",
  "sidenav.label.editorder": "Edit Pemesanan",
  "sideNav.label.eidreports1": "EID Versi 1",
  "sideNav.label.eidreports2": "EID Versi 2",
  "sideNav.label.exportcsvfile": "Ekspor file CSV rutin",
  "sideNav.label.followuprequired": "Diperlukan Tindak Lanjut",
  "sideNav.label.generalreport": "Laporan Umum",
  "sideNav.label.hivtestsummary": "Ringkasan Pemeriksaan HIV",
  "sidenav.label.immunochem": "Imunohistokimia",
  "sidenav.label.immunochem.dashboard": "Dasbor",
  "sidenav.label.incomingorder": "Permintaan elektronik",
  "sideNav.label.intermediatebyservice": "Internediate berdasarkan Layanan",
  "sideNav.label.intermediatereport1": "Intermediate Versi 1",
  "sideNav.label.intermediatereport2": "Internediate Versi 2",
  "sidenav.label.inventory": "Inventaris",
  "sidenav.label.inventory.management": "Pengelolaan inventaris",
  "sidenav.label.inventory.management.tooltip": "Kelola barang inventaris, lot dan jumlah stok",
  "sidenav.label.inventory.tooltip": "Pengelolaan inventaris untuk reagen, kit dan pasokan",
  "sideNav.label.laporanHasil": "Laporan Kepatuhan",
  "sideNav.label.noncomformitynotification": "Notifikasi Ketidaksesuaian",
  "sideNav.label.noncomformityreportsbydate": "Berdasarkan Tanggal",
  "sideNav.label.noncomformityreportsbylabno": "Berdasarkan No Lab",
  "sideNav.label.noncomformityreportsbyunit": "Berdasarkan Unit dan Alasan",
  "sidenav.label.notebook": "Notebook",
  "sidenav.label.add.order": "Tambah Pemesanan",
  "sidenav.label.clinical.order": "Tambah Pemesanan Klinis",
  "sidenav.label.environmental.compliance": "Dasbor Kepatuhan",
  "sidenav.label.environmental.order": "Tambah Pemesanan Lingkungan",
  "sidenav.label.vector.order": "Tambah Pemesanan Vektor",
  "sidenav.label.order": "Pemesanan",
  "sidenav.label.order.collect": "Ambil Sampel",
  "sidenav.label.order.dashboard": "Dasbor",
  "sidenav.label.order.enter": "Masukkan Pemesanan",
  "sidenav.label.order.label": "Label & Simpan",
  "sidenav.label.order.qa": "Tinjauan QA",
  "sidenav.label.order.prepare": "Siapkan Sampel",
  "sidenav.label.order.sampleCheck": "Pengecekan sampel",
  "sidenav.label.pathology": "Patologi",
  "sidenav.label.pathology.dashboard": "Dasbor",
  "sideNav.label.referredtestreport": "Laporan Pemeriksaan yang dirujuk ke luar",
  "sideNav.label.rejectionreport": "Laporan Penolakan",
  "sidenav.label.reports": "Laporan",
  "sidenav.label.reports.routine": "Rutin",
  "sidenav.label.reports.study": "Kajian",
  "sidenav.label.results": "Hasil",
  "sidenav.label.results.byrange": "Berdasarkan Rentang Nomor Registrasi",
  "sidenav.label.results.order": "Berdasarkan Permintaan",
  "sidenav.label.results.patient": "Berdasarkan Pasien",
  "sidenav.label.results.testdate": "Berdasarkan Tanggal Pemeriksaan",
  "sidenav.label.results.unit": "Berdasarkan Unit",
  "sideNav.label.sectionperformance": "Kinerja Bagian",
  "sideNav.label.specialrequest": "Permintaan Khusus",
  "sidenav.label.statisticsreport": "Laporan Statistik",
  "sidenav.label.statusreport": "Laporan Status Pasien",
  "sidenav.label.storage.coldstorage": "Pemantauan Penyimpanan Dingin",
  "sidenav.label.storage.coldstorage.tooltip": "Memantau suhu dan kelembaban freezer dan kulkas",
  "sidenav.label.storage.management": "Pengelolaan Penyimpanan",
  "sidenav.label.storage.management.tooltip": "Pengelolaan lokasi penyimpanan dan perangkat",
  "sidenav.label.testsummary": "Ringkasan Semua Pemeriksaan",
  "sidenav.label.validation": "Validasi",
  "sidenav.label.validation.order": "Cari Berdasarkan Permintaan",
  "sidenav.label.validation.routine": "Rutin",
  "sidenav.label.validation.study": "Kajian",
  "sidenav.label.validation.testdate": "Cari Berdasarkan Tanggal Pemeriksaan",
  "sideNav.label.viralloaddataexport": "Ekspor Data Viral Load",
  "sideNav.label.vlversionnational": "Versi VL Nasional",
  "sidenav.label.workplan": "Rencana Kerja",
  "sidenav.label.workplan.panel": "Berdasarkan Jenis Panel",
  "sidenav.label.workplan.priority": "Berdasarkan Prioritas",
  "sidenav.label.workplan.test": "Berdasarkan Jenis Pemeriksaan",
  "sidenav.label.workplan.unit": "Berdasarkan Unit",
  "sideNav.title.activityreport": "Laporan Kegiatan",
  "sidenav.title.aggregatereport": "Laporan Agregat",
  "sideNav.title.arvreports": "Laporan ARV",
  "sideNav.title.associatedpatientreport": "Laporan Terkait Pasien",
  "sideNav.title.audittrail": "Jejak Audit",
  "sideNav.title.collectedarvpatientreports": "Kumpulan Laporan pasien ARV",
  "sideNav.title.delayedvalidation": "Validasi Tertunda",
  "sideNav.title.eidreports": "Laporan EID",
  "sideNav.title.environmentalReports": "Laporan Lingkungan",
  "sideNav.title.exportbydate": "Ekspor berdasarkan Tanggal",
  "sideNav.title.exportcsvfile": "Ekspor CSV file Rutin",
  "sideNav.title.indicator": "Indikator",
  "sideNav.title.intermediatereport": "Laporan Intermediate",
  "sideNav.title.noncomformityreports": "Laporan Ketidaksesuaian",
  "sideNav.title.referredtestreport": "Laporan Pemeriksaan yang dirujuk ke luar",
  "sideNav.title.rejectionreport": "Laporan Penolakan",
  "sideNav.title.specialrequest": "Permintaan Khusus",
  "sideNav.title.tatreport": "Waktu Penyelesaian",
  "sideNav.title.vectorIdentification": "Identifikasi Vektor",
  "sideNav.title.vlreport": "Laporan VL",
  "sideNav.label.audittrail.orderEvents": "Event Pemesanan",
  "sideNav.label.audittrail.systemEvents": "Event Sistem",
  "sidenav.label.addorder": "Tambah Permintaan",
  "sidenav.label.admin.sampleTypeManagement": "Editor Jenis Sampel",
  "sideNav.label.qa": "Pemantapan Mutu",
  "sideNav.label.qa.overview": "Ikhtisar Pemantapan Mutu",
  "sideNav.label.qa.qc": "QC Statistik",
  "sideNav.label.qa.qc.dashboard": "Dasbor QC",
  "sideNav.label.qa.qc.alerts": "Peringatan QC",
  "sideNav.label.qa.qc.controlLots": "Pengelolaan Lot QC",
  "sideNav.label.qa.qc.ruleConfig": "Konfigurasi Aturan",
  "sideNav.label.qa.qc.reagentQc": "QC Reagen",
  "sideNav.label.qa.qc.manualQc": "QC Manual Alat",
  "sideNav.label.qa.qi": "Indikator Mutu",
  "sideNav.label.qa.qi.dashboard": "Dasbor Indikator Mutu",
  "sideNav.label.qa.qi.config": "Konfigurasi Indikator Mutu",
  "qa.qiConfig.subtitle": "Atur ambang batas target dan tindakan per indikator, aktifkan atau nonaktifkan indikator, dan timpa ambang batas untuk Instalasi Lab tertentu.",
  "qa.qiConfig.column.overrides": "Penimpaan",
  "qa.qiConfig.field.enabled": "Pantau indikator ini",
  "qa.qiConfig.field.target": "Target",
  "qa.qiConfig.field.action": "Ambang batas tindakan",
  "qa.qiConfig.field.category": "Instalasi Lab",
  "qa.qiConfig.editor.title": "Edit {indicator}",
  "qa.qiConfig.editor.defaults": "Ambang batas default",
  "qa.qiConfig.editor.overrides": "Penimpaan per Instalasi Lab",
  "qa.qiConfig.editor.usesDefault": "Instalasi Lab tanpa penimpaan menggunakan default indikator.",
  "qa.qiConfig.editor.noOverrides": "Tidak ada penimpaan, setiap Instalasi Lab menggunakan default.",
  "qa.qiConfig.editor.addOverride": "Tambah penimpaan Instalasi Lab",
  "qa.qiConfig.editor.autoNce": "Jika nilai sejak awal bulan melampaui ambang batas tindakan, kejadian ketidaksesuaian dibuat secara otomatis (satu per indikator per bulan).",
  "qa.qiConfig.indicator.tat": "Rata-rata Waktu Penyelesaian",
  "qa.qiConfig.indicator.rejection": "Tingkat Penolakan",
  "qa.qiConfig.indicator.amendment": "Tingkat Amandemen",
  "qa.qiConfig.indicator.nce": "Denyut KTS",
  "qa.qiConfig.indicator.callback": "Kepatuhan Panggilan Balik Kritis",
  "qa.qiConfig.validation.required": "Ambang batas target dan tindakan keduanya wajib diisi.",
  "qa.qiConfig.validation.range": "Ambang batas harus antara 0 dan 100.",
  "qa.qiConfig.validation.direction": "Urutan target dan ambang batas tindakan salah untuk indikator ini.",
  "qa.qiConfig.validation.category": "Pilih Instalasi Lab untuk setiap penimpaan.",
  "qa.qiConfig.validation.duplicateCategory": "Sebuah Instalasi Lab hanya dapat ditimpa satu kali.",
  "qa.qiConfig.confirmDisableTitle": "Nonaktifkan indikator ini?",
  "qa.qiConfig.confirmDisableBody": "Ini akan menyembunyikan ubin dasbor, menekan peringatan baru, dan menghentikan KTS yang dibuat otomatis untuk indikator ini. Data historis tetap disimpan. Lanjutkan?",
  "qa.qiConfig.saveFailed": "Tidak dapat menyimpan konfigurasi indikator mutu.",
  "sideNav.label.qa.qms": "Sistem Manajemen Mutu & Peningkatan",
  "sideNav.label.qa.qms.esigLog": "Log Tanda Tangan Elektronik",
  "sideNav.label.qa.qms.capaRegister": "Register CAPA",
  "sideNav.label.qa.qms.accreditation": "Akreditasi",
  "qa.qms.capaRegister.subtitle": "Semua tindakan perbaikan dan pencegahan dari seluruh kejadian ketidaksesuaian, beserta tanggal jatuh tempo dan statusnya.",
  "qa.qms.capaRegister.tile.dueThisWeek": "Jatuh Tempo Minggu Ini",
  "qa.qms.capaRegister.tile.completed": "Selesai (90 hari)",
  "qa.qms.capaRegister.filter.assignee": "Penanggung Jawab",
  "qa.qms.capaRegister.filter.from": "Tanggal Jatuh Tempo (Dari)",
  "qa.qms.capaRegister.filter.to": "Tanggal Jatuh Tempo (Sampai)",
  "qa.qms.capaRegister.column.correctiveAction": "Tindakan Perbaikan / Pencegahan",
  "qa.qms.capaRegister.column.assignee": "Penanggung Jawab",
  "qa.qms.capaRegister.status.open": "Buka",
  "qa.qms.capaRegister.status.overdue": "Lewat tenggat",
  "qa.qms.capaRegister.status.completed": "Selesai",
  "qa.qms.capaRegister.error": "Register CAPA tidak dapat dimuat.",
  "qa.qms.accreditation.title": "Akreditasi Pemeriksaan",
  "qa.qms.accreditation.subtitle": "Badan akreditasi dan pendaftaran per pemeriksaan. Menentukan logo akreditasi pada laporan pasien dan jawaban kesiapan inspeksi.",
  "qa.qms.accreditation.error": "Data akreditasi tidak dapat dimuat.",
  "qa.qms.accreditation.actionError": "Perubahan tidak dapat disimpan.",
  "qa.qms.accreditation.tile.total": "Badan",
  "qa.qms.accreditation.inForce": "Berlaku: {names}",
  "qa.qms.accreditation.bodies.title": "Badan Akreditasi",
  "qa.qms.accreditation.bodies.add": "Tambah lembaga",
  "qa.qms.accreditation.body.column.logo": "Logo",
  "qa.qms.accreditation.body.column.expiresOn": "Kedaluwarsa",
  "qa.qms.accreditation.status.ACTIVE": "Aktif",
  "qa.qms.accreditation.status.EXPIRING": "Segera kedaluwarsa",
  "qa.qms.accreditation.status.EXPIRED": "Kedaluwarsa",
  "qa.qms.accreditation.status.INACTIVE": "Inaktif",
  "qa.qms.accreditation.body.modal.addTitle": "Tambah Badan Akreditasi",
  "qa.qms.accreditation.body.modal.editTitle": "Edit Badan Akreditasi",
  "qa.qms.accreditation.body.edit": "Edit lembaga",
  "qa.qms.accreditation.body.delete": "Hapus lembaga",
  "qa.qms.accreditation.body.field.codeHelper": "2-16 karakter: huruf kapital, angka, dan tanda hubung. Tidak dapat diubah kemudian.",
  "qa.qms.accreditation.body.field.expiresOn": "Akreditasi kedaluwarsa",
  "qa.qms.accreditation.body.field.visibilityMode": "Tampilkan logo pada laporan jika",
  "qa.qms.accreditation.visibility.ANY_ACCREDITED_TEST": "Ada pemeriksaan terakreditasi dalam laporan",
  "qa.qms.accreditation.visibility.PERCENTAGE": "Sebagian persentase pemeriksaan dalam laporan terakreditasi",
  "qa.qms.accreditation.body.field.thresholdPct": "Ambang batas (%)",
  "qa.qms.accreditation.body.field.logo": "Logo (PNG atau JPEG, minimal 64×64 piksel, maksimal 500 KB)",
  "qa.qms.accreditation.body.logo.remove": "Hapus logo",
  "qa.qms.accreditation.body.required": "Kode, nama, dan tanggal kedaluwarsa wajib diisi.",
  "qa.qms.accreditation.body.saveError": "Badan akreditasi tidak dapat disimpan.",
  "qa.qms.accreditation.body.logoError": "Logo tidak dapat diunggah. Gunakan PNG atau JPEG minimal 64×64 piksel dan tidak lebih dari 500 KB.",
  "qa.qms.accreditation.body.delete.title": "Hapus Badan Akreditasi",
  "qa.qms.accreditation.body.delete.body": "Hapus {name}? Tindakan ini tidak dapat dibatalkan.",
  "qa.qms.accreditation.body.delete.blocked": "Tidak dapat menghapus: {count} akreditasi pemeriksaan merujuk ke lembaga ini. Hapus terlebih dahulu.",
  "qa.qms.accreditation.enrollments.title": "Pemeriksaan Terdaftar",
  "qa.qms.accreditation.enrollments.add": "Daftarkan pemeriksaan",
  "qa.qms.accreditation.enrollment.column.body": "Badan Akreditasi",
  "qa.qms.accreditation.enrollment.column.effectiveFrom": "Berlaku Sejak",
  "qa.qms.accreditation.enrollment.column.expires": "Lembaga Kedaluwarsa",
  "qa.qms.accreditation.enrollment.remove": "Hapus pendaftaran",
  "qa.qms.accreditation.eqa.title": "Cakupan PME terhadap Ruang Lingkup Akreditasi",
  "qa.qms.accreditation.eqa.subtitle": "ISO 15189 §7.7 menanyakan apakah setiap pemeriksaan yang Anda klaim terakreditasi mengikuti pemantapan mutu eksternal. Ini membandingkan ruang lingkup akreditasi dengan pendaftaran PME yang aktif.",
  "qa.qms.accreditation.eqa.column.scope": "Pemeriksaan dalam Ruang Lingkup",
  "qa.qms.accreditation.eqa.column.covered": "Dicakup oleh PME",
  "qa.qms.accreditation.eqa.column.gaps": "Kesenjangan",
  "qa.qms.accreditation.eqa.noGaps": "Cakupan penuh",
  "qa.qms.accreditation.eqa.gapsMore": "{names} dan {count} lainnya",
  "qa.qms.accreditation.eqa.error": "Cakupan PME tidak dapat dimuat.",
  "qa.qms.accreditation.filter.body": "Badan akreditasi",
  "qa.qms.accreditation.filter.test": "Pemeriksaan: {name}",
  "qa.qms.accreditation.enroll.modal.title": "Daftarkan Pemeriksaan",
  "qa.qms.accreditation.enroll.field.effectiveFrom": "Berlaku sejak (opsional)",
  "qa.qms.accreditation.enroll.required": "Pilih badan akreditasi dan minimal satu pemeriksaan.",
  "qa.qms.accreditation.enroll.failed": "Pendaftaran ditolak.",
  "qa.qms.accreditation.enrollment.delete.title": "Hapus Pendaftaran",
  "qa.qms.accreditation.enrollment.delete.body": "Hapus {test} dari {body}?",
  "qa.qms.esigLog.subtitle": "Semua tanda tangan elektronik yang tercatat dalam sistem: siapa menandatangani apa, kapan, dan mengapa.",
  "qa.qms.esigLog.column.signer": "Penanda Tangan",
  "qa.qms.esigLog.column.subject": "Subjek",
  "qa.qms.esigLog.filter.subjectType": "Jenis Subjek",
  "qa.qms.esigLog.filter.apply": "Terapkan Filter",
  "qa.qms.esigLog.export.confirm.title": "Ekspor tanpa filter?",
  "qa.qms.esigLog.export.confirm.body": "Tidak ada filter yang diterapkan, sehingga ini mengekspor semua tanda tangan dalam rentang tanggal yang dipilih (hingga 10.000 baris).",
  "qa.qms.esigLog.meaning.AUTHORED": "Dibuat oleh",
  "qa.qms.esigLog.meaning.VALIDATED_AND_RELEASED": "Divalidasi & Diterbitkan",
  "qa.qms.esigLog.meaning.REJECTED": "Ditolak",
  "qa.qms.esigLog.error": "Tidak dapat memuat log tanda tangan. Silakan coba lagi.",
  "qa.qi.dashboard.subtitle": "Lima indikator mutu termasuk Kepatuhan Panggilan Balik Kritis yang bersifat opsional.",
  "qa.qi.dashboard.window.label": "Periode pelaporan",
  "qa.qi.dashboard.window.7d": "7 hari terakhir",
  "qa.qi.dashboard.window.30d": "30 hari terakhir",
  "qa.qi.dashboard.window.90d": "90 hari terakhir",
  "qa.qi.dashboard.window.ytd": "Sejak awal tahun",
  "qa.qi.dashboard.lastRecomputed": "Terakhir dihitung ulang: {time}",
  "qa.qi.dashboard.viewDetail": "Lihat rincian",
  "qa.qi.dashboard.tileInfo": "Apa yang diukur oleh ubin ini?",
  "qa.qi.disabled.toast.title": "Indikator dinonaktifkan",
  "qa.qi.disabled.toast.message": "Indikator mutu ini dinonaktifkan di Konfigurasi Indikator Mutu; halaman rinciannya tidak tersedia.",
  "qa.qi.dashboard.tile.tat.label": "Rata-rata TAT",
  "qa.qi.dashboard.tile.tat.tooltip": "Rata-rata waktu penyelesaian dari penerimaan sampel hingga validasi hasil, di seluruh pemesanan pemeriksaan yang selesai dalam periode pelaporan.",
  "qa.qi.dashboard.tile.tat.vsPriorDays": "dibanding {days} hari sebelumnya",
  "qa.qi.dashboard.tile.tat.vsPriorPeriod": "dibanding periode sebelumnya",
  "qa.qi.dashboard.tile.tat.secondary": "Di {count, plural, one {# Instalasi Lab} other {# Instalasi Lab}} · Terlambat: {unit} ({tat})",
  "qa.qi.dashboard.tile.tat.empty": "Tidak ada pemesanan pemeriksaan yang selesai dalam periode ini.",
  "qa.qi.dashboard.tile.tat.error": "Data waktu penyelesaian tidak tersedia.",
  "qa.qi.dashboard.tile.rejection.label": "Tingkat Penolakan",
  "qa.qi.dashboard.tile.amendment.label": "Tingkat Amandemen",
  "qa.qi.dashboard.tile.ncePulse.label": "Denyut KTS",
  "qa.qi.dashboard.tile.ncePulse.tooltip": "Kejadian ketidaksesuaian kritis yang belum diketahui, per saat ini. Jumlah terkini, bukan tren.",
  "qa.qi.dashboard.tile.ncePulse.criticalPending": "kritis tertunda",
  "qa.qi.dashboard.tile.ncePulse.inCorrectiveAction": "{count} dalam tindakan perbaikan",
  "qa.qi.dashboard.tile.ncePulse.error": "Data KTS tidak tersedia.",
  "qa.qi.dashboard.tile.amendment.tooltip": "Hasil yang dikoreksi setelah laporan pasiennya dikirim, sebagai proporsi dari hasil yang dirilis dalam periode pelaporan.",
  "qa.qi.dashboard.tile.amendment.vsPriorDays": "dibanding {days} hari sebelumnya",
  "qa.qi.dashboard.tile.amendment.vsPriorPeriod": "dibanding periode sebelumnya",
  "qa.qi.dashboard.tile.amendment.secondary": "{amended} diamandemen dari {released} yang dirilis",
  "qa.qi.dashboard.tile.amendment.empty": "Tidak ada hasil yang dirilis dalam periode ini.",
  "qa.qi.dashboard.tile.amendment.error": "Data amandemen tidak tersedia.",
  "qa.qi.dashboard.tile.rejection.tooltip": "Pemeriksaan yang ditolak saat entri hasil atau validasi, sebagai proporsi dari pemeriksaan yang dimulai dalam periode pelaporan.",
  "qa.qi.dashboard.tile.rejection.vsPriorDays": "dibanding {days} hari sebelumnya",
  "qa.qi.dashboard.tile.rejection.vsPriorPeriod": "dibanding periode sebelumnya",
  "qa.qi.dashboard.tile.rejection.secondary": "{rejected} ditolak dari {total} yang dimulai",
  "qa.qi.dashboard.tile.rejection.empty": "Tidak ada pemeriksaan yang dimulai dalam periode ini.",
  "qa.qi.dashboard.tile.rejection.error": "Data penolakan tidak tersedia.",
  "qa.qi.dashboard.tile.thresholds": "Target {target} · tindakan {action}",
  "qa.qi.amendment.title": "Tingkat Amandemen: Detail",
  "qa.qi.amendment.subtitle": "Hasil yang dikoreksi setelah laporan pasiennya dikirim.",
  "qa.qi.amendment.column.amendedAt": "Diamandemen pada",
  "qa.qi.amendment.column.priorValue": "Nilai sebelumnya",
  "qa.qi.amendment.column.currentValue": "Nilai saat ini",
  "qa.qi.amendment.column.amendedBy": "Diamandemen oleh",
  "qa.qi.amendment.column.releasedAt": "Dirilis pada",
  "qa.qi.amendment.column.timeToAmend": "Waktu hingga amandemen",
  "qa.qi.amendment.rate.label": "Tingkat amandemen",
  "qa.qi.amendment.trend.empty": "Tidak ada data tren dalam rentang waktu ini.",
  "qa.qi.amendment.breakdown.title": "Per pemeriksaan",
  "qa.qi.amendment.breakdown.column.rate": "Tingkat",
  "qa.qi.rejection.title": "Tingkat Penolakan: Rincian",
  "qa.qi.rejection.subtitle": "Pemeriksaan yang ditolak saat entri hasil, beserta alasan penolakan yang dicatat.",
  "qa.qi.rejection.column.rejectedAt": "Ditolak pada",
  "qa.qi.rejection.column.rejectedBy": "Ditolak oleh",
  "qa.qi.rejection.heatmap.title": "Peta panas: lokasi pemesan × Instalasi Lab",
  "qa.qi.rejection.heatmap.section": "Instalasi Lab",
  "qa.qi.rejection.heatmap.unknown": "Lokasi tidak diketahui",
  "qa.qi.rejection.heatmap.unknownSection": "Bagian tidak diketahui",
  "qa.qi.rejection.heatmap.legend": "Sel diwarnai berdasarkan tingkat terhadap ambang batas lab: hijau ≤ {target}%, kuning di antaranya, merah ≥ {action}%. Arahkan kursor ke sel untuk melihat jumlah ditolak / dimulai.",
  "qa.qi.rejection.rate.label": "Tingkat penolakan",
  "qa.qi.rejection.reasons.title": "Per alasan (Pareto)",
  "qa.qi.rejection.reasons.column.percent": "% dari penolakan",
  "qa.qi.rejection.reasons.column.cumulative": "% Kumulatif",
  "qa.qi.rejection.reasons.donut.label": "Penolakan",
  "qa.qi.rejection.reasons.insight": "{count} alasan teratas dari {total} mencakup {percent}% penolakan; menangani {reason} terlebih dahulu memberikan dampak terbesar.",
  "qa.qi.rejection.breakdown.other": "Lainnya ({count} pemeriksaan)",
  "qa.qi.rejection.list.title": "Penolakan individual",
  "qa.qi.amendment.list.title": "Amandemen individual",
  "qa.qi.callback.button": "Catat panggilan balik",
  "qa.qi.callback.banner.title": "Hasil kritis memerlukan panggilan balik ke klinisi",
  "qa.qi.callback.banner.subtitle": "{count, plural, other {# hasil kritis tersimpan di halaman ini belum memiliki panggilan balik yang dicatat; baca ulang diwajibkan (TJC NPSG.02.03.01).}}",
  "qa.qi.callback.modal.title": "Catat panggilan balik kritis",
  "qa.qi.callback.field.recipientName": "Orang yang diberi tahu",
  "qa.qi.callback.field.recipientName.placeholder": "Nama klinisi atau ruang yang dihubungi",
  "qa.qi.callback.field.status": "Hasil panggilan balik",
  "qa.qi.callback.status.CONFIRMED": "Terkonfirmasi dengan baca ulang",
  "qa.qi.callback.status.REACHED_NO_READBACK": "Terhubung, tanpa baca ulang",
  "qa.qi.callback.status.UNABLE_TO_REACH": "Tidak dapat dihubungi",
  "qa.qi.callback.save.success": "Panggilan balik dicatat",
  "qa.qi.callback.save.fail": "Gagal mencatat panggilan balik",
  "qa.qi.callback.title": "Kepatuhan Panggilan Balik Kritis: Rincian",
  "qa.qi.callback.subtitle": "Hasil kritis yang telah dirilis dan apakah masing-masing telah ditelepon ke klinisi dengan baca ulang dalam rentang waktu target panggilan balik.",
  "qa.qi.callback.distribution.title": "Distribusi waktu hingga konfirmasi",
  "qa.qi.callback.distribution.0-5": "0–5 mnt",
  "qa.qi.callback.distribution.5-15": "5–15 mnt",
  "qa.qi.callback.distribution.15-30": "15–30 mnt",
  "qa.qi.callback.distribution.30-60": "30–60 mnt",
  "qa.qi.callback.distribution.over60": "60+ mnt",
  "qa.qi.callback.distribution.noAck": "Tidak ada konfirmasi",
  "qa.qi.callback.failures.title": "Kegagalan ({count}) berdasarkan alasan",
  "qa.qi.callback.failures.overTarget": "Melebihi target",
  "qa.qi.callback.failures.unableToReach": "Tidak dapat dihubungi",
  "qa.qi.callback.failures.noReadback": "Tidak ada baca ulang yang dicatat",
  "qa.qi.callback.failures.noCallback": "Tidak ada panggilan balik yang dicatat",
  "qa.qi.callback.list.title": "Hasil kritis dalam rentang waktu",
  "qa.qi.callback.rate.label": "Kepatuhan panggilan balik (baca ulang dalam {minutes} mnt)",
  "qa.qi.callback.status.notLogged": "Belum dicatat",
  "qa.qi.callback.column.status": "Status panggilan balik",
  "qa.qi.callback.column.timeToCallback": "Waktu hingga panggilan balik",
  "qa.qi.callback.column.loggedBy": "Dicatat oleh",
  "qa.qi.dashboard.tile.callback.label": "Kepatuhan Panggilan Balik Kritis",
  "qa.qi.dashboard.tile.callback.tooltip": "Hasil kritis yang dirilis dengan panggilan balik pembacaan ulang yang terkonfirmasi dalam jendela target panggilan balik lab. Opsional: aktifkan di Konfigurasi Indikator Mutu. Kepatuhan dihitung ulang berdasarkan rentang kritis saat ini.",
  "qa.qi.dashboard.tile.callback.secondary": "{confirmed} dari {critical} hasil kritis diketahui dalam batas target",
  "qa.qi.dashboard.tile.callback.vsPriorDays": "dibanding {days} hari sebelumnya",
  "qa.qi.dashboard.tile.callback.vsPriorPeriod": "dibanding periode sebelumnya",
  "qa.qi.dashboard.tile.callback.empty": "Tidak ada hasil kritis dalam periode ini.",
  "qa.qi.dashboard.tile.callback.error": "Data panggilan balik tidak tersedia.",
  "qa.qi.dashboard.tile.callback.disabled": "Belum diaktifkan, aktifkan di Konfigurasi Indikator Mutu.",
  "qa.empty.callback.title": "Tidak ada hasil kritis dalam rentang waktu ini",
  "qa.empty.callback.subhead": "Hasil kritis yang telah dirilis muncul di sini beserta status dokumentasi panggilan baliknya.",
  "qa.overview.rejection.caption": "ditolak pada entri hasil (30h)",
  "qa.overview.rejection.ofStarted": "{rejected} dari {total} dimulai",
  "qa.overview.callback.caption": "kepatuhan baca ulang kritis (30h)",
  "qa.overview.callback.ofCritical": "{confirmed} dari {critical} terkonfirmasi",
  "qa.overview.callback.none": "tidak ada hasil kritis dalam rentang waktu",
  "qa.overview.week.confirmedCount": "{count} terkonfirmasi",
  "qa.overview.amendment.caption": "diamandemen setelah laporan (30h)",
  "qa.overview.amendment.ofReleased": "{amended} dari {released} dirilis",
  "qa.future.subtitle": "Fitur mendatang: desain sudah ada; pembangunan belum dijadwalkan.",
  "qa.future.questionLabel": "Pertanyaan yang dijawab fitur ini",
  "qa.future.whyLabel": "Mengapa ini penting",
  "qa.future.readDesignDoc": "Baca dokumen desain di GitHub",
  "qa.future.reagentQc.question": "Apakah lot reagen ini telah diverifikasi sebelum digunakan untuk pasien?",
  "qa.future.reagentQc.summary": "Pelacakan frekuensi QC per lot. Sebelum lot reagen baru digunakan secara klinis, sistem mewajibkan sampel verifikasi terdokumentasi yang membandingkan lot baru dengan lot lama atau rujukan perbandingan sejawat.",
  "qa.future.reagentQc.why": "Tanpa verifikasi lot, lot reagen yang buruk dapat merusak hasil pasien selama seminggu sebelum ada yang menyadarinya. Sebagian besar laboratorium saat ini melakukannya secara informal; menjadikannya fitur sistem akan menangkap kasus ketika proses informal gagal.",
  "qa.future.manualQc.question": "Apakah petugas menjalankan kontrol harian pada alat ini hari ini, dan apakah hasilnya lolos?",
  "qa.future.manualQc.summary": "Log LOLOS/GAGAL harian per alat. Setiap alat memiliki pemeriksaan harian yang berbeda; sistem menyeragamkan semuanya dalam satu bentuk: log LOLOS/GAGAL harian dengan penanda tangan, stempel waktu, dan pemblokiran penggunaan alat jika GAGAL.",
  "qa.future.manualQc.why": "Hal pertama yang ditanyakan asesor saat memasuki laboratorium adalah 'tunjukkan log QC harian untuk alat ini.' Log yang ditandatangani per alat per hari, setiap hari. Lupa mengisinya adalah penyebab kegagalan inspeksi.",
  "qa.overview.subtitle": "Ringkasan harian untuk Petugas Mutu",
  "qa.overview.comingSoon": "Segera hadir",
  "qa.overview.section.attention": "Perlu Perhatian",
  "qa.overview.section.thisWeek": "Minggu Ini",
  "qa.overview.section.pillars": "Status Pilar",
  "qa.overview.section.activity": "Aktivitas Terbaru",
  "qa.overview.section.inspector": "Kesiapan inspeksi: lima pertanyaan mutu ISO 15189",
  "qa.overview.attention.criticalNce": "KTS kritis menunggu konfirmasi Mengetahui",
  "qa.overview.attention.criticalResults": "Hasil kritis dalam 24 jam terakhir",
  "qa.overview.attention.overdueCapas": "CAPA lewat tenggat",
  "qa.overview.attention.qcViolations": "Pelanggaran QC dalam 24 jam terakhir",
  "qa.overview.attention.effectivenessReview": "Tinjauan efektivitas CAPA jatuh tempo",
  "qa.overview.attention.eqaDue": "Pengiriman PME jatuh tempo dalam 14 hari ke depan",
  "qa.overview.attention.nceSla": "KTS mendekati SLA Mengetahui",
  "qa.overview.tile.criticalCallback": "Panggilan Balik Kritis",
  "qa.overview.week.newNces": "KTS baru",
  "qa.overview.week.ncesResolved": "KTS diselesaikan",
  "qa.overview.week.capasCompleted": "CAPA selesai",
  "qa.overview.week.qcViolations": "Pelanggaran QC",
  "qa.overview.week.criticalResults": "Hasil kritis",
  "qa.overview.week.eqaSubmissions": "Pengiriman PME",
  "qa.overview.week.auditEntries": "Entri log audit",
  "qa.overview.week.signatureEvents": "Kejadian tanda tangan",
  "qa.overview.inspector.q1": "Apakah pengujian dalam kendali?",
  "qa.overview.inspector.q2": "Bagaimana kinerja PME pada siklus terakhir?",
  "qa.overview.inspector.q3": "Apakah Indikator Mutu sesuai target?",
  "qa.overview.inspector.q4": "KTS kritis yang terbuka?",
  "qa.overview.inspector.q5": "Status akreditasi?",
  "qa.overview.inspector.q1.answer": "{inControl} dari {total} alat dalam kendali (30h)",
  "qa.overview.inspector.q3.answer": "Rata-rata TAT {tat} dibandingkan 30h sebelumnya",
  "qa.overview.inspector.q4.answer": "{count} KTS kritis menunggu konfirmasi Mengetahui",
  "qa.overview.inspector.q5.answer": "{active} dari {total} berlaku, {expiring} akan kedaluwarsa, {expired} kedaluwarsa",
  "qa.overview.inspector.q5.noData": "Belum ada badan akreditasi yang dikonfigurasi",
  "qa.overview.week.severityBreakdown": "{critical} kritis · {major} mayor · {minor} minor",
  "qa.overview.week.overdueCount": "{count} lewat tenggat",
  "qa.overview.week.currentlyOpen": "saat ini terbuka",
  "qa.overview.pillar.qc.text": "{inControl} dari {total} alat dalam kendali",
  "qa.overview.pillar.qc.noData": "Belum ada data QC",
  "qa.overview.pillar.qi.text": "Rata-rata TAT {tat}",
  "qa.overview.pillar.qi.noData": "Belum ada data TAT",
  "qa.overview.pillar.qi.disabled": "Saat ini tidak dilacak",
  "qa.overview.pillar.qms.text": "{critical} kritis tertunda · {capa} dalam tindakan perbaikan",
  "qa.overview.activity.viewAudit": "Lihat jejak audit lengkap",
  "qa.overview.activity.empty": "Tidak ada aktivitas dalam 24 jam terakhir",
  "qa.empty.activity.subhead": "Tindakan yang dibuktikan di semua pilar muncul di sini saat terjadi.",
  "qa.empty.attention.title": "Tidak ada yang perlu diperhatikan saat ini",
  "qa.empty.attention.subhead": "KTS kritis, CAPA yang lewat tenggat, dan pelanggaran QC muncul di sini saat terjadi.",
  "qa.empty.amendment.title": "Tidak ada amandemen dalam rentang waktu ini",
  "qa.empty.amendment.subhead": "Amandemen muncul di sini saat hasil yang telah dirilis dikoreksi.",
  "qa.empty.rejection.title": "Tidak ada penolakan dalam rentang waktu ini",
  "qa.empty.rejection.subhead": "Penolakan muncul di sini saat pemeriksaan ditolak pada entri hasil atau validasi.",
  "qa.empty.capaRegister.title": "Tidak ada CAPA yang sesuai dengan filter ini",
  "qa.empty.capaRegister.subhead": "Tindakan perbaikan dan pencegahan muncul di sini saat dicatat terhadap kejadian ketidaksesuaian.",
  "qa.empty.accreditation.bodies.title": "Belum ada badan akreditasi",
  "qa.empty.accreditation.bodies.subhead": "Tambahkan lembaga yang mengakreditasi laboratorium ini untuk mulai melacak akreditasi per pemeriksaan.",
  "qa.empty.accreditation.enrollments.title": "Tidak ada pendaftaran yang cocok dengan filter ini",
  "qa.empty.accreditation.enrollments.subhead": "Daftarkan pemeriksaan di bawah badan akreditasi untuk menampilkan logonya pada laporan pasien.",
  "qa.empty.accreditation.eqa.title": "Belum ada yang dibandingkan",
  "qa.empty.accreditation.eqa.subhead": "Setelah pemeriksaan didaftarkan di bawah badan akreditasi, cakupan PME-nya dibandingkan di sini.",
  "qa.empty.esigLog.title": "Tidak ada tanda tangan dalam rentang waktu ini",
  "qa.empty.esigLog.subhead": "Tanda tangan muncul di sini saat hasil dibuat dan divalidasi. Coba rentang tanggal yang lebih luas atau lebih sedikit filter.",
  "qa.empty.tat.title": "Tidak ada hasil dalam rentang waktu ini",
  "qa.empty.tat.subhead": "Waktu penyelesaian muncul di sini saat pemesanan pemeriksaan selesai dan divalidasi. Coba rentang tanggal yang berbeda.",
  "qa.empty.sparse.labUnits": "{count, plural, other {# instalasi lab}} this period",
  "qa.overview.activity.yesterday": "Kemarin {time}",
  "qa.overview.activity.esig": "{actor} {meaning} {record}",
  "qa.overview.activity.meaning.AUTHORED": "membuat hasil untuk",
  "qa.overview.activity.meaning.VALIDATED_AND_RELEASED": "memvalidasi & merilis",
  "qa.overview.activity.meaning.REJECTED": "menolak",
  "qa.overview.activity.qc": "Peringatan QC: {rule} ({severity}) pada {instrument}",
  "qa.overview.activity.nce.CREATED": "{actor} melaporkan {nce}",
  "qa.overview.activity.nce.ACKNOWLEDGED": "{actor} mengetahui {nce}",
  "qa.overview.activity.nce.ASSIGNED": "{actor} menugaskan {nce}",
  "qa.overview.activity.nce.NOTE_ADDED": "{actor} menambahkan catatan ke {nce}",
  "qa.overview.activity.nce.STATUS_CHANGED": "{actor} memperbarui status {nce}",
  "qa.overview.activity.nce.CORRECTIVE_ACTION": "{actor} memperbarui tindakan perbaikan pada {nce}",
  "qa.overview.activity.nce.RESOLVED": "{actor} menyelesaikan {nce}",
  "qa.overview.activity.nce.UPDATED": "{actor} memperbarui {nce}",
  "sidenav.title.statusreport": "Laporan Status Pasien",
  "systemAudit.filter.startDate": "Tanggal Mulai",
  "systemAudit.filter.endDate": "Tanggal Selesai",
  "systemAudit.filter.entityType": "Jenis Entitas",
  "systemAudit.filter.action": "Aksi",
  "systemAudit.filter.search": "Cari",
  "systemAudit.filter.export": "Ekspor CSV",
  "systemAudit.table.heading.time": "Waktu",
  "systemAudit.table.heading.entityType": "Jenis Entitas",
  "systemAudit.table.heading.entityId": "ID Entitas",
  "systemAudit.table.heading.action": "Aksi",
  "systemAudit.table.heading.user": "Pengguna",
  "systemAudit.table.heading.changes": "Perubahan",
  "systemAudit.noResults": "Tidak ada event sistem ditemukan untuk filter ini.",
  "systemAudit.filter.all": "Semua",
  "systemAudit.filter.user": "Pengguna",
  "systemAudit.filter.searchText": "Cari",
  "systemAudit.filter.searchText.placeholder": "Cari berdasarkan ID entitas...",
  "systemAudit.filter.exportPdf": "Ekspor PDF",
  "systemAudit.filter.selectedPatient": "Pasien yang Dipilih",
  "systemAudit.filter.selectedPatient.none": "Tidak ada",
  "systemAudit.filter.selectPatient": "Pilih Pasien",
  "systemAudit.filter.selectAnotherPatient": "Pilih Pasien Lain",
  "systemAudit.action.insert": "Masukkan",
  "systemAudit.action.update": "Perbarui",
  "systemAudit.action.delete": "Hapus",
  "site.branding.cancel": "Batalkan",
  "site.branding.color.format.error": "Format warna tidak valid. Mohon gunakan warna CSS valid (misalnya, #0f62fe)",
  "site.branding.color.hex.label": "Kode Warna Hex",
  "site.branding.colorPicker.helperText": "Masukkan warna CSS (misalnya, #0f62fe, biru, rgb(15, 98, 254))",
  "site.branding.colorPicker.placeholder": "#0f62fe atau biru",
  "site.branding.confirm.remove": "Hapus Logo",
  "site.branding.confirm.remove.message": "Apakah Anda ingin menghapus logo ini dan mengembalikan ke logo OpenELIS default?",
  "site.branding.current.logo": "Logo saat ini",
  "site.branding.description": "Kostumisasi branding visual organisasi, seperti logo dan warna",
  "site.branding.error.remove": "Gagal menghapus file logo.",
  "site.branding.favicon": "Favicon",
  "site.branding.favicon.description": "Ikon yang tampil di browser tab dan bookmark",
  "site.branding.file.format.error": "Format file tidak didukung. Mohon gunakan PNG, SVG, atau JPG/JPEG",
  "site.branding.file.pending": "File dipilih - klik Simpan Perubahan untuk mengunggah",
  "site.branding.file.size.error": "Ukuran file melebihi batas 2MB",
  "site.branding.formats": "Format: PNG, SVG, JPG (maks 2MB)",
  "site.branding.header.color": "Warna header",
  "site.branding.header.color.description": "Warna latar belakang untuk header bar aplikasi",
  "site.branding.header.logo": "Logo Header",
  "site.branding.header.logo.description": "Logo header di kiri-atas",
  "site.branding.login.logo": "Logo Halaman Login",
  "site.branding.login.logo.description": "Logo yang tampil di halaman login",
  "site.branding.login.using.header.logo": "Menggunakan logo header untuk halaman login",
  "site.branding.logo.upload.success": "Logo berhasil diunggah",
  "site.branding.no.logo": "Tidak ada logo kostum (default)",
  "site.branding.preview": "Pratinjau",
  "site.branding.primary.color": "Warna primer",
  "site.branding.primary.color.description": "Warna untuk tombol primer, item menu aktif, dan tautan",
  "site.branding.remove.favicon": "Hapus Favicon",
  "site.branding.remove.header.logo": "Hapus Logo Header",
  "site.branding.remove.login.logo": "Hapus Logo Login",
  "site.branding.remove.logo": "Hapus Logo",
  "site.branding.reset.confirmation": "Apakah anda ingin mengatur ulang semua branding ke default OpenELIS? Aksi ini akan menghapus semua kostumisasi logo dan warna.",
  "site.branding.reset.error": "Gagal mengatur ulang branding ke default.",
  "site.branding.reset.success": "Atur ulang branding ke default berhasil dilakukan.",
  "site.branding.reset.to.defaults": "Atur Ulang ke Branding Awal (Default)",
  "site.branding.save": "Simpan Perubahan",
  "site.branding.save.error": "Gagal menyimpan konfigurasi branding",
  "site.branding.save.success": "Konfigurasi branding berhasil disimpan",
  "site.branding.secondary.color": "Warna Sekunder",
  "site.branding.secondary.color.description": "Warna untuk tombol sekunder, batas, dan status yang inaktif",
  "site.branding.section.colors": "Warna",
  "site.branding.section.logos": "Logo",
  "site.branding.title": "Branding Situs",
  "site.branding.unsaved.changes": "Anda memiliki perubahan yang belum disimpan. Apakah Anda ingin menyimpan, menghapus, atau membatalkan?",
  "site.branding.unsaved.changes.warning": "Perubahan belum disimpan. Klik Simpan untuk menerapkan perubahan.",
  "site.branding.upload.favicon": "Unggah Favicon",
  "site.branding.upload.header.logo": "Unggah Logo Header",
  "site.branding.upload.login.logo": "Unggah Logo Login",
  "site.branding.upload.logo": "Unggah Logo",
  "site.branding.use.header.logo.for.login": "Gunakan logo yang sama sebagai header",
  "siteInfo.description.default.barcode": "Tentukan jumlah default label kode QR yang harus dicetak pada setiap pemesanan dan spesimen.",
  "siteInfo.description.dimensions": "Tentukan dimensi yang harus dipatuhi saaat mencetak label kode QR.",
  "siteInfo.description.elements": "Centang kotak di samping, untuk elemen opsional yang harus muncul pada pemesanan dan label kode QR sampel.",
  "siteInfo.description.max.barcode": "Tentukan jumlah maksimum label kode QR yang dapat dicetak untuk setiap pemesanan atau spesimen. Setelah jumlah maksimum tercapai, pengguna tidak akan dapat mencetak label tambahan.",
  "siteInfo.elements.mandatory": "Elemen Wajib",
  "siteInfo.elements.optional": "Elemen Opsional",
  "siteInfo.section.altAccession": "Kode QR Nomor Registrasi Pracetak",
  "siteInfo.section.elements": "Elemen Label Kode QR",
  "siteInfo.section.number": "Label Nomor Kode QR ",
  "siteInfo.section.size": "Dimensi Label Kode QR",
  "siteInfo.title.default.barcode": "Label Kode QR Default",
  "siteInfo.title.default.barcode.block": "Blok",
  "siteInfo.title.default.barcode.height": "Tinggi",
  "siteInfo.title.default.barcode.order": "Pemesanan",
  "siteInfo.title.default.barcode.order.none": "Tidak ada",
  "siteInfo.title.default.barcode.slide": "Slide",
  "siteInfo.title.default.barcode.specimen": "Spesimen",
  "siteInfo.title.default.barcode.freezer": "Lemari Pembeku",
  "siteInfo.title.default.barcode.width": "Lebar",
  "siteInfo.title.max.barcode": "Label Kode QR Maksimum",
  "started.date": "Tanggal Mulai",
  "status": "Status",
  "status.in.progress": "Dalam Pengerjaan",
  "status.unknown": "Tidak diketahui",
  "stillThere.message": "Sesi pengguna akan habis. Klik dimana saja untuk tetap login.",
  "stillThere.title": "Masih di tempat?",
  "stock.available": "Tersedia",
  "stock.level": "Level Stok",
  "stock.status": "Status Stok",
  "stock.status.expired": "Kedaluwarsa",
  "stock.status.expiring": "Segera Kedaluwarsa",
  "stock.status.expiringIn": "Akan kedaluwarsa ({days} hari)",
  "stock.status.inStock": "Stok Ada",
  "stock.status.lowStock": "Stok Sedikit",
  "stock.status.outOfStock": "Stok Habis",
  "storage.active": "Aktif",
  "storage.add.device": "Tambah Perangkat",
  "storage.add.location": "Lokasi",
  "storage.add.location.option": "Tambah Lokasi...",
  "storage.add.new.device": "Tambah perangkat baru",
  "storage.add.rack": "Tambah Laci",
  "storage.add.box": "Tambah Boks",
  "storage.add.room": "Tambah Ruangan",
  "storage.add.shelf": "Tambah Rak",
  "storage.allAssigned.title": "Semua Sample Ditugaskan",
  "storage.assign.button": "Tempatkan di Lokasi",
  "storage.assign.title": "Tugaskan Lokasi Penyimpanan",
  "storage.assigned": "Ditugaskan",
  "storage.assigned.by": "Ditempatkan Oleh",
  "storage.assigned.date": "Tanggal Penempatan",
  "storage.barcode.scan.placeholder": "Pindai Kode QR atau masukkan manual",
  "storage.bulk.move.auto.assigned": "Posisi ditetapkan otomatis (dapat diedit)",
  "storage.bulk.move.preview": "Pratinjau Pemindahan Jumlah Besar",
  "storage.cannotDelete.hasAssignments": "Tidak dapat menghapus {entityType} '{name}': yang mengandung {count} sampel yang ditempatkan",
  "storage.cannotDelete.hasChildren": "Tidak dapat menghapus {entityType} '{name}': yang mengandung {count} {childType}",
  "storage.capacity.calculated": "Dihitung",
  "storage.capacity.manual": "Batas Manual",
  "storage.capacity.undetermined.tooltip": "Kapasitas tidak dapat dihitung: beberapa lokasi turunan tidak memiliki kapasitas yang ditentukan",
  "storage.capacity.warning": "{location} is {percentage}% penuh. Pertimbangkan penyimpanan alternatif.",
  "storage.code.change.acknowledge": "Saya mengerti dan akan melanjutkan pengubahan kode",
  "storage.code.change.warning": "Peringatan",
  "storage.code.change.warning.message": "Mengubah kode akan membatalkan validasi label yang sudah dicetak untuk lokasi ini.",
  "storage.confirm.add.device": "Apakah Anda mau membuat perangkat baru '{name}'?",
  "storage.conditionNotes": "Catatan Kondisi",
  "storage.conditionNotes.placeholder": "Masukkan catatan tentang kondisi penyimpanan...",
  "storage.confirm.delete": "Konfirmasi Penghapusan",
  "storage.create.room.error": "Gagal membuat ruangan: {error}",
  "storage.create.room.success": "Ruangan \"{name}\" berhasil dibuat",
  "storage.current.location": "Lokasi Saat Ini",
  "storage.currentLocation": "Lokasi Saat Ini",
  "storage.delete.admin.only": "Hanya Administrator Global yang dapat menghapus lokasi",
  "storage.delete.are.you.sure": "Apakah Anda mau menghapus",
  "storage.delete.cannot.be.undone": "Aksi ini tidak dapat dibatalkan",
  "storage.delete.cascade.confirm": "Konfirmasi Penghapusan Bertingkat",
  "storage.delete.cascade.confirmation.checkbox": "Saya mengkonfirmasi akan menghapus lokasi dan turunannya. Semua sampel akan tidak ditempatkan lagi. Aksi ini tidak dapat dibatalkan.",
  "storage.delete.cascade.summary": "Ini akan menghapus {childCount} {childType} dan sampel yang belum ditempatkan {sampleCount}. Apakah Anda ingin lanjut?",
  "storage.delete.cascade.warning": "Peringatan Penghapusan Bertingkat",
  "storage.delete.checking": "Memeriksa batasan...",
  "storage.delete.confirmation.checkbox": "Saya mengkonfirmasi akan menghapus lokasi ini. Aksi ini tidak dapat dibatalkan.",
  "storage.delete.constraints.title": "Tidak Dapat Menghapus",
  "storage.delete.device": "Hapus Perangkat",
  "storage.delete.error": "Gagal menghapus lokasi",
  "storage.delete.location": "Hapus Lokasi",
  "storage.delete.rack": "Hapus Laci",
  "storage.delete.room": "Hapus Ruangan",
  "storage.delete.shelf": "Hapus Rak",
  "storage.device.code": "Kode",
  "storage.device.communicationProtocol": "Protokol Komunikasi",
  "storage.device.communicationProtocol.helper": "Protokol yang digunakan untuk komunikasi perangkat (misalnya, BACnet)",
  "storage.device.ipAddress": "Alamat IP",
  "storage.device.ipAddress.helper": "Alamat IPv4 atau IPv6 untuk alat terkoneksi ke jaringan",
  "storage.device.label": "Perangkat",
  "storage.device.name": "Nama",
  "storage.device.placeholder": "Pilih atau ketik untuk menambah perangkat...",
  "storage.device.port": "Portal",
  "storage.device.port.helper": "Nomor Portal (1-65535) untuk komunikasi",
  "storage.device.room": "Ruangan",
  "storage.device.type": "Jenis",
  "storage.edit.device": "Edit Perangkat",
  "storage.edit.error.loadLocation": "Gagal memuat lokasi",
  "storage.edit.error.saveFailed": "Penyimpanan gagal",
  "storage.edit.error.saveHttp": "Penyimpanan gagal (HTTP {status})",
  "storage.edit.rack": "Edit Laci",
  "storage.edit.room": "Edit Ruangan",
  "storage.edit.shelf": "Edit Rak",
  "storage.edit.selectParent": "Pilih {parent}",
  "storage.editbox.error.loadBox": "Gagal memuat boks",
  "storage.editbox.selectRack": "Pilih Laci",
  "storage.box.capacity": "Kapasitas",
  "storage.box.gridSize": "Ukuran grid",
  "storage.box.rows": "Baris",
  "storage.box.columns": "Kolom",
  "storage.box.preset": "Pengaturan awal dimensi",
  "storage.box.preset.select": "Pilih dimensi",
  "storage.error.location.inactive": "Tidak dapat menempatkan di lokasi yang inaktif",
  "storage.error.name.duplicate": "{entityType} dengan nama ini sudah ada di lokasi induk yang dipilih",
  "storage.error.position.occupied": "Posisi sudah diisi",
  "storage.expanded.capacityLimit": "Batas Kapasitas",
  "storage.expanded.createdBy": "Dibuat Oleh",
  "storage.expanded.createdDate": "Tanggal Dibuat",
  "storage.expanded.description": "Deskripsi",
  "storage.expanded.lastModifiedBy": "Dimodifikasi Terakhir Oleh",
  "storage.expanded.lastModifiedDate": "Tanggal Modifikasi Terakhir",
  "storage.expanded.notAvailable": "N/A",
  "storage.expanded.positionSchemaHint": "Petunjuk Skema Posisi",
  "storage.expanded.temperatureSetting": "Pengaturan Suhu",
  "storage.filter.by.locations": "Filter berdasarkan lokasi",
  "storage.filter.by.locations.placeholder": "Filter berdasarkan lokasi...",
  "storage.filter.device": "Filter berdasarkan Perangkat",
  "storage.filter.room": "Filter berdasarkan Ruangan",
  "storage.filter.status": "Filter berdasarkan Status",
  "storage.hierarchical.path": "Jalur Lokasi",
  "storage.inline.add.device": "Tambah Perangkat Baru",
  "storage.inline.add.rack": "Tambah Laci Baru",
  "storage.inline.add.room": "Tambah Ruangan Baru",
  "storage.inline.add.shelf": "Tambah Rak Baru",
  "storage.location": "Lokasi",
  "storage.location.active": "Aktif",
  "storage.location.add.button": "Tambah Lokasi",
  "storage.location.add.title": "Tambah Lokasi Penyimpanan",
  "storage.location.current": "Lokasi Penyimpanan",
  "storage.location.code": "Kode Lokasi",
  "storage.location.code.helper": "Maksimum 10 karakter, alfanumerik dengan hyphen/underscore",
  "storage.location.description": "Deskripsi",
  "storage.location.label": "Lokasi Penyimpanan",
  "storage.location.name": "Nama Lokasi",
  "storage.location.skipped": "Penyimpanan Dilewati",
  "storage.location.tempMax": "Suhu Maksimum",
  "storage.location.tempMin": "Suhu Minimum",
  "storage.location.type": "Jenis Lokasi",
  "storage.location.unassigned": "Tidak ditugaskan",
  "storage.location.notAssigned": "Tidak ditugaskan",
  "storage.location.move": "Pindahkan lokasi penyimpanan",
  "storage.location.assign": "Tugaskan lokasi penyimpanan",
  "storage.manageLocation.error.saveFailed": "Penyimpanan gagal",
  "storage.manageLocation.error.selectTarget": "Pilih perangkat, rak, laci, atau boks sebelum menyimpan",
  "storage.nav.box": "Boks",
  "storage.nav.device": "Perangkat",
  "storage.nav.room": "Ruangan",
  "storage.nav.shelf": "Rak",
  "storage.picker.currentLocation": "Lokasi saat ini",
  "storage.picker.heading.assignLocation": "Tugaskan Lokasi Penyimpanan",
  "storage.picker.heading.move": "Pindahkan Barang",
  "storage.picker.newLocation": "Lokasi baru",
  "storage.picker.notes": "Catatan",
  "storage.picker.orBrowse": "Atau pilih tingkat demi tingkat",
  "storage.picker.position.optional": "Posisi (opsional)",
  "storage.picker.select": "Pilih {level}",
  "storage.picker.selectDeviceType": "Pilih jenis perangkat",
  "storage.picker.addNewLevel": "Tambah baru {level}",
  "storage.picker.inlineCreate.heading": "Buat baru {level}",
  "storage.picker.inlineCreate.error.title": "Tidak dapat membuat lokasi",
  "storage.picker.inlineCreate.error": "Gagal membuat lokasi",
  "storage.picker.occupant.identifier": "Pengidentifikasi",
  "storage.picker.occupant.heading": "Barang",
  "storage.picker.occupant.status": "Status",
  "storage.picker.occupant.type": "Jenis",
  "storage.picker.storageLocation": "Lokasi Penyimpanan",
  "storage.metrics.active": "Aktif",
  "storage.metrics.disposed": "Dimusnahkan",
  "storage.metrics.total.samples": "Total Item Sampel",
  "storage.mode.autocomplete": "Pencarian Ketik",
  "storage.mode.barcode": "Pindai Kode QR",
  "storage.mode.cascading": "Dropdown bertingkat",
  "storage.move.button": "Pindahkan Sampel",
  "storage.move.reason.label": "Alasan Pemindahan",
  "storage.nav.boxes": "Boks",
  "storage.nav.boxes.tooltip": "Kelola boks penyimpanan",
  "storage.nav.dashboard": "Dasbor penyimpanan",
  "storage.nav.devices": "Perangkat",
  "storage.nav.devices.tooltip": "Kelola perangkat penyimpanan",
  "storage.nav.locations": "Lokasi",
  "storage.nav.locations.tooltip": "Kelola lokasi penyimpanan",
  "storage.nav.racks": "Laci",
  "storage.nav.racks.tooltip": "Kelola laci penyimpanan",
  "storage.nav.rooms": "Ruangan",
  "storage.nav.rooms.tooltip": "Kelola ruangan penyimpanan",
  "storage.nav.sample.items": "Item Sampel",
  "storage.nav.sample.items.tooltip": "Lihat dan kelola sampel tersimpan",
  "storage.nav.samples": "Item Sampel",
  "storage.nav.samples.tooltip": "Lihat dan kelola sampel tersimpan",
  "storage.nav.shelves": "Rak",
  "storage.nav.shelves.tooltip": "Kelola rak penyimpanan",
  "storage.no.data": "Tidak ada data",
  "storage.occupancy": "Tingkat Keterisian",
  "storage.position.label": "Posisi",
  "storage.rack.device": "Perangkat",
  "storage.rack.dimensions": "Dimensi",
  "storage.rack.label": "Laci",
  "storage.rack.placeholder": "Pilih atau ketik untuk menambah laci...",
  "storage.rack.room": "Ruangan",
  "storage.rack.shelf": "Rak",
  "storage.room.code": "Kode",
  "storage.room.devices": "Perangkat",
  "storage.room.label": "Ruangan",
  "storage.room.name": "Nama",
  "storage.room.placeholder": "Pilih atau ketik untuk menambah ruangan...",
  "storage.room.samples": "Sampel",
  "storage.sampleitem.id": "ID Item Sampel",
  "storage.search.boxes.placeholder": "Cari boks berdasarkan label atau kode...",
  "storage.search.devices.placeholder": "Cari berdasarkan nama atau kode perangkat...",
  "storage.search.location.minLength": "Lanjutkan mengetik, minimal 2 karakter",
  "storage.search.location.searching": "Mencari...",
  "storage.search.location.error": "Tidak dapat mencari lokasi. Silakan coba lagi.",
  "storage.search.location.noResults": "Tidak ada lokasi penyimpanan yang cocok dengan \"{query}\"",
  "storage.search.placeholder": "Cari berdasarkan ID sampel atau lokasi...",
  "storage.search.racks.placeholder": "Cari berdasarkan label laci...",
  "storage.search.rooms.placeholder": "Cari berdasarkan nama atau kode ruangan...",
  "storage.search.lots.placeholder": "Cari berdasarkan nomor lot, Kode QR, barang, atau lokasi...",
  "storage.search.samples.placeholder": "Cari berdasarkan ID sampel atau lokasi...",
  "storage.search.shelves.placeholder": "Cari berdasarkan label rak...",
  "storage.select.location": "Pilih Lokasi",
  "storage.selectSample": "Pilih Sampel",
  "storage.shelf.device": "Perangkat",
  "storage.shelf.label": "Rak",
  "storage.shelf.placeholder": "Pilih atau ketik untuk menambah rak...",
  "storage.shelf.room": "Ruangan",
  "storage.status": "Status",
  "storage.status.disposed": "Dimusnahkan",
  "storage.success.assigned": "Penempatan sampel di lokasi penyimpanan berhasil",
  "storage.success.moved": "Pemindahan sampel ke lokasi baru berhasil",
  "storage.tab.ariaLabel": "Tab pengelolaan penyimpanan",
  "storage.tab.dashboard": "Dasbor",
  "storage.tab.inventoryLots": "Lot Inventaris",
  "storage.tab.samples": "Item Sampel",
  "storage.target.location": "Lokasi Target",
  "storage.unassigned.title": "Sampel tidak ditugaskan",
  "storage.skipAssignment": "Tidak diperlukan penyimpanan - sampel akan segera diproses",
  "success.add.edited.msg": "Berhasil Ditambah/Diedit",
  "success.delete.msg": "Berhasil DIhapus",
  "success.import.patient": "Pasien Berhasil Diimpor",
  "success.report.status": "Pembuatan Laporan Berhasil",
  "success.save.msg": "Penyimpanan berhasil",
  "success.save.patient": "Penyimpanan Pasien Berhasil",
  "systemuser.firstName": "Nama Depan Pengguna Sistem",
  "systemuser.isActive": "Adalah Aktif",
  "systemuser.lastName": "Nama Akhir Pengguna Sistem",
  "systemuser.loginName": "Nama Login Pengguna Sistem",
  "systemuser.role": "Peran",
  "systemuserrole.apply": "Terapkan",
  "systemuserrole.allLabUnits.confirm.body": "Mengubah baris ini menjadi Semua Instalasi Lab akan menghapus izin Instalasi Lab ini. Baris Semua Instalasi Lab dimulai tanpa izin yang dicentang.",
  "systemuserrole.allLabUnits.confirm.noPermissions": "tidak ada izin yang dicentang",
  "systemuserrole.allLabUnits.confirm.primary": "Ganti izin",
  "systemuserrole.allLabUnits.confirm.title": "Ganti izin Instalasi Lab?",
  "systemuserrole.allLabUnits.exclusive.error": "Semua Instalasi Lab tidak dapat digabungkan dengan Instalasi Lab individual. Tidak ada yang disimpan.",
  "systemuserrole.allLabUnits.exclusive.info": "Semua Instalasi Lab tidak dapat digabungkan dengan Instalasi Lab individual: memilihnya akan menggantikan setiap izin khusus Instalasi Lab.",
  "systemuserrole.copypermissions": "Salin Izin dari Pengguna",
  "systemuserrole.copypermissions.placeholder": "Menyalin Izin Pengguna",
  "systemuserrole.instruction.1": "Terdapat dua jenis Peran. Peran Global untuk keseluruhan aplikasi dan Peran Unit Laboratorium untuk semua Unit Laboratorium atau Unit Laboratorium tertentu.",
  "systemuserrole.instruction.2": "Peran Global yang tersedia adalah: Administrator Global (Akses ke semua Fungsi Admin), Jejak Audit (Akses ke semua Jejak Audit), Administrator Akun Pengguna (memiliki akses ke semua fitur administrasi akun pengguna, tetapi tidak ke fungsi admin lainnya).",
  "systemuserrole.instruction.3": "Peran Unit Laboratorium adalah: Penerimaan (Akses ke Tab Pemesanan, Pasien, dan Ketidaksesuaian), Hasil (Akses ke Tab Rencana Kerja, Ketidaksesuaian, dan Hasil), Validasi (Akses ke Tab Validasi dan Ketidaksesuaian), Laporan (Akses ke Tab Laporan kecuali ekspor CSV hanya tersedia untuk Administrator Global).",
  "systemuserrole.instruction.4": "Untuk menetapkan Peran Unit Lab, pilih semua unit lab atau unit lab tertentu dari menu dropdown dan pilih peran apa yang ingin ditetapkan.",
  "systemuserrole.instruction.5": "Anda dapat menggunakan Fitur Salin Izin untuk menyalin izin pengguna yang sudah ada. Pastikan Anda telah mengisi semua informasi di atas dan masukkan nama pengguna yang izinnya ingin Anda salin ke dalam kotak, lalu klik terapkan.",
  "systemuserrole.newpermissions": "Tambah Izin Baru",
  "systemuserrole.rmpermissions": "Hapus Izin",
  "systemuserrole.roles.global": "Peran Global",
  "systemuserrole.roles.labunit": "Peran Unit Lab",
  "test.add.copy.name": "Salin dari Nama Pemeriksaan",
  "test.antimicrobialResistance": "Resistensi Antimikroba",
  "test.description.active": "Jika pemeriksaan sedang aktif, maka dapat dipesan melalui formulir pemesanan atau sebagai bagian algoritma pemeriksaan. Jika pemeriksaan tidak aktif, maka tidak dapat dipesan atau dijadikan bagian algoritma pemeriksaan.",
  "test.description.name": "Nama pemeriksaan akan muncul di dalam sistem, baik versi bahasa Inggris maupun Prancis.",
  "test.description.orderable": "Jika pemeriksaan aktif dan dapat dipesan, maka pemeriksaan dapat dipesan melalui formulir pemesanan. Jika pemeriksaan aktif tetapi tidak dapat dipesan, maka pemeriksaan hanya akan dilakukan sebagai refleks dari pemeriksaan lain.",
  "test.description.panel": "Jika pemeriksaan ini merupakan bagian dari panel pemeriksaan, maka panel tersebut dapat ditambahkan di sini. Kemungkinan pemeriksaan ada di lebih dari satu panel.",
  "test.description.reportName": "Nama pemeriksaan akan muncul di dalam sistem, baik versi bahasa Inggris maupun Prancis. Jika Nama dan nama pelapor sama, klik tombol untuk menyalin nama",
  "test.description.testSection": "Bagian tempat pemeriksaan dilakukan",
  "test.description.uom": "Satuan pengukuran pemeriksaan. Biasanya berlaku hanya untuk jenis hasil numerik atau alfanumerik.",
  "test.field.active": "Aktif",
  "test.field.orderable": "Dapat dipesan",
  "test.inLabOnly": "Hanya Di Lab",
  "test.modify.en": "en",
  "test.modify.fr": "fr",
  "test.modify.header.modify": "Pilih Pemeriksaan yang akan Dimodifikasi!",
  "test.modify.header.test": "Pemeriksaan",
  "test.name": "Nama Pemeriksaan",
  "test.notifyResults": "Kirim Notifikasi ke Pasien dengan Hasil",
  "test.section": "Bagian Pemeriksaan",
  "test.section.label": "Bagian Pemeriksaan",
  "test.show.guide": "Tampilkan Panduan",
  "testcalculation.label.calculation": "Penghitungan",
  "testcalculation.label.finalresult": "Hasil Akhir",
  "testcalculation.label.insertOperation": "Masukan Operasi",
  "testcalculation.label.integer": "Bilangan Bulat",
  "testcalculation.label.mathFucntion": "Fungsi Matematika",
  "testcalculation.label.name": "Nama Penghitungan",
  "testcalculation.label.patientAttribute": "Atribut Pasien",
  "testcalculation.label.searchNumericTest": "Cari Pemeriksaan Numerik",
  "testcalculation.label.selectDictionaryValue": "Pilih Nilai Kamus",
  "testcalculation.label.testResult": "Hasil Pemeriksaan",
  "testcalculation.label.textValue": "Nilai teks",
  "testCatalog.header.ageRange": "Rentang Umur",
  "testCatalog.header.criticalRange": "Rentang Kritis",
  "testCatalog.header.field": "Bidang",
  "testCatalog.header.gender": "Jenis Kelamin",
  "testCatalog.header.normalRange": "Rentang Normal",
  "testCatalog.header.reportingRange": "Rentang Pelaporan",
  "testCatalog.header.validRange": "Rentang Valid",
  "testCatalog.header.value": "Nilai",
  "admin.testCatalog.methods.title": "Metode",
  "admin.testCatalog.methods.column.name": "Nama Metode",
  "admin.testCatalog.methods.column.code": "Kode",
  "admin.testCatalog.methods.column.default": "Default",
  "admin.testCatalog.methods.column.effectiveDate": "Tanggal Efektif",
  "admin.testCatalog.methods.column.actions": "Aksi",
  "admin.testCatalog.methods.action.edit": "Sunting",
  "admin.testCatalog.methods.action.remove": "Hapus",
  "admin.testCatalog.methods.btn.linkMethod": "+ Tautkan Metode",
  "admin.testCatalog.methods.btn.createMethod": "+ Buat Metode Baru",
  "admin.testCatalog.methods.btn.copyFromTest": "Salin dari Pemeriksaan",
  "admin.testCatalog.methods.modal.link.title": "Tautkan Metode",
  "admin.testCatalog.methods.modal.link.selectPlaceholder": "Pilih metode untuk menautkan",
  "admin.testCatalog.methods.modal.link.noAvailable": "Semua metode yang aktif sudah terhubung",
  "admin.testCatalog.methods.inline.nameEnglish": "Nama Metode (Bahasa Inggris)",
  "admin.testCatalog.methods.inline.nameFrench": "Nama Metode (Bahasa Prancis)",
  "admin.testCatalog.methods.inline.code": "Kode pendek",
  "admin.testCatalog.methods.inline.codeHint": "3–10 karakter alfanumerik huruf besar, tanpa spasi",
  "admin.testCatalog.methods.inline.createAndLink": "Buat & Tautkan",
  "admin.testCatalog.methods.copyFromTest.label": "Salin metode dari pemeriksaan",
  "admin.testCatalog.methods.copyFromTest.placeholder": "Pilih pemeriksaan",
  "admin.testCatalog.methods.effectiveDate.label": "Tanggal Efektif",
  "admin.testCatalog.methods.default.label": "Tetapkan sebagai default",
  "admin.testCatalog.methods.error.duplicateLink": "Metode ini sudah dihubungkan dengan pemeriksaan tersebut",
  "admin.testCatalog.methods.error.codeFormat": "Kode harus terdiri dari 3–10 karakter alfanumerik huruf besar tanpa spasi",
  "admin.testCatalog.methods.error.effectiveDateRequired": "Tanggal Efektif wajib diisi",
  "admin.testCatalog.methods.error.duplicateCode": "Metode dengan kode ini sudah ada. Masukkan kode yang berbeda.",
  "admin.testCatalog.methods.error.duplicateName": "Metode dengan nama ini sudah ada. Gunakan nama lain, atau tautkan metode yang sudah ada.",
  "admin.testCatalog.methods.error.invalidRequest": "Permintaan ditolak. Periksa bidang lalu coba lagi.",
  "admin.testCatalog.methods.error.server": "Server tidak dapat menyelesaikan permintaan. Coba lagi.",
  "admin.testCatalog.methods.error.removeFailed": "Metode tidak dapat dihapus. Metode masih tertaut; coba lagi.",
  "admin.testCatalog.methods.linked": "Metode ditautkan.",
  "admin.testCatalog.methods.created": "Metode dibuat dan ditautkan.",
  "admin.testCatalog.methods.copied": "Dari {source}: {count, plural, one {# metode} other {# metode}} disalin.",
  "admin.testCatalog.methods.copyNothing": "Tidak ada metode yang disalin: {source} tidak memiliki metode yang belum ditautkan ke pemeriksaan ini.",
  "admin.testCatalog.methods.empty": "Tidak ada metode yang ditautkan. Gunakan '+ Tautkan Metode' atau '+ Buat Metode Baru' untuk menambahkannya.",
  "testnotification.bcc": "BCC",
  "testnotification.instructionis.variables.body": "[testName] : Nama pemeriksaan",
  "testnotification.instructionis.variables.body.0": "[testResult] : Hasil pemeriksaan",
  "testnotification.instructionis.variables.header": "Daftar variabel:",
  "testnotification.instructions.body": "Saat notifikasi dibuat, sistem akan memeriksa dahulu apakah template pesan telah ditentukan untuk penerima/tipe pesan tersebut.",
  "testnotification.instructions.body.0": "Jika tidak ada, maka akan menggunakan pesan default pemeriksaan.",
  "testnotification.instructions.body.1": "Jika tidak ada, maka akan menggunakan pesan default sistem.",
  "testnotification.instructions.body.2": "Variabel akan digantikan oleh nilai yang sesuai di dalam isi pesan dan subjek.",
  "testnotification.instructions.body.3": "Variabel harus selalu menyertakan tanda kurung siku dan tidak boleh mengandung spasi.",
  "testnotification.instructions.header": "Petunjuk:",
  "testnotification.messagetemplate": "Pesan",
  "testnotification.options": "Pesan Pribadi",
  "testnotification.patient.email": "Email Pasien",
  "testnotification.patient.sms": "SMS Pasien",
  "testnotification.patiententry.header": "Pelaporan Hasil",
  "testnotification.patiententry.info": "Jika sistem tidak dapat terhubung ke penerima, maka hasilnya akan dimasukkan ke dalam antrian. Antrian yang banyak dan menumpuk adalah tanda bahwa perlu dilakukan pemecahan masalah, misalnya menghubungi pihak penerima.",
  "testnotification.provider.email": "Email Penyelenggara",
  "testnotification.provider.sms": "SMS Penyelenggara",
  "testnotification.subjecttemplate": "Subjek",
  "testnotification.systemdefault.template": "Pesan Default Sistem",
  "testnotification.testdefault.editIcon": "Edit Notifikasi Pemeriksaan",
  "testnotification.testdefault.template": "Pesan Default untuk Pemeriksaan",
  "testnotificationconfig.browse.title": "Konfigurasi Notifikasi Pemeriksaan",
  "tests.not.assigned": "Pemeriksaan tidak ditugaskan",
  "testsection.testSectionName": "Nama Bagian Pemeriksaan",
  "testUnit.existing": "Instalasi Lab Yang Ada",
  "testUnit.existing.inactive": "Instalasi Lab Inaktif. Tugaskan pemeriksaan untuk mengaktivasi.",
  "testUnit.new": "Pemeriksaan Unit Baru",
  "text.length.max": "Panjang teks tidak lebih dari 200",
  "title.notestfoundmatching": "Tidak ditemukan kecocokan pemeriksaan",
  "to.title": "Kepada",
  "tooltip.banner.menu.generic.sample.results": "Masukan hasil pemeriksaan untuk sampel generik",
  "tooltip.banner.menu.workplan.batch": "Rencana Kerja Batch",
  "total.quantity": "Kuantitas Total",
  "transaction.date": "Tanggal",
  "transaction.quantity": "Kuantitas",
  "transaction.type": "Jenis",
  "transaction.user": "Pengguna",
  "true.label": "Benar",
  "unifiedSystemUser.add.user": "Tambah Pengguna",
  "unifiedSystemUser.browser.button.add": "Tambah Pengguna Baru",
  "unifiedSystemUser.browser.search": "Cari Berdasarkan Nama Pengguna",
  "unifiedSystemUser.browser.search.placeholder": "Cari Berdasarkan Nama Pengguna...",
  "unifiedSystemUser.browser.title": "Pengelolaan Pengguna",
  "unifiedSystemUser.edit.user": "Modifikasi Pengguna",
  "unifiedSystemUser.select": "Pilih",
  "unknown.section": "Bagian Tidak Diketahui",
  "unknown.test": "Pemeriksaan Tidak Diketahui",
  "uom.browse.title": "Satuan Pengukuran",
  "uom.create.heading.confirmation": "Konfirmasi",
  "uom.existing": "Satuan Pengukuran Saat Ini",
  "uom.existing.inactive": "Satuan Pengukuran Inaktif. Tugaskan pemeriksaan pada Satuan Pengukuran untuk mengaktivasi.",
  "uom.new": "Buat Satuan Pengukuran baru",
  "uom.new.added": "Satuan Pengukuran Baru akan ditambahkan",
  "uom.notification.duplicate": "Satuan Pengukuran sudah ada",
  "uom.notification.save": "Satuan Pengukuran Baru akan disimpan.",
  "uom.uomName": "Nama Satuan Pengukuran",
  "training.installation.message": "Instalasi Pelatihan",
  "translation.edit.title": "Edit Terjemahan",
  "translation.export": "Ekspor CSV",
  "translation.export.success": "Terjemahan berhasil diekspor",
  "translation.fallback": "Alternatif (English)",
  "translation.management.description": "Lihat dan edit terjemahan untuk metadata.",
  "translation.management.title": "Pengelolaan Terjemahan",
  "translation.missing": "Hilang",
  "translation.search": "Cari terjemahan...",
  "translation.selectLocale": "Pilih Bahasa",
  "translation.showMissing": "Tampilkan Hanya yang Hilang ",
  "translation.stats.title": "Kemajuan Penterjemahan",
  "translation.stats.total": "Total entri: {count}",
  "translation.update.error": "Gagal memperbarui terjemahan",
  "translation.update.success": "Terjemahan berhasil diperbarui",
  "translation.value": "Terjemahan",
  "translation.origin": "Origin",
  "translation.origin.shipped": "Sudah dikirim",
  "translation.origin.siteOverride": "Site override",
  "translation.origin.siteValue": "Site value",
  "translation.shippedLabel": "Shipped translation: {label}",
  "translation.reset": "Reset to shipped translation",
  "translation.reset.confirm": "Replace the lab's label with the shipped translation \"{label}\"?",
  "translation.reset.confirmButton": "Atur Ulang",
  "translation.reset.success": "The label is back to the shipped translation.",
  "translation.reset.error": "The label could not be reset.",
  "localization.error.overrideBlank": "A label for a value OpenELIS ships cannot be blank. To drop the lab's label, use Reset to shipped translation.",
  "localization.error.notShipped": "Only a value OpenELIS ships has a shipped translation to return to.",
  "usage.analysisId": "Nomor Identitas Analisis",
  "usage.date": "Tanggal Digunakan",
  "usage.error.quantityPositive": "Kuantitas harus lebih dari 0",
  "usage.fefo.note": "Jumlah dikurangkan dari lot barang ini yang lolos QC dan paling awal kedaluwarsa (FEFO), yang mungkin bukan lot tempat Anda membuka ini.",
  "usage.item": "Barang",
  "usage.notes": "Catatan",
  "usage.notes.placeholder": "Tambah catatan untuk penggunaan ini",
  "usage.quantityUsed": "Kuantitas yang Digunakan",
  "usage.quantityUsed.helper": "Masukkan nomor unit yang habis",
  "usage.record.button": "Merekam Penggunaan",
  "usage.record.error": "Error saat mencatat penggunaan",
  "usage.record.success": "Penggunaan berhasil terekam",
  "usage.record.title": "Merekam Penggunaan Inventaris",
  "usage.testResultId": "Nomor Identitas Hasil Pemeriksaan (Opsional)",
  "usage.testResultId.placeholder": "Terkati ke hasil pemeriksaan untuk penelusuran",
  "user.select.instruction": "Pilih Pengguna yang ingin Dimodifikasi atau Dinonaktifkan. Anda dapat mengatur Filter, Mencari pengguna, atau Menambahkan Pengguna dengan kendali di bagian atas.",
  "validation.accept.all": "Simpan Semua Hasil",
  "validation.accept.normal": "Simpan Semua Normal",
  "validation.field.required": "Bidang ini diperlukan",
  "validation.ignore.all": "Abaikan Semua Hasil",
  "validation.label.nonconform": "= Sampel atau Pemesanan yang tidak sesuai atau Pemeriksaan telah ditolak",
  "validation.legend.qcHold": "= QC yang mencakup hasil ini gagal; ketidaksesuaiannya masih terbuka",
  "validation.qcHold.tooltip": "Pengujian kontrol untuk pemeriksaan ini di Instalasi Lab ini gagal. Tinjau ketidaksesuaian sebelum merilis hasil ini.",
  "validation.password.match": "Kata kunci harus sama",
  "validation.password.minLength": "Kata Kunci harus lebih dari 7 karakter",
  "validation.password.notSameAsOld": "Kata kunci baru tidak boleh sama dengan kata kunci lama",
  "validation.password.specialChar": "Kata kunci harus mengandung setidaknya satu karakter khusus (*$#!) dan satu huruf besar",
  "validation.no.records.display": "Tidak ada rekaman untuk ditampilkan",
  "validation.reject.all": "Ulang Semua Pemeriksaan",
  "validation.save.error": "Validasi Hasil berhasil",
  "validation.save.success": "Validasi Hasil berhasil",
  "validation.search.noresult": "Hasil tidak ditemukan untuk divalidasi",
  "validation.search.noresult.analyser": "Hasil tidak ditemukan dari :",
  "vl.arvRegimen": "Regimen ARV",
  "vl.durationOnARV": "Durasi pemberian ARV (bulan)",
  "vl.durationOnARV.placeholder": "Masukkan bulan berjalan pengobatan",
  "vl.indication": "Indikasi untuk pemeriksaan VL",
  "vl.lastVLDate": "Tanggal Hasil VL Terakhir",
  "vl.lastVLResult": "Hasil VL Terakhir (copies/mL)",
  "vl.lastVLResult.placeholder": "mis., 150",
  "vl.pregnancyStatus": "Status Kehamilan / Menyusui",
  "workplan.batch.action.activate": "Aktifkan",
  "workplan.batch.action.archive": "Arsip",
  "workplan.batch.action.complete": "Selesai",
  "workplan.batch.batches": "Batch",
  "workplan.batch.batches.empty": "Tidak ada batch ditemukan",
  "workplan.batch.column.actions": "Aksi",
  "workplan.batch.column.count": "Pemeriksaan",
  "workplan.batch.column.created": "Dibuat",
  "workplan.batch.column.method": "Metode",
  "workplan.batch.column.name": "Batch",
  "workplan.batch.column.sampleType": "Jenis sampel",
  "workplan.batch.column.status": "Status",
  "workplan.batch.column.test": "Pemeriksaan",
  "workplan.batch.column.unit": "Unit",
  "workplan.batch.create": "Buat batch ({count})",
  "workplan.batch.create.error": "Batch tidak dapat dibuat",
  "workplan.batch.create.success": "Batch dibuat",
  "workplan.batch.pending.empty": "Tidak ada pemeriksaan tertunda ditemukan",
  "workplan.batch.pendingTests": "Pemeriksaan Tertunda",
  "workplan.batch.refresh": "Segarkan",
  "workplan.batch.selectPage": "Pilih halaman",
  "workplan.batch.selectTest": "Pilih {accessionNumber}",
  "workplan.batch.status.ACTIVE": "Aktif",
  "workplan.batch.status.ARCHIVED": "Diarsipkan",
  "workplan.batch.status.COMPLETED": "Selesai",
  "workplan.batch.status.DRAFT": "Draf",
  "workplan.batch.status.error": "Status batch tidak dapat diperbarui",
  "workplan.batch.status.success": "Status batch diperbarui",
  "workplan.batch.tabs": "Tab rencana kerja batch",
  "workplan.batch.title": "Rencana Kerja Batch",
  "workplan.page.title": "Rencana Kerja {0}",
  "workplan.panel.selection.error.msg": "Ini pesan error tidak valid.",
  "workplan.panel.title": "Rencana Kerja Berdasarkan Panel",
  "workplan.panel.types": "Jenis Panel",
  "workplan.print": "Cetak Rencana Kerja",
  "workplan.priority.list": "Prioritas",
  "workplan.priority.title": "Rencana Kerja Berdasarkan Prioritas",
  "workplan.run": "Ambil Rencana Kerja",
  "workplan.test.title": "Rencana Kerja Berdasarkan Pemeriksaan",
  "workplan.test.types": "Jenis Pemeriksaan",
  "workplan.title": "Rencana Kerja",
  "workplan.unit.title": "Rencana Kerja Berdasarkan Unit",
  "workplan.unit.types": "Jenis Unit",
  "yes.option": "Ya",
  "shipment.module.title": "Pengelolaan Pengiriman",
  "shipment.breadcrumb": "Pengiriman Sampel",
  "shipment.nav.dashboard": "Dasbor",
  "shipment.nav.createBox": "Buat Boks",
  "shipment.nav.receiveBox": "Terima Boks",
  "shipment.dashboard.title": "Dasbor Pengiriman",
  "shipment.dashboard.description": "Kelola boks pengiriman dan lacak sampel yang dirujuk",
  "shipment.dashboard.tabs.shipments": "Pengiriman",
  "shipment.dashboard.tabs.unassigned": "Pemeriksaan Tidak Ditugaskan",
  "shipment.tab.boxes": "Boks Pengiriman",
  "shipment.tab.unassignedSamples": "Sampel Tidak Ditugaskan",
  "shipment.label.boxId": "ID Boks",
  "shipment.label.createdDate": "Tanggal Dibuat",
  "shipment.label.daysUnassigned": "Hari Tidak Ditugaskan",
  "shipment.label.destination": "Tujuan",
  "shipment.label.priority": "Prioritas",
  "shipment.label.referralTest": "Pemeriksaan Rujukan",
  "shipment.label.sampleCount": "Jumlah Sample",
  "shipment.label.state": "Status",
  "shipment.label.tests": "Pemeriksaan",
  "shipment.filter.state": "Filter berdasarkan Status",
  "shipment.filter.facility": "Filter berdasarkan Lembaga",
  "shipment.action.addSelected": "Tambah yang dipilih",
  "shipment.action.addToBox": "Tambah ke Boks",
  "shipment.action.cancelReferral": "Batalkan Rujukan",
  "shipment.action.confirmRejection": "Konfirmasi Penolakan",
  "shipment.action.createBox": "Buat Boks Baru",
  "shipment.action.markAsLost": "Tandai sebagai Hilang",
  "shipment.action.printManifest": "Cetak Manifest",
  "shipment.action.rejectSample": "Tolak Sampel",
  "shipment.action.saveAndMarkReady": "Simpan & Tandai Siap Dikirim",
  "shipment.action.saveBox": "Simpan Boks",
  "shipment.action.saveDraft": "Simpan sebagai Draf",
  "shipment.action.scanSample": "Pindai Sampel",
  "shipment.box.addSample": "Tambah Sampel",
  "shipment.box.addSampleDescription": "Pilih sampel untuk ditambah ke boks pengiriman ini",
  "shipment.box.addSamples": "Tambah Sampel",
  "shipment.box.details": "Detail Boks",
  "shipment.box.autoGenerate": "Membuat secara otomatis",
  "shipment.box.capacity": "Kapasitas",
  "shipment.box.capacityValue": "{capacity} sampel",
  "shipment.box.create": "Buat Boks",
  "shipment.box.createDescription": "Buat boks pengiriman baru untuk sampel yang dirujuk",
  "shipment.box.created": "Tanggal Dibuat:",
  "shipment.box.createdBy": "Dibuat Oleh:",
  "shipment.box.createdDate": "Tanggal Dibuat",
  "shipment.box.destination": "Tujuan",
  "shipment.box.downloadLabel": "Unduh Label",
  "shipment.box.downloadManifest": "Unduh Manifest",
  "shipment.box.generateLabel": "Buat Label",
  "shipment.box.generateManifest": "Buat Manifest",
  "shipment.box.id": "ID Boks:",
  "shipment.box.labelDownloaded": "Label berhasil diunduh",
  "shipment.box.labelPrefix": "Prefiks Label",
  "shipment.box.labelPrefixHelper": "Dikonfigurasi oleh administrator di Pengaturan Situs",
  "shipment.box.manifest": "Manifest",
  "shipment.box.manifestDownloaded": "Manifest berhasil diunduh",
  "shipment.box.noSamples": "Boks ini belum memiliki sampel",
  "shipment.box.noUnassignedSamples": "Tidak ada sampel yang ditugaskan untuk lembaga ini",
  "shipment.box.notes": "Catatan",
  "shipment.box.notesPlaceholder": "Masukkan instruksi atau catatan penanganan khusus...",
  "shipment.box.number": "Nomor Boks",
  "shipment.box.readyConfirmation": "Apakah Anda yakin ingin menandai boks ini sebagai siap dikirim?",
  "shipment.box.readySampleCount": "Boks ini memiliki {count} sampel",
  "shipment.box.readyToSend": "Tandai Siap Dikirim",
  "shipment.box.reconcile": "Rekonsiliasi",
  "shipment.box.removeSample": "Hapus Sampel",
  "shipment.box.removeSampleConfirmation": "Apakah Anda yakin ingin menghapus sampel ini dari boks?",
  "shipment.box.resendManifest": "Kirim Ulang Manifest",
  "shipment.box.sampleCount": "Jumlah Sampel",
  "shipment.box.sampleProgress": "{added} / {capacity} ({remaining} sisa)",
  "shipment.box.samplesAdded": "Sampel Ditambah",
  "shipment.box.samplesSelected": "{count} sampel dipilih",
  "shipment.box.scanExisting": "Pindai yang ada",
  "shipment.box.scanExistingId": "Pindai atau masukkan ID Boks yang ada",
  "shipment.box.scanExistingIdPlaceholder": "Pindai kode QR atau ketik ID boks",
  "shipment.box.sendBox": "Kirim Boks",
  "shipment.box.sendConfirmation": "Apakah Anda yakin akan mengirim boks ini?",
  "shipment.box.sendSampleCount": "Boks ini memiliki {count} sampel yang akan ditandai sebagai terkirim",
  "shipment.box.state": "Status",
  "shipment.box.summary": "Ringkasan",
  "shipment.box.temperature": "Persyaratan Suhu",
  "shipment.box.title": "Boks {boxId}",
  "shipment.box.useExistingId": "Mode ID Boks",
  "shipment.dashboard.boxNotFound": "Tidak ada boks ditemukan dengan ID \"{boxId}\". Coba dengan memfilter daftar.",
  "shipment.dashboard.scanBoxPlaceholder": "Cari atau pindai ID Boks (tekan Enter untuk navigasi)",
  "shipment.error.addSample": "Gagal menambah sampel ke boks",
  "shipment.error.assignToBox": "Gagal menugaskan sampel ke boks",
  "shipment.error.boxFull": "Boks penuh. Tidak dapat menambah sampel.",
  "shipment.error.boxNotEmpty": "Boks harus memiliki setidaknya satu sampel",
  "shipment.error.boxNotFound": "Boks tidak ditemukan",
  "shipment.error.cancelReferral": "Gagal membatalkan rujukan",
  "shipment.error.confirmReception": "Gagal mengkonfirmasi penerimaan",
  "shipment.error.createBox": "Gagal membuat boks pengiriman",
  "shipment.error.exceedsCapacity": "Tidak dapat menambah {requested} sampel. Hanya {available} slot yang tersedia.",
  "shipment.error.fetchBox": "Gagal menarik informasi boks",
  "shipment.error.fetchBoxes": "Gagal menarik boks yang tersedia",
  "shipment.error.generateLabel": "Error membuat label pengiriman",
  "shipment.error.generateManifest": "Error membuat manifest",
  "shipment.error.invalidState": "Status boks invalid untuk operasional ini",
  "shipment.error.markAsLost": "Gagal menandai sampel sebagai hilang",
  "shipment.error.markReady": "Gagal menandai boks sebagai siap dikirim",
  "shipment.error.noDestinationFacility": "Tidak ada lembaga tujuan dicantumkan untuk sampel ini",
  "shipment.error.noReferralId": "Tidak ada ID rujukan tersedia untuk sampel ini",
  "shipment.error.noSampleSelected": "Mohon pilih setidaknya satu sampel",
  "shipment.error.partialReception": "Beberapa sampel statusnya gagal diperbarui. Mohon coba lagi.",
  "shipment.error.partialSampleAdd": "Hanya {added} dari {total} sampel yang ditambahkan ke boks. Boks disimpan sebagai draf agar Anda dapat menambahkan sisanya.",
  "shipment.error.reasonRequired": "Masukkan alasan",
  "shipment.error.reconcile": "Error rekonsiliasi boks",
  "shipment.error.removeSample": "Gagal menghapus sampel dari boks",
  "shipment.error.sampleAlreadyAssigned": "Sampel ini siap ditugaskan ke boks",
  "shipment.error.sampleAlreadyInBox": "Sampel sudah di dalam boks",
  "shipment.error.sampleNotFound": "Sampel tidak ditemukan",
  "shipment.error.saveFailed": "Gagal menyimpan",
  "shipment.error.searchFailed": "Gagal mencari sampel. Mohon coba lagi.",
  "shipment.error.selectBox": "Mohon pilih boks",
  "shipment.error.sendBox": "Gagal mengirim boks",
  "shipment.filter.clear": "Hapus Filter",
  "shipment.filter.dateFrom": "Dari Tanggal",
  "shipment.filter.dateTo": "Sampai Tanggal",
  "shipment.filter.referenceLab": "Lab Rujukan",
  "shipment.label.addedDate": "Tanggal Ditambah",
  "shipment.label.position": "Posisi",
  "shipment.label.samples": "Sampel",
  "shipment.label.shippingLabel": "LABEL PENGIRIMAN",
  "shipment.manifest.generated": "Dibuat:",
  "shipment.manifest.number": "#",
  "shipment.manifest.recallExpired": "Penarikan manifest tidak tersedia lagi (sudah melebihi batas 7-hari sejak dikirim)",
  "shipment.manifest.regenerationExpired": "Pembuatan ulang manifest tidak tersedia lagi (sudah melebihi batas 24-jam sejak dikirim)",
  "shipment.manifest.serviceLocation": "Lokasi Layanan:",
  "shipment.manifest.specimenBarcodes": "Kode QR Spesimen",
  "shipment.manifest.title": "Manifest Pengiriman",
  "shipment.manifest.totalSamples": "Total Sampel",
  "shipment.modal.addToBox.existingBox": "Tambah ke boks yang ada",
  "shipment.modal.addToBox.mode": "Pilih opsi",
  "shipment.modal.addToBox.newBox": "Buat boks baru",
  "shipment.modal.addToBox.newBoxInfo.message": "Anda akan diarahkan ke pembuatan boks baru untuk sampel ini",
  "shipment.modal.addToBox.newBoxInfo.title": "Buat Boks Baru",
  "shipment.modal.addToBox.noDraftBoxes.message": "Tidak ada draf boks untuk tujuan ini. Boks baru akan dibuat.",
  "shipment.modal.addToBox.noDraftBoxes.title": "Tidak Ada Draf Boks Tersedia",
  "shipment.modal.addToBox.selectBox": "Pilih Boks",
  "shipment.modal.addToBox.title": "Tambah Sampel ke Boks",
  "shipment.modal.cancelReferral.reason": "Alasan Pembatalan",
  "shipment.modal.cancelReferral.reasonPlaceholder": "Mohon jelaskan mengapa perujukan ini dibatalkan...",
  "shipment.modal.cancelReferral.title": "Batalkan Rujukan",
  "shipment.modal.cancelReferral.warning.message": "Aksi ini akan membatalkan rujukan secara permanen dan tidak bisa dibatalkan.",
  "shipment.modal.cancelReferral.warning.title": "Peringatan",
  "shipment.modal.createBox.cancel": "Batal",
  "shipment.modal.createBox.submit": "Buat",
  "shipment.modal.createBox.title": "Buat Boks Baru",
  "shipment.modal.markAsLost.reason": "Alasan menandai sebagai hilang",
  "shipment.modal.markAsLost.reasonPlaceholder": "Jelaskan mengapa sampel ini ditandai sebagai hilang...",
  "shipment.modal.markAsLost.title": "Tandai Sampel sebagai Hilang",
  "shipment.modal.markAsLost.warning.message": "Aksi ini akan menandai sampel sebagai hilang secara permanen dan tidak bisa dibatalkan.",
  "shipment.modal.markAsLost.warning.title": "Peringatan",
  "shipment.modal.rejectSample": "Tolak Sampel",
  "shipment.modal.rejectSampleMessage": "Apakah Anda yakin ingin menolak sampel {accession}?",
  "shipment.nav.referenceLabResults": "Hasil Laboratorium Rujukan",
  "shipment.nav.reports": "Laporan",
  "shipment.nav.settings": "Pengaturan",
  "shipment.notification.boxCreated": "Boks berhasil dibuat",
  "shipment.notification.boxReadyToSend": "Boks ditandai sebagai Siap Dikirim",
  "shipment.notification.boxReconciled": "Boks berhasil direkonsiliasi",
  "shipment.notification.boxSent": "Boks berhasil dikirim",
  "shipment.notification.error": "Terjadi error: {message}",
  "shipment.notification.partialSamplesAdded": "Hanya {added} dari {total} sampel ditambahkan. Boks sudah mencapai kapasitasnya ({notAdded} tidak ditambahkan).",
  "shipment.notification.receptionComplete": "Paket berhasil diterima",
  "shipment.notification.referralCancelled": "Perujukan berhasil dibatalkan",
  "shipment.notification.sampleAdded": "Sampel {accessionNumber} ditambah dengan {testCount, plural, one {# test} other {# tests}}",
  "shipment.notification.sampleAssignedToBox": "Sampel berhasil ditugaskan ke boks",
  "shipment.notification.sampleMarkedAsLost": "Sampel ditandai sebagai hilang",
  "shipment.notification.sampleRejected": "Sampel {accession} ditolak: {reason}",
  "shipment.notification.sampleRemoved": "Sampel dihapus dari boks",
  "shipment.notification.samplesAdded": "{count, plural, other {# sampel ditambah ke boks}}",
  "shipment.notification.samplesRemovedDueToCapacity": "{removed} sampel dihapus karena pengurangan kapasitas.",
  "shipment.reception.acceptSample": "Terima Sampel",
  "shipment.reception.applyToAll": "Terapkan status ke semua...",
  "shipment.reception.awaitingAcceptance": "Menunggu penerimaan",
  "shipment.reception.confirmMessage": "Konfirmasi penerimaan untuk {count} sampel?",
  "shipment.reception.confirmReception": "Konfirmasi Penerimaan",
  "shipment.reception.damaged": "Rusak",
  "shipment.reception.description": "Pindai kode QR boks untuk menerima dan memverifikasi sampel",
  "shipment.reception.enterBoxId": "SIlahkan masukan ID boks",
  "shipment.reception.generalNotes": "Catatan Umum",
  "shipment.reception.generalNotesPlaceholder": "Masukkan catatan umum penerimaan ",
  "shipment.reception.importError": "Error mengimpor pengiriman dari remote server",
  "shipment.reception.importFromFhir": "Impor dari FHIR",
  "shipment.reception.importResult": "{count, plural, =0 {No new shipments found} one {1 shipment imported} other {{count} shipments imported}}",
  "shipment.reception.incomingBoxes": "Pengiriman yang Akan Diterima",
  "shipment.reception.leaked": "Bocor",
  "shipment.reception.markAllMissing": "Tandai Semua Hilang",
  "shipment.reception.markAllReceived": "Tandai Semua Diterima",
  "shipment.reception.missing": "Hilang",
  "shipment.reception.noIncomingBoxes": "Tidak ada pengiriman yang masuk. Klik 'Impor dari FHIR' untuk memeriksa apakah ada pengiriman baru.",
  "shipment.reception.notes": "Catatan",
  "shipment.reception.notesPlaceholder": "Masukkan catatan bila diperlukan",
  "shipment.reception.notesRequired": "Catatan wajib ada untuk sampel yang diterima tidak dalam kondisi baik",
  "shipment.reception.notesRequiredPlaceholder": "Wajib: jelaskan masalah",
  "shipment.reception.openBox": "Buka",
  "shipment.reception.originFacility": "Dari",
  "shipment.reception.pending": "Tertunda",
  "shipment.reception.pendingAcceptance": "Spesimen yang Menunggu Penerimaan",
  "shipment.reception.received": "Diterima",
  "shipment.reception.referralOrder": "Pemesanan Rujukan",
  "shipment.reception.rejected": "Ditolak",
  "shipment.reception.sampleCountSummary": "{accepted} diterima / {expected} diharapkan",
  "shipment.reception.sampleNotFound": "Sampel {accessionNumber} tidak ditemukan di boks ini",
  "shipment.reception.sampleScanned": "Sampel {accessionNumber} diperiksa saat diterima",
  "shipment.reception.sampleVerification": "Verifikasi Sampel",
  "shipment.reception.scanBox": "ID Boks / Kode QR",
  "shipment.reception.scanBoxPlaceholder": "Pindai atau masukkan kode QR boks",
  "shipment.reception.scanButton": "Pindai Boks",
  "shipment.reception.scanSample": "Pindai Sampel ID",
  "shipment.reception.scanSampleButton": "Sampel Check In",
  "shipment.reception.scanSamplePlaceholder": "Pindai atau ketik nomor registrasi sampel",
  "shipment.reception.shipped": "Sudah dikirim",
  "shipment.reception.specimen": "Spesimen",
  "shipment.reception.status": "Status Penerimaan",
  "shipment.reception.title": "Terima Paket",
  "shipment.reception.unresolved": "Tidak ada pemesanan yang cocok",
  "shipment.rejection.damaged": "Rusak",
  "shipment.rejection.expired": "Kedaluwarsa",
  "shipment.rejection.insufficientVolume": "Volume tidak cukup",
  "shipment.rejection.other": "Lainnya",
  "shipment.rejection.reason": "Alasan Penolakan",
  "shipment.rejection.wrongType": "Jenis Sampel Salah",
  "shipment.report.contents": "Isi",
  "shipment.report.description": "Buat dan ekspor laporan pengiriman berdasarkan boks, tanggal, tujuan, atau lab rujukan",
  "shipment.report.export.excel": "Ekspor Excel",
  "shipment.report.export.pdf": "Ekspor PDF",
  "shipment.report.generate": "Buat Laporan",
  "shipment.report.noResults": "Tidak ada rekaman pengiriman ditemukan dengan filter ini.",
  "shipment.report.receivedDate": "Tanggal Diterima",
  "shipment.report.receivedStatus": "Status Penerimaan",
  "shipment.report.receiver": "Penerima",
  "shipment.report.receivingUser": "Pengguna Yang Menerima",
  "shipment.report.sender": "Pengirim",
  "shipment.report.sentDate": "Tanggal Dikirim",
  "shipment.report.title": "Laporan Pengiriman",
  "shipment.report.totalBoxes": "Total Boks",
  "shipment.report.totalSamples": "Total Sampel",
  "shipment.sample.accessionNumber": "Nomor Registrasi",
  "shipment.sample.multipleMatches": "Ada beberapa sampel yang cocok — pilih mana yang akan ditambahkan",
  "shipment.sample.remove": "Hapus",
  "shipment.sample.search": "Cari sampel berdasarkan nomor registrasi",
  "shipment.sample.searchPlaceholder": "Pindai atau masukkan nomor registrasi",
  "shipment.sample.status": "Status",
  "shipment.sample.type": "Jenis Sampel",
  "shipment.settings.administration": "Administrasi",
  "shipment.settings.boxLabelSection": "Konfigurasi Label Boks",
  "shipment.settings.description": "Konfigurasi pengaturan modul pengiriman",
  "shipment.settings.fhirConfig": "Opsi Pemetaan FHIR",
  "shipment.settings.fhirConfigDesc": "Konfigurasi pemetaan SupplyDelivery dan jenis wadah spesimen untuk interoperabilitas FHIR",
  "shipment.settings.fhirConfigNote": "Pemetaan FHIR dikonfigurasi melalui properti aplikasi. Kontak admin sistem untuk melakukan perubahan.",
  "shipment.settings.fhirConfigSaveError": "Gagal menyimpan konfigurasi pemetaan FHIR",
  "shipment.settings.fhirConfigSaved": "Konfigurasi pemetaan FHIR disimpan",
  "shipment.settings.fhirContainerType": "Jenis Wadah Spesimen (SNOMED CT)",
  "shipment.settings.fhirDisplayName": "Nama di Tampilan",
  "shipment.settings.fhirNonConformity": "Kode Ketidaksesuaian (SNOMED CT)",
  "shipment.settings.fhirSnomedCode": "Kode SNOMED CT",
  "shipment.settings.manageFacilities": "Kelola Registri Lembaga",
  "shipment.settings.manageFacilitiesDesc": "Tambah, edit, atau hapus tujuan laboratorium rujukan",
  "shipment.settings.manageUsers": "Kelola Pengguna",
  "shipment.settings.manageUsersDesc": "Konfigurasi akun dan peran pengguna untuk modul pengiriman",
  "shipment.settings.prefixHelperText": "Prefiks yang digunakan saat membuat ID boks baru (mis. BOX, SHIP, LAB)",
  "shipment.settings.prefixPlaceholder": "BOKS",
  "shipment.settings.prefixPreview": "Pratinjau: {preview}",
  "shipment.settings.prefixRequired": "Prefiks label boks wajib ada",
  "shipment.settings.prefixSaveError": "Error saat menyimpan prefiks label boks",
  "shipment.settings.prefixSaved": "Prefiks label boks berhasil disimpan",
  "shipment.settings.siteOrgDescription": "Pilih organisasi yang mewakili laboratorium ini. Hanya pengiriman dengan tujuan laboratorium ini yang akan diimpor ke server FHIR remote.",
  "shipment.settings.siteOrgLabel": "Laboratorium Ini",
  "shipment.settings.siteOrgSaveError": "Error menyimpan pengaturan tempat",
  "workflow.clinical": "Klinis",
  "workflow.environmental": "Lingkungan / Lainnya",
  "provider.name": "Nama Penyelenggara",
  "provider.name.placeholder": "Masukkan nama penyelenggara",
  "provider.phone": "Telepon Penyelenggara",
  "provider.search.helper": "Masukkan nama atau nomor telepon penyelenggara dan tekan Cari.",
  "site.search": "Cari Tempat",
  "site.name": "Nama Tempat",
  "site.name.placeholder": "Masukkan nama tempat",
  "site.location": "Lokasi",
  "site.type": "Jenis",
  "site.department": "Departemen / Ruang / Unit",
  "site.department.selectFirst": "Pilih lembaga terlebih dahulu..",
  "site.department.choose": "Pilih departemen...",
  "site.department.none": "Tidak ada subunit tersedia",
  "sample.filterByLabUnit": "Filter berdasarkan Instalasi Lab",
  "sample.allLabUnits": "Semua Instalasi Lab",
  "sample.orderPanels": "Panel Pemesanan",
  "sample.orderTests": "Pemesanan Pemeriksaan",
  "sample.referToReferenceLab": "Rujuk pemeriksaan ke lab rujukan",
  "sample.optional.info": "Pemilihan sampel dan pemeriksaan opsional pada tahap ini. Jenis pemeriksaan dan sampel dapat dispesifikasi nanti saat pengambilan.",
  "panel.search.placeholder": "Pilih Panel yang Tersedia",
  "test.search.placeholder": "Pilih Pemeriksaan yang tersedia",
  "test.timeHolding": "Waktu Penahanan Maksimum sesuai SOP (menit)",
  "select.regimen": "Pilih Regimen...",
  "select": "Pilih...",
  "generating": "Membuat...",
  "label.order": "Label Pemesanan",
  "label.sample": "Label Sampel",
  "label.slide": "Label Slide",
  "label.block": "Label Blok",
  "label.freezer": "Label Freezer",
  "environmental.coming.soon": "Alur Kerja Lingkungan",
  "environmental.location.info": "Bidang hirarki lokasi (Kabupaten/Kecamatan/Kelurahan-Desa) dan tangkapan GPS akan tersedia disini.",
  "env.collectionConditions.title": "Kondisi Pengambilan Default",
  "env.collectionConditions.subtitle": "Default di aplikasikan ke semua sampel di batch ini",
  "env.collectionMethod": "Metode Pengambilan",
  "env.waterTemp": "Suhu Air (°C)",
  "env.ambientTemp": "Suhu Lingkungan (°C)",
  "env.weather": "Cuaca",
  "env.preservationMethod": "Metode Pengawetan",
  "env.preservationMethod.placeholder": "mis., asidifikasi HNO3, pendinginan 4°C",
  "env.fieldNotes": "Catatan Lapangan",
  "env.fieldNotes.placeholder": "Masukkan pengamatan lapangan...",
  "env.sample.manifest.title": "Manifes Pra-Pengambilan Sampel",
  "env.sample.manifest.subtitle": "satu baris = satu sampel fisik",
  "env.sample.container": "Wadah",
  "env.sample.gpsLat": "Lintang GPS",
  "env.sample.gpsLat.placeholder": "mis. -6.2088",
  "env.sample.gpsLng": "GPS Lng",
  "env.sample.gpsLng.placeholder": "mis. 106.8456",
  "env.sample.samplingSite": "Tempat Pengambilan Sampel",
  "env.sample.useOrderSite": "Gunakan tempat pemesanan {site}",
  "order.microPreview.site": "Tempat: {site}",
  "env.sample.locationDetails": "Rincian Lokasi",
  "env.sample.locationDetails.placeholder": "mis., Keran, Sungai...",
  "env.sample.collected": "Diambil",
  "env.sample.duplicate": "Duplikasi sampel",
  "env.sample.addRow": "+ Tambah baris sampel",
  "env.sample.total": "Total: {count} {count, plural, one {sample} other {samples}} di batch ini",
  "env.sample.testsAndPanels": "Pengujian & Panel",
  "env.sample.tests.required": "wajib",
  "env.complianceStandards.title": "Baku Mutu Tersedia",
  "env.complianceStandards.subtitle": "Pilih standar peraturan untuk pemesanan ini",
  "env.complianceStandards.label": "Baku Mutu",
  "env.complianceStandards.placeholder": "Pilih standar...",
  "env.complianceStandards.empty": "Tidak ada konfigurasi baku mutu aktif. Tambah baku mutu di Administrasi → Baku Mutu.",
  "order.dashboard.samplingSite": "Tempat Pengambilan Sampel",
  "order.search.placeholder.env": "Cari berdasarkan nama tempat atau nomor lab...",
  "order.filter.dateFrom": "Dari",
  "order.filter.dateTo": "Kepada",
  "program.placeholder": "Ketik untuk memfilter atau memilih dari daftar",
  "program.helper": "Ketik untuk memfilter atau memilih dari daftar. Memilih program akan menampilkan bidang Informasi Pesanan Tambahan khusus program tersebut di bawah ini.",
  "patient.externalSearch": "Pencarian Eksternal",
  "patient.results": "Hasil Pasien",
  "patient.id.helper": "Masukkan nomor subyek, NIK, atau nomor ST.",
  "patient.id.placeholder": "Masukkan Identitas Pasien",
  "patient.lastName.placeholder": "Masukkan Nama Belakang Pasien",
  "patient.firstName.placeholder": "Masukkan Nama Depan Pasien",
  "patient.natId": "Nomor Pengidentifikasi Kesehatan Unik",
  "patient.dataSource": "Sumber Data",
  "patient.noResults": "0-0 dari 0 item",
  "patient.new.info": "Masukkan informasi pasien di bawah ini. Pasien akan dibuat saat pemesanan disimpan.",
  "pagination.showing": "Menunjukkan {start}-{end} dari {total} pemeriksaan",
  "results.found.for": "hasil ditemukan untuk \"{term}\"",
  "selected": "Dipilih",
  "shipment.settings.siteOrgSaved": "Pengorganisasian situs disimpan (FHIR UUID: {uuid})",
  "shipment.settings.siteOrgSection": "Organisasi Situs (FHIR)",
  "shipment.settings.title": "Pengaturan Pengiriman",
  "shipment.state.cancelled": "Dibatalkan",
  "shipment.state.draft": "Draf",
  "shipment.state.inTransit": "Dalam Transit",
  "shipment.state.lostInTransit": "Hilang Dalam Transit",
  "shipment.state.partiallyReceived": "Parsial DIterima",
  "shipment.state.readyToSend": "Siap Dikirim",
  "shipment.state.received": "Diterima",
  "shipment.state.reconciled": "Direkonsiliasi",
  "shipment.state.sent": "Terkirim",
  "shipment.stats.delivered": "Sudah Diantar",
  "shipment.stats.inTransit": "Dalam Transit",
  "shipment.stats.reconciled": "Direkonsiliasi",
  "shipment.stats.totalSamples": "Total Sampel",
  "shipment.temperature.ambient": "Ambient (Suhu Ruangan)",
  "shipment.temperature.deepFrozen": "Beku Sangat Dalam (-80°C)",
  "shipment.temperature.dryIce": "Es Kering",
  "shipment.temperature.frozen": "Beku (-20°C)",
  "shipment.temperature.refrigerated": "Didinginkan (2–8 °C)",
  "shipment.validation.addSample": "Tambah setidaknya satu sampel",
  "shipment.validation.selectDestination": "Pilih lembaga tujuan",
  "qc.dashboard.title": "Dasbor Kendali Mutu",
  "qc.dashboard.lastUpdate": "Pembaruan Terakhir",
  "qc.dashboard.complianceStatus": "Status Kepatuhan",
  "qc.dashboard.compliant": "Sesuai Kepatuhan",
  "qc.dashboard.warning": "Peringatan",
  "qc.dashboard.nonCompliant": "Tidak Sesuai Kepatuhan",
  "qc.dashboard.violationsCount": "{count} pelanggaran",
  "qc.dashboard.lastResult": "Hasil Terakhir",
  "qc.dashboard.noInstruments": "Tidak ada alat dikonfigurasi",
  "qc.dashboard.subtitle": "Monitor status dan peringatan QC alat",
  "qc.dashboard.loading": "Memuat data dasbor...",
  "qc.dashboard.refresh": "Segarkan",
  "qc.dashboard.lastUpdated": "Pembaruan Terakhir",
  "qc.dashboard.export.title": "Ekspor Data QC",
  "qc.dashboard.export.selectInstrument": "Pilih alat",
  "qc.dashboard.export.dateError": "Tanggal akhir harus sama dengan atau setelah tanggal mulai.",
  "qc.dashboard.error.title": "Error",
  "qc.dashboard.error.loadFailed": "Gagal memuat data dasbor. Silahkan coba lagi.",
  "qc.dashboard.tab.instruments": "Alat",
  "qc.dashboard.tab.alerts": "Peringatan",
  "qc.dashboard.summary.inControl": "Alat Dalam Kendali",
  "qc.dashboard.summary.warningStatus": "Status Peringatan",
  "qc.dashboard.summary.outOfControl": "Diluar Kendali",
  "qc.dashboard.summary.passRate": "QC Pass Rate Secara Umum",
  "qc.dashboard.summary.ofTotal": "{percentage}% total alat",
  "qc.dashboard.instruments.title": "Status Kendali Mutu Alat",
  "qc.dashboard.instruments.subtitle": "Monitor status kepatuhan dan kinerja QC di semua alat laboratorium",
  "qc.dashboard.instruments.search": "Cari alat...",
  "qc.dashboard.instruments.col.id": "ID Alat",
  "qc.dashboard.instruments.col.name": "Nama Alat",
  "qc.dashboard.instruments.col.type": "Tipe",
  "qc.dashboard.instruments.col.location": "Lokasi",
  "qc.dashboard.instruments.col.status": "Status",
  "qc.dashboard.instruments.col.analytes": "Analit",
  "qc.dashboard.instruments.col.violations": "Pelanggaran Terkini",
  "qc.dashboard.instruments.col.lastUpdate": "Pembaruan Terakhir",
  "qc.dashboard.instruments.col.actions": "Aksi",
  "qc.dashboard.instruments.view": "Lihat",
  "qc.dashboard.instruments.status.green": "Dalam Kendali",
  "qc.dashboard.instruments.status.yellow": "Peringatan",
  "qc.dashboard.instruments.status.red": "Diluar Kendali",
  "qc.dashboard.instruments.status.notConfigured": "Tidak dikonfigurasi",
  "qc.dashboard.instruments.status.unknown": "Tidak diketahui",
  "qc.dashboard.instruments.noViolations": "Tidak ada pelanggaran",
  "qc.dashboard.instruments.empty": "Tidak ada alat ditemukan",
  "qc.dashboard.alerts.title": "Pelanggaran & Peringatan QC",
  "qc.dashboard.alerts.subtitle": "Menunjukkan pelanggaran dari {period} terakhir",
  "qc.dashboard.alerts.timePeriod": "Periode Waktu",
  "qc.dashboard.alerts.timePeriod.24h": "24 jam terakhir",
  "qc.dashboard.alerts.timePeriod.72h": "72 jam terakhir",
  "qc.dashboard.alerts.timePeriod.7d": "7 hari terakhir",
  "qc.dashboard.alerts.timePeriod.30d": "30 hari terakhir",
  "qc.dashboard.alerts.timePeriod.all": "Semua Waktu",
  "qc.dashboard.alerts.active": "Pelanggaran QC Aktif",
  "qc.dashboard.alerts.active.count": "{count} pelanggaran tidak diketahui yang memerlukan perhatian",
  "qc.dashboard.alerts.active.empty": "Tidak ada pelanggaran aktif",
  "qc.dashboard.alerts.acknowledge": "Mengetahui",
  "qc.dashboard.alerts.acknowledged": "Pelanggaran yang Diketahui",
  "qc.dashboard.alerts.acknowledged.count": "{count} pelanggaran telah diketahui",
  "qc.dashboard.alerts.acknowledged.empty": "Tidak ada pelanggaran yang diketahui",
  "qc.dashboard.alerts.col.severity": "Keparahan",
  "qc.dashboard.alerts.col.time": "Waktu",
  "qc.dashboard.alerts.col.instrument": "Alat",
  "qc.dashboard.alerts.col.analyte": "Analit",
  "qc.dashboard.alerts.col.rule": "Aturan",
  "qc.dashboard.alerts.col.acknowledgedBy": "DIketahui Oleh",
  "qc.dashboard.alerts.col.acknowledgedDate": "Tanggal Diketahui",
  "qc.dashboard.banner.title": "{count} pelanggaran QC aktif memerlukan perhatian",
  "qc.dashboard.banner.viewAll": "Lihat semua peringatan",
  "qc.violations.error.acknowledgeFailed": "Gagal mengetahui pelanggaran",
  "qc.chart.axis.date": "Tanggal/Waktu",
  "qc.chart.axis.run": "Putaran",
  "qc.chart.axis.value": "Simpangan Baku (σ)",
  "qc.instrument.notFound": "Alat tidak ditemukan",
  "qc.chart.stats.sd": "SD",
  "qc.chart.stats.cv": "CV",
  "qc.chart.stats.sigma": "Kinerja sigma",
  "qc.chart.sigma.notCalculable": "Tidak dapat dihitung, TEa belum dikonfigurasi",
  "qc.chart.sigma.bias": "Bias tidak diterapkan (tidak ada data sejawat)",
  "qc.chart.sigma.WORLD_CLASS": "Kelas dunia",
  "qc.chart.sigma.ACCEPTABLE": "Dapat diterima",
  "qc.chart.sigma.MARGINAL": "Marginal",
  "qc.chart.sigma.POOR": "Buruk",
  "qc.chart.title": "Grafik Kendali Mutu",
  "qc.chart.loading": "Memuat grafik kontrol…",
  "qc.chart.error.title": "Tidak dapat memuat grafik kontrol",
  "qc.chart.tabs.label": "Level grafik kontrol",
  "qc.chart.filter.allLevels": "Semua level",
  "qc.chart.filter.selectLot": "Pilih lot",
  "qc.chart.action.zoomIn": "Perbesar",
  "qc.chart.action.zoomOut": "Perkecil",
  "qc.chart.action.zoomReset": "Atur ulang zoom",
  "qc.chart.legend.normal": "Normal",
  "qc.chart.legend.violation": "Pelanggaran",
  "qc.chart.mean": "Rata-rata",
  "qc.chart.noData": "Tidak ada data QC tersedia",
  "qc.chart.tooltip.date": "Tanggal",
  "qc.chart.tooltip.value": "Nilai",
  "qc.chart.tooltip.violations": "Pelanggaran",
  "qc.chart.tooltip.zScore": "Skor Z",
  "qc.charts.title": "Control Charts",
  "qc.charts.leveyJennings": "Bagan Levey-Jennings",
  "qc.charts.dateRange": "Rentang Tanggal",
  "qc.charts.controlLevel": "Level Kontrol",
  "qc.charts.export": "Ekspor grafik",
  "qc.charts.noData": "Tidak ada data QC tersedia",
  "qc.violations.title": "Pelanggaran QC",
  "qc.violations.severity": "Keparahan",
  "qc.violations.rule": "Aturan",
  "qc.violations.date": "Tanggal",
  "qc.violations.status": "Status",
  "qc.violations.unresolved": "Belum diatasi",
  "qc.violations.resolved": "Sudah diatasi",
  "qc.violations.acknowledged": "Sudah diketahui",
  "qc.correctiveActions.title": "Tindakan Perbaikan",
  "qc.correctiveActions.create": "Buat Tindakan Perbaikan",
  "qc.correctiveActions.type": "Jenis Tindakan",
  "qc.correctiveActions.description": "Deskripsi",
  "qc.correctiveActions.assignedTo": "Ditugaskan Ke",
  "qc.correctiveActions.status": "Status",
  "qc.correctiveActions.pending": "Tertunda",
  "qc.correctiveActions.inProgress": "Dalam Pengerjaan",
  "qc.correctiveActions.completed": "Selesai",
  "qc.correctiveActions.resolutionNotes": "Catatan Pemecahan Masalah",
  "qc.alerts.title": "Peringatan QC",
  "qc.alerts.markAsRead": "Tandai sebagai Sudah Dibaca",
  "qc.alerts.viewDetails": "Lihat Rincian",
  "qc.rules.title": "Konfigurasi Aturan Westgard",
  "qc.rules.enable": "Aktifkan",
  "qc.rules.disable": "Nonaktifkan",
  "qc.rules.preset": "Pengaturan Ulang Konfigurasi ",
  "qc.rules.basic": "Dasar",
  "qc.rules.standard": "Standar",
  "qc.rules.comprehensive": "Komprehensif",
  "qc.rules.1₂ₛ.description": "Satu kontrol melebihi ±2SD",
  "qc.rules.1₃ₛ.description": "Satu kontrol melebihi ±3SD",
  "qc.rules.2₂ₛ.description": "Dua kontrol berurutan melebihi ±2SD ke arah yang sama",
  "qc.rules.R₄ₛ.description": "Rentang antara dua kontrol melebihi 4SD",
  "qc.rules.4₁ₛ.description": "Empat kontrol berurutan melebihi ±1SD ke arah yang sama",
  "qc.rules.10ₓ.description": "Sepuluh kontrol berurutan berada di sisi mean yang sama",
  "qc.rules.3₁ₛ.description": "Tiga kontrol berurutan melebihi ±1SD ke arah yang sama",
  "qc.rules.7ₜ.description": "Tujuh kontrol berurutan cenderung ke arah yang sama",
  "qc.ruleConfig.title": "Konfigurasi Aturan",
  "qc.ruleConfig.subtitle": "Konfigurasi Westgard rule per kombinasi alat dan pemeriksaan",
  "qc.ruleConfig.field.analyzer": "Alat",
  "qc.ruleConfig.field.selectAnalyzer": "Pilih alat",
  "qc.ruleConfig.field.test": "Pemeriksaan",
  "qc.ruleConfig.field.selectTest": "Pilih pemeriksaan",
  "qc.ruleConfig.field.severity": "Keparahan",
  "qc.ruleConfig.severity.warning": "Peringatan",
  "qc.ruleConfig.severity.rejection": "Penolakan",
  "qc.ruleConfig.category.rejection": "Aturan Penolakan",
  "qc.ruleConfig.category.warning": "Aturan Peringatan",
  "qc.ruleConfig.action.reset": "Atur Ulang ke Default",
  "qc.ruleConfig.loading": "Memuat konfigurasi aturan...",
  "qc.ruleConfig.prompt.selectAnalyzerTest": "Pilih alat dan pemeriksaan untuk mengkonfigurasi Westgard rules.",
  "qc.ruleConfig.error.title": "Error",
  "qc.ruleConfig.error.selectAnalyzerTest": "Silahkan pilih alat maupun pemeriksaan.",
  "qc.ruleConfig.error.saveFailed": "Gagal menyimpan konfigurasi aturan",
  "qc.ruleConfig.success.title": "Berhasil",
  "qc.ruleConfig.success.saved": "Konfigurasi aturan berhasil disimpan.",
  "qc.ruleConfig.table.title": "Set Aturan yang Dikonfigurasi",
  "qc.ruleConfig.table.empty": "Konfigurasi aturan tidak ditemukan",
  "qc.ruleConfig.field.enabledRules": "Aktifkan Aturan",
  "qc.ruleConfig.unconfigured.title": "Pemetaan Kontrol yang Tidak Dikonfigurasi",
  "qc.ruleConfig.unconfigured.subtitle": "Lot kontrol tanpa konfigurasi aturan Westgard",
  "qc.ruleConfig.unconfigured.configure": "Konfigurasi",
  "qc.ruleConfig.unconfigured.activeLots": "Lot Aktif",
  "qc.ruleConfig.modal.title.edit": "Edit Konfigurasi Aturan",
  "qc.ruleConfig.modal.title.create": "Membuat Konfigurasi Aturan",
  "button.saving": "Menyimpan...",
  "qc.controlLots.title": "Lot Kontrol",
  "qc.controlLots.create": "Buat Lot Kontrol",
  "qc.controlLots.productName": "Nama Produk",
  "qc.controlLots.lotNumber": "Nomor Lot",
  "qc.controlLots.level": "Level Kontrol",
  "qc.controlLots.statisticsMethod": "Metode Kalkulasi Statistik",
  "qc.controlLots.initialRuns": "Putaran Awal",
  "qc.controlLots.rolling": "Jendela Bergerak",
  "qc.controlLots.manufacturerFixed": "Perbaikan Pabrik",
  "qc.controlLots.activationDate": "Tanggal Aktivasi",
  "qc.controlLots.expirationDate": "Tanggal Kedaluwarsa",
  "qc.controlLots.status.active": "Aktif",
  "qc.controlLots.status.establishment": "Percobaan",
  "qc.controlLots.status.expired": "Kedaluwarsa",
  "qc.controlLots.subtitle": "Kelola lot kontrol QC untuk evaluasi Westgard rule",
  "qc.controlLots.empty": "Tidak ada lot kontrol ditemukan",
  "qc.controlLot.filter.allStatuses": "Semua Status",
  "qc.controlLot.status.establishment": "Percobaan",
  "qc.controlLot.status.active": "Aktif",
  "qc.controlLot.status.expired": "Kedaluwarsa",
  "qc.controlLot.field.lotNumber": "Nomor Lot",
  "qc.controlLot.field.lotNumberPlaceholder": "Masukkan nomor lot",
  "qc.controlLot.field.material": "Bahan Kontrol",
  "qc.controlLot.field.materialPlaceholder": "Masukkan nama bahan",
  "qc.controlLot.field.manufacturer": "Produsen",
  "qc.controlLot.field.level": "Level Kontrol",
  "qc.controlLot.field.selectLevel": "Pilih level",
  "qc.controlLot.field.expiration": "Tanggal Kedaluwarsa",
  "qc.controlLot.field.analyzer": "Alat",
  "qc.controlLot.field.selectAnalyzer": "Pilih Alat",
  "qc.controlLot.field.analyzerHelper": "Opsional. Pilih \"Meja kerja / tanpa alat\" untuk metode manual yang dikerjakan di meja kerja tanpa alat.",
  "qc.controlLot.analyzer.bench": "Meja kerja / tanpa alat (metode manual)",
  "qc.controlLot.field.test": "Pemeriksaan",
  "qc.controlLot.field.selectTest": "Pilih Pemeriksaan",
  "qc.controlLot.field.isActive": "Status",
  "qc.controlLot.field.inactive": "Inaktif",
  "qc.controlLot.field.active": "Aktif",
  "qc.controlLot.field.status": "Status",
  "qc.controlLot.loading": "Memuat...",
  "qc.controlLot.error.title": "Error",
  "qc.controlLot.error.saveFailed": "Gagal menyimpan lot kontrol",
  "qc.controlLot.error.statsRequired": "Lot dengan nilai tetap produsen memerlukan rerata dan simpangan baku. Klik \"Konfigurasi\" untuk memasukkannya sebelum menyimpan.",
  "qc.controlLot.error.benchNeedsFixedStats": "Lot meja kerja tidak memiliki alat yang mengumpulkan putaran, sehingga harus menggunakan statistik tetap dari produsen. Klik \"Konfigurasi\" untuk memasukkan rerata dan simpangan baku, atau pilih alat untuk lot ini.",
  "qc.controlLot.new.title": "Lot Kontrol Baru",
  "qc.controlLot.viewChart": "Lihat grafik",
  "qc.controlLot.new.subtitle": "Buat lot kontrol QC baru",
  "qc.controlLot.edit.title": "Edit Lot Kontrol",
  "qc.controlLot.edit.subtitle": "Perbarui konfigurasi lot kontrol",
  "qc.controlLot.validation.lotNumberRequired": "Nomor lot wajib ada",
  "qc.controlLot.validation.materialRequired": "Bahan wajib ada",
  "qc.controlLot.validation.levelRequired": "Level kontrol wajib ada",
  "qc.controlLot.validation.expirationRequired": "Tanggal kedaluwarsa wajib ada",
  "qc.controlLot.validation.analyzerRequired": "Alat wajib ada",
  "qc.controlLot.validation.testRequired": "Pemeriksaan wajib ada",
  "qc.controlLot.level.low": "Rendah",
  "qc.controlLot.level.normal": "Normal",
  "qc.controlLot.level.high": "Tinggi",
  "qc.controlLot.statistics.title": "Konfigurasi Statistik",
  "qc.controlLot.statistics.configure": "Konfigurasi",
  "qc.controlLot.statistics.method": "Metode Kalkulasi",
  "qc.controlLot.statistics.mean": "Rata-rata",
  "qc.controlLot.statistics.sd": "Simpangan Baku",
  "qc.controlLot.statistics.config.title": "Konfigurasi Statistik",
  "qc.controlLot.statistics.config.label": "Konfigurasi metode statistik",
  "qc.controlLot.statistics.method.manufacturer_fixed": "Perbaikan Produsen",
  "qc.controlLot.statistics.method.manufacturer_fixed.description": "Gunakan nilai mean dan SD yang disediakan produsen",
  "qc.controlLot.statistics.method.rolling": "Jendela Bergerak",
  "qc.controlLot.statistics.method.rolling.description": "Hitung ulang dari hasil N terkini",
  "qc.controlLot.statistics.method.initial_runs": "Putaran Awal",
  "qc.controlLot.statistics.method.initial_runs.description": "Hitung sekali dari putaran N pertama",
  "qc.controlLot.statistics.manufacturerValues": "Nilai Produsen",
  "qc.controlLot.statistics.rollingConfig": "Konfigurasi Rolling",
  "qc.controlLot.statistics.windowSize": "Ukuran Jendela",
  "qc.controlLot.statistics.windowSize.helper": "Jumlah hasil terakhir untuk diikutkan ke kalkulasi",
  "qc.controlLot.statistics.initialRunsConfig": "Konfigurasi Run Awal",
  "qc.controlLot.statistics.initialRunsRequired": "Putaran yang Diperlukan",
  "qc.controlLot.statistics.initialRunsRequired.helper": "Jumlah putaran uji coba sebelum penghitungan statistik dilakukan",
  "qc.instrumentDetail.analytesMonitored": "Analit yang Dimonitor",
  "qc.instrumentDetail.analyte.cv": "CV: {value}%",
  "qc.instrumentDetail.analyte.violations": "{count, plural, other {# pelanggaran}}",
  "qc.instrumentDetail.tab.activityTimeline": "Timeline Kegiatan",
  "qc.instrumentDetail.tab.controlChart": "Control Charts",
  "qc.instrumentDetail.timeline.empty": "Tidak ada peringatan atau tindakan korektif direkam pada periode waktu yang dipilih",
  "qc.instrumentDetail.timeline.violation": "Pelanggaran",
  "qc.instrumentDetail.timeline.correctiveAction": "Tindakan Perbaikan",
  "qc.instrumentDetail.timeline.loading": "Memuat timeline kegiatan...",
  "qc.instrumentDetail.chart.selectAnalyte": "Pilih Analit",
  "qc.instrumentDetail.chart.loading": "Memuat control chart...",
  "qc.instrumentDetail.chart.noData": "Tidak ada data QC tersedia untuk analit ini.",
  "qc.instrumentDetail.chart.activeRules": "Aturan QC Aktif",
  "qc.instrumentDetail.chart.noRules": "Tidak ada aturan aktif yang dikonfigurasi",
  "qc.instrumentDetail.chart.stats.cv": "CV%",
  "qc.instrumentDetail.chart.stats.mean": "Rata-rata (x̄)",
  "qc.instrumentDetail.chart.stats.n": "N",
  "qc.instrumentDetail.chart.stats.sd": "Simpangan Baku (s)",
  "qc.instrumentDetail.error.loadFailed": "Gagal memuat rincian alat",
  "qc.instrumentDetail.notConfigured.title": "QC operasional tidak dikonfigurasi",
  "qc.instrumentDetail.notConfigured.description": "Tidak ada lot kontrol aktif atau hasil QC yang terhubung dengan alat ini.",
  "question.text.required": "Teks pertanyaan wajib ada",
  "compliance.legend.limitTypes": "JENIS BATAS:",
  "compliance.limitType.borderlineShort": "Garis Ambang ⚑",
  "compliance.limitType.descriptiveShort": "Kualitatif",
  "compliance.limitType.MAXIMUM": "Batas Atas ≤",
  "compliance.limitType.MINIMUM": "Batas Bawah ≥",
  "compliance.limitType.RANGE": "Rentang Normal",
  "compliance.limitType.BORDERLINE": "Garis Ambang 🚩",
  "compliance.limitType.DESCRIPTIVE": "Kualitatif",
  "compliance.limitType.EXACT": "Pasti",
  "compliance.limitType.SELECT_MAP": "Pemetaan Nilai",
  "compliance.status.ACTIVE": "Aktif",
  "compliance.status.DRAFT": "Draf",
  "compliance.status.SUPERSEDED": "Digantikan",
  "compliance.status.ARCHIVED": "Diarsipkan",
  "compliance.standard.placeholder.name": "mis., PP No. 22/2021 — Kualitas Air",
  "compliance.standard.placeholder.issuingBody": "mis., Pemerintah RI",
  "compliance.standard.placeholder.regulationNumber": "mis., PP 22/2021",
  "compliance.standard.placeholder.version": "mis., 2021",
  "compliance.standard.placeholder.countryRegion": "mis., Indonesia",
  "compliance.standard.placeholder.description": "Opsional. Deskripsi lengkap ruang lingkup standar",
  "compliance.standard.placeholder.date": "yyyy-mm-dd",
  "compliance.threshold.placeholder.lower": "Bawah / Min",
  "compliance.threshold.placeholder.upper": "Atas / Max",
  "compliance.threshold.placeholder.unit": "Unit",
  "compliance.standard.archive": "Arsip",
  "compliance.standard.archiveHeading": "Arsipkan Baku Mutu",
  "compliance.standard.archivePrompt": "Apakah standar ini mau diarsipkan? Hasil yang sudah dievaluasi akan tetap ada untuk audit, tapi standar akan disembunyikan dari daftar aktif. Aksi ini dapat di batalkan dengan mengedit status standar kembali ke Aktif.",
  "compliance.standard.archived": "Baku Mutu Diarsipkan",
  "compliance.standard.archiveError": "Tidak dapat mengarsipkan baku mutu ini.",
  "button.complianceStandard.copy": "Salin Standar",
  "compliance.standard.copied": "Baku Mutu disalin sebagai Draf baru.",
  "compliance.standard.copyError": "Tidak dapat menyalin standar ini",
  "compliance.standard.viewLinkedTests": "Lihat Pengujian Terkait",
  "compliance.testEditor.groupBy": "Digrupkan berdasar",
  "compliance.testEditor.section.configuration": "Konfigurasi",
  "compliance.testEditor.section.organization": "Organisasi",
  "compliance.testEditor.section.resources": "Sumber daya",
  "compliance.testEditor.section.automation": "Otomatisasi",
  "compliance.testEditor.section.compliance": "Kepatuhan",
  "compliance.testEditor.tab.compliance": "Kepatuhan",
  "compliance.testEditor.tabPlaceholder": "Segera datang dengan Editor Pengujian — saat ini dapat dikelola di halaman Modifikasi Pengujian.",
  "compliance.parameterGroup.editBtn": "Edit",
  "compliance.parameterGroup.moveUp": "Geser ke atas",
  "compliance.parameterGroup.moveDown": "Geser ke bawah",
  "compliance.parameterGroup.updateError": "Tidak dapat memperbarui grup parameter.",
  "compliance.testEditor.standardInactiveBanner": "Pengujian ini memiliki ambang batas terkait dengan {name} yang sekarang {status}. Hasil tidak lagi dievaluasi terhadap standar ini.",
  "compliance.standard.viewLinkedTests.heading": "Pengujian terkait — {name}",
  "compliance.standard.viewLinkedTests.empty": "Tidak ada pengujian yang terkait dengan standar ini.",
  "compliance.filter.status": "Status",
  "compliance.filter.region": "Daerah",
  "compliance.filter.allStatuses": "Semua Status",
  "compliance.filter.allRegions": "Semua Daerah",
  "compliance.filter.sampleType": "Jenis Sampel",
  "compliance.filter.allSampleTypes": "Semua Jenis Sampel",
  "compliance.sampleTypes.addLabel": "Tambah jenis sampel",
  "compliance.sampleTypes.noneConfigured": "Tidak ada konfigurasi",
  "compliance.sampleTypes.noneTitle": "Belum ada konfigurasi jenis sampel.",
  "compliance.sampleTypes.noneSubtitle": "Tambahkan satu jenis sampel sebelum mengaitkan pengujian.",
  "compliance.sampleTypes.counter": "{count, plural, other {# jenis sampel dikonfigurasi}}",
  "compliance.standard.default": "Default",
  "compliance.standard.groups": "Grup",
  "compliance.standard.tests": "Pengujian",
  "compliance.standard.expiryDate": "Tanggal Kedaluwarsa",
  "compliance.parameterGroups.heading": "Grup Parameter & Pengujian Terkait",
  "compliance.parameterGroups.requireSampleTypes": "Konfigurasi bidang standar dan jenis sampel, kemudian kaitkan pengujian.",
  "compliance.button.save": "Simpan",
  "compliance.button.saving": "Menyimpan...",
  "compliance.parameterGroup.createError": "Tidak dapat menambah grup parameter.",
  "compliance.parameterGroup.deleteHeading": "Hapus Grup Parameter",
  "compliance.parameterGroup.deletePrompt": "Hapus grup parameter {name} dan semua ambang batas? Hal ini tidak dapat dibatalkan.",
  "compliance.parameterGroup.deleteWarning": "{count, plural, other {# pengujian adalah}} currently linked. All linked thresholds will be removed.",
  "compliance.threshold.saveError": "Tidak dapat menyimpan baris ini.",
  "compliance.threshold.deleteError": "Tidak dapat menghapus baris ini.",
  "compliance.validation.required": "Bidang ini diperlukan.",
  "compliance.validation.expiryAfterEffective": "Tanggal kedaluwarsa harus pada atau setelah tanggal efektif.",
  "compliance.validation.missingUpper": "Batas atas wajib ada.",
  "compliance.validation.missingLower": "Batas bawah wajib ada.",
  "compliance.validation.missingBounds": "Baik batas bawah dan atas wajib ada.",
  "compliance.validation.lowerGtUpper": "Batas bawah harus kurang dari atau sama dengan batas atas",
  "compliance.validation.missingDescriptive": "Nilai kualitatif wajib ada.",
  "compliance.linkTest.selectNoOptions": "Pengujian ini select-list tapi tidak ada opsi yang dikonfigurasi di katalog uji. Tambah opsi hasil di kelola pengujian sebelum mengaitkan ke baku mutu.",
  "compliance.linkTest.resultTypeLegend": "Jenis hasil",
  "compliance.linkTest.resultType.numeric": "Numerik (gunakan nilai batas)",
  "compliance.linkTest.resultType.select": "Select list (petakan opsi ke status)",
  "compliance.linkTest.optionsHint": "Tambah opsi hasil untuk pengujian ini (mis., 'Absent', 'Present'). Anda dapat memetakannya di status kepatuhan baku mutu di tahap selanjutnya.",
  "compliance.linkTest.optionLabel": "Nilai opsi",
  "compliance.linkTest.optionPlaceholder": "mis., Absen",
  "compliance.linkTest.optionsRequired": "Masukkan setidaknya satu opsi di atas sebelum melakukan pemetaan status.",
  "compliance.admin.title": "Administrasi Baku Mutu",
  "compliance.admin.tile.explain": "Kelola baku mutu, grup parameter, dan ambang batas pengujian (mis., PP 22/2021, WHO Air Minum).",
  "compliance.tabs.standardsAdmin": "Daftar Baku Mutu",
  "compliance.tabs.testThresholds": "Tab Kepatuhan (Editor Pengujian)",
  "compliance.testEditor.back": "Kembali",
  "compliance.testEditor.editTest": "Edit Pengujian:",
  "compliance.testEditor.loinc": "LOINC:",
  "compliance.testEditor.sampleType": "Jenis Sampel:",
  "compliance.testEditor.resultType": "Jenis Hasil:",
  "compliance.testEditor.saveTest": "Simpan Pengujian",
  "compliance.testEditor.saveDisabledHint": "Tab editor teks lainnya belum diintegrasikan dalam iterasi ini.",
  "compliance.testEditor.thresholdsHeading": "Ambang Batas Kepatuhan untuk",
  "compliance.testEditor.addThreshold": "Tambah Ambang Batas",
  "compliance.testEditor.addThresholdHeading": "Kaitkan {name} ke baku mutu",
  "compliance.testEditor.pickStandard": "Baku Mutu",
  "compliance.testEditor.pickStandardPlaceholder": "-- Pilih standar --",
  "compliance.testEditor.pickGroup": "Grup parameter",
  "compliance.testEditor.pickGroupPlaceholder": "-- Pilih grup parameter --",
  "compliance.testEditor.pickGroupHint": "Pilih standar dan grup parameter di atas untuk mengkonfigurasi ambang batas.",
  "compliance.testEditor.unlink": "Tidak kaitkan",
  "compliance.testEditor.unlinkHeading": "Tidak kaitkan ambang batas",
  "compliance.testEditor.unlinkPrompt": "Hapus ambang batas ini dari {test}? Ambang batas akan tetap ada di grup parameter standar; tapi akan dihapus dari pengujian yang terkait.",
  "compliance.testEditor.linkedBanner": "Pengujian ini terkait ke {count, plural, one {# compliance standard} other {# compliance standards}}. Ambang batas akan dievaluasi pada saat validasi.",
  "compliance.testEditor.expandRow": "Perluas baris",
  "compliance.testEditor.col.standard": "Standar",
  "compliance.testEditor.col.parameterGroup": "Grup Parameter",
  "compliance.testEditor.col.limitType": "Jenis Batas",
  "compliance.testEditor.col.thresholdRange": "Ambang batas / Rentang",
  "compliance.testEditor.col.unit": "Unit",
  "compliance.testEditor.col.effective": "Efektif",
  "compliance.testEditor.col.status": "Status",
  "compliance.testThresholds.selectHint": "Pilih pemeriksaan untuk melihat ambang kepatuhan yang saling terkait dengan berbagai standar.",
  "compliance.testThresholds.overviewHeading": "Pengujian terkait ke baku mutu",
  "compliance.testThresholds.overviewCount": "{filtered} dari {total} pengujian {total, plural, one {} other {s}}",
  "compliance.testThresholds.overviewEmpty": "Belum ada pengujian terkait ke baku mutu.",
  "compliance.testThresholds.overviewEmptyHint": "Ambang batas berbasis CSV pada tingkat grup parameter muncul di Tab 1 (Administrasi Baku Mutu), bukan di sini. Cari di atas untuk memilih pengujian dari katalog dan tautkan ke standar.",
  "compliance.testThresholds.noLinkedMatches": "Tidak ada pengujian terkait yang cocok dengan \"{q}\".",
  "compliance.testThresholds.addSection": "Tambahkan pengujian ke baku mutu",
  "compliance.testThresholds.col.test": "Pengujian",
  "compliance.testThresholds.col.code": "Kode",
  "compliance.testThresholds.col.loinc": "LOINC",
  "compliance.testThresholds.col.sampleTypes": "Jenis Sampel",
  "compliance.testThresholds.col.thresholdCount": "# Ambang Batas",
  "compliance.testThresholds.col.standardCount": "# Standar",
  "compliance.testThresholds.openEditor": "Buka",
  "compliance.testThresholds.title": "Ambang Kepatuhan Pengujian",
  "compliance.testThresholds.tile.explain": "Lihat ambang batas kepatuhan terkait ke pengujian, berdasarkan grup standar dan parameter.",
  "compliance.testThresholds.searchLabel": "Cari pengujian",
  "compliance.testThresholds.searchPlaceholder": "Filter daftar pengujian...",
  "compliance.testThresholds.test": "Pengujian",
  "compliance.testThresholds.selectPlaceholder": "-- Pilih pengujian --",
  "compliance.testThresholds.empty": "Belum ada ambang batas kepatuhan terkait dengan pengujian ini. Kilk + Tambah Ambang Batas di atas untuk mengaitkan baku mutu dengan grup parameter.",
  "compliance.testThresholds.parameter": "Parameter",
  "compliance.testThresholds.type": "Jenis Batas",
  "compliance.testThresholds.value": "Nilai",
  "compliance.testThresholds.note": "Catatan",
  "compliance.testThresholds.unknownStandard": "Standar tidak diketahui",
  "compliance.button.openAdmin": "Buka Admin Baku Mutu",
  "compliance.button.addStandard": "Tambah Standar",
  "compliance.button.saveStandard": "Simpan Standar",
  "compliance.button.linkTest": "Kaitkan Pemeriksaan ke Grup",
  "compliance.button.saveLimits": "Simpan Batas",
  "compliance.button.saveMapping": "Simpan Pemetaan",
  "compliance.search": "Cari standar",
  "compliance.search.placeholder": "Cari berdasarkan nama, badan yang menerbitkan, peraturan, negara...",
  "compliance.list.empty": "Belum ada baku mutu.",
  "compliance.standard.name": "Nama Standar",
  "compliance.standard.issuingBody": "Badan yang menerbitkan",
  "compliance.standard.regulationNumber": "Nomor Peraturan",
  "compliance.standard.version": "Versi",
  "compliance.standard.countryRegion": "Negara / Regional",
  "compliance.standard.status": "Status",
  "compliance.standard.effectiveDate": "Tanggal Efektif",
  "compliance.standard.description": "Deskripsi",
  "compliance.standard.addNew": "Tambah Baku Mutu Baru",
  "compliance.standard.edit": "Edit Baku Mutu",
  "compliance.standard.preSeeded": "Telah ditempatkan sebelumnya",
  "compliance.standard.saved": "Baku mutu disimpan.",
  "compliance.standard.saveError": "Tidak dapat menyimpan standar.",
  "compliance.standard.saveBeforeGroups": "Simpan standar sebelum menambahkan grup parameter.",
  "compliance.standard.deleted": "Baku mutu dihapus.",
  "compliance.standard.deleteError": "Tidak dapat menghapus standar (mungkin sedang diisi atau terkait dengan ambang batas).",
  "compliance.standard.deleteHeading": "Hapus Baku Mutu",
  "compliance.standard.deletePrompt": "Apakah Anda yakin mau menghapus standar ini? Standar yang tengah diisi atau terkait dengan ambang batas tidak dapat dihapus.",
  "compliance.sampleTypes.heading": "Jenis Sampel yang Dapat Diterapkan",
  "compliance.sampleTypes.explicitHint": "Sebutkan kategori jenis sampel yang dapat menerapkan standar. Pilihan ini menentukan filter pengujian saat mengatikan pengujian.",
  "compliance.sampleTypes.empty": "Belum ada jenis sample disebutkan.",
  "compliance.sampleTypes.selectPlaceholder": "Pilih jenis sampel...",
  "compliance.sampleTypes.addBtn": "Tambah Jenis Sampel",
  "compliance.sampleTypes.remove": "Hapus",
  "compliance.parameterGroups": "Grup Parameter",
  "compliance.parameterGroups.empty": "Belum ada grup parameter didefinisikan.",
  "compliance.parameterGroups.add": "Tambah Grup Parameter",
  "compliance.parameterGroup.name": "Nama grup",
  "compliance.parameterGroup.description": "Deskripsi",
  "compliance.parameterGroup.deleteBtn": "Hapus",
  "compliance.label.tests": "pengujian",
  "compliance.linkedTest.name": "Pengujian",
  "compliance.linkedTest.sampleTypes": "Jenis Sampel",
  "compliance.linkedTest.limits": "Konfigurasi Batas",
  "compliance.linkedTest.editLimits": "Edit batas",
  "compliance.linkedTest.unlink": "Hapus dari grup",
  "compliance.linkedTest.unlinkHeading": "Hapus Pengujian dari Grup",
  "compliance.linkedTest.unlinkConfirm": "Hapus",
  "compliance.linkedTest.unlinkPrompt": "Hapus pengujian dari grup? Semua definisi ambang batas untuk pengujian ini di grup ini akan dihapus.",
  "compliance.group.noTests": "Belum ada pengujian terkait dengan grup ini. Kaitkan pengujian untuk mendefinisikan ambang batas kepatuhan untuk evaluasi.",
  "compliance.linkTest.heading": "Kaitkan Pemeriksaan ke Grup",
  "compliance.linkTest.step1": "Tahap 1 — Filter berdasar Jenis Sampel",
  "compliance.linkTest.step2": "Tahap 2 — Cari & Pilih Pengujian",
  "compliance.linkTest.step3Numeric": "Tahap 3 — Konfigurasi Batas",
  "compliance.linkTest.step3Select": "Tahap 3 — Pemetaan Nilai Kepatuhan",
  "compliance.linkTest.filterByST": "Filter berdasarkan jenis sampel:",
  "compliance.linkTest.searchTest": "Cari katalog pengujian",
  "compliance.linkTest.searchPlaceholder": "Ketik untuk mencari berdasarkan nama atau kode...",
  "compliance.linkTest.noResults": "Tidak ada pengujian yang cocok.",
  "compliance.linkTest.selectListBadge": "Daftar Pilihan",
  "compliance.linkTest.clearSelection": "Hapus pilihan",
  "compliance.multiLimit.editHeading": "Konfigurasi Batas",
  "compliance.multiLimit.hint": "Mungkinkan satu atau lebih jenis batas untuk pengujian ini. Setidaknya satu jenis batas harus ada.",
  "compliance.multiLimit.type": "Jenis Batas",
  "compliance.multiLimit.lower": "Bawah",
  "compliance.multiLimit.upper": "Atas",
  "compliance.multiLimit.unit": "Unit",
  "compliance.multiLimit.note": "Catatan / Saran",
  "compliance.multiLimit.descriptive.placeholder": "mis., Tidak berbau, Absen, Jernih",
  "compliance.multiLimit.note.placeholder": "Catatan Opsional",
  "compliance.limitType.high": "Batas Atas ≤",
  "compliance.limitType.high.hint": "Tidak sesuai kepatuhan bila hasil melebihi batas atas",
  "compliance.limitType.low": "Batas Bawah ≥",
  "compliance.limitType.low.hint": "Tidak sesuai kepatuhan bila hasil di bawah batas bawah",
  "compliance.limitType.range": "Rentang Normal",
  "compliance.limitType.range.hint": "Dalam rentang kepatuhan atas–bawah",
  "compliance.limitType.borderline": "Garis ambang (Saran)",
  "compliance.limitType.borderline.hint": "Zona Saran - akan mentriger flag untuk meninjau, tidak gagal",
  "compliance.limitType.descriptive": "Kualitatif / Deskriptif",
  "compliance.limitType.descriptive.hint": "Nilai teks dievaluasi oleh analis",
  "compliance.selectMap.editHeading": "Pemetaan Kepatuhan",
  "compliance.selectMap.hint": "Petakan semua opsi hasil terhadap status kepatuhan. Opsi diambil dari katalog pengujian.",
  "compliance.selectMap.option": "Opsi Hasil",
  "compliance.selectMap.status": "Status Kepatuhan",
  "compliance.selectMap.preview": "Pratinjau",
  "compliance.selectMap.badge": "Pemetaan Nilai",
  "compliance.selectMap.optionsLabel": "opsi dipetakan",
  "compliance.selectMap.statusForOption": "Status kepatuhan untuk {option}",
  "compliance.status.compliant": "Sesuai Kepatuhan",
  "compliance.status.borderline": "Garis ambang",
  "compliance.status.nonCompliant": "Tidak Sesuai Kepatuhan",
  "compliance.status.compliantWithIcon": "Sesuai Kepatuhan ✓",
  "compliance.status.borderlineWithIcon": "Garis Ambang ⚑",
  "compliance.status.nonCompliantWithIcon": "Tidak Sesuai Kepatuhan ✗",
  "compliance.linkedTest.noLimits": "Tidak ada konfigurasi batas",
  "compliance.threshold.savedThresholds": "Ambang batas kepatuhan terkait pada pengujian.",
  "compliance.threshold.savedValueMap": "Ambang batas pemetaan nilai berhasil disimpan.",
  "compliance.threshold.savedPartialError": "Ambang batas tidak dapat disimpan. Tinjau ulang baris yang ditandai.",
  "compliance.threshold.unlinked": "Ambang batas tidak terkait dari pengujian.",
  "compliance.threshold.unlinkError": "Tidak dapat membatalkan ambang terkait.",
  "notification.title.success": "Berhasil",
  "notification.title.error": "Error",
  "sidenav.label.admin.vectorSurveillance": "Surveilans Vektor",
  "vector.admin.title": "Pengaturan Surveilans Vektor",
  "vector.admin.groups": "Grup organisme",
  "vector.admin.group.code": "Kode",
  "vector.admin.group.label": "Label",
  "vector.admin.group.colorTag": "Tag Warna",
  "vector.admin.group.description": "Deskripsi",
  "vector.admin.active": "Aktif",
  "vector.admin.system": "Sistem",
  "vector.admin.trapTypes": "Jenis Perangkap",
  "vector.admin.trapType.name": "Nama",
  "vector.admin.trapType.description": "Deskripsi",
  "vector.admin.species": "Spesies",
  "vector.admin.selectGroup": "Pilih grup di kiri untuk mengelola perangkap berdasar jenis dan spesies.",
  "vector.admin.newGroup": "Grup baru (tidak disimpan)",
  "vector.admin.newTrapType": "Jenis perangkap baru",
  "vector.admin.newSpecies": "Spesies baru",
  "vector.admin.saveGroup": "Simpan grup",
  "vector.admin.saveTrap": "Simpan perangkap",
  "vector.admin.saveSpecies": "Simpan spesies",
  "vector.admin.addGroup": "+ Tambah group",
  "vector.admin.addTrapType": "+ Tambah jenis perangkap",
  "vector.admin.addSpecies": "+ Tambah spesies",
  "vector.admin.locked": "dikunci",
  "vector.admin.systemGroup": "Grup diproteksi sistem",
  "vector.admin.systemGroup.desc": "Kode ini dikunci karena grup di gunakan pada laporan inti dan data. Anda tetap dapat mengedit label, warna, dan deskripsi.",
  "vector.admin.usedBy": "Digunakan oleh",
  "vector.admin.status": "Status",
  "vector.admin.status.active": "Aktif",
  "vector.admin.status.inactive": "Inaktif",
  "vector.admin.group": "Grup organisme",
  "vector.admin.trapType.group": "Grup organisme target",
  "vector.admin.trapType.groups": "Grup organisme",
  "vector.admin.trapType.sampleTypes": "Jenis sampel",
  "vector.admin.sampleType": "Jenis sampel",
  "vector.admin.search.groups": "Cari berdasarkan kode dan label...",
  "vector.admin.search.traps": "Cari nama perangkap atau deskripsi...",
  "vector.admin.search.species": "Cari genus atau spesies...",
  "vector.admin.samplingSites": "Tempat Pengambilan Sampel",
  "vector.admin.samplingSite.newSite": "Tempat baru",
  "vector.admin.samplingSite.allSites": "Semua Tempat",
  "vector.admin.samplingSite.code": "Kode",
  "vector.admin.samplingSite.name": "Nama Tempat",
  "vector.admin.samplingSite.type": "Jenis Tempat",
  "vector.admin.samplingSite.region": "Regional",
  "vector.admin.samplingSite.district": "Kabupaten / Kota",
  "vector.admin.samplingSite.contactName": "Kontak Person",
  "vector.admin.samplingSite.contactPhone": "Telepon Kontak",
  "vector.admin.samplingSite.gpsLatitude": "Garis Lintang GPS",
  "vector.admin.samplingSite.gpsLongitude": "Garis bujur GPS",
  "vector.admin.samplingSite.environmentalZone": "Zona Lingkungan",
  "vector.admin.samplingSite.address": "Alamat",
  "vector.admin.samplingSite.description": "Deskripsi",
  "vector.admin.samplingSite.source": "Sumber",
  "vector.admin.samplingSite.source.local": "LOKAL",
  "vector.admin.samplingSite.source.hub": "HUB",
  "vector.admin.samplingSite.lastCollection": "Pengambilan Terakhir",
  "vector.admin.samplingSite.search": "Cari berdasarkan kode, nama, regional...",
  "vector.admin.samplingSite.saveSite": "Simpan tempat",
  "vector.admin.samplingSites.registry": "Registri Tempat Pengambilan Sampel",
  "vector.admin.samplingSite.deactivate": "Nonaktifkan",
  "vector.admin.samplingSite.activate": "Aktifkan",
  "vector.admin.samplingSite.location": "Lokasi",
  "vector.admin.samplingSite.allTypes": "Semua Jenis",
  "vector.admin.samplingSite.subtype": "Subtipe",
  "vector.admin.samplingSite.subtype.placeholder": "e.g. Sungai, Sumur, BG-Sentinel, Fixed Station",
  "vector.admin.samplingSite.city": "Kota",
  "vector.admin.samplingSite.addressLocation": "Lokasi Alamat",
  "vector.admin.samplingSite.addressSearch.placeholder": "Cari lokasi untuk auto-fill dropdown...",
  "vector.admin.samplingSite.gpsCoordinates": "Koordinat GPS",
  "vector.admin.samplingSite.lastModified": "Dimodifikasi Terakhir",
  "label.noResults": "Hasil tidak ditemukan",
  "vector.admin.addSite": "+ Tempat Baru",
  "vector.order.title": "Pemesanan Vektor Baru",
  "vector.order.subtitle": "Instalasi Lab: Lab Surveilans Vektor - Domain vektor aktif",
  "vector.order.samplingSite": "Tempat Pengambilan Sampel",
  "vector.order.site.code": "Kode Tempat",
  "vector.order.site.helper": "Hanya tempat pemantauan aktif yang muncul dalam hasil. Koordinat GPS sudah terisi otomatis berdasarkan catatan tempat.",
  "vector.order.site.name": "Nama Tempat",
  "vector.order.site.placeholder": "Cari berdasarkan nama tempat atau kode...",
  "vector.order.site.type": "Jenis Tempat",
  "vector.order.specimen": "Spesimen",
  "vector.order.organism": "Hewan / Organisme",
  "vector.order.organism.hint": "Nama umum — mis., Nyamuk, Caplak, Rodensia, Agas.",
  "vector.order.organism.placeholder": "Cari organisme atau spesies...",
  "vector.order.quantity": "Kuantitas",
  "vector.order.quantity.hint": "Jumlah organisme dalam pool ini.",
  "vector.order.requester.section": "Program yang Memohon / Memesan",
  "vector.order.requester": "Pemohon",
  "vector.order.requester.placeholder": "Cari organisasi berdasarkan nama atau kode...",
  "vector.order.panels": "Panel Pemesanan",
  "vector.order.panels.search": "Pilih panel tersedia",
  "vector.order.tests": "Pemesanan Pengujian",
  "vector.order.tests.search": "Pilih Pengujian yang tersedia",
  "vector.order.collectionContext": "Konteks Pengambilan (opsional — bionomics capture)",
  "vector.order.timeOfDay": "Waktu Hari Itu",
  "vector.order.timeOfDay.dawn": "Pagi",
  "vector.order.timeOfDay.day": "Siang",
  "vector.order.timeOfDay.dusk": "Sore",
  "vector.order.timeOfDay.night": "Malam",
  "vector.order.restingContext": "Konteks Resting",
  "vector.order.restingContext.outdoor": "Di luar ruangan (eksofilik)",
  "vector.order.restingContext.indoor": "Di dalam ruangan (endofilik)",
  "vector.order.restingContext.peridomestic": "Sekitar rumah",
  "vector.order.humanBitingCatch": "Penangkapan saat menggigit manusia (Human-Biting)",
  "vector.order.humanBitingCatch.hint": "spesimen ditemukan pada manusia",
  "vector.order.collectionNotes": "Catatan Pengambilan",
  "vector.order.collectionNotes.placeholder": "Cuaca, kondisi perangkap, anomali...",
  "vector.admin.group.code.placeholder": "mis., AGAS",
  "vector.admin.group.label.placeholder": "mis., Agas",
  "vector.species.genus.placeholder": "mis., Mansonia",
  "vector.species.species.placeholder": "mis., uniformis",
  "vector.species.subspecies.placeholder": "mis., diardii",
  "vector.species.genus": "Genus",
  "vector.species.species": "Spesies",
  "vector.species.subspecies": "Subspesies",
  "vector.species.pathogensOfInterest": "Patogen yang Menarik Perhatian",
  "vector.species.lifecycleStages": "Tahap Siklus Hidup",
  "vector.species.pathogenCategory": "Kategori Patogen",
  "vector.species.lifecycleCategory": "Kategori Siklus Hidup",
  "workflow.vector": "Surveilans Vektor",
  "vector.sampleType": "Jenis Sampel",
  "vector.organismGroup": "Grup organisme",
  "vector.species": "Spesies",
  "vector.animalOrganism": "Hewan/Organisme",
  "vector.animalOrganism.add": "Tambah Hewan/Organisme",
  "vector.animalOrganism.remove": "Hapus Hewan/Organisme",
  "vector.collectedVolume": "Kuantitas dalam Pool",
  "vector.lifecycleStage": "Tahapan Siklus Hidup",
  "vector.trapCount": "Perangkap Telah Dipasang",
  "vector.trapNights": "Malam Pemasangan",
  "vector.trapType": "Jenis Perangkap",
  "vector.poolingMethod": "Metode Pooling",
  "vector.poolCount": "Jumlah Pool",
  "vector.samplesPerPool": "Spesimen per Pool",
  "vector.totalSpecimens": "Total Spesimen",
  "vector.pathogensOfInterest": "Patogen yang Menarik Perhatian",
  "vector.homogeneous": "Homogen",
  "vector.random": "Acak",
  "vector.collectionSite": "Tempat Pengambilan",
  "vector.collectionSiteName": "Nama Tempat Pengambilan",
  "vector.gpsLatitude": "Garis Lintang GPS",
  "vector.gpsLongitude": "Garis bujur GPS",
  "patient.search.merged.tag": "Menggabungkan",
  "patient.merged.banner.title": "Rekaman pasien ini telah digabungkan",
  "patient.merged.banner.subtitle": "Rekaman aktif disimpan pada Pasien {target}.",
  "patient.merged.banner.subtitle.noTarget": "Rekaman ini telah digabungkan ke pasien lain.",
  "admin.testCatalog.tabs.ariaLabel": "Tab rincian pemeriksaan",
  "admin.testCatalog.tabs.details": "Rincian",
  "admin.testCatalog.tabs.labels": "Label",
  "admin.testCatalog.labels.masterOverride.label": "Izinkan Override saat Entri Pemesanan",
  "admin.testCatalog.labels.masterOverride.on": "Nyalakan",
  "admin.testCatalog.labels.masterOverride.off": "Matikan",
  "admin.testCatalog.labels.linkedPresets.title": "Pengaturan Label Tertaut",
  "admin.testCatalog.labels.linkedPresets.empty": "Tidak ada pengaturan label yang terhubung. Gunakan menu tarik-turun di bawah ini untuk menambahkan satu.",
  "admin.testCatalog.labels.col.presetName": "Nama Pengaturan",
  "admin.testCatalog.labels.col.defaultQty": "Kuantitas Default",
  "admin.testCatalog.labels.col.maxQty": "Kuantitas Maks",
  "admin.testCatalog.labels.col.allowOverride": "Izinkan Override",
  "admin.testCatalog.labels.col.actions": "Aksi",
  "admin.testCatalog.labels.action.remove": "Hapus tautan pengaturan",
  "admin.testCatalog.labels.addPreset.label": "Tambah Jenis Label",
  "admin.testCatalog.labels.addPreset.placeholder": "Pilih Pengaturan Label",
  "admin.testCatalog.labels.preview.title": "Pratinjau Entri Pemesanan",
  "admin.testCatalog.labels.preview.col.locked": "Terkunci",
  "admin.testCatalog.labels.preview.locked": "Terkunci",
  "admin.testCatalog.labels.preview.unlocked": "Dapat diedit",
  "admin.testCatalog.labels.save.success": "Konfigurasi label disimpan.",
  "admin.testCatalog.labels.save.error": "Gagal menyimpan konfigurasi label.",
  "orderEntry.labels.orderTable.title": "Label pemesanan",
  "orderEntry.labels.sampleTable.title": "Label Sampel",
  "orderEntry.labels.col.row": "Baris",
  "orderEntry.labels.col.sample": "Sampel",
  "orderEntry.labels.col.quantity": "Kuantitas",
  "orderEntry.labels.orderRow.header": "Pemesanan",
  "orderEntry.labels.sampleRow.header": "Sampel {number}",
  "orderEntry.labels.input.sample": "Jumlah {column} sampel {number}",
  "orderEntry.labels.input.sampleNamed": "{sample} {column} quantity",
  "orderEntry.labels.source.test": "Dari pemeriksaan",
  "orderEntry.labels.source.presetDefault": "Pengaturan bawaan",
  "orderEntry.labels.source.saved": "Disimpan",
  "orderEntry.labels.locked.tooltipFor": "{label} terkunci oleh konfigurasi pemeriksaan dan tidak dapat diubah.",
  "orderEntry.labels.total": "Jumlah label: {total}",
  "orderEntry.labels.heading": "LABEL",
  "orderEntry.labels.title": "Label",
  "orderEntry.labels.printRow": "Cetak label untuk {label}",
  "orderEntry.labels.printColumn": "Cetak semua label {label}",
  "orderEntry.labels.printAll": "Cetak semua label",
  "orderEntry.labels.pendingSave": "Dicetak setelah disimpan",
  "orderEntry.labels.empty": "Tambahkan sampel di atas untuk melihat labelnya.",
  "orderEntry.labels.loadFailed": "Jumlah label tidak dapat dimuat dari pengaturan.",
  "orderEntry.labels.printFailed": "Label tidak dapat dibuat.",
  "orderEntry.labels.printFailed.detail": "Server menjawab {status}.",
  "orderEntry.labels.printFailed.unreachable": "Server tidak dapat dijangkau.",
  "orderEntry.labels.nothingToPrint": "Tidak ada label yang dikonfigurasi untuk pilihan ini.",
  "orderEntry.labels.downloaded": "Jendela cetak diblokir, sehingga label diunduh sebagai gantinya.",
  "orderEntry.labels.retry": "Ulang",
  "label.patientHistory.filterByCategory": "Saring berdasarkan kategori pemeriksaan",
  "label.patientHistory.testCategories": "Kategori pemeriksaan",
  "label.patientHistory.tree": "Pohon",
  "label.patientHistory.showTree": "Tampilkan pohon",
  "label.patientHistory.resetTree": "Atur Ulang pohon",
  "label.patientHistory.viewResults": "Lihat {count} hasil",
  "label.patientHistory.emptyState": "Tidak ada \"{displayText}\" yang dapat ditampilkan untuk pasien ini",
  "label.patientHistory.record": "Rekam {displayText}",
  "label.patientHistory.dataLoadError": "Kesalahan Pemuatan Data",
  "label.patientHistory.errorCopy": "Maaf, terjadi masalah saat menampilkan informasi ini. Anda dapat mencoba memuat ulang halaman ini, atau menghubungi administrator situs dan menyebutkan kode kesalahan di atas.",
  "label.patientHistory.backToTimeline": "Kembali ke garis waktu",
  "label.patientHistory.returnToTimeline": "Kembali ke garis waktu",
  "label.patientHistory.timeOfTest": "Waktu Pemeriksaan",
  "label.patientHistory.observations": "pengamatan",
  "label.patientHistory.range.oneDay": "1 hari",
  "label.patientHistory.range.fiveDays": "5 hari",
  "label.patientHistory.range.oneMonth": "1 bulan",
  "label.patientHistory.range.sixMonths": "6 bulan",
  "label.patientHistory.range.oneYear": "1 tahun",
  "label.patientHistory.range.fiveYears": "5 tahun",
  "label.patientHistory.range.all": "Semua",
  "label.patientHistory.date": "Tanggal",
  "address.search.no.results": "Tidak ditemukan alamat untuk '{term}'",
  "address.search.placeholder": "Cari alamat (masukkan minimal 2 karakter)...",
  "address.search.results.count": "{count} hasil ditemukan",
  "alert.error": "Error",
  "alert.warning": "Peringatan",
  "analyzer.errorDetails.noLogsAvailable": "Tidak ada log yang tersedia",
  "analyzer.fieldSelector.placeholder": "Cari dan pilih bidang...",
  "analyzer.fieldSelector.title": "Pilih Bidang OpenELIS",
  "analyzer.form.columnMappings": "Pemetaan Kolom (JSON)",
  "analyzer.form.columnMappings.helperText": "Memetakan nama kolom berkas ke nama bidang internal",
  "analyzer.form.delimiter": "Pemisah",
  "analyzer.form.fileFormat": "Format File",
  "analyzer.form.fileImport.title": "Pengaturan Impor File",
  "analyzer.form.filePattern": "Pola File",
  "analyzer.form.filePattern.helperText": "Pola Glob untuk mencocokkan file hasil",
  "analyzer.form.hasHeader": "File ini memiliki baris yang memiliki Header",
  "analyzer.form.importDirectory": "Direktori Impor",
  "analyzer.form.importDirectory.helperText": "Direktori tempat bridge memantau file hasil yang masuk",
  "analyzer.form.importDirectory.placeholder": "/data/analyzer-imports/my-analyzer/incoming",
  "analyzer.form.validation.columnMappings.invalid": "Pemetaan kolom harus berupa JSON yang valid",
  "analyzer.form.validation.importDirectory.required": "Direktori impor wajib ada untuk penganalisis berbasis file",
  "analyzer.form.validation.port.invalid": "Nomor port harus berupa angka antara 1 dan 65535",
  "analyzer.qc.batch.failure.subtitle": "Proses pengendalian mutu pada batch ini menunjukkan adanya ketidaksesuaian. Silakan tinjau hasil pengendalian mutu di bawah ini sebelum menerima hasil pemeriksaan pasien.",
  "analyzer.qc.batch.failure.title": "Pengendalian QC Gagal",
  "analyzer.qc.controls.hidden": "Kontrol QC disembunyikan dari tampilan hasil pasien",
  "analyzer.qc.controls.section.title": "Kontrol QC ({count})",
  "audittrail.table.heading": "Informasi Pemesanan",
  "barcode.label.info.labnumber": "Nomor Registrasi",
  "button.close": "Tutup",
  "button.collapse": "Sembunyikan",
  "button.expand": "Perluas",
  "button.home": "Beranda",
  "button.new.search": "Cari Baru",
  "column.name.labNo": "No. Registrasi",
  "env.collectionConditions.helper": "Cari lokasi pengambilan sampel yang sudah ada atau buat yang baru. Lokasi-lokasi tersebut dapat digunakan kembali di berbagai pemesanan — seperti halnya pasien dalam alur kerja klinis.",
  "env.collectionMethod.placeholder": "misalnya, sampel acak, sampel gabungan 24 jam",
  "env.conditions": "Kondisi Lingkungan",
  "env.conditions.placeholder": "misalnya, 20°C, cuaca cerah, musim kemarau",
  "env.regulatoryReference": "Referensi Peraturan",
  "env.regulatoryReference.placeholder": "mis., PP 22/2021 tentang Kualitas Air",
  "env.samplingSite.title": "Subjek — Tempat Pengambilan Sampel",
  "env.site.address": "Alamat",
  "env.site.addressSearch.placeholder": "Cari lokasi untuk mengisi otomatis daftar tarik-turun di bawah ini...",
  "env.site.code": "Kode Tempat",
  "env.site.code.placeholder": "Membuat secara otomatis (atau masukkan secara manual)",
  "env.site.contactPerson": "Kontak Person",
  "env.site.contactPerson.placeholder": "Nama pengelola situs atau kontak",
  "env.site.contactPhone": "Telepon Kontak",
  "env.site.description": "Deskripsi Situs",
  "env.site.description.placeholder": "misalnya, titik pemantauan hilir di dekat pintu air",
  "env.site.helperText": "Daftarkan tempat pengambilan sampel baru. Tempat tersebut akan disimpan di Registri Tempat Pengambilan Sampel dan dapat digunakan kembali untuk pemesanan di masa mendatang.",
  "env.site.name": "Nama Tempat",
  "env.site.name.placeholder": "misalnya, Sungai Ciliwung — Manggarai",
  "env.site.newTab": "Tempat Baru",
  "env.site.saveAndSelect": "Simpan & Pilih Tempat",
  "env.site.searchLabel": "Nama Tempat",
  "env.site.searchPlaceholder": "misalnya, Sungai Ciliwung – Manggarai",
  "env.site.searchTab": "Cari Situs Ini",
  "env.site.streetAddress": "Alamat",
  "env.site.streetAddress.placeholder": "Nama Jalan atau referensi lokasi",
  "env.site.subtype": "Subtipe",
  "env.site.subtype.placeholder": "misalnya, Sungai, Sumur, BG-Sentinel, Stasiun Tetap",
  "env.site.type": "Jenis Tempat",
  "env.site.type.select": "Pilih Jenis...",
  "env.site.zone": "Zona Lingkungan",
  "env.site.zone.select": "Pilih Zona...",
  "error.dateRange.start": "Silakan pilih tanggal mulai dan tanggal selesai.",
  "error.loading.metrics": "Terjadi kesalahan saat memuat metrik",
  "error.nonconform.report.data.found": "Tidak ada data ditemukan",
  "error.report.csv.dateType": "Silahkan pilih jenis tanggal.",
  "error.required.fields": "Silakan isi semua bidang yang wajib diisi",
  "error.save.sample": "Terjadi kesalahan saat menyimpan sampel",
  "error.validation.failed": "Validasi gagal",
  "error.value": "Silakan pilih sebuah nilai.",
  "esig.context.saveResults": "Simpan hasil pencarian \"{count}\" untuk Nomor Registrasi {accession}",
  "esig.context.saveResultsMulti": "Simpan hasil \"{count}\" dari berbagai nomor registrasi {accessionCount}",
  "esig.context.validateResults": "Validasi hasil {count} untuk nomor registrasi {accession}",
  "esig.context.validateResultsMulti": "Validasi hasil penelitian “{count}” pada berbagai nomor registrasi “{accessionCount}”",
  "fhir.questionnaire.title": "Informasi Tambahan",
  "genericSample.default.fields.title": "Informasi Sampel",
  "genericSample.import.success": "Impor Berhasil",
  "genericSample.notebook.label": "Pilih Notebook",
  "genericSample.order.newOrder": "Buat Sampel Lainnya",
  "genericSample.search.title": "Cari berdasarkan Nomor Registrasi",
  "http.success": "Berhasil!",
  "label.button.assign": "Menugaskan",
  "label.button.create": "Buat",
  "label.button.saving": "Menyimpan...",
  "label.button.view": "Lihat Laporan",
  "label.code": "Kode",
  "label.editing": "Pengeditan",
  "label.label": "Label",
  "label.name": "Nama",
  "label.panel": "Panel",
  "label.tests": "pengujian",
  "loading.label": "Memuat...",
  "loading.metrics": "Memuat metrik...",
  "locale.save.error": "Gagal menyimpan bahasa",
  "logging.management.tail.clear": "Kosongkan",
  "logging.management.tail.disconnected": "Koneksi streaming putus. Matikan dan nyalakan kembali untuk menghubungkan kembali.",
  "logging.management.tail.label": "Log aplikasi secara langsung",
  "logging.management.tail.off": "Matikan",
  "logging.management.tail.on": "Nyalakan",
  "logging.management.tail.stream": "Aliran langsung",
  "nationalID.title": "NIK",
  "nce.button.linkSelected": "Tautkan Sampel yang Dipilih",
  "nce.button.submit": "Kirim KTS",
  "nce.error.numberGeneration": "Gagal membuat nomor Kejadian Ketidaksesuaian. Silakan coba lagi.",
  "nce.error.unknownOrder": "No order has the lab number {0}.",
  "nce.field.dateOfEvent": "Tanggal Kejadian",
  "nce.field.description": "Deskripsi",
  "nce.field.nceNumber": "Nomor Kejadian Ketidaksesuaian",
  "nce.field.proposedAction.helper": "Terpisah dari tindakan CAPA yang ditugaskan selama alur kerja Tindakan Perbaikan",
  "nce.field.proposedAction.placeholder": "Langkah Berikutnya yang disarankan...",
  "nce.field.reporterName": "Nama Pelapor",
  "nce.field.reportingUnit": "Unit yang melapor",
  "nce.field.subcategory": "Subkategori",
  "nce.field.suspectedCauses.helper": "Hanya penilaian awal — penyebab utama yang sebenarnya ditentukan selama Investigasi",
  "nce.field.suspectedCauses.placeholder": "Pelapor",
  "nce.form.subtitle": "Dokumentasikan kejadian mutu dan tautkan ke sampel dan hasil yang terpengaruh",
  "nce.form.title": "Lapor Kejadian Ketidaksesuaian",
  "nce.linkSamples.helper": "Cari pemesanan di atas untuk menghubungkan sampel ke KTS ini. Langkah ini bersifat opsional.",
  "nce.section.attachments": "Lampiran",
  "nce.section.classification": "Klasifikasi",
  "nce.section.details": "Rincian",
  "nce.section.linkSamples": "Tautan ke Sampel / Hasil (Opsional)",
  "nce.section.reporterContext": "Pelapor & Konteks Kejadian",
  "nce.select.subcategory": "Pilih subkategori...",
  "nce.severity.critical.desc": "Resiko keselamatan pasien, pelanggaran peraturan",
  "nce.severity.major.desc": "Dampat signifikan pada mutu atau operasional",
  "nce.severity.minor.desc": "Dampak terbatas, mudah diperbaiki",
  "nonconform.corrective.requiredFields": "Isi semua kolom tindakan korektif (tindakan, Petugas yang bertanggungjawab, Tanggal selesai, dan setidaknya satu jenis tindakan), atau biarkan baris tersebut kosong seluruhnya.",
  "nonconform.view.requiredFields": "Komponen laboratorium, kategori Kejadian Ketidaksesuaian, jenis Kejadian Ketidaksesuaian, tingkat keparahan, konsekuensi, dan frekuensi kejadian semuanya wajib diisi.",
  "notebook.sample.create": "Buat",
  "notebook.sample.create.title": "Buat sampel baru",
  "notebook.sample.edit": "Edit",
  "notebook.sample.edit.title": "Edit Sampel",
  "notebook.sample.import": "Impor",
  "notebook.sample.import.title": "Impor Sampel",
  "notebook.sample.order.info": "Sampel ini akan dikaitkan dengan notebook yang sedang aktif.",
  "notebook.sample.order.title": "Buat Sampel untuk Notebook",
  "notification.warning": "Peringatan",
  "order.entry.setup.batch": "Masukkan Pemesanan Batch",
  "order.legend.patient1": "Informasi Pasien",
  "pagination.next": "Halaman berikutnya",
  "pagination.previous": "Halaman sebelumnya",
  "patient.fetch.error": "Tidak dapat memuat data pasien. Identitas tersebut mungkin tidak valid atau server tidak dapat diakses.",
  "patient.firstName": "Nama Depan",
  "patient.lastName": "Nama Belakang",
  "print.barcode.all": "Cetak Semua Kode QR ({count})",
  "sample.item.id": "ID Item Sampel",
  "sample.label": "Sampel",
  "sample.noPanels": "Tidak ada panel yang tersedia untuk jenis sampel ini",
  "sample.noTests": "Tidak ada pemeriksaan yang tersedia untuk jenis sampel ini",
  "sample.testsLoadFailed": "Pemeriksaan untuk jenis sampel ini tidak dapat dimuat.",
  "sample.noTestsMatchSearch": "Tidak ada pemeriksaan yang cocok dengan pencarian Anda",
  "sample.noPanelsMatchSearch": "Tidak ada panel yang cocok dengan pencarian Anda",
  "sample.selectType.first": "Pilih jenis sampel di atas untuk melihat panel dan pemeriksaan yang tersedia",
  "sample.testsCount": "{count} Pemeriksaan Tersedia",
  "sample.types": "Sampel",
  "sample.referral.listsFailed": "Alasan rujukan atau daftar laboratorium tidak dapat dimuat. Semua yang Anda masukkan tetap tersimpan; tekan Ulangi untuk merujuk pemeriksaan.",
  "sample.tests.loadFailed": "Pemeriksaan untuk {sampleType} tidak dapat dimuat.",
  "sample.tests.loadFailed.hint": "Semua yang Anda masukkan tetap tersimpan. Periksa koneksi atau masuk kembali, lalu tekan Ulangi.",
  "sample.tests.loading": "Memuat pemeriksaan…",
  "save.error.msg": "Error saat menyimpan",
  "saving.label": "Menyimpan...",
  "select.label.analyzer": "Pilih Alat",
  "site.code": "Kode",
  "steps.complete": "langkah-langkah",
  "storage.audit.empty": "Tidak ada pergerakan yang tercatat untuk sampel ini.",
  "storage.audit.empty.title": "Tidak ada perpindahan",
  "storage.audit.fetch.error": "Tidak dapat memuat jejak audit.",
  "storage.audit.fetch.error.title": "Error",
  "storage.audit.from": "Dari",
  "storage.audit.movedBy": "Dipindahkan Oleh",
  "storage.audit.movementDate": "Tanggal Perpindahan",
  "storage.audit.reason": "Alasan",
  "storage.audit.to": "Kepada",
  "storage.box.code.helper": "Maksimal 10 karakter",
  "storage.confirm.disposal": "Konfirmasi Pemusnahan",
  "storage.dashboard.title": "Penyimpanan",
  "storage.disposal.method": "Metode Pemusnahan",
  "storage.disposal.method.placeholder": "Pilih metode...",
  "storage.disposal.notes": "Catatan Tambahan (Opsional)",
  "storage.disposal.notes.placeholder": "Masukkan catatan tambahan apa saja...",
  "storage.disposal.reason": "Alasan Pemusnahan",
  "storage.disposal.reason.placeholder": "Pilih Alasan...",
  "storage.dispose.confirmation": "Saya menyatakan bahwa saya ingin memusnahkan sampel ini secara permanen. Tindakan ini tidak dapat dibatalkan.",
  "storage.dispose.error": "Pemusnahan gagal",
  "storage.dispose.instructions.subtitle": "Harap pastikan prosedur pemusnahan yang benar dipatuhi sesuai dengan Protokol Keselamatan Laboratorium.",
  "storage.dispose.instructions.title": "Petunjuk Pemusnahan",
  "storage.dispose.location.note": "Sampel akan dihapus dari lokasi ini saat pemusnahan",
  "storage.dispose.sample": "Musnahkan Sampel",
  "storage.dispose.sample.subtitle": "Musnahkan sampel {sampleId} secara permanen",
  "storage.dispose.warning.subtitle": "Sampel tersebut akan ditandai sebagai telah dimusnahkan dan dihapus dari tempat penyimpanan.",
  "storage.dispose.warning.title": "Aksi ini tidak dapat dibatalkan",
  "storage.edit.heading": "Edit {type}",
  "storage.edit.title": "Sunting",
  "storage.editbox.heading": "Kotak Edit",
  "storage.error": "Kesalahan",
  "storage.error.save": "Gagal menyimpan lokasi",
  "storage.filter.select.location": "Pilih Lokasi...",
  "storage.filter.selected": "Dipilih:",
  "storage.location.assigned.error": "Gagal menempatkan di lokasi",
  "storage.location.assigned.success": "Lokasi berhasil ditetapkan",
  "storage.location.created": "{level} dibuat",
  "storage.location.deleted": "{level} dihapus",
  "storage.location.no.results": "Tidak ditemukan lokasi",
  "storage.location.type.devices": "Perangkat",
  "storage.location.type.racks": "Laci",
  "storage.location.type.rooms": "Ruangan",
  "storage.location.type.shelves": "Rak",
  "storage.location.updated": "{level} diperbarui",
  "storage.manage.location": "Kelola Lokasi",
  "storage.nav.rack": "Laci",
  "storage.sample.actions": "Aksi sampel",
  "storage.sampleitem.accession": "Aksesi Sampel",
  "storage.sampleitem.location": "Lokasi Penyimpanan",
  "storage.sampleitem.status": "Status",
  "storage.sampleitem.type": "Tipe",
  "storage.search.location.label": "Cari lokasi penyimpanan",
  "storage.search.location.placeholder": "Ketik 2+ karakter untuk mencari…",
  "storage.skipRemaining": "Lewati penyimpanan untuk sampel tidak ditugaskan ({count}) — akan segera diproses",
  "storage.view.audit": "Lihat Audit",
  "storage.view.audit.subtitle": "Riwayat pergerakan untuk sampel {sampleId}",
  "storage.view.audit.title": "Jejak Audit Penyimpanan",
  "systemDefaultPayloadTemplate.messageTemplate": "Templat pesan",
  "systemDefaultPayloadTemplate.subjectTemplate": "Template Subjek",
  "tests.count": "{count, plural, other {pemeriksaan}}",
  "validation.invalid.ip": "Format alamat IP tidak valid (IPv4 atau IPv6)",
  "validation.invalid.port": "Nomor port harus berkisar antara 1 dan 65535",
  "validation.required": "Bidang ini diperlukan",
  "common.accept": "Terima",
  "common.accessionNumber": "Nomor Registrasi",
  "common.action": "Aksi",
  "common.actions": "Aksi",
  "common.active": "Aktif",
  "common.addTests": "Tambah Pemeriksaan",
  "common.aliquots": "alikuot",
  "common.all": "Semua",
  "common.allStatuses": "Semua Status",
  "common.analyzer": "Alat",
  "common.analyzers": "Alat",
  "common.auditTrail": "Jejak Audit",
  "common.back": "Kembali",
  "common.boxId": "ID Boks",
  "common.byUnit": "Berdasarkan Unit",
  "common.cancel": "Batal",
  "common.category": "Kategori",
  "common.clinical": "Klinis",
  "common.code": "Kode",
  "common.collected": "Diambil",
  "common.collectionDate": "Tanggal Pengambilan",
  "common.complete": "Selesai",
  "common.completed": "Selesai",
  "common.confirm": "Konfirmasi",
  "common.correctiveActions": "Tindakan Perbaikan",
  "common.createAliquot": "Buat Alikuot",
  "common.critical": "Kritis",
  "common.dashboard": "Dasbor",
  "common.date": "Tanggal",
  "common.dateRange": "Rentang Tanggal",
  "common.deactivate": "Nonaktifkan",
  "common.delete": "Hapus",
  "common.description": "Deskripsi",
  "common.draft": "Draf",
  "common.edit": "Edit",
  "common.editOrder": "Edit Sampel",
  "common.email": "Email",
  "common.enterResults": "Masukkan Hasil",
  "common.error": "Error",
  "common.expired": "Kedaluwarsa",
  "common.exportPdf": "Ekspor PDF",
  "common.failed": "Gagal",
  "common.filterByStatus": "Filter berdasarkan Status",
  "common.firstName": "Nama Depan",
  "common.from": "Dari",
  "common.generateReport": "Buat Laporan",
  "common.home": "Beranda",
  "common.inProgress": "Dalam Pengerjaan",
  "common.inactive": "Inaktif",
  "common.labNumber": "Nomor Registrasi",
  "common.lastName": "Nama Belakang",
  "common.loading": "Memuat...",
  "common.location": "Lokasi",
  "common.mean": "Rata-rata",
  "common.name": "Nama",
  "common.nationalId": "NIK",
  "common.new": "Baru",
  "common.none": "Tidak ada",
  "common.normal": "Normal",
  "common.normalRange": "Rentang Normal",
  "common.notCompleted": "Not Completed",
  "common.notes": "Catatan",
  "common.order": "Pemesanan",
  "common.overdue": "Lewat tenggat",
  "common.panels": "Panel",
  "common.participants": "Peserta",
  "common.patient": "Pasien",
  "common.pending": "Tertunda",
  "common.position": "Posisi",
  "common.printLabel": "Cetak Label",
  "common.priority": "Prioritas",
  "common.program": "Program",
  "common.programName": "Nama Program",
  "common.provider": "Penyelenggara",
  "common.quantity": "Kuantitas",
  "common.reason": "Alasan",
  "common.received": "Diterima",
  "common.referenceLab": "Lab Rujukan",
  "common.reject": "Tolak",
  "common.remove": "Hapus",
  "common.removeSelection": "Hapus {name}",
  "common.reports": "Laporan",
  "common.requester": "Pemohon",
  "common.result": "Hasil",
  "common.results": "Hasil",
  "common.room": "Ruangan",
  "common.routine": "Rutin",
  "common.sample": "Sampel",
  "common.sampleId": "Nomor Identitas Sampel",
  "common.sampleManagement": "Pengelolaan Sampel",
  "common.sampleType": "Jenis Sampel",
  "common.samples": "Sampel",
  "common.samplingSite": "Tempat Pengambilan Sampel",
  "common.save": "Simpan",
  "common.saveFailed": "Penyimpanan gagal",
  "common.saving": "Menyimpan...",
  "common.search": "Cari",
  "common.select": "Pilih",
  "common.severity": "Keparahan",
  "common.siteName": "Nama Tempat",
  "common.species": "Spesies",
  "common.standard": "Standar",
  "common.status": "Status",
  "common.storageLocation": "Lokasi Penyimpanan",
  "common.study": "Kajian",
  "common.test": "Pemeriksaan",
  "common.testName": "Nama Pemeriksaan",
  "common.tests": "Pemeriksaan",
  "common.type": "Tipe",
  "common.unit": "Unit",
  "common.user": "Pengguna",
  "common.value": "Nilai",
  "common.view": "Lihat",
  "common.warning": "Peringatan",
  "label.testCatalog.alerts.field.component": "Komponen hasil",
  "label.testCatalog.alerts.field.componentHelp": "Hasil mana yang dipantau oleh peringatan ini. Biarkan tidak diatur agar semua komponen pemeriksaan ini dipantau.",
  "label.testCatalog.alerts.field.sampleType": "Jenis sampel",
  "label.testCatalog.alerts.field.sampleTypeHelp": "Spesimen mana yang dipantau oleh peringatan ini. Biarkan tidak diatur agar semua jenis sampel yang diuji dalam pemeriksaan ini dipantau.",
  "label.testCatalog.alerts.scope.anyComponent": "Komponen apa saja",
  "label.testCatalog.alerts.scope.anySampleType": "Jenis sampel apa saja",
  "label.testCatalog.alerts.col.scope": "Berlaku untuk",
  "label.testCatalog.alerts.scope.wholeTest": "Seluruh pemeriksaan",
  "microbiology.ast.breakpointStandard": "Standar breakpoint",
  "microbiology.ast.hint": "Rekam pembacaan MIC atau zona, tinjau interpretasinya, dan dokumentasikan pengecualian secara langsung.",
  "microbiology.ast.noOverride": "Tidak ada penggantian",
  "microbiology.ast.reading": "Pembacaan AST",
  "microbiology.case.isolates.hint": "Tambah dan identifikasi pertumbuhan yang signifikan secara klinis sebelum AST.",
  "microbiology.isolate.contaminant": "Kontaminan",
  "microbiology.isolate.edit": "Edit isolat",
  "microbiology.isolate.identificationStatus": "Status identifikasi",
  "microbiology.isolate.normalFlora": "Flora normal",
  "microbiology.isolate.organism": "Organisme",
  "microbiology.isolate.organism.freeText": "Masukkan nama organisme sebagai teks bebas",
  "microbiology.isolate.significant": "Signifikan secara klinis",
  "microbiology.isolate.unknown": "Tidak diketahui",
  "microbiology.isolate.update": "Simpan data identifikasi",
  "microbiology.enum.AST_REVIEW_REQUIRED": "Peninjauan AST wajib",
  "microbiology.enum.AWAITING_RESULTS": "Menunggu Hasil",
  "microbiology.enum.ANTIBIOTIC_MAPPING_REQUIRED": "Pemetaan Antibiotik Diperlukan",
  "microbiology.enum.CASE_FINALIZATION_REQUIRED": "Penyelesaian Kasus Diperlukan",
  "microbiology.enum.AMENDED": "Telah diubah",
  "microbiology.enum.AMENDMENT_ACTION_FAILED": "Aksi Amandemen Gagal",
  "microbiology.enum.CULTURE_PROTOCOL_CHANGED": "Protokol Kultur Diubah",
  "microbiology.enum.AMENDMENT_ALREADY_OPEN": "Amandemen Telah Dibuka",
  "microbiology.enum.AMENDMENT_HISTORY_LOAD_FAILED": "Gagal Memuat Riwayat Amandemen",
  "microbiology.enum.AMENDMENT_IN_PROGRESS": "Proses Amandemen Dalam Pengerjaan",
  "microbiology.enum.AMENDMENT_NEW_AST_RUN_REQUIRED": "Run AST Baru Diperlukan untuk Amandemen",
  "microbiology.enum.AMENDMENT_NOT_OPEN": "Amandemen Tidak Dibuka",
  "microbiology.enum.AMENDMENT_REASON_REQUIRED": "Alasan Amandemen Wajib Diisi",
  "microbiology.enum.AMENDMENT_REQUIRES_FINAL_RELEASE": "Amandemen Memerlukan Rilis Final",
  "microbiology.enum.ACKNOWLEDGED": "Sudah diketahui",
  "microbiology.enum.AMENDMENT_CANCELLED": "Amandemen Dibatalkan",
  "microbiology.enum.AMENDMENT_OPENED": "Amandemen Dibuka",
  "microbiology.enum.AMENDMENT_RELEASED": "Amandemen Telah Dirilis",
  "microbiology.enum.AST_AMENDMENT_SOURCE_MUST_BE_REPORTABLE": "Sumber AST Amandemen Harus Dapat Dilaporkan",
  "microbiology.enum.AST_ANALYZER_FLAGS_ACKNOWLEDGED": "Penanda Alat Sudah Diketahui",
  "microbiology.enum.AST_ANALYZER_QC_FAILED": "QC Alat Gagal",
  "microbiology.enum.AST_ANALYZER_RESULTS_RECEIVED": "Hasil Alat Diterima",
  "microbiology.enum.AST_ATTEMPT_REASON_REQUIRED": "Alasan Upaya AST Wajib Diisi",
  "microbiology.enum.AST_ENTRY": "Entri AST",
  "microbiology.enum.AST_IN_PROGRESS": "AST Dalam Pengerjaan",
  "microbiology.enum.AST_READY": "Siap untuk AST",
  "microbiology.enum.AST_REPEAT_OR_RETEST_REQUIRED": "Diperlukan Pengulangan atau Pemeriksaan Ulang",
  "microbiology.enum.AST_REVIEW": "Tinjauan AST",
  "microbiology.enum.AST_REVIEWED": "AST Telah Ditinjau",
  "microbiology.enum.AST_READING_OVERRIDDEN": "Pembacaan AST Diganti",
  "microbiology.enum.AST_READING_RECORDED": "Pembacaan AST Direkam",
  "microbiology.enum.AST_REPORTABLE_SELECTED": "AST yang Harus Dilaporkan Telah Dipilih",
  "microbiology.enum.AST_RUN_CREATED": "AST Run Dibuat",
  "microbiology.enum.AST_RUN_INVALIDATED": "AST Run Dibatalkan",
  "microbiology.enum.AST_RUN_METHOD_MISMATCH": "Ketidaksesuaian Metode Pelaksanaan AST",
  "microbiology.enum.AST_QC_OVERRIDDEN": "AST QC Diabaikan",
  "microbiology.enum.AST_SETUP_UNAVAILABLE": "Pengaturan AST Tidak Tersedia",
  "microbiology.enum.AST_SOURCE_RUN_REVIEW_REQUIRED": "Peninjauan Run Sumber AST Diperlukan",
  "microbiology.enum.ANALYZER": "Alat",
  "microbiology.enum.BROTH_MICRODILUTION": "Metode Mikrodilusi Kaldu",
  "microbiology.enum.CASE": "Kasus",
  "microbiology.enum.CASE_CREATED": "Kasus Dibuat",
  "microbiology.enum.CASE_REVIEW": "Tinjauan Kasus",
  "microbiology.enum.CANCELLED": "Dibatalkan",
  "microbiology.enum.CLINICALLY_SIGNIFICANT": "Signifikan secara klinis",
  "microbiology.enum.CLOSED": "Ditutup",
  "microbiology.enum.CONFIRMED": "Telah dilakukan konfirmasi",
  "microbiology.enum.CONTAMINANT": "Kontaminan",
  "microbiology.enum.CRITICAL_COMMUNICATION_ACKNOWLEDGED": "Komunikasi Kritis Sudah Diketahui",
  "microbiology.enum.CRITICAL_COMMUNICATION_CLOSED": "Komunikasi Kritis Ditutup",
  "microbiology.enum.CRITICAL_COMMUNICATION_LOGGED": "Catatan Komunikasi Kritis Telah Dicatat",
  "microbiology.enum.CRITICAL_FOLLOW_UP_REQUIRED": "Tindak Lanjut Kritis Diperlukan",
  "microbiology.enum.DISK_DIFFUSION": "Difusi Disk",
  "microbiology.enum.EMAIL": "Email",
  "microbiology.enum.EMERGENCY": "Keadaan Darurat",
  "microbiology.enum.ETEST": "Etest",
  "microbiology.enum.FAILED": "Gagal",
  "microbiology.enum.FINAL": "Final",
  "microbiology.enum.FINAL_REPORT_RELEASED": "Laporan Akhir Telah Diterbitkan",
  "microbiology.enum.GROWTH_DETECTED": "Terdeteksi Pertumbuhan",
  "microbiology.enum.HIGH": "Tinggi",
  "microbiology.enum.IDENTIFICATION": "Identifikasi",
  "microbiology.enum.ICU": "ICU",
  "microbiology.enum.INCUBATING": "Sedang Inkubasi",
  "microbiology.enum.INPATIENT": "Pasien rawat inap",
  "microbiology.enum.IN_PROGRESS": "Dalam Pengerjaan",
  "microbiology.enum.MALDI_TOF": "MALDI-TOF",
  "microbiology.enum.IN_PERSON": "Secara Langsung",
  "microbiology.enum.INOCULATION_RECORDED": "Inokulasi Direkam",
  "microbiology.enum.ISOLATE": "Isolat",
  "microbiology.enum.ISOLATE_CREATED": "Isolat Dibuat",
  "microbiology.enum.ISOLATE_ID": "Identitas Isolat",
  "microbiology.enum.ISOLATE_REQUIRED": "Isolat Wajib",
  "microbiology.enum.ISOLATE_UPDATED": "Isolat Terbarui",
  "microbiology.enum.LEGACY_UNSPECIFIED_MIC": "Teknik MIC yang Tidak Ditentukan",
  "microbiology.enum.LEGACY_UNSPECIFIED_ZONE": "Teknik Zona yang Tidak Ditentukan",
  "microbiology.enum.MANUAL_NOTE": "Catatan Manual",
  "microbiology.enum.MANUAL_ENTRY": "Entri Manual",
  "microbiology.enum.MIC": "MIC",
  "microbiology.enum.MICROBIOLOGY_INOCULATION_AUDIT_SERIALIZATION_FAILED": "Audit Inokulasi Tidak Dapat Direkam",
  "microbiology.enum.MICROBIOLOGY_PROTOCOL_AUDIT_SERIALIZATION_FAILED": "Audit Protokol Tidak Dapat Direkam",
  "microbiology.enum.MICROBIOLOGY_PROTOCOL_UNCHANGED": "Pilih Protokol Lain",
  "microbiology.enum.MICROBIOLOGY_PROTOCOL_WORKFLOW_REQUIRED": "Tetapkan Alur Kerja Sebelum Memilih Protokol",
  "microbiology.enum.MICROBIOLOGY_SUBCULTURE_SOURCE_CASE_MISMATCH": "Sumber subkultur harus berkaitan dengan kasus ini",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_AUDIT_SERIALIZATION_FAILED": "Audit Alur Kerja Tidak Dapat Direkam",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_CHANGE_CONFIRMATION_REQUIRED": "Konfirmasi Penyimpanan Pekerjaan yang Sudah Ada",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_CLASSIFICATION_REQUIRED": "Klasifikasi Alur Kerja Wajib",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_METHOD_INCOMPATIBLE": "Metode Kultur Tidak Sesuai dengan Alur Kerja",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_NOT_SUPPORTED": "Alur Kerja Tidak Didukung",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_SIBLING_EXISTS": "Kasus untuk Alur Kerja Ini Sudah Ada",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_UNCHANGED": "Pilih Alur Kerja Lainnya",
  "microbiology.enum.NO_GROWTH_READY": "Siap Tanpa Pertumbuhan",
  "microbiology.enum.NORMAL_FLORA": "Flora normal",
  "microbiology.enum.NEEDS_WORKFLOW": "Perlu Alur Kerja",
  "microbiology.enum.NOT_READY": "Belum Siap",
  "microbiology.enum.NONCONFORMANCE_REPORTED": "Ketidaksesuaian Dilaporkan",
  "microbiology.enum.NONE": "Tidak ada",
  "microbiology.enum.OPEN": "Buka",
  "microbiology.enum.ORGANISM_MAPPING_REQUIRED": "Pemetaan Organisme Wajib",
  "microbiology.enum.ORGANISM": "Organisme",
  "microbiology.enum.ORIGINAL": "Asli",
  "microbiology.enum.OTHER": "Lainnya",
  "microbiology.enum.OUTPATIENT": "Rawat Jalan",
  "microbiology.enum.PENDING": "Tertunda",
  "microbiology.enum.PASSED": "Lolos",
  "microbiology.enum.PHOENIX": "Phoenix",
  "microbiology.enum.PHONE": "Telepon",
  "microbiology.enum.POSITIVE_SIGNAL": "Sinyal Positif",
  "microbiology.enum.PRELIM_RELEASED": "Rilis Awal",
  "microbiology.enum.PRELIMINARY": "Awal",
  "microbiology.enum.PRELIMINARY_RELEASED": "Rilis Awal",
  "microbiology.enum.PRELIMINARY_REPORT_RELEASED": "Laporan Awal Telah Dirilis",
  "microbiology.enum.QC_FAILED": "QC Gagal",
  "microbiology.enum.RECEIVED": "Diterima",
  "microbiology.enum.RELEASED": "Dirilis",
  "microbiology.enum.REPEAT": "Ulangi",
  "microbiology.enum.REPORTABLE_AST_RUN_REQUIRED": "Diperlukan Pelaksanaan AST yang Wajib Dilaporkan",
  "microbiology.enum.REPORTABLE_AST_RUN_MUST_BE_REVIEWED": "Proses AST yang Harus Dilaporkan Harus Ditinjau",
  "microbiology.enum.RESULT": "Hasil",
  "microbiology.enum.RESULTS_IN": "Hasil Masuk",
  "microbiology.enum.RETEST": "Pemeriksaan Ulang",
  "microbiology.enum.REVIEW_READY": "Siap Ditinjau",
  "microbiology.enum.REVIEWED": "Telah Ditinjau",
  "microbiology.enum.INTERMEDIATE": "Intermediet",
  "microbiology.enum.LOST_SPECIMEN": "Spesimen yang Hilang",
  "microbiology.enum.LOST_SPECIMEN_POSITIVE": "Spesimen yang Hilang - Kultur Positif",
  "microbiology.enum.NO_BREAKPOINT": "Tidak ada breakpoint",
  "microbiology.enum.RESISTANT": "Resisten",
  "microbiology.enum.ROUTINE": "Rutin",
  "microbiology.enum.SAMPLE_ITEM": "Item Sampel",
  "microbiology.enum.SETUP": "Pengaturan",
  "microbiology.enum.SETUP_RECORDED": "Pengaturan Telah Direkam",
  "microbiology.enum.SMS": "SMS",
  "microbiology.enum.SPECIMEN_LOST": "Spesimen Hilang",
  "microbiology.enum.STAGE_CHANGED": "Tahapan Telah Berubah",
  "microbiology.enum.SUBCULTURE_RECORDED": "Subkultur Direkam",
  "microbiology.enum.UNASSIGNED": "Tidak ditugaskan",
  "microbiology.enum.UNKNOWN_ERROR": "Kesalahan Tidak Diketahui",
  "microbiology.enum.VITEK_2": "VITEK 2",
  "microbiology.enum.WORKFLOW_CHANGED": "Perubahan Alur Kerja",
  "microbiology.enum.ZONE": "Zona",
  "microbiology.enum.FINAL_RELEASED": "Versi Final Telah Dirilis",
  "microbiology.enum.SUSCEPTIBLE": "Sensitif",
  "microbiology.enum.UNKNOWN": "Tidak diketahui",
  "rulebuilder.label.selectComponent": "Pilih Komponen",
  "testcalculation.label.selectComponent": "Pilih Komponen",
  "testcalculation.label.finalComponent": "Komponen Hasil",
  "qc.dashboard.tab.bench": "QC Meja Kerja",
  "qc.bench.source.all": "Semua sumber meja kerja",
  "qc.bench.source.manual": "Kuantitatif manual",
  "qc.bench.source.rdt": "Tes cepat (RDT)",
  "qc.bench.column.runs": "Kontrol dijalankan",
  "qc.bench.column.lastRun": "Putaran terakhir",
  "qc.bench.empty": "Tidak ada kontrol manual atau tes cepat yang tercatat pada periode ini.",
  "microbiology.case.activityNote": "Catatan Kegiatan",
  "microbiology.case.accessionNumber": "Nomor Registrasi",
  "microbiology.case.actionError": "Aksi kultur tidak dapat diselesaikan",
  "microbiology.case.action.markNoGrowth": "Tandai siap tanpa pertumbuhan",
  "microbiology.case.action.recordGrowth": "Rekam pertumbuhan terdeteksi",
  "microbiology.case.action.rejectCase": "Tolak kasus",
  "microbiology.case.action.setIncubating": "Tandai sedang inkubasi",
  "microbiology.case.action.startInoculation": "Mulai proses inokulasi",
  "microbiology.case.createIsolate": "Buat isolat",
  "microbiology.case.cultureAction": "Aksi kultur",
  "microbiology.case.atmosphere": "Atmosfer",
  "microbiology.case.eyebrow": "Meja kerja kasus mikrobiologi",
  "microbiology.case.sectionExpanded": "{section} diperluas",
  "microbiology.case.sectionStatus": "Status bagian",
  "microbiology.case.error": "Kesalahan dalam kasus mikrobiologi",
  "microbiology.case.isolateLabel": "Label isolat",
  "microbiology.case.isolates": "Isolat",
  "microbiology.case.isolates.empty": "Tidak ada isolat yang tercatat",
  "microbiology.case.loadError": "Tidak dapat memuat kasus mikrobiologi",
  "microbiology.case.lastActivityBy": "Aktivitas terakhir oleh",
  "microbiology.case.incubation": "Inkubasi",
  "microbiology.case.media": "Media atau botol",
  "microbiology.case.nextStage": "Tahapan berikutnya",
  "microbiology.case.patient": "Pasien",
  "microbiology.case.nonconformanceCount": "{count, plural, other {# KTS}}",
  "microbiology.case.relatedWorkflows": "Alur Kerja spesimen terkait",
  "microbiology.case.requestingLocation": "Lokasi pemohon",
  "microbiology.case.preliminaryOrganism": "Organisme awal",
  "microbiology.case.recordActivity": "Rekam aktivitas",
  "microbiology.case.sampleItem": "Item sampel",
  "microbiology.case.setup": "Inokulasi",
  "microbiology.case.setup.hint": "Rekam langkah pengaturan awal, media, atau inkubasi untuk kasus kultur ini.",
  "microbiology.case.significance": "Signifikansi",
  "microbiology.case.specimenType": "Jenis Spesimen",
  "microbiology.case.timeline": "Garis waktu kasus",
  "microbiology.case.timeline.addNote": "Tambah Catatan",
  "microbiology.case.timeline.auto": "Otomatis",
  "microbiology.case.timeline.culturePurposeChange": "{from} ke {to}",
  "microbiology.case.timeline.culturePurposeChanged": "Tujuan kultur diubah",
  "microbiology.case.timeline.empty": "Tidak ada aktivitas kasus yang tercatat",
  "microbiology.case.timeline.hint": "Data kasus yang tercatat ditampilkan secara kronologis.",
  "microbiology.case.timeline.manual": "Manual",
  "microbiology.case.timeline.note": "Catatan atau pengamatan",
  "microbiology.case.timeline.noteExpanded": "Formulir catatan diperluas",
  "microbiology.case.timeline.performedBy": "Dilakukan oleh {actor}",
  "microbiology.case.timeline.saveNote": "Simpan catatan",
  "microbiology.case.timeline.showAll": "Tampilkan semua {count} kejadian",
  "microbiology.case.timeline.showRecent": "Tampilkan {count} kejadian terbaru",
  "microbiology.case.events": "kejadian",
  "microbiology.case.finalLocked.message": "Perubahan isolat dan AST dinonaktifkan setelah rilis final.",
  "microbiology.case.finalLocked.title": "Kasus final bersifat hanya baca",
  "microbiology.case.title": "Kasus mikrobiologi",
  "microbiology.inoculation.addSubculture": "Tambah subkultur",
  "microbiology.inoculation.empty": "Tidak ada media yang direkam. Mulai proses inokulasi.",
  "microbiology.inoculation.hint": "Rekam setiap botol atau cawan dan simpan riwayat kulturnya.",
  "microbiology.inoculation.identifier": "ID botol atau cawan",
  "microbiology.inoculation.identifierHint": "Pindai atau ketikkan pengidentifikasi tersebut.",
  "microbiology.inoculation.parent": "Media induk",
  "microbiology.inoculation.parentPlaceholder": "Pilih botol atau cawan sumber",
  "microbiology.inoculation.primaryExpanded": "Formulir inokulasi diperluas",
  "microbiology.inoculation.primary": "Primer",
  "microbiology.inoculation.recorded": "Media yang direkam",
  "microbiology.inoculation.save": "Simpan media",
  "microbiology.inoculation.source": "Sumber",
  "microbiology.inoculation.start": "Mulai proses inokulasi",
  "microbiology.inoculation.subcultureExpanded": "Formulir subkultur diperluas",
  "microbiology.inoculation.subculture": "Subkultur",
  "microbiology.amendment.actionError": "Aksi amandemen tidak dapat diselesaikan",
  "microbiology.amendment.cancel": "Batalkan amandemen",
  "microbiology.amendment.cancelReason": "Alasan pembatalan",
  "microbiology.amendment.cancelled": "Amandemen dibatalkan; kasus final kembali terkunci",
  "microbiology.amendment.correctsVersion": "Memperbaiki versi {number}",
  "microbiology.amendment.hint": "Perbaiki laporan akhir tanpa mengganti riwayat publikasinya.",
  "microbiology.amendment.history": "Riwayat Amandemen",
  "microbiology.amendment.inProgress.message": "Rekam koreksi tersebut, lalu terbitkan atau batalkan amandemen ini untuk mengunci kasus kembali.",
  "microbiology.amendment.inProgress.title": "Proses amandemen sedang dalam pengerjaan",
  "microbiology.amendment.noReportVersions": "Tidak ada versi laporan akhir yang tercatat",
  "microbiology.amendment.none": "Tidak ada amandemen yang tercatat",
  "microbiology.amendment.number": "Amandemen",
  "microbiology.amendment.numberValue": "Amandemen {number}",
  "microbiology.amendment.open": "Amandemen terbuka",
  "microbiology.amendment.opened": "Amandemen telah dibuka; koreksi klinis kini diaktifkan",
  "microbiology.amendment.reason": "Alasan amandemen",
  "microbiology.amendment.release": "Terbitkan laporan yang telah direvisi",
  "microbiology.amendment.released": "Laporan yang telah direvisi telah dirilis; kasus ini kembali terkunci",
  "microbiology.amendment.reportVersions": "Versi laporan yang telah diterbitkan",
  "microbiology.amendment.status": "Status",
  "microbiology.amendment.status.closed": "Tidak ada amandemen terbuka",
  "microbiology.amendment.status.open": "Amandemen terbuka",
  "microbiology.amendment.title": "Amandemen",
  "microbiology.amendment.version": "Versi {number}",
  "microbiology.ast.antibiotic": "Antibiotik",
  "microbiology.ast.acceptResults": "Terima hasilnya",
  "microbiology.ast.acknowledgeFlags": "Mengetahui penanda yang telah ditinjau",
  "microbiology.ast.analyzer": "Alat",
  "microbiology.ast.analyzerOrganism": "Organisme dari Alat: {organism} ({confidence}%)",
  "microbiology.ast.analyzerProvenance": "Kartu atau panel {card} · perangkat lunak {version}",
  "microbiology.ast.analyzerResolutionReason": "Alasan dan Tindakan Perbaikan",
  "microbiology.ast.actionError": "Aksi AST tidak dapat diselesaikan",
  "microbiology.ast.adjustPanel": "Sesuaikan panel",
  "microbiology.ast.orderedAntibiotics": "Antibiotik yang akan diperiksa",
  "microbiology.ast.actions": "Aksi",
  "microbiology.ast.applyOverride": "Terapkan penggantian",
  "microbiology.ast.attempt": "Upaya",
  "microbiology.ast.attemptMethod": "Metode percobaan",
  "microbiology.ast.attemptNumber": "Upaya {number}",
  "microbiology.ast.attemptReason": "Alasan",
  "microbiology.ast.attemptScope": "Ruang Lingkup pengulangan",
  "microbiology.ast.attempts": "Upaya AST",
  "microbiology.ast.attemptType": "Jenis upaya",
  "microbiology.ast.awaitingAnalyzerResults": "Menunggu hasil dari Alat",
  "microbiology.ast.awaitingAnalyzerResultsDetail": "Hasil akan muncul secara otomatis saat Alat yang terhubung mengirimkannya. Kejadian yang tidak cocok disimpan di Masalah Impor Alat.",
  "microbiology.ast.awaitingSetupCount": "{count} menunggu Pengaturan",
  "microbiology.ast.cardId": "Identitas kartu atau panel",
  "microbiology.ast.entryMode": "Entri Hasil",
  "microbiology.ast.entryMode.analyzer": "Alat terhubung",
  "microbiology.ast.entryMode.manual": "Entri manual",
  "microbiology.ast.expertFlags": "Penanda ahli dari Alat perlu ditinjau",
  "microbiology.ast.hideOriginal": "Sembunyikan riwayat",
  "microbiology.ast.historyTo": "ke",
  "microbiology.ast.interpretation": "Interpretasi",
  "microbiology.ast.instrumentInterpretation": "Alat: {interpretation}",
  "microbiology.ast.invalidateAndRepeat": "Nyatakan tidak valid dan mulai proses baru",
  "microbiology.ast.includedInReport": "Termasuk dalam laporan",
  "microbiology.ast.initialAttemptReason": "Upaya pertama",
  "microbiology.ast.isolate": "Isolat",
  "microbiology.ast.method": "Metode",
  "microbiology.ast.matchedBy": "Breakpoint yang cocok",
  "microbiology.ast.measurement.mic": "MIC (ug/mL)",
  "microbiology.ast.measurement.zone": "Diameter zona (mm)",
  "microbiology.ast.noBreakpointGuidance": "Tidak ada breakpoint standar. Tafsirkan hasil pengukuran ini sesuai dengan SOP setempat.",
  "microbiology.ast.noBreakpointTitle": "Diperlukan interpretasi lokal",
  "microbiology.ast.noIsolate": "Buat isolat sebelum merekam AST",
  "microbiology.ast.noSourceAttempt": "Upaya awal",
  "microbiology.ast.notIncludedInReport": "Tidak termasuk",
  "microbiology.ast.newAttempt": "Ulangi atau lakukan Pemeriksaan Ulang",
  "microbiology.ast.noRunsYet": "Tidak ada run",
  "microbiology.ast.antibioticToRepeat": "Antibiotik yang akan diulang",
  "microbiology.ast.override": "Ganti interpretasi",
  "microbiology.ast.overrideHistory": "Riwayat penggantian",
  "microbiology.ast.optionsExpanded": "Opsi {section} diperluas.",
  "microbiology.ast.overrideReason": "Alasan penggantian",
  "microbiology.ast.orderedPanel": "Panel AST yang dipesan",
  "microbiology.ast.organismMismatch": "Organisme dari Alat berbeda dari isolat kasus",
  "microbiology.ast.organismMismatchDetail": "Identifikasi dari Alat bersifat informatif. Periksa ketidaksesuaian tersebut; isolat kasus yang telah dikonfirmasi tetap menjadi acuan.",
  "microbiology.ast.overrideQc": "Abaikan penanda QC",
  "microbiology.ast.panel": "Panel AST",
  "microbiology.ast.panelAdjustmentReason": "Alasan penyesuaian panel",
  "microbiology.ast.panelProvenance.organismDefault": "Dipesan dari konfigurasi default organisme yang telah diidentifikasi",
  "microbiology.ast.rawValue": "Nilai Hasil",
  "microbiology.ast.qcFailed": "QC Alat gagal",
  "microbiology.ast.qcFailedDetail": "Referensi QC {reference}. Penerimaan hasil ditangguhkan hingga proses ini dinyatakan tidak sah atau seorang supervisor mencatat adanya pengecualian.",
  "microbiology.ast.replacementCardId": "Identitas kartu atau panel baru",
  "microbiology.ast.resultsReady": "Hasil Alat siap untuk ditinjau",
  "microbiology.ast.resultsReadyDetail": "Periksa ketidaksesuaian, breakpoint yang hilang, dan penanda ahli sebelum menerima hasil-hasil ini.",
  "microbiology.ast.runsComplete": "{complete} / {total} telah selesai dijalankan",
  "microbiology.ast.pendingIdentificationCount": "{count} menunggu identifikasi",
  "microbiology.ast.reasonForAttempt": "Alasan pengulangan atau Pemeriksaan Ulang",
  "microbiology.ast.recordReading": "Rekam hasil pengukuran AST",
  "microbiology.ast.reviewRun": "Tinjau proses AST",
  "microbiology.ast.repeat": "Ulangi",
  "microbiology.ast.revertOverride": "Kembalikan ke versi asli",
  "microbiology.ast.revertReason": "Alasan membatalkan penggantian",
  "microbiology.ast.reporting": "Pelaporan",
  "microbiology.ast.retest": "Pemeriksaan Ulang",
  "microbiology.ast.selectAntibiotic": "Pilih antibiotik",
  "microbiology.ast.singleAntibiotic": "Antibiotik tunggal",
  "microbiology.ast.wholePanel": "Seluruh panel",
  "microbiology.ast.runStatus": "Status eksekusi AST",
  "microbiology.ast.startRun": "Mulai proses AST",
  "microbiology.ast.startAttempt": "Mulai upaya {type}",
  "microbiology.ast.sourceAttempt": "Sumber",
  "microbiology.ast.source": "Sumber pembacaan",
  "microbiology.ast.showOriginal": "Tampilkan teks asli",
  "microbiology.ast.title": "AST Manual",
  "microbiology.ast.useAttemptForReporting": "Gunakan upaya {number} untuk pelaporan",
  "microbiology.ast.useForReporting": "Gunakan untuk pelaporan",
  "microbiology.ast.view": "Lihat",
  "microbiology.ast.viewAttempt": "Lihat upaya {number}",
  "microbiology.ast.viewing": "Sedang melihat",
  "microbiology.ast.viewingAttempt": "Melihat upaya {number}",
  "microbiology.critical.acknowledge": "Mengetahui",
  "microbiology.critical.followUp": "Perlu dilakukan tindak lanjut",
  "microbiology.critical.hint": "Catat panggilan balik hasil kritis dan tandai sudah diketahui secara langsung.",
  "microbiology.critical.log": "Catat komunikasi",
  "microbiology.critical.logForIsolate": "Catat pemberitahuan kritis untuk {isolate}",
  "microbiology.critical.logNotification": "Catat notifikasi kritis",
  "microbiology.critical.method": "Metode komunikasi",
  "microbiology.critical.message": "Pesan",
  "microbiology.critical.messageRequired": "Pesan wajib diisi",
  "microbiology.critical.none": "Tidak ada komunikasi kritis yang tercatat",
  "microbiology.critical.recipient": "Penerima",
  "microbiology.critical.recipientContact": "Kontak penerima",
  "microbiology.critical.required": "Pilih tujuan, lalu masukkan nama penerima dan isi pesan.",
  "microbiology.critical.resolution": "Catatan Pemecahan Masalah",
  "microbiology.critical.resolutionRequired": "Catatan penyelesaian wajib sebelum mengakhiri komunikasi.",
  "microbiology.critical.close": "Tutup komunikasi",
  "microbiology.critical.target": "Target hasil kritis",
  "microbiology.critical.targetId": "Catatan target",
  "microbiology.critical.title": "Komunikasi kritis",
  "microbiology.caseInfo.no": "Tidak",
  "microbiology.caseInfo.notProvided": "Tidak tersedia",
  "microbiology.caseInfo.summary": "Ringkasan informasi kasus",
  "microbiology.caseInfo.yes": "Ya",
  "microbiology.currentStep.open": "Buka {step}",
  "microbiology.currentStep.title": "Langkah saat ini",
  "microbiology.cultureAction.error": "Status kultur tidak dapat diperbarui.",
  "microbiology.cultureAction.noGrowth.confirm": "Pastikan tidak ada pertumbuhan",
  "microbiology.cultureAction.noGrowth.detail": "Pastikan bahwa masa inkubasi yang wajib dilakukan telah selesai dan tidak terdeteksi adanya pertumbuhan.",
  "microbiology.cultureAction.noGrowth.title": "Tandai kultur sebagai \"tidak ada pertumbuhan\"",
  "microbiology.cultureAction.positive.confirm": "Konfirmasi adanya sinyal positif",
  "microbiology.cultureAction.positive.detail": "Konfirmasi adanya hasil positif. Langkah selanjutnya adalah melakukan subkultur dan mencatat hasil pewarnaan Gram.",
  "microbiology.cultureAction.positive.title": "Tandai kultur positif",
  "microbiology.nce.category": "Kategori",
  "microbiology.nce.configurationBlockerTitle": "Konfigurasi wajib",
  "microbiology.nce.configurationLoadError": "Kategori dan unit pelaporan KTS tidak dapat dimuat.",
  "microbiology.nce.critical": "Kritis",
  "microbiology.nce.description": "Deskripsi",
  "microbiology.nce.disposition": "Disposisi",
  "microbiology.nce.errorTitle": "Ketidaksesuaian tidak dapat dilaporkan",
  "microbiology.nce.flagOnly": "Hanya penanda",
  "microbiology.nce.immediateAction": "Aksi segera",
  "microbiology.nce.lostTypeMissing": "Konfigurasi KTS yang aktif tidak mencakup jenis Spesimen Hilang.",
  "microbiology.nce.major": "Mayor",
  "microbiology.nce.markLost": "Tandai hilang",
  "microbiology.nce.markLostHint": "Rekam spesimen fisik tersebut sebagai hilang dan tolak pemeriksaan yang terpengaruh.",
  "microbiology.nce.markLostTitle": "Tandai spesimen hilang",
  "microbiology.nce.minor": "Minor",
  "microbiology.nce.rejectTests": "Tolak pemeriksaan yang terpengaruh",
  "microbiology.nce.retest": "Pemeriksaan Ulang AST",
  "microbiology.nce.retestLoadError": "Hasil AST yang telah ditinjau tidak dapat dimuat. Silakan coba lagi sebelum memilih \"Pemeriksaan Ulang AST\".",
  "microbiology.nce.sourceAstRun": "Proses AST yang akan diperiksa ulang",
  "microbiology.nce.report": "Lapor KTS",
  "microbiology.nce.reportHint": "Rekam ketidaksesuaian pada spesimen ini dan tentukan tindakan yang akan diambil.",
  "microbiology.nce.reportingUnit": "Unit yang melapor",
  "microbiology.nce.reportTitle": "Laporkan ketidaksesuaian",
  "microbiology.nce.required": "Pilih kategori, Unit yang melapor, dan tingkat keparahan, lalu berikan deskripsi.",
  "microbiology.nce.sectionTitle": "Ketidaksesuaian",
  "microbiology.nce.severity": "Keparahan",
  "microbiology.nce.submitError": "Ketidaksesuaian tersebut tidak dapat disimpan.",
  "microbiology.nce.title": "Judul",
  "microbiology.nce.type": "Jenis",
  "microbiology.isolate.identify": "Identifikasi organisme",
  "microbiology.isolate.reidentify": "Identifikasi ulang",
  "microbiology.isolate.identified": "Telah diidentifikasi",
  "microbiology.isolate.pending": "Identifikasi tertunda",
  "microbiology.isolate.gramStain": "Pewarnaan Gram",
  "microbiology.isolate.colonyMorphology": "Morfologi koloni",
  "microbiology.isolate.identification": "Identifikasi",
  "microbiology.isolate.identificationMethod": "Metode ID",
  "microbiology.isolate.identificationConfidence": "Tingkat kepercayaan Identitas (%)",
  "microbiology.isolate.identificationChange": "{previous} ke {next}: {reason}",
  "microbiology.isolate.identificationHistory": "Riwayat identifikasi",
  "microbiology.isolate.identificationReason": "Alasan reidentifikasi",
  "microbiology.isolate.organism.select": "Pilih suatu organisme",
  "microbiology.isolate.unidentified": "Tidak teridentifikasi",
  "microbiology.ast.identificationRequired": "Identifikasi isolat tersebut sebelum melakukan uji sensitivitas antibiotik (AST).",
  "microbiology.next.createIsolate": "Inokulasi telah direkam. Tambahkan pertumbuhan yang signifikan atau tandai kasus siap untuk penanganan tanpa pertumbuhan.",
  "microbiology.next.completeAmendment": "Amandemen terbuka. Catat koreksinya, tinjau laporan, lalu terbitkan versi yang telah diamandemen.",
  "microbiology.next.finalReleased": "Laporan akhir telah dirilis. Periksa kesiapan pengawasan sebelum Ekspor.",
  "microbiology.next.incubating": "Inkubasi. Tandai kasus sebagai positif jika terdeteksi adanya pertumbuhan, atau tandai sebagai tidak ada pertumbuhan jika masa inkubasi yang wajib dilakukan telah selesai.",
  "microbiology.next.subculturePositive": "Terdeteksi tanda positif. Lakukan subkultur pada botol tersebut dan rekam hasil pewarnaan Gram.",
  "microbiology.next.recordSetup": "Kasus telah diterima. Rekam pengaturan awal untuk memulai inkubasi.",
  "microbiology.next.release": "AST telah ditinjau. Konfirmasi bahwa laporan sudah siap dan terbitkan laporan akhir.",
  "microbiology.next.noGrowthRelease": "Tidak tercatat adanya pertumbuhan. Tinjau dan terbitkan laporan negatif akhir.",
  "microbiology.next.reviewAst": "Isolat telah tercatat. Selesaikan dan tinjau AST sebelum rilis.",
  "microbiology.next.title": "Langkah Berikutnya",
  "microbiology.navigation.backToWorklist": "Kembali ke daftar tugas mikrobiologi",
  "microbiology.navigation.menu": "Mikrobiologi",
  "microbiology.navigation.worklist": "Daftar Pekerjaan Mikrobiologi",
  "order.context.workflowProgress": "Kemajuan alur kerja pemesanan",
  "microbiology.culturePurpose.clinical": "Diagnosis atau pengobatan klinis",
  "microbiology.culturePurpose.label": "Tujuan kultur",
  "microbiology.culturePurpose.screening": "Skrining aktif atau status pembawa",
  "microbiology.culturePurpose.unspecified": "Tidak ditentukan",
  "microbiology.orderDetail.antibioticExposure": "Pasien baru-baru ini mengonsumsi antibiotik (dalam 2 minggu terakhir)",
  "microbiology.orderDetail.admissionDate": "Tanggal masuk",
  "microbiology.orderDetail.admissionDateFuture": "Tanggal masuk tidak boleh berada di masa depan.",
  "microbiology.orderDetail.admissionDateHelper": "Tanggal masuk sebagai pasien rawat inap. Biarkan kosong jika tidak diketahui.",
  "microbiology.orderDetail.admissionDateOutpatient": "Pasien rawat jalan tidak dirawat inap — dicatat sebagai pasien dari masyarakat.",
  "microbiology.orderDetail.collectionDateContext": "Tanggal Pengambilan: {date}",
  "microbiology.orderDetail.collectionTimingHospital": "Diambil {days} hari setelah masuk rumah sakit - berasal dari rumah sakit untuk keperluan surveilans.",
  "microbiology.orderDetail.collectionTimingCommunity": "Diambil pada {days} hari setelah masuk rumah sakit — berasal dari masyarakat untuk keperluan pengawasan.",
  "microbiology.orderDetail.clinicalHistory": "Riwayat klinis",
  "microbiology.orderDetail.cultureMethod": "Protokol Kultur",
  "microbiology.orderDetail.hint": "Catat konteks pemesanan yang diperlukan oleh laboratorium untuk pengaturan kultur dan tindak lanjut hasil kritis.",
  "microbiology.orderDetail.numberOfSets": "Jumlah set",
  "microbiology.orderDetail.numberOfSets.helper": "Grup sampel, seperti dua set kultur darah yang diambil dari lokasi yang berbeda. Bukan jumlah atau volume spesimen.",
  "microbiology.orderDetail.patientOrigin": "Asal pasien",
  "microbiology.orderDetail.protocolDerived": "Turunan",
  "microbiology.orderDetail.protocolHelper": "Dari pemeriksaan yang dipesan. Ubah di Meja Kerja jika alur pemeriksaan berbeda.",
  "microbiology.orderDetail.protocolUnset": "Belum ditentukan - Meja Kerja akan memilih protokol",
  "microbiology.orderDetail.protocolUnsetTitle": "Protokol belum ditetapkan",
  "microbiology.orderDetail.save": "Simpan detail pemesanan",
  "microbiology.orderDetail.title": "Rincian Pemesanan",
  "microbiology.patientOrigin.emergency": "Unit Gawat Darurat",
  "microbiology.patientOrigin.icu": "Unit perawatan intensif",
  "microbiology.patientOrigin.inpatient": "Ruang rawat inap",
  "microbiology.patientOrigin.other": "Lainnya",
  "microbiology.patientOrigin.outpatient": "Klinik rawat jalan",
  "microbiology.progress.ast": "Hasil AST",
  "microbiology.progress.caseInfo": "Informasi kasus",
  "microbiology.progress.inoculation": "Inokulasi",
  "microbiology.progress.isolates": "Isolat",
  "microbiology.progress.reports": "Laporan",
  "microbiology.progress.review": "Tinjauan ahli",
  "microbiology.progress.timeline": "Garis Waktu",
  "microbiology.progress.title": "Perkembangan kasus",
  "microbiology.protocol.noneTitle": "Tidak ada protokol yang ditetapkan",
  "microbiology.case.timeline.protocolChanged": "Protokol kultur telah diubah dari {from} menjadi {to}: {reason}",
  "microbiology.readiness.blocked": "Rilis final diblokir",
  "microbiology.readiness.ready": "Siap untuk dirilis secara resmi",
  "microbiology.reagentLots.blocked": "Diblokir: {reason}",
  "microbiology.reagentLots.context": "Konteks Meja Kerja",
  "microbiology.reagentLots.context.AST_SETUP": "Pengaturan AST",
  "microbiology.reagentLots.context.CULTURE_SETUP": "Pengaturan kultur",
  "microbiology.reagentLots.empty": "Tidak ada reagen yang terkait dengan pemeriksaan ini.",
  "microbiology.reagentLots.fefo": "FEFO - gunakan yang pertama",
  "microbiology.reagentLots.fifo.tooltip": "Lot diurutkan berdasarkan tanggal kedaluwarsa paling awal, kemudian berdasarkan tanggal penerimaan jika tanggal kedaluwarsa tidak tersedia.",
  "microbiology.reagentLots.hint": "Pilih nomor lot yang pasti digunakan untuk setiap reagen atau bahan habis pakai yang terkait.",
  "microbiology.reagentLots.history": "Catatan penggunaan lot",
  "microbiology.reagentLots.legend": "Lot yang tersedia untuk {reagent}",
  "microbiology.reagentLots.lot": "Lot",
  "microbiology.reagentLots.noExpiry": "Tidak ada tanggal kedaluwarsa yang tercatat",
  "microbiology.reagentLots.noLots": "Tidak ada lot inventaris yang tersedia untuk reagen ini.",
  "microbiology.reagentLots.option": "{lot}, {quantity} {unit} tersedia, masa berlakunya berakhir pada {expiration}",
  "microbiology.reagentLots.quantity": "{quantity} {unit}",
  "microbiology.reagentLots.quantityPerTest": "Kuantitas per Pemeriksaan: {quantity} {unit}",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_EXPIRED": "{reagent} Lot {lot} telah kedaluwarsa; pilih lot lain.",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_INSUFFICIENT_QUANTITY": "{reagent} Lot {lot} sudah tidak tersedia dalam jumlah yang cukup; silakan pilih lot lainnya.",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_QC_FAILED": "{reagent} Lot {lot} gagal QC; pilih lot yang telah lolos QC.",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_QC_NOT_PASSED": "{reagent} Lot {lot} belum lolos pemeriksaan kualitas (QC); silakan pilih lot yang sudah lolos pemeriksaan kualitas (QC).",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_UNAVAILABLE": "{reagent} Lot {lot} sudah tidak tersedia lagi; silakan segarkan halaman dan pilih lot lainnya.",
  "microbiology.reagentLots.qc.FAILED": "QC gagal",
  "microbiology.reagentLots.qc.PASSED": "QC lolos",
  "microbiology.reagentLots.qc.PENDING": "QC tertunda",
  "microbiology.reagentLots.qc.QUARANTINED": "QC dikarantina",
  "microbiology.reagentLots.reason.INVENTORY_LOT_CONSUMED": "Habis",
  "microbiology.reagentLots.reason.INVENTORY_LOT_EXPIRED": "Kedaluwarsa",
  "microbiology.reagentLots.reason.INVENTORY_LOT_INACTIVE": "Inaktif",
  "microbiology.reagentLots.reason.INVENTORY_LOT_INSUFFICIENT_QUANTITY": "Kuantitas tidak mencukupi",
  "microbiology.reagentLots.reason.INVENTORY_LOT_QC_FAILED": "QC gagal",
  "microbiology.reagentLots.reason.INVENTORY_LOT_QC_NOT_PASSED": "Tidak lolos QC",
  "microbiology.reagentLots.reagent": "Reagen atau bahan habis pakai",
  "microbiology.reagentLots.recorded": "Direkam",
  "microbiology.reagentLots.role.PRIMARY": "Primer",
  "microbiology.reagentLots.role.SECONDARY": "Sekunder",
  "microbiology.reagentLots.scan.ambiguous": "Nomor lot tersebut cocok dengan lebih dari satu reagen yang terkait. Pilih lot tersebut dalam daftar reagennya.",
  "microbiology.reagentLots.scan.label": "Pindai atau masukkan nomor lot",
  "microbiology.reagentLots.scan.notFound": "Tidak ada lot terkait yang cocok dengan nomor lot tersebut.",
  "microbiology.reagentLots.scan.placeholder": "Pindai atau masukkan nomor lot yang pasti",
  "microbiology.reagentLots.scan.selected": "Lot {lot} dipilih.",
  "microbiology.reagentLots.status": "Status lot saat ini",
  "microbiology.reagentLots.status.ACTIVE": "Aktif",
  "microbiology.reagentLots.status.CONSUMED": "Habis",
  "microbiology.reagentLots.status.IN_USE": "Sedang Digunakan",
  "microbiology.reagentLots.title": "Ketertelusuran reagen dan lot",
  "microbiology.reagentLots.used": "Kuantitas yang Digunakan",
  "microbiology.release.failed": "Laporan tersebut tidak dapat dipublikasikan. Periksa kembali persyaratannya, lalu coba lagi.",
  "microbiology.release.final": "Terbitkan laporan akhir",
  "microbiology.release.finalReleased": "Laporan akhir telah dirilis",
  "microbiology.release.hint": "Hanya publikasikan laporan jika pemeriksaan kesiapan telah lolos.",
  "microbiology.release.mappingConfigured": "Pemetaan laporan pasien telah dikonfigurasi",
  "microbiology.release.mappingRequired": "Pemetaan laporan pasien wajib untuk rilis akhir",
  "microbiology.release.noReportableContent": "Tidak ada hasil uji mikrobiologi yang siap dilaporkan.",
  "microbiology.release.notEvaluated": "Kesiapan belum dievaluasi",
  "microbiology.release.patientReport": "Pratinjau laporan pasien",
  "microbiology.release.preliminary": "Terbitkan laporan awal",
  "microbiology.release.readinessChecks": "Kesiapan rilis akhir",
  "microbiology.release.title": "Kesiapan laporan",
  "microbiology.release.viewPatientResults": "Lihat hasil pemeriksaan pasien",
  "microbiology.release.useAmendment": "Rilis versi yang telah diperbaiki dari Amandemen",
  "microbiology.release.whonetChecks": "Kesiapan WHONET",
  "microbiology.whonet.blocked": "Ekspor WHONET diblokir",
  "microbiology.whonet.ready": "Siap untuk ekspor ke WHONET",
  "microbiology.worklist.clearFilters": "Hapus filter",
  "microbiology.worklist.column.action": "Aksi",
  "microbiology.worklist.column.context": "Konteks",
  "microbiology.worklist.column.due": "Aksi yang semestinya",
  "microbiology.worklist.column.flags": "Penanda",
  "microbiology.worklist.column.isolate": "Isolat",
  "microbiology.worklist.column.labNumber": "Lab #",
  "microbiology.worklist.column.lastActivity": "Aktivitas terakhir oleh",
  "microbiology.worklist.column.organism": "Organisme",
  "microbiology.worklist.column.panel": "Panel",
  "microbiology.worklist.column.patient": "Pasien",
  "microbiology.worklist.column.priority": "Prioritas",
  "microbiology.worklist.column.sample": "Item sampel",
  "microbiology.worklist.column.specimen": "Spesimen",
  "microbiology.worklist.column.stage": "Tahapan",
  "microbiology.worklist.column.started": "Dimulai",
  "microbiology.worklist.column.status": "Status",
  "microbiology.worklist.column.urgency": "Urgensi",
  "microbiology.worklist.critical": "Komunikasi kritis",
  "microbiology.worklist.dueDetail.ast_entry": "Lakukan uji AST untuk isolat yang telah diidentifikasi.",
  "microbiology.worklist.dueDetail.ast_review": "Tinjau hasil uji kerentanan yang dilaporkan.",
  "microbiology.worklist.dueDetail.case_review": "Tinjau kesiapan laporan dan penerbitannya.",
  "microbiology.worklist.dueDetail.isolate_id": "Catat pertumbuhan dan identifikasi isolat tersebut.",
  "microbiology.worklist.dueDetail.incubating": "Hari ke-{day} dari {max}",
  "microbiology.worklist.dueDetail.setup": "Rekam langkah-langkah awal pengaturan kultur.",
  "microbiology.worklist.dueDetail.subculture_gram_stain": "Lakukan subkultur dan rekam hasil pewarnaan Gram.",
  "microbiology.worklist.empty.ast": "Tidak ada proses AST yang cocok. Kosongkan hasil pencarian atau pilih status yang lain.",
  "microbiology.worklist.empty.cultures": "Tidak ada kultur yang cocok. Kosongkan kriteria pencarian atau pilih status yang berbeda.",
  "microbiology.worklist.expertRulesUnavailable": "Penanda aturan ahli OpenELIS tersedia pada Fase 1B. Penanda yang dilaporkan oleh Alat akan ditampilkan jika ada.",
  "microbiology.worklist.filters": "Filter daftar pekerjaan",
  "microbiology.worklist.filter.allActions": "Semua aksi",
  "microbiology.worklist.filter.allStages": "Semua tahapan",
  "microbiology.worklist.filter.allUrgencies": "Semua tingkat urgensi",
  "microbiology.worklist.filter.activeAst": "Pekerjaan aktif",
  "microbiology.worklist.filter.astStatus": "Status AST",
  "microbiology.worklist.filter.dueAction": "Aksi yang semestinya",
  "microbiology.worklist.filter.reviewed": "Telah Ditinjau",
  "microbiology.worklist.filter.stage": "Tahapan",
  "microbiology.worklist.filter.urgency": "Urgensi",
  "microbiology.worklist.flagsUnavailable": "Aturan ahli (Fase 1B)",
  "microbiology.worklist.loadError.subtitle": "Antrean tidak dapat dimuat. Silakan segarkan halaman ini.",
  "microbiology.worklist.loadError.title": "Tidak dapat memuat daftar pekerjaan mikrobiologi",
  "microbiology.worklist.editAst": "Edit AST",
  "microbiology.worklist.grain.ast": "Proses AST",
  "microbiology.worklist.grain.cultures": "Kultur",
  "microbiology.worklist.notSet": "Belum ditentukan",
  "microbiology.worklist.notStarted": "Belum dimulai",
  "microbiology.worklist.markLost": "Tandai hilang",
  "microbiology.worklist.markNoGrowth": "Tandai tidak ada pertumbuhan",
  "microbiology.worklist.markPositive": "Tanda positif",
  "microbiology.worklist.openCase": "Buka kasus",
  "microbiology.worklist.newAstAttempt": "Siapkan proses AST baru",
  "microbiology.worklist.newPositive": "Hasil positif baru",
  "microbiology.worklist.phase1b": "Tersedia pada Fase 1B",
  "microbiology.worklist.print": "Cetak daftar",
  "microbiology.worklist.qcDashboard": "Dasbor QC",
  "microbiology.worklist.queueStatus": "Antrian bersama",
  "microbiology.worklist.refresh": "Segarkan sekarang",
  "microbiology.worklist.rowActions": "Aksi baris",
  "microbiology.worklist.recentActivity.empty": "Tidak ada aktivitas mikrobiologi baru-baru ini.",
  "microbiology.worklist.recentActivity.title": "Aktivitas terbaru ({count})",
  "microbiology.worklist.resistance.hint": "Penanda yang dilaporkan oleh Alat telah selesai hari ini; deteksi aturan ahli OpenELIS masih pada Fase 1B.",
  "microbiology.worklist.resistance.title": "Temuan resistensi hari ini",
  "microbiology.worklist.search.ast": "Cari nomor registrasi laboratorium, pasien, isolat, organisme, atau panel",
  "microbiology.worklist.search.cultures": "Cari nomor registrasi laboratorium, pasien, atau spesimen",
  "microbiology.worklist.sharedQueue": "Antrian laboratorium bersama",
  "microbiology.worklist.setupAst": "Siapkan AST",
  "microbiology.worklist.sort": "Urutkan",
  "microbiology.worklist.sort.newest": "Aktivitas terbaru",
  "microbiology.worklist.sort.priority": "Prioritas",
  "microbiology.worklist.sort.workflow": "Alur Kerja",
  "microbiology.worklist.subtitle": "Prioritaskan kasus kultur berdasarkan tahapan alur kerja, tingkat urgensi, dan tindakan laboratorium yang wajib dilakukan.",
  "microbiology.worklist.summary.astReview": "Tinjauan AST",
  "microbiology.worklist.summary.astInProgress": "Dalam pengerjaan",
  "microbiology.worklist.summary.astInQueue": "Sedang dalam antrian",
  "microbiology.worklist.summary.astPendingSetup": "Tertunda dalam pengaturan",
  "microbiology.worklist.summary.astResultsIn": "Hasil masuk - tinjau",
  "microbiology.worklist.summary.caseReview": "Siap untuk peninjauan kasus",
  "microbiology.worklist.summary.critical": "Tindak lanjut kritis yang masih terbuka",
  "microbiology.worklist.summary.growthDetected": "Terdeteksi adanya pertumbuhan",
  "microbiology.worklist.summary.hint": "Pilih antrian untuk memperbarui daftar kasus.",
  "microbiology.worklist.summary.identification": "Proses identifikasi sedang dalam pengerjaan",
  "microbiology.worklist.summary.incubating": "Sedang inkubasi",
  "microbiology.worklist.summary.positive": "Positif",
  "microbiology.worklist.summary.expertFlags": "Penanda ahli (1B)",
  "microbiology.worklist.summary.title": "Pekerjaan yang memerlukan aksi",
  "microbiology.worklist.summary.totalPending": "Total yang masih tertunda",
  "microbiology.worklist.table.hint": "Kasus-kasus diurutkan berdasarkan tingkat urgensi dan aksi berikutnya yang wajib dilakukan.",
  "microbiology.worklist.table.astTitle": "Proses AST",
  "microbiology.worklist.table.title": "Kasus-kasus mikrobiologi yang masih terbuka",
  "microbiology.worklist.viewAudit": "Lihat hasil audit",
  "microbiology.worklist.viewReviewedAst": "Lihat AST yang telah ditinjau",
  "microbiology.worklist.whonetExport": "Ekspor ke WHONET",
  "microbiology.worklist.surveillance.title": "Ruang Lingkup pemantauan",
  "microbiology.worklist.surveillance.description": "Saring baris AST berdasarkan periode pelaporan dan bidang pengawasan terstruktur. Filter antrian operasional tidak mengubah populasi ekspor.",
  "microbiology.worklist.ast.automaticResults": "Hasil Alat masuk secara otomatis",
  "microbiology.worklist.ast.automaticResultsDetail": "Alat yang terhubung mengirimkan hasil langsung ke kasus. Kejadian yang gagal atau tidak cocok disimpan di Masalah Impor Alat.",
  "microbiology.worklist.ast.awaitingResults": "Menunggu hasil dari Alat",
  "microbiology.worklist.ast.pendingIdentification": "Identifikasi tertunda",
  "microbiology.worklist.ast.resultsInBadge": "Hasil masuk",
  "microbiology.worklist.title": "Daftar Pekerjaan Mikrobiologi",
  "microbiology.worklist.updated": "Diperbarui {seconds} detik yang lalu · penyegaran otomatis 30 detik",
  "microbiology.admin.action.deactivate": "Nonaktifkan",
  "microbiology.admin.action.moveDown": "Geser ke bawah",
  "microbiology.admin.action.moveUp": "Geser ke atas",
  "microbiology.admin.action.reactivate": "Aktifkan Ulang",
  "microbiology.admin.actions": "Aksi baris",
  "microbiology.admin.antibiotics.add": "Tambah antibiotik",
  "microbiology.admin.antibiotics.description": "Kosakata antimikroba yang digunakan oleh panel AST dan aturan breakpoint.",
  "microbiology.admin.antibiotics.edit": "Antibiotik",
  "microbiology.admin.antibiotics.title": "Antibiotik",
  "microbiology.admin.astPanels.add": "Tambah panel AST",
  "microbiology.admin.astPanels.antibiotic": "Antibiotik",
  "microbiology.admin.astPanels.behavior.always": "Selalu",
  "microbiology.admin.astPanels.behavior.cascade": "Bertingkat",
  "microbiology.admin.astPanels.behavior.resistant": "Hanya jika resisten",
  "microbiology.admin.astPanels.current": "Saat ini",
  "microbiology.admin.astPanels.confirmDeactivate": "Terbitkan versi {version} sebagai tidak tersedia untuk pekerjaan baru? Proses AST yang sudah ada akan tetap menggunakan versi panel aslinya.",
  "microbiology.admin.astPanels.confirmPublish": "Terbitkan versi {version}? Proses AST yang sudah ada akan tetap menggunakan versi panel aslinya.",
  "microbiology.admin.astPanels.confirmTitle": "Konfirmasi publikasi panel",
  "microbiology.admin.astPanels.historical": "Historis",
  "microbiology.admin.astPanels.loadingEditor": "Administrasi panel AST sedang dimuat.",
  "microbiology.admin.astPanels.publishVersion": "Rilis versi baru",
  "microbiology.admin.astPanels.readOnly": "Versi historis ini hanya dapat dibaca. Buka versi terkini untuk mempublikasikan perubahan.",
  "microbiology.admin.astPanels.reportBehavior": "Perilaku pelaporan",
  "microbiology.admin.astPanels.tier": "Tingkat",
  "microbiology.admin.astPanels.title": "Panel AST",
  "microbiology.admin.astPanels.version": "Versi",
  "microbiology.admin.astPanels.versionNotice": "Menyimpan akan membuat versi panel baru; proses AST yang sudah ada tetap mempertahankan versi aslinya.",
  "microbiology.admin.astPanels.viewVersion": "Lihat versi",
  "microbiology.admin.breakpoints.activate": "Aktifkan standar",
  "microbiology.admin.breakpoints.applyValid": "Terapkan baris yang valid",
  "microbiology.admin.breakpoints.archive": "Arsipkan standar",
  "microbiology.admin.breakpoints.archiveConfirm": "Standar ini akan tetap tersedia untuk proses AST historis, namun tidak dapat dipilih untuk pekerjaan baru.",
  "microbiology.admin.breakpoints.back": "Kembali ke standar",
  "microbiology.admin.breakpoints.breakpointType": "Jenis breakpoint",
  "microbiology.admin.breakpoints.chooseFile": "Pilih file CSV",
  "microbiology.admin.breakpoints.correction.add": "Tambah koreksi lokal",
  "microbiology.admin.breakpoints.correction.edit": "Edit koreksi lokal",
  "microbiology.admin.breakpoints.count.imported": "{count} diimpor",
  "microbiology.admin.breakpoints.count.skipped": "{count} dilewati",
  "microbiology.admin.breakpoints.count.unchanged": "{count} tidak berubah",
  "microbiology.admin.breakpoints.count.valid": "{count} valid",
  "microbiology.admin.breakpoints.csv": "CSV breakpoint",
  "microbiology.admin.breakpoints.description": "Standar breakpoint yang dimuat dan versi yang aktif untuk proses AST baru.",
  "microbiology.admin.breakpoints.detail": "Aturan breakpoint",
  "microbiology.admin.breakpoints.downloadRejected": "Unduh baris yang ditolak",
  "microbiology.admin.breakpoints.effectiveDate": "Tanggal Efektif",
  "microbiology.admin.breakpoints.import": "Impor CSV",
  "microbiology.admin.breakpoints.intermediate": "Intermediet",
  "microbiology.admin.breakpoints.intermediateLower": "Batas bawah intermediet",
  "microbiology.admin.breakpoints.intermediateUpper": "Batas atas intermediet",
  "microbiology.admin.breakpoints.groupOption": "Grup: {name}",
  "microbiology.admin.breakpoints.method.all": "Semua metode",
  "microbiology.admin.breakpoints.method.zone": "Zona",
  "microbiology.admin.breakpoints.organism": "Organisme atau kelompok",
  "microbiology.admin.breakpoints.organismGroup": "Grup organisme",
  "microbiology.admin.breakpoints.publisher": "Penerbit",
  "microbiology.admin.breakpoints.resistant": "Resisten",
  "microbiology.admin.breakpoints.rowError": "Baris ke-{row}",
  "microbiology.admin.breakpoints.rules": "Aturan",
  "microbiology.admin.breakpoints.source": "Sumber",
  "microbiology.admin.breakpoints.source.imported": "Diimpor",
  "microbiology.admin.breakpoints.source.local": "Koreksi lokal",
  "microbiology.admin.breakpoints.source.manual": "Manual",
  "microbiology.admin.breakpoints.specimen": "Konteks spesimen",
  "microbiology.admin.breakpoints.specimen.any": "Spesimen apa saja",
  "microbiology.admin.breakpoints.status.active": "Aktif",
  "microbiology.admin.breakpoints.status.archived": "Diarsipkan",
  "microbiology.admin.breakpoints.status.loaded": "Dimuat",
  "microbiology.admin.breakpoints.susceptible": "Sensitif",
  "microbiology.admin.breakpoints.title": "Standar breakpoint",
  "microbiology.admin.breakpoints.units": "Unit",
  "microbiology.admin.breakpoints.view": "Lihat Aturan",
  "microbiology.admin.filter.all": "Semua",
  "microbiology.admin.sort": "Urutkan",
  "microbiology.admin.sort.nameAsc": "Nama A-Z",
  "microbiology.admin.sort.nameDesc": "Nama Z-A",
  "microbiology.admin.deactivate.impact": "{name} digunakan oleh {count, plural, one {# catatan alur kerja yang ada} other {# catatan alur kerja yang ada}}. Penonaktifan mencegah pemilihan baru tetapi tetap mempertahankan rujukan historis tersebut.",
  "microbiology.admin.deactivate.title": "Meninjau dampak penonaktifan",
  "microbiology.admin.deactivated": "Referensi sudah inaktif",
  "microbiology.admin.empty": "Tidak ada catatan referensi yang cocok",
  "microbiology.admin.error.save": "Catatan referensi tidak dapat disimpan.",
  "microbiology.admin.error.title": "Permintaan tidak dapat diselesaikan",
  "microbiology.admin.field.active": "Tersedia untuk pekerjaan baru",
  "microbiology.admin.field.atmosphere": "Pengaturan default atmosfer",
  "microbiology.admin.field.class": "Kelas",
  "microbiology.admin.field.code": "Kode",
  "microbiology.admin.field.defaultPanel": "Panel AST bawaan",
  "microbiology.admin.field.defaultPanelId": "ID panel AST default",
  "microbiology.admin.field.gramStain": "Pewarnaan Gram",
  "microbiology.admin.field.group": "Grup organisme",
  "microbiology.admin.field.incubation": "Pengaturan default inkubasi",
  "microbiology.admin.field.incubationHours": "Interval pembacaan Rutin (jam)",
  "microbiology.admin.field.subcultureAtHours": "Subkultur pada (jam)",
  "microbiology.admin.field.maxIncubationDays": "Waktu inkubasi maksimum (hari)",
  "microbiology.admin.field.media": "Pengaturan default media",
  "microbiology.admin.field.method": "Metode",
  "microbiology.admin.field.methodId": "ID Metode",
  "microbiology.admin.field.name": "Nama",
  "microbiology.admin.field.notes": "Catatan",
  "microbiology.admin.field.oclCode": "Kode OCL",
  "microbiology.admin.field.reportableAnalyteId": "ID analit yang dapat dilaporkan",
  "microbiology.admin.field.route": "Rute",
  "microbiology.admin.field.shortName": "Nama singkat",
  "microbiology.admin.field.significance": "Signifikansi awal",
  "microbiology.admin.field.whonetCode": "Kode WHONET",
  "microbiology.admin.organisms.add": "Tambahkan organisme",
  "microbiology.admin.organisms.description": "Kosakata organisme yang digunakan oleh identifikasi kultur dan AST.",
  "microbiology.admin.organisms.edit": "Organisme",
  "microbiology.admin.organisms.title": "Organisme",
  "microbiology.admin.patientOrigins.description": "Pilihan asal pasien yang dikonfigurasi dan digunakan saat entri pemesanan mikrobiologi dan ekspor WHONET.",
  "microbiology.admin.patientOrigins.title": "Asal pasien",
  "microbiology.admin.reactivated": "Referensi telah diaktifkan ulang",
  "microbiology.admin.route.both": "Pemberian melalui mulut dan infus",
  "microbiology.admin.route.iv": "IV",
  "microbiology.admin.route.oral": "Oral",
  "microbiology.admin.route.topical": "Topikal",
  "microbiology.admin.saved": "Referensi telah disimpan",
  "microbiology.admin.search": "Cari data referensi",
  "microbiology.admin.sections": "Bagian referensi mikrobiologi",
  "microbiology.admin.significance.possible": "Kemungkinan patogen",
  "microbiology.admin.significance.rare": "Patogen langka",
  "microbiology.admin.significance.usually": "Biasanya signifikan",
  "microbiology.admin.status": "Status",
  "microbiology.admin.status.active": "Aktif",
  "microbiology.admin.status.all": "Semua status",
  "microbiology.admin.status.inactive": "Inaktif",
  "microbiology.admin.title": "Data referensi mikrobiologi",
  "button.add": "Tambah",
  "button.remove": "Hapus",
  "sidenav.label.microbiology": "Mikrobiologi",
  "sidenav.label.microbiology.worklist": "Daftar Pekerjaan Mikrobiologi",
  "sidenav.label.microbiology.whonet": "Ekspor WHONET",
  "microbiology.whonet.title": "Ekspor WHONET",
  "microbiology.whonet.eyebrow": "Pemantauan bakteriologi rutin",
  "microbiology.whonet.subtitle": "Tinjau data kultur dan AST yang telah difinalisasi sebelum membuat berkas CSV surveilans OpenELIS terbaru untuk validasi WHONET.",
  "microbiology.whonet.progress": "Kemajuan ekspor WHONET",
  "microbiology.whonet.step.configure": "Konfigurasi",
  "microbiology.whonet.step.preview": "Pratinjau",
  "microbiology.whonet.step.generate": "Membuat",
  "microbiology.whonet.configure.title": "Konfigurasi ekspor",
  "microbiology.whonet.configure.description": "Pilih periode pelaporan dan isolat yang akan dimasukkan.",
  "microbiology.whonet.from": "Dari",
  "microbiology.whonet.to": "Kepada",
  "microbiology.whonet.date.placeholder": "yyyy-mm-dd",
  "microbiology.whonet.period.invalid": "Tanggal Selesai harus sama dengan atau setelah tanggal awal.",
  "microbiology.whonet.period.preset": "Periode pelaporan",
  "microbiology.whonet.period.thisMonth": "Bulan ini",
  "microbiology.whonet.period.lastMonth": "Bulan lalu",
  "microbiology.whonet.period.thisQuarter": "Triwulan ini",
  "microbiology.whonet.period.custom": "Kustom",
  "microbiology.whonet.source.worklist.title": "Ruang Lingkup yang disediakan oleh daftar kerja AST",
  "microbiology.whonet.source.worklist.description": "Periode pelaporan dan filter pengawasan terstruktur diambil dari daftar tugas AST. Keduanya masih dapat diedit di sini.",
  "microbiology.whonet.source.worklist.clear": "Kosongkan ruang lingkup daftar pekerjaan",
  "microbiology.whonet.significance": "Inklusi",
  "microbiology.whonet.significance.clinical": "Isolat yang signifikan secara klinis",
  "microbiology.whonet.significance.all": "Semua isolat",
  "microbiology.whonet.significance.CLINICALLY_SIGNIFICANT": "Signifikan secara klinis",
  "microbiology.whonet.significance.CONTAMINANT": "Kontaminan",
  "microbiology.whonet.significance.NORMAL_FLORA": "Flora normal",
  "microbiology.whonet.significance.UNKNOWN": "Tidak diklasifikasikan",
  "microbiology.whonet.culturePurpose.description": "Kultur klinis sudah termasuk secara default. Tambah populasi lain secara eksplisit jika pertanyaan surveilans mengharuskannya.",
  "microbiology.whonet.culturePurpose.includeScreening": "Sertakan skrining aktif atau kultur pembawa",
  "microbiology.whonet.culturePurpose.includeUnspecified": "Sertakan kultur historis yang tujuannya tidak ditentukan",
  "microbiology.whonet.culturePurpose.title": "Tujuan kultur",
  "microbiology.whonet.filter.specimen": "Jenis Spesimen",
  "microbiology.whonet.filter.organism": "Organisme",
  "microbiology.whonet.filter.origin": "Asal pasien",
  "microbiology.whonet.filter.any": "Apa saja",
  "microbiology.whonet.filter.choose": "Pilih nilai",
  "microbiology.whonet.dedup": "Penghapusan duplikasi",
  "microbiology.whonet.dedup.apply": "Terapkan seleksi isolat pertama",
  "microbiology.whonet.dedup.apply.help": "Gabungkan isolat yang berulang dari pasien dan mikroorganisme yang sama dalam rentang waktu yang dipilih.",
  "microbiology.whonet.dedup.advanced": "Sesuaikan kebijakan isolat pertama",
  "microbiology.whonet.dedup.window": "Panjang jendela",
  "microbiology.whonet.dedup.window.help": "Pengulangan tepat pada batas hari yang dipilih akan membuka jendela baru.",
  "microbiology.whonet.dedup.sevenDay": "7 hari",
  "microbiology.whonet.dedup.fourteenDay": "14 hari",
  "microbiology.whonet.dedup.thirtyDay": "30 hari",
  "microbiology.whonet.dedup.basis": "Tanggal acuan jendela",
  "microbiology.whonet.dedup.basis.collection": "Tanggal Pengambilan Spesimen",
  "microbiology.whonet.dedup.basis.release": "Tanggal pengumuman hasil akhir",
  "microbiology.whonet.dedup.basis.help": "Pilih apakah jendela waktu tersebut mengacu pada pengambilan spesimen atau pengumuman Hasil Akhir. Periode pelaporan selalu mengacu pada tanggal pengambilan spesimen.",
  "microbiology.whonet.dedup.scope": "Ruang Lingkup sumber spesimen",
  "microbiology.whonet.dedup.scope.any": "Sumber spesimen apa saja",
  "microbiology.whonet.dedup.scope.same": "Hanya dari sumber spesimen yang sama",
  "microbiology.whonet.dedup.scope.help": "Sumber apa saja membandingkan pasien dan organisme di seluruh jenis spesimen; sumber yang sama membandingkan di dalam masing-masing jenis spesimen.",
  "microbiology.whonet.dedup.contaminants": "Singkirkan kemungkinan kontaminan sebelum pemilihan",
  "microbiology.whonet.dedup.contaminants.help": "Hapus kemungkinan kontaminan sebelum memilih isolat representatif pertama.",
  "microbiology.whonet.dedup.profile": "Profil kerentanan",
  "microbiology.whonet.dedup.profile.insensitive": "Abaikan perubahan S/I/R",
  "microbiology.whonet.dedup.profile.sensitive": "Perlakukan S/I/R yang telah mengalami perubahan sebagai yang baru",
  "microbiology.whonet.dedup.profile.help": "Seleksi peka profil menghitung pola S/I/R antibiotik yang telah ditinjau dan berbeda sebagai isolat baru dalam jendela waktu tersebut.",
  "microbiology.whonet.dedup.none": "Tidak ada deduplikasi",
  "microbiology.whonet.preview.action": "Pratinjau ekspor",
  "microbiology.whonet.preview.title": "Pratinjau",
  "microbiology.whonet.preview.description": "Jumlah dan baris ini akan digunakan saat file CSV dibuat.",
  "microbiology.whonet.generate.action": "Membuat File CSV",
  "microbiology.whonet.count.cases": "Kasus yang telah difinalisasi",
  "microbiology.whonet.count.clinicalPurpose": "Kultur klinis",
  "microbiology.whonet.count.screeningPurpose": "Kultur penyaringan",
  "microbiology.whonet.count.unspecifiedPurpose": "Kultur yang tujuannya tidak ditentukan",
  "microbiology.whonet.count.purposeIncluded": "Setelah seleksi berdasarkan tujuan kultur",
  "microbiology.whonet.count.isolates": "Isolat yang ditemukan",
  "microbiology.whonet.count.specimen": "Setelah filter spesimen",
  "microbiology.whonet.count.organism": "Setelah filter organisme",
  "microbiology.whonet.count.origin": "Setelah filter asal",
  "microbiology.whonet.count.included": "Isolat yang disertakan",
  "microbiology.whonet.count.deduplicated": "Setelah proses deduplikasi",
  "microbiology.whonet.count.mappable": "Isolat yang dapat dipetakan",
  "microbiology.whonet.count.rows": "Baris yang memenuhi syarat",
  "microbiology.whonet.count.excluded": "Baris yang dikecualikan",
  "microbiology.whonet.mapping.title": "Kesiapan pemetaan",
  "microbiology.whonet.mapping.excluded": "{count, plural, other {# baris dikecualikan}} from this export.",
  "microbiology.whonet.mapping.fixOrganism": "Perbaiki pemetaan organisme",
  "microbiology.whonet.mapping.fixAntibiotic": "Perbaiki pemetaan antibiotik",
  "microbiology.whonet.mapping.fixSpecimen": "Perbaiki pemetaan spesimen",
  "microbiology.whonet.table.title": "Baris AST yang memenuhi syarat",
  "microbiology.whonet.table.description": "Hasil pengukuran AST yang telah diperiksa dan layak untuk dilaporkan, beserta pemetaan yang wajib dilakukan oleh Ekspor ini.",
  "microbiology.whonet.table.accession": "No. Registrasi",
  "microbiology.whonet.table.specimen": "Spesimen",
  "microbiology.whonet.table.organism": "Organisme",
  "microbiology.whonet.table.antibiotic": "Antibiotik",
  "microbiology.whonet.table.interpretation": "S / I / R",
  "microbiology.whonet.table.method": "Metode",
  "microbiology.whonet.error.title": "Ekspor WHONET tidak dapat diselesaikan",
  "microbiology.whonet.error.invalidRequest": "Periksa periode laporan dan opsi ekspor, lalu coba lagi.",
  "microbiology.whonet.error.blocked": "Tidak ada baris yang valid yang tersisa. Selesaikan masalah kesiapan yang tercantum sebelum membuat file CSV.",
  "microbiology.whonet.error.network": "Layanan ekspor tidak dapat diakses. Silakan coba lagi saat koneksi sudah tersedia.",
  "microbiology.whonet.error.generic": "Permintaan ekspor tidak dapat diselesaikan.",
  "microbiology.whonet.preview.loading": "Sedang menyiapkan pratinjau ekspor.",
  "microbiology.whonet.preview.announced": "Pratinjau siap dengan {count, plural, one {# baris yang memenuhi syarat} other {# baris yang memenuhi syarat}}.",
  "microbiology.whonet.generated.title": "CSV telah dibuat",
  "microbiology.whonet.generated.subtitle": "Ekspor yang telah diverifikasi telah diunduh dan ringkasan auditnya telah dicatat.",
  "catalog.import.title": "Impor Katalog (CSV)",
  "catalog.import.description": "Muat file katalog pemeriksaan tanpa mengedit pemeriksaan satu per satu. Pratinjau memeriksa setiap file terhadap katalog saat ini dan tidak menyimpan apa pun, sehingga baris yang membutuhkan Instalasi Lab, sampel, atau pemeriksaan yang dibuat oleh file lain dalam unggahan yang sama akan tercantum sebagai dilewati hingga Anda menerapkannya. Terapkan memuat file secara berurutan dan menyimpannya bersama konfigurasi, sehingga saat mulai ulang berikutnya sistem memuat persis apa yang Anda terapkan.",
  "catalog.import.dropzone": "Tambahkan file CSV",
  "catalog.import.preview": "Pratinjau",
  "catalog.import.apply": "Terapkan",
  "catalog.import.remove": "Hapus",
  "catalog.import.plan.title": "Yang akan dilakukan file-file ini",
  "catalog.import.result.title": "Yang telah dimuat",
  "catalog.import.column.file": "File",
  "catalog.import.column.domain": "Area katalog",
  "catalog.import.column.created": "Dibuat",
  "catalog.import.column.updated": "Terbarui",
  "catalog.import.column.skipped": "Dilewati",
  "catalog.import.column.name": "Nama dalam file",
  "catalog.import.column.where": "Lokasi kemunculan",
  "catalog.import.column.use": "Gunakan catatan ini",
  "catalog.import.file.error": "File ini tidak dapat dibaca",
  "catalog.import.applied": "File katalog telah diterapkan.",
  "catalog.import.applied.partial": "Beberapa file katalog tidak dimuat. Tabel menunjukkan file mana dan alasannya.",
  "catalog.import.apply.failed": "File katalog tidak diterapkan.",
  "catalog.import.apply.hint": "Pratinjau file terlebih dahulu. Terapkan dapat digunakan setelah pratinjau tidak menunjukkan error file.",
  "catalog.import.failed": "File katalog tidak dapat dikirim.",
  "catalog.import.unresolved.title": "Memerlukan Keputusan Anda",
  "catalog.import.unresolved.description": "Nama yang tidak dapat dicocokkan oleh impor dengan catatan apa pun. Arahkan masing-masing ke catatan yang dimaksud, atau lewati. Mengingat sebuah nama akan menyelesaikannya secara otomatis di lain waktu.",
  "catalog.import.unresolved.empty": "Tidak ada yang menunggu keputusan.",
  "catalog.import.remember": "Ingat nama ini",
  "catalog.import.resolve": "Gunakan",
  "catalog.import.skip": "Lewati",
  "sidenav.label.admin.catalogImport": "Impor Katalog (CSV)",
  "reporting.design.subtitle": "Buat CSV untuk pertanyaan baru atau jalankan ulang laporan yang sudah dikenal untuk periode baru.",
  "reporting.design.overview": "Ikhtisar ekspor",
  "reporting.design.newTitle": "Buat ekspor baru",
  "reporting.design.newHelp": "Pilih jenis laporan, bidang yang Anda perlukan, dan periode pelaporan. Pekerjaan Anda tetap tersedia jika Anda membuka antrian atau kembali nanti.",
  "reporting.design.savedTitle": "Gunakan laporan tersimpan",
  "reporting.design.savedHelp": "Gunakan kembali bidang dan filter yang tersimpan, lalu pilih periode laporan baru.",
  "reporting.design.start": "Mulai ekspor baru",
  "reporting.design.continue": "Lanjutkan ekspor saat ini",
  "reporting.design.newExport": "Ekspor baru",
  "reporting.design.useReport": "Gunakan laporan",
  "reporting.design.savedFields": "{count} bidang tersimpan · periode laporan tidak pernah disimpan",
  "reporting.design.steps": "Langkah ekspor",
  "reporting.design.chooseColumns": "Pilih kolom",
  "reporting.design.setFilters": "Atur Filter",
  "reporting.design.reviewSubmit": "Tinjau & Kirim",
  "reporting.design.typeQuestion": "Informasi apa yang Anda butuhkan?",
  "reporting.design.typeHelp": "Pilih satu jenis laporan agar setiap baris CSV memiliki makna yang jelas. Anda dapat mengubah jenis hingga Anda memilih bidang.",
  "reporting.design.type.SAMPLE_TESTING": "Sampel & Pemeriksaan",
  "reporting.design.type.REFERRALS": "Rujukan",
  "reporting.design.type.NON_CONFORMANCE": "Ketidaksesuaian",
  "reporting.design.typeHelp.SAMPLE_TESTING": "Pemesanan, hasil, pasien & waktu penyelesaian",
  "reporting.design.typeHelp.REFERRALS": "Pemeriksaan yang dirujuk ke laboratorium lain · mempertahankan hasil yang dikembalikan dan rujukan yang tertunda",
  "reporting.design.typeHelp.NON_CONFORMANCE": "Sampel ditolak & kejadian ketidaksesuaian · mempertahankan sampel terkait dan kejadian yang terpisah",
  "reporting.design.pending": "Belum terhubung",
  "reporting.design.building": "Anda sedang menyusun laporan {type}.",
  "reporting.design.changeType": "Ubah jenis dan kosongkan bidang",
  "reporting.design.chooseType": "Pilih jenis laporan untuk melihat bidangnya.",
  "reporting.design.configuredReports": "Laporan yang dikonfigurasi",
  "reporting.design.chooseConfigured": "Pilih laporan yang telah dikonfigurasi",
  "reporting.design.available": "Bidang yang tersedia",
  "reporting.design.findField": "Cari bidang",
  "reporting.design.searchPlaceholder": "Cari semua bidang dan grup…",
  "reporting.design.clearSearch": "Hapus pencarian",
  "reporting.design.fieldCount": "{count} bidang dalam {groups} kelompok",
  "reporting.design.matchCount": "{count} bidang yang cocok dalam {groups} kelompok",
  "reporting.design.expansion": "Perluas atau ciutkan kelompok bidang",
  "reporting.design.expandAll": "Perluas semua",
  "reporting.design.collapseAll": "Ciutkan semua",
  "reporting.design.groupCount": "{added} / {total} ditambahkan",
  "reporting.design.scrollCatalog": "Katalog bidang yang dapat digulir",
  "reporting.design.addShown": "Tambah semua yang ditampilkan",
  "reporting.design.removeShown": "Hapus yang ditampilkan",
  "reporting.design.addShownGroup": "Tambah semua bidang {group} yang ditampilkan",
  "reporting.design.removeShownGroup": "Hapus semua bidang {group} yang ditampilkan",
  "reporting.design.addField": "Tambah {field}",
  "reporting.design.addedField": "{field} ditambahkan",
  "reporting.design.add": "+ Tambah",
  "reporting.design.added": "Ditambahkan",
  "reporting.design.noFields": "Tidak ada bidang yang cocok dengan pencarian Anda.",
  "reporting.design.selectedCount": "Kolom CSV Anda ({count})",
  "reporting.design.orderHelp": "Seret pegangan untuk mengubah urutan kolom, atau gunakan tombol panah. Tombol panah memindahkan pegangan yang difokuskan; Home dan End memindahkannya ke posisi pertama atau terakhir.",
  "reporting.design.columnOrder": "Kolom CSV secara berurutan",
  "reporting.design.drag": "Seret {field} untuk mengubah urutan",
  "reporting.design.move": "Pindahkan {field}",
  "reporting.design.emptyColumns": "Tambahkan bidang untuk menyusun CSV Anda.",
  "reporting.design.addedMessage": "{field} ditambahkan. {count} kolom.",
  "reporting.design.removedMessage": "{field} dihapus. {count} kolom.",
  "reporting.design.columnViews": "Tampilan penyusun kolom",
  "reporting.design.yourColumns": "Kolom Anda ({count})",
  "reporting.design.csvPreview": "Pratinjau CSV",
  "reporting.design.previewHelp": "Tata letak kolom sesuai urutan yang akan muncul di CSV yang Anda unduh.",
  "reporting.design.scrollPreview": "Pratinjau CSV yang dapat digulir",
  "reporting.design.nextFilters": "Berikutnya: Atur Filter",
  "reporting.design.nextReview": "Berikutnya: Tinjau & Kirim",
  "reporting.design.scopeFilters": "Filter Ruang Lingkup (Opsional)",
  "reporting.design.periodDays": "{count, plural, other {# hari}}",
  "reporting.design.moreFilters": "Tampilkan filter lainnya",
  "reporting.design.hideFilters": "Sembunyikan filter lainnya",
  "reporting.design.sampleStatus": "Status Sampel",
  "reporting.design.referringSite": "Tempat Perujuk",
  "reporting.design.reviewConfiguration": "Tinjau Konfigurasi",
  "reporting.design.dateFilters": "Rentang Tanggal dan filter",
  "reporting.design.testStatus": "Pemeriksaan dan status",
  "reporting.design.change": "Ubah",
  "reporting.design.deliveryHelp": "CSV Anda akan dibuat di latar belakang. Unduh di sini setelah siap, atau kembali ke Antrian Laporan Saya.",
  "reporting.design.fileName": "Nama File",
  "reporting.design.customFileName": "Nama file khusus",
  "reporting.design.fileNamePending": "Nama file dibuat secara otomatis. Nama khusus belum tersambung.",
  "reporting.design.saveLater": "Simpan pengaturan laporan ini untuk nanti",
  "reporting.design.saveSettings": "Simpan pengaturan laporan",
  "reporting.design.queueHelp": "Lihat dan unduh ekspor CSV Anda yang ada dalam antrian.",
  "reporting.design.queue.jobName": "Nama Pekerjaan",
  "reporting.design.queue.report": "Laporan",
  "reporting.design.queue.size": "Baris / Ukuran File",
  "reporting.design.queue.submitted": "Dikirim Pada",
  "reporting.design.queuePending": "Pekerjaan aktif diperbarui secara otomatis. Ulangi ekspor yang gagal, batalkan pekerjaan dalam antrian, atau jalankan ulang laporan kedaluwarsa dengan tanggal baru. Penghapusan pekerjaan belum terhubung.",
  "reporting.design.details": "Rincian",
  "reporting.design.expires": "Tersedia hingga {date}",
  "reporting.design.jobsShown": "Menampilkan {count} pekerjaan",
  "reporting.design.jobAction.EXPIRED": "Jalankan ulang",
  "reporting.design.labScope": "Cakupan Lab",
  "reporting.design.reviewFields": "Bidang Terpilih ({count})",
  "reporting.recovery.cancelTitle": "Batalkan ekspor",
  "reporting.recovery.keepQueued": "Tetap dalam antrian",
  "reporting.recovery.cancelHelp": "Batalkan ekspor dalam antrian ini? Jika pemrosesan sudah dimulai, pemrosesan akan tetap berjalan dan Anda dapat kembali ke hasilnya.",
  "reporting.job.cannotCancel": "Ekspor ini sudah dimulai atau selesai dan tidak dapat dibatalkan.",
  "reporting.job.cannotRetry": "Hanya ekspor yang gagal yang dapat diulang. Gunakan pekerjaan saat ini atau mulai ekspor baru.",
  "reporting.job.interrupted": "Pemrosesan terputus. Ulangi ekspor ini untuk membuat file baru.",
  "reporting.job.claimLost": "Ekspor ini tidak lagi ditugaskan ke pemroses saat ini. Kembali ke antrian untuk melihat statusnya.",
  "sidenav.section.main": "Menu Utama",
  "sidenav.section.patientOrders": "Pasien & Pemesanan",
  "sidenav.section.administration": "Administrasi",
  "sidenav.workflow.orderTest": "Pemesanan Pemeriksaan",
  "sidenav.workflow.resultsValidation": "Validasi Hasil",
  "sidenav.workflow.patientManagement": "Pengelolaan Pasien",
  "sidenav.moreTools": "Fitur lainnya",
  "reporting.menu.otherReports": "Laporan lainnya",
  "reporting.menu.patientPrintQueue": "Antrian Cetak Laporan Pasien",
  "common.icon": "Ikon",
  "menu.presentation.style": "Tampilkan sebagai",
  "menu.presentation.item": "Item menu",
  "menu.presentation.section": "Judul bagian",
  "menu.configuration.managed": "Dikelola oleh konfigurasi instans",
  "menu.configuration.description": "Perbarui visibilitas menu, judul bagian, dan ikon. Pengaturan yang dikelola oleh instans ini hanya dapat dibaca di sini.",
  "menu.configuration.loadError": "Pengaturan menu tidak dapat dimuat.",
  "menu.configuration.saved": "Pengaturan menu disimpan.",
  "menu.presentation.sectionHint": "Judul bagian mengelompokkan item menu turunannya tanpa tautan.",
  "menu.presentation.sectionIconHint": "Ikon ditampilkan pada item menu, bukan pada judul bagian.",
  "analyzer.action.copyMappings": "Salin Pemetaan",
  "analyzer.action.delete": "Hapus",
  "analyzer.action.edit": "Edit",
  "analyzer.action.fieldMappings": "Pemetaan Bidang",
  "analyzer.action.qcRules": "Aturan QC",
  "analyzer.action.testConnection": "Uji Koneksi",
  "analyzer.copyMappings.confirmation.message": "Apakah Anda ingin menyalin sejumlah {count} pemetaan? Pemetaan sebelumnya akan ditimpa.",
  "analyzer.copyMappings.confirmation.title": "Konfirmasi Salin Pemetaan",
  "analyzer.copyMappings.copy": "Salin Pemetaan",
  "analyzer.copyMappings.error": "Error saat menyalin pemetaan",
  "analyzer.copyMappings.error.noSourceMappings": "Alat sumber tidak memiliki pemetaan untuk disalin",
  "analyzer.copyMappings.loading": "Menyalin pemetaan...",
  "analyzer.copyMappings.source": "Alat Sumber",
  "analyzer.copyMappings.source.name": "Nama",
  "analyzer.copyMappings.source.type": "Jenis",
  "analyzer.copyMappings.subtitle": "Salin pemetaan bidang dari {source} ke {target}",
  "analyzer.copyMappings.success": "Sejumlah {count} pemetaan berhasil disalin",
  "analyzer.copyMappings.success.viewTarget": "Lihat Alat yang Dituju",
  "analyzer.copyMappings.summary": "Ringkasan Pemetaan",
  "analyzer.copyMappings.summary.breakdown": "Pemetaan bidang: {fieldCount}, Konversi satuan: {unitCount}, Pemetaan kualitatif: {qualCount}",
  "analyzer.copyMappings.summary.count": "sejumlah {count} pemetaan akan disalin",
  "analyzer.copyMappings.target": "Alat yang Dituju",
  "analyzer.copyMappings.target.placeholder": "Pilih alat yang dituju",
  "analyzer.copyMappings.target.required": "Alat yang Dituju*",
  "analyzer.copyMappings.title": "Salin Pemetaan Bidang",
  "analyzer.copyMappings.warning": "Hal ini akan menyalin semua pemetaan bidang termasuk konversi satuan dan pemetaan nilai kualitatif. Pemetaan sebelumnya akan ditimpa.",
  "analyzer.delete.cancel": "Batal",
  "analyzer.delete.delete": "Hapus",
  "analyzer.delete.error": "Error",
  "analyzer.delete.error.noId": "Identitas alat wajib ada",
  "analyzer.delete.error.unknown": "Error saat menghapus alat",
  "analyzer.delete.message": "Apakah Anda yakin ingin menghapus '{name}'? Aksi ini tidak dapat dibatalkan dan akan menghapus semua pemetaan bidang terkait.",
  "analyzer.delete.success": "Alat dihapus",
  "analyzer.delete.title": "Hapus Alat",
  "analyzer.delete.unknown": "Alat Tidak Dikenal",
  "analyzer.errorDashboard.acknowledgeAll": "Mengetahui Semua",
  "analyzer.errorDashboard.action.acknowledge": "Mengetahui",
  "analyzer.errorDashboard.action.menu": "Aksi error",
  "analyzer.errorDashboard.action.viewDetails": "Lihat Rincian",
  "analyzer.errorDashboard.errorType.connection": "Koneksi",
  "analyzer.errorDashboard.errorType.mapping": "Pemetaan",
  "analyzer.errorDashboard.errorType.protocol": "Protokol",
  "analyzer.errorDashboard.errorType.timeout": "Waktu habis",
  "analyzer.errorDashboard.errorType.validation": "Validasi",
  "analyzer.errorDashboard.filter.analyzer": "Alat",
  "analyzer.errorDashboard.filter.analyzer.all": "Semua",
  "analyzer.errorDashboard.filter.search": "Cari error...",
  "analyzer.errorDashboard.filter.severity": "Keparahan",
  "analyzer.errorDashboard.filter.severity.all": "Semua Keparahan",
  "analyzer.errorDashboard.filter.type": "Jenis Error",
  "analyzer.errorDashboard.filter.type.all": "Semua Jenis",
  "analyzer.errorDashboard.severity.critical": "Kritis",
  "analyzer.errorDashboard.severity.error": "Error",
  "analyzer.errorDashboard.severity.warning": "Peringatan",
  "analyzer.errorDashboard.stats.critical": "Kritis",
  "analyzer.errorDashboard.stats.last24Hours": "24 jam terakhir",
  "analyzer.errorDashboard.stats.total": "Total Error",
  "analyzer.errorDashboard.stats.unacknowledged": "Tidak diketahui",
  "analyzer.errorDashboard.status.acknowledged": "Sudah diketahui",
  "analyzer.errorDashboard.status.unacknowledged": "Tidak diketahui",
  "analyzer.errorDashboard.subtitle": "Lihat dan kelola error dan peringatan alat",
  "analyzer.errorDashboard.table.analyzer": "Alat",
  "analyzer.errorDashboard.table.message": "Pesan",
  "analyzer.errorDashboard.table.severity": "Keparahan",
  "analyzer.errorDashboard.table.status": "Status",
  "analyzer.errorDashboard.table.timestamp": "Cap waktu",
  "analyzer.errorDashboard.table.type": "Jenis",
  "analyzer.errorDashboard.title": "Dasbor Error",
  "analyzer.errorDetails.acknowledged": "Sudah diketahui",
  "analyzer.errorDetails.acknowledgedBy": "Oleh {user} pada tanggal {date}",
  "analyzer.errorDetails.analyzer": "Alat",
  "analyzer.errorDetails.analyzerId": "ID Alat",
  "analyzer.errorDetails.close": "Tutup",
  "analyzer.errorDetails.copy": "Salin",
  "analyzer.errorDetails.createMapping": "Buat Pemetaan",
  "analyzer.errorDetails.download": "Unduh",
  "analyzer.errorDetails.errorId": "ID Error",
  "analyzer.errorDetails.errorMessage": "Pesan Error",
  "analyzer.errorDetails.errorType": "Jenis Error",
  "analyzer.errorDetails.logs": "Log Alat ({count} entri)",
  "analyzer.errorDetails.recommendedActions": "Aksi yang disarankan",
  "analyzer.errorDetails.recommendedActions.checkConfiguration": "Periksa alamat IP dan konfigurasi portal di pengaturan alat",
  "analyzer.errorDetails.recommendedActions.createMapping": "Buat pemetaan untuk bidang yang belum dipetakan untuk menyelesaikan error ini",
  "analyzer.errorDetails.recommendedActions.testConnection": "Uji koneksi dengan menggunakan fitur 'Uji Koneksi'",
  "analyzer.errorDetails.recommendedActions.verifyConnection": "Verifikasi apakah alat terkoneksi dengan listrik dan kabel jaringan",
  "analyzer.errorDetails.severity": "Keparahan",
  "analyzer.errorDetails.subtitle": "RIncian informasi error dan log alat {id}",
  "analyzer.errorDetails.timestamp": "Cap waktu",
  "analyzer.errorDetails.title": "Rincian Error",
  "analyzer.fieldMapping.activationModal.activate": "Aktivasi Perubahan",
  "analyzer.fieldMapping.activationModal.cancel": "Batal",
  "analyzer.fieldMapping.activationModal.confirmCheckbox": "Saya mengerti perubahan ini akan diterapkan hanya pada pesan baru",
  "analyzer.fieldMapping.activationModal.errorConcurrentEdit": "Perubahan pemetaan terdeteksi. Pengguna lain telah memodifikasi pemetaan alat ini. Mohon memuat ulang halaman untuk melihat perubahan terakhir.",
  "analyzer.fieldMapping.activationModal.errorMissingRequired": "Tidak dapat mengaktivasi: Pemetaan yang wajib tidak ditemukan",
  "analyzer.fieldMapping.activationModal.errorMissingRequired.detail": "Bidang yang wajib tidak ditemukan: {fields}",
  "analyzer.fieldMapping.activationModal.reloadPage": "Memuat ulang halaman",
  "analyzer.fieldMapping.activationModal.subtitle": "Konfirmasi aktivasi perubahan pemetaan untuk alat '{name}'",
  "analyzer.fieldMapping.activationModal.title": "Aktivasi Perubahan Pemetaan",
  "analyzer.fieldMapping.activationModal.viewPendingMessages": "Lihat Pesan Tertunda",
  "analyzer.fieldMapping.activationModal.warning": "Anda akan mengaktivasi perubahan pemetaan untuk alat '{name}'. Perubahan ini akan diterapkan untuk semua pesan yang diterima setelah aktivasi. Hasil yang sudah ada tidak akan terpengaruh.",
  "analyzer.fieldMapping.activationModal.warningActive": "Alat ini tengah aktif. Aktivasi perubahan akan mempengaruhi hasil yang masuk.",
  "analyzer.fieldMapping.activationModal.warningPendingMessages": "Alat ini memiliki sejumlah {count} pesan tertunda di antrian error. Mengaktivasi perubahan pemetaan akan mempengaruhi pemrosesan pesan-pesan tersebut. Disarankan untuk menyelesaikan error terlebih dahulu.",
  "analyzer.fieldMapping.back": "Kembali",
  "analyzer.fieldMapping.fieldType.controlTest": "Pemeriksaan Kontrol",
  "analyzer.fieldMapping.fieldType.custom": "Kustom",
  "analyzer.fieldMapping.fieldType.dateTime": "Tanggal/Waktu",
  "analyzer.fieldMapping.fieldType.meltingPoint": "Titik Leleh",
  "analyzer.fieldMapping.fieldType.numeric": "Numerik",
  "analyzer.fieldMapping.fieldType.qualitative": "Kualitatif",
  "analyzer.fieldMapping.fieldType.text": "Teks",
  "analyzer.fieldMapping.page.subtitle": "Konfigurasi pemetaan bidang antara alat dan SILNAS",
  "analyzer.fieldMapping.page.title": "Pemetaan Bidang",
  "analyzer.fieldMapping.panel.mapping.active": "Aktif",
  "analyzer.fieldMapping.panel.mapping.retired": "Bebas tugas",
  "analyzer.fieldMapping.panel.retire": "Bebastugaskan Pemetaan",
  "analyzer.fieldMapping.panel.retire.disabled.tooltip": "Tidak dapat dibebastugaskan: {reason}",
  "analyzer.fieldMapping.panel.source.fieldsAvailable": "{count} bidang tersedia",
  "analyzer.fieldMapping.panel.source.search": "Cari bidang...",
  "analyzer.fieldMapping.panel.source.title": "Bidang Alat ({type})",
  "analyzer.fieldMapping.panel.status.mapped": "Dipetakan",
  "analyzer.fieldMapping.panel.status.unmapped": "Tidak dipetakan",
  "analyzer.fieldMapping.panel.statusFilter.active": "Hanya yang Aktif",
  "analyzer.fieldMapping.panel.statusFilter.all": "Semua Bidang",
  "analyzer.fieldMapping.panel.statusFilter.draft": "Hanya Draf",
  "analyzer.fieldMapping.panel.statusFilter.label": "Filter berdasarkan Status",
  "analyzer.fieldMapping.panel.statusFilter.mapped": "Hanya yang Dipetakan",
  "analyzer.fieldMapping.panel.statusFilter.unmapped": "Hanya yang Tidak Dipetakan",
  "analyzer.fieldMapping.panel.target.cancel": "Batal",
  "analyzer.fieldMapping.panel.target.edit": "Edit",
  "analyzer.fieldMapping.panel.target.remove": "Hapus",
  "analyzer.fieldMapping.panel.target.saveActivate": "Simpan dan Aktivasi",
  "analyzer.fieldMapping.panel.target.saveDraft": "Simpan sebagai Draf",
  "analyzer.fieldMapping.panel.target.selectField": "Pilih bidang di panel kiri untuk melihat dan membuat pemetaan.",
  "analyzer.fieldMapping.panel.target.summary": "Ringkasan Pemetaan",
  "analyzer.fieldMapping.panel.unmappedField.tooltip": "Bidang Tidak Dipetakan - Bidang ini tidak memiliki konfigurasi pemetaan",
  "analyzer.fieldMapping.pendingCodes.actions": "Aksi",
  "analyzer.fieldMapping.pendingCodes.code": "Kode Alat",
  "analyzer.fieldMapping.pendingCodes.empty": "Tidak ada pemetaan kode alat yang tertunda.",
  "analyzer.fieldMapping.pendingCodes.ignore": "Abaikan",
  "analyzer.fieldMapping.pendingCodes.markMapped": "Tandai yang sudah dipetakan",
  "analyzer.fieldMapping.pendingCodes.seenCount": "Terlihat",
  "analyzer.fieldMapping.pendingCodes.status": "Status",
  "analyzer.fieldMapping.pendingCodes.subtitle": "Tinjau dan selesaikan kode alat yang belum dipetakan.",
  "analyzer.fieldMapping.pendingCodes.title": "Pemetaan Kode yang Tertunda",
  "analyzer.fieldMapping.pluginConfig.title": "Snapshot Konfigurasi Plugin",
  "analyzer.fieldMapping.queryAnalyzer": "Kueri Alat",
  "analyzer.fieldMapping.retirementModal.cancel": "Batal",
  "analyzer.fieldMapping.retirementModal.confirmation": "Apakah Anda ingin membebastugaskan pemetaan ini? Riwayat pesan masih akan merujuk ke pemetaan ini untuk kepentingan audit.",
  "analyzer.fieldMapping.retirementModal.errorPendingMessages": "Tidak dapat bebas tugas: sejumlah {count} pesan tertunda masih menggunakan pemetaan ini",
  "analyzer.fieldMapping.retirementModal.reasonLabel": "Alasan Pembebastugasan (Opsional)",
  "analyzer.fieldMapping.retirementModal.reasonPlaceholder": "Opsional: Alasan pembebastugasan pemetaan ini",
  "analyzer.fieldMapping.retirementModal.retire": "Bebastugaskan Pemetaan",
  "analyzer.fieldMapping.retirementModal.subtitle": "Konfirmasi pembebastugasan pemetaan bidang",
  "analyzer.fieldMapping.retirementModal.title": "Bebastugaskan Pemetaan",
  "analyzer.fieldMapping.save": "Simpan Pemetaan",
  "analyzer.fieldMapping.stats.pendingCodes": "Kode Tertunda",
  "analyzer.fieldMapping.stats.required": "Pemetaan Wajib Ada",
  "analyzer.fieldMapping.stats.total": "Total Pemetaan",
  "analyzer.fieldMapping.stats.unmapped": "Bidang tidak dipetakan",
  "analyzer.fieldMapping.status.active": "Aktif",
  "analyzer.fieldMapping.status.draft": "Draf",
  "analyzer.fieldMapping.status.retired": "Bebas tugas",
  "analyzer.fieldMapping.status.unmapped": "Tidak dipetakan",
  "analyzer.fieldMapping.testMapping": "Pemetaan Pemeriksaan",
  "analyzer.fieldMapping.warning.missingRequired": "Pemetaan yang diperlukan tidak ditemukan",
  "analyzer.fieldMapping.warning.missingRequired.detail": "Beberapa bidang yang wajib tidak terpetakan. Mohon memetakan semua bidang wajib sebelum mengaktivasi.",
  "analyzer.navigation.errorDashboard": "Dasbor Error",
  "analyzerType.column.name": "Nama",
  "analyzerType.column.description": "Deskripsi",
  "analyzerType.column.pluginClass": "Kelas Plugin",
  "analyzerType.column.genericPlugin": "Plugin Generik",
  "analyzerType.column.identifierPattern": "Pola Pengidentifikasi",
  "analyzerType.column.pluginLoaded": "Plugin Dimuat",
  "analyzerType.column.instances": "Instance",
  "analyzerType.button.creating": "Membuat...",
  "analyzerType.modal.createTitle": "Buat Jenis Alat Baru",
  "analyzerType.field.name": "Nama",
  "analyzerType.field.description": "Deskripsi",
  "analyzerType.field.selectProtocol": "Pilih protokol",
  "analyzerType.field.pluginClassName": "Nama Kelas Plugin",
  "analyzerType.field.identifierPattern": "Pola Pengidentifikasi",
  "analyzerType.field.identifierPatternHelper": "Pola regex untuk mencocokkan pengidentifikasi sampel (misal. ^[A-Z]{2}\\d{6}$)",
  "analyzerType.field.isGenericPlugin": "Plugin Generik",
  "analyzerType.field.isActive": "Aktif",
  "analyzerType.error.nameRequired": "Wajb ada nama ",
  "analyzerType.notification.createSuccess": "Membuat jenis alat berhasil",
  "analyzerType.notification.createError": "Gagal membuat jenis alat",
  "analyzer.stat.pluginWarnings": "Peringatan Plugin",
  "analyzer.status.pending_registration": "Registrasi Tertunda",
  "analyzer.qcRules.modal.title": "Aturan Identifikasi Sample QC — {analyzerName}",
  "analyzer.qcRules.breadcrumb": "Aturan Identifikasi Sampel QC",
  "analyzer.qcRules.orSemantics": "Aturan yang digunakan ATAU semantik:  sampel akan di tandai sebagai QC jika ADA kecocokan aturan yang aktif.",
  "analyzer.qcRules.addRule": "Tambah Aturan",
  "analyzer.qcRules.deleteRule": "Hapus Aturan",
  "analyzer.qcRules.noRules": "Tidak ada konfigurasi aturan QC. Tambah setidaknya satu aturan sebelum mengaktivasi alat.",
  "analyzer.qcRules.ruleType": "Jenis Aturan",
  "analyzer.qcRules.targetField": "Referensi Lapangan",
  "analyzer.qcRules.targetField.placeholder": "Misalnya, O.12, QC_TASK",
  "analyzer.qcRules.operand": "Cocokkan Nilai",
  "analyzer.qcRules.operand.placeholder": "Misalnya, Q, CNEG, ^(CNEG|CPOS).*",
  "analyzer.qcRules.error.loadFailed": "Gagal memuat aturan QC",
  "analyzer.qcRules.error.saveFailed": "Gagal menyimpan aturan QC",
  "analyzer.qcRules.error.deleteFailed": "Gagal menghapus aturan QC",
  "analyzer.placement.instrumentSpecimen": "Dikirim instrumen: {id}",
  "analyzer.placement.state.RESOLVED": "Cocok",
  "analyzer.placement.state.RETEST_CHOICE": "Sudah ada hasil",
  "analyzer.placement.state.MULTI_TUBE": "Beberapa kecocokan",
  "analyzer.placement.state.UNORDERED_ONE_FITS": "Pemeriksaan tidak dipesan",
  "analyzer.placement.state.UNORDERED_MANY_FIT": "Pemeriksaan tidak dipesan",
  "analyzer.placement.state.UNORDERED_NONE_FIT": "Pemeriksaan tidak dipesan",
  "analyzer.placement.state.NEW_SAMPLE": "Sampel baru",
  "analyzer.placement.reason.RESOLVED": "Satu analisis pada {tube} sedang menunggu hasil ini.",
  "analyzer.placement.reason.RETEST_CHOICE": "Analisis pada {tube} sudah memiliki hasil. Menyimpan akan menggantinya dan menandainya sebagai dikoreksi.",
  "analyzer.placement.reason.MULTI_TUBE": "Lebih dari satu analisis cocok dengan ID ini. Pilih analisis tempat hasil ini berada.",
  "analyzer.placement.reason.MULTI_TUBE_NO_ANALYSIS": "Lebih dari satu tabung memiliki ID ini. Perbaiki label tabung yang duplikat, lalu tinjau kembali.",
  "analyzer.placement.reason.UNORDERED_ONE_FITS": "Pemeriksaan ini tidak dipesan. Menyimpan akan menambahkannya ke {tube}.",
  "analyzer.placement.reason.UNORDERED_MANY_FIT": "Pemeriksaan ini tidak dipesan dan lebih dari satu tabung dapat menampungnya. Pilih jenis sampel di bawah.",
  "analyzer.placement.reason.UNORDERED_NONE_FIT": "Pemeriksaan ini tidak dipesan dan tidak ada tabung pada pemesanan yang dapat menampungnya. Menyimpan akan menambahkan tabung baru dengan jenis sampel pemeriksaan tersebut.",
  "analyzer.placement.reason.NEW_SAMPLE": "Tidak ada pemesanan atau tabung yang memiliki ID ini. Menyimpan akan membuat sampel baru untuknya.",
  "analyzer.placement.chooseAnalysis": "Analisis tempat hasil ini berada",
  "analyzer.placement.chooseAnalysis.none": "Pilih analisis",
  "analyzer.placement.option": "{tube}, {status}",
  "analyzer.placement.option.awaiting": "menunggu hasil",
  "analyzer.placement.option.hasResult": "sudah ada hasil",
  "analyzer.placement.tubeUnlabelled": "tabung {id}",
  "analyzer.placement.viewBundle": "Lihat paket",
  "analyzer.placement.bundleTitle": "Paket pengiriman",
  "analyzer.placement.bundleLoading": "Memuat paket pengiriman",
  "analyzer.placement.bundleFailed": "Paket pengiriman tidak dapat dimuat.",
  "analyzer.placement.redirect.open": "Tempatkan pada pemesanan lain",
  "analyzer.placement.redirect.accession": "Pemesanan (No. Registrasi)",
  "analyzer.placement.redirect.reason": "Alasan hasil ini milik pemesanan tersebut",
  "analyzer.placement.redirect.help": "Gunakan ini jika instrumen salah membaca ID sampel. Alasannya disimpan bersama hasil.",
  "analyzer.placement.redirect.reasonRequired": "Masukkan alasan sebelum menyimpan.",
  "analyzer.placement.patient.match": "Pasien instrumen {instrument} cocok dengan pasien pada pemesanan.",
  "analyzer.placement.patient.mismatch.tag": "Pasien tidak cocok",
  "analyzer.placement.patient.mismatch": "Instrumen melaporkan pasien {instrument}, tetapi pasien pada pemesanan adalah {order}. Tambahkan catatan alasannya sebelum menyimpan.",
  "analyzer.placement.patient.noOrderPatient": "Instrumen melaporkan pasien {instrument}. Pemesanan tidak memiliki identitas pasien untuk dibandingkan.",
  "instructions.qc.fail.blocks.validation": "Jika diaktifkan, hasil yang tercakup oleh kegagalan kontrol mutu yang masih terbuka tidak dapat diterima di Validasi sampai ketidaksesuaian ditutup; hasil tersebut tetap dapat ditolak. Jika dinonaktifkan, kegagalan hanya ditampilkan pada baris sebagai peringatan.",
  "coldStorage.bacnetUdpPort": "Portal BACnet UDP",
  "coldStorage.config.saveSuccess": "Konfigurasi sistem berhasil disimpan",
  "coldStorage.configMoved": "Konfigurasi Dipindah ke Panel Admin",
  "coldStorage.configMovedDesc": "Pengaturan sistem keseluruhan harus dikelola oleh Admin UI dimana terdapat semua konfigurasi global. Halaman ini read-only dan akan dihapus di perilisan berikutnya.",
  "coldStorage.databaseVersion": "Versi Database",
  "coldStorage.error.loadConfig": "Gagal memuat konfigurasi sistem:",
  "coldStorage.error.saveConfig": "Gagal menyimpan konfigurasi sistem:",
  "coldStorage.lastUpdate": "Pembaruan Terakhir",
  "coldStorage.loadingConfig": "Memuat konfigurasi sistem...",
  "coldStorage.modbusTcpPort": "Portal Modbus TCP",
  "coldStorage.protocolConfiguration": "Konfigurasi Protokol",
  "coldStorage.readOnlyMode": "Mode Read-Only",
  "coldStorage.readOnlyModeDesc": "Untuk memodifikasi pengaturan ini, silahkan navigasi ke Admin → Konfigurasi Sistem",
  "coldStorage.securitySettings": "Pengaturan Keamanan",
  "coldStorage.sessionTimeout": "Sesi Habis",
  "coldStorage.systemConfiguration": "Konfigurasi Peringatan",
  "coldStorage.systemInformation": "Informasi Sistem",
  "coldStorage.systemVersion": "Versi Sistem",
  "coldStorage.twoFactorAuth": "Two-Factor Authentication",
  "coldStorage.uptime": "Waktu aktif",
  "customFieldType.page.hierarchy.management": "Jenis Kolom Kustom",
  "customFieldType.page.hierarchy.root": "Administrasi Sistem",
  "eqa.program.tests.helper": "Penerimaan hasil untuk program ini hanya menawarkan pemeriksaan ini, pada grid hasil dan pada impor CSV-nya.",
  "eqa.program.tests.saveFailed": "Program telah disimpan tetapi pemeriksaannya tidak. Buka kembali dan atur ulang pemeriksaannya.",
  "inventory.search.placeholder": "Cari berdasarkan nama barang, nomor lot, atau kode QR",
  "label.results.control.capture.pass": "Lolos",
  "label.results.control.capture.fail": "Gagal",
  "message.noPluginFound": "Tidak ada plugin ditemukan",
  "nce.status.capa": "CAPA",
  "nce.status.completed": "Selesai",
  "nce.capa.add": "Tambah",
  "plugin.files": "File Plugin",
  "plugin.name": "Nama Plugin",
  "sidenav.label.admin.analyzerTest": "Nama Alat",
  "sidenav.label.admin.Listplugin": "Daftar Plugin",
  "sidenav.label.admin.pluginFile": "File Plugin",
  "label.testCatalog.accreditation.col.body": "Badan Akreditasi",
  "label.testCatalog.accreditation.col.expires": "Masa Berlaku Badan",
  "label.testCatalog.accreditation.col.status": "Status",
  "label.testCatalog.accreditation.col.actions": "Aksi",
  "label.testCatalog.accreditation.remove.confirm": "Hapus",
  "qa.qiConfig.title": "Konfigurasi Indikator Mutu",
  "qa.qiConfig.error": "Tidak dapat memuat konfigurasi indikator mutu.",
  "qa.qiConfig.column.indicator": "Indikator",
  "qa.qiConfig.column.enabled": "Diaktifkan",
  "qa.qiConfig.column.target": "Target",
  "qa.qiConfig.column.action": "Ambang batas tindakan",
  "qa.qiConfig.column.actions": "Aksi",
  "qa.qms.capaRegister.title": "Register CAPA",
  "qa.qms.capaRegister.tile.open": "Buka",
  "qa.qms.capaRegister.tile.overdue": "Lewat tenggat",
  "qa.qms.capaRegister.filter.status": "Status",
  "qa.qms.capaRegister.filter.status.all": "Semua",
  "qa.qms.capaRegister.column.nceNumber": "Nomor Kejadian Ketidaksesuaian",
  "qa.qms.capaRegister.column.actionType": "Jenis",
  "qa.qms.capaRegister.column.dueDate": "Tanggal Jatuh Tempo",
  "qa.qms.capaRegister.column.completed": "Selesai",
  "qa.qms.capaRegister.column.status": "Status",
  "qa.qms.accreditation.tile.active": "Aktif",
  "qa.qms.accreditation.tile.expiring": "Segera Kedaluwarsa",
  "qa.qms.accreditation.tile.expired": "Kedaluwarsa",
  "qa.qms.accreditation.body.column.code": "Kode",
  "qa.qms.accreditation.body.column.name": "Nama",
  "qa.qms.accreditation.body.column.enrolled": "Pemeriksaan Terdaftar",
  "qa.qms.accreditation.body.column.status": "Status",
  "qa.qms.accreditation.body.column.actions": "Aksi",
  "qa.qms.accreditation.body.field.code": "Kode",
  "qa.qms.accreditation.body.field.name": "Nama",
  "qa.qms.accreditation.body.field.displayOrder": "Urutan tampilan",
  "qa.qms.accreditation.body.field.active": "Aktif",
  "qa.qms.accreditation.body.delete.confirm": "Hapus",
  "qa.qms.accreditation.enrollment.column.test": "Pemeriksaan",
  "qa.qms.accreditation.enrollment.column.status": "Status",
  "qa.qms.accreditation.enrollment.column.actions": "Aksi",
  "qa.qms.accreditation.eqa.column.body": "Badan Akreditasi",
  "qa.qms.accreditation.filter.status": "Status",
  "qa.qms.accreditation.filter.all": "Semua",
  "qa.qms.accreditation.filter.search": "Cari pemeriksaan",
  "qa.qms.accreditation.enroll.field.body": "Badan akreditasi",
  "qa.qms.accreditation.enroll.field.tests": "Pemeriksaan",
  "qa.qms.accreditation.enrollment.delete.confirm": "Hapus",
  "qa.qms.esigLog.title": "Log Tanda Tangan Elektronik",
  "qa.qms.esigLog.column.signedAt": "Waktu Tanda Tangan",
  "qa.qms.esigLog.column.action": "Aksi",
  "qa.qms.esigLog.column.reason": "Alasan",
  "qa.qms.esigLog.filter.from": "Rentang Tanggal (Dari)",
  "qa.qms.esigLog.filter.to": "Rentang Tanggal (Sampai)",
  "qa.qms.esigLog.filter.action": "Aksi",
  "qa.qms.esigLog.filter.user": "Pengguna",
  "qa.qms.esigLog.filter.all": "Semua",
  "qa.qms.esigLog.filter.clear": "Hapus Filter",
  "qa.qms.esigLog.export.csv": "Ekspor CSV",
  "qa.qms.esigLog.export.pdf": "Ekspor PDF",
  "qa.qms.esigLog.export.confirm.confirm": "Ekspor",
  "qa.qms.esigLog.export.confirm.cancel": "Batal",
  "qa.qi.dashboard.title": "Dasbor Indikator Mutu",
  "qa.qi.dashboard.refresh": "Segarkan",
  "qa.qi.dashboard.comingSoon": "Segera hadir: {ticket}",
  "qa.qi.amendment.filter.from": "Dari",
  "qa.qi.amendment.filter.to": "Kepada",
  "qa.qi.amendment.column.labNumber": "No. Registrasi",
  "qa.qi.amendment.column.test": "Pemeriksaan",
  "qa.qi.amendment.empty": "Tidak ada amandemen dalam rentang waktu ini.",
  "qa.qi.amendment.error": "Data amandemen tidak tersedia.",
  "qa.qi.amendment.trend.title": "Tren",
  "qa.qi.amendment.trend.series": "Tingkat amandemen",
  "qa.qi.amendment.trend.interval": "Agregasi",
  "qa.qi.amendment.threshold.target": "Target",
  "qa.qi.amendment.threshold.action": "Aksi",
  "qa.qi.amendment.breakdown.column.test": "Pemeriksaan",
  "qa.qi.amendment.breakdown.column.amended": "Telah diubah",
  "qa.qi.amendment.breakdown.column.released": "Dirilis",
  "qa.qi.rejection.filter.from": "Dari",
  "qa.qi.rejection.filter.to": "Kepada",
  "qa.qi.rejection.column.labNumber": "No. Registrasi",
  "qa.qi.rejection.column.test": "Pemeriksaan",
  "qa.qi.rejection.column.reason": "Alasan",
  "qa.qi.rejection.column.location": "Lokasi",
  "qa.qi.rejection.column.nce": "NCE",
  "qa.qi.rejection.error": "Data penolakan tidak tersedia.",
  "qa.qi.rejection.trend.title": "Tren",
  "qa.qi.rejection.trend.series": "Tingkat penolakan",
  "qa.qi.rejection.trend.interval": "Agregasi",
  "qa.qi.rejection.trend.empty": "Tidak ada data tren dalam periode ini.",
  "qa.qi.rejection.threshold.target": "Target",
  "qa.qi.rejection.threshold.action": "Aksi",
  "qa.qi.rejection.reasons.column.reason": "Alasan",
  "qa.qi.rejection.reasons.column.count": "Jumlah",
  "qa.qi.rejection.breakdown.title": "Per pemeriksaan",
  "qa.qi.rejection.breakdown.column.test": "Pemeriksaan",
  "qa.qi.rejection.breakdown.column.rejected": "Ditolak",
  "qa.qi.rejection.breakdown.column.total": "Dimulai",
  "qa.qi.rejection.breakdown.column.rate": "Tingkat",
  "qa.qi.callback.failures.column.reason": "Alasan",
  "qa.qi.callback.failures.column.count": "Jumlah",
  "qa.qi.callback.error": "Data panggilan balik tidak tersedia.",
  "qa.qi.callback.column.releasedAt": "Dirilis",
  "qa.qi.callback.column.labNumber": "No. Registrasi",
  "qa.qi.callback.column.test": "Pemeriksaan",
  "qa.qi.callback.column.resultValue": "Hasil",
  "qa.qi.callback.column.criticalRange": "Rentang kritis",
  "qa.qi.callback.column.recipient": "Orang yang diberi tahu",
  "qa.comingSoon.subtitle": "Halaman ini sudah direncanakan tetapi belum dibuat.",
  "qa.overview.section.today": "Hari ini",
  "qa.overview.tile.tat": "Rata-rata TAT",
  "qa.overview.tile.rejectionRate": "Tingkat Penolakan",
  "qa.overview.tile.amendmentRate": "Tingkat Amandemen",
  "qa.overview.tile.ncePulse": "Denyut KTS",
  "qa.overview.ncePulse.criticalPending": "kritis tertunda",
  "qa.overview.ncePulse.inCorrectiveAction": "{count} dalam tindakan perbaikan",
  "qa.overview.activity.system": "Sistem",
  "storage.picker.backToSearch": "Kembali ke pencarian",
  "storage.picker.createNewLocation": "Buat lokasi baru",
  "storage.picker.heading.moveSample": "Pindahkan Sampel",
  "storage.picker.sample.accession": "Nomor Registrasi",
  "storage.picker.sample.heading": "Sampel",
  "storage.picker.sample.status": "Status",
  "storage.picker.sample.type": "Jenis",
  "storage.metrics.storage.locations": "Lokasi Penyimpanan",
  "storage.tab.devices": "Perangkat",
  "storage.tab.racks": "Laci",
  "storage.tab.rooms": "Ruangan",
  "storage.tab.shelves": "Rak",
  "validation.label.qcHold": "QC gagal",
  "validation.qcHold.blocked": "Beberapa hasil tidak dirilis karena QC yang mencakupnya gagal. Tutup ketidaksesuaian, atau tolak hasil yang terdampak.",
  "validation.qcHold.withheld": "{count, plural, other {# hasil tidak dirilis ({accessions}). Kegagalan QC yang mencakupnya masih terbuka. Tinjau ketidaksesuaian, atau tolak hasilnya.}}",
  "qc.dashboard.export.button": "Ekspor",
  "qc.dashboard.export.instrument": "Alat",
  "qc.dashboard.export.level": "Level Kontrol",
  "qc.dashboard.export.startDate": "Tanggal Mulai",
  "qc.dashboard.export.endDate": "Tanggal Selesai",
  "qc.dashboard.export.csv": "Ekspor CSV",
  "qc.dashboard.export.pdf": "Ekspor PDF",
  "qc.dashboard.export.cancel": "Batal",
  "qc.instrument.tab.timeline": "Timeline Kegiatan",
  "qc.instrument.tab.chart": "Control Charts",
  "qc.chart.stats.mean": "Rata-rata",
  "qc.chart.stats.n": "N",
  "qc.chart.subtitle": "Grafik kontrol Levey-Jennings",
  "qc.chart.filter.startDate": "Tanggal Mulai",
  "qc.chart.filter.endDate": "Tanggal Selesai",
  "qc.chart.filter.controlLevel": "Level kontrol",
  "qc.chart.filter.selectLevel": "Pilih level",
  "qc.chart.filter.levelLow": "Rendah",
  "qc.chart.filter.levelNormal": "Normal",
  "qc.chart.filter.levelHigh": "Tinggi",
  "qc.chart.filter.controlLot": "Lot kontrol",
  "qc.chart.filter.allLots": "Semua lot",
  "qc.chart.action.export": "Ekspor",
  "qc.bench.source.label": "Sumber",
  "qc.bench.column.labUnit": "Instalasi Lab",
  "qc.bench.column.test": "Pemeriksaan",
  "qc.bench.column.source": "Sumber",
  "qc.bench.column.failed": "Gagal",
  "eqa.distribution.updateSuccess": "Draf distribusi diperbarui.",
  "banner.menu.eqa.myCycles": "Siklus Saya",
  "banner.menu.eqa.labPerformance": "Kinerja Lab",
  "banner.menu.eqa.followUpQueue": "Tindak Lanjut Lab Ini",
  "banner.menu.eqa.analystCompetency": "Kompetensi Analis",
  "banner.menu.eqa.provider": "Penyelenggara PME",
  "eqa.participant.myCycles.title": "Siklus PME Saya",
  "eqa.participant.myCycles.subtitle": "Siklus yang diikuti lab Anda. Entri hasil dan validasi dilakukan di alur hasil standar OpenELIS; halaman ini memantau kemajuan dan mengarahkan Anda ke sana.",
  "eqa.participant.infoTitle": "Hasil PME melalui validasi standar.",
  "eqa.participant.infoBody": "Klik No. Registrasi untuk membuka entri hasil standar untuk sampel tersebut. Setelah validasi selesai, siklus berlanjut ke Dikirim (atau Siap untuk mengirim jika program memerlukan tinjauan tingkat siklus).",
  "eqa.kpi.active": "Siklus aktif",
  "eqa.kpi.active.hint": "sedang berjalan",
  "eqa.kpi.readyToSubmit": "Siap untuk mengirim",
  "eqa.kpi.readyToSubmit.hint": "dengan penanda tinjau aktif",
  "eqa.kpi.awaiting": "Menunggu nilai",
  "eqa.kpi.awaiting.hint": "dikirim ke penyelenggara",
  "eqa.kpi.openNce": "KTS terkait PME yang terbuka",
  "eqa.kpi.openNce.attention": "perlu perhatian",
  "eqa.kpi.openNce.none": "tidak ada yang terbuka",
  "eqa.bucket.label": "Status",
  "eqa.bucket.active": "Aktif",
  "eqa.bucket.awaiting": "Menunggu skor",
  "eqa.bucket.completed": "Selesai",
  "eqa.bucket.all": "Semua",
  "eqa.bucket.active.hint": "Pekerjaan berjalan: akan datang, dalam pemeriksaan, atau siap dikirim",
  "eqa.bucket.awaiting.hint": "Dikirim ke penyelenggara; menunggu penilaian",
  "eqa.bucket.completed.hint": "Sudah dinilai atau ditutup",
  "eqa.bucket.all.hint": "Semua siklus yang pernah diikuti lab ini",
  "eqa.filter.schemeType": "Jenis program",
  "eqa.schemeType.all": "Semua Jenis",
  "eqa.schemeType.international_pt": "Uji Profisiensi Internasional",
  "eqa.schemeType.regional_pt": "Uji Profisiensi Regional",
  "eqa.schemeType.inter_lab_split": "Pembagian antar-lab",
  "eqa.schemeType.in_house": "Internal",
  "eqa.filter.searchCycles": "Cari program, penyelenggara, atau siklus",
  "eqa.filter.showing": "Menampilkan {shown} dari {total} siklus",
  "eqa.filter.clear": "Hapus filter",
  "eqa.col.scheme": "Program",
  "eqa.col.type": "Jenis",
  "eqa.col.cycle": "Siklus",
  "eqa.col.status": "Status",
  "eqa.col.deadline": "Tenggat",
  "eqa.col.progress": "Kemajuan",
  "eqa.cycle.status.planned": "Direncanakan",
  "eqa.cycle.status.panel_received": "Panel diterima",
  "eqa.cycle.status.testing": "Pengujian",
  "eqa.cycle.status.ready_to_submit": "Siap untuk mengirim",
  "eqa.cycle.status.submitted": "Dikirim",
  "eqa.cycle.status.scored": "Dinilai",
  "eqa.cycle.status.closed": "Ditutup",
  "eqa.cycle.toggleDetails": "Tampilkan/sembunyikan detail siklus",
  "eqa.cycle.emptyFiltered": "Tidak ada siklus yang cocok dengan filter ini.",
  "eqa.cycle.nceBanner": "Skor tidak dapat diterima pada {scheme}. Tindak lanjuti di daftar KTS.",
  "eqa.cycle.perAnalyst.title": "Wajib per analis",
  "eqa.cycle.perAnalyst.body": "Analis dipetakan saat pendaftaran program. Kolom per analis terlihat pada halaman entri hasil standar.",
  "eqa.cycle.review.title": "Tinjauan opsional tingkat siklus diaktifkan untuk program ini.",
  "eqa.cycle.review.body": "Semua {total} analit telah divalidasi dalam alur standar. Pengiriman cukup dengan satu klik; validasi adalah gerbang utama, tanpa autentikasi ulang.",
  "eqa.btn.reviewSubmit": "Tinjau & kirim",
  "eqa.cycle.submitted.success": "Siklus dikirim ke penyelenggara, menunggu nilai.",
  "eqa.cycle.submitted.error": "Pengiriman gagal, siklus tidak dilanjutkan. Pastikan semua hasil sudah divalidasi lalu coba lagi.",
  "eqa.progress.title": "Kemajuan sampel",
  "eqa.sample.labNo": "No Registrasi",
  "eqa.sample.providerId": "ID sampel penyelenggara",
  "eqa.sample.analytes": "Analit",
  "eqa.sample.analyst": "Analis yang ditugaskan",
  "eqa.sample.entryStatus": "Status entri",
  "eqa.labNo.tooltip": "Buka entri hasil untuk No. Registrasi ini",
  "eqa.entry.entered": "Sudah diisi",
  "eqa.entry.in_progress": "Dalam pengerjaan",
  "eqa.entry.empty": "Belum diisi",
  "eqa.cycle.scoredCopy": "Penilaian selesai. Hasil yang dinilai muncul di Kinerja Lab.",
  "eqa.cycle.submittedCopy": "Dikirim ke penyelenggara, menunggu nilai.",
  "eqa.cycle.closedCopy": "Siklus ditutup.",
  "eqa.cycle.panelReceivedCopy": "Panel diterima. Lanjutkan ke entri hasil standar untuk mulai melakukan pemeriksaan.",
  "eqa.cycle.plannedCopy": "Panel belum diterima di lab ini. Buka Tambah Pemesanan dengan kotak PME dicentang untuk mencatat penerimaan.",
  "eqa.btn.receivePanel": "Terima panel: buka Tambah Pemesanan",
  "eqa.uncycled.title": "Pemesanan PME Tanpa Siklus",
  "eqa.uncycled.subtitle": "Pemesanan PME yang tidak terkait dengan siklus apa pun. Pemesanan ini tetap terlihat di sini agar tidak ada yang hilang.",
  "eqa.review.title": "Ringkasan Sebelum Pengiriman",
  "eqa.review.subtitle": "Ringkasan baca-saja dari setiap hasil yang telah divalidasi, dikelompokkan per sampel. Inilah yang akan dikirim ke penyelenggara.",
  "eqa.review.auditFootnote": "Setiap nilai di atas telah divalidasi melalui alur standar, yang mencatat pengguna yang memvalidasi di jejak audit. Pengiriman hanya mencatat konfirmasi mengetahui, tanpa pengesahan terpisah.",
  "eqa.sample.analyte": "Analit",
  "eqa.sample.reportedValue": "Nilai yang dilaporkan",
  "eqa.sample.validatedAt": "Divalidasi",
  "eqa.order.cycle": "Siklus PME",
  "eqa.order.receipt.title": "Penerimaan Panel",
  "eqa.order.receipt.tempC": "Suhu saat tiba (°C)",
  "eqa.order.receipt.integrityOk": "Panel tiba dalam keadaan utuh",
  "eqa.order.receipt.notes": "Catatan keutuhan",
  "eqa.order.receipt.recorded": "Penerimaan panel sudah dicatat pada {date}.",
  "eqa.cycle.status.prep_in_progress": "Persiapan sedang berlangsung",
  "eqa.cycle.status.ready_to_ship": "Siap dikirim",
  "eqa.cycle.status.shipped": "Sudah dikirim",
  "eqa.cycle.status.delivered": "Sudah Diantar",
  "eqa.cycle.status.submissions_open": "Penyerahan dibuka",
  "eqa.cycle.status.submissions_closed": "Penyerahan ditutup",
  "eqa.cycle.status.scoring": "Penilaian",
  "eqa.provider.workbench.cycle": "Meja Kerja Siklus",
  "eqa.provider.workbench.forCycle": "Persiapan & pengiriman: {name}",
  "eqa.provider.workbench.tabs": "Meja Kerja",
  "eqa.provider.workbench.stateHint": "Persiapan harus lolos gerbang inventaris dan QC sebelum panel apa pun dapat dikirim.",
  "eqa.prep.tab": "Persiapan",
  "eqa.prep.participants": "Peserta",
  "eqa.prep.panels": "Panel",
  "eqa.prep.gate": "Gerbang siap kirim",
  "eqa.prep.gate.clear": "Semua persyaratan persiapan terpenuhi",
  "eqa.prep.noPanel.title": "Belum ada panel yang disiapkan",
  "eqa.prep.noPanel.body": "Buat panel siklus dan sampelnya sebelum mencatat kemajuan persiapan.",
  "eqa.prep.needExplained": "Alikuot yang diperlukan: {samples, plural, one {# sampel} other {# sampel}} x {participants, plural, one {# peserta} other {# peserta}} + {reserved} disimpan sebagai cadangan = {needed, plural, one {# alikuot} other {# alikuot}}; {shipped, plural, one {# alikuot} other {# alikuot}} telah dikirim sejauh ini.",
  "eqa.prep.produced": "Alikuot yang dihasilkan",
  "eqa.prep.reserved": "Alikuot cadangan",
  "eqa.prep.shortfall": "Kurang {n}",
  "eqa.prep.homogeneity": "QC homogenitas lolos",
  "eqa.prep.homogeneityNotes": "Catatan QC",
  "eqa.prep.save": "Simpan catatan persiapan",
  "eqa.prep.saved": "Catatan persiapan diperbarui.",
  "eqa.prep.saveFailed": "Catatan persiapan tidak tersimpan.",
  "eqa.prep.readyToShip": "Tandai siklus siap dikirim",
  "eqa.prep.readyToShip.success": "Siklus disetujui untuk dikirim; catat detail kurir di tab Pengiriman.",
  "eqa.prep.readyToShip.refused": "Siklus tidak disetujui untuk dikirim. Selesaikan item persiapan yang tertunda dan coba lagi.",
  "eqa.shipment.tab": "Pengiriman",
  "eqa.shipment.participant": "Peserta",
  "eqa.shipment.box": "Boks",
  "eqa.shipment.courier": "Kurir",
  "eqa.shipment.courierFor": "Kurir untuk {name}",
  "eqa.shipment.tracking": "Nomor pelacakan",
  "eqa.shipment.trackingFor": "Nomor pelacakan untuk {name}",
  "eqa.shipment.expected": "Perkiraan pengiriman",
  "eqa.shipment.expectedFor": "Perkiraan pengiriman untuk {name}",
  "eqa.shipment.selectAll": "Pilih semua yang tertunda",
  "eqa.shipment.selectRow": "Pilih {name} untuk dikirim",
  "eqa.shipment.markShipped": "Tandai {n} sudah dikirim",
  "eqa.shipment.firstShipHint": "Pengiriman pertama memindahkan siklus ke status dikirim.",
  "eqa.shipment.saved": "Rincian kiriman disimpan.",
  "eqa.shipment.saveFailed": "Rincian kiriman tidak disimpan.",
  "eqa.shipment.shipped": "{n} kiriman peserta telah dikirim.",
  "eqa.shipment.shipFailed": "Tidak ada yang dikirim.",
  "eqa.shipment.shippedOn": "Dikirim {date}",
  "eqa.shipment.packList": "Daftar kemasan",
  "eqa.shipment.packList.noPanel": "Siklus ini tidak memiliki panel, sehingga tidak ada yang perlu dikemas.",
  "eqa.shipment.packList.unavailable": "Sampel panel tidak dapat dibaca, sehingga daftar kemasan tidak dibuat. Muat ulang dan coba lagi.",
  "eqa.shipment.packList.notes": "Bahan panel PME, jangan dibuka sebelum periode pengujian.",
  "eqa.shipment.label": "Label",
  "eqa.shipment.noParticipants.title": "Tidak ada peserta",
  "eqa.shipment.noParticipants.body": "Daftarkan laboratorium peserta dalam siklus ini sebelum mengirim panel.",
  "eqa.report.download": "Unduh laporan kinerja",
  "banner.menu.eqa.inHouse": "Penyamaran Internal",
  "eqa.inhouse.wizard.title": "Buat panel tersamar internal",
  "eqa.inhouse.step1": "Program & siklus",
  "eqa.inhouse.step2": "Sampel & persiapan",
  "eqa.inhouse.step3": "Analis",
  "eqa.inhouse.step4": "Konfirmasi & segel",
  "eqa.inhouse.scheme": "Program internal",
  "eqa.inhouse.cycleName": "Nama siklus",
  "eqa.inhouse.plannedStart": "Tanggal mulai yang direncanakan",
  "eqa.inhouse.unblindDate": "Tanggal buka samaran (tenggat penyerahan)",
  "eqa.inhouse.sample": "Sampel",
  "eqa.inhouse.samples": "Sampel",
  "eqa.inhouse.test": "Pemeriksaan",
  "eqa.inhouse.target": "Nilai target",
  "eqa.inhouse.unit": "Unit",
  "eqa.inhouse.rangeLow": "Batas bawah rentang",
  "eqa.inhouse.rangeHigh": "Batas atas rentang",
  "eqa.inhouse.addSample": "Tambah sampel",
  "eqa.inhouse.analyst": "Analis",
  "eqa.inhouse.roster": "Analis program",
  "eqa.inhouse.roster.pick": "Pilih analis",
  "eqa.inhouse.roster.saveError": "Tidak dapat menyimpan daftar analis",
  "eqa.inhouse.assign.manual": "Tugaskan analis secara manual (jika tidak, round-robin)",
  "eqa.inhouse.assign.mode": "Mode penugasan",
  "eqa.inhouse.assign.ROUND_ROBIN": "Round-robin: satu analis per sampel, dibagi bergiliran",
  "eqa.inhouse.assign.IDENTICAL": "Set identik: setiap analis memeriksa sampel yang sama",
  "eqa.inhouse.assign.MANUAL": "Penugasan manual per sampel",
  "eqa.inhouse.assign.identicalNote": "Setiap analis memeriksa setiap sampel: {materials, plural, one {# sampel} other {# sampel}} × {analysts, plural, one {# analis} other {# analis}} = {aliquots, plural, one {# alikuot tersamar} other {# alikuot tersamar}}, masing-masing dengan kode samarannya sendiri.",
  "eqa.inhouse.assign.footnote": "Setiap penugasan dicatat pada pemesanan tersamar yang dibuatnya, dan mengikuti pemesanan tersebut hingga entri hasil.",
  "eqa.inhouse.gate.identicalNeedsAnalysts": "Set identik memerlukan minimal satu analis dalam daftar analis program",
  "eqa.inhouse.samplesLeadIn": "{count, plural, other {# sampel}} defined. Target values are sealed when the wizard finishes; they are never stored in clear text.",
  "eqa.inhouse.confirm.aliquotRows": "Alikuot tersamar",
  "eqa.inhouse.confirm.sealWarning": "Penyegelan mengenkripsi nilai target",
  "eqa.inhouse.confirm.sealWarningBody": "Setelah disegel, membuka nilai target memerlukan hak buka samaran dan dicatat di jejak audit. Panel tidak dapat diedit sesudahnya.",
  "eqa.inhouse.confirm.afterSeal": "Penyegelan membuat satu pemesanan tersamar per alikuot. Pemesanan tersebut muncul di entri hasil dan Rencana Kerja dengan kode samarannya, seperti pemesanan lainnya.",
  "eqa.inhouse.prep.sourceType": "Sumber",
  "eqa.inhouse.prep.lotNumber": "Nomor lot",
  "eqa.inhouse.prep.aliquots": "Alikuot yang dihasilkan",
  "eqa.inhouse.prep.storageTemp": "Suhu penyimpanan",
  "eqa.inhouse.prep.expiration": "Tanggal Kedaluwarsa",
  "eqa.inhouse.prep.homogeneity": "QC homogenitas lolos",
  "eqa.inhouse.prep.homogeneityNotes": "Catatan QC homogenitas",
  "eqa.inhouse.gate.noSamples": "Tambahkan minimal satu sampel sebelum melanjutkan",
  "eqa.inhouse.gate.aliquots": "Alikuot yang dihasilkan harus mencakup setiap sampel tersamar",
  "eqa.inhouse.gate.homogeneity": "QC homogenitas belum lolos, sehingga distribusi memerlukan justifikasi tertulis",
  "eqa.inhouse.gate.targets": "Setiap sampel memerlukan pemeriksaan dan nilai target",
  "eqa.inhouse.confirm.samples": "Sampel",
  "eqa.inhouse.confirm.labelNote": "Lembar label hanya memuat kode samaran, siklus, dan analit, tidak pernah nilai target.",
  "eqa.inhouse.seal": "Segel panel & distribusikan",
  "eqa.inhouse.seal.error": "Tidak dapat menyegel panel",
  "eqa.inhouse.seal.cycleError": "Tidak dapat membuat siklus",
  "eqa.inhouse.seal.panelError": "Tidak dapat membuat panel",
  "eqa.inhouse.sealed.title": "Panel disegel dan didistribusikan",
  "eqa.inhouse.sealed.help": "Pemesanan tersamar kini memakai kode samaran ini sebagai ID sampel, di entri hasil dan di Rencana Kerja.",
  "eqa.inhouse.sealed.done": "Kembali ke panel internal",
  "eqa.inhouse.panel": "Panel bahan PME",
  "eqa.inhouse.panel.defaultName": "Panel internal",
  "eqa.inhouse.cycle": "Siklus",
  "eqa.inhouse.status": "Status",
  "eqa.inhouse.actions": "Aksi",
  "eqa.inhouse.launchWizard": "Buka wizard penyamaran",
  "eqa.inhouse.noSchemes": "Belum ada program internal. Buat terlebih dahulu di pengelolaan program PME.",
  "eqa.inhouse.labels.print": "Cetak lembar label",
  "eqa.inhouse.labels.error": "Tidak dapat membuat lembar label",
  "eqa.inhouse.unblind.now": "Buka samaran sekarang",
  "eqa.inhouse.unblind.done": "Samaran panel dibuka dan dinilai",
  "eqa.inhouse.unblind.error": "Tidak dapat membuka samaran panel ini",
  "eqa.inhouse.targetValues": "Nilai target",
  "eqa.inhouse.seal.sealed": "Disegel",
  "eqa.inhouse.seal.unsealed": "Belum disegel",
  "eqa.inhouse.kpi.awaitingDistribution": "Disegel, menunggu distribusi",
  "eqa.inhouse.kpi.inTesting": "Dalam pengujian",
  "eqa.inhouse.kpi.unblindingSoon": "Buka samaran dalam 7 hari",
  "eqa.inhouse.kpi.closed": "Dinilai atau ditutup",
  "eqa.inhouse.prep.title": "Detail Persiapan & Alikuot",
  "eqa.inhouse.prep.subtitle": "Catat detail inventaris panel yang sama seperti yang dicatat penyelenggara.",
  "eqa.inhouse.prep.required": "Diperlukan: minimal {samples, plural, one {# sampel} other {# sampel}} = {samples, plural, one {# alikuot} other {# alikuot}}",
  "eqa.inhouse.back": "Kembali",
  "eqa.inhouse.next": "Berikutnya",
  "eqa.inhouse.cancel": "Batal",
  "eqa.enrollment.testAnalytes": "Analit pelaporan per pemeriksaan",
  "eqa.enrollment.testAnalytes.help": "Tentukan analit yang dilaporkan setiap pemeriksaan untuk program ini. Hasil dikirim ke penyelenggara dengan analit ini; pemeriksaan yang belum diatur tidak dikirim secara otomatis.",
  "eqa.enrollment.selectAnalyte": "Pilih analit",
  "eqa.provider.schemes.title": "Program PME yang kami selenggarakan",
  "eqa.provider.schemes.hint": "Perluas program untuk melihat siklusnya, atau mulai siklus baru untuk menentukan panel dan pesertanya.",
  "eqa.provider.schemes.none.title": "Belum ada program untuk diselenggarakan",
  "eqa.provider.schemes.none.body": "Program muncul di sini setelah laboratorium lain terdaftar secara aktif di dalamnya.",
  "eqa.provider.schemes.provider": "Penyelenggara",
  "eqa.provider.schemes.enrolled": "Lab terdaftar",
  "eqa.provider.schemes.cycles": "Siklus",
  "eqa.provider.schemes.expand": "Tampilkan siklus",
  "eqa.provider.schemes.newCycle": "Siklus baru",
  "eqa.provider.schemes.noCycles": "Belum ada siklus. Mulai satu siklus untuk menentukan panel dan pesertanya.",
  "eqa.scheme.type.international_pt": "Uji Profisiensi Internasional",
  "eqa.scheme.type.regional_pt": "Uji Profisiensi Regional",
  "eqa.scheme.type.inter_lab_split": "Pembagian antar-lab",
  "eqa.scheme.type.in_house": "Internal",
  "eqa.panel.source.in_house_aliquoted": "Pool sampel pasien, dialikuot secara internal",
  "eqa.panel.source.vendor_sourced": "Material dari vendor",
  "eqa.panel.source.mixed": "Sumber campuran",
  "eqa.panel.storage.ambient": "Suhu ruang",
  "eqa.panel.storage.refrigerated_2_8c": "Didinginkan, 2–8°C",
  "eqa.panel.storage.frozen_minus_20c": "Beku, −20°C",
  "eqa.panel.storage.ultra_frozen_minus_80c": "Ultra-beku, −80°C",
  "eqa.panel.storage.dry_ice": "Es kering",
  "eqa.provider.wizard.title": "Siklus baru",
  "eqa.provider.wizard.forScheme": "Siklus baru: {name}",
  "eqa.provider.wizard.step.cycle": "Siklus",
  "eqa.provider.wizard.step.panel": "Panel",
  "eqa.provider.wizard.step.distribution": "Distribusi",
  "eqa.provider.wizard.cycleName": "Nama siklus",
  "eqa.provider.wizard.cycleNumber": "Nomor siklus",
  "eqa.provider.wizard.cycleNumber.hint": "Jika dikosongkan, nomor berikutnya yang belum digunakan untuk program ini akan dipakai.",
  "eqa.provider.wizard.panelName": "Nama Panel",
  "eqa.provider.wizard.source": "Sumber bahan",
  "eqa.provider.wizard.lot": "Nomor lot",
  "eqa.provider.wizard.vendor": "Nama pemasok",
  "eqa.provider.wizard.vendorLot": "Lot pemasok",
  "eqa.provider.wizard.vendorCertificate": "Referensi sertifikat pemasok",
  "eqa.provider.wizard.sampleCode": "Kode sampel",
  "eqa.provider.wizard.target": "Nilai target",
  "eqa.provider.wizard.target.hint": "Nilai target disegel dan dienkripsi saat disimpan; kosongkan jika target baru diketahui saat penilaian.",
  "eqa.provider.wizard.unit": "Unit",
  "eqa.provider.wizard.rangeLow": "Batas bawah penerimaan",
  "eqa.provider.wizard.rangeHigh": "Batas atas penerimaan",
  "eqa.provider.wizard.addSample": "Tambah sampel",
  "eqa.provider.wizard.removeSample": "Hapus",
  "eqa.provider.wizard.sampleCount": "Sampel panel",
  "eqa.provider.wizard.test": "Pemeriksaan",
  "eqa.provider.wizard.test.select": "Pilih pemeriksaan",
  "eqa.provider.wizard.participants": "Laboratorium peserta",
  "eqa.provider.wizard.participants.hint": "Hanya lab yang terdaftar aktif dalam program ini yang dapat ikut serta, dan hanya lab yang dipilih di sini yang dihitung oleh gerbang persiapan.",
  "eqa.provider.wizard.storageTemp": "Suhu penyimpanan",
  "eqa.provider.wizard.storageTemp.hint": "Menjadi persyaratan suhu untuk setiap boks pengiriman.",
  "eqa.provider.wizard.storageTemp.select": "Pilih suhu",
  "eqa.provider.wizard.expiration": "Kedaluwarsa bahan",
  "eqa.provider.wizard.reserve.hint": "Alikuot yang disisihkan untuk pemeriksaan ulang dicatat di meja kerja persiapan, setelah bahannya tersedia.",
  "eqa.provider.wizard.confirm.hint": "Membuat siklus akan langsung memindahkannya ke tahap persiapan, tempat jumlah alikuot dan QC homogenitas dicatat.",
  "eqa.provider.wizard.create": "Buat siklus dan mulai persiapan",
  "eqa.provider.wizard.failed": "Siklus tidak dibuat.",
  "eqa.cycle.distributionMethod": "Metode distribusi",
  "eqa.cycle.distributionMethod.fhir": "FHIR",
  "eqa.cycle.distributionMethod.csv": "Ekspor CSV",
  "eqa.cycle.distributionMethod.mixed": "Campuran",
  "eqa.cycle.distributionMethod.hint": "FHIR terhubung, file yang diekspor, atau keduanya jika peserta berbeda. Rantai dingin panel dicatat beserta sumbernya pada langkah 2.",
  "eqa.cycle.history": "Riwayat siklus",
  "eqa.cycle.history.empty": "Belum ada perubahan status yang tercatat untuk siklus ini.",
  "eqa.cycle.history.when": "Ketika",
  "eqa.cycle.history.state": "Status",
  "eqa.cycle.history.trigger": "Pemicu",
  "eqa.cycle.history.reason": "Alasan",
  "eqa.cycle.history.manual": "Manual",
  "eqa.report.comments.tab": "Komentar Laporan",
  "eqa.report.comments.hint": "Hanya komentar yang telah disetujui sebelumnya yang dapat dicetak. Edit kata-katanya di Administrasi → Manajemen Kamus.",
  "eqa.report.comments.picker": "Komentar yang disetujui",
  "eqa.report.comments.pickerLabel": "Pilih komentar",
  "eqa.report.comments.add": "Tambahkan ke laporan",
  "eqa.report.comments.added": "{count} komentar ditambahkan ke laporan",
  "eqa.report.comments.comment": "Komentar",
  "eqa.report.comments.attribution": "Ditambahkan oleh",
  "eqa.report.comments.none": "Belum ada komentar pada laporan siklus ini.",
  "eqa.report.comments.remove": "Hapus",
  "eqa.report.comments.emptyLibrary.title": "Belum ada komentar yang disetujui",
  "eqa.report.comments.emptyLibrary.body": "Tambahkan entri ke kategori kamus Komentar Laporan PME agar dapat dipilih di sini.",
  "eqa.report.comments.addFailed": "Komentar tidak dapat ditambahkan ke laporan.",
  "eqa.report.comments.removeFailed": "Komentar tidak dapat dihapus dari laporan.",
  "eqa.performance.ACCEPTABLE": "Dapat diterima",
  "eqa.performance.QUESTIONABLE": "Dipertanyakan",
  "eqa.performance.UNACCEPTABLE": "Tidak dapat diterima",
  "eqa.oversight.followUpQueue": "Tindak Lanjut Lab Ini",
  "eqa.oversight.queueSubtitle": "Skor PME lab ini yang meragukan dan menunggu tinjauan perbaikan, dari penyelenggara eksternal dan program internal lab ini. Korespondensi dengan laboratorium yang mengikuti program yang diselenggarakan lab ini adalah register yang berbeda:",
  "eqa.queue.policyTitle": "Kebijakan KTS otomatis aktif.",
  "eqa.queue.policyBody": "Skor yang tidak dapat diterima pada program eksternal mana pun yang diikuti lab ini akan membuka KTS secara otomatis. Antrian ini berisi rentang meragukan (2 < |Z| ≤ 3) dan kegagalan internal, yang memerlukan triase oleh manusia.",
  "eqa.queue.kpi.queued": "Item dalam antrian",
  "eqa.queue.kpi.questionable": "Dipertanyakan",
  "eqa.queue.kpi.questionable.hint": "2 < |Z| ≤ 3",
  "eqa.queue.kpi.inHouse": "Kegagalan internal",
  "eqa.queue.kpi.oldest": "Terlama",
  "eqa.queue.kpi.days": "{days} hari",
  "eqa.queue.count": "Antrian · {count, plural, one {# item} other {# item}}",
  "eqa.queue.exportCsv": "Ekspor CSV",
  "eqa.queue.empty": "Tidak ada yang menunggu triase. Skor yang meragukan dan kegagalan internal masuk ke sini saat siklus dinilai.",
  "eqa.queue.cycle": "Siklus",
  "eqa.queue.cycleNumber": "Siklus {number}",
  "eqa.queue.analyte": "Analit",
  "eqa.queue.analytePlus": "{first} +{more} lainnya",
  "eqa.queue.zScore": "Skor Z",
  "eqa.queue.reason": "Alasan",
  "eqa.queue.enqueued": "Dimasukkan ke antrian",
  "eqa.queue.source": "Sumber",
  "eqa.queue.source.external": "Penyelenggara eksternal",
  "eqa.queue.source.in_house": "Internal",
  "eqa.queue.source.inter_lab_split": "Pembagian antar-lab",
  "eqa.queue.reason.questionable": "Dipertanyakan",
  "eqa.queue.reason.inHouseFailure": "Gagal internal",
  "eqa.queue.triage": "Triase",
  "eqa.queue.triageTitle": "Triase item ini",
  "eqa.queue.triageHelp": "Lakukan eskalasi jika Anda mencurigai adanya ketidaksesuaian yang nyata. Abaikan dengan alasan jika ini hanya gangguan, misalnya kesalahan transkripsi atau masalah alat yang sudah terdokumentasi. Entri yang diabaikan tetap terhubung ke siklus untuk ketertelusuran akreditasi.",
  "eqa.queue.reported": "Dilaporkan",
  "eqa.queue.target": "Target",
  "eqa.queue.verdict": "Putusan",
  "eqa.queue.escalate": "Eskalasi ke KTS",
  "eqa.queue.dismiss": "Abaikan dengan alasan",
  "eqa.queue.viewCycle": "Lihat siklus",
  "eqa.queue.escalated": "Dieskalasi: KTS {nce} diajukan untuk siklus ini.",
  "eqa.queue.escalateFailed": "Eskalasi ditolak.",
  "eqa.queue.dismissed": "Diabaikan. Kejadian kompetensi untuk kategori ini telah dicatat.",
  "eqa.queue.dismissFailed": "Pengabaian ditolak.",
  "eqa.queue.dismissHeading": "Abaikan dengan alasan",
  "eqa.queue.dismissConfirm": "Tutup",
  "eqa.queue.dismissHelp": "Kategori menentukan kejadian kompetensi yang dicatat untuk setiap hasil yang tercakup dalam entri ini, jadi pilih kategori yang menggambarkan apa yang terjadi.",
  "eqa.queue.cancel": "Batal",
  "eqa.queue.category": "Kategori",
  "eqa.queue.category.TRANSCRIPTION_ERROR": "Kesalanan transkripsi",
  "eqa.queue.category.KNOWN_EQUIPMENT_ISSUE": "Masalah alat yang sudah diketahui",
  "eqa.queue.category.PENDING_RE_TEST": "Menunggu pemeriksaan ulang",
  "eqa.queue.category.ACCEPTABLE_ON_REVIEW": "Dapat diterima setelah ditinjau",
  "eqa.queue.category.OTHER": "Lainnya",
  "eqa.queue.notes": "Catatan",
  "eqa.labperf.title": "Kinerja Lab",
  "eqa.labperf.coverage.title": "Kinerja PME Lab: Cakupan",
  "eqa.labperf.coverage.subtitle": "Ringkasan akreditasi: KPI tingkat lab, lalu cakupan PME per instalasi lab pada empat siklus terakhir setiap program. Instalasi lab tanpa PT aktif menjadi kandidat untuk penilaian alternatif ISO 15189 §7.7.2.",
  "eqa.labperf.recent.title": "Kinerja PME Lab: Siklus Terbaru",
  "eqa.labperf.recent.subtitle": "Siklus yang dilaporkan lab ini dalam 12 bulan terakhir, beserta status penilaian dan putusannya.",
  "eqa.labperf.tab.coverage": "Cakupan",
  "eqa.labperf.tab.recent": "Siklus Terbaru",
  "eqa.labperf.kpi.acceptance": "Tingkat penerimaan (12 bln)",
  "eqa.labperf.kpi.delta": "{delta} dibanding tahun sebelumnya",
  "eqa.labperf.kpi.noPriorYear": "tidak ada tahun sebelumnya untuk dibandingkan",
  "eqa.labperf.kpi.onTime": "Tingkat pengiriman tepat waktu",
  "eqa.labperf.kpi.late": "{late} terlambat dari {total}",
  "eqa.labperf.kpi.nce": "KTS yang dipicu PME (12 bln)",
  "eqa.labperf.kpi.nceOpen": "{open} terbuka → register KTS",
  "eqa.labperf.kpi.uncovered": "Pemeriksaan terakreditasi tanpa PME",
  "eqa.labperf.kpi.uncovered.hint": "Kandidat §7.7.2",
  "eqa.labperf.openNceRegister": "Buka register KTS yang difilter untuk kejadian yang dipicu PME",
  "eqa.labperf.legendIntro": "Empat siklus terakhir setiap program, per bagian.",
  "eqa.labperf.legend.acceptable": "Dapat diterima",
  "eqa.labperf.legend.questionable": "Dipertanyakan",
  "eqa.labperf.legend.unacceptable": "Tidak dapat diterima",
  "eqa.labperf.legend.missing": "Tidak terdaftar / terlewat",
  "eqa.labperf.section": "Bagian",
  "eqa.labperf.unassignedSection": "Bagian belum ditetapkan",
  "eqa.labperf.scheme": "Program",
  "eqa.labperf.cycle": "Siklus",
  "eqa.labperf.cycleOffset": "Siklus −{n}",
  "eqa.labperf.mostRecent": "Terbaru",
  "eqa.labperf.acceptanceRate": "Tingkat penerimaan",
  "eqa.labperf.coverage.empty": "Belum ada hasil PME yang dinilai. Cakupan muncul setelah siklus yang diikuti lab ini dinilai.",
  "eqa.labperf.gapTitle": "Terakreditasi tanpa cakupan PME:",
  "eqa.labperf.gapBody": "{tests}: tidak ada pendaftaran PME aktif, sehingga penilaian alternatif ISO 15189 §7.7.2 diperlukan.",
  "eqa.labperf.filterScheme": "Filter program",
  "eqa.labperf.status": "Status",
  "eqa.labperf.score": "Skor",
  "eqa.labperf.scoreOf": "{acceptable} dari {scored}",
  "eqa.labperf.performance": "Kinerja",
  "eqa.labperf.submitted": "Dikirim",
  "eqa.labperf.pending": "tertunda",
  "eqa.labperf.verdict.acceptable": "Dapat diterima",
  "eqa.labperf.verdict.questionable": "Dipertanyakan",
  "eqa.labperf.verdict.unacceptable": "Tidak dapat diterima",
  "eqa.labperf.recent.empty": "Tidak ada siklus yang dilaporkan dalam 12 bulan terakhir.",
  "nce.filter.source": "Sumber",
  "nce.filter.source.all": "Semua sumber",
  "nce.filter.source.eqa": "Dipicu PME",
  "eqa.receipt.tab": "Tanda Terima & Penilaian",
  "eqa.receipt.hint": "Penyerahan terbuka dengan sendirinya setelah setiap peserta menerima panelnya. Lewat tenggat berarti dua hari kerja setelah perkiraan tanggal pengiriman.",
  "eqa.receipt.noParticipants.body": "Tanda terima muncul di sini setelah panel dikirim ke laboratorium peserta yang terdaftar.",
  "eqa.receipt.condition": "Kondisi",
  "eqa.receipt.damaged": "Rusak: {notes}",
  "eqa.receipt.tempOnArrival": "{temp} °C",
  "eqa.receipt.isRepeat": "Kiriman ulang",
  "eqa.receipt.markReceived": "Tandai diterima",
  "eqa.receipt.delivered": "Pengiriman telah dicatat.",
  "eqa.receipt.deliveredFailed": "Pengiriman tidak dapat dicatat.",
  "eqa.receipt.sendRepeat": "Kirim ulang",
  "eqa.receipt.repeatHeading": "Kirim panel ulang",
  "eqa.receipt.repeatHelp": "Panel ulang diambil dari cadangan panel. Jika cadangan tidak mencukupi, justifikasi tertulis wajib diberikan sebelum bahan yang tidak dicadangkan digunakan.",
  "eqa.receipt.overrideNote": "Catatan penimpaan",
  "eqa.receipt.repeatSent": "Panel ulang telah dikirim.",
  "eqa.receipt.repeatFailed": "Pengiriman ulang ditolak.",
  "eqa.receipt.status.NOT_SHIPPED": "Belum dikirim",
  "eqa.receipt.status.IN_TRANSIT": "Dalam Transit",
  "eqa.receipt.status.EXCEPTION": "Tiba dalam keadaan rusak",
  "eqa.score.scoreCycle": "Nilai siklus",
  "eqa.score.scored": "Siklus telah dinilai. Peserta dengan hasil tidak dapat diterima tercantum di register tindak lanjut.",
  "eqa.score.scoreFailed": "Siklus tidak dapat dinilai.",
  "eqa.score.verdicts": "Skor",
  "eqa.score.counts": "{unacceptable} tidak dapat diterima dari {total}",
  "eqa.score.sendScores": "Kirim skor",
  "eqa.score.distributed": "Skor ditempatkan di penyimpanan FHIR untuk diambil oleh peserta.",
  "eqa.score.distributeFailed": "Skor tidak dapat dikembalikan.",
  "eqa.score.downloadCsv": "CSV Skor",
  "eqa.provider.followups.title": "Tindak lanjut peserta",
  "eqa.provider.followups.subtitle": "Laboratorium yang mengikuti program yang diselenggarakan lab ini dan mengembalikan hasil yang tidak dapat diterima. Tindak lanjut di sini adalah korespondensi dengan lab lain; tindak lanjut ini tidak pernah membuka ketidaksesuaian di register lab ini sendiri.",
  "eqa.provider.followups.open": "Register tindak lanjut",
  "eqa.provider.followups.empty": "Tidak ada tindak lanjut peserta. Entri muncul di sini saat siklus penyelenggara dinilai.",
  "eqa.provider.followups.unknownOrg": "Lab tidak diketahui",
  "eqa.provider.followups.persistent": "Kegagalan berulang",
  "eqa.provider.followups.response": "Tanggapan",
  "eqa.provider.followups.notify": "Beri tahu lab",
  "eqa.provider.followups.emailed": "Notifikasi telah dikirim melalui email ke {to}.",
  "eqa.provider.followups.csvFallback": "Tidak ada email kontak yang tercatat; notifikasi telah diunduh sebagai CSV untuk dikirim secara manual.",
  "eqa.provider.followups.flagRepeat": "Tandai untuk pengulangan",
  "eqa.provider.followups.repeatSent": "Panel ulang telah dikirim ke {name}.",
  "eqa.provider.followups.moved": "Tindak lanjut dipindahkan ke {status}.",
  "eqa.provider.followups.failed": "Tindakan ditolak.",
  "eqa.provider.followups.notesHelp": "Apa yang disepakati dengan laboratorium. Dicatat pada entri register untuk ketertelusuran akreditasi.",
  "eqa.provider.followups.status.NOTIFIED": "Telah diberi tahu",
  "eqa.provider.followups.status.RESPONSE_RECEIVED": "Tanggapan diterima",
  "eqa.provider.followups.status.UNDER_INVESTIGATION": "Dalam investigasi",
  "eqa.provider.followups.status.ESCALATED": "Dieskalasi",
  "eqa.provider.followups.status.REMOVED_FROM_PROGRAM": "Dikeluarkan dari program",
  "eqa.provider.followups.action.RESPONSE_RECEIVED": "Catat tanggapan",
  "eqa.provider.followups.action.UNDER_INVESTIGATION": "Investigasi",
  "eqa.provider.followups.action.RESOLVED": "Selesaikan",
  "eqa.provider.followups.action.REMOVED_FROM_PROGRAM": "Keluarkan dari program",
  "eqa.competency.subtitle": "Semua analis yang ditugaskan pada uji profisiensi dalam dua belas bulan terakhir, dikategorikan per analit. Analis dinyatakan kompeten hanya jika didukung bukti; kurang dari empat sampel yang dapat dinilai berarti dalam peninjauan, bukan lolos.",
  "eqa.competency.band.competent": "Kompeten",
  "eqa.competency.band.underReview": "Dalam peninjauan",
  "eqa.competency.band.notCompetent": "Tidak kompeten",
  "eqa.competency.outcome.acceptable": "Dapat diterima",
  "eqa.competency.outcome.questionable": "Dipertanyakan",
  "eqa.competency.outcome.unacceptable": "Tidak dapat diterima",
  "eqa.competency.outcome.missed": "Melewati tenggat",
  "eqa.competency.outcome.dismissed": "Diabaikan saat triase",
  "eqa.competency.event.scored": "Hasil yang dinilai",
  "eqa.competency.event.UNACCEPTABLE_SCORE": "Skor tidak dapat diterima",
  "eqa.competency.event.QUESTIONABLE_SCORE": "Skor meragukan",
  "eqa.competency.event.EXTERNAL_MISSED_DEADLINE": "Melewati tenggat penyelenggara",
  "eqa.competency.event.IN_HOUSE_MISSED_DEADLINE": "Melewati tenggat internal",
  "eqa.competency.event.ESCALATED_TO_NCE": "Dieskalasi menjadi ketidaksesuaian",
  "eqa.competency.event.DISMISSED_EQUIPMENT": "Diabaikan: peralatan",
  "eqa.competency.event.DISMISSED_TRANSCRIPTION": "Diabaikan: transkripsi",
  "eqa.competency.event.DISMISSED_ACCEPTABLE_ON_REVIEW": "Diabaikan: dapat diterima saat ditinjau",
  "eqa.competency.event.DISMISSED_OTHER": "Diabaikan: lainnya",
  "eqa.competency.kpi.analysts": "Analis yang dinilai",
  "eqa.competency.kpi.samples": "{count} sampel uji profisiensi",
  "eqa.competency.kpi.notCompetent.hint": "KTS eskalasi terbuka",
  "eqa.competency.search": "Filter analis",
  "eqa.competency.export": "Ekspor CSV",
  "eqa.competency.analyst": "Analis",
  "eqa.competency.samples": "Sampel uji profisiensi (12 bln)",
  "eqa.competency.recent": "Kinerja terbaru",
  "eqa.competency.status": "Kompetensi",
  "eqa.competency.history": "Riwayat",
  "eqa.competency.viewHistory": "Lihat Riwayat",
  "eqa.competency.empty": "Belum ada analis yang tercatat pada hasil PME dalam dua belas bulan terakhir. Analis akan muncul di sini setelah hasil memiliki analis yang ditugaskan.",
  "eqa.competency.analyteCount": "{count} analit dinilai",
  "eqa.competency.thisYear": "{count} tahun ini · {failures} gagal",
  "eqa.competency.byAnalyte": "Kompetensi per analit",
  "eqa.competency.analyte": "Analit",
  "eqa.competency.evaluable": "Dapat dievaluasi",
  "eqa.competency.failures": "Kegagalan",
  "eqa.competency.latest": "Terbaru",
  "eqa.competency.unnamedAnalyte": "Analit tanpa nama",
  "eqa.competency.evidence": "Bukti · semua kejadian dalam periode",
  "eqa.competency.date": "Tanggal",
  "eqa.competency.scheme": "Program",
  "eqa.competency.event": "Kejadian",
  "eqa.competency.outcome": "Hasil",
  "eqa.competency.counted": "Diperhitungkan",
  "eqa.competency.countsFail": "Gagal",
  "eqa.competency.countsPass": "Dinilai",
  "eqa.competency.countsExcused": "Dikecualikan",
  "eqa.result.analyst": "Analis (PME)",
  "eqa.result.analystChoose": "Pilih analis",
  "eqa.result.analystRequired": "Program PME ini mencatat siapa yang mengerjakan setiap sampel. Pilih analis sebelum menyimpan.",
  "eqa.program.perAnalyst": "Catat analis pada setiap hasil",
  "eqa.program.perAnalyst.on": "Analis dicatat",
  "eqa.program.perAnalyst.off": "Tidak terekam",
  "eqa.result.analyst.tooltip": "Ditampilkan karena proses ini mencakup sampel PME yang programnya mencatat siapa yang mengerjakan setiap sampel. Pilih pengguna OpenELIS yang mengerjakan sampel tersebut dari daftar analis program; catatan ini terpisah dari pengguna yang memasukkan hasil ini dan pengguna yang memvalidasinya. Baris non-PME tidak memerlukan isian.",
  "shipment.settings.siteOrgUnsetTitle": "Organisasi tempat belum diatur",
  "shipment.settings.siteOrgUnsetSubtitle": "Kiriman masuk tidak difilter untuk tempat ini dan boks keluar tidak memiliki pengirim. Pilih organisasi yang mewakili laboratorium ini.",
  "shipment.settings.siteOrgUnmatchedTitle": "Diatur ke organisasi yang tidak ada di instans ini",
  "shipment.settings.siteOrgUnmatchedSubtitle": "UUID di bawah ini adalah UUID yang digunakan mitra untuk mengenali laboratorium ini, dan tidak cocok dengan organisasi mana pun di sini. Pemfilteran tetap berfungsi; biarkan kecuali mitra mengubahnya.",
  "eqa.receipt.openSubmissions": "Buka penyerahan",
  "eqa.receipt.openSubmissionsHeading": "Buka penyerahan dengan panel yang belum terkirim",
  "eqa.receipt.openSubmissionsHelp": "Peserta yang belum menerima panelnya tetap tercantum dalam daftar sebagai terlambat. Ini adalah penimpaan manual yang dicatat; berikan alasannya.",
  "eqa.receipt.openSubmissionsReason": "Alasan",
  "eqa.receipt.submissionsOpened": "Penyerahan telah dibuka.",
  "eqa.receipt.submissionsOpenFailed": "Tidak dapat membuka penyerahan.",
  "eqa.provider.schemes.lastDistribution": "Distribusi terakhir",
  "eqa.provider.wizard.distributionDate": "Tanggal distribusi",
  "eqa.provider.wizard.submissionDeadline": "Tenggat penyerahan",
  "eqa.provider.kpi.activeSchemes": "Program aktif",
  "eqa.provider.kpi.openCycles": "Siklus terbuka",
  "eqa.provider.kpi.enrolled": "Peserta terdaftar",
  "eqa.provider.kpi.followupsOpen": "Tindak lanjut terbuka",
  "eqa.provider.schemes.discipline": "Disiplin",
  "eqa.cycle.history.actor": "Pelaku",
  "eqa.cycle.history.systemActor": "Sistem",
  "eqa.prep.reserved.recommend": "{n} direkomendasikan: maks(10% peserta, 5)",
  "eqa.provider.schemes.participantOnly.title": "Hanya tampilan peserta",
  "eqa.provider.schemes.participantOnly.body": "Administrasi program penyelenggara memerlukan hak penyelenggara. Partisipasi lab Anda ada di halaman di bawah ini.",
  "eqa.provider.schemes.link.myPrograms": "Pendaftaran saya: program yang diikuti lab ini",
  "eqa.provider.schemes.link.myCycles": "Siklus Saya: panel, hasil, dan tenggat",
  "eqa.btn.newCycle": "Siklus baru",
  "eqa.cycle.new.heading": "Siklus PME Baru",
  "eqa.cycle.new.help": "Untuk penyelenggara yang tidak mengirim kiriman ke OpenELIS ini: catat siklus tempat panel tersebut berada agar muncul di sini dengan \"Terima panel\". Kiriman dari penyelenggara OpenELIS membuka siklusnya saat diimpor.",
  "eqa.cycle.new.scheme": "Program (dari Program PME Saya)",
  "eqa.cycle.new.name": "Nama siklus",
  "eqa.cycle.new.distributionDate": "Tanggal distribusi",
  "eqa.cycle.new.deadline": "Tenggat penyerahan",
  "eqa.cycle.new.create": "Buat siklus",
  "eqa.cycle.new.created": "Siklus dibuat. Siklus tercantum sebagai Direncanakan; gunakan \"Terima panel\" saat panel tiba.",
  "eqa.cycle.new.error": "Tidak dapat membuat siklus",
  "eqa.cycle.new.noPrograms": "Daftar ke program di Program PME Saya terlebih dahulu.",
  "eqa.order.receipt.consignment": "Kiriman masuk",
  "eqa.order.receipt.consignment.none": "Tidak ada: diterima di luar modul pengiriman",
  "eqa.order.receipt.consignment.thisCycle": "siklus ini",
  "eqa.order.receipt.consignment.help": "Memilih kiriman berarti menerima kiriman tersebut dan memberi tahu penyelenggara bahwa panel telah tiba.",
  "eqa.order.receipt.reference": "Referensi pengiriman",
  "eqa.order.receipt.referenceRecorded": "Kiriman {code} diterima.",
  "eqa.intake.enterResults": "Masukkan hasil",
  "eqa.intake.heading": "Hasil dari {lab}",
  "eqa.intake.help": "Masukkan nilai sesuai yang dilaporkan peserta, berupa angka atau kata seperti Reaktif. Menyimpan akan menimpa data yang tersimpan untuk pemeriksaan tersebut.",
  "eqa.intake.test": "Pemeriksaan",
  "eqa.intake.value": "Nilai yang dilaporkan",
  "eqa.intake.save": "Simpan hasil",
  "eqa.intake.saved": "Hasil dicatat untuk {lab}.",
  "eqa.intake.failed": "Tidak dapat mencatat hasil",
  "eqa.intake.csv": "Atau tempel bundel ekspor peserta (CSV)",
  "eqa.intake.import": "Impor CSV",
  "eqa.intake.imported": "{count, plural, other {# nilai diimpor.}}",
  "eqa.intake.noTests": "Program ini belum memiliki pemeriksaan yang ditetapkan.",
  "eqa.cycle.importScores": "Impor skor (CSV)",
  "eqa.cycle.importScores.heading": "Impor skor dari penyelenggara",
  "eqa.cycle.importScores.help": "Tempelkan CSV skor yang dikirim penyelenggara (kolom analyte_name dan performance_status). Skor dari penyelenggara OpenELIS masuk secara otomatis melalui penyimpanan FHIR.",
  "eqa.cycle.importScores.csv": "CSV skor",
  "eqa.cycle.importScores.import": "Impor skor",
  "eqa.cycle.importScores.imported": "{count} skor dicatat.",
  "eqa.cycle.importScores.unmapped": "Tidak dikenali di sini: {names}",
  "eqa.cycle.importScores.failed": "Tidak dapat mengimpor skor",
  "eqa.program.schemeType": "Jenis program",
  "eqa.program.schemeType.helper": "Program internal dijalankan oleh laboratorium ini dan tidak memerlukan penyelenggara; semua jenis lainnya memerlukannya.",
  "eqa.order.receipt.notes.required": "Jelaskan apa yang salah dengan material. Penerimaan yang ditandai tidak utuh memerlukan catatan yang menjelaskannya.",
  "eqa.provider.wizard.cycleName.required": "Siklus memerlukan nama.",
  "eqa.provider.wizard.dates.required": "Siklus memerlukan tanggal distribusi dan tenggat penyerahan; pengingat dikirim berdasarkan tenggat tersebut.",
  "eqa.enrollment.scheme": "Program",
  "eqa.enrollment.scheme.helper": "Pilih program yang tersedia di instans ini, atau pilih Tidak tercantum dan ketik namanya.",
  "eqa.enrollment.scheme.frozen": "Pendaftaran ini sudah memiliki siklus, sehingga program dan penyelenggaranya tidak dapat diubah.",
  "eqa.enrollment.scheme.other": "Tidak tercantum - ketik namanya",
  "eqa.action.forbidden": "Tindakan ini memerlukan izin {grant}, yang tidak dimiliki akun Anda. Mintalah izin tersebut kepada administrator.",
  "eqa.receipt.readOnly.title": "Tampilan baca-saja tanda terima dan skor",
  "eqa.receipt.readOnly.body": "Mencatat pengiriman, mengirim ulang panel, memasukkan hasil, dan mengembalikan skor memerlukan hak penyelenggara; menilai siklus memerlukan hak kelola. Tabel di bawah ini tetap menampilkan seluruh siklus.",
  "eqa.inhouse.readOnly.title": "Tampilan baca-saja panel internal",
  "eqa.inhouse.readOnly.body": "Merancang dan menyegel panel tersamar memerlukan hak kelola. Panel di bawah ini tetap menampilkan gambaran lengkap.",
  "eqa.score.downloadReport": "PDF Laporan",
  "eqa.labperf.exportCsv": "Ekspor CSV",
  "eqa.labperf.kpi.submitted": "Siklus yang dikirim",
  "eqa.labperf.acceptableOf": "Dapat diterima dari yang dinilai",
  "eqa.labperf.kpi.lateCount": "Pengiriman terlambat",
  "eqa.labperf.kpi.nceOpenCount": "Dari jumlah itu, masih terbuka",
  "eqa.queue.source.all": "Semua sumber",
  "eqa.queue.countFiltered": "Antrian · {count} dari {total, plural, one {# item} other {# item}}",
  "eqa.queue.emptyForSource": "Tidak ada item dari sumber ini yang menunggu triase. Antrian berisi {total, plural, one {# item} other {# item}} dari sumber lain.",
  "eqa.program.requiresCycleReview": "Tahan setiap siklus untuk ditinjau sebelum dikirim",
  "eqa.program.requiresCycleReview.off": "Kirim otomatis",
  "eqa.program.requiresCycleReview.on": "Tahan untuk tinjauan",
  "eqa.cycle.submitManual": "Kirim manual",
  "eqa.cycle.submitManual.heading": "Catat penyerahan yang dilakukan secara manual",
  "eqa.cycle.submitManual.help": "Gunakan ini setelah hasil sampai ke penyelenggara melalui cara lain. Referensi yang diberikan penyelenggara menjadikan ini sebuah catatan, bukan sekadar klaim, sehingga wajib diisi.",
  "eqa.cycle.submitManual.reference": "Referensi penyelenggara",
  "eqa.cycle.submitManual.success": "Dicatat sebagai dikirim manual, dengan referensi penyelenggara.",
  "eqa.cycle.retriesSpent.title": "Pengiriman otomatis telah dihentikan untuk siklus ini.",
  "eqa.cycle.retriesSpent.body": "Pengiriman gagal {attempts} kali dan tidak akan dicoba lagi. Kirim hasil ke penyelenggara secara mandiri - paket ekspor tersedia di halaman program - lalu catat referensinya di sini.",
  "eqa.provider.wizard.sampleCode.duplicate": "Setiap kode sampel pada satu panel harus berbeda.",
  "eqa.provider.wizard.rangeHigh.backwards": "Batas atas rentang penerimaan tidak boleh lebih rendah dari batas bawah.",
  "eqa.shipment.packList.panelColumn": "Panel",
  "eqa.provider.schemes.performance": "Kinerja",
  "eqa.performance.title": "Kinerja peserta",
  "eqa.performance.subtitle": "Tingkat kelolosan setiap laboratorium selama empat siklus terakhir yang dinilai dalam program ini. Perluas baris untuk melihat siklus di balik tingkat tersebut.",
  "eqa.performance.laboratory": "Laboratorium",
  "eqa.performance.region": "Regional",
  "eqa.performance.enrollment": "Pendaftaran",
  "eqa.performance.passRate": "Tingkat kelolosan (4 terakhir)",
  "eqa.performance.mostRecent": "Terbaru",
  "eqa.performance.openFollowups": "Tindak lanjut terbuka",
  "eqa.performance.expand": "Riwayat siklus",
  "eqa.performance.ofJudged": "{accepted} dari {judged}",
  "eqa.performance.noRate": "Belum ada siklus yang dinilai",
  "eqa.performance.noCycles": "Laboratorium ini belum melaporkan ke siklus yang dinilai.",
  "eqa.performance.empty": "Belum ada laboratorium yang terdaftar dalam program ini.",
  "eqa.performance.loadFailed": "Tidak dapat memuat kinerja peserta",
  "eqa.myPrograms.group.active": "Pendaftaran aktif ({count})",
  "eqa.order.coverage.title": "Di luar pendaftaran laboratorium ini",
  "eqa.order.coverage.subtitle": "Pendaftaran untuk program ini tidak mencakup: {tests}. Anda tetap dapat menyimpan pemesanan.",
  "eqa.myPrograms.group.suspended": "Pendaftaran ditangguhkan ({count})",
  "eqa.myPrograms.group.withdrawn": "Pendaftaran ditarik ({count})",
  "eqa.enrollment.resume": "Lanjutkan",
  "eqa.enrollment.statusReason": "Alasan",
  "eqa.enrollment.statusReasonPlaceholder": "Mengapa status pendaftaran ini berubah?",
  "eqa.enrollment.statusEffectiveDate": "Berlaku sejak",
  "eqa.enrollment.withdrawIsFinal": "Penarikan bersifat final. Untuk ikut kembali, laboratorium ini harus mendaftar ulang ke program.",
  "eqa.enrollment.statusChanged": "Pendaftaran ini sekarang {status}",
  "eqa.enrollment.statusChangeFailed": "Tidak dapat mengubah status pendaftaran ini",
  "eqa.enrollment.panels.help": "Paket pemeriksaan standar dari katalog. Inilah yang dilaporkan oleh laboratorium Anda, bukan bahan PME yang dikirim penyelenggara kepada Anda.",
  "eqa.myPrograms.panels.help": "Panel pemeriksaan dari katalog yang dicakup oleh pendaftaran ini.",
  "eqa.score.scoredWithUnjudged": "Siklus telah dinilai, tetapi {count} hasil tidak mendapat putusan, pada {tests}. Analit tersebut tidak memiliki target tersegel dan siklus ini memiliki terlalu sedikit pembanding untuk menilainya.",
  "eqa.cycle.close": "Tutup siklus",
  "eqa.cycle.closeHeading": "Tutup siklus ini",
  "eqa.cycle.closeHelp": "Siklus yang ditutup bersifat final: peserta melihatnya sebagai ditutup dan tidak ada keputusan lebih lanjut yang dicatat untuk siklus tersebut. Penutupan ditolak selama masih ada tindak lanjut yang terbuka atau hasil yang melewati tenggat masih menunggu jawaban.",
  "eqa.cycle.closeFailed": "Tidak dapat menutup siklus ini",
  "eqa.prep.ofTotal": "{n} dari {total}",
  "eqa.prep.tile.participants": "Laboratorium terdaftar yang dipilih untuk siklus ini",
  "eqa.prep.tile.panels": "Panel material yang disiapkan",
  "eqa.prep.dispatched": "Kiriman peserta telah dikirim",
  "eqa.prep.readyToShip.blockedByGate": "Persiapan belum lengkap. Gerbang siap kirim di atas mencantumkan apa yang masih tertunda.",
  "eqa.prep.readyToShip.notInPrep": "Status siklus: {status}. Persetujuan pengiriman hanya tersedia selama siklus dalam tahap persiapan.",
  "eqa.prep.goToShipments": "Buka tab Pengiriman",
  "eqa.competency.rule.meetsEvidence": "Bukti terpenuhi",
  "eqa.competency.rule.repeatedFailure": "Kegagalan berulang",
  "eqa.competency.rule.insufficientEvidence": "Bukti tidak mencukupi",
  "eqa.competency.rule.openEscalation": "Ketidaksesuaian terbuka",
  "eqa.competency.reason.meetsEvidence": "{evaluable} sampel yang dapat dinilai dengan {failures} kegagalan antara {from} dan {to}, mencapai atau melebihi batas minimum bukti sebanyak {floor}. Tidak ada tindakan yang diperlukan.",
  "eqa.competency.reason.repeatedFailure": "{failures} kegagalan dari {evaluable} sampel yang dapat dinilai antara {from} dan {to}. Ini adalah masalah kinerja: tinjau hasil yang gagal dan ajukan ketidaksesuaian, atau abaikan saat triase.",
  "eqa.competency.reason.insufficientEvidence": "{evaluable} sampel yang dapat dinilai antara {from} dan {to}, kurang dari batas minimum bukti sebanyak {floor}. Ini bukan masalah kinerja: tugaskan lebih banyak sampel uji profisiensi kepada analis ini.",
  "eqa.competency.reason.openEscalation": "Ketidaksesuaian yang dieskalasi antara {from} dan {to} masih terbuka, dari {evaluable} sampel yang dapat dinilai dengan {failures} kegagalan. Tutup ketidaksesuaian tersebut untuk menghapus kategori ini.",
  "eqa.competency.whatIsAnAnalyst": "Analis adalah akun pengguna OpenELIS dalam daftar analis program, yang dicatat pada sampel yang dikerjakannya. Catatan ini terpisah dari pengguna yang memasukkan hasil dan pengguna yang memvalidasinya.",
  "eqa.inhouse.roster.help": "Analis adalah akun pengguna OpenELIS. Setiap orang yang dipilih di sini masuk ke daftar analis program ini dan dapat ditugaskan sampel untuk diperiksa; daftar ini terpisah dari siapa yang memasukkan dan siapa yang memvalidasi hasil.",
  "banner.menu.eqa.providerFollowups": "Tindak Lanjut Peserta",
  "eqa.oversight.queueSubtitle.link": "Tindak lanjut peserta",
  "eqa.inhouse.sealed.deadline": "Tanggal buka samaran, sekaligus tenggat penyerahan bagi analis: {date}",
  "eqa.inhouse.sealed.analysts": "Analis yang ditugaskan: {names}",
  "eqa.inhouse.sealed.noAnalysts": "Tidak ada analis yang ditugaskan ke sampel mana pun pada panel ini.",
  "eqa.inhouse.sealed.toMyCycles": "Buka Siklus Saya",
  "eqa.inhouse.sealed.toWorkplan": "Buka Rencana Kerja",
  "analyzerType.editor.heading": "Pengaturan profil",
  "analyzerType.editor.choose": "Pilih…",
  "analyzerType.editor.version": "Versi profil",
  "analyzerType.editor.confidence": "Tingkat keyakinan bukti",
  "analyzerType.editor.category": "Disiplin laboratorium",
  "analyzerType.editor.inboundResults": "Menerima hasil dari alat",
  "analyzerType.editor.outboundOrders": "Mengirim pemesanan ke alat",
  "analyzerType.editor.connectionTest": "Mendukung uji koneksi",
  "analyzerType.editor.fileHeading": "Penguraian file",
  "analyzerType.editor.fileFormat": "Format file profil",
  "analyzerType.editor.defaultFileFormat": "Format file default",
  "analyzerType.editor.filePattern": "Pola nama file",
  "analyzerType.editor.hasHeader": "Baris pertama berisi nama kolom",
  "analyzerType.editor.delimiter": "Pemisah kolom",
  "analyzerType.editor.encoding": "Pengodean teks",
  "analyzerType.editor.sheetIndex": "Nomor sheet (dimulai dari nol)",
  "analyzerType.editor.skipRows": "Baris yang dilewati",
  "analyzerType.editor.extensions": "Ekstensi file yang didukung",
  "analyzerType.editor.columns": "Kolom file",
  "analyzerType.editor.columnsHelp": "Cocokkan nama kolom dalam file ekspor dengan bidang hasil di bawah. Pertahankan ejaan dan tanda baca.",
  "analyzerType.editor.columnNumber": "Kolom file {number}",
  "analyzerType.editor.columnName": "Nama kolom dalam file",
  "analyzerType.editor.columnField": "Arti kolom",
  "analyzerType.editor.removeColumn": "Hapus kolom",
  "analyzerType.editor.columnsInvalid": "Setiap kolom memerlukan nama unik dan arti yang dipilih.",
  "analyzerType.editor.addColumn": "Tambah kolom",
  "analyzerType.editor.resultOrder": "Preferensi nilai hasil (nilai pertama yang tersedia digunakan)",
  "analyzerType.editor.communicationHeading": "Default komunikasi",
  "analyzerType.editor.analyzerName": "Nama alat dalam pesan",
  "analyzerType.editor.identifierPattern": "Pola pengenal alat",
  "analyzerType.editor.protocolVersion": "Versi protokol",
  "analyzerType.editor.lowerLayerVersion": "Versi framing ASTM",
  "analyzerType.editor.msh3Pattern": "Pola aplikasi pengirim",
  "analyzerType.editor.communicationMode": "Pihak yang memulai komunikasi",
  "analyzerType.editor.lisInitiated": "Mengizinkan sistem laboratorium memulai komunikasi",
  "analyzerType.editor.connectionRole": "Peran koneksi default",
  "analyzerType.editor.transport": "Transport default",
  "analyzerType.editor.port": "Portal keluar default (opsional)",
  "analyzerType.editor.aggregationMode": "Pengelompokan hasil",
  "analyzerType.editor.aggregationWindowSeconds": "Jendela pengelompokan hasil dalam detik",
  "analyzerType.editor.connectionFields": "Bidang yang ditampilkan saat mengatur koneksi",
  "analyzerType.editor.connectionFieldsHelp": "Bidang ini menjelaskan pengaturan yang diisi laboratorium untuk setiap koneksi. Koneksi FILE memerlukan bidang direktori untuk folder pantauannya di Bridge. Label menggunakan kunci terjemahan aplikasi. Pilihan mempertahankan tipe nilainya; kondisi visibilitas merujuk ke pengaturan lain.",
  "analyzerType.editor.connectionFieldNumber": "Bidang koneksi {number}",
  "analyzerType.editor.fieldKey": "Nama pengaturan",
  "analyzerType.editor.fieldLabel": "Kunci terjemahan label",
  "analyzerType.editor.inputKind": "Tipe input",
  "analyzerType.editor.required": "Wajib diisi saat pengaturan koneksi",
  "analyzerType.editor.addField": "Tambah bidang koneksi",
  "analyzerType.editor.removeField": "Hapus bidang koneksi",
  "analyzerType.editor.save": "Simpan dan validasi pengaturan profil",
  "analyzerType.editor.saved": "Pengaturan profil disimpan",
  "analyzerType.editor.saveBeforeRecognition": "Simpan pengaturan profil sebelum mengedit pengenalan kontrol atau menerbitkan.",
  "analyzerType.editor.loadError": "Tidak dapat memuat ulang draf. Perubahan Anda yang belum disimpan masih ada di sini.",
  "analyzerType.editor.saveError": "Tidak dapat menyimpan draf. Perubahan Anda masih ada di sini; coba simpan lagi.",
  "analyzerType.editor.conflict": "Draf telah berubah sejak dibuka. Perubahan Anda belum dikirim. Muat ulang draf tersimpan sebelum membuat perubahan lebih lanjut.",
  "analyzerType.editor.error": "Profil tidak dapat disimpan",
  "analyzerType.editor.reload": "Muat ulang draf tersimpan dan buang perubahan lokal",
  "analyzerType.editor.validation": "Profil perlu diperhatikan",
  "analyzerType.editor.add": "Tambah nilai",
  "analyzerType.editor.remove": "Hapus nilai",
  "analyzerType.editor.semantic.sampleId": "Pengidentifikasi sampel",
  "analyzerType.editor.semantic.testCode": "Kode pemeriksaan alat",
  "analyzerType.editor.semantic.qcTask": "Tugas kontrol",
  "analyzerType.editor.semantic.ctValue": "Ambang siklus (Ct)",
  "analyzerType.editor.inputKind.TEXT": "Teks",
  "analyzerType.editor.inputKind.NUMBER": "Angka",
  "analyzerType.editor.inputKind.SELECT": "Daftar pilihan",
  "analyzerType.editor.inputKind.BOOLEAN": "Ya atau tidak",
  "analyzerType.editor.inputKind.SECRET": "Rahasia",
  "analyzerType.editor.inputKind.FILE_PATH": "Jalur folder atau file",
  "analyzerType.editor.testDefinitions": "Definisi pemeriksaan alat",
  "analyzerType.editor.testDefinitionsHelp": "Daftarkan kode pemeriksaan dan nilai hasil yang dilaporkan oleh alat. Definisi ini memberikan saran untuk pencocokan dengan katalog laboratorium; definisi ini tidak membuat atau mengubah pemeriksaan laboratorium.",
  "analyzerType.editor.testNumber": "Pemeriksaan alat {number}",
  "analyzerType.editor.testCode": "Kode pemeriksaan alat",
  "analyzerType.editor.testName": "Nama pemeriksaan yang disarankan",
  "analyzerType.editor.loinc": "Kode LOINC",
  "analyzerType.editor.testUnit": "Satuan yang dilaporkan",
  "analyzerType.editor.resultType": "Tipe nilai yang dilaporkan",
  "analyzerType.editor.resultType.quantitative": "Pengukuran numerik",
  "analyzerType.editor.resultType.qualitative": "Hasil bernama",
  "analyzerType.editor.resultType.text": "Hasil teks bebas",
  "analyzerType.editor.testAliases": "Kode lain untuk pemeriksaan yang sama",
  "analyzerType.editor.testValues": "Nilai hasil yang dilaporkan oleh pemeriksaan ini",
  "analyzerType.editor.removeTest": "Hapus pemeriksaan alat",
  "analyzerType.editor.addTest": "Tambah pemeriksaan alat",
  "analyzerType.editor.choices": "Pilihan koneksi",
  "analyzerType.editor.choiceNumber": "Pilihan {number}",
  "analyzerType.editor.choiceValue": "Nilai pilihan",
  "analyzerType.editor.addChoice": "Tambah pilihan",
  "analyzerType.editor.removeChoice": "Hapus pilihan",
  "analyzerType.editor.visibility": "Tampilkan kolom koneksi ini jika",
  "analyzerType.editor.controllingField": "Pengaturan pengendali",
  "analyzerType.editor.comparison": "Perbandingan",
  "analyzerType.editor.comparisonValue": "Nilai pembanding",
  "analyzerType.editor.comparison.EQUALS": "Sama dengan",
  "analyzerType.editor.comparison.NOT_EQUALS": "Tidak sama dengan",
  "analyzerType.editor.comparison.IN": "Salah satu dari",
  "analyzerType.editor.comparison.NOT_IN": "Bukan salah satu dari",
  "analyzerType.editor.addCondition": "Tambah kondisi visibilitas",
  "analyzerType.editor.removeCondition": "Hapus kondisi visibilitas",
  "analyzerType.editor.valueType": "Jenis nilai",
  "analyzerType.editor.valueType.string": "Nilai teks",
  "analyzerType.editor.valueType.boolean": "Nilai boolean",
  "analyzerType.editor.valueType.array": "Nilai daftar",
  "analyzerType.editor.valueType.object": "Nilai objek",
  "analyzerType.editor.valueType.null": "Nilai kosong (null)",
  "analyzerType.editor.nullValue": "Pilihan ini memiliki nilai null.",
  "analyzerType.editor.invalidTypedValue": "Masukkan nilai yang valid sesuai tipe yang dipilih.",
  "analyzerType.editor.structuredValueHelp": "Masukkan daftar atau objek JSON yang sesuai dengan jenis yang dipilih. Gunakan daftar untuk perbandingan “salah satu dari”.",
  "analyzerType.editor.newProtocolHelp": "Pilih FILE, ASTM, atau HL7 dan masukkan pengaturan yang didukung alat. Protokol tidak dapat diubah setelah penyimpanan pertama.",
  "analyzerType.editor.switchProtocol": "Ganti protokol dan hapus pengaturannya",
  "analyzerType.editor.switchProtocolHelp": "Ganti ke {protocol}? Tindakan ini menghapus pengaturan komunikasi, parsing, kolom koneksi, dan pengenalan kontrol yang belum disimpan. Identitas profil, definisi pemeriksaan, dan informasi deskriptif tetap dipertahankan.",
  "analyzerType.editor.keepProtocol": "Pertahankan protokol saat ini",
  "analyzerType.editor.supportedTransports": "Transport yang didukung",
  "analyzerType.editor.supportTransport": "Dukung {transport}",
  "analyzerType.editor.transportSettings": "Pengaturan {transport}",
  "analyzerType.editor.transportPortHelp": "Port tujuan keluar opsional untuk transport ini. Biarkan kosong untuk menggunakan cadangan Bridge; pesan masuk menggunakan listener bersama.",
  "analyzerType.editor.serialSettings": "Pengaturan komunikasi serial",
  "analyzerType.editor.readTimeout": "Batas waktu baca serial (milidetik)",
  "analyzerType.editor.messageTimeout": "Batas waktu pesan serial (milidetik)",
  "analyzerType.editor.reconnectInterval": "Interval sambung ulang serial (milidetik)",
  "analyzerType.editor.maxReconnectAttempts": "Jumlah maksimum percobaan sambung ulang serial",
  "analyzerType.editor.rtsEnabled": "Aktifkan RTS",
  "analyzerType.editor.dtrEnabled": "Aktifkan DTR",
  "analyzerType.editor.resultRecords": "Rekaman hasil yang diurai",
  "analyzerType.editor.resultRecords.ALL": "Semua rekaman hasil",
  "analyzerType.editor.resultRecords.FIELD_NON_BLANK": "Rekaman dengan bidang yang terisi",
  "analyzerType.editor.resultRecordField": "Bidang ASTM wajib (record.field.component)",
  "analyzerType.editor.specimenPosition": "Posisi sampel HL7 relatif terhadap hasil",
  "analyzerType.editor.dataFlow": "Arah transfer data default",
  "analyzerType.editor.outboundPortMode": "Pemilihan portal keluar default",
  "analyzerType.editor.clientProfilePort": "Portal koneksi klien yang disimpan dalam profil ini (opsional)",
  "eqa.intake.sample": "Sampel {code}",
  "eqa.competency.countsFoldedTriage": "Diputuskan melalui triase",
  "eqa.competency.countsFoldedScore": "Dihitung bersama skor",
  "eqa.provider.followups.responseText": "Apa yang disampaikan laboratorium",
  "eqa.provider.followups.responseHelp": "Akar masalah yang ditemukan laboratorium dan tindakan perbaikan yang diambil. Disimpan bersama tindak lanjut.",
  "eqa.provider.followups.responseShown": "Tanggapan laboratorium: {text}",
  "notification.organization.post.error": "Organisasi tidak disimpan. Periksa kolom dan coba lagi.",
  "organization.email": "Email Kontak",
  "eqa.provider.followups.sendFailed": "Tidak dapat mengirim email ke {to}. Notifikasi telah diunduh sebagai CSV untuk dikirim secara manual.",
  "label.validation.review.error.qcHold": "Rilis diblokir: kontrol QC yang gagal menahan hasil ini sampai ketidaksesuaiannya ditutup.",
  "sidenav.label.admin.locations": "Lokasi & Organisasi",
  "sidenav.label.admin.locations.organizations": "Organisasi",
  "sidenav.label.admin.locations.sites": "Tempat Pengambilan Sampel",
  "sidenav.label.admin.locations.areas": "Wilayah Geografis",
  "sidenav.label.admin.locations.import": "Impor / Ekspor",
  "help.locations.page.organizations": "Organisasi adalah fasilitas kesehatan dan laboratorium yang bekerja sama dengan lab Anda: rumah sakit, klinik, dan puskesmas yang mengirimkan sampel pasien kepada Anda, serta laboratorium tujuan rujukan sampel. Ruang dan departemen di dalam organisasi tercantum di bawahnya. Organisasi muncul pada entri pemesanan sebagai tempat pemohon dan pada rujukan sebagai lab tujuan.",
  "help.locations.page.sites": "Tempat pengambilan sampel adalah lokasi tetap di lingkungan tempat sampel yang tidak berasal dari pasien diambil: sumber air, perangkap nyamuk, monitor udara, petak tanah. Tempat pengambilan sampel tidak memesan pemeriksaan. Tempat ini mencatat lokasi pengambilan sampel, sehingga hasil dapat dibandingkan dari waktu ke waktu pada titik yang sama. Setiap tempat berada di suatu wilayah geografis dan dapat memiliki titik GPS serta narahubung sendiri.",
  "help.locations.page.areas": "Wilayah geografis adalah pembagian administratif negara, misalnya Daerah, Provinsi, Kabupaten, dan LLG. Wilayah ini digunakan untuk alamat pasien dan untuk menunjukkan lokasi setiap organisasi dan tempat pengambilan sampel. Sebagian besar penerapan memuatnya sekali dari daftar nasional, lalu menambahkan atau memperbaiki wilayah di sini. Untuk menambahkan wilayah di dalam wilayah lain, gunakan tombol + pada baris induk: \"+ District\" pada Morobe Province menambahkan kabupaten di Morobe. Gunakan \"+ Add Region\" di bagian atas untuk wilayah tingkat teratas yang baru.",
  "help.locations.page.import": "Muat atau perbarui organisasi, ruang / departemen, tempat pengambilan sampel, dan wilayah geografis dari file CSV, dengan format yang sama yang digunakan sistem saat instalasi. Tidak ada yang disimpan sampai Anda meninjau pratinjau dan menerapkannya.",
  "label.locations.page.compare": "Organisasi atau tempat pengambilan sampel: mana yang saya perlukan?",
  "label.locations.page.compare.orgTitle": "Tambahkan organisasi jika...",
  "label.locations.page.compare.siteTitle": "Tambahkan tempat pengambilan sampel jika...",
  "label.locations.page.compare.orgExamples": "Contoh: Port Moresby General Hospital, 9 Mile Urban Clinic, Central Public Health Laboratory",
  "label.locations.page.compare.siteExamples": "Contoh: Bumbu Settlement light trap, Laloki River intake, Waigani air monitor",
  "help.locations.page.compare.org": "Tambahkan organisasi jika sampel berasal dari orang yang diperiksa di sana, jika organisasi tersebut memesan pemeriksaan atau menerima laporan atau sampel rujukan, atau jika organisasi tersebut memiliki ruang atau departemen yang meminta pemeriksaan.",
  "help.locations.page.compare.site": "Tambahkan tempat pengambilan sampel jika sampel berasal dari lingkungan (air, tanah, udara, atau serangga), jika Anda mengambil sampel di titik tetap yang sama berulang kali, atau jika Anda menginginkan hasil untuk titik tersebut dari waktu ke waktu, pada peta.",
  "help.locations.page.compare.tip": "Tangki air di rumah sakit tetap merupakan tempat pengambilan sampel: rumah sakit adalah organisasi, dan tangki adalah tempat yang berada di wilayah yang sama.",
  "label.locations.kind.facility": "Lembaga",
  "label.locations.kind.ward": "Ruang / Departemen",
  "label.locations.kind.wards": "ruang / departemen",
  "label.locations.kind.site": "Tempat Pengambilan Sampel",
  "label.locations.kind.area": "Area geografis",
  "label.locations.kind.records": "rekaman",
  "label.locations.column.name": "Nama",
  "label.locations.column.code": "Kode",
  "label.locations.column.type": "Jenis",
  "label.locations.column.wards": "Ruang / Departemen",
  "label.locations.column.location": "Lokasi",
  "label.locations.column.inUse": "Sedang Digunakan",
  "label.locations.column.level": "Level",
  "label.locations.column.children": "Area turunan",
  "label.locations.column.siteType": "Jenis tempat",
  "label.locations.column.active": "Aktif",
  "label.locations.column.actions": "Aksi",
  "label.locations.column.serviceType": "Jenis layanan",
  "label.locations.column.contact": "Nama kontak",
  "label.locations.column.phone": "Telepon",
  "label.locations.column.email": "Email",
  "label.locations.column.gps": "GPS",
  "label.locations.open": "terbuka",
  "label.locations.openOrders": "pemesanan terbuka",
  "label.locations.none": "Tidak ada",
  "label.locations.empty": "(kosong)",
  "label.locations.location.notSet": "belum diatur",
  "label.locations.status.active": "Aktif",
  "label.locations.status.inactive": "Inaktif",
  "label.locations.status.all": "Semua",
  "label.locations.source.registry": "Registri",
  "help.locations.registry": "Berasal dari registri lembaga. Registri adalah sumber kebenaran untuk data ini.",
  "label.locations.filter.type": "Jenis",
  "label.locations.filter.type.all": "Semua Jenis",
  "label.locations.filter.location": "Lokasi (termasuk area di bawahnya)",
  "label.locations.filter.location.any": "Area mana pun",
  "label.locations.filter.status": "Status",
  "label.locations.filter.clear": "Hapus filter",
  "label.locations.filter.reviewOverdue": "Hanya lab rujukan yang lewat tenggat tinjauan atau akreditasinya kedaluwarsa",
  "label.locations.filter.category.all": "Semua kategori",
  "label.locations.filter.ownership.all": "Semua kepemilikan",
  "label.locations.toolbar": "Filter",
  "placeholder.locations.search": "Cari berdasarkan nama, kode, atau pengenal apa pun",
  "placeholder.locations.area.search": "Cari area berdasarkan nama atau kode",
  "help.locations.status.inactive": "Data inaktif disembunyikan dari entri pemesanan dan daftar pilihan lainnya. Data tersebut tetap muncul pada pemesanan dan laporan yang sudah ada.",
  "help.locations.field.location": "Pilih wilayah paling spesifik yang Anda ketahui. Kabupaten sudah cukup jika Anda tidak mengetahui LLG.",
  "help.locations.field.gps": "Derajat desimal, WGS84",
  "help.locations.field.siteDescription": "Sertakan petunjuk arah agar orang lain dapat menemukan lokasi yang tepat",
  "help.locations.identifiers": "Ketik label apa pun, atau pilih label yang sudah digunakan. Kode pelaporan ditampilkan sebagai Kode dalam daftar, ekspor, dan laporan. Setiap pengidentifikasi dapat dicari dan digunakan untuk mencocokkan baris impor.",
  "help.locations.ward": "Ruang, departemen, atau klinik di dalam organisasi ini",
  "help.locations.ward.gps": "Kosongkan GPS untuk menggunakan lokasi {parent}. Alamat selalu milik {parent}.",
  "label.locations.ward.inheritedGps": "{lat}, {lng} diwarisi dari {parent}",
  "label.locations.inherited": "diwarisi",
  "label.locations.inherits": "mewarisi",
  "label.locations.draft": "Draf",
  "label.locations.ward.namePlaceholder": "Nama ruang / departemen",
  "label.locations.optional": "Opsional",
  "warning.locations.registry.edit": "Rekam data ini berasal dari registri lembaga. Perubahan pada bidang yang disediakan registri akan ditimpa pada sinkronisasi berikutnya. Untuk mengubahnya secara permanen, perbarui registri. Ruang / departemen dan rincian lokal lain yang Anda tambahkan di sini tetap disimpan.",
  "warning.locations.registry.deactivate": "Rekam data ini berasal dari registri lembaga. Sinkronisasi berikutnya dapat mengaktifkannya kembali; untuk menutupnya secara permanen, perbarui registri.",
  "label.locations.registry.field": "Dari registri",
  "button.locations.add": "Tambah",
  "button.locations.import": "Impor",
  "button.locations.export": "Ekspor",
  "button.locations.deactivate": "Nonaktifkan",
  "button.locations.reactivate": "Aktifkan Ulang",
  "button.locations.exportSelected": "Ekspor yang dipilih",
  "button.locations.addWard": "Tambah ruang / departemen",
  "button.locations.saveWards": "Simpan {count} ruang / departemen baru",
  "button.locations.moveWard": "Pindahkan",
  "button.locations.history": "Riwayat",
  "button.locations.history.hide": "Sembunyikan riwayat",
  "button.locations.identifier.add": "Tambah pengidentifikasi",
  "button.locations.area.addChildLevel": "+ {level}",
  "button.locations.area.addTop": "Tambah {level}",
  "button.locations.area.expandAll": "Perluas semua",
  "button.locations.area.collapseAll": "Ciutkan semua",
  "button.locations.undo": "Batal",
  "button.locations.template": "Unduh templat",
  "button.locations.import.preview": "Pratinjau",
  "button.locations.import.apply": "Terapkan",
  "button.locations.import.report": "Unduh laporan hasil",
  "label.locations.selectAll": "Pilih semua baris",
  "label.locations.select": "Pilih",
  "label.locations.section.identity": "Identitas",
  "label.locations.section.identifiers": "Pengidentifikasi",
  "label.locations.section.location": "Lokasi",
  "label.locations.section.contact": "Kontak",
  "label.locations.section.referral": "Laboratorium rujukan",
  "label.locations.section.site": "Detail tempat",
  "label.locations.section.wards": "Ruang / Departemen",
  "label.locations.form.jump": "Lompat ke",
  "label.locations.field.types": "Jenis organisasi",
  "label.locations.field.shortName": "Nama singkat",
  "label.locations.field.category": "Kategori",
  "label.locations.field.ownership": "Kepemilikan",
  "label.locations.field.description": "Deskripsi",
  "label.locations.field.location": "Lokasi",
  "label.locations.field.parentArea": "Area induk",
  "label.locations.field.streetAddress": "Nama jalan",
  "label.locations.field.city": "Kota",
  "label.locations.field.state": "Provinsi",
  "label.locations.field.zipCode": "Kode pos",
  "label.locations.field.gpsLatitude": "Garis lintang GPS",
  "label.locations.field.gpsLongitude": "Garis bujur GPS",
  "label.locations.field.contactName": "Nama kontak",
  "label.locations.field.phone": "Telepon",
  "label.locations.field.email": "Email",
  "label.locations.field.website": "Website",
  "label.locations.field.serviceType": "Jenis layanan",
  "label.locations.field.siteType": "Jenis tempat",
  "label.locations.field.subtype": "Subtipe",
  "label.locations.field.zone": "Zona lingkungan",
  "label.locations.identifier.label": "Label",
  "label.locations.identifier.value": "Nilai",
  "label.locations.identifier.reporting": "Kode pelaporan",
  "label.locations.identifier.labelPlaceholder": "mis. ID DHIS2",
  "label.locations.referral.approval": "Status persetujuan",
  "label.locations.referral.approved": "Disetujui",
  "label.locations.referral.evaluation": "Dalam evaluasi",
  "label.locations.referral.suspended": "Ditangguhkan",
  "label.locations.referral.notApproved": "Tidak disetujui",
  "label.locations.referral.accreditationBody": "Badan akreditasi",
  "label.locations.referral.accreditationNumber": "Nomor akreditasi",
  "label.locations.referral.accreditationExpiry": "Masa berlaku akreditasi",
  "label.locations.referral.lastReview": "Tanggal tinjauan terakhir",
  "label.locations.referral.nextReview": "Jatuh tempo tinjauan berikutnya",
  "label.locations.referral.notes": "Catatan tinjauan",
  "label.locations.referral.overdue": "Tinjauan terlambat",
  "label.locations.referral.expired": "Akreditasi kedaluwarsa",
  "message.locations.referral.overdueSince": "Tinjauan lewat tenggat sejak {date}. Catat tinjauan di bawah, atau ubah status persetujuan.",
  "label.locations.history.title": "Riwayat {name}",
  "label.locations.history.filter": "Filter berdasarkan tindakan",
  "label.locations.history.allChanges": "Semua perubahan",
  "help.locations.history.readOnly": "Hanya baca. Disimpan selama data masih ada.",
  "label.locations.history.formerly": "Sebelumnya {name}",
  "label.locations.history.action.created": "Dibuat",
  "label.locations.history.action.edited": "Diedit",
  "label.locations.history.action.deactivated": "Sudah inaktif",
  "label.locations.history.action.reactivated": "Diaktifkan ulang",
  "label.locations.history.action.moved": "Dipindahkan",
  "label.locations.history.action.identifiers": "Pengidentifikasi diubah",
  "label.locations.history.action.referralReview": "Tinjauan rujukan",
  "label.locations.history.action.imported": "Diimpor",
  "label.locations.history.action.registrySync": "Diperbarui dari registri",
  "label.locations.search.ward": "Ruang / departemen: {name}",
  "error.locations.name.required": "Wajb ada nama ",
  "error.locations.types.required": "Pilih minimal satu jenis organisasi",
  "error.locations.gps.range": "Masukkan derajat desimal: lintang -90 hingga 90, bujur -180 hingga 180",
  "error.locations.parent.kind": "Induk dari ruang harus berupa lembaga",
  "error.locations.parent.required": "Pilih wilayah induk",
  "error.locations.referral.status": "Pilih status persetujuan",
  "error.locations.identifier.duplicate": "{label} {value} sudah digunakan oleh {name}",
  "error.locations.reactivate.parentInactive": "Aktifkan ulang {parent} terlebih dahulu.",
  "error.locations.save.conflict": "Admin lain telah menyimpan data ini terlebih dahulu. Nilai mereka ditampilkan di bawah; terapkan kembali perubahan Anda dan simpan lagi.",
  "error.locations.save.failed": "Data tidak disimpan.",
  "error.locations.request.failed": "Permintaan tidak dapat diselesaikan, sehingga tidak ada yang disimpan. Coba lagi, dan jika terus gagal, beri tahu administrator Anda.",
  "error.locations.save.check": "Belum disimpan. Periksa: {fields}.",
  "error.locations.save.failedBecause": "Data tidak disimpan: {reason}",
  "error.locations.save.conflictKept": "Admin lain telah menyimpan data ini terlebih dahulu. Perubahan Anda tetap dipertahankan, dan perubahan mereka diisikan pada bagian yang tidak Anda ketik ({fields}). Periksa formulir dan simpan lagi.",
  "warning.locations.wards.unsaved": "{count, plural, other {# ruang / departemen}} typed but not saved yet. Save them with Save wards, or remove them, then save the record.",
  "error.locations.ward.notSaved": "{name} tidak disimpan: {reason}",
  "message.locations.wards.saved": "{count, plural, other {# ruang / departemen disimpan.}}",
  "warning.locations.import.ignoredColumns": "Kolom berikut tidak diimpor dan diabaikan: {columns}",
  "label.locations.import.run.applied": "Diterapkan",
  "label.locations.import.run.preview": "Pratinjau",
  "warning.locations.identifiers.shared": "Beberapa pengidentifikasi digunakan oleh lebih dari satu rekam data. Berikan nilai tersendiri untuk setiap rekam data.",
  "error.locations.load.failed": "Daftar tidak dapat dimuat. Coba lagi.",
  "warning.locations.name.duplicate": "{kind} aktif lain bernama \"{name}\" sudah ada",
  "message.locations.empty.none": "Belum ada data. Tambahkan satu, atau impor file.",
  "message.locations.empty.filtered": "Tidak ada data yang cocok dengan filter ini.",
  "message.locations.search.elsewhere": "Di {view}: {count, plural, one {# kecocokan} other {# kecocokan}}",
  "message.locations.saved": "{name} disimpan.",
  "message.locations.added": "{name} ditambahkan.",
  "message.locations.deactivated": "{name} dinonaktifkan.",
  "message.locations.reactivated": "{name} diaktifkan ulang.",
  "message.locations.undo.deactivated": "{name} dinonaktifkan.",
  "message.locations.deactivate.inUse": "{name} memiliki {open} pemesanan terbuka dan {children} {childKind} aktif.",
  "message.locations.deactivate.confirm": "Nonaktifkan {name}?",
  "button.locations.deactivate.record": "Nonaktifkan {name}",
  "button.locations.deactivate.only": "Nonaktifkan {name} saja",
  "button.locations.deactivate.withChildren": "Nonaktifkan {name} beserta {count} {childKind} di bawahnya",
  "message.locations.area.inUse": "{name} masih memiliki area, organisasi, atau tempat aktif di dalamnya. Nonaktifkan atau pindahkan terlebih dahulu.",
  "message.locations.area.searchContext": "{count, plural, other {# kecocokan}}, shown with the areas they sit in",
  "message.locations.area.loadOnExpand": "Turunan dimuat saat baris dibuka.",
  "label.locations.area.new": "Baru",
  "label.locations.area.topLevel": "tingkat teratas",
  "message.locations.unsaved": "Ada perubahan yang belum disimpan. Keluar tanpa menyimpan?",
  "label.locations.import.mode": "Mode impor",
  "label.locations.import.mode.merge": "Tambah & perbarui",
  "help.locations.import.mode.merge": "Tambahkan data baru dan perbarui data yang cocok. Tidak ada yang lain yang berubah.",
  "label.locations.import.mode.replace": "Ganti",
  "help.locations.import.mode.replace": "Juga nonaktifkan data dengan jenis yang ada dalam file ini tetapi tidak disertakan dalam file. Tidak ada yang dihapus.",
  "label.locations.import.files": "File",
  "label.locations.import.drop": "Seret file CSV ke sini atau klik untuk menelusuri (organizations-*.csv, *-levels.csv, *-values.csv)",
  "label.locations.import.area": "Area",
  "label.locations.import.area.organizations": "Lembaga, ruang & tempat",
  "label.locations.import.area.levels": "Tingkat geografis",
  "label.locations.import.area.values": "Area geografis",
  "label.locations.import.forThisFile": "Untuk file ini:",
  "label.locations.import.replaceScope": "File ini memiliki baris {types}. {untouched} tidak akan berubah. Ruang / departemen hanya akan diganti di {parents}. Rekaman registri tidak pernah dinonaktifkan.",
  "label.locations.import.rename.title": "Kemungkinan Ganti Nama",
  "label.locations.import.rename.same": "Tempat sama, berganti nama",
  "label.locations.import.rename.different": "Tempat berbeda",
  "warning.locations.import.registryOverwrite": "Akan ditimpa pada sinkronisasi registri berikutnya",
  "warning.locations.import.wardAddressIgnored": "Baris {line}: alamat diabaikan untuk ruang / departemen, yang menggunakan alamat organisasinya",
  "label.locations.import.outcome.new": "Baru",
  "label.locations.import.outcome.updated": "Terbarui",
  "label.locations.import.outcome.unchanged": "Tidak berubah",
  "label.locations.import.outcome.reactivated": "Diaktifkan ulang",
  "label.locations.import.outcome.deactivated": "Sudah inaktif",
  "label.locations.import.outcome.decision": "Perlu keputusan",
  "label.locations.import.outcome.rename": "Kemungkinan ganti nama",
  "label.locations.import.outcome.rejected": "Ditolak",
  "label.locations.import.decision.use": "Gunakan rekaman ini",
  "label.locations.import.decision.new": "Buat baru",
  "label.locations.import.decision.skip": "Lewati baris",
  "label.locations.import.decision.remember": "Ingat nama ini",
  "label.locations.import.willDeactivate": "Akan dinonaktifkan",
  "label.locations.import.rows": "Baris",
  "label.locations.import.column.line": "Baris",
  "label.locations.import.column.outcome": "Hasil",
  "label.locations.import.column.type": "Jenis",
  "label.locations.import.column.code": "Kode",
  "label.locations.import.column.name": "Nama",
  "label.locations.import.column.detail": "Detail",
  "message.locations.import.nothingSaved": "Tidak ada yang disimpan.",
  "label.locations.import.confirm.title": "Terapkan impor ini?",
  "label.locations.import.confirm.replace": "Saya memahami {count} rekaman akan dinonaktifkan",
  "label.locations.import.complete": "Impor selesai",
  "label.locations.import.recent": "Impor terkini",
  "message.locations.export.done": "{count} data diekspor dalam format impor.",
  "label.locations.import.working": "Membaca file dan mencocokkan setiap baris. File besar memerlukan waktu sebentar.",
  "message.locations.import.failed": "Impor tidak dapat dibaca: {reason}",
  "eqa.wizard.noSchemeTests": "Program ini tidak memiliki pemeriksaan yang dapat digunakan oleh panel.",
  "eqa.performance.titleForScheme": "Kinerja peserta: {scheme}",
  "eqa.cycle.trigger.first_shipment_sent": "Kiriman pertama dikirim",
  "eqa.cycle.trigger.all_shipments_delivered": "Semua kiriman telah diterima",
  "eqa.cycle.trigger.score_intake": "Nilai dicatat",
  "eqa.cycle.trigger.panel_receipt": "Panel diterima",
  "eqa.cycle.trigger.last_validated_result": "Hasil terakhir divalidasi",
  "eqa.cycle.trigger.fhir_submit_success": "Hasil dikirim ke penyelenggara",
  "eqa.cycle.trigger.panel_unblind": "Samaran panel dibuka",
  "eqa.cycle.trigger.v1_backfill": "Dibawa dari distribusi sebelumnya",
  "sampleAcceptance.banner.resampledFrom.accession": "Ini adalah sampel pengganti yang dibuat dari pengambilan ulang sampel {accession}.",
  "label.results.sampleStatus.markUsedUpConfirm.title": "Tandai sampel ini habis terpakai?",
  "label.results.sampleStatus.markUsedUpConfirm.body": "Volume sisanya diatur ke nol. Sampel tetap berada di penyimpanan sampai dimusnahkan.",
  "alerts.acknowledge.note": "Komentar Mengetahui",
  "alerts.acknowledge.note.required": "Komentar wajib diisi untuk mengetahui peringatan kritis",
  "alerts.resolve.button": "Selesaikan",
  "alerts.resolve.title": "Selesaikan Peringatan",
  "alerts.resolve.comment.required": "Komentar penyelesaian wajib diisi",
  "alerts.resolve.error": "Gagal menyelesaikan peringatan",
  "configuration.panel.manage": "Kelola Panel",
  "sidenav.label.admin.testmgt.ViewtestCatalog": "Lihat Katalog Pemeriksaan",
  "compliance.parameterGroup.deleted": "Grup parameter dihapus.",
  "compliance.parameterGroup.updated": "Grup parameter diperbarui.",
  "compliance.parameterGroup.deleteError": "Tidak dapat menghapus grup parameter.",
  "compliance.validation.fillRequired": "Harap isi semua kolom wajib.",
  "compliance.parameterGroup.moveError": "Tidak dapat mengubah urutan grup parameter.",
  "compliance.parameterGroup.moved": "Urutan grup parameter diubah.",
  "compliance.parameterGroup.created": "Grup parameter ditambahkan.",
  "compliance.testEditor.thresholdsDone": "Ambang batas kepatuhan diperbarui untuk pemeriksaan ini.",
  "compliance.testEditor.meta.loinc": "LOINC:",
  "compliance.testEditor.meta.resultType.select": "Daftar Pilihan",
  "compliance.testEditor.meta.resultType": "Jenis Hasil:",
  "compliance.testEditor.editHeader": "Edit Pengujian:",
  "compliance.testEditor.meta.sampleType": "Jenis Sampel:",
  "compliance.testThresholds.comboboxPlaceholder": "Cari berdasarkan nama, kode, atau LOINC…",
  "label.button.done": "Selesai",
  "compliance.testEditor.meta.resultType.numeric": "Numerik",
  "compliance.multiLimit.advisoryNote.placeholder": "mis., Memerlukan pengambilan sampel ulang dalam 24 jam",
  "compliance.multiLimit.advisoryNote": "Catatan Peringatan",
  "compliance.inlineEdit.editingMapping": "mengedit pemetaan kepatuhan",
  "label.loading.message": "Sedang dimuat…",
  "compliance.linkedTest.unlinked": "Pemeriksaan dihapus dari grup parameter.",
  "compliance.linkedTest.unlinkError": "Tidak dapat menghapus pemeriksaan ini dari grup.",
  "compliance.threshold.testLinked": "Pemeriksaan ditautkan ke grup parameter.",
  "compliance.inlineEdit.editingLimits": "mengedit semua batas",
  "search.possibleMatches.title": "Kemungkinan Kecocokan",
  "search.possibleMatches.intro": "Rekam data ini mirip dengan yang sedang Anda buat. Gunakan salah satunya, atau buat rekam data baru.",
  "search.possibleMatches.use": "Gunakan yang ini",
  "search.possibleMatches.createAnyway": "Tetap buat baru",
  "search.possibleMatches.confirm": "Buat rekam data baru meskipun ada {count} rekam data yang mirip?",
  "search.possibleMatches.confirm.button": "Buat rekam data baru",
  "search.possibleMatches.back": "Kembali",
  "search.possibleMatches.matched": "Cocok pada: {fields}",
  "search.possibleMatches.field.name": "nama",
  "search.possibleMatches.field.dateOfBirth": "tanggal lahir",
  "search.possibleMatches.field.identifier": "pengidentifikasi",
  "search.possibleMatches.field.code": "kode",
  "search.possibleMatches.inactive": "Inaktif",
  "search.possibleMatches.failed": "Rekam data yang mirip tidak dapat diperiksa. Anda tetap dapat membuat rekam data baru.",
  "search.possibleMatches.recordFailed": "Pilihan Anda tidak dapat dicatat, sehingga tidak ada yang dibuat. Coba lagi.",
  "order.entry.patient.create": "Buat pasien",
  "order.entry.patient.willBeCreated": "Pasien baru dibuat saat pemesanan disimpan.",
  "provider.title.none": "Tanpa gelar",
  "order.billing.reference": "Referensi pembayaran",
  "sample.handling.title": "Penanganan",
  "sample.handling.noRequirement": "Tidak ada persyaratan",
  "sample.handling.processWithin": "proses dalam {time}",
  "sample.handling.holding.minutes": "{minutes} mnt",
  "sample.handling.holding.hours": "{hours} jam",
  "sample.handling.holding.hoursMinutes": "{hours} jam {minutes} mnt",
  "sample.handling.requiredLabel": "Diperlukan:",
  "sample.handling.storedAtLabel": "Disimpan di:",
  "sample.handling.arrivedAs": "Tiba dalam kondisi",
  "sample.handling.measuredTemp": "Suhu terukur (°C)",
  "sample.handling.measuredTemp.invalid": "Masukkan suhu dari -100 hingga 60 °C.",
  "sample.handling.sameForAll": "Sama untuk semua sampel",
  "sample.handling.notStored": "Belum disimpan",
  "sample.handling.storedAt.temperature": "{location} ({degrees} °C)",
  "sample.handling.mismatch": "Penanganan tidak sesuai",
  "sample.handling.mismatch.detail": "Memerlukan {required}; {actual}",
  "sample.handling.actual.arrived": "tiba dalam kondisi {condition}",
  "sample.handling.actual.measured": "terukur {degrees} °C saat tiba",
  "sample.handling.actual.stored": "disimpan pada {degrees} °C",
  "sample.handling.reportNonConformity": "Laporkan ketidaksesuaian",
  "sample.condition.roomTemp": "Suhu ruangan",
  "sample.condition.refrigerated": "Didinginkan 2 hingga 8 °C",
  "sample.condition.frozen": "Beku",
  "sample.condition.onIce": "Dalam es",
  "sample.condition.dryIce": "Es kering",
  "common.notRecorded": "Tidak terekam",
  "sample.legacy.recordedBefore": "Dicatat sebelum versi ini",
  "order.continue.item.arrivalTemperature": "Suhu terukur {sample} berada di luar -100 hingga 60 °C",
  "order.entry.receivedBy.you": "Diterima oleh {name} (Anda)",
  "order.entry.receivedBy.other": "Diterima oleh {name}",
  "order.entry.receivedBy.search": "Diterima oleh",
  "common.change": "Perubahan",
  "common.moreActions": "Tindakan lainnya",
  "order.tests.action.markTestedElsewhere": "Tandai diperiksa di tempat lain",
  "order.tests.action.unmarkTestedElsewhere": "Tidak diperiksa di tempat lain",
  "order.tests.tag.testedElsewhere": "Diperiksa di tempat lain",
  "order.tests.testedElsewhere.help": "Hasil dilaporkan oleh laboratorium lain",
  "order.tests.testedElsewhereAt": "Diperiksa di tempat lain: {lab}",
  "order.tests.testedElsewhere.value": "Nilai yang dilaporkan",
  "order.tests.testedElsewhere.lab": "Laboratorium pelaksana",
  "order.tests.testedElsewhere.saveFailed": "Diperiksa di tempat lain tidak tersimpan: {reason}",
  "inventory.board.title": "Barang",
  "inventory.board.purpose": "Apa yang Anda miliki dan apa yang perlu dipesan ulang. Bentangkan baris untuk melihat lot dan lokasinya.",
  "inventory.board.column.item": "Barang",
  "inventory.board.column.onHand": "Stok tersedia",
  "inventory.board.column.runsOut": "Habis pada",
  "inventory.board.byLocation": "Berdasarkan lokasi:",
  "inventory.board.empty": "Belum ada barang inventaris. Tambahkan barang untuk mulai melacaknya, lalu terima stok.",
  "inventory.board.noMatches": "Tidak ada barang yang cocok dengan pencarian dan filter Anda. Hapus pencarian dan filter untuk melihat seluruh katalog.",
  "inventory.board.error": "Papan barang tidak dapat dimuat.",
  "inventory.filter.location": "Filter berdasarkan Lokasi",
  "inventory.projection.window": "{early} – {late}",
  "inventory.projection.windowOpen": "{early} atau setelahnya",
  "inventory.projection.basis": "berdasarkan penggunaan hingga {date}",
  "inventory.projection.stale": "Pantau: data penggunaan mungkin sudah usang",
  "inventory.projection.insufficient": "Terlalu sedikit hari penggunaan untuk memproyeksikan tanggal habisnya stok",
  "inventory.projection.outOfStock": "Stok habis",
  "inventory.projection.trend": "Tren penggunaan",
  "inventory.projection.trend.steady": "stabil",
  "inventory.projection.trend.change": "{percent}% / {days} hr",
  "inventory.projection.medianDailyUse": "Median penggunaan harian: {rate} {units}/hari ({days} hari terakhir; median meredam lonjakan sesaat)",
  "inventory.orderBy.label": "Pesan sebelum",
  "inventory.orderBy.pastDue": "lewat tenggat",
  "inventory.orderBy.leadSet": "{days} hr (diatur)",
  "inventory.orderBy.leadObserved": "~{days} hr (teramati)",
  "inventory.orderBy.leadDefault": "{days} hr (default, atur untuk meningkatkan akurasi)",
  "inventory.reorderStatus.now": "Pesan ulang sekarang",
  "inventory.reorderStatus.soon": "Pesan ulang segera",
  "inventory.reorderStatus.adequate": "Cukup",
  "inventory.reorderStatus.buildingData": "Mengumpulkan data",
  "inventory.lots.useFirst": "Gunakan dahulu",
  "inventory.lots.disposeFailedQc": "QC gagal: musnahkan",
  "inventory.lots.flag": "Penanda",
  "inventory.lots.none": "Belum ada lot yang tercatat untuk barang ini. Terima stok untuk mulai melacaknya.",
  "inventory.actions.forItem": "Aksi untuk {item}",
  "inventory.actions.forLot": "Tindakan untuk lot {lot}",
  "inventory.actions.editItem": "Edit rincian barang",
  "inventory.actions.editLot": "Edit lot dan lokasi",
  "inventory.lots.expiringInDays": "Kedaluwarsa dalam {days} hr",
  "inventory.logUsage.button": "Catat penggunaan",
  "inventory.logUsage.title": "Catat penggunaan",
  "inventory.logUsage.help": "Catat stok yang digunakan di meja kerja. Data ini digunakan untuk proyeksi habisnya stok; gunakan Sesuaikan stok untuk mengoreksi jumlah hitungan.",
  "inventory.logUsage.quantityWithUnits": "Kuantitas yang digunakan ({units})",
  "inventory.logUsage.onHand": "{quantity} {units} tersedia. Lot diambil mulai dari yang paling cepat kedaluwarsa.",
  "inventory.logUsage.error.noItem": "Pilih barang untuk dicatat penggunaannya.",
  "inventory.logUsage.error.wholeUnits": "Masukkan jumlah unit berupa bilangan bulat, minimal 1.",
  "inventory.receiveStock.button": "Terima stok",
  "label.testCatalog.basicInfo.opensMicrobiologyCase": "Membuka kasus Mikrobiologi",
  "label.testCatalog.basicInfo.microbiologyCaseRole": "Peran kasus",
  "label.testCatalog.basicInfo.microbiologyCaseRole.CULTURE": "Kultur",
  "label.testCatalog.basicInfo.microbiologyCaseRole.DIRECT": "Langsung",
  "label.testCatalog.basicInfo.microbiologyCaseRole.CASE": "Kasus",
  "label.testCatalog.basicInfo.collectedInSets": "Diambil dalam set",
  "microbiology.sets.warning.SINGLE_BOTTLE": "Hanya satu botol dalam set ini",
  "microbiology.sets.warning.REPEATED_CONTAINER": "Jenis wadah berulang dalam set ini",
  "microbiology.sets.warning.DIFFERENT_SITES": "Lokasi pengambilan berbeda dalam set ini",
  "microbiology.sets.warning.COLLECTION_INTERVAL": "Waktu pengambilan berselisih lebih dari {minutes} menit",
  "microbiology.sets.title": "Set kultur",
  "microbiology.sets.count.sets": "{sets, plural, other {# set}}",
  "microbiology.sets.count.bottles": "{bottles, plural, other {# botol}}",
  "microbiology.sets.count.summary": "{sets}, {bottles}",
  "microbiology.sets.number": "Set {number}",
  "microbiology.sets.unassigned": "Set tidak tercatat",
  "order.microPreview.title": "Yang akan dibuka oleh pemesanan ini",
  "order.microPreview.loading": "Memperbarui pratinjau pemesanan…",
  "order.microPreview.failed": "Pratinjau pemesanan tidak tersedia",
  "order.microPreview.failedDetail": "Pratinjau tidak dapat diperbarui. Periksa koneksi Anda dan coba lagi.",
  "order.microPreview.opens": "Membuka kasus",
  "order.microPreview.ordinary": "Tetap di Hasil",
  "order.microPreview.case": "Kasus {tests} di {unit}: {samples}",
  "order.microPreview.sample": "Sampel {type} {number}",
  "order.microPreview.stays": "{test} tetap di Hasil",
  "order.microPreview.splitTag": "Kasus terpisah",
  "order.microPreview.split": "Sampel {number} membuka {count} kasus: {units}.",
  "order.microPreview.reflex": "{name}: jika {conditions}, dapat menambahkan {tests}.",
  "order.microPreview.component": "{test} - {component}",
  "order.microPreview.specimen": "{test} ({type})",
  "order.microPreview.and": " dan ",
  "order.microPreview.or": " atau ",
  "order.microPreview.condition.EQUALS": "Hasil {subject} sama dengan {value}",
  "order.microPreview.condition.NOT_EQUALS": "Hasil {subject} tidak sama dengan {value}",
  "order.microPreview.condition.LESS_THAN": "Hasil {subject} lebih kecil dari {value}",
  "order.microPreview.condition.LESS_THAN_OR_EQUAL": "Hasil {subject} maksimal {value}",
  "order.microPreview.condition.GREATER_THAN": "Hasil {subject} lebih besar dari {value}",
  "order.microPreview.condition.GREATER_THAN_OR_EQUAL": "Hasil {subject} minimal {value}",
  "order.microPreview.condition.BETWEEN": "Hasil {subject} berada di antara {value} dan {value2}",
  "order.microPreview.condition.INSIDE_NORMAL_RANGE": "Hasil {subject} berada dalam rentang normal",
  "order.microPreview.condition.OUTSIDE_NORMAL_RANGE": "Hasil {subject} berada di luar rentang normal",
  "order.microPreview.newUnitTag": "Instalasi lab baru",
  "order.microPreview.newUnit": "{test} membuka kasus di {unit}; pemesanan ini tidak memiliki pekerjaan lain di instalasi lab tersebut.",
  "dictionary.containerPopulation": "Populasi botol (wadah sampel)",
  "dictionary.containerPopulation.unspecified": "Tidak dispesifikasi",
  "dictionary.containerPopulation.ADULT": "Dewasa",
  "dictionary.containerPopulation.PAEDIATRIC": "Anak",
  "dictionary.aedesAegyptiPathogens.chikungunya": "Chikungunya",
  "dictionary.aedesAegyptiPathogens.dengue": "Dengue",
  "dictionary.aedesAegyptiPathogens.yellowFever": "Yellow Fever",
  "dictionary.aedesAegyptiPathogens.zika": "Zika",
  "dictionary.aedesAlbopictusPathogens.chikungunya": "Chikungunya",
  "dictionary.aedesAlbopictusPathogens.dengue": "Dengue",
  "dictionary.aedesAlbopictusPathogens.zika": "Zika",
  "dictionary.afbSkinResults.1Plus": "1+",
  "dictionary.afbSkinResults.2Plus": "2+",
  "dictionary.afbSkinResults.3Plus": "3+",
  "dictionary.afbSkinResults.4Plus": "4+",
  "dictionary.afbSkinResults.5Plus": "5+",
  "dictionary.afbSkinResults.6Plus": "6+",
  "dictionary.afbSkinResults.negative": "Negative",
  "dictionary.afbSputumResults.1Plus": "1+",
  "dictionary.afbSputumResults.2Plus": "2+",
  "dictionary.afbSputumResults.3Plus": "3+",
  "dictionary.afbSputumResults.negative": "Negative",
  "dictionary.afbSputumResults.scanty": "Scanty",
  "dictionary.analyzerGeneXpertResults.detected": "DETECTED",
  "dictionary.analyzerGeneXpertResults.error": "ERROR",
  "dictionary.analyzerGeneXpertResults.high": "HIGH",
  "dictionary.analyzerGeneXpertResults.indeterminate": "INDETERMINATE",
  "dictionary.analyzerGeneXpertResults.low": "LOW",
  "dictionary.analyzerGeneXpertResults.medium": "MEDIUM",
  "dictionary.analyzerGeneXpertResults.mtbDetected": "MTB DETECTED",
  "dictionary.analyzerGeneXpertResults.noResult": "NO RESULT",
  "dictionary.analyzerGeneXpertResults.notDetected": "NOT DETECTED",
  "dictionary.analyzerGeneXpertResults.veryLow": "VERY LOW",
  "dictionary.analyzerGeneXpertRifResults.detected": "DETECTED",
  "dictionary.analyzerGeneXpertRifResults.indeterminate": "Tidak ditentukan",
  "dictionary.analyzerGeneXpertRifResults.notDetected": "NOT DETECTED",
  "dictionary.anophelesPathogens.malaria": "Malaria",
  "dictionary.biolineHivResults.hiv1And2Positive": "HIV 1 and 2 Positive",
  "dictionary.biolineHivResults.hiv1Positive": "HIV 1 Positive",
  "dictionary.biolineHivResults.hiv2Positive": "HIV 2 Positive",
  "dictionary.biolineHivResults.indeterminate": "Tidak ditentukan",
  "dictionary.biolineHivResults.negative": "Negative",
  "dictionary.candidaKohResults.hypa": "Hyphae",
  "dictionary.candidaKohResults.spora": "Spores",
  "dictionary.candidaKohResults.yeastCell": "Yeast cell",
  "dictionary.clinicalCollectionMethod.arterialPuncture": "Arterial Puncture",
  "dictionary.clinicalCollectionMethod.aspirate": "Aspirate",
  "dictionary.clinicalCollectionMethod.biopsy": "Biopsy",
  "dictionary.clinicalCollectionMethod.capillaryFingerPrick": "Capillary / Finger Prick",
  "dictionary.clinicalCollectionMethod.catheter": "Catheter",
  "dictionary.clinicalCollectionMethod.heelPrick": "Heel Prick",
  "dictionary.clinicalCollectionMethod.lumbarPuncture": "Lumbar Puncture",
  "dictionary.clinicalCollectionMethod.midstreamCleanCatch": "Midstream Clean Catch",
  "dictionary.clinicalCollectionMethod.other": "Lainnya",
  "dictionary.clinicalCollectionMethod.sputumExpectoration": "Sputum Expectoration",
  "dictionary.clinicalCollectionMethod.swab": "Swab",
  "dictionary.clinicalCollectionMethod.venipuncture": "Venipuncture",
  "dictionary.confirmatoryResults.indeterminate": "Tidak ditentukan",
  "dictionary.confirmatoryResults.invalid": "Tidak valid",
  "dictionary.confirmatoryResults.negative": "Negative",
  "dictionary.confirmatoryResults.positive": "Positif",
  "dictionary.culexPathogens.westNileVirus": "West Nile Virus",
  "dictionary.detectionResults.terdeteksi": "Detected",
  "dictionary.detectionResults.tidakMeyakinkan": "Inconclusive",
  "dictionary.detectionResults.tidakTerdeteksi": "Not Detected",
  "dictionary.envCollectionMethod.composite24H": "Composite 24h",
  "dictionary.envCollectionMethod.composite8H": "Composite 8h",
  "dictionary.envCollectionMethod.depthIntegrated": "Depth Integrated",
  "dictionary.envCollectionMethod.grabSample": "Grab Sample",
  "dictionary.envCollectionMethod.other": "Lainnya",
  "dictionary.envCollectionMethod.passiveSampler": "Passive Sampler",
  "dictionary.envCollectionMethod.surfaceGrab": "Surface Grab",
  "dictionary.envWeather.clearSunny": "Clear / Sunny",
  "dictionary.envWeather.drizzle": "Drizzle",
  "dictionary.envWeather.foggy": "Foggy",
  "dictionary.envWeather.heavyRain": "Heavy Rain",
  "dictionary.envWeather.lightRain": "Light Rain",
  "dictionary.envWeather.other": "Lainnya",
  "dictionary.envWeather.overcast": "Overcast",
  "dictionary.envWeather.partlyCloudy": "Partly Cloudy",
  "dictionary.envWeather.windy": "Windy",
  "dictionary.environmentalZone.agricultural": "Agricultural",
  "dictionary.environmentalZone.industrial": "Industrial",
  "dictionary.environmentalZone.periUrban": "Peri-Urban",
  "dictionary.environmentalZone.protectedArea": "Protected Area",
  "dictionary.environmentalZone.rural": "Rural",
  "dictionary.environmentalZone.urban": "Urban",
  "dictionary.fleaFullCycle.adult": "Dewasa",
  "dictionary.fleaFullCycle.egg": "Egg",
  "dictionary.fleaFullCycle.larva": "Larva",
  "dictionary.fleaFullCycle.pupa": "Pupa",
  "dictionary.flyStages.adult": "Dewasa",
  "dictionary.flyStages.larva": "Larva",
  "dictionary.flyStages.pupa": "Pupa",
  "dictionary.genieHivResults.hiv1": "HIV 1",
  "dictionary.genieHivResults.hiv2": "HIV 2",
  "dictionary.genieHivResults.hivDual": "HIV Dual",
  "dictionary.genieHivResults.indeterminate": "Tidak ditentukan",
  "dictionary.genieHivResults.invalid": "Tidak valid",
  "dictionary.genieHivResults.negative": "Negative",
  "dictionary.gramStainGenitalResults.gramDiplococcusFound": "Gram(-) diplococcus found",
  "dictionary.gramStainGenitalResults.gramDiplococcusNotFound": "Gram(-) diplococcus not found",
  "dictionary.hBsAgResults.negative": "Negative",
  "dictionary.hBsAgResults.positive": "Positif",
  "dictionary.hivRapidResults.indeterminate": "Tidak ditentukan",
  "dictionary.hivRapidResults.negative": "Negative",
  "dictionary.hivRapidResults.positive": "Positif",
  "dictionary.malariaResults.mixedInfection": "Mixed infection",
  "dictionary.malariaResults.noParasitesSeen": "No parasites seen",
  "dictionary.malariaResults.plasmodiumFalciparum": "Plasmodium falciparum",
  "dictionary.malariaResults.plasmodiumMalariae": "Plasmodium malariae",
  "dictionary.malariaResults.plasmodiumOvale": "Plasmodium ovale",
  "dictionary.malariaResults.plasmodiumVivax": "Plasmodium vivax",
  "dictionary.mosquitoFullCycle.adult": "Dewasa",
  "dictionary.mosquitoFullCycle.egg": "Egg",
  "dictionary.mosquitoFullCycle.larva": "Larva",
  "dictionary.mosquitoFullCycle.pupa": "Pupa",
  "dictionary.muscaPathogens.typhus": "Typhus",
  "dictionary.p24AgResults.hiv1": "HIV 1",
  "dictionary.p24AgResults.indeterminate": "Tidak ditentukan",
  "dictionary.p24AgResults.negative": "Negative",
  "dictionary.phlebotomusPathogens.riftValleyFever": "Rift Valley Fever",
  "dictionary.positifNegatif.negatif": "Negative",
  "dictionary.positifNegatif.positif": "Positif",
  "dictionary.pregnancyTestResults.negative": "Negative",
  "dictionary.pregnancyTestResults.positive": "Positif",
  "dictionary.proteinuriaResults.negative": "Negative",
  "dictionary.proteinuriaResults.positivePlus": "Positive +",
  "dictionary.proteinuriaResults.positivePlusPlus": "Positive ++",
  "dictionary.proteinuriaResults.positivePlusPlusPlus": "Positive +++",
  "dictionary.qaChecklistItem.labelsVerified": "Labels have been printed and applied",
  "dictionary.qaChecklistItem.patientInfoVerified": "Patient information is correct",
  "dictionary.qaChecklistItem.samplesVerified": "Sample types and tests are correct",
  "dictionary.qaChecklistItem.storageVerified": "Storage locations have been assigned",
  "dictionary.rattusPathogens.plague": "Plague",
  "dictionary.rattusPathogens.typhus": "Typhus",
  "dictionary.rodentStages.adult": "Dewasa",
  "dictionary.sampleAcceptanceItem.coldChain": "Cold chain maintained",
  "dictionary.sampleAcceptanceItem.containerIntact": "Container intact / undamaged",
  "dictionary.sampleAcceptanceItem.labelLegible": "Label legible and matches request",
  "dictionary.sampleAcceptanceItem.paperwork": "Required paperwork present and complete",
  "dictionary.sampleAcceptanceItem.transit": "Acceptable transit time / condition",
  "dictionary.sampleAcceptanceItem.volumeAdequate": "Sample volume adequate",
  "dictionary.sampleContainer.1LHdpeBottle": "1L HDPE bottle",
  "dictionary.sampleContainer.250MLGlassBottle": "250mL glass bottle",
  "dictionary.sampleContainer.500MLGlassBottle": "500mL glass bottle",
  "dictionary.sampleContainer.compositeJerryCan5L": "Composite jerry can 5L",
  "dictionary.sampleContainer.filterMembrane": "Filter membrane",
  "dictionary.sampleContainer.other": "Lainnya",
  "dictionary.sampleContainer.sterileBag": "Sterile bag",
  "dictionary.sampleType.hPlasma": "Plasma",
  "dictionary.sampleType.hSaliva": "Saliva",
  "dictionary.sampleType.hSerum": "Serum",
  "dictionary.sampleType.hTissue": "Tissue",
  "dictionary.sampleType.hUrine": "Urine",
  "dictionary.sampleType.hWholeBlood": "Whole Blood",
  "dictionary.samplingSiteType.airMonitoringStation": "Air Monitoring Station",
  "dictionary.samplingSiteType.distributionPoint": "Distribution Point",
  "dictionary.samplingSiteType.foodFacility": "Food Facility",
  "dictionary.samplingSiteType.monitoringStation": "Monitoring Station",
  "dictionary.samplingSiteType.other": "Lainnya",
  "dictionary.samplingSiteType.soilSamplingSite": "Soil Sampling Site",
  "dictionary.samplingSiteType.treatmentPlant": "Treatment Plant",
  "dictionary.samplingSiteType.waterSource": "Water Source",
  "dictionary.specimenOrigin.communityField": "Community / Field",
  "dictionary.specimenOrigin.emergencyDepartment": "Emergency Department",
  "dictionary.specimenOrigin.inpatientWard": "Inpatient Ward",
  "dictionary.specimenOrigin.intensiveCare": "Intensive Care",
  "dictionary.specimenOrigin.operatingTheatre": "Operating Theatre",
  "dictionary.specimenOrigin.outpatientClinic": "Outpatient Clinic",
  "dictionary.specimenOrigin.referredFromExternalFacility": "Referred from External Facility",
  "dictionary.susceptibilityResults.intermediate": "Intermediet",
  "dictionary.susceptibilityResults.resistan": "Resisten",
  "dictionary.susceptibilityResults.sensitif": "Sensitive",
  "dictionary.testResults.detected": "Detected",
  "dictionary.testResults.inconclusive": "Inconclusive",
  "dictionary.testResults.indeterminate": "Tidak ditentukan",
  "dictionary.testResults.negative": "Negative",
  "dictionary.testResults.nonReactive": "Non-Reactive",
  "dictionary.testResults.notDetected": "Not Detected",
  "dictionary.testResults.positive": "Positif",
  "dictionary.testResults.reactive": "Reactive",
  "dictionary.titerResults.1To10": "1:10",
  "dictionary.titerResults.1To160": "1:160",
  "dictionary.titerResults.1To20": "1:20",
  "dictionary.titerResults.1To320": "1:320",
  "dictionary.titerResults.1To40": "1:40",
  "dictionary.titerResults.1To640": "1:640",
  "dictionary.titerResults.1To80": "1:80",
  "dictionary.trichomonasResults.trichomonasNegative": "Trichomonas negative",
  "dictionary.trichomonasResults.trichomonasPositive": "Trichomonas positive",
  "dictionary.urinalysisResults.clear": "Kosongkan",
  "dictionary.urinalysisResults.cloudy": "Cloudy",
  "dictionary.urinalysisResults.slightlyCloudy": "Slightly Cloudy",
  "dictionary.urinalysisResults.turbid": "Turbid",
  "dictionary.urineColor.amber": "Amber",
  "dictionary.urineColor.brown": "Brown",
  "dictionary.urineColor.darkYellow": "Dark Yellow",
  "dictionary.urineColor.red": "Red",
  "dictionary.urineColor.yellow": "Yellow",
  "dictionary.vecBloodmealHostSpecies.avianProxyToChicken": "Avian (proxy: chicken)",
  "dictionary.vecBloodmealHostSpecies.cattleBosTaurus": "Cattle (Bos taurus)",
  "dictionary.vecBloodmealHostSpecies.dogCanisFamiliaris": "Dog (Canis familiaris)",
  "dictionary.vecBloodmealHostSpecies.goatCapraHircus": "Goat (Capra hircus)",
  "dictionary.vecBloodmealHostSpecies.humanHomoSapiens": "Human (Homo sapiens)",
  "dictionary.vecBloodmealHostSpecies.mixedHostBloodmeal": "Mixed-host bloodmeal",
  "dictionary.vecBloodmealHostSpecies.noHostDetected": "No host detected",
  "dictionary.vecBloodmealHostSpecies.pigSusScrofa": "Pig (Sus scrofa)",
  "dictionary.vecCollectionTimeOfDay.dawn": "Pagi",
  "dictionary.vecCollectionTimeOfDay.daylight": "Daylight",
  "dictionary.vecCollectionTimeOfDay.dusk": "Sore",
  "dictionary.vecCollectionTimeOfDay.night": "Malam",
  "dictionary.vecCollectionTimeOfDay.unknown": "Tidak diketahui",
  "dictionary.vecInsecticideResistanceGenotype.heterozygote": "Heterozygote",
  "dictionary.vecInsecticideResistanceGenotype.indeterminate": "Tidak ditentukan",
  "dictionary.vecInsecticideResistanceGenotype.resistantHomozygote": "Resistant homozygote",
  "dictionary.vecInsecticideResistanceGenotype.susceptibleHomozygote": "Susceptible homozygote",
  "dictionary.vecLifecycleStages.adult": "Dewasa",
  "dictionary.vecLifecycleStages.egg": "Egg",
  "dictionary.vecLifecycleStages.larva": "Larva",
  "dictionary.vecLifecycleStages.nymph": "Nymph",
  "dictionary.vecLifecycleStages.pupa": "Pupa",
  "dictionary.vecPathogenResult.equivocalIndeterminate": "Equivocal / Indeterminate",
  "dictionary.vecPathogenResult.invalid": "Tidak valid",
  "dictionary.vecPathogenResult.negative": "Negative",
  "dictionary.vecPathogenResult.positive": "Positif",
  "dictionary.vecPathogens.chikungunya": "Chikungunya",
  "dictionary.vecPathogens.dengue": "Dengue",
  "dictionary.vecPathogens.malaria": "Malaria",
  "dictionary.vecPathogens.plague": "Plague",
  "dictionary.vecPathogens.riftValleyFever": "Rift Valley Fever",
  "dictionary.vecPathogens.typhus": "Typhus",
  "dictionary.vecPathogens.westNileVirus": "West Nile Virus",
  "dictionary.vecPathogens.yellowFever": "Yellow Fever",
  "dictionary.vecPathogens.zika": "Zika",
  "dictionary.vecPhysiologicalState.bloodFed": "Telah menghisap darah",
  "dictionary.vecPhysiologicalState.gravid": "Hamil",
  "dictionary.vecPhysiologicalState.halfGravid": "Setengah hamil",
  "dictionary.vecPhysiologicalState.unfed": "Belum diberi makan",
  "dictionary.vecPhysiologicalState.unknownNotAssessed": "Tidak diketahui / belum dievaluasi",
  "dictionary.vecPlasmodiumDrugResistanceVariant.76T": "76T",
  "dictionary.vecPlasmodiumDrugResistanceVariant.a437G": "A437G",
  "dictionary.vecPlasmodiumDrugResistanceVariant.a581G": "A581G",
  "dictionary.vecPlasmodiumDrugResistanceVariant.a613S": "A613S",
  "dictionary.vecPlasmodiumDrugResistanceVariant.c580Y": "C580Y",
  "dictionary.vecPlasmodiumDrugResistanceVariant.d1246": "D1246",
  "dictionary.vecPlasmodiumDrugResistanceVariant.i164L": "I164L",
  "dictionary.vecPlasmodiumDrugResistanceVariant.i543T": "I543T",
  "dictionary.vecPlasmodiumDrugResistanceVariant.k540E": "K540E",
  "dictionary.vecPlasmodiumDrugResistanceVariant.k76WildType": "K76 (wild type)",
  "dictionary.vecPlasmodiumDrugResistanceVariant.n1042": "N1042",
  "dictionary.vecPlasmodiumDrugResistanceVariant.n51I": "N51I",
  "dictionary.vecPlasmodiumDrugResistanceVariant.otherVariantSequenceCaptured": "Other variant (sequence captured)",
  "dictionary.vecPlasmodiumDrugResistanceVariant.p553L": "P553L",
  "dictionary.vecPlasmodiumDrugResistanceVariant.r539T": "R539T",
  "dictionary.vecPlasmodiumDrugResistanceVariant.r59": "R59",
  "dictionary.vecPlasmodiumDrugResistanceVariant.s1034": "S1034",
  "dictionary.vecPlasmodiumDrugResistanceVariant.s108": "S108",
  "dictionary.vecPlasmodiumDrugResistanceVariant.wildTypePfkelch13": "Wild type (pfkelch13)",
  "dictionary.vecPlasmodiumDrugResistanceVariant.y184": "Y184",
  "dictionary.vecPlasmodiumDrugResistanceVariant.y493H": "Y493H",
  "dictionary.vecPlasmodiumDrugResistanceVariant.y86": "Y86",
  "dictionary.vecPlasmodiumSpecies.indeterminate": "Tidak ditentukan",
  "dictionary.vecPlasmodiumSpecies.mixedInfection": "Mixed infection",
  "dictionary.vecPlasmodiumSpecies.pFalciparum": "P. falciparum",
  "dictionary.vecPlasmodiumSpecies.pKnowlesi": "P. knowlesi",
  "dictionary.vecPlasmodiumSpecies.pMalariae": "P. malariae",
  "dictionary.vecPlasmodiumSpecies.pOvale": "P. ovale",
  "dictionary.vecPlasmodiumSpecies.pVivax": "P. vivax",
  "dictionary.vecRestingContext.indoorEndophilic": "Di dalam ruangan (endofilik)",
  "dictionary.vecRestingContext.outdoorExophilic": "Di luar ruangan (eksofilik)",
  "dictionary.vecRestingContext.unknown": "Tidak diketahui",
  "dictionary.vecTrapType.aspirator": "Aspirator",
  "dictionary.vecTrapType.bgSentinelTrap": "BG-Sentinel trap",
  "dictionary.vecTrapType.cdcLightTrap": "CDC light trap",
  "dictionary.vecTrapType.gravidTrap": "Gravid trap",
  "dictionary.vecTrapType.humanLandingCollection": "Human-landing collection",
  "dictionary.vecTrapType.otherSpecifyInNotes": "Other (specify in notes)",
  "dictionary.vecTrapType.ovitrap": "Ovitrap",
  "dictionary.vecTrapType.sweepNet": "Sweep net",
  "dictionary.vecVirusIsolationResult.inconclusive": "Inconclusive",
  "dictionary.vecVirusIsolationResult.isolated": "Isolated",
  "dictionary.vecVirusIsolationResult.notIsolated": "Not isolated",
  "dictionary.vecWhoInsecticideSusceptibilityClass.possiblyResistant": "Possibly resistant",
  "dictionary.vecWhoInsecticideSusceptibilityClass.resistant": "Resisten",
  "dictionary.vecWhoInsecticideSusceptibilityClass.susceptible": "Sensitif",
  "dictionary.waterClarity.agakKeruh": "Slightly Turbid",
  "dictionary.waterClarity.jernih": "Kosongkan",
  "dictionary.waterClarity.keruh": "Turbid",
  "dictionary.waterColor.biru": "Blue",
  "dictionary.waterColor.cokelat": "Brown",
  "dictionary.waterColor.hijau": "Green",
  "dictionary.waterColor.hitam": "Black",
  "dictionary.waterColor.kuning": "Yellow",
  "dictionary.waterColor.merah": "Red",
  "dictionary.waterColor.putih": "White",
  "dictionary.waterColor.tidakBerwarna": "Colorless",
  "dictionary.xenopsyllaPathogens.plague": "Plague",
  "dictionary.xenopsyllaPathogens.typhus": "Typhus",
  "microbiology.sets.warning.MIXED_POPULATIONS": "Set ini berisi botol pediatrik dan dewasa.",
  "order.cultureSetNumber": "Nomor set",
  "order.cultureSetNumber.required": "Masukkan nomor set berupa bilangan bulat positif.",
  "order.cultureBottle.duplicate": "Duplikasi botol",
  "microbiology.sets.container": "Jenis wadah",
  "microbiology.sets.bodySite": "Lokasi tubuh",
  "inventory.reorder.suggestions": "Saran pemesanan ulang",
  "inventory.reorder.help": "Barang yang berada pada atau di bawah ambang batasnya, atau diproyeksikan mencapainya sebelum pesanan baru dapat tiba. Menandai sebagai dipesan mencatat bahwa pesanan telah dibuat, bukan membuat pesanan.",
  "inventory.reorder.none": "Tidak ada yang perlu dipesan saat ini.",
  "inventory.reorder.markOrdered": "Tandai sebagai dipesan",
  "inventory.reorder.onOrder": "Sedang dipesan",
  "inventory.reorder.note": "Catatan",
  "inventory.reorder.note.placeholder": "Referensi permintaan barang atau PO",
  "inventory.reorder.expectedDate": "Tanggal perkiraan",
  "inventory.reorder.marked": "{count, plural, other {# barang}} marked as ordered.",
  "inventory.reorder.reviewAndOrder": "Tinjau dan tandai sebagai dipesan",
  "inventory.reorder.clearOrdered": "Batal dipesan",
  "inventory.reorder.cleared": "{count, plural, other {# barang}} no longer marked as ordered.",
  "inventory.board.andMore": "dan {count} lainnya",
  "inventory.item.leadTime": "Waktu tunggu (hari)",
  "inventory.item.leadTime.help": "Berapa lama barang ini tiba setelah dipesan. Biarkan kosong agar dipelajari dari pengiriman Anda sendiri.",
  "inventory.item.leadTime.observedSuggest": "Beberapa pengiriman terakhir Anda memerlukan sekitar {days} hari.",
  "inventory.item.leadTime.useObserved": "Gunakan ini",
  "inventory.item.tags": "Tag",
  "inventory.item.tags.help": "Cara barang ini dikelompokkan, difilter, dan dilaporkan. Satu barang dapat memiliki lebih dari satu tag.",
  "inventory.item.tags.add": "Ketik untuk mencari atau menambah tag",
  "inventory.item.tags.remove": "Hapus tag {tag}",
  "inventory.item.autoConsume.help": "Tidak ada pengaturan konsumsi otomatis. Menautkan barang ke pemeriksaan di Katalog Pemeriksaan memungkinkan meja kerja mencatat penggunaannya saat memasukkan hasil pemeriksaan tersebut.",
  "inventory.search.placeholder.board": "Cari berdasarkan nama barang, kode, tag, atau nomor lot",
  "inventory.filter.tags": "Filter berdasarkan Tag",
  "inventory.filter.tags.clear": "Hapus tag",
  "inventory.tags.manage": "Kelola tag",
  "inventory.tags.help": "Rapikan tag Anda. Menonaktifkan tag membuatnya tidak lagi disarankan atau ditawarkan sebagai filter. Barang yang sudah memilikinya tetap menyimpannya.",
  "inventory.tags.tag": "Tag",
  "inventory.tags.usage": "Barang",
  "inventory.tags.status": "Status",
  "inventory.tags.active": "Aktif",
  "inventory.tags.deactivated": "Sudah inaktif",
  "inventory.tags.deactivate": "Nonaktifkan",
  "inventory.tags.reactivate": "Aktifkan Ulang",
  "inventory.tags.showDeactivated": "Tampilkan sudah inaktif",
  "inventory.tags.new": "Tag baru",
  "inventory.tags.add": "Tambah tag",
  "inventory.tags.none": "Belum ada tag. Tambahkan di sini, atau beri tag langsung pada barang.",
  "inventory.tags.error.blank": "Tag harus memiliki nama.",
  "inventory.item.new": "Barang baru",
  "inventory.item.created": "Barang telah didefinisikan. Terima stok untuk barang ini agar kuantitasnya mulai dilacak.",
  "inventory.item.showDeactivated": "Tampilkan sudah inaktif",
  "inventory.item.deactivated": "Sudah inaktif",
  "inventory.item.deactivate": "Nonaktifkan barang",
  "inventory.item.reactivate": "Aktifkan ulang barang",
  "inventory.item.reactivated": "{item} aktif kembali.",
  "inventory.item.deactivated.success": "{item} telah dinonaktifkan. Tampilkan yang nonaktif untuk menemukannya lagi.",
  "inventory.item.deactivate.confirm.title": "Nonaktifkan barang ini?",
  "inventory.item.deactivate.confirm": "Nonaktifkan {item}?",
  "inventory.item.deactivate.implication.hidden": "Barang ini akan keluar dari papan dan tidak lagi ditawarkan saat penerimaan atau pencatatan penggunaan.",
  "inventory.item.deactivate.implication.stock": "Lot dan riwayatnya tetap disimpan, dan stok yang masih ada tidak dihapusbukukan.",
  "inventory.item.deactivate.implication.reversible": "Anda dapat mengaktifkannya kembali kapan saja dari Tampilkan yang nonaktif.",
  "catalog.item.catalogNumber": "Nomor katalog",
  "catalog.item.expirationAlertDays": "Peringatkan sekian hari sebelum kedaluwarsa",
  "catalog.item.trackLots": "Lacak lot dan kedaluwarsa",
  "catalog.item.trackLots.help": "Aktifkan untuk barang yang diterima dalam batch dengan tanggal kedaluwarsa. Nonaktifkan untuk bahan habis pakai yang dihitung sebagai satu Pool.",
  "catalog.item.form.help": "Ini mendefinisikan suatu jenis barang. Untuk menambah jumlah barang yang sudah ada, gunakan Terima stok.",
  "inventory.item.form.title.add": "Barang baru",
  "inventory.item.form.title.edit": "Edit barang",
  "inventory.count.enter": "Mode penghitungan",
  "inventory.count.leave": "Keluar dari mode penghitungan",
  "inventory.count.confirm": "Konfirmasi penghitungan",
  "inventory.count.expected": "dari {expected} {units}",
  "inventory.count.matches": "Cocok",
  "inventory.count.perLot": "Hitung setiap lot di bawah ({expected} {units} diharapkan di sini)",
  "inventory.count.nothingHere": "Tidak ada yang perlu dihitung di sini",
  "inventory.count.countOf": "Jumlah terhitung untuk {item}",
  "inventory.count.tally": "{counted, plural, =0 {Belum ada yang dihitung} one {# lot dihitung} other {# lot dihitung}}",
  "inventory.count.scoped": "Menghitung {location}. Hanya stok di lokasi ini yang ditampilkan, dan hanya yang Anda ketik yang disimpan.",
  "inventory.count.unscoped": "Menghitung di semua lokasi. Filter berdasarkan lokasi untuk menghitung satu rak setiap kali. Hanya yang Anda ketik yang disimpan.",
  "inventory.count.done": "Penghitungan dicatat: {adjusted, plural, =0 {tidak ada koreksi} one {# koreksi} other {# koreksi}}, {confirmed, plural, =0 {tidak ada yang dikonfirmasi} one {# lot dikonfirmasi} other {# lot dikonfirmasi}}.",
  "inventory.count.lastCounted": "Dihitung {date}",
  "inventory.count.neverCounted": "Belum pernah dihitung",
  "inventory.count.column": "Penghitungan terakhir",
  "inventory.delivery.purpose": "Masukkan pengiriman. Pindai kotak, ketik jumlah yang datang, tambahkan, lalu pindai kotak berikutnya. Tidak ada yang disimpan sampai Anda mengonfirmasi seluruh pengiriman.",
  "inventory.delivery.scan": "Pindai kotak",
  "inventory.delivery.scan.help": "Label GS1 mengisi produk, batch, dan tanggal kedaluwarsa. Data yang tidak ada pada label dapat diketik di bawah.",
  "inventory.delivery.scan.unread": "Kode tersebut tidak dikenali. Masukkan baris secara manual.",
  "inventory.delivery.partialScan": "Terpindai sebagian",
  "inventory.delivery.add": "Tambahkan ke pengiriman",
  "inventory.delivery.remove": "Hapus",
  "inventory.delivery.confirm": "Terima {count, plural, one {# baris} other {# baris}}",
  "inventory.delivery.discard": "Buang pengiriman",
  "inventory.delivery.received": "{count, plural, other {# baris}} received.",
  "inventory.delivery.expired": "Lot ini sudah melewati tanggal kedaluwarsanya",
  "inventory.delivery.expired.help": "Anda tetap dapat menerimanya. Stok dengan masa simpan pendek adalah pengiriman normal, dan papan akan menandainya.",
  "catalog.item.upc": "Kode batang produk (UPC atau GTIN)",
  "catalog.item.upc.help": "Kode QR produsen untuk produk ini. Setiap kemasannya membawa kode yang sama, sehingga memindainya menunjukkan jenis barang, bukan batch mana yang datang.",
  "inventory.receive.title": "Terima stok",
  "inventory.receive.submit": "Terima",
  "inventory.receive.success": "Diterima {quantity} {units}. Stok ini kini dihitung sebagai tersedia, dan dapat digunakan setelah QC-nya lolos.",
  "inventory.receive.help": "Menambahkan stok untuk barang yang sudah ada. Untuk mendefinisikan barang baru, gunakan Barang baru.",
  "inventory.receive.scan": "Pindai kode batang produk",
  "inventory.receive.scan.help": "Pindai atau ketik UPC untuk memilih barang tanpa mencari.",
  "inventory.receive.scan.unknown": "Tidak ada barang dengan kode batang tersebut",
  "inventory.receive.quantityWithUnits": "Kuantitas yang diterima ({units})",
  "inventory.receive.lotNumber.help": "Biarkan kosong, nomor lot akan dibuat dari kode barang dan tanggal hari ini.",
  "inventory.receive.location.optional": "Belum ditetapkan. Anda dapat mengaturnya sekarang atau nanti dari lot.",
  "inventory.receive.error.noItem": "Pilih barang yang diterima.",
  "inventory.receive.error.quantity": "Masukkan jumlah yang tiba.",
  "inventory.receive.error.locationAfterReceive": "Stok telah diterima, tetapi lokasi penyimpanan tidak dapat ditetapkan: {reason}",
  "reports.type.received": "Diterima",
  "reports.type.received.description": "Barang yang datang dalam periode ini, per barang dan lot.",
  "reports.type.consumed": "Habis",
  "reports.type.consumed.description": "Barang yang digunakan dalam periode ini, dijumlahkan per barang.",
  "reports.type.stockOnHand": "Stok tersedia",
  "reports.type.stockOnHand.description": "Stok yang Anda miliki, per lot, dengan tanggal kedaluwarsa.",
  "reports.type.expiring": "Segera Kedaluwarsa",
  "reports.type.expiring.description": "Lot yang tanggal kedaluwarsanya jatuh dalam rentang waktu yang Anda pilih.",
  "reports.asOfDate": "Per tanggal",
  "reports.asOfDate.help": "Kosongkan untuk stok saat ini.",
  "reports.expiringFrom": "Kedaluwarsa dari",
  "reports.expiringTo": "Kedaluwarsa sampai",
  "reports.tags": "Tag",
  "reports.tags.help": "Batasi laporan pada barang yang memiliki salah satu tag ini.",
  "reports.tags.placeholder": "Tag apa saja",
  "reports.run": "Jalankan laporan",
  "reports.running": "Sedang berjalan...",
  "reports.empty": "Tidak ada yang cocok dengan filter ini.",
  "reports.empty.stockOnHandAsOf": "Tidak ada pergerakan stok yang tercatat pada atau sebelum tanggal ini, sehingga stok pada saat itu tidak dapat direkonstruksi. Ini tidak sama dengan tidak memiliki stok.",
  "reports.asOfDate.basis": "Direkonstruksi dari pergerakan stok yang tercatat hingga tanggal ini, bukan dari penghitungan fisik.",
  "order.continue.item.eqaScheme": "Choose the EQA scheme",
  "order.eqa.cycle": "Siklus",
  "order.eqa.cycle.none": "No cycle",
  "order.eqa.cycleNotInScheme": "The chosen cycle is not an open cycle of this EQA scheme.",
  "order.eqa.newCycle": "Siklus baru",
  "order.eqa.noCycle.warning": "This sample is not linked to a cycle, so it will not be submitted or scored from OpenELIS.",
  "order.eqa.noEnrollments.link": "Enroll under My EQA Schemes",
  "order.eqa.noEnrollments.title": "This laboratory is not enrolled in any active EQA scheme.",
  "order.eqa.providerSampleId.codes": "Panel codes for this cycle: {codes}",
  "order.eqa.providerSampleId.noMatch": "This code matches none of the cycle's panel codes ({codes}).",
  "order.eqa.scheme": "Program PME",
  "order.eqa.scheme.choose": "Choose a scheme",
  "order.eqa.schemeRequired": "Choose the EQA scheme this sample belongs to.",
  "order.eqa.schemeUnknown": "The chosen EQA scheme is not one of this laboratory's active enrollments.",
  "order.save.requirement.eqaScheme": "the EQA scheme",
  "save.order.success.labNumber": "Order {labNumber} has been saved.",
  "qc.status.error.required": "Select a QC status.",
  "qc.status.error.notesRequired": "Say why QC failed.",
  "disposal.error.reasonRequired": "Select a disposal reason.",
  "common.error.notesRequiredForOther": "Add a note to explain the reason you chose.",
  "adjustment.error.negativeQuantity": "Quantity cannot be negative.",
  "adjustment.error.reasonRequired": "Select a reason for the adjustment.",
  "lot.error.numberRequired": "Lot number is required.",
  "lot.error.locationRequired": "Assign a storage location.",
  "lot.status.select": "Select lot status",
  "catalog.item.error.nameRequired": "Item name is required.",
  "sidenav.label.inventory.items": "Barang",
  "sidenav.label.inventory.items.tooltip": "What you have and what to reorder",
  "sidenav.label.inventory.receive": "Terima",
  "sidenav.label.inventory.receive.tooltip": "Enter a delivery, scanning or typing each line",
  "sidenav.label.inventory.reports": "Laporan",
  "sidenav.label.inventory.reports.tooltip": "Received, consumed, stock on hand and expiring",
  "inventory.import.button": "Import items",
  "inventory.import.title": "Import items from a file",
  "inventory.import.help": "Define many items at once from a CSV file. The preview shows what the file would do and saves nothing; only Apply writes anything. Re-importing a corrected file updates the same items rather than adding them again.",
  "inventory.import.template": "Download the template",
  "inventory.import.dropzone": "Add a CSV file",
  "inventory.import.preview": "Pratinjau",
  "inventory.import.apply": "Terapkan",
  "inventory.import.plan.title": "What this file would do",
  "inventory.import.result.title": "What was imported",
  "inventory.import.column.line": "Baris",
  "inventory.import.column.outcome": "Hasil",
  "inventory.import.column.reason": "Alasan",
  "inventory.import.outcome.create": "Baru",
  "inventory.import.outcome.update": "Terbarui",
  "inventory.import.outcome.unchanged": "Tidak berubah",
  "inventory.import.outcome.skip": "Dilewati",
  "inventory.import.count.created": "{count} new",
  "inventory.import.count.updated": "{count} diperbarui",
  "inventory.import.count.unchanged": "{count} tidak berubah",
  "inventory.import.count.skipped": "{count} dilewati",
  "inventory.import.error.rowsTitle": "Some rows cannot be used",
  "inventory.import.error.rowsMessage": "The rows listed below will be skipped. Applying saves the rest; fix those rows and add the file again to include them.",
  "inventory.import.error.unreadable": "That file could not be read.",
  "inventory.import.error.failed": "The file could not be imported.",
  "inventory.import.nothingToDo": "This file would change nothing",
  "inventory.import.nothingToDo.help": "Every item in it already matches what is stored.",
  "sidenav.label.reports.printQueue": "Report Print Queue",
  "reportQueue.title": "Report Print Queue",
  "reportQueue.subtitle": "Print, reprint and reissue released reports",
  "reportQueue.guidance.lead": "Reports land here when their first result is released.",
  "reportQueue.guidance.body": "Printed reports come back when more results are released or a printed result changes.",
  "reportQueue.legend.partial": "Some results are not released yet",
  "reportQueue.legend.final": "Every result is released",
  "reportQueue.legend.amended": "A printed result changed, or the report was reissued with a correction",
  "reportQueue.legend.unprinted": "The current content has not been printed yet",
  "reportQueue.legend.printed": "The last print matches what is released",
  "reportQueue.tile.toPrint": "To print",
  "reportQueue.tile.amendedToPrint": "Amended to print",
  "reportQueue.type.patient": "Patient report",
  "reportQueue.state.partial": "Partial {released}/{total}",
  "reportQueue.state.partialName": "Partial",
  "reportQueue.state.final": "Final",
  "reportQueue.state.amended": "Telah diubah",
  "reportQueue.state.amendedPartial": "Amended {released}/{total}",
  "reportQueue.printStatus.unprinted": "Unprinted",
  "reportQueue.printStatus.printed": "Printed",
  "reportQueue.col.type": "Jenis",
  "reportQueue.col.labNoName": "Lab No / Name",
  "reportQueue.col.subject": "Subjek",
  "reportQueue.col.details": "Rincian",
  "reportQueue.col.released": "Released / Submitted",
  "reportQueue.col.state": "Status",
  "reportQueue.col.printStatus": "Print status",
  "reportQueue.col.version": "Versi",
  "reportQueue.version.none": "Not issued",
  "reportQueue.version.value": "v{n}",
  "reportQueue.action.print": "Cetak",
  "reportQueue.print.disabled.nothingReleased": "Nothing released yet on this order",
  "reportQueue.print.success": "{count, plural, one {# report} other {# reports}} ready",
  "reportQueue.print.failed": "Could not prepare {count, plural, one {# report} other {# reports}}: {labNumbers}",
  "reportQueue.print.reprinted": "Reprinted version {n} of {labNumber}",
  "reportQueue.print.issued": "Printed version {n} of {labNumber}",
  "reportQueue.print.popupBlocked": "The browser blocked the report window for {labNumber}",
  "reportQueue.print.open": "Open the report",
  "reportQueue.filter.labNo.placeholder": "Scan or type lab number",
  "reportQueue.filter.labNo.helper": "Scanning a barcode applies the filter instantly",
  "reportQueue.filter.labNo.range": "Rentang",
  "reportQueue.filter.labNo.to": "To lab number",
  "reportQueue.filter.labNo.rangeReversed": "The To lab number is before the From lab number",
  "reportQueue.filter.patient": "Cari berdasarkan Pasien",
  "reportQueue.filter.state": "Status",
  "reportQueue.filter.printStatus": "Print status",
  "reportQueue.filter.window": "Time window",
  "reportQueue.filter.window.24h": "Last 24 hours",
  "reportQueue.filter.window.7d": "Last 7 days",
  "reportQueue.filter.window.30d": "Last 30 days",
  "reportQueue.filter.window.all": "All time",
  "reportQueue.filter.window.custom": "Custom range",
  "reportQueue.filter.window.to": "Kepada",
  "reportQueue.filter.window.helper": "Applies to printed reports; unprinted ones always show",
  "reportQueue.filter.facility": "Lembaga",
  "reportQueue.filter.ward": "Ward / Dept / Unit",
  "reportQueue.filter.ward.disabled": "Select a facility first",
  "reportQueue.filter.typeahead.helper": "Type 2 or more characters to search",
  "reportQueue.filter.clear": "Hapus filter",
  "reportQueue.search.active.labNo": "Lab No: {labNo}",
  "reportQueue.search.active.labRange": "Lab No: {from} to {to}",
  "reportQueue.search.active.patient": "Patient: {name}",
  "reportQueue.search.clear": "Hapus pencarian",
  "reportQueue.search.disabledHelper": "Other filters are off while you look up a specific order",
  "reportQueue.empty": "Nothing to print. Every released report in this view has been printed.",
  "reportQueue.error.load": "Could not load the queue.",
  "reportQueue.detail.tests": "Pemeriksaan",
  "reportQueue.detail.order": "Pemesanan",
  "reportQueue.detail.validatedBy": "Validated by",
  "reportQueue.detail.col.test": "Pemeriksaan",
  "reportQueue.detail.col.result": "Hasil",
  "reportQueue.detail.col.flag": "Penanda",
  "reportQueue.detail.col.released": "Dirilis",
  "reportQueue.detail.awaitingValidation": "Awaiting validation",
  "reportQueue.detail.inProgress": "Dalam pengerjaan",
  "reportQueue.history.title": "Version history",
  "reportQueue.history.issued": "Issued",
  "reportQueue.history.by": "Oleh",
  "reportQueue.history.change": "Ubah",
  "reportQueue.history.firstIssue": "First issue",
  "reportQueue.history.completeness": "Completeness",
  "reportQueue.history.fingerprint": "Fingerprint",
  "reportQueue.history.openPdf": "Open PDF",
  "reportQueue.history.reprinted": "Reprinted {date} by {user}",
  "reportQueue.history.notArchived": "Not archived (issued before {date})",
  "reportQueue.history.archiveFailed": "Archive failed",
  "reportQueue.history.none": "Nothing printed yet",
  "reportQueue.awaitingValidation": "Correction awaiting validation",
  "sidenav.label.reports.sentMessages": "Pesan yang Terkirim",
  "sidenav.label.admin.notifications": "Notifikasi",
  "sidenav.label.admin.notifications.channels": "Channel",
  "sidenav.label.admin.notifications.templates": "Templat",
  "sidenav.label.admin.notifications.delivery": "Delivery Settings",
  "sidenav.label.admin.notifications.triggers": "Pemicu",
  "delivery.sent.title": "Pesan yang Terkirim",
  "delivery.sent.subtitle": "Every message the laboratory sent or tried to send: reports, alerts, notices, notification triggers and channel tests",
  "delivery.sent.empty": "Nothing sent in this period.",
  "delivery.sent.loadError": "The messages could not be loaded",
  "delivery.sent.resend": "Kirim ulang",
  "delivery.sent.resend.done": "Message queued again.",
  "delivery.sent.resend.failed": "The message could not be queued again.",
  "delivery.sent.sentBy.auto": "Automatic",
  "delivery.sent.col.time": "Waktu",
  "delivery.sent.col.product": "Product",
  "delivery.sent.col.labNo": "No. Registrasi",
  "delivery.sent.col.recipient": "Penerima",
  "delivery.sent.col.channel": "Saluran",
  "delivery.sent.col.status": "Status",
  "delivery.sent.col.attempts": "Upaya",
  "delivery.sent.col.sentBy": "Sent by",
  "delivery.sent.filter.product": "Product",
  "delivery.sent.filter.status": "Status",
  "delivery.sent.filter.channel": "Saluran",
  "delivery.sent.filter.to": "Kepada",
  "delivery.sent.filter.recipient": "Penerima",
  "delivery.sent.filter.all": "Semua",
  "delivery.sent.detail.subject": "Subjek",
  "delivery.sent.detail.message": "Pesan",
  "delivery.sent.detail.attempts": "Upaya",
  "delivery.sent.detail.noAttempts": "No attempt yet",
  "delivery.sent.detail.nextAttempt": "Next attempt {time}",
  "delivery.sent.detail.rule": "Aturan",
  "delivery.sent.detail.report": "Report version {n}, {format}",
  "delivery.sent.detail.openOrder": "Open the order",
  "delivery.sent.detail.openQueue": "Open in the Report Print Queue",
  "delivery.sent.detail.loadError": "The message could not be loaded",
  "delivery.status.queued": "Dalam antrian",
  "delivery.status.sent": "Terkirim",
  "delivery.status.failed": "Gagal",
  "delivery.status.skipped": "Dilewati",
  "delivery.product.report": "Laporan",
  "delivery.product.alert": "Alert",
  "delivery.product.notice": "Ready notice",
  "delivery.product.trigger": "Notification",
  "delivery.product.test": "Pemeriksaan",
  "delivery.format.protected": "Protected full report",
  "delivery.format.masked": "Masked copy",
  "delivery.channel.email": "Email",
  "delivery.channel.sms": "SMS",
  "delivery.channel.whatsapp": "WhatsApp",
  "delivery.channel.title": "Channel",
  "delivery.channel.subtitle": "Email, SMS and WhatsApp are set up here once and used by every message the laboratory sends",
  "delivery.channel.status.ready": "Siap",
  "delivery.channel.status.notSetUp": "Not set up",
  "delivery.channel.status.failing": "Failing",
  "delivery.channel.lastSuccess": "Last successful send",
  "delivery.channel.never": "Tidak pernah",
  "delivery.channel.lastError": "Last error",
  "delivery.channel.active": "Aktif",
  "delivery.channel.host": "SMTP host",
  "delivery.channel.port": "Portal",
  "delivery.channel.security": "Security",
  "delivery.channel.security.starttls": "STARTTLS",
  "delivery.channel.security.ssl": "SSL/TLS",
  "delivery.channel.security.none": "Tidak ada",
  "delivery.channel.username": "Nama pengguna",
  "delivery.channel.password": "Kata kunci",
  "delivery.channel.secretSet": "Set",
  "delivery.channel.secretHelper": "A secret is stored. Leave this blank to keep it.",
  "delivery.channel.replace": "Ganti",
  "delivery.channel.senderAddress": "Sender address",
  "delivery.channel.senderName": "Sender name",
  "delivery.channel.replyTo": "Reply-to address",
  "delivery.channel.whatsapp.accountSid": "Account SID",
  "delivery.channel.whatsapp.token": "Auth token",
  "delivery.channel.whatsapp.from": "Sending number",
  "delivery.channel.whatsapp.address": "API address (optional)",
  "delivery.channel.countryCode": "Default country code",
  "delivery.channel.gateway": "Gateway",
  "delivery.channel.sms.note": "The SMS gateway (BMP or SMPP) keeps its settings in the server properties until its own change lands; this row shows whether one is enabled.",
  "delivery.channel.save": "Simpan",
  "delivery.channel.saved": "Channel saved.",
  "delivery.channel.saveFailed": "The channel could not be saved: check {field}.",
  "delivery.channel.sendTest": "Send test",
  "delivery.channel.test.title": "Send a test message",
  "delivery.channel.test.address": "Alamat",
  "delivery.channel.test.send": "Kirim",
  "delivery.channel.test.sent": "Test message sent.",
  "delivery.channel.test.failed": "The test message was not sent.",
  "delivery.settings.title": "Delivery Settings",
  "delivery.settings.subtitle": "Lab-wide rules for how reports, alerts and notices are sent",
  "delivery.settings.retryDelays": "Retry after (minutes, in order)",
  "delivery.settings.retryDelays.helper": "For example 1,5,15: a failed send is tried again after 1, 5 and 15 minutes, then marked Failed",
  "delivery.settings.defaultFormat": "Format for recipients without a password",
  "delivery.settings.hold": "Wait before sending a new version (minutes)",
  "delivery.settings.partials": "Send partial reports automatically",
  "delivery.settings.contact": "Lab contact line",
  "delivery.settings.contact.helper": "Phone, email and opening hours, as printed in notices",
  "delivery.settings.location": "Where reports are sent from",
  "delivery.settings.location.local": "This lab",
  "delivery.settings.location.central": "Central delivery service",
  "delivery.settings.centralAddress": "Central delivery service address",
  "delivery.settings.centralConfirm": "Reports, alerts and patient notices for this lab will be sent by the central service at {address}. This lab will stop sending them.",
  "delivery.settings.links": "Secure links",
  "delivery.settings.linkDays": "Link lifetime (days)",
  "delivery.settings.countryCode": "Default country code",
  "delivery.settings.save": "Simpan",
  "delivery.settings.saved": "Settings saved.",
  "delivery.settings.invalid": "The settings could not be saved: check {field}.",
  "externalconnections.password.set": "A password is stored. Leave this blank to keep it.",
  "notificationtrigger.referralrejected.name": "Referral result rejected",
  "notificationtrigger.referralrejected.description": "Sent when a result returned by the reference laboratory is rejected and the sample must be collected again.",
  "notificationtrigger.templates.referralrejected.description": "Sent to the ordering provider or the submitting user when a returned referral result is rejected.",
  "notificationtrigger.referralnudge.name": "Referral nudge",
  "notificationtrigger.referralnudge.description": "Sent to the reference laboratory's contact when a referral is overdue and a nudge is requested.",
  "notificationtrigger.templates.referralnudge.description": "Sent to the chain-of-custody contact at the reference laboratory when a result is awaited.",
  "notificationtrigger.sampleresampled.name": "Sample re-collection",
  "notificationtrigger.sampleresampled.description": "Sent when an order is marked for re-collection and a replacement order is created.",
  "notificationtrigger.templates.sampleresampled.description": "Sent to the ordering provider or the submitting user when a sample must be collected again.",
  "notificationtrigger.testresult.name": "Patient results ready",
  "notificationtrigger.testresult.description": "Sent to the patient or the provider when a test configured under Test Notifications has a released result.",
  "notificationtrigger.templates.testresult.description": "Sent to the patient or the provider when a configured test's result is released. It never names the patient."
}
